import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** BigDecimal type for monetary values with high precision */
  BigDecimal: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  Json: any;
  Upload: any;
};




/** Autogenerated return type of AcceptLineItems. */
export type AcceptLineItemsPayload = {
  __typename?: 'AcceptLineItemsPayload';
  orders?: Maybe<Array<Order>>;
};

/** Autogenerated return type of AcceptOfferAsSupplier. */
export type AcceptOfferAsSupplierPayload = {
  __typename?: 'AcceptOfferAsSupplierPayload';
  /** The counter offer that was accepted */
  counterOffer?: Maybe<Offer>;
  /** What went wrong when accepting the counter offer */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Fields available on an account statement */
export type AccountStatement = {
  __typename?: 'AccountStatement';
  /** The company that made the transaction */
  company?: Maybe<Company>;
  /** The contact involved in the transaction */
  contact?: Maybe<Contact>;
  /** Unique payment identifier */
  id?: Maybe<Scalars['ID']>;
  /** Object containing information on the document generated for this account statement */
  templateOutput?: Maybe<TemplateOutput>;
};

export type AccountingExport = {
  __typename?: 'AccountingExport';
  /** Errors that occurred during the export for individual invoices */
  exportErrors?: Maybe<Array<AccountingExportError>>;
  /** File attached to the accounting export */
  exportFile: Document;
  /** Status of the accounting export */
  exportStatus: Scalars['String'];
  /** Date and time the accounting export was exported */
  exportedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the accounting export */
  id: Scalars['ID'];
  /** Invoices attached to the accounting export */
  invoices: Array<Invoice>;
  /** User who exported the accounting export */
  user: User;
};

/** Errors that occurred during the accounting export */
export type AccountingExportError = {
  __typename?: 'AccountingExportError';
  /** Error message describing what went wrong */
  errorMessage: Scalars['String'];
  /** Type of error that occurred during accounting export */
  errorType: AccountingExportErrorTypeEnum;
  /** Unique identifier for the invoice */
  invoiceId: Scalars['ID'];
  /** Number of the invoice */
  invoiceNumber?: Maybe<Scalars['String']>;
};

/** Type of error that occurred during accounting export */
export enum AccountingExportErrorTypeEnum {
  /** Error related to customer data or configuration */
  Customer = 'CUSTOMER',
  /** Error related to inventory data or configuration */
  Inventory = 'INVENTORY',
  /** Non-blocking warning: a vendor invoice line exported without a short code suffix */
  VendorCodeMissing = 'VENDOR_CODE_MISSING',
  /** Error related to Pastel detail line description configuration or length */
  Description = 'DESCRIPTION',
  /** Non-blocking warning: a description template variable had no source value on the invoice */
  DescriptionDataMissing = 'DESCRIPTION_DATA_MISSING',
  /** Error related to Pastel exchange rate configuration */
  ExchangeRate = 'EXCHANGE_RATE',
  /** Unknown error type */
  Unknown = 'UNKNOWN'
}

/** Attributes for adding an internal packhouse */
export type AddInternalPackhouseAttributes = {
  /** The ID of the packhouse (FBO) to add */
  packhouseId: Scalars['ID'];
  /** The ID of the packhouse connection selected by the user */
  packhouseConnectionId?: Maybe<Scalars['ID']>;
  /** Whether the user is unsure about the packhouse connection or not */
  isUserUnsure?: Maybe<Scalars['Boolean']>;
  /** Whether the packhouse should be connected to a new server or not */
  isPackhouseConnectedToNewServer?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of AddInternalPackhouse. */
export type AddInternalPackhousePayload = {
  __typename?: 'AddInternalPackhousePayload';
  /** The created client change request */
  clientChangeRequest?: Maybe<InternalPackhouseClientChangeRequest>;
  /** The errors that occurred while creating the client change request */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type AddendumHeader = {
  __typename?: 'AddendumHeader';
  /** Line items on the Addendum */
  addendumLineItems?: Maybe<Array<AddendumLineItem>>;
  /** Actual Addendum Progress Status */
  addendumStatus?: Maybe<Scalars['String']>;
  /** Airwaybill number (master waybill) from Air Freight shipment associated with the addendum header */
  airwaybillNumber?: Maybe<Scalars['String']>;
  /** Clearing and forwarding agent code */
  cfCode?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the department of inspection services agent was specified */
  disAgentDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the department of inspection services agent is */
  disAgentName?: Maybe<Scalars['String']>;
  /** Five character location code */
  dischargePort?: Maybe<Scalars['String']>;
  /** eCert Agreement Code */
  eCertAgreementCode?: Maybe<Scalars['String']>;
  /** eCert progress status */
  ecertStatus?: Maybe<Scalars['String']>;
  /** PPECB Error for Addendum */
  errorReason?: Maybe<Scalars['String']>;
  /** Estimated date of departure from load port */
  estimatedDepartureDate?: Maybe<Scalars['ISO8601Date']>;
  /** Export Certificate Place of Issue */
  exportCertPlaceOfIssue?: Maybe<Scalars['String']>;
  /** Export Certificate Product Type */
  exportCertProductType?: Maybe<Scalars['String']>;
  /** Export Certificate Serial Number */
  exportCertSerialNumber?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying the Export Certificate Number */
  exportCertificateNumber?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromCapeTown?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromDurban?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromMaputo?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromOther?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromPortElizabeth?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the exporter agent was specified */
  exporterAgentDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the exporter agent is */
  exporterAgentName?: Maybe<Scalars['String']>;
  /** Exporter FBO code */
  exporterCode?: Maybe<Scalars['String']>;
  /** Flight number received from Air Freight shipment associated with the addendum header */
  flightNumber?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the forwarding agent was specified */
  forwardingAgentDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the forwarding agent is */
  forwardingAgentName?: Maybe<Scalars['String']>;
  /** Unique identifier for the Addendum */
  id: Scalars['ID'];
  /** PPECB specific field for specifying when the inland inspector was specified */
  inlandInspectorDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the inland inspector is */
  inlandInspectorName?: Maybe<Scalars['String']>;
  /** Load out instructions linked to air freight shipment line items */
  loadOutInstructions?: Maybe<Array<LoadOutInstruction>>;
  /** Five character location code */
  loadPort?: Maybe<Scalars['String']>;
  /** Activity Point code where cert will be issued */
  locationOfIssue?: Maybe<Scalars['String']>;
  /** Logistics Service Provider code */
  lspCode?: Maybe<Scalars['String']>;
  /** Pallet out linked to addendum header */
  palletOut?: Maybe<PalletOut>;
  /** PPECB specific field for specifying when the port inspector was specified */
  portInspectorDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the port inspector is */
  portInspectorName?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying the PPECB Certificate Number */
  ppecbCertificateNumber?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying some name (in print) */
  printedName?: Maybe<Scalars['String']>;
  /** Regime Code linked to load port and phc */
  regimeCode?: Maybe<Scalars['String']>;
  /** Unique id for the request */
  requestId?: Maybe<Scalars['String']>;
  /** Final country of destination */
  shippedTargetCountry?: Maybe<Scalars['String']>;
  /** Full name of the shipped_target_country */
  shippedTargetCountryName?: Maybe<Scalars['String']>;
  /** Target shipping region for addendum */
  shippedTargetRegion?: Maybe<Scalars['String']>;
  /** Vessel booking reference */
  shippingBookingReference?: Maybe<Scalars['String']>;
  /** Internal State of the Addendum */
  state?: Maybe<AddendumHeaderStateEnum>;
  /** Object containing information on the document generated for this addendum header */
  templateOutput?: Maybe<Array<TemplateOutput>>;
  /** eCert progress status */
  transactionId?: Maybe<Scalars['Int']>;
  /** Type of Transport */
  transportType?: Maybe<Scalars['String']>;
  /** Verification Status When Submitting Addendum */
  verificationStatus?: Maybe<Scalars['String']>;
  /** Name of the Vessel */
  vesselName?: Maybe<Scalars['String']>;
  /** Type of vessel */
  vesselType?: Maybe<Scalars['String']>;
  /** Voyage Number for vessels */
  voyageNumber?: Maybe<Scalars['String']>;
};

export type AddendumHeaderAttributes = {
  /** Unique identifier for the Addendum */
  id: Scalars['ID'];
  /** Unique id for the request */
  requestId?: Maybe<Scalars['String']>;
  /** Exporter FBO code */
  exporterCode?: Maybe<Scalars['String']>;
  /** Clearing and forwarding agent code */
  cfCode?: Maybe<Scalars['String']>;
  /** Logistics Service Provider code */
  lspCode?: Maybe<Scalars['String']>;
  /** Type of Transport */
  transportType?: Maybe<Scalars['String']>;
  /** Name of the Vessel */
  vesselName?: Maybe<Scalars['String']>;
  /** Type of vessel */
  vesselType?: Maybe<Scalars['String']>;
  /** Voyage Number for vessels */
  voyageNumber?: Maybe<Scalars['String']>;
  /** Regime Code linked to load port and phc */
  regimeCode?: Maybe<Scalars['String']>;
  /** Vessel booking reference */
  shippingBookingReference?: Maybe<Scalars['String']>;
  /** Five character location code */
  loadPort?: Maybe<Scalars['String']>;
  /** Five character location code */
  dischargePort?: Maybe<Scalars['String']>;
  /** Final country of destination */
  shippedTargetCountry?: Maybe<Scalars['String']>;
  /** Target shipping region for addendum */
  shippedTargetRegion?: Maybe<Scalars['String']>;
  /** Activity Point code where cert will be issued */
  locationOfIssue?: Maybe<Scalars['String']>;
  /** Estimated date of departure from load port */
  estimatedDepartureDate?: Maybe<Scalars['ISO8601Date']>;
  /** eCert Agreement Code */
  eCertAgreementCode?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying the Export Certificate Number */
  exportCertificateNumber?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromCapeTown?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromDurban?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromMaputo?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromOther?: Maybe<Scalars['String']>;
  /** PPECB specific field specifying where in South Africa the goods are being exported from */
  exportFromPortElizabeth?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the exporter agent was specified */
  exporterAgentDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the exporter agent is */
  exporterAgentName?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the forwarding agent was specified */
  forwardingAgentDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the forwarding agent is */
  forwardingAgentName?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying some name (in print) */
  printedName?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the department of inspection services agent was specified */
  disAgentDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the department of inspection services agent is */
  disAgentName?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the inland inspector was specified */
  inlandInspectorDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the inland inspector is */
  inlandInspectorName?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying when the port inspector was specified */
  portInspectorDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB specific field for specifying who the port inspector is */
  portInspectorName?: Maybe<Scalars['String']>;
  /** PPECB specific field for specifying the PPECB Certificate Number */
  ppecbCertificateNumber?: Maybe<Scalars['String']>;
  /** Export Certificate Product Type */
  exportCertProductType?: Maybe<Scalars['String']>;
  /** Export Certificate Serial Number */
  exportCertSerialNumber?: Maybe<Scalars['String']>;
};

export enum AddendumHeaderStateEnum {
  /** The state of the addendum header is GENERATING */
  Generating = 'GENERATING',
  /** The state of the addendum header is READY */
  Ready = 'READY',
  /** The state of the addendum header is SUBMITTING */
  Submitting = 'SUBMITTING',
  /** The state of the addendum header is SUBMITTED */
  Submitted = 'SUBMITTED',
  /** The state of the addendum header is ERRORED */
  Errored = 'ERRORED'
}

export type AddendumLineItem = {
  __typename?: 'AddendumLineItem';
  /** Carton Quantity */
  cartonQuantity?: Maybe<Scalars['Int']>;
  /** Client Reference for pallet */
  clientRef?: Maybe<Scalars['String']>;
  /** PPECB Commodity code */
  commodityCode?: Maybe<Scalars['String']>;
  /** Consignment number for pallet */
  consignmentNumber?: Maybe<Scalars['String']>;
  /** Container Number */
  containerNumber?: Maybe<Scalars['String']>;
  /** The color of the flesh of the fruit, specifically stone fruit */
  fleshColor?: Maybe<Scalars['String']>;
  /** Gross Weight */
  grossWeight?: Maybe<Scalars['Float']>;
  /** Unique identifier for the Addendum Line */
  id: Scalars['ID'];
  /** Inspected pallet number */
  inspectedSscc?: Maybe<Scalars['String']>;
  /** Target Country for pallet */
  inspectedTargetCountry?: Maybe<Scalars['String']>;
  /** Target Region for pallet */
  inspectedTargetRegion?: Maybe<Scalars['String']>;
  /** Date of inspection as on PO */
  inspectionDate?: Maybe<Scalars['String']>;
  /** The inspection manifest number for the shipment line item */
  inspectionManifestNumber?: Maybe<Scalars['String']>;
  /** PPECB Actvitiy Point Code for inspection */
  inspectionPoint?: Maybe<Scalars['String']>;
  /** PPECB registered inspector code */
  inspectorCode?: Maybe<Scalars['String']>;
  /** PPECB Activity Point Code */
  loadPointFboCode?: Maybe<Scalars['String']>;
  /** Nett Weight */
  nettWeight?: Maybe<Scalars['Float']>;
  /** Orchard code */
  orchard?: Maybe<Scalars['String']>;
  /** Pack Code */
  packCode?: Maybe<Scalars['String']>;
  /** Pallet Quantity */
  palletQuantity?: Maybe<Scalars['Float']>;
  /** Packhouse code for pallet */
  phc?: Maybe<Scalars['String']>;
  /** Phyto Data */
  phytoData?: Maybe<Scalars['String']>;
  /** Product Class code */
  productClass?: Maybe<Scalars['String']>;
  /** Production Area */
  productionArea?: Maybe<Scalars['String']>;
  /** DALRRD PUC Code */
  puc?: Maybe<Scalars['String']>;
  /** Pallet sequence number */
  sequenceNumberOfInspectedSscc?: Maybe<Scalars['Int']>;
  /** Size Count or Berry Size */
  sizeCountBerrySize?: Maybe<Scalars['String']>;
  /** Pallet Gross Weight */
  ssccGrossWeight?: Maybe<Scalars['Float']>;
  /** Pallet Nett Weight */
  ssccNettWeight?: Maybe<Scalars['Float']>;
  /** Container loading date */
  stuffLoadDate?: Maybe<Scalars['ISO8601Date']>;
  /** Unique number issued by PPECB */
  upn?: Maybe<Scalars['String']>;
  /** Variety Code */
  varietyCode?: Maybe<Scalars['String']>;
};

export type AddendumLineItemAttributes = {
  /** Unique identifier for the Addendum Line */
  id: Scalars['ID'];
  /** Container loading date */
  stuffLoadDate?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB Activity Point Code */
  loadPointFboCode?: Maybe<Scalars['String']>;
  /** Consignment number for pallet */
  consignmentNumber?: Maybe<Scalars['String']>;
  /** Packhouse code for pallet */
  phc?: Maybe<Scalars['String']>;
  /** Inspected pallet number */
  inspectedSscc?: Maybe<Scalars['String']>;
  /** Client Reference for pallet */
  clientRef?: Maybe<Scalars['String']>;
  /** Unique number issued by PPECB */
  upn?: Maybe<Scalars['String']>;
  /** Target Region for pallet */
  inspectedTargetRegion?: Maybe<Scalars['String']>;
  /** Target Country for pallet */
  inspectedTargetCountry?: Maybe<Scalars['String']>;
  /** PPECB Commodity code */
  commodityCode?: Maybe<Scalars['String']>;
  /** Variety Code */
  varietyCode?: Maybe<Scalars['String']>;
  /** Product Class code */
  productClass?: Maybe<Scalars['String']>;
  /** Nett Weight */
  nettWeight?: Maybe<Scalars['Float']>;
  /** Gross Weight */
  grossWeight?: Maybe<Scalars['Float']>;
  /** Pallet Nett Weight */
  ssccNettWeight?: Maybe<Scalars['Float']>;
  /** Pallet Gross Weight */
  ssccGrossWeight?: Maybe<Scalars['Float']>;
  /** Carton Quantity */
  cartonQuantity?: Maybe<Scalars['Int']>;
  /** PPECB Actvitiy Point Code for inspection */
  inspectionPoint?: Maybe<Scalars['String']>;
  /** PPECB registered inspector code */
  inspectorCode?: Maybe<Scalars['String']>;
  /** Date of inspection as on PO */
  inspectionDate?: Maybe<Scalars['String']>;
  /** Container Number */
  containerNumber?: Maybe<Scalars['String']>;
  /** Pallet sequence number */
  sequenceNumberOfInspectedSscc?: Maybe<Scalars['Int']>;
  /** DALRRD PUC Code */
  puc?: Maybe<Scalars['String']>;
  /** Orchard code */
  orchard?: Maybe<Scalars['String']>;
  /** Production Area */
  productionArea?: Maybe<Scalars['String']>;
  /** Phyto Data */
  phytoData?: Maybe<Scalars['String']>;
  /** Size Count or Berry Size */
  sizeCountBerrySize?: Maybe<Scalars['String']>;
  /** Pack Code */
  packCode?: Maybe<Scalars['String']>;
  /** Pallet Quantity */
  palletQuantity?: Maybe<Scalars['Float']>;
  /** The color of the flesh of the fruit, specifically stone fruit */
  fleshColor?: Maybe<Scalars['String']>;
  /** The inspection manifest number for the shipment line item */
  inspectionManifestNumber?: Maybe<Scalars['String']>;
};

export type AdditionalField = {
  __typename?: 'AdditionalField';
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isPackingInstruction?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Address = {
  __typename?: 'Address';
  /** The first line of the address */
  addressLine1?: Maybe<Scalars['String']>;
  /** The second line of the address */
  addressLine2?: Maybe<Scalars['String']>;
  /** The city of the address */
  city?: Maybe<Scalars['String']>;
  /** The country of the address */
  country?: Maybe<Scalars['String']>;
  /** The timestamp of the creation of the address */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the address */
  id?: Maybe<Scalars['ID']>;
  /** The Google place ID of the address */
  placeId?: Maybe<Scalars['ID']>;
  /** The postal code of the address */
  postalCode?: Maybe<Scalars['String']>;
  /** The timestamp of the last update to the address */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AddressAttributes = {
  addressline1: Scalars['String'];
  addressline2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  postalcode?: Maybe<Scalars['String']>;
  country: Scalars['String'];
};

/** Attributes for creating or editing an address */
export type AddressInput = {
  /** The first line of the address */
  addressLine1?: Maybe<Scalars['String']>;
  /** The second line of the address */
  addressLine2?: Maybe<Scalars['String']>;
  /** The city of the address */
  city?: Maybe<Scalars['String']>;
  /** The postal code of the address */
  postalCode?: Maybe<Scalars['String']>;
  /** The country of the address */
  country?: Maybe<Scalars['String']>;
  /** The Google place ID of the address */
  placeId?: Maybe<Scalars['String']>;
};

/** Field attributes for AG1 table component */
export type Ag1TableFieldAttribute = {
  /** Used to show/hide the field */
  checked?: Maybe<Scalars['Boolean']>;
  /** Mapped name for display purposes */
  displayName?: Maybe<Scalars['String']>;
  /** The order the field is grouped in */
  groupOrder?: Maybe<Scalars['Int']>;
  /** Indicates if this field can be grouped */
  groupable?: Maybe<Scalars['Boolean']>;
  /** Indicates if this field is grouped */
  grouped?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for the field */
  name?: Maybe<Scalars['String']>;
  /** Used to order the fields */
  order?: Maybe<Scalars['Int']>;
  /** The direction the field is sorted */
  sortDirection?: Maybe<Scalars['String']>;
  /** Indicates if this field can be sorted */
  sortable?: Maybe<Scalars['Boolean']>;
  /** Indicates a custom width for this field */
  width?: Maybe<Scalars['Float']>;
};

export type AirFreightShipment = {
  __typename?: 'AirFreightShipment';
  /** When the shipment actually arrived */
  actualArrivalTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the shipment actually departed */
  actualDepartureTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** List of line items for the air freight shipment */
  airFreightShipmentLineItems?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Who the shipment is billed to */
  billToParty?: Maybe<Scalars['String']>;
  /** Carrier name of the shipment */
  carrierName?: Maybe<Scalars['String']>;
  /** Company of the shipment */
  company?: Maybe<Scalars['String']>;
  /** Receiver of the shipment */
  consignee?: Maybe<Scalars['String']>;
  /** Sender of the shipment */
  consignor?: Maybe<Scalars['String']>;
  /** Controller of the shipment */
  controller?: Maybe<Scalars['String']>;
  /** When the shipment was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Where the shipment departs from */
  departureAirport?: Maybe<Scalars['String']>;
  /** When the shipment is estimated to arrive */
  estimatedArrivalTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the shipment is estimated to depart */
  estimatedDepartureTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Exporter code of the shipment */
  exporterCode?: Maybe<Scalars['String']>;
  /** External transport master ID of the shipment */
  externalTransportMasterId?: Maybe<Scalars['String']>;
  /** FBO code of the shipment */
  fboCode?: Maybe<Scalars['String']>;
  /** Flight number of the shipment */
  flightNumber?: Maybe<Scalars['String']>;
  /** Name of forwarder */
  forwarderName?: Maybe<Scalars['String']>;
  /** Unique ID for the shipment */
  id: Scalars['ID'];
  /** Master waybill number of the shipment */
  masterWaybillNumber?: Maybe<Scalars['String']>;
  /** Phone number of the shipment */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Which port the shipment is headed */
  portOfDestination?: Maybe<Scalars['String']>;
  /** Port code of where the shipment is loaded */
  portOfLoadingCode?: Maybe<Scalars['String']>;
  /** Port location name of where the shipment is loaded */
  portOfLoadingLocation?: Maybe<Scalars['String']>;
  /** Type of shipment */
  shipmentType?: Maybe<Scalars['String']>;
  /** Shipper of the shipment */
  shipper?: Maybe<Scalars['String']>;
  /** State of the shipment */
  state?: Maybe<Scalars['String']>;
  /** When the shipment was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** User name of the shipment */
  userName?: Maybe<Scalars['String']>;
};

/** The connection type for AirFreightShipment. */
export type AirFreightShipmentConnection = {
  __typename?: 'AirFreightShipmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AirFreightShipmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AirFreightShipment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AirFreightShipmentEdge = {
  __typename?: 'AirFreightShipmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AirFreightShipment>;
};

export type AirFreightShipmentLineItem = {
  __typename?: 'AirFreightShipmentLineItem';
  /** The Air Freight Shipment the SLI belongs to */
  airFreightShipment?: Maybe<AirFreightShipment>;
  /** Booking reference for the goods on the SLI */
  bookingReference?: Maybe<Scalars['String']>;
  /** Collection Date for the SLI */
  collectionDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Comments related to the SLI */
  comments?: Maybe<Scalars['String']>;
  /** Commodity code */
  commodityCode?: Maybe<Scalars['String']>;
  /** Company of the Air Freight Shipment Line Item */
  company?: Maybe<Company>;
  /** The consignee of the goods on the SLI */
  consignee?: Maybe<Scalars['String']>;
  /** The consignor of the goods on the SLI */
  consignor?: Maybe<Scalars['String']>;
  /** when the air freight shipment line item was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Estimated Time of Arrival for the SLI */
  eta?: Maybe<Scalars['ISO8601DateTime']>;
  /** External ID for the SLI */
  externalShipmentId: Scalars['ID'];
  /** The code identifier for the final destination of the goods on the SLI */
  finalDestinationCode?: Maybe<Scalars['String']>;
  /** The final destination of the goods on the SLI */
  finalDestinationLocation?: Maybe<Scalars['String']>;
  /** The code identifier for final port of discharge of the SLI */
  finalPortOfDischargeCode?: Maybe<Scalars['String']>;
  /** The final port of discharge of the SLI */
  finalPortOfDischargeLocation?: Maybe<Scalars['String']>;
  /** Description of goods */
  goodsDescription?: Maybe<Scalars['String']>;
  /** Gross dimensions */
  grossDimensions?: Maybe<Scalars['String']>;
  /** Gross weight */
  grossWeight?: Maybe<Scalars['String']>;
  /** Housebill */
  housebill?: Maybe<Scalars['String']>;
  /** Unique ID for the shipment */
  id: Scalars['ID'];
  /** Whether the SLI is part of a transshipment */
  isTransshipment?: Maybe<Scalars['Boolean']>;
  /** Last status message received */
  lastStatusMessage?: Maybe<Scalars['String']>;
  /** Nature of goods */
  natureOfGoods?: Maybe<Scalars['String']>;
  /** Order reference for the vessel */
  orderReference?: Maybe<Scalars['String']>;
  /** Quantity of packages */
  packageQuantity?: Maybe<Scalars['String']>;
  /** Type of package */
  packageType?: Maybe<Scalars['String']>;
  /** Any special handling instructions on the SLI */
  specialHandling?: Maybe<Scalars['String']>;
  /** State of the Air Freight Shipment Line Item */
  state?: Maybe<Scalars['String']>;
  /** The name of the transshipment carrier */
  transshipmentCarrierName?: Maybe<Scalars['String']>;
  /** The flight number of the transshipment vessel */
  transshipmentFlightNumber?: Maybe<Scalars['String']>;
  /** The port for the transshipment vessel */
  transshipmentPort?: Maybe<Scalars['String']>;
  /** when the air freight shipment line item was updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Volume */
  volume?: Maybe<Scalars['String']>;
};

/** The connection type for AirFreightShipmentLineItem. */
export type AirFreightShipmentLineItemConnection = {
  __typename?: 'AirFreightShipmentLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AirFreightShipmentLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AirFreightShipmentLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AirFreightShipmentLineItemEdge = {
  __typename?: 'AirFreightShipmentLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AirFreightShipmentLineItem>;
};

export type AirFreightShipmentsFilter = {
  /** The carriers to filter on */
  carrierNames?: Maybe<Array<Scalars['String']>>;
  /** The controllers to filter on */
  controllers?: Maybe<Array<Scalars['String']>>;
  /** The flight numbers to filter on */
  flightNumbers?: Maybe<Array<Scalars['String']>>;
  /** The states to filter on */
  states?: Maybe<Array<Scalars['String']>>;
  /** The shippers to filter on */
  shippers?: Maybe<Array<Scalars['String']>>;
  /** The master waybills to filter on */
  masterWaybillNumbers?: Maybe<Array<Scalars['String']>>;
};

/** Attributes for filtering air freight shipments */
export type AirFreightShipmentsFilterAttribute = {
  __typename?: 'AirFreightShipmentsFilterAttribute';
  /** Carriers of the shipment */
  carrierNames?: Maybe<Array<Scalars['String']>>;
  /** Controllers of the shipment */
  controllers?: Maybe<Array<Scalars['String']>>;
  /** Flight numbers of the shipment */
  flightNumbers?: Maybe<Array<Scalars['String']>>;
  /** Master Waybills of the shipment */
  masterWaybillNumbers?: Maybe<Array<Scalars['String']>>;
  /** Shippers of the shipment */
  shippers?: Maybe<Array<Scalars['String']>>;
  /** States of the shipment */
  states?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of AllocatePayments. */
export type AllocatePaymentsPayload = {
  __typename?: 'AllocatePaymentsPayload';
  /** What went wrong when assigning payments */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Returns true if the payment was successfully assigned */
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of AllocateShipmentController. */
export type AllocateShipmentControllerPayload = {
  __typename?: 'AllocateShipmentControllerPayload';
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AllocateSliContainer. */
export type AllocateSliContainerPayload = {
  __typename?: 'AllocateSliContainerPayload';
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ArchiveNotifications. */
export type ArchiveNotificationsPayload = {
  __typename?: 'ArchiveNotificationsPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']>;
  /** The IDs of the notifications that were archived */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type ArrivalQcGeneration = {
  __typename?: 'ArrivalQcGeneration';
  /** ID of the container claim generated for the containerable */
  containerClaimId?: Maybe<Scalars['ID']>;
  /** Container number of the container the arrival qc is being generated for */
  containerNumber?: Maybe<Scalars['String']>;
  /** ID of the containerable the arrival qc is being generated for */
  containerableId: Scalars['ID'];
  /** Type of the containerable the arrival qc is being generated for (BreakBulkContainer OR Container) */
  containerableType?: Maybe<ContainerableTypeEnum>;
  /** The counter party specifies the recipient of the break bulk container, as the recipient is not always the buyer */
  counterParty?: Maybe<Company>;
  /** Error message if the container's arrival qc generation failed */
  errorMessage?: Maybe<Scalars['String']>;
  /** Generation status of the container's arrival qc */
  status: ArrivalQcGenerationStatesEnum;
  /** Vessel name of the containerable the arrival qc is being generated for (BreakBulkContainer) */
  vesselName?: Maybe<Scalars['String']>;
  /** Voyage number of the containerable the arrival qc is being generated for (BreakBulkContainer) */
  voyageNumber?: Maybe<Scalars['String']>;
};

export enum ArrivalQcGenerationStatesEnum {
  /** The Arrival QC generation state: loading */
  Loading = 'loading',
  /** The Arrival QC generation state: error */
  Error = 'error',
  /** The Arrival QC generation state: success */
  Success = 'success',
  /** The Arrival QC generation state: queued */
  Queued = 'queued'
}

export enum ArrivalQcGradeEnum {
  /** The Arrival QC grade: black */
  Black = 'black',
  /** The Arrival QC grade: red */
  Red = 'red',
  /** The Arrival QC grade: amber */
  Amber = 'amber',
  /** The Arrival QC grade: green */
  Green = 'green'
}

export enum ArrivalQcStateEnum {
  /** The Arrival QC state: arrival_qc_outstanding */
  ArrivalQcOutstanding = 'arrival_qc_outstanding',
  /** The Arrival QC state: arrival_qc_in_progress */
  ArrivalQcInProgress = 'arrival_qc_in_progress',
  /** The Arrival QC state: green */
  Green = 'green',
  /** The Arrival QC state: amber */
  Amber = 'amber',
  /** The Arrival QC state: red */
  Red = 'red',
  /** The Arrival QC state: black */
  Black = 'black'
}

export enum ArrivalQcTabEnum {
  /** The Arrival QC tab: containers */
  Containers = 'containers',
  /** The Arrival QC tab: breakbulk */
  Breakbulk = 'breakbulk',
  /** The Arrival QC tab: completed_qcs */
  CompletedQcs = 'completed_qcs'
}

export type Audit = {
  __typename?: 'Audit';
  action?: Maybe<Scalars['String']>;
  associatedId?: Maybe<Scalars['Int']>;
  associatedType?: Maybe<Scalars['String']>;
  auditableId?: Maybe<Scalars['Int']>;
  auditableType?: Maybe<Scalars['String']>;
  auditedChanges?: Maybe<Array<Scalars['Json']>>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type Badge = {
  __typename?: 'Badge';
  /** The color of the badge to be used in UI */
  color?: Maybe<ColorEnum>;
  /** The date and time the badge was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the badge */
  id?: Maybe<Scalars['Int']>;
  /** The text to be displayed on the badge */
  text?: Maybe<Scalars['String']>;
  /** The date and time the badge was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum BankChargeSplitEnum {
  MyCompany = 'my_company',
  OtherParty = 'other_party',
  FiftyFifty = 'fifty_fifty'
}


export type BreakBulkContainer = {
  __typename?: 'BreakBulkContainer';
  /** Agent Code on the mates file */
  agentCode?: Maybe<Scalars['String']>;
  /** Carton groupings of the container */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** The counterparty specifies the recipient of the break bulk container, as the recipient is not always the buyer */
  counterParty?: Maybe<Company>;
  /** Internal Id of the Break Bulk Container */
  id: Scalars['ID'];
  /** Concatted Break Bulk Name */
  name?: Maybe<Scalars['String']>;
  /** vessel name that the break bulk is loaded on */
  vesselName?: Maybe<Scalars['String']>;
  /** vessel voyage number that the break bulk is loaded on */
  voyageNumber?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CalculateCommercials. */
export type CalculateCommercialsPayload = {
  __typename?: 'CalculateCommercialsPayload';
  advanceCreditTerm?: Maybe<Scalars['Int']>;
  advancePayment?: Maybe<Scalars['BigDecimal']>;
  errors?: Maybe<Scalars['String']>;
  finalCreditTerm?: Maybe<Scalars['Int']>;
  finalPayment?: Maybe<Scalars['BigDecimal']>;
};

/** Autogenerated return type of CalculateInvoiceIncoterm. */
export type CalculateInvoiceIncotermPayload = {
  __typename?: 'CalculateInvoiceIncotermPayload';
  invoice?: Maybe<Invoice>;
};

/** Autogenerated return type of CalculatePalletCosts. */
export type CalculatePalletCostsPayload = {
  __typename?: 'CalculatePalletCostsPayload';
  errors?: Maybe<Scalars['String']>;
  estimatePalletCosts: Scalars['Float'];
};

/** Autogenerated return type of CancelAddendum. */
export type CancelAddendumPayload = {
  __typename?: 'CancelAddendumPayload';
  /** The internal ID of the Addendum */
  id?: Maybe<Scalars['Int']>;
  /** Response message from PPECB */
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CancelAirAddendum. */
export type CancelAirAddendumPayload = {
  __typename?: 'CancelAirAddendumPayload';
  /** The internal ID of the air addendum */
  id?: Maybe<Scalars['Int']>;
  /** Delete message */
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CaptureAccountSale. */
export type CaptureAccountSalePayload = {
  __typename?: 'CaptureAccountSalePayload';
  /** Any errors from capturing account sale */
  errors?: Maybe<Scalars['String']>;
  /** id of the created account sale */
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of CaptureDefectPercentages. */
export type CaptureDefectPercentagesPayload = {
  __typename?: 'CaptureDefectPercentagesPayload';
  /** Errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']>;
};

export type CargoDue = {
  __typename?: 'CargoDue';
  /** Booking reference for this Cargo Due */
  bookingReference?: Maybe<Scalars['String']>;
  /** When the Cargo Dues was first created in the system */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for this Cargo Dues */
  id: Scalars['ID'];
  /** Shipment line items associated with this Cargo Due */
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
  /** Submission status of this Cargo Due */
  status?: Maybe<Scalars['String']>;
  /** Datetime that the Cargo Dues was submitted */
  submissionDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the Cargo Dues was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime'];
  /** User that submitted the Cargo Dues */
  user?: Maybe<User>;
};

export type CargoDuesFilterAttributes = {
  /** status of the cargo dues; use "not_started" for SLIs without cargo dues */
  status?: Maybe<Array<Scalars['String']>>;
  /** start of cargo dues submission you want to filter by */
  submissionDateStart?: Maybe<Scalars['String']>;
  /** end of cargo dues submission you want to filter by */
  submissionDateEnd?: Maybe<Scalars['String']>;
  /** start of estimated time of departure you want to filter by */
  estimatedTimeOfDepartureStart?: Maybe<Scalars['String']>;
  /** end of estimated time of departure you want to filter by */
  estimatedTimeOfDepartureEnd?: Maybe<Scalars['String']>;
  /** start of actual time of departure you want to filter by */
  actualTimeOfDepartureStart?: Maybe<Scalars['String']>;
  /** end of actual time of departure you want to filter by */
  actualTimeOfDepartureEnd?: Maybe<Scalars['String']>;
};

export type CartonConversion = {
  __typename?: 'CartonConversion';
  /** Actual Mass */
  actualMass?: Maybe<Scalars['Float']>;
  /** The commodity record associated with the carton conversion record */
  commodity?: Maybe<Commodity>;
  /** The commodity name associated with the carton conversion record */
  commodityName?: Maybe<Scalars['String']>;
  /** Conversion Factor */
  conversionFactor?: Maybe<Scalars['Float']>;
  /** Conversion Type */
  conversionType?: Maybe<Scalars['String']>;
  /** Converted Size Count */
  convertedSizeCount?: Maybe<Scalars['String']>;
  /** The unique identifier of the carton conversion record */
  id: Scalars['ID'];
  /** Hidden field */
  isSoftDeleted?: Maybe<Scalars['Boolean']>;
  /** Mass Conversion */
  massConversion?: Maybe<Scalars['Float']>;
  /** Pack */
  pack?: Maybe<Scalars['String']>;
  /** Size Count */
  sizeCount?: Maybe<Scalars['String']>;
};

/** Carton Conversion filter attribute for populating frontend filters */
export type CartonConversionFilterAttribute = {
  __typename?: 'CartonConversionFilterAttribute';
  /** List of available commodities */
  commodityName?: Maybe<Array<Scalars['String']>>;
  /** List of available conversion types */
  conversionType?: Maybe<Array<Scalars['String']>>;
};

export type CartonConversionFilters = {
  /** The conversion types to filter on */
  conversionType?: Maybe<Array<Scalars['String']>>;
  /** The commodities to filter on */
  commodityName?: Maybe<Array<Scalars['String']>>;
};

export type CartonCount = {
  __typename?: 'CartonCount';
  cartonTypeId?: Maybe<Scalars['Int']>;
  commodityId?: Maybe<Scalars['Int']>;
  counts?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  priceMetric?: Maybe<Scalars['String']>;
  stackSizes?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CartonGrouping = {
  __typename?: 'CartonGrouping';
  advanceDueDate?: Maybe<Scalars['ISO8601DateTime']>;
  advancePrice?: Maybe<Scalars['Float']>;
  batchNumber?: Maybe<Scalars['String']>;
  buyer?: Maybe<Company>;
  buyerId?: Maybe<Scalars['Int']>;
  cartons?: Maybe<Scalars['Int']>;
  coldStore?: Maybe<Scalars['String']>;
  commercialTerm?: Maybe<CommercialTerm>;
  commercialTermId?: Maybe<Scalars['Int']>;
  commodity?: Maybe<Commodity>;
  consignmentNumber?: Maybe<Scalars['String']>;
  container?: Maybe<Container>;
  containerId?: Maybe<Scalars['Int']>;
  containerNumber?: Maybe<Scalars['String']>;
  exporterCode?: Maybe<Scalars['String']>;
  /** extended (additional) fields per CG */
  extendedFields?: Maybe<ExtendedField>;
  farmCode?: Maybe<Scalars['String']>;
  /** FBO related CG Farm */
  farmFbo?: Maybe<FoodBusinessOperator>;
  finalDueDate?: Maybe<Scalars['ISO8601DateTime']>;
  finalPrice?: Maybe<Scalars['Float']>;
  grade?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inspectionDate?: Maybe<Scalars['ISO8601DateTime']>;
  inventoryCode?: Maybe<Scalars['String']>;
  /** The invoice line items for this carton grouping */
  invoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  lineItem?: Maybe<LineItem>;
  lineItemId?: Maybe<Scalars['Int']>;
  loadOutInstructions?: Maybe<Array<LoadOutInstruction>>;
  mark?: Maybe<Scalars['String']>;
  netMass?: Maybe<Scalars['Float']>;
  orchard?: Maybe<Scalars['String']>;
  pack?: Maybe<Scalars['String']>;
  /** The datetime the carton grouping was packed */
  packedDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  packhouseCode?: Maybe<Scalars['String']>;
  /** FBO related CG Packhouse */
  packhouseFbo?: Maybe<FoodBusinessOperator>;
  packingWeek?: Maybe<Scalars['String']>;
  palletAge?: Maybe<Scalars['Int']>;
  palletGrossMass?: Maybe<Scalars['Float']>;
  palletNumber?: Maybe<Scalars['String']>;
  palletRejected?: Maybe<Scalars['Boolean']>;
  /** The pallet rule errors  */
  palletRuleErrors?: Maybe<Array<PalletRuleError>>;
  palletStack?: Maybe<Scalars['Int']>;
  productCharacteristic?: Maybe<Scalars['String']>;
  seller?: Maybe<Company>;
  sellerId?: Maybe<Scalars['Int']>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  sizeCount?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  targetCountry?: Maybe<Scalars['String']>;
  targetMarket?: Maybe<Scalars['String']>;
  targetRegion?: Maybe<Scalars['String']>;
  tempDeviceId?: Maybe<Scalars['String']>;
  variety?: Maybe<Variety>;
  varietyId?: Maybe<Scalars['Int']>;
  voyage?: Maybe<Voyage>;
};

export type CartonGroupingAudit = {
  __typename?: 'CartonGroupingAudit';
  /** Description of change */
  changeDescription?: Maybe<Scalars['String']>;
  /** Value after change */
  currentValue?: Maybe<Scalars['String']>;
  /** ID of the carton grouping audit */
  id?: Maybe<Scalars['ID']>;
  /** Value before change */
  oldValue?: Maybe<Scalars['String']>;
  /** The user IDs who viewed the audit */
  viewedByIds?: Maybe<Array<Scalars['ID']>>;
};

/** Filter values for a provided list of carton_groupings */
export type CartonGroupingFilters = {
  __typename?: 'CartonGroupingFilters';
  /** batch numbers found on this list of carton groupings */
  batchNumber?: Maybe<Array<Scalars['String']>>;
  /** buyers found on this list of carton groupings */
  buyer?: Maybe<Array<Company>>;
  /** consignment numbers found on this list of carton groupings */
  consignmentNumber?: Maybe<Array<Scalars['String']>>;
  /** exporter codes found on this list of carton groupings */
  exporterCode?: Maybe<Array<Scalars['String']>>;
  /** packing weeks found on this list of carton groupings */
  packingWeek?: Maybe<Array<Scalars['String']>>;
  /** sellers found on this list of carton groupings */
  seller?: Maybe<Array<Company>>;
  /** target markets found on this list of carton groupings */
  targetMarket?: Maybe<Array<Scalars['String']>>;
  /** varieties found on this list of carton groupings */
  variety?: Maybe<Array<Variety>>;
  /** vessel names found on this list of carton groupings tracking events */
  vessel?: Maybe<Array<Vessel>>;
  /** voyage numbers found on this list of carton groupings tracking events */
  voyageNumber?: Maybe<Array<Scalars['String']>>;
};

export type CartonGroupingSearch = {
  __typename?: 'CartonGroupingSearch';
  /** Carton Groupings for the provided context */
  cartonGroupings: Array<CartonGrouping>;
  /** Carton Grouping Filter Values for the provided context */
  filterValues?: Maybe<CartonGroupingFilters>;
  /** Total count of carton groupings */
  totalCount?: Maybe<Scalars['Int']>;
  /** Total count of pallets */
  totalCountPallets?: Maybe<Scalars['Int']>;
};

/** Attributes for filtering carton groupings */
export type CartonGroupingSearchAttributes = {
  /** carton groupings with these ids */
  ids?: Maybe<Array<Scalars['Int']>>;
  /** carton groupings with these pallet numbers */
  includePallets?: Maybe<Array<Scalars['String']>>;
  /** carton groupings with these batch numbers */
  batchNumbers?: Maybe<Array<Scalars['String']>>;
  /** whether to include carton groupings that are break bulk */
  breakBulk?: Maybe<Scalars['Boolean']>;
  /** whether to include carton groupings with no invoice associations */
  invoiceUnassigned?: Maybe<Scalars['Boolean']>;
  /** whether these carton groupings have a financial invoice */
  financialInvoice?: Maybe<Scalars['Boolean']>;
  /** document type if there is one */
  documentType?: Maybe<Scalars['String']>;
  /** carton groupings belonging to these companies */
  companyIds?: Maybe<Array<Scalars['Int']>>;
  /** carton groupings with these consignment numbers */
  consignmentNumbers?: Maybe<Array<Scalars['String']>>;
  /** carton groupings with these container ids */
  containerIds?: Maybe<Array<Scalars['Int']>>;
  /** carton groupings with these container numbers */
  containerNumbers?: Maybe<Array<Scalars['String']>>;
  /** currency you would like to filter on */
  currency?: Maybe<Scalars['String']>;
  /** filter up to the end due date */
  endDueDate?: Maybe<Scalars['String']>;
  /** filter events after this date */
  eventsAfter?: Maybe<Scalars['ISO8601DateTime']>;
  /** carton groupings you would like to exclude */
  excludeCartonGroupingIds?: Maybe<Array<Scalars['Int']>>;
  /** pallets you would like to exclude */
  excludePallets?: Maybe<Array<Scalars['String']>>;
  /** states you would like to exclude */
  excludeStates?: Maybe<Array<CartonGroupingStateEnum>>;
  /** limit the number of items returned */
  limit?: Maybe<Scalars['Int']>;
  /** limit the number of pallets returned */
  limitPallets?: Maybe<Scalars['Int']>;
  /** cgs associated with a specific load out instruction */
  loadOutInstructionId?: Maybe<Scalars['Int']>;
  /** whether to include carton groupings with no load out instruction associations */
  loadOutInstructionsUnallocated?: Maybe<Scalars['Boolean']>;
  /** whether to order by pallet number */
  orderByPalletNumber?: Maybe<Scalars['Boolean']>;
  /** order id you would like to filter on */
  orderId?: Maybe<Scalars['Int']>;
  /** range of packing weeks you would like to filter on */
  packingWeeks?: Maybe<Array<Scalars['String']>>;
  /** filter from the start packing week */
  packingWeekFrom?: Maybe<Scalars['String']>;
  /** filter up to the end packing week */
  packingWeekTo?: Maybe<Scalars['String']>;
  /** search field you would like to match the search term to */
  searchField?: Maybe<CartonGroupingSearchableFieldEnum>;
  /** search term you would like to match on */
  searchTerm?: Maybe<Scalars['String']>;
  /** season ids you would like to filter on */
  seasonIds?: Maybe<Array<Scalars['Int']>>;
  /** seller ids you would like to filter on */
  sellerIds?: Maybe<Array<Scalars['Int']>>;
  /** buyer ids you would like to filter on */
  buyerIds?: Maybe<Array<Scalars['Int']>>;
  /** exporter codes you would like to filter on */
  exporterCodes?: Maybe<Array<Scalars['String']>>;
  /** filter from the start due date */
  startDueDate?: Maybe<Scalars['String']>;
  /** states you would like to filter on */
  states?: Maybe<Array<CartonGroupingStateEnum>>;
  /** target markets you would like to filter on */
  targetMarkets?: Maybe<Array<Scalars['String']>>;
  /** whether to include carton groupings with tracking disabled */
  trackingDisabled?: Maybe<Scalars['Boolean']>;
  /** varieties you would like to filter on */
  varietyIds?: Maybe<Array<Scalars['Int']>>;
  /** field you would like to order by */
  orderByField?: Maybe<Scalars['String']>;
  /** direction you would like to order by */
  orderByDirection?: Maybe<Scalars['String']>;
  /** vessel name for the carton grouping voyage */
  vesselIds?: Maybe<Array<Scalars['Int']>>;
  /** voyage number for the carton grouping voyage */
  voyageNumbers?: Maybe<Array<Scalars['String']>>;
};

export enum CartonGroupingSearchableFieldEnum {
  /** Search on Everything */
  All = 'all',
  /** The batch number of the carton grouping */
  BatchNumber = 'batch_number',
  /** The name of the company buying the carton grouping */
  BuyerName = 'buyer_name',
  /** the container number of the carton grouping */
  ContainerNumber = 'container_number',
  /** The commodity name of the carton grouping */
  CommodityName = 'commodity_name',
  /** The consignment number of the carton grouping */
  ConsignmentNumber = 'consignment_number',
  /** The exporter code of the carton grouping */
  ExporterCode = 'exporter_code',
  /** The farm code of the carton grouping */
  FarmCode = 'farm_code',
  /** The grade of the carton grouping */
  Grade = 'grade',
  /** The inventory code of the carton grouping */
  InventoryCode = 'inventory_code',
  /** The mark of the carton grouping */
  Mark = 'mark',
  /** The orchard of the carton grouping */
  Orchard = 'orchard',
  /** The pack of the carton grouping */
  Pack = 'pack',
  /** The packhouse code of the carton grouping */
  PackhouseCode = 'packhouse_code',
  /** The packing week of the carton grouping */
  PackingWeek = 'packing_week',
  /** Start packing week of the carton grouping */
  PackingWeekFrom = 'packing_week_from',
  /** End packing week of the carton grouping */
  PackingWeekTo = 'packing_week_to',
  /** The pallet number of the carton grouping */
  PalletNumber = 'pallet_number',
  /** The name of the company selling the carton grouping */
  SellerName = 'seller_name',
  /** The size count of the carton grouping */
  SizeCount = 'size_count',
  /** The state of the carton grouping */
  State = 'state',
  /** The sub commodity of the carton grouping */
  SubCommodityName = 'sub_commodity_name',
  /** The target country of the carton grouping */
  TargetCountry = 'target_country',
  /** The target market of the carton grouping */
  TargetMarket = 'target_market',
  /** The target region of the carton grouping */
  TargetRegion = 'target_region',
  /** The variety name of the carton grouping */
  VarietyName = 'variety_name'
}

export enum CartonGroupingStateEnum {
  /** The carton grouping state is created */
  Created = 'created',
  /** The carton grouping state is packed */
  Packed = 'packed',
  /** The carton grouping state is departed_packhouse */
  DepartedPackhouse = 'departed_packhouse',
  /** The carton grouping state is at_cold_store */
  AtColdStore = 'at_cold_store',
  /** The carton grouping state is at_rail_depot */
  AtRailDepot = 'at_rail_depot',
  /** The carton grouping state is loaded_into_container */
  LoadedIntoContainer = 'loaded_into_container',
  /** The carton grouping state is departed_cold_store */
  DepartedColdStore = 'departed_cold_store',
  /** The carton grouping state is departed_for_cold_store */
  DepartedForColdStore = 'departed_for_cold_store',
  /** The carton grouping state is departed_rail_depot */
  DepartedRailDepot = 'departed_rail_depot',
  /** The carton grouping state is at_origin_port */
  AtOriginPort = 'at_origin_port',
  /** The carton grouping state is delivered */
  Delivered = 'delivered',
  /** The carton grouping is in transit */
  InTransit = 'in_transit'
}

/** Transaction representation/ aspect of a carton grouping */
export type CartonGroupingTransaction = {
  __typename?: 'CartonGroupingTransaction';
  /** The account type of this CGT */
  accountType?: Maybe<Scalars['String']>;
  /** The unit price of the advance transaction */
  advanceTransactionUnitPrice?: Maybe<Scalars['BigDecimal']>;
  /** The VAT-exclusive amount for this CGT */
  amountExclVatMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** The total amount including VAT for this CGT (copy of amount_major_unit). Prefer this field for clarity. */
  amountInclVatMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /**
   * Total Amount for this CGT (VAT-inclusive). Deprecated: prefer amount_incl_vat_major_unit.
   * @deprecated Use amount_incl_vat_major_unit instead. amount_major_unit is VAT-inclusive; both are kept in sync.
   */
  amountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Carton Grouping Associted to this CGT */
  cartonGrouping?: Maybe<CartonGrouping>;
  /** ID of the associated carton grouping */
  cartonGroupingId?: Maybe<Scalars['ID']>;
  /** Cartons for the CGT */
  cartons?: Maybe<Scalars['Int']>;
  /** Transaction Type related to this CGT */
  costCode?: Maybe<CostCode>;
  /** Created At for the CGT */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Currency the CGT was captured as */
  currency?: Maybe<CurrencyEnum>;
  /** Currency that this should be exchanged to */
  exchangeCurrency?: Maybe<Scalars['String']>;
  /** Exchange Rate for the currency on the CGT */
  exchangeRate?: Maybe<Scalars['Float']>;
  /** External Reference to identify the CGT */
  externalReferenceNum?: Maybe<Scalars['String']>;
  /** Unique identifier for the CGT */
  id?: Maybe<Scalars['Int']>;
  /** Distinction whether this transaction is an estimate or actual */
  isActual: Scalars['Boolean'];
  /** The net mass of the CGT */
  netMass?: Maybe<Scalars['Float']>;
  /** The number of pallets in this CGT */
  palletCount?: Maybe<Scalars['Float']>;
  /** The pallet gross mass of the CGT */
  palletGrossMass?: Maybe<Scalars['Float']>;
  /** The actual quantity amount of the CGT */
  quantityAmount?: Maybe<Scalars['BigDecimal']>;
  /** The price per quantity for this CGT */
  quantityPriceMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** The quantity type eg. 'kg', 'cartons', 'pallets', 'containers', 'percentage', 'percentage_of_incoterm' */
  quantityType?: Maybe<Scalars['String']>;
  /** Target Market for the CGT */
  targetMarket?: Maybe<Scalars['String']>;
  /** Transaction Date the CGT took place */
  transactionDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Date when the CGT was last updated at */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The VAT amount for this CGT */
  vatAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** The VAT type applied to this CGT */
  vatType?: Maybe<VatType>;
};

export type CartonGroupingTransactionAttributes = {
  /** Total Amount for this CGT */
  amountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Carton Grouping Associated to this CGT */
  cartonGroupingId: Scalars['ID'];
  /** Associated Invoice line item */
  invoiceLineItemId?: Maybe<Scalars['Int']>;
  /** Created At for the CGT */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Currency the CGT was captured as */
  currency?: Maybe<CurrencyEnum>;
  /** Exchange Rate for the currency on the CGT */
  exchangeRate?: Maybe<Scalars['Float']>;
  /** External Reference to identify the CGT */
  externalReferenceNum?: Maybe<Scalars['String']>;
  /** ID of the CGT */
  id?: Maybe<Scalars['Int']>;
  /** Transaction Date the CGT took place */
  transactionDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Date when the CGT was last updated at */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Currency that this should be exchanged to */
  exchangeCurrency?: Maybe<Scalars['String']>;
  /** The Quantity type that applies to the CGT */
  quantityType?: Maybe<Scalars['String']>;
  /** The Quantity amount that was part of this CGT */
  quantityAmount?: Maybe<Scalars['Float']>;
  /** The price per quantity for this CGT */
  quantityPriceMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Target Market for the CGT */
  targetMarket?: Maybe<Scalars['String']>;
  /** Cartons for the CGT */
  cartons?: Maybe<Scalars['Int']>;
  /** The net mass of the CGT */
  netMass?: Maybe<Scalars['Float']>;
  /** The gross mass of the CGT */
  palletGrossMass?: Maybe<Scalars['Float']>;
};

/** Returns the name of the location and CG states at that location. */
export type CartonGroupingWithLocation = {
  __typename?: 'CartonGroupingWithLocation';
  /** The actual arrival time */
  actualArrivalTime?: Maybe<Scalars['String']>;
  /** The actual departure time */
  actualDepartureTime?: Maybe<Scalars['String']>;
  /** The batch number */
  batchNumber?: Maybe<Scalars['String']>;
  /** The buyer id number */
  buyerId?: Maybe<Scalars['String']>;
  /** The buyer number */
  buyerName?: Maybe<Scalars['String']>;
  /** The number of cartons */
  cartons?: Maybe<Scalars['Int']>;
  /** The commodity id */
  commodityId?: Maybe<Scalars['String']>;
  /** The commodity name */
  commodityName?: Maybe<Scalars['String']>;
  /** The Consignment number */
  consignmentNumber?: Maybe<Scalars['String']>;
  /** The container number */
  containerNumber?: Maybe<Scalars['String']>;
  /** The country of the current location */
  currentLocationCountry?: Maybe<Scalars['String']>;
  /** The id of the current location */
  currentLocationId?: Maybe<Scalars['String']>;
  /** The name of the current location */
  currentLocationName?: Maybe<Scalars['String']>;
  /** The type of the current location */
  currentLocationType?: Maybe<Scalars['String']>;
  /** The document status */
  documentStatus?: Maybe<Scalars['String']>;
  /** The estimated arrival time */
  estimatedArrivalTime?: Maybe<Scalars['String']>;
  /** The estimated departure time */
  estimatedDepartureTime?: Maybe<Scalars['String']>;
  /** The exporter code */
  exporterCode?: Maybe<Scalars['String']>;
  /** The extended fields for the pallet */
  extendedFields?: Maybe<Scalars['Json']>;
  /** The farm code */
  farmCode?: Maybe<Scalars['String']>;
  /** The cg audits */
  fileUpdates?: Maybe<Array<CartonGroupingAudit>>;
  /** The carton grouping grade */
  grade?: Maybe<Scalars['String']>;
  /** The ID */
  id?: Maybe<Scalars['Int']>;
  /** The inspection date */
  inspectionDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The inventory code */
  inventoryCode?: Maybe<Scalars['String']>;
  /** The load out instruction id */
  loadOutInstructionId?: Maybe<Scalars['String']>;
  /** The load out reference */
  loadOutReference?: Maybe<Scalars['String']>;
  /** The mark */
  mark?: Maybe<Scalars['String']>;
  /** The net mass */
  netMass?: Maybe<Scalars['Float']>;
  /** The country of the next location */
  nextLocationCountry?: Maybe<Scalars['String']>;
  /** The id of the next location */
  nextLocationId?: Maybe<Scalars['String']>;
  /** The name of the next location */
  nextLocationName?: Maybe<Scalars['String']>;
  /** The type of the next location */
  nextLocationType?: Maybe<Scalars['String']>;
  /** The orchard */
  orchard?: Maybe<Scalars['String']>;
  /** The pack type */
  pack?: Maybe<Scalars['String']>;
  /** The packhouse code */
  packhouseCode?: Maybe<Scalars['String']>;
  /** The packing week */
  packingWeek?: Maybe<Scalars['String']>;
  /** The pallet age measured in days */
  palletAge?: Maybe<Scalars['Int']>;
  /** The pallet gross mass */
  palletGrossMass?: Maybe<Scalars['Float']>;
  /** The pallet number */
  palletNumber?: Maybe<Scalars['String']>;
  /** Errors from pallet rule validations */
  palletRulesErrors?: Maybe<Scalars['String']>;
  /** Whether this CG passed the pallet rules check */
  palletRulesPassed?: Maybe<Scalars['Boolean']>;
  /** The id of the previous location */
  previousLocationId?: Maybe<Scalars['String']>;
  /** The name of the previous location */
  previousLocationName?: Maybe<Scalars['String']>;
  /** The type of the previous location */
  previousLocationType?: Maybe<Scalars['String']>;
  /** The product characteristic */
  productCharacteristic?: Maybe<Scalars['String']>;
  /** The seller id */
  sellerId?: Maybe<Scalars['String']>;
  /** The seller name */
  sellerName?: Maybe<Scalars['String']>;
  /** The sequence number */
  sequenceNumber?: Maybe<Scalars['Int']>;
  /** The size count */
  sizeCount?: Maybe<Scalars['String']>;
  /** The state of the carton grouping */
  state?: Maybe<Scalars['String']>;
  /** The status of the carton grouping at the location */
  status?: Maybe<Scalars['String']>;
  /** The commodity id */
  subCommodityId?: Maybe<Scalars['String']>;
  /** The commodity name */
  subCommodityName?: Maybe<Scalars['String']>;
  /** The target country */
  targetCountry?: Maybe<Scalars['String']>;
  /** The target market */
  targetMarket?: Maybe<Scalars['String']>;
  /** The target region */
  targetRegion?: Maybe<Scalars['String']>;
  /** The variety id */
  varietyId?: Maybe<Scalars['String']>;
  /** The variety name */
  varietyName?: Maybe<Scalars['String']>;
  /** The variety code */
  varietyVarietyCode?: Maybe<Scalars['String']>;
  /** The eta for the vessel */
  vesselEta?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the vessel */
  vesselId?: Maybe<Scalars['Int']>;
  /** The name of the vessel */
  vesselName?: Maybe<Scalars['String']>;
};

/** The connection type for CartonGroupingWithLocation. */
export type CartonGroupingWithLocationConnection = {
  __typename?: 'CartonGroupingWithLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CartonGroupingWithLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CartonGroupingWithLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CartonGroupingWithLocationEdge = {
  __typename?: 'CartonGroupingWithLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CartonGroupingWithLocation>;
};

export type CartonType = {
  __typename?: 'CartonType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Certificate Transport Instruction */
export type CertificateTransportInstruction = {
  __typename?: 'CertificateTransportInstruction';
  /** Booking reference */
  bookingRef?: Maybe<Scalars['String']>;
  /** Company associated with this certificate transport instruction */
  company?: Maybe<Company>;
  /** Container number */
  containerNumber?: Maybe<Scalars['String']>;
  /** Delivery address */
  deliverTo?: Maybe<Scalars['String']>;
  /** Description information */
  description?: Maybe<Scalars['String']>;
  /** Empty depot information */
  emptyDepot?: Maybe<Scalars['String']>;
  /** Exporter information */
  exporter?: Maybe<Scalars['String']>;
  /** Gross weight */
  grossWeight?: Maybe<Scalars['String']>;
  /** Unique identifier for the certificate transport instruction */
  id: Scalars['ID'];
  /** Loadout reference */
  loadoutRef?: Maybe<Scalars['String']>;
  /** Packstore name */
  packstore?: Maybe<Scalars['String']>;
  /** Port of discharge details */
  portOfDischarge?: Maybe<Scalars['String']>;
  /** Port of loading details */
  portOfLoading?: Maybe<Scalars['String']>;
  /** Seal number */
  sealNumber?: Maybe<Scalars['String']>;
  /** Second Packstore name */
  secondPackstore?: Maybe<Scalars['String']>;
  /** Shipment Line Item Id reference */
  shipmentLineItemId?: Maybe<Scalars['ID']>;
  /** Tare weight */
  tareWeight?: Maybe<Scalars['String']>;
  /** Temperature code settings */
  tempCode?: Maybe<Scalars['String']>;
  /** Temperature settings */
  tempSettings?: Maybe<Scalars['String']>;
  /**
   * Object containing information on the document
   *            generated for this certificate transport instruction
   */
  templateOutput?: Maybe<TemplateOutput>;
  /** Transporter details */
  transporter?: Maybe<Scalars['String']>;
  /** Vent settings */
  vents?: Maybe<Scalars['String']>;
  /** Vessel information */
  vessel?: Maybe<Scalars['String']>;
  /** Voyage details */
  voyage?: Maybe<Scalars['String']>;
};

export type CertificateType = {
  __typename?: 'CertificateType';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type CgError = {
  __typename?: 'CgError';
  /** The context for the client to resolve the Cg Error */
  errorContext?: Maybe<Scalars['Json']>;
  /** The error message of the Cg Error */
  errorMessage?: Maybe<Scalars['String']>;
  /** The subtype of the Cg Error */
  errorSubtype?: Maybe<Scalars['String']>;
  /** The error type of the Cg Error */
  errorType?: Maybe<Scalars['String']>;
  /** The unique identifier of the Cg Error */
  id?: Maybe<Scalars['ID']>;
  /** The state of the Cg Error */
  state?: Maybe<Scalars['String']>;
};

/** Cg Error filter attribute for populating frontend filters */
export type CgErrorFilterAttribute = {
  __typename?: 'CgErrorFilterAttribute';
  /** List of available error types */
  errorType?: Maybe<Array<Scalars['String']>>;
  /** List of available states */
  state?: Maybe<Array<Scalars['String']>>;
};

export type CgErrorFilters = {
  /** The error types to filter on */
  errorType?: Maybe<Array<Scalars['String']>>;
  /** The state to filter on */
  state?: Maybe<Array<Scalars['String']>>;
};

export type CgErrorResolutionInput = {
  resolutionType: Scalars['String'];
  resolutionId: Scalars['ID'];
};

/** returns details channel notification model */
export type ChannelNotification = {
  __typename?: 'ChannelNotification';
  /** the date and time the channel notification was archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the body of the channel notification */
  body?: Maybe<Scalars['String']>;
  /** the metadata for the channel notification */
  channelMetadata?: Maybe<Scalars['JSON']>;
  /** the date and time the channel notification was deleted */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the date and time the channel notification was delivered */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the unique identifier for the channel notification */
  id?: Maybe<Scalars['ID']>;
  /** the notification items that are associated with the channel notification */
  notificationItems?: Maybe<Array<NotificationItem>>;
  /** the notification rule that created the channel notification */
  notificationRule?: Maybe<NotificationRule>;
  /** the date and time the channel notification was read */
  readAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the date and time the channel notification was sent */
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the title of the channel notification */
  title?: Maybe<Scalars['String']>;
};

/** The connection type for ChannelNotification. */
export type ChannelNotificationConnection = {
  __typename?: 'ChannelNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChannelNotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChannelNotification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ChannelNotificationEdge = {
  __typename?: 'ChannelNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ChannelNotification>;
};

/** Attributes to filter channel notifications by */
export type ChannelNotificationFilterAttributes = {
  /** filter by severity of the notification rule */
  severity?: Maybe<NotificationRuleSeverityEnum>;
  /** filter by archived channel notifications */
  archived?: Maybe<Scalars['Boolean']>;
  /** filter by unread and read channel notifications */
  unreadAndRead?: Maybe<Scalars['Boolean']>;
  /** filter by unread channel notifications */
  unread?: Maybe<Scalars['Boolean']>;
};

export type ChargeApplied = {
  __typename?: 'ChargeApplied';
  moneyAmount: Money;
  name: Scalars['String'];
};

export type ChildInvoice = {
  __typename?: 'ChildInvoice';
  /** Errors preventing invoice creation (e.g., pallets already invoiced) */
  errors?: Maybe<Array<Scalars['String']>>;
  invoice?: Maybe<Invoice>;
  revenueLineItems?: Maybe<Array<InvoiceLineItem>>;
};

export type ClaimLineItem = {
  __typename?: 'ClaimLineItem';
  /** The arrival qc grade of the claim line item */
  arrivalQcGrade?: Maybe<ArrivalQcGradeEnum>;
  /** The expected claim of the claim line item */
  expectedClaim?: Maybe<ExpectedClaimEnum>;
  /** The unique identifier for a claim line item */
  id: Scalars['ID'];
};

export type ClaimLineItemDefect = {
  __typename?: 'ClaimLineItemDefect';
  /** The defect on the claim line item */
  defect: Defect;
  /** The percentage of the defect */
  defectPercentage?: Maybe<Scalars['Float']>;
};

export type ClaimLineItemDefectInput = {
  /** Defect */
  defect: DefectInput;
  /** Defect Percentage */
  defectPercentage?: Maybe<Scalars['Float']>;
};

export type ClaimLineItemGrouping = {
  __typename?: 'ClaimLineItemGrouping';
  /** The Arrival QC grade of the claim line item grouping */
  arrivalQcGrade?: Maybe<ArrivalQcGradeEnum>;
  /** The comment placed on a claim line item grouping */
  comment?: Maybe<Scalars['String']>;
  /** The commodity of the claim line item grouping */
  commodity?: Maybe<Commodity>;
  /** The cosmetic defects of the claim line item grouping */
  cosmeticClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The cosmetic defect options of the claim line item grouping */
  cosmeticDefectOptions?: Maybe<Array<Defect>>;
  /** The cosmetic defect percentage of the claim line item grouping */
  cosmeticDefectPercentage?: Maybe<Scalars['Float']>;
  /** The expected claim of the claim line item grouping */
  expectedClaims?: Maybe<Array<ExpectedClaimEnum>>;
  /** The farm code of the claim line item grouping */
  farmCode?: Maybe<Scalars['String']>;
  /** The grade og the claim line item grouping */
  grade?: Maybe<Scalars['String']>;
  /** Unique identifier for the claim line item grouping */
  id: Scalars['ID'];
  /** The other defects of the claim line item grouping */
  otherClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The other defect options of the claim line item grouping */
  otherDefectOptions?: Maybe<Array<Defect>>;
  /** The other defect percentage of the claim line item grouping */
  otherDefectPercentage?: Maybe<Scalars['Float']>;
  /** The number of pallets that belong to the claim line item grouping */
  palletCount?: Maybe<Scalars['Int']>;
  /** The progressive defects of the claim line item grouping */
  progressiveClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The progressive defect options of the claim line item grouping */
  progressiveDefectOptions?: Maybe<Array<Defect>>;
  /** The progressive defect percentage of the claim line item grouping */
  progressiveDefectPercentage?: Maybe<Scalars['Float']>;
  /** The size count of the claim line item grouping */
  sizeCount?: Maybe<Scalars['String']>;
  /** The variety of the claim line item grouping */
  variety?: Maybe<Variety>;
};

export type ClaimLineItemPallet = {
  __typename?: 'ClaimLineItemPallet';
  /** The arrival qc grade of the claim line items pallet */
  arrivalQcGrade?: Maybe<ArrivalQcGradeEnum>;
  /** The claim line item grouping id of the claim line item pallet */
  claimLineItemGroupingId?: Maybe<Scalars['ID']>;
  /** The claim line items that belong to the claim line item's pallet */
  claimLineItems?: Maybe<Array<ClaimLineItem>>;
  /** The commodity of the claim line item pallet */
  commodity?: Maybe<Commodity>;
  /** The cosmetic defects of the claim line item pallet */
  cosmeticClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The cosmetic defect options of the claim line item pallet */
  cosmeticDefectOptions?: Maybe<Array<Defect>>;
  /** The expected claim of the claim line items pallet  */
  expectedClaim?: Maybe<ExpectedClaimEnum>;
  /** The uniques identifier for the claim line item pallet which is the pallet's id */
  id: Scalars['ID'];
  /** The other defects of the claim line item pallet */
  otherClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The other defect options of the claim line item pallet */
  otherDefectOptions?: Maybe<Array<Defect>>;
  /** The pallet number of the pallet */
  palletNumber: Scalars['String'];
  /** The progressive defects of the claim line item pallet */
  progressiveClaimLineItemDefects?: Maybe<Array<ClaimLineItemDefect>>;
  /** The progressive defect options of the claim line item pallet */
  progressiveDefectOptions?: Maybe<Array<Defect>>;
};

export type Claims = {
  __typename?: 'Claims';
  /** The claim line item groupings returned by the resolver */
  claimLineItemGroupings: Array<ClaimLineItemGrouping>;
  /** The claim line item's pallets returned by the resolver */
  claimLineItemPallets: Array<ClaimLineItemPallet>;
  /** The container claims returned by the resolver */
  containerClaims: ContainerClaimConnection;
};


export type ClaimsContainerClaimsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ClientChangeRequest = {
  __typename?: 'ClientChangeRequest';
  /** Unique identifier for the client change request */
  id?: Maybe<Scalars['ID']>;
  /** The context of the error */
  userContext?: Maybe<Scalars['String']>;
};

/** Attributes for confirming a relation between cold stores and a client change request */
export type ClientChangeRequestExportColdStoreAttributes = {
  /** The ID of the client change request */
  clientChangeRequestId: Scalars['ID'];
  /** The IDs of the cold stores */
  coldStoreIds: Array<Scalars['ID']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CloseOfferAsSupplier. */
export type CloseOfferAsSupplierPayload = {
  __typename?: 'CloseOfferAsSupplierPayload';
  /** What went wrong when closing the offer */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The offer that was closed */
  offer?: Maybe<Offer>;
};

/** The color of the badge to be used in UI */
export enum ColorEnum {
  Red = 'red',
  Orange = 'orange',
  Amber = 'amber',
  Yellow = 'yellow',
  Lime = 'lime',
  Green = 'green',
  Emerald = 'emerald',
  Teal = 'teal',
  Cyan = 'cyan',
  Sky = 'sky',
  Blue = 'blue',
  Indigo = 'indigo',
  Violet = 'violet',
  Purple = 'purple',
  Fuchsia = 'fuchsia',
  Pink = 'pink',
  Rose = 'rose',
  Slate = 'slate'
}

/** Attributes to order on */
export type ColumnOrderAttributes = {
  /** field you want to order on */
  orderField: Scalars['String'];
  /** direction you want to order on */
  orderDirection: ColumnOrderDirectionEnum;
};

export enum ColumnOrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type Command = {
  __typename?: 'Command';
  batchId?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  commandType?: Maybe<CommandTypeEnum>;
  connectorName?: Maybe<Scalars['String']>;
};

/** Attributes for an on premises batch result */
export type CommandResultAttributes = {
  batchid: Scalars['String'];
  state: CommandStateEnum;
  jsonresult?: Maybe<Scalars['Json']>;
  /** base64 encoded, zlib compressed, json string */
  zippedjson?: Maybe<Scalars['String']>;
};

export enum CommandStateEnum {
  OnPremisesSuccess = 'on_premises_success',
  OnPremisesError = 'on_premises_error',
  OnPremisesUnknown = 'on_premises_unknown'
}

export enum CommandTypeEnum {
  MssqlQuery = 'MSSQL_QUERY',
  CheckForUpdate = 'CHECK_FOR_UPDATE',
  Restart = 'RESTART',
  ReconnectDb = 'RECONNECT_DB',
  SystemReport = 'SYSTEM_REPORT',
  SetConnector = 'SET_CONNECTOR'
}

export type Comment = {
  __typename?: 'Comment';
  commentText?: Maybe<Scalars['String']>;
  commentable?: Maybe<CommentableUnion>;
  commentableId?: Maybe<Scalars['Int']>;
  commentableType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

export type CommentableUnion = LineItem | Order;

export type CommercialTerm = {
  __typename?: 'CommercialTerm';
  /** Amount for advance payment */
  advanceAmount?: Maybe<Scalars['Float']>;
  /** Credit term for advance payment */
  advanceCreditTerm?: Maybe<Scalars['Int']>;
  /** Currency for advance payment */
  advanceCurrency?: Maybe<Scalars['String']>;
  /** Event triggering advance payment */
  advanceEvent?: Maybe<Scalars['String']>;
  /** Type of advance payment */
  advanceType?: Maybe<Scalars['String']>;
  /** Unit for advance payment */
  advanceUnit?: Maybe<Scalars['String']>;
  /** The buyer company */
  buyer?: Maybe<Company>;
  /** ID of the buyer company */
  buyerId?: Maybe<Scalars['Int']>;
  /** The name of the buyer company */
  buyerName?: Maybe<Scalars['String']>;
  /** The commodity associated with this commercial term */
  commodity?: Maybe<Commodity>;
  /** The name of the commodity associated with this commercial term */
  commodityName?: Maybe<Scalars['String']>;
  /** Whether this commercial term is deleted */
  deleted: Scalars['Boolean'];
  /** End date of the commercial term */
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Exporter code associated with this commercial term */
  exporterCode?: Maybe<Scalars['String']>;
  /** Credit term for final payment */
  finalCreditTerm?: Maybe<Scalars['Int']>;
  /** Currency for final payment */
  finalCurrency?: Maybe<Scalars['String']>;
  /** Event triggering final payment */
  finalEvent?: Maybe<Scalars['String']>;
  /** Grade specification */
  grade?: Maybe<Scalars['String']>;
  /** Unique identifier for the commercial term */
  id?: Maybe<Scalars['Int']>;
  /** Pack specification */
  pack?: Maybe<Scalars['String']>;
  /** Payment term specification */
  paymentTerm?: Maybe<Scalars['String']>;
  /** Rank one advance event trigger */
  rankOneAdvanceEvent?: Maybe<Scalars['String']>;
  /** Rank one final event trigger */
  rankOneFinalEvent?: Maybe<Scalars['String']>;
  /** The seller company */
  seller?: Maybe<Company>;
  /** ID of the seller company */
  sellerId?: Maybe<Scalars['Int']>;
  /** Start date of the commercial term */
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The target country associated with this commercial term */
  targetCountry?: Maybe<Scalars['String']>;
  /** Target region for the commercial term */
  targetRegion?: Maybe<Scalars['String']>;
  /** The variety associated with this commercial term */
  variety?: Maybe<Variety>;
  /** The name of the variety associated with this commercial term */
  varietyName?: Maybe<Scalars['String']>;
};

/** Attributes for upserting a commercial term */
export type CommercialTermAttributes = {
  /** The ID of the commercial term to upsert */
  id?: Maybe<Scalars['ID']>;
  /** The ID of the seller */
  sellerId: Scalars['ID'];
  /** The ID of the buyer */
  buyerId: Scalars['ID'];
  /** The ID of the commodity */
  commodityId: Scalars['ID'];
  /** The ID of the variety */
  varietyId?: Maybe<Scalars['ID']>;
  /** The target region */
  targetRegionId?: Maybe<Scalars['ID']>;
  /** The target country */
  targetCountryId?: Maybe<Scalars['ID']>;
  /** The pack */
  packId?: Maybe<Scalars['ID']>;
  /** The grade */
  grade?: Maybe<Scalars['String']>;
  /** The exporter code */
  exporterCode?: Maybe<Scalars['String']>;
  /** The payment term */
  paymentTerm: Scalars['String'];
  /** The advance type */
  advanceType?: Maybe<Scalars['String']>;
  /** The advance amount */
  advanceAmount?: Maybe<Scalars['Float']>;
  /** The advance currency */
  advanceCurrency?: Maybe<Scalars['String']>;
  /** The advance credit term */
  advanceCreditTerm?: Maybe<Scalars['Float']>;
  /** The final credit term */
  finalCreditTerm?: Maybe<Scalars['Float']>;
  /** The final currency */
  finalCurrency?: Maybe<Scalars['String']>;
  /** The start date */
  startDate: Scalars['ISO8601DateTime'];
  /** The end date */
  endDate: Scalars['ISO8601DateTime'];
  /** The advance unit */
  advanceUnit?: Maybe<Scalars['String']>;
};

export type CommercialTermChangeRequest = {
  __typename?: 'CommercialTermChangeRequest';
  commercialTerm?: Maybe<CommercialTerm>;
  flag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

/** The connection type for CommercialTerm. */
export type CommercialTermConnection = {
  __typename?: 'CommercialTermConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommercialTermEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CommercialTerm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CommercialTermEdge = {
  __typename?: 'CommercialTermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CommercialTerm>;
};

/** Attributes to filter commercial terms by */
export type CommercialTermFilterAttribute = {
  __typename?: 'CommercialTermFilterAttribute';
  /** advance types you want to filter by */
  advanceTypes?: Maybe<Array<Scalars['String']>>;
  /** advance units you want to filter by */
  advanceUnits?: Maybe<Array<Scalars['String']>>;
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** events you want to filter by */
  events?: Maybe<Array<Scalars['String']>>;
  /** target region you want to filter by */
  targetRegions?: Maybe<Array<Scalars['String']>>;
};

/** Attributes to filter commercial terms by */
export type CommercialTermFilterAttributes = {
  /** buyers you want to filter by */
  buyerIds?: Maybe<Array<Scalars['ID']>>;
  /** commodities you want to filter by */
  commodityIds?: Maybe<Array<Scalars['ID']>>;
  /** target region you want to filter by */
  targetRegions?: Maybe<Array<Scalars['String']>>;
  /** events from rank 1 advance and final events to filter by */
  events?: Maybe<Array<Scalars['String']>>;
  /** Packing Week to filter on */
  endWeek?: Maybe<Scalars['String']>;
  /** Packing Week to filter on */
  startWeek?: Maybe<Scalars['String']>;
  /** advance types to filter by */
  advanceTypes?: Maybe<Array<Scalars['String']>>;
  /** advance units to filter by */
  advanceUnits?: Maybe<Array<Scalars['String']>>;
};

export type Commodity = {
  __typename?: 'Commodity';
  commodityGroup?: Maybe<CommodityGroupEnum>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  icon?: Maybe<Image>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  varieties?: Maybe<Array<Variety>>;
};

export type CommodityDefaultSeason = {
  __typename?: 'CommodityDefaultSeason';
  commodityId: Scalars['Int'];
  id: Scalars['Int'];
  maxWeek: Scalars['String'];
  minWeek: Scalars['String'];
};


export type CommodityDefaultSeasonMaxWeekArgs = {
  year?: Scalars['Int'];
};


export type CommodityDefaultSeasonMinWeekArgs = {
  year?: Scalars['Int'];
};

export enum CommodityGroupEnum {
  TableGrapes = 'TableGrapes',
  Citrus = 'Citrus',
  Subtropical = 'Subtropical',
  Exotic = 'Exotic',
  Stone = 'Stone',
  Pome = 'Pome',
  Tropical = 'Tropical',
  Vegetable = 'Vegetable'
}

export type CommoditySeason = {
  __typename?: 'CommoditySeason';
  commodity?: Maybe<Commodity>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  id?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Company = {
  __typename?: 'Company';
  about?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Array<User>>;
  additionalFields?: Maybe<Array<AdditionalField>>;
  address?: Maybe<Address>;
  /** all associated companies */
  allCompanies?: Maybe<Array<Company>>;
  averageRating?: Maybe<Scalars['Float']>;
  buyers?: Maybe<Array<Company>>;
  certificates?: Maybe<Array<CompanyCertificate>>;
  /** The commodities associated with the company */
  commodities?: Maybe<Array<Commodity>>;
  commoditySeasons?: Maybe<Array<CommoditySeason>>;
  /** @deprecated Companies has been replaced with Buyers and Sellers */
  companies?: Maybe<Array<Company>>;
  /** The URL of the company logo */
  companyLogoImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  defaultLocale?: Maybe<Scalars['String']>;
  /** List of exporter codes associated with this company */
  exporterCodes?: Maybe<Array<ExporterCode>>;
  exporters?: Maybe<Array<Company>>;
  id?: Maybe<Scalars['Int']>;
  invites?: Maybe<Array<Invite>>;
  isBuyer?: Maybe<Scalars['Boolean']>;
  isSeller?: Maybe<Scalars['Boolean']>;
  /** @deprecated Doesn't provide a full URL. Use logoImage instead */
  logo?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by logoImage */
  logoFile?: Maybe<Document>;
  logoImage?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
  numberOfRatings?: Maybe<Scalars['Int']>;
  /** The current step of the onboarding process */
  onboardingStep?: Maybe<CompanyOnboardingStepEnum>;
  packhouseConnections?: Maybe<Array<PackhouseConnection>>;
  /** Yield persona: buyer, producer, or agent */
  persona?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  sellerVarieties?: Maybe<Array<Variety>>;
  sellers?: Maybe<Array<Company>>;
  /** The state of the company */
  state?: Maybe<CompanyStateEnum>;
  tradeRegions?: Maybe<Array<TradeRegion>>;
  users?: Maybe<Array<User>>;
  varieties?: Maybe<Array<FarmVariety>>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type CompanyAssociation = {
  __typename?: 'CompanyAssociation';
  /** The child company in the association */
  childCompany?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the company association */
  id?: Maybe<Scalars['Int']>;
  /** The name of the company association */
  name?: Maybe<Scalars['String']>;
  /** Whether the association is facilitated by OneSwitch */
  oneswitchFacilitated?: Maybe<Scalars['Boolean']>;
  /** The parent company in the association */
  parentCompany?: Maybe<Company>;
  /** The type of relationship between the companies */
  relation?: Maybe<CompanyAssociationRelationTypeEnum>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for confirming a relation between cold stores and a supplier-exporter association */
export type CompanyAssociationExportColdStoreAttributes = {
  /** The ID of the supplier-exporter association */
  companyAssociationId: Scalars['ID'];
  /** The IDs of the cold stores */
  coldStoreIds: Array<Scalars['ID']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: Maybe<Scalars['Boolean']>;
};

/** The type of relationship between the companies */
export enum CompanyAssociationRelationTypeEnum {
  /** Company association is seller buyer */
  SellerBuyer = 'SELLER_BUYER',
  /** Company association is supplier packhouse */
  SupplierPackhouse = 'SUPPLIER_PACKHOUSE',
  /** Company association is supplier exporter */
  SupplierExporter = 'SUPPLIER_EXPORTER',
  /** Company association is consignor consignee */
  ConsignorConsignee = 'CONSIGNOR_CONSIGNEE',
  /** Company association is invoice */
  Invoice = 'INVOICE',
  /** Company association is notify */
  Notify = 'NOTIFY',
  /** Company association is market marketsection */
  MarketMarketsection = 'MARKET_MARKETSECTION'
}

export type CompanyCertificate = {
  __typename?: 'CompanyCertificate';
  certificate?: Maybe<Document>;
  certificateType?: Maybe<CertificateType>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  expiryDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The current step of the onboarding process */
export enum CompanyOnboardingStepEnum {
  /** Onboarding step is start */
  Start = 'START',
  /** Onboarding step is packhouse connections */
  PackhouseConnections = 'PACKHOUSE_CONNECTIONS',
  /** Onboarding step is data confirmations */
  DataConfirmations = 'DATA_CONFIRMATIONS',
  /** Onboarding step is supply chain confirmations */
  SupplyChainConfirmations = 'SUPPLY_CHAIN_CONFIRMATIONS',
  /** Onboarding step is complete */
  Complete = 'COMPLETE'
}

/** Fields available on a company payment */
export type CompanyPayment = {
  __typename?: 'CompanyPayment';
  /** The company recording the payment, this can either be the recipient or the payer */
  company?: Maybe<Company>;
  /** The id of the company recording the payment, this can either be the recipient or the payer */
  companyId?: Maybe<Scalars['ID']>;
  /** The name of the company recording the payment, this can either be the recipient or the payer */
  companyName?: Maybe<Scalars['String']>;
  /** The contact involved in the transaction */
  contact?: Maybe<Contact>;
  /** The id of the contact involved in the transaction */
  contactId?: Maybe<Scalars['ID']>;
  /** The name of the contact involved in the transaction */
  contactName?: Maybe<Scalars['String']>;
  /** Currency allows us to group payments and invoices of the same currency together */
  currency?: Maybe<Scalars['String']>;
  /** Amount of money needed to pay outstanding incoming invoices in major unit */
  incomingAmountDueMajorUnit?: Maybe<Scalars['Float']>;
  /** Amount of incoming money not yet allocated to invoices in major unit */
  incomingUnallocatedAmountMajorUnit?: Maybe<Scalars['Float']>;
  /** Number of invoices due for this company */
  invoicesDue?: Maybe<Scalars['Int']>;
  /** Amount of money needed to pay outstanding outgoing invoices in major unit */
  outgoingAmountDueMajorUnit?: Maybe<Scalars['Float']>;
  /** Amount of outgoing money not yet allocated to invoices in major unit */
  outgoingUnallocatedAmountMajorUnit?: Maybe<Scalars['Float']>;
  /** Number of unallocated payments for this company */
  unallocatedPayments?: Maybe<Scalars['Int']>;
  /** When the associated invoice or payment was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Company payment filter attribute for populating frontend filters */
export type CompanyPaymentFilterAttribute = {
  __typename?: 'CompanyPaymentFilterAttribute';
  /** contacts linked to this user's payments */
  contacts?: Maybe<Array<Contact>>;
};

/** Filtering options for company payments */
export type CompanyPaymentFilters = {
  /** currency of the company payments */
  currencies?: Maybe<Array<Scalars['String']>>;
  /** id of the contacts associated */
  contactIds?: Maybe<Array<Scalars['Int']>>;
  /** filter payments (by payment_date) and invoices (by invoice_date) on or after this date (inclusive) */
  fromDate?: Maybe<Scalars['ISO8601Date']>;
  /** filter payments (by payment_date) and invoices (by invoice_date) on or before this date (inclusive) */
  toDate?: Maybe<Scalars['ISO8601Date']>;
};

export enum CompanyPersonaEnum {
  Producer = 'producer',
  Agent = 'agent',
  Buyer = 'buyer'
}

/** The state of a company used to control platform access */
export enum CompanyStateEnum {
  /** Company state is onboarding */
  Onboarding = 'onboarding',
  /** Company state is in season */
  InSeason = 'in_season',
  /** Company state is re onboarding */
  ReOnboarding = 're_onboarding',
  /** Company state is suspended */
  Suspended = 'suspended'
}

/** Autogenerated return type of CompleteAirFreightShipment. */
export type CompleteAirFreightShipmentPayload = {
  __typename?: 'CompleteAirFreightShipmentPayload';
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CompleteShipmentLineItem. */
export type CompleteShipmentLineItemPayload = {
  __typename?: 'CompleteShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CompleteShipment. */
export type CompleteShipmentPayload = {
  __typename?: 'CompleteShipmentPayload';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type Config = {
  __typename?: 'Config';
  /** name of the config */
  name?: Maybe<Scalars['String']>;
  /** value of the config */
  value?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ConfirmExportNotificationLineItem. */
export type ConfirmExportNotificationLineItemPayload = {
  __typename?: 'ConfirmExportNotificationLineItemPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
  /** The current shipment */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of ConfirmExporterColdStores. */
export type ConfirmExporterColdStoresPayload = {
  __typename?: 'ConfirmExporterColdStoresPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Whether the cold stores were confirmed successfully */
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ConfirmMasterfileConfigCompanyAssociations. */
export type ConfirmMasterfileConfigCompanyAssociationsPayload = {
  __typename?: 'ConfirmMasterfileConfigCompanyAssociationsPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

/** Autogenerated return type of ConfirmMasterfileConfigFarmVarieties. */
export type ConfirmMasterfileConfigFarmVarietiesPayload = {
  __typename?: 'ConfirmMasterfileConfigFarmVarietiesPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

/** Autogenerated return type of ConfirmMasterfileConfigFbo. */
export type ConfirmMasterfileConfigFboPayload = {
  __typename?: 'ConfirmMasterfileConfigFboPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

/** Autogenerated return type of ConfirmMasterfileConfigPackhouseConnections. */
export type ConfirmMasterfileConfigPackhouseConnectionsPayload = {
  __typename?: 'ConfirmMasterfileConfigPackhouseConnectionsPayload';
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The masterfile configs */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
};

export type Contact = {
  __typename?: 'Contact';
  /** The company associated with the contact */
  company?: Maybe<Company>;
  /** The type of contact */
  contactType?: Maybe<ContactTypeEnum>;
  /** The date and time the contact was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The User ID of the User that created this contact */
  createdByUserId?: Maybe<Scalars['ID']>;
  /** Unique identifier for the contact */
  id?: Maybe<Scalars['Int']>;
  /** Additional information about the contact */
  info?: Maybe<Scalars['String']>;
  /** The name of the contact */
  name?: Maybe<Scalars['String']>;
  /** The date and time the contact was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ContactAttributes = {
  contactType?: Maybe<ContactTypeEnum>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** The type of contact to be used in templates */
export enum ContactTypeEnum {
  Consignee = 'consignee',
  Consignor = 'consignor',
  InvoiceParty = 'invoice_party',
  NotifyParty = 'notify_party'
}

/** Containers */
export type Container = {
  __typename?: 'Container';
  /** Container carrier name */
  carrierName?: Maybe<Scalars['String']>;
  /** Carton groupings of the container */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** Container number */
  containerNumber?: Maybe<Scalars['String']>;
  /** Container size */
  containerSize?: Maybe<Scalars['String']>;
  /** Container type */
  containerType?: Maybe<Scalars['String']>;
  /** Container ID */
  id?: Maybe<Scalars['Int']>;
  /** Origin port of the container */
  originPort?: Maybe<SeaPort>;
  /** Container seal number */
  sealNumber?: Maybe<Scalars['String']>;
  /** Container stuff date */
  stuffDate?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ContainerClaim = {
  __typename?: 'ContainerClaim';
  /** The date that the arrival qc was caprtured */
  arrivalQcDatetime?: Maybe<Scalars['ISO8601Date']>;
  /** The associated break bulk container */
  breakBulkContainer?: Maybe<BreakBulkContainer>;
  /** Unique identifier for the Company associated with this container claim */
  companyId: Scalars['ID'];
  /** The date that the container claim was marked as completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The associated container's container number */
  container?: Maybe<Container>;
  /** The date that the container arrived */
  containerArrivalDate?: Maybe<Scalars['ISO8601Date']>;
  /** The id of the containerable associated with the container claim */
  containerableId: Scalars['ID'];
  /** The type of containerable associated with the container claim */
  containerableType: ContainerableTypeEnum;
  /** The counterparty specifies the recipient of the break bulk container, as the recipient is not always the buyer */
  counterParty?: Maybe<Company>;
  /** The uploaded documents associated with the container claim */
  documents?: Maybe<Array<Document>>;
  /** Unique identifier for the container claim */
  id: Scalars['ID'];
  /** The notes stored on the container claim */
  notes?: Maybe<Scalars['String']>;
  /** The uploaded photos associated with the container claim */
  photos?: Maybe<Array<Image>>;
  /** The arrival qc state of the container claim */
  state?: Maybe<ArrivalQcStateEnum>;
  /** When the shipment line item was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The vessel name associated with the container claim */
  vesselName?: Maybe<Scalars['String']>;
  /** The voyage number associated with the container claim */
  voyageNumber?: Maybe<Scalars['String']>;
};

/** The connection type for ContainerClaim. */
export type ContainerClaimConnection = {
  __typename?: 'ContainerClaimConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContainerClaimEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContainerClaim>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContainerClaimEdge = {
  __typename?: 'ContainerClaimEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ContainerClaim>;
};

export enum ContainerableTypeEnum {
  /** The containerable type: Container */
  Container = 'Container',
  /** The containerable type: BreakBulkContainer */
  BreakBulkContainer = 'BreakBulkContainer'
}

export type ContainersForArrivalQc = {
  __typename?: 'ContainersForArrivalQc';
  /** The Container number of the container eligible for arrival QC */
  containerNumber?: Maybe<Scalars['String']>;
  /** The ID of the Container eligible for arrival QC */
  id: Scalars['ID'];
  /** The Vessel name */
  vesselName?: Maybe<Scalars['String']>;
  /** The Voyage number */
  voyageNumber?: Maybe<Scalars['String']>;
};

export type CostCode = {
  __typename?: 'CostCode';
  /** The company associated with this cost code */
  company?: Maybe<Company>;
  /** Type of cost */
  costType: Scalars['String'];
  /** Field name used for the cost code */
  fieldName: Scalars['String'];
  /** General ledger name */
  generalLedgerName?: Maybe<Scalars['String']>;
  /** Unique identifier for the cost code */
  id: Scalars['Int'];
  /** Whether this is a default cost code */
  isDefault: Scalars['Boolean'];
  /** Display name of the cost code */
  name: Scalars['String'];
  /** The supply chain segment where this cost code applies */
  supplyChainLeg?: Maybe<Scalars['String']>;
};

export type CostCodeFilterAttribute = {
  __typename?: 'CostCodeFilterAttribute';
  /** Cost type to filter by. */
  costTypes?: Maybe<Array<Scalars['String']>>;
  /** Field name to filter by. */
  fieldNames?: Maybe<Array<Scalars['String']>>;
  /** List of finance rule IDs to filter by. */
  financeRules?: Maybe<Array<FinanceRule>>;
  /** General ledger name to filter by. */
  generalLedgerNames?: Maybe<Array<Scalars['String']>>;
  /** Filter by default status. */
  isDefault?: Maybe<Scalars['Boolean']>;
  /** Name to filter by. */
  names?: Maybe<Array<Scalars['String']>>;
  /** Whether the screen should display active or historic costs */
  pageType?: Maybe<Scalars['String']>;
  /** Supply chain leg to filter by. */
  supplyChainLegs?: Maybe<Array<Scalars['String']>>;
};

/** Attributes used to create a counter offer */
export type CounterOfferAttributes = {
  /** The items associated with the counter offer */
  offerItems: Array<CounterOfferItemAttributes>;
};

/** Attributes used to create an offer item on a counter offer */
export type CounterOfferItemAttributes = {
  /** The size counts for the offer item */
  sizeCounts: Array<Scalars['String']>;
  /** The grade for the offer item (A, B, C, etc.) */
  grade: Scalars['String'];
  /** The quantity for the offer item, must be greater than 0 */
  quantity: Scalars['Int'];
  /** The CIF price per carton for this counter offer item. Required on every counter — only the supplier-initial offer may defer CIF to the buyer. */
  cifPriceAmountMajorUnit: Scalars['BigDecimal'];
};

/** Basic attributes for adding additional fields to a company's new order template */
export type CreateAdditionalFieldAttributes = {
  companyid: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  fieldtype: Scalars['String'];
  ispackinginstruction?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parameters?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateAdditionalField. */
export type CreateAdditionalFieldPayload = {
  __typename?: 'CreateAdditionalFieldPayload';
  additionalField?: Maybe<AdditionalField>;
};

/** Autogenerated return type of CreateCargoDue. */
export type CreateCargoDuePayload = {
  __typename?: 'CreateCargoDuePayload';
  /** The created cargo due */
  cargoDue?: Maybe<CargoDue>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateCartonConversion. */
export type CreateCartonConversionPayload = {
  __typename?: 'CreateCartonConversionPayload';
  cartonConversion?: Maybe<CartonConversion>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CreateClientChangeRequest. */
export type CreateClientChangeRequestPayload = {
  __typename?: 'CreateClientChangeRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<ClientChangeRequest>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
};

export type CreateCommentAttributes = {
  commentabletype: Scalars['String'];
  commentableid: Scalars['Int'];
  userid: Scalars['Int'];
  commenttext: Scalars['String'];
};

/** Autogenerated return type of CreateComment. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  comment?: Maybe<Comment>;
};

export type CreateCommercialTermChangeRequestAttributes = {
  commercialtermsid: Scalars['Int'];
  message: Scalars['String'];
  flag: Scalars['String'];
};

/** Autogenerated return type of CreateCommercialTermChangeRequest. */
export type CreateCommercialTermChangeRequestPayload = {
  __typename?: 'CreateCommercialTermChangeRequestPayload';
  changeRequest?: Maybe<CommercialTermChangeRequest>;
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateContact. */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCounterOfferAsSupplier. */
export type CreateCounterOfferAsSupplierPayload = {
  __typename?: 'CreateCounterOfferAsSupplierPayload';
  /** The counter offer that was created */
  counterOffer?: Maybe<Offer>;
  /** What went wrong when creating the counter offer */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateCustomField. */
export type CreateCustomFieldPayload = {
  __typename?: 'CreateCustomFieldPayload';
  /** The custom field */
  customField?: Maybe<CustomField>;
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateExportNotificationBooking. */
export type CreateExportNotificationBookingPayload = {
  __typename?: 'CreateExportNotificationBookingPayload';
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateExportNotificationLineItem. */
export type CreateExportNotificationLineItemPayload = {
  __typename?: 'CreateExportNotificationLineItemPayload';
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateExporterAndColdStoreClientRequest. */
export type CreateExporterAndColdStoreClientRequestPayload = {
  __typename?: 'CreateExporterAndColdStoreClientRequestPayload';
  /** The exporter client change request created */
  clientChangeRequest?: Maybe<SupplierExporterClientChangeRequest>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateExporterColdStoreRequest. */
export type CreateExporterColdStoreRequestPayload = {
  __typename?: 'CreateExporterColdStoreRequestPayload';
  /** Client change requests created for requested exporter cold store records */
  clientChangeRequests?: Maybe<Array<ExporterColdStoreClientChangeRequest>>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Whether the operation succeeded */
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for creating a farm */
export type CreateFarmAttribute = {
  /** The name of the farm */
  farmName: Scalars['String'];
  /** The FBO code of the farm */
  farmCode: Scalars['String'];
  /** The Global Gap number of the farm */
  globalGapNumber: Scalars['String'];
  /** The producer name of the farm */
  producerName: Scalars['String'];
  /** The ID of the production region of the farm */
  productionRegionId: Scalars['ID'];
};

/** Autogenerated return type of CreateFarmFbo. */
export type CreateFarmFboPayload = {
  __typename?: 'CreateFarmFboPayload';
  /** The errors that occurred while creating the farm FBO */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The created farm FBO */
  foodBusinessOperator?: Maybe<FoodBusinessOperator>;
  /** The created masterfile config */
  masterfileConfig?: Maybe<MasterfileConfig>;
};

/** Basic attributes for adding Varieties to a Company */
export type CreateFarmVarietyAttributes = {
  companyId: Scalars['Int'];
  hectares?: Maybe<Scalars['Float']>;
  packingend: Scalars['String'];
  packingstart: Scalars['String'];
  peakcount?: Maybe<Scalars['String']>;
  varietyid: Scalars['Int'];
};

/** Autogenerated return type of CreateFarmVariety. */
export type CreateFarmVarietyPayload = {
  __typename?: 'CreateFarmVarietyPayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of CreateFarmVarietyRequest. */
export type CreateFarmVarietyRequestPayload = {
  __typename?: 'CreateFarmVarietyRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<FarmVarietyRequest>;
  /** The commodity id associated with the requested farm variety */
  commodityId?: Maybe<Scalars['Int']>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
  /** The variety id associated with the requested farm variety */
  varietyId?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateFinanceRule. */
export type CreateFinanceRulePayload = {
  __typename?: 'CreateFinanceRulePayload';
  /** Error information when attempting to create finance rules */
  errors?: Maybe<Scalars['String']>;
  /** Finance rules created */
  financeRules?: Maybe<Array<FinanceRule>>;
};

/** Autogenerated return type of CreateFoodBusinessOperatorRequest. */
export type CreateFoodBusinessOperatorRequestPayload = {
  __typename?: 'CreateFoodBusinessOperatorRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<FoodBusinessOperatorRequest>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CreateIgnoreErrorRequest. */
export type CreateIgnoreErrorRequestPayload = {
  __typename?: 'CreateIgnoreErrorRequestPayload';
  /** Describes the action taken for the change request */
  action?: Maybe<Scalars['String']>;
  /** Represents a request to change information for a client */
  clientChangeRequest?: Maybe<ClientChangeRequest>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CreateIncotermLineItem. */
export type CreateIncotermLineItemPayload = {
  __typename?: 'CreateIncotermLineItemPayload';
  errors?: Maybe<Scalars['String']>;
  lineItem?: Maybe<LineItem>;
};

/** Autogenerated return type of CreateIncotermLineItems. */
export type CreateIncotermLineItemsPayload = {
  __typename?: 'CreateIncotermLineItemsPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  lineItems?: Maybe<Array<LineItem>>;
};

/** Autogenerated return type of CreateInvoiceFromBatch. */
export type CreateInvoiceFromBatchPayload = {
  __typename?: 'CreateInvoiceFromBatchPayload';
  /** Any errors from creating the new invoice */
  errors?: Maybe<Scalars['String']>;
  /** Created invoice from batch */
  invoice?: Maybe<Invoice>;
};

/** Autogenerated return type of CreateInvoice. */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  /** What went wrong when creating an invoice */
  errors?: Maybe<Scalars['String']>;
  /** The invoice that was created */
  invoice?: Maybe<Invoice>;
};

/** Attributes for creating a line item */
export type CreateLineItemAttributes = {
  /** The id of the buyer associated with the line item */
  buyerId?: Maybe<Scalars['ID']>;
  /** The id of the seller associated with the line item */
  sellerId?: Maybe<Scalars['ID']>;
  /** The id of the variety associated with the line item */
  varietyId: Scalars['Int'];
  /** The id of the commodity associated with the line item */
  commodityId: Scalars['Int'];
  /** The quantity of the line item */
  quantity?: Maybe<Scalars['Int']>;
  /** The unit of quantity of the line item */
  quantityUnit?: Maybe<Scalars['String']>;
  /** The price of the line item per minor unit */
  priceMinorUnit?: Maybe<Scalars['Int']>;
  /** The unit of price of the line item */
  priceUnit?: Maybe<Scalars['String']>;
  /** The currency of the line item */
  currency: Scalars['String'];
  /** The size counts of the line item */
  sizeCounts: Array<Scalars['String']>;
  /** The pack of the line item */
  pack: Scalars['String'];
  /** The price term of the line item */
  priceTerm: Scalars['String'];
  /** The priority of the line item */
  priority?: Maybe<Scalars['Int']>;
  /** The additional fields of the line item */
  additionalFields: Scalars['String'];
  /** The pallet stack of the line item */
  palletStack: Scalars['Int'];
  /** Whether the line item is unlimited */
  unlimited: Scalars['Boolean'];
  /** The target market of the line item */
  targetMarket?: Maybe<Scalars['String']>;
  /** The target region of the line item */
  targetRegion: Scalars['String'];
  /** The target country of the line item */
  targetCountry?: Maybe<Scalars['String']>;
  /** The packing week of the line item */
  packingWeek?: Maybe<Scalars['String']>;
  /** The start week of the line item */
  startWeek?: Maybe<Scalars['String']>;
  /** The end week of the line item */
  endWeek?: Maybe<Scalars['String']>;
  /** The incoterm of the line item */
  incoterm: Scalars['String'];
  /** The grade of the line item */
  grade?: Maybe<Scalars['String']>;
  /** The mark of the line item */
  mark?: Maybe<Scalars['String']>;
  /** The reference number of the line item */
  referenceNumber?: Maybe<Scalars['String']>;
  /** The rank/ order of the line item */
  rank?: Maybe<Scalars['Int']>;
  /** The batch number of the line item */
  batchNumber?: Maybe<Scalars['String']>;
  /** The inventory code of the line item */
  inventoryCode?: Maybe<Scalars['String']>;
  /** The id of the departure port of the line item */
  departurePortId?: Maybe<Scalars['Int']>;
  /** The id of the destination port of the line item */
  destinationPortId?: Maybe<Scalars['Int']>;
};

/** Attributes for creating a line item grouping */
export type CreateLineItemGroupingAttributes = {
  /** The cumulative quantity of the line item grouping */
  cumulativeQuantity?: Maybe<Scalars['Int']>;
  /** The type of quantity of the line item grouping */
  quantityType?: Maybe<Scalars['String']>;
  /** The common fields associated with the line item grouping */
  commonFields: Array<Scalars['String']>;
  /** The line items associated with the line item grouping */
  lineItems: Array<CreateLineItemAttributes>;
  /** The rank/ order of the line item grouping */
  rank?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateLoadOutInstruction. */
export type CreateLoadOutInstructionPayload = {
  __typename?: 'CreateLoadOutInstructionPayload';
  errors?: Maybe<Array<LoadOutInstructionError>>;
  loadOutInstruction?: Maybe<LoadOutInstruction>;
};

/** Autogenerated return type of CreateNetReturnProgram. */
export type CreateNetReturnProgramPayload = {
  __typename?: 'CreateNetReturnProgramPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  netReturnProgram?: Maybe<NetReturnProgram>;
};

/** Autogenerated return type of CreateOfferAsSupplier. */
export type CreateOfferAsSupplierPayload = {
  __typename?: 'CreateOfferAsSupplierPayload';
  /** What went wrong when creating the offer */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The offer that was created */
  offer?: Maybe<Offer>;
};

/** Attributes for creating an order */
export type CreateOrderAttributes = {
  /** The id of the buyer associated with the order */
  buyerId?: Maybe<Scalars['Int']>;
  /** The common fields associated with the order */
  commonFields?: Maybe<Array<Scalars['String']>>;
  /** Whether the order is a packhouse run */
  isPackhouseRun: Scalars['Boolean'];
  /** The line item groupings associated with the order */
  lineItemGroupings?: Maybe<Array<CreateLineItemGroupingAttributes>>;
  /** The id of the seller associated with the order */
  sellerId?: Maybe<Scalars['Int']>;
  /** The id of the user associated with the order */
  userId: Scalars['Int'];
};

/** Autogenerated return type of CreateOrder. */
export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  /** Errors that occurred while creating the order */
  errors?: Maybe<Scalars['String']>;
  /** The order that was created */
  order?: Maybe<Order>;
};

/** Autogenerated return type of CreateOrderProgram. */
export type CreateOrderProgramPayload = {
  __typename?: 'CreateOrderProgramPayload';
  /** What went wrong when creating an order program */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The order program that was created */
  orderProgram?: Maybe<OrderProgram>;
};

/** Attributes for creating packhouse connections */
export type CreatePackhouseConnectionsAttribute = {
  /** The IDs of the packhouses we need to connect our company to */
  packhouseIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of CreatePackhouseConnectionsRequest. */
export type CreatePackhouseConnectionsRequestPayload = {
  __typename?: 'CreatePackhouseConnectionsRequestPayload';
  /** The packhouse connection client change requests */
  clientChangeRequests?: Maybe<Array<PackhouseConnectionClientChangeRequest>>;
  /** The errors that occurred while creating the packhouse connection requests */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreatePayment. */
export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  /** What went wrong when creating a payment */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The payment that was created */
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of CreateQuickCost. */
export type CreateQuickCostPayload = {
  __typename?: 'CreateQuickCostPayload';
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateReportGroup. */
export type CreateReportGroupPayload = {
  __typename?: 'CreateReportGroupPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
  /** The report group */
  reportGroup?: Maybe<ReportGroup>;
};

/** Autogenerated return type of CreateShipmentLineItem. */
export type CreateShipmentLineItemPayload = {
  __typename?: 'CreateShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  shipmentLineItem?: Maybe<ShipmentLineItem>;
};

/** Autogenerated return type of CreateShipment. */
export type CreateShipmentPayload = {
  __typename?: 'CreateShipmentPayload';
  /** A list of error messages encountered during the mutation execution. Null if the creation is successful. */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The created shipment object. Null if the creation fails. */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of CreateSoftwareUpdateReport. */
export type CreateSoftwareUpdateReportPayload = {
  __typename?: 'CreateSoftwareUpdateReportPayload';
  /** The client change request that was created */
  clientChangeRequest?: Maybe<SoftwareUpdateReportRequest>;
  /** The errors that occurred */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Attributes for creating a supplier-exporter request */
export type CreateSupplierExporterRequestAttribute = {
  /** The IDs of the food business operators */
  foodBusinessOperatorIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of CreateSupplierExporterRequest. */
export type CreateSupplierExporterRequestPayload = {
  __typename?: 'CreateSupplierExporterRequestPayload';
  /** The created client change request */
  clientChangeRequests?: Maybe<Array<SupplierExporterClientChangeRequest>>;
  /** The errors that occurred while creating the client change request */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateUiConfig. */
export type CreateUiConfigPayload = {
  __typename?: 'CreateUiConfigPayload';
  config?: Maybe<UiConfig>;
};

export type CreateUpdateUiConfigAttributes = {
  configType: Scalars['String'];
  data: Scalars['Json'];
  /** Required when updating a config item */
  id?: Maybe<Scalars['Int']>;
  visibility: UiConfigVisibilityEnum;
};

/** A summary of the results of a tabular mutation */
export type CudSummary = {
  __typename?: 'CudSummary';
  /** Unique list of errors relating to failed changes. */
  errors: Array<Scalars['String']>;
  /** Count of failed changes. */
  failed: Scalars['Int'];
  /** Count of successful changes. */
  succeeded: Scalars['Int'];
};

/** A currency as defined by the ISO 4217 standard. */
export type Currency = {
  __typename?: 'Currency';
  /** The currency format as defined by IS0 4217. */
  isoCode: Iso4217;
  /** The smallest denomination of the currency. */
  smallestDenomination: Scalars['Int'];
  /** Factor used to convert a subunit to a unit. */
  subunitToUnit: Scalars['Int'];
  /** The symbol for the currency (i.e. "€"). */
  symbol: Scalars['String'];
};

/** Collection of Currency Conversions rates for a particular day */
export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  /** Unique indentifier for each currency conversion entry */
  id?: Maybe<Scalars['ID']>;
  /** Currency conversion exchange rates */
  rates?: Maybe<Scalars['Json']>;
  /** When exchange rates were stored */
  timestamp?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Attributes for loading a currency conversion */
export type CurrencyConversionAttributes = {
  /** Whether the conversion is a spot rate. i.e a daily rate */
  isSpotRate?: Maybe<Scalars['Boolean']>;
  /** Whether the conversion is a fixed rate. i.e a company-specific rate */
  isFixedRate?: Maybe<Scalars['Boolean']>;
  /** The date of the exchange */
  date?: Maybe<Scalars['ISO8601Date']>;
};

export enum CurrencyEnum {
  /** The currency with code USD */
  Usd = 'USD',
  /** The currency with code EUR */
  Eur = 'EUR',
  /** The currency with code GBP */
  Gbp = 'GBP',
  /** The currency with code CAD */
  Cad = 'CAD',
  /** The currency with code ZAR */
  Zar = 'ZAR',
  /** The currency with code JPY */
  Jpy = 'JPY',
  /** The currency with code CNY */
  Cny = 'CNY',
  /** The currency with code NAD */
  Nad = 'NAD'
}

/** Currency exchange rate type represents the exchange rate with parameters for a given resource. eg. Invoice, Payment, etc. */
export type CurrencyExchangeRate = {
  __typename?: 'CurrencyExchangeRate';
  /** The currency conversion associated with the set exchange rate, can be null for custom rates */
  currencyConversion?: Maybe<CurrencyConversion>;
  /** The currency conversion id associated with the set exchange rate, can be null for custom rates */
  currencyConversionId?: Maybe<Scalars['ID']>;
  /** The actual exchange rate value */
  exchangeRate: Scalars['BigDecimal'];
  /** The date of the exchange rate */
  exchangeRateDate: Scalars['ISO8601Date'];
  /** The type of exchange rate eg. "custom", "fixed", "spot" */
  exchangeRateType: Scalars['String'];
  /** The id of the exchangeable object */
  exchangeableId: Scalars['ID'];
  /** The type of exchangeable object eg. "Invoice", "Payment" */
  exchangeableType: Scalars['String'];
  /** The currency code of the currency being converted from */
  fromCurrency: Scalars['String'];
  /** Unique identifier for the Currency Exchange Rate */
  id: Scalars['ID'];
  /** The currency code of the currency being converted to */
  toCurrency: Scalars['String'];
};

/** Attributes to set a currency exchange rate */
export type CurrencyExchangeRateAttributes = {
  /** Unique identifier for the Currency Exchange Rate */
  id?: Maybe<Scalars['ID']>;
  /** The date of the exchange rate */
  exchangeRateDate: Scalars['ISO8601Date'];
  /** The exchange rate */
  exchangeRate: Scalars['BigDecimal'];
  /** The currency conversion id associated with the set exchange rate */
  currencyConversionId?: Maybe<Scalars['ID']>;
  /** The type of exchange rate eg. "custom", "fixed", "spot" */
  exchangeRateType: ExchangeRateTypeEnum;
  /** The currency code of the currency being converted from */
  fromCurrency: Scalars['String'];
  /** The currency code of the currency being converted to */
  toCurrency: Scalars['String'];
  /** The id of the exchangeable object */
  exchangeableId?: Maybe<Scalars['ID']>;
  /** The type of exchangeable object eg. "Invoice", "Payment" */
  exchangeableType: ExchangeableTypeEnum;
};

export type CustomField = {
  __typename?: 'CustomField';
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
};

export type CustomFieldAttributes = {
  /** The id of the customField */
  id?: Maybe<Scalars['Int']>;
  /** The name of the custom field */
  name?: Maybe<Scalars['String']>;
  /** Whether the custom field is required */
  required?: Maybe<Scalars['Boolean']>;
  /** Whether the custom field should appear by default */
  isDefault?: Maybe<Scalars['Boolean']>;
  /** The default value of the custom field */
  defaultValue?: Maybe<Scalars['String']>;
};

export type DashboardCartonGrouping = {
  __typename?: 'DashboardCartonGrouping';
  batchNumber?: Maybe<Scalars['String']>;
  cartons?: Maybe<Scalars['Int']>;
  commodityName?: Maybe<Scalars['String']>;
  consignmentNumber?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['Int']>;
  /**
   * A unique sequence made up of 4 letters and 7 numbers, the container \
   *           number is displayed on the top right part of the container door
   */
  containerNumber?: Maybe<Scalars['String']>;
  exporterCode?: Maybe<Scalars['String']>;
  farmCode?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inspectionDate?: Maybe<Scalars['ISO8601DateTime']>;
  inventoryCode?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['Int']>;
  mark?: Maybe<Scalars['String']>;
  netMass?: Maybe<Scalars['Float']>;
  orchard?: Maybe<Scalars['String']>;
  packhouseCode?: Maybe<Scalars['String']>;
  packingWeek?: Maybe<Scalars['String']>;
  palletGrossMass?: Maybe<Scalars['Float']>;
  palletNumber?: Maybe<Scalars['String']>;
  productCharacteristic?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  targetCountry?: Maybe<Scalars['String']>;
  targetMarket?: Maybe<Scalars['String']>;
  targetRegion?: Maybe<Scalars['String']>;
  varietyName?: Maybe<Scalars['String']>;
};

export type DashboardContainer = {
  __typename?: 'DashboardContainer';
  /** Actual arrival date of goods at current location, blank for goods on a vessel */
  arrivalDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Delivery event classifier. States if the arrival date is an estimate or an actual */
  arrivalEventClassifier?: Maybe<Scalars['String']>;
  /** Number of cartons inside container or bulk grouping */
  cartons?: Maybe<Scalars['Int']>;
  /** Number of cartons inside container or bulk grouping that are in transit */
  cartonsInTransit?: Maybe<Scalars['Int']>;
  /** Collection date of the goods at the current location */
  collectionDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Original unique identifier of an actual container, used for debugging purposes */
  containerId?: Maybe<Scalars['Int']>;
  /** A unique sequence made up of 4 letters and 7 numbers, the container number is displayed on the top right part of the container door */
  containerNumber?: Maybe<Scalars['String']>;
  /** Whether the container is a bulk grouping or an actual container */
  containerType?: Maybe<Scalars['String']>;
  /** Actual or planned departure date of goods on a vessel, or actual or planned from current location */
  departureDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Collection event classifier. States if the departure Date is an estimate or an actual */
  departureEventClassifier?: Maybe<Scalars['String']>;
  /** Actual or planned delivery date of the goods at the final location */
  finalDeliveryDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Identifier that combined with final_destination_type uniquely identifies a final destination */
  finalDestinationId?: Maybe<Scalars['Int']>;
  /** Latitude of the final destination */
  finalDestinationLatitude?: Maybe<Scalars['Float']>;
  /** Longitude of the final destination */
  finalDestinationLongitude?: Maybe<Scalars['Float']>;
  /** Name of the final destination */
  finalDestinationName?: Maybe<Scalars['String']>;
  /** Describes the type of the final destination, e.g. SeaPort */
  finalDestinationType?: Maybe<Scalars['String']>;
  /** Uniquely identifies this container */
  id?: Maybe<Scalars['Int']>;
  /** Unique identifier of the location this container was last seen or is currently situated at */
  locationId?: Maybe<Scalars['Int']>;
  /** actual or planned delivery date of the goods at the next location */
  nextDeliveryDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Identifier that combined with next_destination_type uniquely identifies a final destination */
  nextDestinationId?: Maybe<Scalars['Int']>;
  /** Latitude of the next destination */
  nextDestinationLatitude?: Maybe<Scalars['Float']>;
  /** Longitude of the next destination */
  nextDestinationLongitude?: Maybe<Scalars['Float']>;
  /** Name of the next destination */
  nextDestinationName?: Maybe<Scalars['String']>;
  /** Describes the type of the next destination, e.g. SeaPort */
  nextDestinationType?: Maybe<Scalars['String']>;
  /** Number of pallets inside container or bulk grouping */
  pallets?: Maybe<Scalars['Int']>;
  /** Number of pallets inside container or bulk grouping that are in transit */
  palletsInTransit?: Maybe<Scalars['Int']>;
  /** Representative of the container's current state as a sequence of states representing the overall supply chain */
  state?: Maybe<Scalars['String']>;
  /** Representative of the container's estimated state based on unallocated cartons in transit */
  stateInTransit?: Maybe<Scalars['String']>;
};

export type DashboardFilters = {
  __typename?: 'DashboardFilters';
  commodities?: Maybe<Array<Commodity>>;
};

export type DashboardLocation = {
  __typename?: 'DashboardLocation';
  /** Number of cartons at location */
  cartons?: Maybe<Scalars['Int']>;
  /** Number of cartons at location that are in transit */
  cartonsInTransit?: Maybe<Scalars['Int']>;
  /** Number of containers at location */
  containers?: Maybe<Scalars['Int']>;
  /** Number of containers at location that are in transit */
  containersInTransit?: Maybe<Scalars['Int']>;
  /** Coordinates of the location */
  geoLocation?: Maybe<GeoLocation>;
  /** Location identifier */
  id?: Maybe<Scalars['Int']>;
  /**
   * Location latitude
   * @deprecated Replaced by geo_location
   */
  latitude?: Maybe<Scalars['Float']>;
  /** Location identifier */
  locationId?: Maybe<Scalars['Int']>;
  /** Location type */
  locationType?: Maybe<Scalars['String']>;
  /**
   * Location longitude
   * @deprecated Replaced by geo_location
   */
  longitude?: Maybe<Scalars['Float']>;
  /** Location name */
  name?: Maybe<Scalars['String']>;
  /** Number of pallets at location */
  pallets?: Maybe<Scalars['Int']>;
  /** Number of pallets at location that are in transit */
  palletsInTransit?: Maybe<Scalars['Int']>;
  /** Number of unallocated containers or carton groupings at location */
  unallocated?: Maybe<Scalars['Int']>;
  /** Number of unallocated containers or carton groupings at location that are in transit */
  unallocatedInTransit?: Maybe<Scalars['Int']>;
};

export enum DashboardSearchFieldsEnum {
  BatchNumber = 'batch_number',
  ArrivalEventClassifier = 'arrival_event_classifier',
  CommodityName = 'commodity_name',
  ConsignmentNumber = 'consignment_number',
  ContainerNumber = 'container_number',
  ContainerType = 'container_type',
  DepartureDate = 'departure_date',
  DepartureEventClassifier = 'departure_event_classifier',
  ExporterCode = 'exporter_code',
  FarmCode = 'farm_code',
  Grade = 'grade',
  FinalDeliveryDatetime = 'final_delivery_datetime',
  FinalDestinationName = 'final_destination_name',
  FinalDestinationType = 'final_destination_type',
  InspectionDate = 'inspection_date',
  InventoryCode = 'inventory_code',
  LocationType = 'location_type',
  Mark = 'mark',
  Name = 'name',
  NextDeliveryDatetime = 'next_delivery_datetime',
  NextDestinationName = 'next_destination_name',
  NextDestinationType = 'next_destination_type',
  Orchard = 'orchard',
  PackhouseCode = 'packhouse_code',
  PackingWeek = 'packing_week',
  PalletNumber = 'pallet_number',
  ProductCharacteristic = 'product_characteristic',
  ArrivalDate = 'arrival_date',
  State = 'state',
  StateInTransit = 'state_in_transit',
  TargetCountry = 'target_country',
  TargetMarket = 'target_market',
  TargetRegion = 'target_region',
  VarietyName = 'variety_name'
}

export type DashboardTrackingData = {
  __typename?: 'DashboardTrackingData';
  /** current active order carton_groupings */
  cartonGroupings?: Maybe<Array<DashboardCartonGrouping>>;
  /** current active order containers */
  containers?: Maybe<Array<DashboardContainer>>;
  /** current active order locations */
  locations?: Maybe<Array<DashboardLocation>>;
};

/** Contains information on data generation output */
export type DataOutput = {
  __typename?: 'DataOutput';
  /** Timestamp representing the date this document was last updated */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp representing the date this document was last downloaded */
  downloadedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Data source type associated with this data output */
  fileType?: Maybe<Scalars['String']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']>;
  /** The documents produced from template generation */
  outputFile?: Maybe<Document>;
};

/** Attributes for creating or updating a Data Output */
export type DataOutputAttributes = {
  /** Date and time the Data Output was downloaded */
  downloadedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the Data Output */
  id?: Maybe<Scalars['Int']>;
};

/** Contains information on data preparation */
export type DataPreparation = {
  __typename?: 'DataPreparation';
  /** The documents produced from template generation */
  dataOutputs?: Maybe<Array<DataOutput>>;
  /** Description of the output */
  description?: Maybe<Scalars['String']>;
  /** Provides further detail if state is errored */
  error?: Maybe<Scalars['String']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']>;
  /** Name of the output */
  name?: Maybe<Scalars['String']>;
  /** State of the template generation (Created, Processing, Errored, Completed) */
  status?: Maybe<Scalars['String']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type DefaultCost = {
  __typename?: 'DefaultCost';
  /** CGT associated with this default cost */
  cartonGroupingTransaction?: Maybe<CartonGroupingTransaction>;
  /** Finance rule associated with this default cost */
  financeRule?: Maybe<FinanceRule>;
  /** Unique default cost identifier */
  id?: Maybe<Scalars['ID']>;
};

/** The connection type for DefaultCost. */
export type DefaultCostConnection = {
  __typename?: 'DefaultCostConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DefaultCostEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DefaultCost>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DefaultCostEdge = {
  __typename?: 'DefaultCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DefaultCost>;
};

export type DefaultCostFilters = {
  /** Finance rule associated with the default cost */
  financeRuleId?: Maybe<Scalars['ID']>;
  /** Whether the default costs are finalised or not */
  isActual?: Maybe<Scalars['Boolean']>;
  /** List of pallet numbers to filter by. */
  palletNumbers?: Maybe<Scalars['String']>;
  /** List of container numbers to filter by. */
  containerNumbers?: Maybe<Array<Scalars['String']>>;
};

export type Defect = {
  __typename?: 'Defect';
  /** The category the defect belongs to */
  category?: Maybe<DefectCategoryEnum>;
  /** The ID of the defect */
  id: Scalars['Int'];
  /** The name of the defect */
  name?: Maybe<Scalars['String']>;
};

export enum DefectCategoryEnum {
  /** The defect categorisation: progressive */
  Progressive = 'progressive',
  /** The defect categorisation: cosmetic */
  Cosmetic = 'cosmetic',
  /** The defect categorisation: other */
  Other = 'other'
}

export type DefectInput = {
  /** Defect Category */
  category: DefectCategoryEnum;
  /** Defect ID */
  id: Scalars['ID'];
  /** Defect Name */
  name?: Maybe<Scalars['String']>;
};

export type DefectPercentageCaptureAttributes = {
  /** Claim Line Item Grouping ID */
  claimLineItemGroupingId: Scalars['ID'];
  /** Progressive  Defects */
  progressiveDefects?: Maybe<Array<ClaimLineItemDefectInput>>;
  /** Cosmetic  Defects */
  cosmeticDefects?: Maybe<Array<ClaimLineItemDefectInput>>;
  /** Other Defects */
  otherDefects?: Maybe<Array<ClaimLineItemDefectInput>>;
  /** Progressive Defects Group Total Percentage */
  progressiveDefectsGroupTotalPercentage?: Maybe<Scalars['Float']>;
  /** Cosmetic Defects Group Total Percentage */
  cosmeticDefectsGroupTotalPercentage?: Maybe<Scalars['Float']>;
  /** Other Defects Group Total Percentage */
  otherDefectsGroupTotalPercentage?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of DeleteAddendumLineItem. */
export type DeleteAddendumLineItemPayload = {
  __typename?: 'DeleteAddendumLineItemPayload';
  addendumLineItems?: Maybe<Array<AddendumLineItem>>;
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteAdditionalField. */
export type DeleteAdditionalFieldPayload = {
  __typename?: 'DeleteAdditionalFieldPayload';
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DeleteCartonConversion. */
export type DeleteCartonConversionPayload = {
  __typename?: 'DeleteCartonConversionPayload';
  /** The deleted Carton Conversion */
  cartonConversion?: Maybe<CartonConversion>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DeleteComment. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  comment?: Maybe<Comment>;
};

/** Autogenerated return type of DeleteCompanyCertificate. */
export type DeleteCompanyCertificatePayload = {
  __typename?: 'DeleteCompanyCertificatePayload';
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DeleteContact. */
export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
  /** The contact was deleted */
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeleteCurrencyExchangeRate. */
export type DeleteCurrencyExchangeRatePayload = {
  __typename?: 'DeleteCurrencyExchangeRatePayload';
  /** The unique identifier of the currency exchange rate that was deleted */
  currencyExchangeRateId?: Maybe<Scalars['ID']>;
  /** Errors that occurred while deleting the currency exchange rate */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of DeleteCustomField. */
export type DeleteCustomFieldPayload = {
  __typename?: 'DeleteCustomFieldPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
  /** The custom field was deleted */
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeleteEmployee. */
export type DeleteEmployeePayload = {
  __typename?: 'DeleteEmployeePayload';
  employeeId?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DeleteEphytoDocument. */
export type DeleteEphytoDocumentPayload = {
  __typename?: 'DeleteEphytoDocumentPayload';
  /** The ID of the Ephyto Document */
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DeleteEphyto. */
export type DeleteEphytoPayload = {
  __typename?: 'DeleteEphytoPayload';
  /** Response message when attempting to delete */
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteExportDocument. */
export type DeleteExportDocumentPayload = {
  __typename?: 'DeleteExportDocumentPayload';
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DeleteFarmVarietyImage. */
export type DeleteFarmVarietyImagePayload = {
  __typename?: 'DeleteFarmVarietyImagePayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of DeleteFarmVariety. */
export type DeleteFarmVarietyPayload = {
  __typename?: 'DeleteFarmVarietyPayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of DeleteFinanceRule. */
export type DeleteFinanceRulePayload = {
  __typename?: 'DeleteFinanceRulePayload';
  errors?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DeleteInvoiceDocument. */
export type DeleteInvoiceDocumentPayload = {
  __typename?: 'DeleteInvoiceDocumentPayload';
  /** Errors that occurred during deletion */
  errors: Array<Scalars['String']>;
  /** The updated invoice after document deletion */
  invoice?: Maybe<Invoice>;
};

/** Autogenerated return type of DeleteInvoice. */
export type DeleteInvoicePayload = {
  __typename?: 'DeleteInvoicePayload';
  /** What went wrong when deleting the invoice */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteLoadOutInstruction. */
export type DeleteLoadOutInstructionPayload = {
  __typename?: 'DeleteLoadOutInstructionPayload';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DeleteNetReturnProgram. */
export type DeleteNetReturnProgramPayload = {
  __typename?: 'DeleteNetReturnProgramPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  netReturnProgram?: Maybe<NetReturnProgram>;
};

/** Autogenerated return type of DeleteOrderProgram. */
export type DeleteOrderProgramPayload = {
  __typename?: 'DeleteOrderProgramPayload';
  /** What went wrong when deleting an order program */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The order program that was deleted */
  orderProgram?: Maybe<OrderProgram>;
};

/** Autogenerated return type of DeletePayment. */
export type DeletePaymentPayload = {
  __typename?: 'DeletePaymentPayload';
  /** What went wrong when deleting the payment */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The payment that was deleted */
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of DeleteReportGroup. */
export type DeleteReportGroupPayload = {
  __typename?: 'DeleteReportGroupPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
  /** The report group was deleted */
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeleteShipmentDocument. */
export type DeleteShipmentDocumentPayload = {
  __typename?: 'DeleteShipmentDocumentPayload';
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DeleteShipmentLineItem. */
export type DeleteShipmentLineItemPayload = {
  __typename?: 'DeleteShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DeleteTaskDocument. */
export type DeleteTaskDocumentPayload = {
  __typename?: 'DeleteTaskDocumentPayload';
  /** Errors that occurred during the delete */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Tasks for the given Shipment Line Item (after update) */
  tasks?: Maybe<Array<TaskableTask>>;
};

/** Autogenerated return type of DeleteUiConfig. */
export type DeleteUiConfigPayload = {
  __typename?: 'DeleteUiConfigPayload';
  id?: Maybe<Scalars['Int']>;
};

export type Document = {
  __typename?: 'Document';
  contentType?: Maybe<Scalars['String']>;
  emailId?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Timestamp when the file was uploaded */
  uploadedAt?: Maybe<Scalars['ISO8601DateTime']>;
  url?: Maybe<Scalars['String']>;
  v2Url?: Maybe<Scalars['String']>;
};

export type DocumentProcessingProgress = {
  __typename?: 'DocumentProcessingProgress';
  /** The ID of the document */
  documentId?: Maybe<Scalars['ID']>;
  /** The name of the file */
  filename?: Maybe<Scalars['String']>;
  /** The size of the file */
  filesize?: Maybe<Scalars['String']>;
  /** The file extension */
  filetype?: Maybe<Scalars['String']>;
  /** The status of the document processing */
  status?: Maybe<Scalars['String']>;
  /** The updated_at timestamp */
  updatedAt?: Maybe<Scalars['String']>;
};

/** Attributes for a document, including ID and source. */
export type DocumentSource = {
  /** The ID of the document/activestorageattachment. */
  id: Scalars['ID'];
  /** The source of the document/activestorageattachment. */
  source: Scalars['String'];
};

/** Attributes for the document being downloaded */
export type DownloadDocumentAttributes = {
  /** The ID of the document uploaded by user */
  documentId?: Maybe<Scalars['ID']>;
  /** The ID of the document generated */
  platformDocumentId?: Maybe<Scalars['ID']>;
  /** Name of the file */
  filename: Scalars['String'];
};

/** Autogenerated return type of DownloadDocuments. */
export type DownloadDocumentsPayload = {
  __typename?: 'DownloadDocumentsPayload';
  /** Errors that occurred during download */
  errors: Array<Scalars['String']>;
  /** Temporary URL to download the zip file */
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DraftEphyto. */
export type DraftEphytoPayload = {
  __typename?: 'DraftEphytoPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to submit draft */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DuplicateAddendumLineItem. */
export type DuplicateAddendumLineItemPayload = {
  __typename?: 'DuplicateAddendumLineItemPayload';
  addendumLineItems?: Maybe<Array<AddendumLineItem>>;
};

/** Autogenerated return type of DuplicateEphyto. */
export type DuplicateEphytoPayload = {
  __typename?: 'DuplicateEphytoPayload';
  /** The ID of the Ephyto to duplicate */
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of DuplicateInvoice. */
export type DuplicateInvoicePayload = {
  __typename?: 'DuplicateInvoicePayload';
  /** Any errors from duplicating */
  errors?: Maybe<Scalars['String']>;
  /** id of the duplicated invoice */
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of DuplicateShipmentLineItem. */
export type DuplicateShipmentLineItemPayload = {
  __typename?: 'DuplicateShipmentLineItemPayload';
  /** All SLIs on the shipment */
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
};

export type ElasticHit = {
  __typename?: 'ElasticHit';
  highlight?: Maybe<Scalars['Json']>;
  score?: Maybe<Scalars['Float']>;
  source?: Maybe<ElasticHitSourceUnion>;
};

export type ElasticHitSourceUnion = DashboardCartonGrouping | DashboardContainer | DashboardLocation;

export type ElasticSearchResult = {
  __typename?: 'ElasticSearchResult';
  /** Array of results from elasticsearch */
  hits?: Maybe<Array<ElasticHit>>;
  /** The raw response from Elasticsearch. Use only for debugging. */
  raw?: Maybe<Scalars['Json']>;
  /** Info on how many matching items were found in total. hits may only be a subset */
  total?: Maybe<ElasticTotal>;
};

export type ElasticTotal = {
  __typename?: 'ElasticTotal';
  relation?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** Attributes related to the emailing of a set of documents */
export type EmailDocumentsAttributes = {
  /** Body of the email */
  body: Scalars['String'];
  /** The documents to send */
  documents: Array<DocumentSource>;
  /** Comma-seperated list of recipient email address */
  recipients: Array<Scalars['String']>;
  /** Comma-seperated list of carbon copy email address */
  cc?: Maybe<Array<Scalars['String']>>;
  /** Subject of the email */
  subject: Scalars['String'];
};

/** Autogenerated return type of EmailDocuments. */
export type EmailDocumentsPayload = {
  __typename?: 'EmailDocumentsPayload';
  /** Any errors that occured during processing */
  errors?: Maybe<Scalars['String']>;
  /** Return Message */
  message: Scalars['String'];
};

export type EmailTaskDocumentsAttributes = {
  /** Body of the email */
  body: Scalars['String'];
  /** IDs of the tasks to send documents from */
  ids: Array<Scalars['Int']>;
  /** Comma-seperated list of recipient email address */
  recipients: Array<Scalars['String']>;
  /** Subject of the email */
  subject: Scalars['String'];
};

/** Autogenerated return type of EmailTaskDocuments. */
export type EmailTaskDocumentsPayload = {
  __typename?: 'EmailTaskDocumentsPayload';
  /** Any errors that occured during processing */
  errors?: Maybe<Scalars['String']>;
  /** Return Message */
  message: Scalars['String'];
};

/** Returns all attributes needed to embed a PowerBI report. */
export type EmbeddedChart = {
  __typename?: 'EmbeddedChart';
  /** Report embed access token */
  embedToken?: Maybe<Scalars['String']>;
  /** Report embed URL */
  embedUrl?: Maybe<Scalars['String']>;
  /** Report Id in powerbi */
  reportId?: Maybe<Scalars['String']>;
  /** Report embed config variables */
  settings?: Maybe<Scalars['String']>;
};

export type Employee = {
  __typename?: 'Employee';
  /** The ID of the Employee */
  id?: Maybe<Scalars['Int']>;
  /** The first name of the User the Employee belongs to */
  userFirstName?: Maybe<Scalars['String']>;
  /** The last name of the User the Employee belongs to */
  userLastName?: Maybe<Scalars['String']>;
};

export type Ephyto = {
  __typename?: 'Ephyto';
  /** Any additional treatment information */
  additionalInformation?: Maybe<Scalars['String']>;
  /** Is additional inspection required */
  additionalInspection?: Maybe<Scalars['Boolean']>;
  /** Agreement Code related the commodity and target country */
  agreementCode?: Maybe<Scalars['String']>;
  /** Reference returned by Ecert when Phyto has been submitted */
  applicationReferenceNo?: Maybe<Scalars['String']>;
  /** The status for the Phyto returned from Ecert */
  applicationStatus?: Maybe<Scalars['String']>;
  /** Type of Ephyto being applied for */
  applicationType?: Maybe<Scalars['Int']>;
  /** Is Phyto based on the original */
  basedOnOriginalPhyto?: Maybe<Scalars['Boolean']>;
  /** Booking Reference */
  bookingRef?: Maybe<Scalars['String']>;
  /** The scientific name of the plant */
  botanicalName?: Maybe<Scalars['String']>;
  /** Ecert Business Registered ID to be billed for the Phyto */
  cbrBillingId?: Maybe<Scalars['Int']>;
  /** Ecert Business Registered ID applying for the Phyto */
  cbrId?: Maybe<Scalars['Int']>;
  /** Flexi Field for CBS Free Area on the ephyto */
  cbsFreeArea?: Maybe<Scalars['String']>;
  /** Type of chemical applied */
  chemical?: Maybe<Scalars['String']>;
  /** Company that this ephyto belongs to */
  companyId?: Maybe<Scalars['Int']>;
  /** The concentration of chemical application */
  concentration?: Maybe<Scalars['String']>;
  /** Consignees Address */
  consigneeAddressLine1?: Maybe<Scalars['String']>;
  /** Consignees Address */
  consigneeAddressLine2?: Maybe<Scalars['String']>;
  /** Consignees Address */
  consigneeAddressLine3?: Maybe<Scalars['String']>;
  /** Consignees Country Code */
  consigneeCountryId?: Maybe<Scalars['String']>;
  /** Consignees registered ID on Ecert */
  consigneeId?: Maybe<Scalars['String']>;
  /** Consignees name */
  consigneeName?: Maybe<Scalars['String']>;
  /** Consignors address */
  consignorAddressLine1?: Maybe<Scalars['String']>;
  /** Consignors address */
  consignorAddressLine2?: Maybe<Scalars['String']>;
  /** Consignors address */
  consignorAddressLine3?: Maybe<Scalars['String']>;
  /** Consignors registered Id on Ecert */
  consignorId?: Maybe<Scalars['String']>;
  /** Consignors name */
  consignorName?: Maybe<Scalars['String']>;
  /** Reference No */
  customReferenceNo?: Maybe<Scalars['String']>;
  /** DALRRD registered Account number to handle payments */
  dalrrdAccNum?: Maybe<Scalars['String']>;
  /** Means of conveyance */
  declaredMeansOfConveyance?: Maybe<Scalars['String']>;
  /** First Point of Entry */
  declaredPointOfEntry?: Maybe<Scalars['String']>;
  /** Date of Departure for Vessel */
  departureDate?: Maybe<Scalars['String']>;
  /** The location where the EPhyto is issued */
  desiredIssueLocation?: Maybe<Scalars['String']>;
  /** The scientific name of the plant */
  distinguishingMarks?: Maybe<Scalars['String']>;
  /** Length of treatment and temperature applied */
  durationAndTemperature?: Maybe<Scalars['String']>;
  /** Consignment items declared for the ephyto */
  ephytoConsignmentItems?: Maybe<Array<EphytoConsignmentItem>>;
  /** Supporting documents uploaded for the ephyto */
  ephytoDocuments?: Maybe<Array<EphytoDocument>>;
  /** Trade Units declared for the Ephyto */
  ephytoTradeUnits?: Maybe<Array<EphytoTradeUnit>>;
  /** Error tracking for the Ephyto */
  errorReason?: Maybe<Scalars['String']>;
  /** Ephyto ID */
  id: Scalars['ID'];
  /** Import Country Code */
  importCountryId?: Maybe<Scalars['String']>;
  /** Flexi Field for import permit date on the ephyto */
  importPermitDate?: Maybe<Scalars['String']>;
  /** Flexi Field for import permit no on the ephyto */
  importPermitNo?: Maybe<Scalars['String']>;
  /** PPECB Activity Point Code that represents the load point */
  loadSeaPoint?: Maybe<Scalars['String']>;
  /** Name of the product and declared quantity */
  nameOfProductAndDeclaredQuantity?: Maybe<Scalars['String']>;
  /** Email where updates will be sent via Ecert */
  notificationEmail?: Maybe<Scalars['String']>;
  /** Number and description of Package */
  numberAndDescriptionOfPackage?: Maybe<Scalars['String']>;
  /** Is the consignment in the same or packed in a new container */
  originalContainer?: Maybe<Scalars['Boolean']>;
  /** The original phyto or a certified copy if false */
  originalPhyto?: Maybe<Scalars['Boolean']>;
  /** Date of issuance for original phyto */
  originalPhytoDate?: Maybe<Scalars['String']>;
  /** The original phyto no being reexported */
  originalPhytoNo?: Maybe<Scalars['String']>;
  /** Type of Payment such as Cash or Account */
  paymentType?: Maybe<Scalars['String']>;
  /** Place of origin */
  placeOfOrigin?: Maybe<Scalars['String']>;
  /** Location Code for port of entry */
  portOfEntry?: Maybe<Scalars['String']>;
  /** Is the original Phyto repacked */
  rePacked?: Maybe<Scalars['Boolean']>;
  /** The reexport phyto place of origin */
  reexportPlaceOfOrigin?: Maybe<Scalars['String']>;
  /** Flexi Field for regime code on the ephyto */
  regimeCode?: Maybe<Scalars['String']>;
  /** Internal State of the Ephyto */
  state?: Maybe<Scalars['String']>;
  /** Stuff Date related to the Ephyto */
  stuffDate?: Maybe<Scalars['String']>;
  /** Target Country Code */
  targetCountry?: Maybe<Scalars['String']>;
  /** Target Country Code */
  targetCountryId?: Maybe<Scalars['String']>;
  /** Target Region Code */
  targetRegion?: Maybe<Scalars['String']>;
  /** Temperature Regime */
  temperatureRegime?: Maybe<Scalars['String']>;
  /** Further describing transport eg. Container Vessel if Marine */
  transportMeans?: Maybe<Scalars['String']>;
  /** Transport Type code to represent Air or Marine */
  transportModeCode?: Maybe<Scalars['Int']>;
  /** Type of treatment */
  treatment?: Maybe<Scalars['String']>;
  /** Date of treatment */
  treatmentDate?: Maybe<Scalars['String']>;
  /** Location Code */
  unloadingBaseportLocation?: Maybe<Scalars['String']>;
  /** When the ephyto was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Flexi Field for VAT no on the ephyto */
  vatNo?: Maybe<Scalars['String']>;
  /** Vessel or Carrier Name */
  vessel?: Maybe<Scalars['String']>;
  /** Voyage Number or Flight Number */
  voyageNumber?: Maybe<Scalars['String']>;
};

/** Agreement Attributes related to exporting */
export type EphytoAgreementCode = {
  __typename?: 'EphytoAgreementCode';
  /** Agreement Code for exporting goods to a country */
  agreementCode?: Maybe<Scalars['String']>;
  /** Agreement Name for exporting goods to a country */
  agreementName?: Maybe<Scalars['String']>;
};

export type EphytoAttributes = {
  /** Ephyto ID */
  id: Scalars['ID'];
  /** Reference returned by Ecert when Phyto has been submitted */
  applicationReferenceNo?: Maybe<Scalars['String']>;
  /** Type of Ephyto being applied for */
  applicationType?: Maybe<Scalars['Int']>;
  /** The status for the Phyto returned from Ecert */
  applicationStatus?: Maybe<Scalars['String']>;
  /** Ecert Business Registered ID applying for the Phyto */
  cbrId?: Maybe<Scalars['Int']>;
  /** Ecert Business Registered ID to be billed for the Phyto */
  cbrBillingId?: Maybe<Scalars['Int']>;
  /** Reference No */
  customReferenceNo?: Maybe<Scalars['String']>;
  /** Agreement Code related the commodity and target country */
  agreementCode?: Maybe<Scalars['String']>;
  /** The location where the EPhyto is issued */
  desiredIssueLocation?: Maybe<Scalars['String']>;
  /** Email where updates will be sent via Ecert */
  notificationEmail?: Maybe<Scalars['String']>;
  /** Consignors registered Id on Ecert */
  consignorId?: Maybe<Scalars['String']>;
  /** Consignors name */
  consignorName?: Maybe<Scalars['String']>;
  /** Consignors address */
  consignorAddressLine1?: Maybe<Scalars['String']>;
  /** Consignors address */
  consignorAddressLine2?: Maybe<Scalars['String']>;
  /** Consignors address */
  consignorAddressLine3?: Maybe<Scalars['String']>;
  /** Consignees registered ID on Ecert */
  consigneeId?: Maybe<Scalars['String']>;
  /** Consignees name */
  consigneeName?: Maybe<Scalars['String']>;
  /** Consignees Address */
  consigneeAddressLine1?: Maybe<Scalars['String']>;
  /** Consignees Address */
  consigneeAddressLine2?: Maybe<Scalars['String']>;
  /** Consignees Address */
  consigneeAddressLine3?: Maybe<Scalars['String']>;
  /** Consignees Country Code */
  consigneeCountryId?: Maybe<Scalars['String']>;
  /** Import Country Code */
  importCountryId?: Maybe<Scalars['String']>;
  /** Target Country Code */
  targetCountryId?: Maybe<Scalars['String']>;
  /** Location Code */
  unloadingBaseportLocation?: Maybe<Scalars['String']>;
  /** Transport Type code to represent Air or Marine */
  transportModeCode?: Maybe<Scalars['Int']>;
  /** Further describing transport eg. Container Vessel if Marine */
  transportMeans?: Maybe<Scalars['String']>;
  /** Type of Payment such as Cash or Account */
  paymentType?: Maybe<Scalars['String']>;
  /** DALRRD registered Account number to handle payments */
  dalrrdAccNum?: Maybe<Scalars['String']>;
  /** PPECB Activity Point Code that represents the load point */
  loadSeaPoint?: Maybe<Scalars['String']>;
  /** Target Country Code */
  targetCountry?: Maybe<Scalars['String']>;
  /** Target Region Code */
  targetRegion?: Maybe<Scalars['String']>;
  /** Location Code for port of entry */
  portOfEntry?: Maybe<Scalars['String']>;
  /** Booking Reference */
  bookingRef?: Maybe<Scalars['String']>;
  /** Vessel or Carrier Name */
  vessel?: Maybe<Scalars['String']>;
  /** Voyage Number or Flight Number */
  voyageNumber?: Maybe<Scalars['String']>;
  /** Date of Departure for Vessel */
  departureDate?: Maybe<Scalars['String']>;
  /** Stuff Date related to the Ephyto */
  stuffDate?: Maybe<Scalars['String']>;
  /** Temperature Regime */
  temperatureRegime?: Maybe<Scalars['String']>;
  /** Number and description of Package */
  numberAndDescriptionOfPackage?: Maybe<Scalars['String']>;
  /** The scientific name of the plant */
  botanicalName?: Maybe<Scalars['String']>;
  /** The scientific name of the plant */
  distinguishingMarks?: Maybe<Scalars['String']>;
  /** Place of origin */
  placeOfOrigin?: Maybe<Scalars['String']>;
  /** Means of conveyance */
  declaredMeansOfConveyance?: Maybe<Scalars['String']>;
  /** First Point of Entry */
  declaredPointOfEntry?: Maybe<Scalars['String']>;
  /** Name of the product and declared quantity */
  nameOfProductAndDeclaredQuantity?: Maybe<Scalars['String']>;
  /** Date of treatment */
  treatmentDate?: Maybe<Scalars['String']>;
  /** Type of treatment */
  treatment?: Maybe<Scalars['String']>;
  /** Type of chemical applied */
  chemical?: Maybe<Scalars['String']>;
  /** Length of treatment and temperature applied */
  durationAndTemperature?: Maybe<Scalars['String']>;
  /** The concentration of chemical application */
  concentration?: Maybe<Scalars['String']>;
  /** Any additional treatment information */
  additionalInformation?: Maybe<Scalars['String']>;
  /** Company that this ephyto belongs to */
  companyId?: Maybe<Scalars['Int']>;
  /** Internal State of the Ephyto */
  state?: Maybe<Scalars['String']>;
  /** Date of issuance for original phyto */
  originalPhytoDate?: Maybe<Scalars['String']>;
  /** The original phyto no being reexported */
  originalPhytoNo?: Maybe<Scalars['String']>;
  /** The reexport phyto place of origin */
  reexportPlaceOfOrigin?: Maybe<Scalars['String']>;
  /** The original phyto or a certified copy if false */
  originalPhyto?: Maybe<Scalars['Boolean']>;
  /** Is the original Phyto repacked */
  rePacked?: Maybe<Scalars['Boolean']>;
  /** Is the consignment in the same or packed in a new container */
  originalContainer?: Maybe<Scalars['Boolean']>;
  /** Is Phyto based on the original */
  basedOnOriginalPhyto?: Maybe<Scalars['Boolean']>;
  /** Is additional inspection required */
  additionalInspection?: Maybe<Scalars['Boolean']>;
  /** Flexi Field for CBS Free Area on the ephyto */
  cbsFreeArea?: Maybe<Scalars['String']>;
  /** Flexi Field for VAT no on the ephyto */
  vatNo?: Maybe<Scalars['String']>;
  /** Flexi Field for regime code on the ephyto */
  regimeCode?: Maybe<Scalars['String']>;
  /** Flexi Field for import permit no on the ephyto */
  importPermitNo?: Maybe<Scalars['String']>;
  /** Flexi Field for import permit date on the ephyto */
  importPermitDate?: Maybe<Scalars['String']>;
};

/** The connection type for Ephyto. */
export type EphytoConnection = {
  __typename?: 'EphytoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EphytoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Ephyto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EphytoConsignmentItem = {
  __typename?: 'EphytoConsignmentItem';
  /** Additional notes or declarations for consignment */
  additionalConsignmentNotes?: Maybe<Scalars['String']>;
  /** Additional notes for treatments */
  appliedProcessAdditionalNote?: Maybe<Scalars['String']>;
  /** Chemical Ingredient */
  appliedProcessChemicalCode?: Maybe<Scalars['String']>;
  /** Concentration Level */
  appliedProcessConcentration?: Maybe<Scalars['String']>;
  /** Unit of measure for concentration */
  appliedProcessConcentrationUnitCode?: Maybe<Scalars['String']>;
  /** Treatment End Date */
  appliedProcessEndDate?: Maybe<Scalars['String']>;
  /** Treatment Start Date */
  appliedProcessStartDate?: Maybe<Scalars['String']>;
  /** Temperature applied */
  appliedProcessTemperature?: Maybe<Scalars['String']>;
  /** Unit of measure for temperature */
  appliedProcessTemperatureUnitCode?: Maybe<Scalars['String']>;
  /** Treatment Type Level 1 */
  appliedProcessTreatmentTypeLevel1?: Maybe<Scalars['String']>;
  /** Treatment Type Level 2 */
  appliedProcessTreatmentTypeLevel2?: Maybe<Scalars['String']>;
  /** Condition of commodity */
  commodityConditionClass?: Maybe<Scalars['String']>;
  /** Commoditys intent of use */
  commodityIntentOfUseClass?: Maybe<Scalars['String']>;
  /** Type of commodity class */
  commodityVegetablePart?: Maybe<Scalars['String']>;
  /** General product name */
  commonName?: Maybe<Scalars['String']>;
  /** Harmonized system code */
  customsHarmonizedSystemClass?: Maybe<Scalars['String']>;
  /** Product Description */
  description?: Maybe<Scalars['String']>;
  /** Duration of treatment */
  durationMeasure?: Maybe<Scalars['String']>;
  /** Unit code for the duration of treatment */
  durationMeasureCode?: Maybe<Scalars['String']>;
  /** Ephyto ID this item belongs to */
  ephytoId?: Maybe<Scalars['Int']>;
  /** Summary of the full treatment as would appear on the Phyto. */
  fullTreatmentInformation?: Maybe<Scalars['String']>;
  /** Gross weight */
  grossWeightMeasure?: Maybe<Scalars['String']>;
  /** Unit of measure for the gross weight */
  grossWeightMeasureCode?: Maybe<Scalars['String']>;
  /** Internal Unique Consignment Item ID */
  id: Scalars['ID'];
  /** Net weight */
  netWeightMeasure?: Maybe<Scalars['String']>;
  /** Unit of measure for net weight */
  netWeightMeasureCode?: Maybe<Scalars['String']>;
  /** Quantity of packaged items */
  packageItemQuantity?: Maybe<Scalars['String']>;
  /** Unit of code to quantify the packaged item */
  packageItemUnitCode?: Maybe<Scalars['String']>;
  /** Package Level */
  packageLevelCode?: Maybe<Scalars['String']>;
  /** Visible Shipping Marks */
  packageShippingMarks?: Maybe<Scalars['String']>;
  /** Package Type */
  packageTypeCode?: Maybe<Scalars['String']>;
  /** The scientific name of the product */
  scientificName?: Maybe<Scalars['String']>;
  /** A number used to uniquely identify a consignment for updates on eCert */
  sequenceNumeric?: Maybe<Scalars['String']>;
};

export type EphytoConsignmentItemAttributes = {
  /** Consignment Item ID in our DB */
  id?: Maybe<Scalars['ID']>;
  /** Product Description */
  description?: Maybe<Scalars['String']>;
  /** General product name */
  commonName?: Maybe<Scalars['String']>;
  /** The scientific name of the product */
  scientificName?: Maybe<Scalars['String']>;
  /** Unit of measure for net weight */
  netWeightMeasureCode?: Maybe<Scalars['String']>;
  /** Net weight */
  netWeightMeasure?: Maybe<Scalars['String']>;
  /** Unit of measure for the gross weight */
  grossWeightMeasureCode?: Maybe<Scalars['String']>;
  /** Gross weight */
  grossWeightMeasure?: Maybe<Scalars['String']>;
  /** Harmonized system code */
  customsHarmonizedSystemClass?: Maybe<Scalars['String']>;
  /** Type of commodity class */
  commodityVegetablePart?: Maybe<Scalars['String']>;
  /** Condition of commodity */
  commodityConditionClass?: Maybe<Scalars['String']>;
  /** Commoditys intent of use */
  commodityIntentOfUseClass?: Maybe<Scalars['String']>;
  /** Treatment Start Date */
  appliedProcessStartDate?: Maybe<Scalars['String']>;
  /** Treatment End Date */
  appliedProcessEndDate?: Maybe<Scalars['String']>;
  /** Unit code for the duration of treatment */
  durationMeasureCode?: Maybe<Scalars['String']>;
  /** Duration of treatment */
  durationMeasure?: Maybe<Scalars['String']>;
  /** Treatment Type Level 1 */
  appliedProcessTreatmentTypeLevel1?: Maybe<Scalars['String']>;
  /** Treatment Type Level 2 */
  appliedProcessTreatmentTypeLevel2?: Maybe<Scalars['String']>;
  /** Chemical Ingredient */
  appliedProcessChemicalCode?: Maybe<Scalars['String']>;
  /** Unit of measure for temperature */
  appliedProcessTemperatureUnitCode?: Maybe<Scalars['String']>;
  /** Temperature applied */
  appliedProcessTemperature?: Maybe<Scalars['String']>;
  /** Unit of measure for concentration */
  appliedProcessConcentrationUnitCode?: Maybe<Scalars['String']>;
  /** Concentration Level */
  appliedProcessConcentration?: Maybe<Scalars['String']>;
  /** Additional notes for treatments */
  appliedProcessAdditionalNote?: Maybe<Scalars['String']>;
  /** Summary of the full treatment as would appear on the Phyto. */
  fullTreatmentInformation?: Maybe<Scalars['String']>;
  /** Package Level */
  packageLevelCode?: Maybe<Scalars['String']>;
  /** Package Type */
  packageTypeCode?: Maybe<Scalars['String']>;
  /** Unit of code to quantify the packaged item */
  packageItemUnitCode?: Maybe<Scalars['String']>;
  /** Quantity of packaged items */
  packageItemQuantity?: Maybe<Scalars['String']>;
  /** Visible Shipping Marks */
  packageShippingMarks?: Maybe<Scalars['String']>;
  /** Additional notes or declarations for consignment */
  additionalConsignmentNotes?: Maybe<Scalars['String']>;
  /** A number used to uniquely identify a consignment for updates on eCert */
  sequenceNumeric?: Maybe<Scalars['String']>;
  /** Ephyto ID this item belongs to */
  ephytoId?: Maybe<Scalars['Int']>;
};

export type EphytoCountry = {
  __typename?: 'EphytoCountry';
  /** Country ISO alpha code */
  isoCode?: Maybe<Scalars['String']>;
  /** Name of country */
  name?: Maybe<Scalars['String']>;
};

export type EphytoDocument = {
  __typename?: 'EphytoDocument';
  /** The Ecert Ephyto specified document type */
  documentType?: Maybe<Scalars['String']>;
  /** The document associated with the EphytoDocument */
  file?: Maybe<Document>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']>;
};

/** An edge in a connection. */
export type EphytoEdge = {
  __typename?: 'EphytoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Ephyto>;
};

export type EphytoFilterAttribute = {
  __typename?: 'EphytoFilterAttribute';
  /** ephyto consignees */
  consignees?: Maybe<Array<Scalars['String']>>;
  /** ephyto consignors */
  consignors?: Maybe<Array<Scalars['String']>>;
  /** ephyto customer references */
  customerReferences?: Maybe<Array<Scalars['String']>>;
  /** ephyto ports of entry */
  entryPorts?: Maybe<Array<Scalars['String']>>;
  /** ephyto statuses */
  statuses?: Maybe<Array<Scalars['String']>>;
  /** ephyto vessels */
  vessels?: Maybe<Array<Scalars['String']>>;
};

export type EphytoFilterAttributes = {
  /** ephyto statuses */
  applicationStatuses?: Maybe<Array<Scalars['String']>>;
  /** ephyto customer references */
  customerReferences?: Maybe<Array<Scalars['String']>>;
  /** ephyto ports of entry */
  entryPorts?: Maybe<Array<Scalars['String']>>;
  /** ephyto consignees */
  consignees?: Maybe<Array<Scalars['String']>>;
  /** ephyto consignors */
  consignors?: Maybe<Array<Scalars['String']>>;
  /** ephyto vessels */
  vessels?: Maybe<Array<Scalars['String']>>;
};

export type EphytoLocation = {
  __typename?: 'EphytoLocation';
  /** Location code value */
  code?: Maybe<Scalars['String']>;
  /** Display name of location */
  name?: Maybe<Scalars['String']>;
};

export type EphytoPackage = {
  __typename?: 'EphytoPackage';
  /** Code of the package type */
  code?: Maybe<Scalars['String']>;
  /** Display name of the package type */
  name?: Maybe<Scalars['String']>;
};

export type EphytoPortOfEntry = {
  __typename?: 'EphytoPortOfEntry';
  /** Location code value */
  code?: Maybe<Scalars['String']>;
  /** Display name of port of entry */
  name?: Maybe<Scalars['String']>;
};

export type EphytoTradeUnit = {
  __typename?: 'EphytoTradeUnit';
  /** Clients Reference for this trade unit */
  clientRef?: Maybe<Scalars['String']>;
  /** Commodity Code */
  commodity?: Maybe<Scalars['String']>;
  /** Container Number if applicable for trade unit */
  containerNumber?: Maybe<Scalars['String']>;
  /** Ephyto ID this trade unit belongs to */
  ephytoId?: Maybe<Scalars['Int']>;
  /** Flesh color for trade unit if applicable */
  fleshColour?: Maybe<Scalars['String']>;
  /** Trade Unit Id in our DB */
  id: Scalars['ID'];
  /** PPECB manifest no for the trade unit */
  inspectionManifestNo?: Maybe<Scalars['String']>;
  /** PPECB Actvitiy Point Code for inspection */
  inspectionPointLocationCode?: Maybe<Scalars['String']>;
  /** Marketing Indication for trade unit */
  marketingIndication?: Maybe<Scalars['String']>;
  /** Nett Weight */
  netTradeUnitWeight?: Maybe<Scalars['String']>;
  /** Pallet Nett Weight */
  nettPalletWeight?: Maybe<Scalars['String']>;
  /** Packaged Quantity for trade unit */
  numberOfPackagedItems?: Maybe<Scalars['String']>;
  /** Orchard Code */
  orchard?: Maybe<Scalars['String']>;
  /** Phyto Stats for Orchard */
  orchardPhytoStatus?: Maybe<Scalars['String']>;
  /** Packhouse code for trade unit */
  phc?: Maybe<Scalars['String']>;
  /** Date of inspection as on PO */
  ppecbInspectionDate?: Maybe<Scalars['String']>;
  /** Production Area */
  productionArea?: Maybe<Scalars['String']>;
  /** DALRRD PUC Code */
  puc?: Maybe<Scalars['String']>;
  /** Loading Date for trade unit */
  stuffDate?: Maybe<Scalars['String']>;
  /** Trade Units ID such as pallet or container number */
  tradeUnitId?: Maybe<Scalars['String']>;
  /** product class code for the trade unit */
  tuClass?: Maybe<Scalars['String']>;
};

export type EphytoTreatment = {
  __typename?: 'EphytoTreatment';
  /** First level of chemical treatment */
  firstLevel?: Maybe<Scalars['String']>;
  /** Unique code for first level */
  firstLevelCode?: Maybe<Scalars['String']>;
  /** Second level of chemical treatment */
  secondLevel?: Maybe<Scalars['String']>;
  /** Unique code for second level */
  secondLevelCode?: Maybe<Scalars['String']>;
};

export type Estimate = {
  __typename?: 'Estimate';
  cartonType: CartonType;
  commodity: Commodity;
  company: Company;
  estimateValues?: Maybe<Array<EstimateValue>>;
  fboOrchard?: Maybe<FboOrchard>;
  id: Scalars['Int'];
  packHouse?: Maybe<FoodBusinessOperator>;
  productionUnit?: Maybe<FoodBusinessOperator>;
  provider?: Maybe<Company>;
  season: Scalars['Int'];
  variety?: Maybe<Variety>;
  visibleCompanies?: Maybe<Array<Company>>;
  week?: Maybe<Scalars['String']>;
};

/** Basic attributes for creating & updating an estimate */
export type EstimateAttributes = {
  cartonTypeId: Scalars['Int'];
  commodityId: Scalars['Int'];
  fboOrchardId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  packHouseId?: Maybe<Scalars['Int']>;
  productionUnitId?: Maybe<Scalars['Int']>;
  providerId: Scalars['Int'];
  season: Scalars['Int'];
  values: Array<EstimateValueAttributes>;
  varietyId?: Maybe<Scalars['Int']>;
  visibleCompanyIds?: Maybe<Array<Scalars['Int']>>;
  week?: Maybe<Scalars['String']>;
};

/** Determines how estimates and line items are matched. */
export enum EstimateMatchModeEnum {
  Provider = 'provider',
  ProviderProducer = 'provider_producer',
  Phc = 'phc',
  Puc = 'puc',
  Variety = 'variety',
  SubCommodity = 'sub_commodity',
  Commodity = 'commodity'
}

export type EstimateValue = {
  __typename?: 'EstimateValue';
  acceptedValue: Scalars['Float'];
  conversionWeight?: Maybe<Scalars['Float']>;
  estType: EstimateValueTypeEnum;
  grade?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inSeasonValue?: Maybe<Scalars['Float']>;
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  value: Scalars['Float'];
};


export type EstimateValueAcceptedValueArgs = {
  matchCols?: Maybe<Array<EstimateMatchModeEnum>>;
};

/** Basic attributes for creating & updating an estimate value */
export type EstimateValueAttributes = {
  conversionWeight?: Maybe<Scalars['Float']>;
  deleted?: Maybe<Scalars['Boolean']>;
  estType: EstimateValueTypeEnum;
  grade?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inSeasonValue?: Maybe<Scalars['Float']>;
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  value: Scalars['Float'];
};

/** The type of estimate value. Either picked (kg) or packed (cartons) */
export enum EstimateValueTypeEnum {
  Picked = 'picked',
  Packed = 'packed'
}

export type EtlDocument = {
  __typename?: 'EtlDocument';
  createdAt: Scalars['ISO8601DateTime'];
  /** Document type from document mapping, or "unknown" if no mapping */
  documentType?: Maybe<Scalars['String']>;
  /** Email from address if source is an email */
  emailFrom?: Maybe<Scalars['String']>;
  /** Email to address if source is an email */
  emailTo?: Maybe<Scalars['String']>;
  errorReason?: Maybe<Scalars['String']>;
  erroredRows?: Maybe<Scalars['Int']>;
  fileUrl?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  /** ETL states per linked invoice (derived from document rows) */
  invoiceEtlStates?: Maybe<Array<EtlInvoiceState>>;
  /** Invoices created by this document (vendor invoices only) */
  invoices?: Maybe<Array<Invoice>>;
  processedRows?: Maybe<Scalars['Int']>;
  rows?: Maybe<Scalars['Int']>;
  /** Source of the document (user name, email to, or source type/id) */
  source?: Maybe<Scalars['String']>;
  state: EtlDocumentStateEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for EtlDocument. */
export type EtlDocumentConnection = {
  __typename?: 'EtlDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EtlDocumentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EtlDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EtlDocumentEdge = {
  __typename?: 'EtlDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EtlDocument>;
};

export type EtlDocumentRow = {
  __typename?: 'EtlDocumentRow';
  createdAt: Scalars['ISO8601DateTime'];
  errorReason?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  processOutput?: Maybe<Scalars['String']>;
  state: EtlDocumentRowStateEnum;
  value: Scalars['Json'];
};

/** The connection type for EtlDocumentRow. */
export type EtlDocumentRowConnection = {
  __typename?: 'EtlDocumentRowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EtlDocumentRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EtlDocumentRow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EtlDocumentRowEdge = {
  __typename?: 'EtlDocumentRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EtlDocumentRow>;
};

export enum EtlDocumentRowStateEnum {
  Unprocessed = 'unprocessed',
  Mapped = 'mapped',
  Processed = 'processed',
  Skipped = 'skipped',
  Errored = 'errored'
}

export enum EtlDocumentStateEnum {
  Created = 'created',
  Unmapped = 'unmapped',
  Processed = 'processed',
  Processing = 'processing',
  Ignored = 'ignored',
  Duplicate = 'duplicate',
  Errored = 'errored'
}

export type EtlInvoiceState = {
  __typename?: 'EtlInvoiceState';
  invoiceId: Scalars['Int'];
  processOutput?: Maybe<Scalars['String']>;
  state?: Maybe<EtlDocumentRowStateEnum>;
};

/** The type of exchange rate eg. "custom", "fixed", "spot" */
export enum ExchangeRateTypeEnum {
  /** The exchange rate type is custom */
  Custom = 'CUSTOM',
  /** The exchange rate type is fixed */
  Fixed = 'FIXED',
  /** The exchange rate type is spot */
  Spot = 'SPOT'
}

/** The type of exchangeable object eg. "Invoice", "Payment" */
export enum ExchangeableTypeEnum {
  /** The exchangeable type is Invoice */
  Invoice = 'INVOICE',
  /** The exchangeable type is Payment */
  Payment = 'PAYMENT'
}

export enum ExpectedClaimEnum {
  /** The expected claim: quality */
  Quality = 'quality',
  /** The expected claim: market */
  Market = 'market',
  /** The expected claim: insurance */
  Insurance = 'insurance'
}

export type ExpectedReturnSummary = {
  __typename?: 'ExpectedReturnSummary';
  equivalentPrice?: Maybe<IncotermPrice>;
  error?: Maybe<Scalars['String']>;
  pricePoints?: Maybe<Array<IncotermPrice>>;
  unit?: Maybe<Scalars['String']>;
};

export type ExportDocument = {
  __typename?: 'ExportDocument';
  documentType?: Maybe<Scalars['String']>;
  file?: Maybe<Document>;
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

export type ExporterCode = {
  __typename?: 'ExporterCode';
  /** The buyer company */
  buyerCompany?: Maybe<Company>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The actual exporter code */
  exporterCode?: Maybe<Scalars['String']>;
  /** The exporter company */
  exporterCompany?: Maybe<Company>;
  /** Unique identifier for the exporter code */
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** A client change request for requested exporter cold store records */
export type ExporterColdStoreClientChangeRequest = {
  __typename?: 'ExporterColdStoreClientChangeRequest';
  /** The cold store to be added (pending approval) */
  coldStore?: Maybe<FoodBusinessOperator>;
  /** The supplier-exporter company association */
  companyAssociation?: Maybe<CompanyAssociation>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']>;
  /** The status of the client change request */
  status?: Maybe<Scalars['String']>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ExtendedField = {
  __typename?: 'ExtendedField';
  /** company the extended fields are for */
  companyId?: Maybe<Scalars['ID']>;
  /** polymorphic parent ID */
  resourceId: Scalars['ID'];
  /** polymorphic parent e.g. CartonGrouping */
  resourceType: Scalars['String'];
  /** extended fields key-value pairs */
  value?: Maybe<Scalars['Json']>;
};

export type FarmVariety = {
  __typename?: 'FarmVariety';
  /** The commodity record associated with the farm variety */
  commodity?: Maybe<Commodity>;
  /** The commodity name associated with the farm variety */
  commodityName?: Maybe<Scalars['String']>;
  /** The id of the company associated with the farm variety. */
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The area of this farm variety in hectares */
  hectares?: Maybe<Scalars['Float']>;
  /** Unique identifier for the farm variety */
  id?: Maybe<Scalars['Int']>;
  /** Image objects related to the farm variety */
  images?: Maybe<Array<Image>>;
  /** The full name of the variety, including sub-commodity and variety code */
  name?: Maybe<Scalars['String']>;
  /** The last week for packing, formatted as a string */
  packingEnd?: Maybe<Scalars['String']>;
  /** The starting week for packing, formatted as a string */
  packingStart?: Maybe<Scalars['String']>;
  /** A string representing the size count with the highest volume */
  peakCount?: Maybe<Scalars['String']>;
  /** The status of the farm variety */
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The variety record associated with the farm variety */
  variety?: Maybe<Variety>;
  /** The variety codes associated with the farm variety */
  varietyCode?: Maybe<Scalars['String']>;
  /** The variety id associated with the farm variety */
  varietyId?: Maybe<Scalars['Int']>;
  /** The name of the farm variety */
  varietyName?: Maybe<Scalars['String']>;
};

export type FarmVarietyFilterAttribute = {
  __typename?: 'FarmVarietyFilterAttribute';
  /** List of commodity names */
  commodityName?: Maybe<Array<Scalars['String']>>;
  /** List of available states */
  status?: Maybe<Array<Scalars['String']>>;
};

export type FarmVarietyFilters = {
  /** The commodities to filter on */
  commodityName?: Maybe<Array<Scalars['String']>>;
  /** The statuses to filter on */
  status?: Maybe<Array<Scalars['String']>>;
};

export type FarmVarietyRequest = {
  __typename?: 'FarmVarietyRequest';
  /** The commodity name associated with the farm variety */
  commodityName?: Maybe<Scalars['String']>;
  /** Unique identifier for the client change request */
  id?: Maybe<Scalars['ID']>;
  /** Unique identifier for the farm variety after the request is approved */
  modelId?: Maybe<Scalars['ID']>;
  /** The name of the requested farm variety */
  name?: Maybe<Scalars['String']>;
  /** Status of the change request */
  status?: Maybe<Scalars['String']>;
  /** The variety codes associated with the requested farm variety */
  varietyCode?: Maybe<Scalars['String']>;
};

export type FboOrchard = {
  __typename?: 'FboOrchard';
  block?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  foodBusinessOperator: FoodBusinessOperator;
  hectares?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  orchard: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  variety: Variety;
};


export type FboOrchardHectaresArgs = {
  season?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of FetchEphytoStatus. */
export type FetchEphytoStatusPayload = {
  __typename?: 'FetchEphytoStatusPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to fetch ephyto status */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of FetchTransnetContainerOperators. */
export type FetchTransnetContainerOperatorsPayload = {
  __typename?: 'FetchTransnetContainerOperatorsPayload';
  /** The container operators */
  containerOperators?: Maybe<Array<Scalars['Json']>>;
  /** List of error messages */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of FetchTransnetVisitsByShipment. */
export type FetchTransnetVisitsByShipmentPayload = {
  __typename?: 'FetchTransnetVisitsByShipmentPayload';
  /** Error message if the fetch fails */
  error?: Maybe<Scalars['String']>;
  /** The visit list */
  visitList?: Maybe<Array<Visit>>;
};

/** Fields defining a generic filter model */
export type Filter = {
  /** Field to filter on */
  field?: Maybe<Scalars['String']>;
  /** can be a value of 'text' or 'number' */
  fieldType?: Maybe<Scalars['String']>;
  /**
   * Filter type in report group:
   * - 'input': Custom text entry.
   * - 'idSelection': Dropdown 'id', for backend identifiers.
   * - 'labelSelection': Dropdown 'label', for display text.
   * Select based on backend requirements.
   */
  filterType?: Maybe<Scalars['String']>;
  /** Filtering condition: 'equals', 'notEqual', 'contains','notContains', 'startsWith', 'endsWith','lessThan', 'lessThanOrEqual', 'greaterThan','greaterThanOrEqual', 'inRange' */
  condition?: Maybe<Scalars['String']>;
  /** The value you want to filter on. */
  filter?: Maybe<Scalars['String']>;
  /** The value you want to filter on. */
  filterTo?: Maybe<Scalars['String']>;
  /** The values you want to filter on. */
  values?: Maybe<Array<Scalars['String']>>;
};

/** Attributes for finalising default costs */
export type FinaliseDefaultCostAttributes = {
  /** The ID of the Finance Rule being used to update the default costs */
  financeRuleId: Scalars['ID'];
  /** Container Ids to update */
  containerIds?: Maybe<Array<Scalars['ID']>>;
  /** Pallet numbers to update */
  palletNumbers?: Maybe<Array<Scalars['String']>>;
  /** The amount to override the default cost with */
  overrideAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** The percentage to override the default cost with */
  overridePercentage?: Maybe<Scalars['BigDecimal']>;
};

/** Autogenerated return type of FinaliseDefaultCosts. */
export type FinaliseDefaultCostsPayload = {
  __typename?: 'FinaliseDefaultCostsPayload';
  /** Finalised CGT IDs associated with this finance rule */
  cgtIds?: Maybe<Array<Scalars['ID']>>;
  /** Error information when attempting to finalise default costs */
  errors?: Maybe<Scalars['String']>;
};

export type FinanceReport = {
  __typename?: 'FinanceReport';
  items?: Maybe<Array<FinanceReportItem>>;
};

export type FinanceReportFilterAttributes = {
  companyIds?: Maybe<Array<Scalars['Int']>>;
  containerNumbers?: Maybe<Array<Scalars['String']>>;
  currencies?: Maybe<Array<Scalars['String']>>;
  endWeek?: Maybe<Scalars['String']>;
  orderIds?: Maybe<Array<Scalars['Int']>>;
  startWeek?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Scalars['String']>>;
};

export type FinanceReportItem = {
  __typename?: 'FinanceReportItem';
  amount?: Maybe<Scalars['Float']>;
  amountPerCarton?: Maybe<Scalars['Float']>;
  batchNumber?: Maybe<Scalars['String']>;
  buyer?: Maybe<Scalars['String']>;
  cartons?: Maybe<Scalars['Int']>;
  commodity?: Maybe<Scalars['String']>;
  containerNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  exporterCode?: Maybe<Scalars['String']>;
  farmCode?: Maybe<Scalars['String']>;
  generalLedgerName?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['String']>;
  incoterm?: Maybe<Scalars['String']>;
  isActual?: Maybe<Scalars['Boolean']>;
  liReferenceNumber?: Maybe<Scalars['String']>;
  packType?: Maybe<Scalars['String']>;
  packingWeek?: Maybe<Scalars['String']>;
  palletNumber?: Maybe<Scalars['String']>;
  primaryCategory?: Maybe<Scalars['String']>;
  secondaryCategory?: Maybe<Scalars['String']>;
  seller?: Maybe<Scalars['String']>;
  shippingWeek?: Maybe<Scalars['String']>;
  sizeCount?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stdCartons?: Maybe<Scalars['Int']>;
  targetMarket?: Maybe<Scalars['String']>;
  targetRegion?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['ISO8601DateTime']>;
  transactionType?: Maybe<Scalars['String']>;
  transactionWeek?: Maybe<Scalars['String']>;
  txReferenceNumber?: Maybe<Scalars['String']>;
  variety?: Maybe<Scalars['String']>;
  zarAmount?: Maybe<Scalars['Float']>;
  zarPerCarton?: Maybe<Scalars['Float']>;
};

export type FinanceRule = {
  __typename?: 'FinanceRule';
  /** The amount in cents related to the finance rule. */
  amountCents?: Maybe<Scalars['Int']>;
  /** The company associated with the finance rule. */
  company?: Maybe<Company>;
  /** The cost code associated with the finance rule. */
  costCode?: Maybe<CostCode>;
  /** Date and time when the finance rule created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The currency in which the finance rule is denominated. */
  currency?: Maybe<Scalars['String']>;
  /** The amount of CGTs this rule has been finalised on */
  defaultCgtsFinalised?: Maybe<Scalars['Int']>;
  /** The amount of CGTs this rule has created but are still  estimates */
  defaultCgtsPendingReview?: Maybe<Scalars['Int']>;
  /** Indicates whether the finance rule is enabled or active. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The date when the finance rule will end or expire. */
  endDate?: Maybe<Scalars['ISO8601Date']>;
  /** Formatted cost string including currency, amount, and unit */
  formattedCost?: Maybe<Scalars['String']>;
  /** The cost codes associated with the grouped finance rule, including their effective dates */
  groupedCostCodes?: Maybe<Array<GroupedCostCode>>;
  /** Returns the match condition in a human-readable format */
  humanReadableExpression?: Maybe<Scalars['String']>;
  /** The unique identifier of the finance rule. */
  id: Scalars['ID'];
  /** The incoterm used for calculating percentages */
  incotermForPercentageCalculation?: Maybe<Scalars['String']>;
  /** Whether this finance rule creates default costs or not */
  isDefaultCost: Scalars['Boolean'];
  /** The match condition associated with this finance rule */
  matchCondition?: Maybe<MatchCondition>;
  /** The name or label of the finance rule. */
  name: Scalars['String'];
  /** The percentage value applied within the finance rule, if applicable. */
  percentage?: Maybe<Scalars['Float']>;
  /** Description of this finance rule */
  ruleDescription?: Maybe<Scalars['String']>;
  /** Returns the simple expression if the rule is simple. */
  simpleExpression?: Maybe<Scalars['String']>;
  /** The extracted fields from the simple expression. */
  simpleExpressionFields?: Maybe<Array<Scalars['String']>>;
  /** The match types from the simple expression. */
  simpleExpressionMatchTypes?: Maybe<Array<Scalars['String']>>;
  /** The extracted values from the simple expression. */
  simpleExpressionValues?: Maybe<Array<Scalars['String']>>;
  /** The date when the finance rule starts. */
  startDate?: Maybe<Scalars['ISO8601Date']>;
  /** The unit of measurement for the finance rule. */
  unit?: Maybe<FinanceRuleUnitEnum>;
  /** Date and time when the finance rule was updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type FinanceRuleAttributes = {
  /**
   * The amount in minor units (e.g.,
   *               cents) for this finance rule
   */
  amountCents?: Maybe<Scalars['Int']>;
  /** The ID of the company associated with this finance rule (optional) */
  companyId?: Maybe<Scalars['ID']>;
  /** The ID of the cost code associated with this finance rule */
  costCodeId?: Maybe<Scalars['ID']>;
  /** The currency in which the amount is specified */
  currency?: Maybe<Scalars['String']>;
  /** Indicates whether the finance rule is currently enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The end date after which the finance rule is no longer applicable */
  endDate?: Maybe<Scalars['ISO8601Date']>;
  /** The ID of the finance rule */
  id?: Maybe<Scalars['ID']>;
  /**
   * The Incoterm used for percentage calculation,
   *               if applicable
   */
  incotermForPercentageCalculation?: Maybe<Scalars['String']>;
  /** Attributes for the match condition associated with this finance rule */
  matchConditionAttributes?: Maybe<MatchConditionAttributes>;
  /** The name of the finance rule */
  name: Scalars['String'];
  /**
   * The percentage value for this finance rule,
   *               if applicable
   */
  percentage?: Maybe<Scalars['Float']>;
  /** The start date from which the finance rule is applicable */
  startDate?: Maybe<Scalars['ISO8601Date']>;
  /** The unit of measure for this finance rule e.g. KG, PALLET */
  unit: Scalars['String'];
  /** Indicates whether this finance rule is a default cost */
  isDefaultCost: Scalars['Boolean'];
};

/** The connection type for FinanceRule. */
export type FinanceRuleConnection = {
  __typename?: 'FinanceRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FinanceRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FinanceRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FinanceRuleEdge = {
  __typename?: 'FinanceRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<FinanceRule>;
};

/** A user-readable error for FinanceRule */
export type FinanceRuleError = {
  __typename?: 'FinanceRuleError';
  /** A description of the error */
  message: Scalars['String'];
};

export type FinanceRuleFilterAttribute = {
  __typename?: 'FinanceRuleFilterAttribute';
  /** Cost codes associated with the finance rules */
  costCodes?: Maybe<Array<CostCode>>;
  /** Currencies used in the finance rules */
  currencies?: Maybe<Array<Scalars['String']>>;
  /** Is finance rules enabled? */
  enabled?: Maybe<Array<Scalars['Boolean']>>;
  /** End dates for the finance rules */
  endDates?: Maybe<Array<Scalars['String']>>;
  /** Is a default cost finance rule? */
  isDefaultCost?: Maybe<Scalars['Boolean']>;
  /** Names of the finance rules */
  ruleNames?: Maybe<Array<Scalars['String']>>;
  /** Start dates for the finance rules */
  startDates?: Maybe<Array<Scalars['String']>>;
  /** Units of measurement used in the finance rules */
  units?: Maybe<Array<Scalars['String']>>;
};

export type FinanceRuleFilters = {
  /** List of finance rule IDs to filter by. */
  financeRuleIds?: Maybe<Array<Scalars['ID']>>;
  /** List of cost code IDs to filter by. */
  costCodeIds?: Maybe<Array<Scalars['Int']>>;
  /** Currency to filter by. */
  currency?: Maybe<Array<Scalars['String']>>;
  /** Name to filter by. */
  name?: Maybe<Array<Scalars['String']>>;
  /** Filter by enabled status. */
  enabled?: Maybe<Array<Scalars['String']>>;
  /** Filter by default cost status. */
  isDefaultCost?: Maybe<Scalars['Boolean']>;
  /** Incoterm for percentage calculation to filter by. */
  incotermForPercentageCalculation?: Maybe<Array<Scalars['String']>>;
  /** Unit to filter by. */
  unit?: Maybe<Array<Scalars['String']>>;
  /** Start date to filter by. */
  startDate?: Maybe<Array<Scalars['ISO8601Date']>>;
  /** End date to filter by. */
  endDate?: Maybe<Array<Scalars['ISO8601Date']>>;
  /** Whether the screen should display active or historic costs */
  pageType?: Maybe<Scalars['String']>;
};

/** The unit of measurement for the finance rule. */
export enum FinanceRuleUnitEnum {
  Kg = 'KG',
  RawCarton = 'RAW_CARTON',
  StdCarton = 'STD_CARTON',
  Pallet = 'PALLET',
  Container = 'CONTAINER',
  Percentage = 'PERCENTAGE',
  PercentageOfIncoterm = 'PERCENTAGE_OF_INCOTERM'
}

/** A financial year option for filtering */
export type FinancialYearOption = {
  __typename?: 'FinancialYearOption';
  /** FY end date */
  endDate: Scalars['ISO8601Date'];
  /** Human-readable short label (e.g. "FY27 (Mar 2026 - Feb 2027)") */
  label: Scalars['String'];
  /** FY start date */
  startDate: Scalars['ISO8601Date'];
  /** The calendar year the FY ends in (end-year convention, e.g. 2027 for Mar 2026 - Feb 2027 on a Mar-Feb company) */
  year: Scalars['Int'];
};

/** Autogenerated return type of FindOrCreateVessel. */
export type FindOrCreateVesselPayload = {
  __typename?: 'FindOrCreateVesselPayload';
  /** Any errors that occurred */
  errors?: Maybe<Scalars['String']>;
  /** The vessel */
  vessel?: Maybe<Vessel>;
};

export type FoodBusinessOperator = {
  __typename?: 'FoodBusinessOperator';
  /** The address of the food business operator */
  address?: Maybe<Address>;
  /** The company associated with the food business operator */
  company?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique DALRAD code for the food business operator */
  fboCode?: Maybe<Scalars['String']>;
  /** The GlobalGAP certification number */
  globalGapNumber?: Maybe<Scalars['String']>;
  /** Unique identifier for this food business operator */
  id?: Maybe<Scalars['Int']>;
  /** The latitude coordinate of the food business operator */
  latitude?: Maybe<Scalars['Float']>;
  /** The location mappings for this food business operator */
  locationMappings?: Maybe<Array<LocationMapping>>;
  /** The longitude coordinate of the food business operator */
  longitude?: Maybe<Scalars['Float']>;
  /** The name of the food business operator */
  name?: Maybe<Scalars['String']>;
  /** The packhouse connections for this food business operator */
  packhouseConnections?: Maybe<Array<PackhouseConnection>>;
  /** The producer name of this food business operator */
  producerName?: Maybe<Scalars['String']>;
  /** The production region of this food business operator */
  productionRegion?: Maybe<Scalars['String']>;
  /** The status of the food business operator */
  status?: Maybe<Scalars['String']>;
  /** The type of business for this food business operator */
  typeOfBusiness?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type FoodBusinessOperatorFilterAttribute = {
  __typename?: 'FoodBusinessOperatorFilterAttribute';
  /** The list of statuses */
  status?: Maybe<Array<Scalars['String']>>;
  /** The list of type of businesses */
  typeOfBusiness?: Maybe<Array<Scalars['String']>>;
};

export type FoodBusinessOperatorFilters = {
  /** The status to filter on */
  status?: Maybe<Array<Scalars['String']>>;
  /** The type of business to filter on */
  typeOfBusiness?: Maybe<Array<Scalars['String']>>;
};

export type FoodBusinessOperatorRequest = {
  __typename?: 'FoodBusinessOperatorRequest';
  /** The unique DALRAD code for the food business operator */
  fboCode?: Maybe<Scalars['String']>;
  /** The GlobalGAP certification number */
  globalGapNumber?: Maybe<Scalars['String']>;
  /** Unique identifier for the food business operator request */
  id: Scalars['ID'];
  /** The latitude coordinate of the food business operator */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude coordinate of the food business operator */
  longitude?: Maybe<Scalars['Float']>;
  /** Unique identifier for the farm variety after the request is approved */
  modelId?: Maybe<Scalars['Int']>;
  /** The name of the requested food business operator */
  name?: Maybe<Scalars['String']>;
  /** The producer name of this requested food business operator */
  producerName?: Maybe<Scalars['String']>;
  /** The production region of this requested food business operator */
  productionRegion?: Maybe<Scalars['String']>;
  /** Status of the change request */
  status?: Maybe<Scalars['String']>;
  /** The type of business for this requested food business operator */
  typeOfBusiness?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of GenerateAccountStatementOutputFiles. */
export type GenerateAccountStatementOutputFilesPayload = {
  __typename?: 'GenerateAccountStatementOutputFilesPayload';
  /** The account statement containing state of the file generation */
  accountStatement?: Maybe<AccountStatement>;
};

/** Autogenerated return type of GenerateAccountingExport. */
export type GenerateAccountingExportPayload = {
  __typename?: 'GenerateAccountingExportPayload';
  /** The accounting export containing state of the file generation */
  accountingExport?: Maybe<AccountingExport>;
  /** Errors that occurred during the export */
  exportErrors?: Maybe<Array<AccountingExportError>>;
};

/** Autogenerated return type of GenerateAddendumHeaderOutputFiles. */
export type GenerateAddendumHeaderOutputFilesPayload = {
  __typename?: 'GenerateAddendumHeaderOutputFilesPayload';
  /** The template output object containing state of the file generation */
  templateOutput?: Maybe<Array<TemplateOutput>>;
};

/** Autogenerated return type of GenerateAddendum. */
export type GenerateAddendumPayload = {
  __typename?: 'GenerateAddendumPayload';
  /** The Addendum Header */
  addendumHeader?: Maybe<AddendumHeader>;
  /** Errors */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of GenerateAg1TableOutputFile. */
export type GenerateAg1TableOutputFilePayload = {
  __typename?: 'GenerateAg1TableOutputFilePayload';
  /** URL for the generated File */
  fileUrl: Scalars['String'];
};

/** Autogenerated return type of GenerateAirAddendum. */
export type GenerateAirAddendumPayload = {
  __typename?: 'GenerateAirAddendumPayload';
  /** The generated addendum header */
  addendumHeader?: Maybe<AddendumHeader>;
  /** Errors */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of GenerateArrivalQcs. */
export type GenerateArrivalQcsPayload = {
  __typename?: 'GenerateArrivalQcsPayload';
  /** Errors that occurred during the generation of the arrival qcs */
  errors: Array<Scalars['String']>;
  /** Whether triggering the generation of the arrival qcs was successful */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of GenerateCommoditySeasons. */
export type GenerateCommoditySeasonsPayload = {
  __typename?: 'GenerateCommoditySeasonsPayload';
  error?: Maybe<Scalars['String']>;
  failures?: Maybe<Scalars['Int']>;
  successes?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of GenerateDataOutputFiles. */
export type GenerateDataOutputFilesPayload = {
  __typename?: 'GenerateDataOutputFilesPayload';
  /** The template output object containing state of the file generation */
  dataPreparation?: Maybe<DataPreparation>;
};

/** Autogenerated return type of GenerateEphyto. */
export type GenerateEphytoPayload = {
  __typename?: 'GenerateEphytoPayload';
  /** The Resulting Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Errors */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of GenerateEphytoTradeUnit. */
export type GenerateEphytoTradeUnitPayload = {
  __typename?: 'GenerateEphytoTradeUnitPayload';
  /** The Resulting EphytoTradeUnits */
  ephytoTradeUnits?: Maybe<Array<EphytoTradeUnit>>;
  /** Errors */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of GenerateInvoiceOutputFiles. */
export type GenerateInvoiceOutputFilesPayload = {
  __typename?: 'GenerateInvoiceOutputFilesPayload';
  /** The template output object containing state of the file generation */
  templateOutput?: Maybe<Array<TemplateOutput>>;
};

/** Autogenerated return type of GenerateLoadOutInstructionOutputFiles. */
export type GenerateLoadOutInstructionOutputFilesPayload = {
  __typename?: 'GenerateLoadOutInstructionOutputFilesPayload';
  /** The template output object containing state of the file generation */
  templateOutput?: Maybe<Array<TemplateOutput>>;
};

/** Autogenerated return type of GeneratePalletInOutputFiles. */
export type GeneratePalletInOutputFilesPayload = {
  __typename?: 'GeneratePalletInOutputFilesPayload';
  /** Unique identifier of the created or updated pallet in */
  palletInId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of GeneratePalletOutOutputFiles. */
export type GeneratePalletOutOutputFilesPayload = {
  __typename?: 'GeneratePalletOutOutputFilesPayload';
  /** Unique identifier of the created or updated pallet out */
  palletOutId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of GenerateProducerStatement. */
export type GenerateProducerStatementPayload = {
  __typename?: 'GenerateProducerStatementPayload';
  /** URL for the generated statement file (from persisted TemplateOutput) */
  fileUrl?: Maybe<Scalars['String']>;
  /** The generated statement number (e.g. PS-00001) */
  statementNumber: Scalars['String'];
};

/** Autogenerated return type of GenerateShipmentExportNotificationOutputFiles. */
export type GenerateShipmentExportNotificationOutputFilesPayload = {
  __typename?: 'GenerateShipmentExportNotificationOutputFilesPayload';
  /** The shipment containing state of the file generation */
  shipment?: Maybe<Shipment>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  /** Latitude */
  lat?: Maybe<Scalars['Float']>;
  /** Longitude */
  lon?: Maybe<Scalars['Float']>;
};

export type GridColumn = {
  aggFunc?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  field?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

/** This defines a request for a SSR AG Grid */
export type GridRequest = {
  /** First row requested or undefined for all rows. */
  startRow: Scalars['Int'];
  /** Last row requested or undefined for all rows. */
  endRow: Scalars['Int'];
  /** Columns that are currently row grouped. */
  rowGroupCols?: Maybe<Array<GridColumn>>;
  /** Columns that have aggregations on them. */
  valueCols?: Maybe<Array<GridColumn>>;
  /** Columns that have pivot on them. */
  pivotCols?: Maybe<Array<GridColumn>>;
  /** Defines if pivot mode is on or off. */
  pivotMode?: Maybe<Scalars['Boolean']>;
  /** What groups the user is viewing. */
  groupKeys?: Maybe<Array<Scalars['String']>>;
  /** If filtering, what the filter model is. */
  filterModel?: Maybe<Array<Filter>>;
  /** If sorting, what the sort model is. */
  sortModel?: Maybe<Array<GridSortModel>>;
};

/** Fields defining the sorting model for AG Grid */
export type GridSortModel = {
  /** Column Id to apply the sort to. */
  colId: Scalars['String'];
  /** Sort direction. 'asc' or 'desc' */
  sort: Scalars['String'];
};

export type GroupedCostCode = {
  __typename?: 'GroupedCostCode';
  /** The cost code */
  costCode: CostCode;
  /** End date for this cost code in the finance rule */
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the finance rule that is used to group this cost code */
  financeRuleId?: Maybe<Scalars['ID']>;
  /** Start date for this cost code in the finance rule */
  startDate: Scalars['ISO8601DateTime'];
};

/** Historical market volume data showing percentage share by company, region, commodity and grade */
export type HistoricalMarketVolume = {
  __typename?: 'HistoricalMarketVolume';
  /** Name of the commodity */
  commodityName?: Maybe<Scalars['String']>;
  /** Company of the historical market volume */
  company?: Maybe<Company>;
  /** ID of the company */
  companyId?: Maybe<Scalars['ID']>;
  /** Name of the company */
  companyName?: Maybe<Scalars['String']>;
  /** Grade classification of the fruit */
  grade?: Maybe<Scalars['String']>;
  /** Percentage of total market volume for this region-commodity combination */
  percentageOfMarketVolume?: Maybe<Scalars['Float']>;
  /** Target region code for the market */
  targetRegion?: Maybe<Scalars['String']>;
  /** Total volume in cartons for this combination */
  volumeInCartons?: Maybe<Scalars['Float']>;
};

/** A valid ISO 4217 currency code string. */
export enum Iso4217 {
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Gulden */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bitcoin Cash */
  Bch = 'BCH',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudian Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bitcoin */
  Btc = 'BTC',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Botswana Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** Swiss Franc */
  Chf = 'CHF',
  /** Unidad de Fomento */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Renminbi Yuan Offshore */
  Cnh = 'CNH',
  /** Chinese Renminbi Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Czech Koruna */
  Czk = 'CZK',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Pound */
  Fkp = 'FKP',
  /** British Pound */
  Gbp = 'GBP',
  /** British Penny */
  Gbx = 'GBX',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Guernsey Pound */
  Ggp = 'GGP',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Guyanese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Israeli New Sheqel */
  Ils = 'ILS',
  /** Isle of Man Pound */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Jersey Pound */
  Jep = 'JEP',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgyzstani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Lao Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tögrög */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya */
  Mro = 'MRO',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Złoty */
  Pln = 'PLN',
  /** Paraguayan Guaraní */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Saint Helenian Pound */
  Shp = 'SHP',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé and Príncipe Dobra */
  Std = 'STD',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd = 'TTD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** United States Dollar */
  Usd = 'USD',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uzbekistan Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar */
  Vef = 'VEF',
  /** Venezuelan Bolívar Soberano */
  Ves = 'VES',
  /** Vietnamese Đồng */
  Vnd = 'VND',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African Cfa Franc */
  Xaf = 'XAF',
  /** Silver (Troy Ounce) */
  Xag = 'XAG',
  /** Gold (Troy Ounce) */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account 9 */
  Xbc = 'XBC',
  /** European Unit of Account 17 */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** UIC Franc */
  Xfu = 'XFU',
  /** West African Cfa Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** Cfp Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** Codes specifically reserved for testing purposes */
  Xts = 'XTS',
  /** Yemeni Rial */
  Yer = 'YER',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha */
  Zmk = 'ZMK',
  /** Zimbabwean Dollar */
  Zwd = 'ZWD'
}



export type IdName = {
  __typename?: 'IdName';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  /** The image as a base 64 encoded string formatted for usage in an img html tag */
  base64ImgSrc?: Maybe<Scalars['String']>;
  /** The MIME type of the image (e.g., image/png, image/jpeg) */
  contentType?: Maybe<Scalars['String']>;
  /** The original name of the file */
  filename?: Maybe<Scalars['String']>;
  /** The ID of the image */
  id?: Maybe<Scalars['Int']>;
  /** A smaller version of the image */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** The direct URL to the image */
  url?: Maybe<Scalars['String']>;
  /** The upgraded version of the thumbnail URL */
  v2ThumbnailUrl?: Maybe<Scalars['String']>;
  /** The direct URL to the image that includes the host */
  v2Url?: Maybe<Scalars['String']>;
};

/** An in-app notification for the current user */
export type InAppNotification = {
  __typename?: 'InAppNotification';
  /** When the user archived the notification, null means not archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Notification body */
  body?: Maybe<Scalars['String']>;
  /** When the notification was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** When the notification was delivered in-app */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Channel notification ID */
  id: Scalars['ID'];
  /** Structured metadata (entity_type, entity_ids, severity, etc.). */
  metadata?: Maybe<Scalars['JSON']>;
  /** Severity for UI: update - informative or alert - needs attention. */
  notificationType?: Maybe<NotificationTypeEnum>;
  /** When the user read the notification null means unread */
  readAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the notification was sent */
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Notification title */
  title?: Maybe<Scalars['String']>;
};

export enum IncotermEnum {
  /** The incoterm is EXW */
  Exw = 'EXW',
  /** The incoterm is DIP */
  Dip = 'DIP',
  /** The incoterm is FCA */
  Fca = 'FCA',
  /** The incoterm is FAS */
  Fas = 'FAS',
  /** The incoterm is FOB */
  Fob = 'FOB',
  /** The incoterm is CFR */
  Cfr = 'CFR',
  /** The incoterm is CIF */
  Cif = 'CIF',
  /** The incoterm is FOT */
  Fot = 'FOT',
  /** The incoterm is DAP */
  Dap = 'DAP',
  /** The incoterm is DDP */
  Ddp = 'DDP'
}

export type IncotermPrice = {
  __typename?: 'IncotermPrice';
  chargesApplied?: Maybe<Array<ChargeApplied>>;
  incoterm: IncotermWithNscEnum;
  moneyAmount: Money;
};

export enum IncotermWithNscEnum {
  /** The incoterm is NSC */
  Nsc = 'NSC',
  /** The incoterm is EXW */
  Exw = 'EXW',
  /** The incoterm is DIP */
  Dip = 'DIP',
  /** The incoterm is FCA */
  Fca = 'FCA',
  /** The incoterm is FAS */
  Fas = 'FAS',
  /** The incoterm is FOB */
  Fob = 'FOB',
  /** The incoterm is CFR */
  Cfr = 'CFR',
  /** The incoterm is CIF */
  Cif = 'CIF',
  /** The incoterm is FOT */
  Fot = 'FOT',
  /** The incoterm is DAP */
  Dap = 'DAP',
  /** The incoterm is DDP */
  Ddp = 'DDP'
}

/** A client change request for adding an internal packhouse */
export type InternalPackhouseClientChangeRequest = {
  __typename?: 'InternalPackhouseClientChangeRequest';
  /** The company that requested the packhouse addition */
  company?: Maybe<Company>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']>;
  /** The packhouse (FBO) being added */
  packhouse?: Maybe<FoodBusinessOperator>;
  /** The packhouse connection being added */
  packhouseConnection?: Maybe<PackhouseConnection>;
  /** The status of the client change request */
  status?: Maybe<Scalars['String']>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


/** A client change request for adding an internal packhouse */
export type InternalPackhouseClientChangeRequestPackhouseConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type Invite = {
  __typename?: 'Invite';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  initiator?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of InviteUser. */
export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  invite?: Maybe<Invite>;
};

/** Fields available on an invoice */
export type Invoice = {
  __typename?: 'Invoice';
  /** Accounting Exports attached to the invoice */
  accountingExports?: Maybe<Array<AccountingExport>>;
  /** The number of days within which advance payment is needed from agreed upon event */
  advanceCreditTerm?: Maybe<Scalars['Int']>;
  /** The total advance payment for this invoice */
  advancePayment?: Maybe<Scalars['BigDecimal']>;
  /** The air waybill no associated with this Invoice */
  airWaybillNo?: Maybe<Scalars['String']>;
  /** Amount remitted against this invoice */
  allocatedAmountMajorUnit?: Maybe<Scalars['Float']>;
  /** The allocated weight of the goods for the Invoice */
  allocatedWeight?: Maybe<Scalars['Float']>;
  /** Attached documents (PDF and Excel files) for this invoice */
  attachedDocuments?: Maybe<Array<Document>>;
  /** The number of cartons in the invoice */
  cartonCount?: Maybe<Scalars['Int']>;
  /** The carton groupings that are associated with this invoice */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** All connected children invoices to this invoice */
  childInvoices?: Maybe<Array<Invoice>>;
  /** Commercial term associated with this invoice */
  commercialTerm?: Maybe<CommercialTerm>;
  /** The company that owns this invoice */
  company?: Maybe<Company>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: Maybe<Scalars['ISO8601Date']>;
  /** The contacts for the invoice */
  contacts?: Maybe<Array<Contact>>;
  /** The container numbers associated with this invoice */
  containerNumbers?: Maybe<Scalars['String']>;
  /** The containers on the invoice */
  containers?: Maybe<Array<Container>>;
  /** Whether or not to convert tons to kilograms */
  convertTonToKg?: Maybe<Scalars['Boolean']>;
  /** Costs associated with the invoice */
  costs?: Maybe<Scalars['String']>;
  /** The country of origin for the invoice */
  countryOfOrigin?: Maybe<TradeCountry>;
  /** The date and time at which the invoice was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Currency of the invoice */
  currency?: Maybe<CurrencyEnum>;
  /** Currency exchange rate for the payment */
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** The destination associated with the Invoice */
  destination?: Maybe<Scalars['String']>;
  /** The kind of document e.g. invoice, tax invoice, ... */
  documentType?: Maybe<InvoiceDocumentTypeEnum>;
  /** The due date of the invoice, either final or advance */
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  /** The advance due date of the invoice */
  dueDateAdvance?: Maybe<Scalars['ISO8601Date']>;
  /** The final due date of the invoice */
  dueDateFinal?: Maybe<Scalars['ISO8601Date']>;
  /** Exchange rate for the payment */
  exchangeRate?: Maybe<Scalars['String']>;
  /** The number of days within which final payment is needed from agreed upon event */
  finalCreditTerm?: Maybe<Scalars['Int']>;
  /** The total final payment for this invoice */
  finalPayment?: Maybe<Scalars['BigDecimal']>;
  /** The flights date */
  flightDate?: Maybe<Scalars['ISO8601Date']>;
  /** Freight cost of the CI */
  freightCost?: Maybe<Scalars['Float']>;
  /** Unique CI identifier */
  id?: Maybe<Scalars['ID']>;
  /** Incoterm applicable */
  incoterm?: Maybe<IncotermEnum>;
  /** Insurance cost of the CI */
  insuranceCost?: Maybe<Scalars['Float']>;
  /** Custom fields associated with this invoice */
  invoiceCustomFields?: Maybe<Array<InvoiceCustomField>>;
  /** The user-selected date that the invoice was issued */
  invoiceDate?: Maybe<Scalars['ISO8601Date']>;
  /** The pallets that are associated with this invoice's carton groupings */
  invoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** A reference assigned to the CI */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** The payments associated with this invoice */
  invoicePayments?: Maybe<Array<InvoicePayment>>;
  /** The advance invoice that is linked to this invoice */
  linkedAdvanceInvoice?: Maybe<Invoice>;
  /** All linked invoices to this invoice */
  linkedRecords?: Maybe<Array<Invoice>>;
  /** The FBO where the goods are loaded */
  loadingPoint?: Maybe<FoodBusinessOperator>;
  /** Local costs of the CI */
  localCosts?: Maybe<Scalars['Float']>;
  /** Net amount calculation for the account sale */
  netAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** The FBO where the goods are unloaded */
  offloadingPoint?: Maybe<FoodBusinessOperator>;
  /** The credit note created for an over-recovery on this invoice */
  overRecoveryCreditNote?: Maybe<Invoice>;
  /** The number of pallets in the invoice */
  palletCount?: Maybe<Scalars['Int']>;
  /** Parent invoice to this invoice */
  parentInvoice?: Maybe<Invoice>;
  /** The ID this invoice is linked to */
  parentInvoiceId?: Maybe<Scalars['Int']>;
  /** Purchase order number */
  poNumber?: Maybe<Scalars['String']>;
  /** Where vessel is delivering the shipment */
  portOfDestination?: Maybe<SeaPort>;
  /** Where shipment was loaded onto a vessel */
  portOfLoading?: Maybe<SeaPort>;
  /** The remaining amount in major unit */
  remainingAmountMajorUnit?: Maybe<Scalars['Float']>;
  /** The invoice total with debit and credits applied */
  remittableAmountMajorUnit?: Maybe<Scalars['Float']>;
  /** The flights routing */
  routing?: Maybe<Scalars['String']>;
  /** The sale type of this CI */
  saleType?: Maybe<Scalars['String']>;
  /** Emails in which this document was included */
  sentEmailList?: Maybe<Array<SentEmail>>;
  /** The Shippers name */
  shipper?: Maybe<Scalars['String']>;
  /** The state of the invoice */
  state?: Maybe<InvoiceStateEnum>;
  /** FBO Associated with this CI */
  stuffLocation?: Maybe<FoodBusinessOperator>;
  /** The sub total on the invoice */
  subTotal?: Maybe<Scalars['Float']>;
  /** Object containing information on the document generated for this invoice */
  templateOutput?: Maybe<Array<TemplateOutput>>;
  /** Total costs calculation for the account sale */
  totalCostsMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** The total FOB value of the invoice */
  totalFob?: Maybe<Scalars['Float']>;
  /** Total incoterm value of the CI */
  totalIncoterm?: Maybe<Scalars['BigDecimal']>;
  /** Transport Type seleccted for this document */
  transportType?: Maybe<Scalars['String']>;
  /** UCR number */
  ucrNumber?: Maybe<Scalars['String']>;
  /** The time at which the invoice was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The Total VAT payable on the invoice */
  vat?: Maybe<Scalars['Float']>;
  /** The VAT Type associated with the invoice */
  vatType?: Maybe<VatType>;
  /** The vehicle number that is associated with this CI */
  vehicleNumber?: Maybe<Scalars['String']>;
  /** Vessel associated with CI */
  vessel?: Maybe<Vessel>;
  /** Estimated Time of Arrival based on Vessel Tracking Events */
  vesselEta?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated Time of Departure based on Vessel Tracking Events */
  vesselEtd?: Maybe<Scalars['ISO8601DateTime']>;
  /** Voyage that the associated vessel is taking */
  voyage?: Maybe<Scalars['String']>;
};


/** Fields available on an invoice */
export type InvoiceSentEmailListArgs = {
  direction?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};

/** Whether an invoice has been included in an accounting export (invoice list filter). */
export enum InvoiceAccountingExportFilterEnum {
  /** Invoices that have been exported to accounting */
  Exported = 'EXPORTED',
  /** Invoices not yet exported to accounting */
  NotExported = 'NOT_EXPORTED'
}

export type InvoiceAttributes = {
  /** The number of days within which advance payment is needed from agreed upon event */
  advanceCreditTerm: Scalars['Int'];
  /** The advance to be paid on the invoice */
  advancePayment?: Maybe<Scalars['BigDecimal']>;
  /** The air waybill number associated with this Invoice */
  airWaybillNo?: Maybe<Scalars['String']>;
  /** The allocated weight of the goods for the Invoice */
  allocatedWeight?: Maybe<Scalars['Float']>;
  /** The IDs of the carton groupings associated with the invoice */
  cartonGroupingIds?: Maybe<Array<Scalars['Int']>>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: Maybe<Scalars['ISO8601Date']>;
  /** The IDs of the contacts associated with the invoice */
  contactIds?: Maybe<Array<Scalars['Int']>>;
  /** The IDs of the containers associated with the invoice */
  containerIds?: Maybe<Array<Scalars['Int']>>;
  /** Indicates whether the weight should be converted from tons to kilograms */
  convertTonToKg?: Maybe<Scalars['Boolean']>;
  /** The Cost line Items on the invoice */
  costLineItems?: Maybe<Array<InvoiceLineItemAttributes>>;
  /** The ID of the country of origin for the shipment */
  countryOfOriginId?: Maybe<Scalars['Int']>;
  /** The currency of the invoice line item. */
  currency?: Maybe<CurrencyEnum>;
  /** The destination associated with the Invoice */
  destination?: Maybe<Scalars['String']>;
  /** The type of document (e.g., invoice, credit note) */
  documentType: Scalars['String'];
  /** The number of days within which final payment is needed from agreed upon event */
  finalCreditTerm: Scalars['Int'];
  /** The final amount to be payed on the invoice */
  finalPayment?: Maybe<Scalars['BigDecimal']>;
  /** The flight's date */
  flightDate?: Maybe<Scalars['ISO8601Date']>;
  /** The ID of the invoice */
  id?: Maybe<Scalars['ID']>;
  /** The Incoterm associated with the shipment */
  incoterm?: Maybe<IncotermEnum>;
  /** The custom fields associated with the invoice */
  invoiceCustomFields?: Maybe<Array<InvoiceCustomFieldAttributes>>;
  /** The date associated to the invoice */
  invoiceDate?: Maybe<Scalars['ISO8601Date']>;
  /** The pallets associated with the invoice */
  invoiceLineItems?: Maybe<Array<InvoiceLineItemAttributes>>;
  /** The invoice number */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** The loading point */
  loadingPointId?: Maybe<Scalars['Int']>;
  /** The offloading point */
  offloadingPointId?: Maybe<Scalars['Int']>;
  /** The parent invoice that this invoice is linked to */
  parentInvoiceId?: Maybe<Scalars['Int']>;
  /** The purchase order number associated with the shipment */
  poNumber?: Maybe<Scalars['String']>;
  /** The ID of the port of destination for the shipment */
  portOfDestinationId?: Maybe<Scalars['Int']>;
  /** The ID of the port of loading for the shipment */
  portOfLoadingId?: Maybe<Scalars['Int']>;
  /** The flights routing */
  routing?: Maybe<Scalars['String']>;
  /** The sale type */
  saleType?: Maybe<Scalars['String']>;
  /** The Shipper's name */
  shipper?: Maybe<Scalars['String']>;
  /** The state of the invoice */
  state?: Maybe<InvoiceStateEnum>;
  /** Where the container was loaded */
  stuffLocationId?: Maybe<Scalars['Int']>;
  /** The sub total on the invoice */
  subTotal?: Maybe<Scalars['Float']>;
  /** The Total Incoterm of the invoice */
  totalIncoterm?: Maybe<Scalars['BigDecimal']>;
  /** The type of transportation for the shipment (e.g., container, break bulk) */
  transportType?: Maybe<Scalars['String']>;
  /** The Unique Consignment Reference (UCR) number associated with the shipment */
  ucrNumber?: Maybe<Scalars['String']>;
  /** The Total VAT payable on the invoice */
  vat?: Maybe<Scalars['Float']>;
  /** The associated VAT Type on the invoice */
  vatTypeId?: Maybe<Scalars['ID']>;
  /** The vehicle number */
  vehicleNumber?: Maybe<Scalars['String']>;
  /** The vessel details associated with the shipment */
  vessel?: Maybe<VesselAttributes>;
  /** The voyage or trip number associated with the shipment */
  voyage?: Maybe<Scalars['String']>;
  /** The commercial term associated with the invoice */
  commercialTermId?: Maybe<Scalars['Int']>;
  /** The final due date of the invoice */
  dueDateFinal?: Maybe<Scalars['ISO8601Date']>;
};

/** The connection type for Invoice. */
export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Invoice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type InvoiceCustomField = {
  __typename?: 'InvoiceCustomField';
  /** whether the underlying custom field is soft-deleted */
  customFieldDeleted: Scalars['Boolean'];
  /** Unique custom field identifier */
  customFieldId?: Maybe<Scalars['Int']>;
  /** The default value of the custom field */
  defaultValue?: Maybe<Scalars['String']>;
  /** Unique invoice identifier */
  invoiceId?: Maybe<Scalars['Int']>;
  /** Whether the custom field should appear by default */
  isDefault?: Maybe<Scalars['Boolean']>;
  /** The name of the custom field */
  name?: Maybe<Scalars['String']>;
  /** Whether the custom field is required */
  required?: Maybe<Scalars['Boolean']>;
  /** The value of the custom field */
  value?: Maybe<Scalars['String']>;
};

export type InvoiceCustomFieldAttributes = {
  /** The id of the invoice */
  invoiceId?: Maybe<Scalars['Int']>;
  /** The id of the custom field */
  customFieldId?: Maybe<Scalars['Int']>;
  /** The custom field value */
  value?: Maybe<Scalars['String']>;
};

export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  name: Scalars['String'];
  type: Scalars['String'];
};

/** The different types of invoice documents available. */
export enum InvoiceDocumentTypeEnum {
  CommercialInvoice = 'commercial_invoice',
  TaxInvoice = 'tax_invoice',
  AdvanceInvoice = 'advance_invoice',
  CreditNote = 'credit_note',
  DebitNote = 'debit_note',
  VendorInvoice = 'vendor_invoice',
  AccountStatement = 'AccountStatement',
  AccountSale = 'account_sale'
}

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>;
};

export type InvoiceFilterAttribute = {
  __typename?: 'InvoiceFilterAttribute';
  /** commodities found on this user's CIs */
  commodities?: Maybe<Array<Commodity>>;
  /** Contacts for this invoice */
  contacts?: Maybe<Array<Contact>>;
  /** Containers of this user's Invoices */
  containers?: Maybe<Array<Scalars['String']>>;
  /** Cost codes of this user's Invoices */
  costCodes?: Maybe<Array<Scalars['String']>>;
  /** Types of invoices - commercial / tax / credit_note / debit_note */
  documentTypes: Array<InvoiceDocument>;
  /** Export status options for filtering invoices */
  exportStatuses?: Maybe<Array<InvoiceAccountingExportFilterEnum>>;
  /** Available financial year options for the FY filter dropdown */
  financialYearOptions?: Maybe<Array<FinancialYearOption>>;
  /** Incoterms associated with this user's CIs */
  incoterms?: Maybe<Array<IncotermEnum>>;
  /** Invoice number for the invoice */
  invoiceNumbers?: Maybe<Array<Scalars['String']>>;
  /** Pallet numbers of this user's Invoices */
  palletNumbers?: Maybe<Array<Scalars['String']>>;
  /** The states of a document e.g. draft, finalised, ... */
  states?: Maybe<Array<Scalars['String']>>;
  /** Target countries associated with this user's CIs */
  targetCountries: Array<Scalars['String']>;
  /** Transport Types of this user's CIs */
  transportTypes?: Maybe<Array<Scalars['String']>>;
  /** varieties found on this user's CIs */
  varieties?: Maybe<Array<Variety>>;
  /** Vessels associated with this user's CIs */
  vessels?: Maybe<Array<Vessel>>;
};

export type InvoiceIncotermAttributes = {
  /** The id of the invoice */
  invoiceId: Scalars['Int'];
  /** The currency to calculate the incoterm for */
  currency: CurrencyEnum;
  /** The incoterm to calculate for */
  incoterm: IncotermEnum;
  /** The freight cost to use */
  freightCost?: Maybe<Scalars['Float']>;
  /** The insurance cost to use */
  insuranceCost?: Maybe<Scalars['Float']>;
  /** The local costs to use */
  localCosts?: Maybe<Scalars['Float']>;
  /** The total advance payment for this invoice */
  advancePayment?: Maybe<Scalars['BigDecimal']>;
  /** The total final payment for this invoice */
  finalPayment?: Maybe<Scalars['BigDecimal']>;
  /** The number of days within which advance payment is needed from agreed upon event */
  advanceCreditTerm?: Maybe<Scalars['Int']>;
  /** The number of days within which final payment is needed from agreed upon event */
  finalCreditTerm?: Maybe<Scalars['Int']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  /** Total Amount on the Invoice Line Item */
  amount?: Maybe<Scalars['Float']>;
  /** The carton grouping associated with this invoice line item */
  cartonGrouping?: Maybe<CartonGrouping>;
  /** Carton Grouping Transactions associated with the Invoice LI */
  cartonGroupingTransactions?: Maybe<Array<CartonGroupingTransaction>>;
  /** The updated number of cartons in the carton grouping */
  cartons?: Maybe<Scalars['Int']>;
  /** Cost Code Associated with the InvoiceLineItem */
  costCode?: Maybe<CostCode>;
  /** The updated currency of the carton grouping */
  currency?: Maybe<CurrencyEnum>;
  /** The kind of document e.g. invoice, tax invoice, ... */
  documentType?: Maybe<Scalars['String']>;
  /** Grouped Grade Field */
  grade?: Maybe<Scalars['String']>;
  /** ID of the invoice line item */
  id?: Maybe<Scalars['ID']>;
  /** Parent CI identifier */
  invoiceId?: Maybe<Scalars['ID']>;
  /** Grouped Mark Field */
  mark?: Maybe<Scalars['String']>;
  /** The updated net mass of the carton grouping */
  netMass?: Maybe<Scalars['Float']>;
  /** Grouped Pack Field */
  pack?: Maybe<Scalars['String']>;
  /** The number of pallets in this invoice line item */
  palletCount?: Maybe<Scalars['Float']>;
  /** The updated gross mass of the carton grouping */
  palletGrossMass?: Maybe<Scalars['Float']>;
  /** The updated price of the carton grouping */
  price?: Maybe<Scalars['String']>;
  /** Total Amount on the Invoice Line Item */
  priceMinorUnit?: Maybe<Scalars['Float']>;
  /** The updated price unit of the carton grouping (carton/ton) */
  priceUnit?: Maybe<Scalars['String']>;
  /** Amount of the Price Unit on the Invoice Line Item */
  quantityAmount?: Maybe<Scalars['Float']>;
  /** Grouped Size Count Field */
  sizeCount?: Maybe<Scalars['String']>;
  /** The target market of the invoice line item */
  targetMarket?: Maybe<Scalars['String']>;
  /** The total price minor unit of the invoice line item. */
  totalPriceMinorUnit?: Maybe<Scalars['String']>;
  /** Grouped Variety Field */
  variety?: Maybe<Variety>;
  /** The VAT Type associated with the invoice line item */
  vatType?: Maybe<VatType>;
};

export type InvoiceLineItemAttributes = {
  /** Total Amount on the Invoice Line Item. */
  amount?: Maybe<Scalars['Float']>;
  /** The ID of the associated carton grouping. */
  cartonGroupingId?: Maybe<Scalars['Int']>;
  /** Carton Grouping Transactions associated with this invoice line item */
  cartonGroupingTransactions?: Maybe<Array<CartonGroupingTransactionAttributes>>;
  /** The number of cartons in the invoice line item. */
  cartons?: Maybe<Scalars['Int']>;
  /** The currency of the invoice line item. */
  currency?: Maybe<CurrencyEnum>;
  /** The document type of the invoice line item. */
  documentType?: Maybe<Scalars['String']>;
  /** Grade of the item on this invoice line item. */
  grade?: Maybe<Scalars['String']>;
  /** ID of the invoice line item */
  id?: Maybe<Scalars['Int']>;
  /** Mark of the item on this invoice line item. */
  mark?: Maybe<Scalars['String']>;
  /** The net mass of the invoice line item. */
  netMass?: Maybe<Scalars['Float']>;
  /** Pack type of the item on this invoice line item. */
  pack?: Maybe<Scalars['String']>;
  /** The gross mass of the pallet in the invoice line item. */
  palletGrossMass?: Maybe<Scalars['Float']>;
  /** The price of the invoice line item in minor units. */
  priceMinorUnit?: Maybe<Scalars['String']>;
  /** The unit of the price (e.g., carton or ton). */
  priceUnit?: Maybe<PriceUnitEnum>;
  /** Amount of the Price Unit on the Invoice Line Item. */
  quantityAmount?: Maybe<Scalars['Float']>;
  /** Size count of the item on this invoice line item . */
  sizeCount?: Maybe<Scalars['String']>;
  /** Target market of the item on this invoice line item . */
  targetMarket?: Maybe<Scalars['String']>;
  /** The Variety associated with the invoice line item . */
  variety?: Maybe<VarietyAttributes>;
  /** The Vat Type associated with the invoice line item . */
  vatType?: Maybe<VatTypeAttributes>;
  /** The Cost Code associated with the invoice line item . */
  costCodeId?: Maybe<Scalars['Int']>;
};

/** Fields available on an invoice payment */
export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  /** Amount of money allocated to the invoice in major unit */
  amountMajorUnit: Scalars['Float'];
  /** Date and time the payment allocation was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique invoice payment identifier */
  id: Scalars['ID'];
  /** The invoice linked to the payment */
  invoice: Invoice;
  /** The invoice linked to the payment */
  invoiceId: Scalars['String'];
  /** The payment linked to the invoice */
  payment: Payment;
  /** The payment linked to the invoice */
  paymentId: Scalars['String'];
  /** Date and time the payment allocation was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Fields available on an invoice payment allocation */
export type InvoicePaymentAllocation = {
  __typename?: 'InvoicePaymentAllocation';
  /** The invoice linked to the payment */
  invoiceId: Scalars['ID'];
  /** Total amount of money allocated to the invoice in major unit */
  totalAmountMajorUnit: Scalars['Float'];
};

/** The different states available for invoices. */
export enum InvoiceStateEnum {
  /** The invoice state type draft */
  Draft = 'draft',
  /** The invoice state type finalised */
  Finalised = 'finalised',
  /** The invoice state type awaiting_payment */
  AwaitingPayment = 'awaiting_payment',
  /** The invoice state type partially_paid */
  PartiallyPaid = 'partially_paid',
  /** The invoice state type paid */
  Paid = 'paid',
  /** The invoice state type overpaid */
  Overpaid = 'overpaid',
  /** The invoice state type closed */
  Closed = 'closed',
  /** The invoice state type overdue */
  Overdue = 'overdue',
  /** The invoice state type voided */
  Voided = 'voided',
  /** The invoice state type to_be_invoiced */
  ToBeInvoiced = 'to_be_invoiced',
  /** The invoice state type invoiced */
  Invoiced = 'invoiced',
  /** The invoice state type archived */
  Archived = 'archived',
  /** The invoice state type building */
  Building = 'building'
}

export type InvoicesFilters = {
  /** List of commodity IDs to filter by. */
  commodityIds?: Maybe<Array<Scalars['Int']>>;
  /** List of contact IDs to filter by. */
  contactIds?: Maybe<Array<Scalars['Int']>>;
  /** List of currencies to filter by. */
  currencies?: Maybe<Array<Scalars['String']>>;
  /** List of document types to filter by. */
  documentTypes?: Maybe<Array<Scalars['String']>>;
  /** Filter invoices with invoice_date on or after this date (inclusive). */
  fromDate?: Maybe<Scalars['ISO8601Date']>;
  /** Filter invoices with invoice_date on or before this date (inclusive). */
  toDate?: Maybe<Scalars['ISO8601Date']>;
  /** List of Incoterms to filter by. */
  incoterms?: Maybe<Array<IncotermEnum>>;
  /** List of invoice numbers to filter by. */
  invoiceNumbers?: Maybe<Array<Scalars['String']>>;
  /** List of states to filter by. */
  states?: Maybe<Array<Scalars['String']>>;
  /** List of target countries to filter by. */
  targetCountries?: Maybe<Array<Scalars['String']>>;
  /** List of transport types to filter by. */
  transportTypes?: Maybe<Array<Scalars['String']>>;
  /** List of variety IDs to filter by. */
  varietyIds?: Maybe<Array<Scalars['Int']>>;
  /** List of vessel IDs to filter by. */
  vesselIds?: Maybe<Array<Scalars['Int']>>;
  /** Filter by accounting export presence; omit for all invoices. */
  accountingExportFilter?: Maybe<InvoiceAccountingExportFilterEnum>;
  /** only fetch unallocated or partially allocated invoices */
  unallocatedOrPartiallyAllocated?: Maybe<Scalars['Boolean']>;
  /** filter by incoming or outgoing payment type */
  paymentTypes?: Maybe<Scalars['String']>;
  /** List of container numbers to filter by. */
  containers?: Maybe<Array<Scalars['String']>>;
  /** List of pallet numbers to filter by. */
  palletNumbers?: Maybe<Array<Scalars['String']>>;
  /** List of cost codes to filter by. */
  costCodes?: Maybe<Array<Scalars['String']>>;
  /** only show invoices created after this date (inclusive) */
  createdAtDateStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** only show invoices created before this date (inclusive) */
  createdAtDateEnd?: Maybe<Scalars['ISO8601DateTime']>;
  /** Financial year to filter by. The year the FY ends in (end-year convention, e.g. 2025 = Mar 2024 - Feb 2025 on a Mar-Feb company). Uses company FY config to resolve the date range. */
  financialYear?: Maybe<Scalars['Int']>;
};



/** A line item contains the fruit specification, quantity and payment details of the product being ordered */
export type LineItem = {
  __typename?: 'LineItem';
  /** A list of extra fields that are not part of the standard fields, set by the user */
  additionalFields?: Maybe<Scalars['Json']>;
  /** The audit trail of the line item showing changes made to the line item */
  audits?: Maybe<Array<Audit>>;
  /** Unique number for a collection of line items with similar/ same specifications, user set */
  batchNumber?: Maybe<Scalars['String']>;
  /** The buyer of the line item */
  buyer?: Maybe<Company>;
  /** The carton groupings of the line item */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** Comments on the line item provided by the user */
  comments?: Maybe<Array<Comment>>;
  /** The commodity of the fruit being ordered */
  commodity?: Maybe<Commodity>;
  /** The commodity of the fruit being ordered */
  commodityId?: Maybe<Scalars['Int']>;
  /** The container that the line item is in */
  containerId?: Maybe<Scalars['Int']>;
  /** When the line item was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The cumulative quantity of the line item grouping */
  cumulativeQuantity?: Maybe<Scalars['Int']>;
  /**
   * The currency of the line item
   * @deprecated use MoneyType `price` instead
   */
  currency?: Maybe<Scalars['String']>;
  /** Deal sheet fields when this line item is part of a deal sheet */
  dealSheetLineItemDetail?: Maybe<YieldDealSheetLineItemDetail>;
  /** Whether the line item has been soft deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The departure port of the line item */
  departurePort?: Maybe<SeaPort>;
  /** The departure port of the line item */
  departurePortId?: Maybe<Scalars['Int']>;
  /** The name of the departure port of the line item */
  departurePortName?: Maybe<Scalars['String']>;
  /** The destination port of the line item */
  destinationPort?: Maybe<SeaPort>;
  /** The destination port of the line item */
  destinationPortId?: Maybe<Scalars['Int']>;
  /** The name of the destination port of the line item */
  destinationPortName?: Maybe<Scalars['String']>;
  /** Indicates the final week of a packhouse run, a system where all available fruit is packed for a given week range */
  endWeek?: Maybe<Scalars['String']>;
  /** Net return summary using input args OR defaults 'ZAR', 'RAW CARTON', 'EXW' */
  expectedReturnSummary?: Maybe<ExpectedReturnSummary>;
  /** The classification of the fruit, eg. A, B inidicating quality */
  grade?: Maybe<Scalars['String']>;
  /** The unique identifier for the line item */
  id?: Maybe<Scalars['Int']>;
  /** An international commercial term, used to define ownership and responsibility for the goods */
  incoterm?: Maybe<Scalars['String']>;
  /** The inventory code of the fruit, eg. 1234567890 */
  inventoryCode?: Maybe<Scalars['String']>;
  /** The unique identifier for the line item grouping that contains the line item */
  lineItemGroupingId?: Maybe<Scalars['Int']>;
  /** food and safety indicator to indicate compliance with safety standards */
  mark?: Maybe<Scalars['String']>;
  /** The new seller of the line item */
  newSellerId?: Maybe<Scalars['Int']>;
  /** The unique identifier for the order that the line item belongs to */
  orderId?: Maybe<Scalars['Int']>;
  /** The box that the fruit is packed in, eg. A15C. This denotes size and type of box */
  pack?: Maybe<Scalars['String']>;
  /** The actual quantity of cartons that have been packed thus far for this line item */
  packedCartons?: Maybe<Scalars['Int']>;
  /** The actual quantity of pallets that have been packed thus far for this line item */
  packedPallets?: Maybe<Scalars['Float']>;
  /** When not doing a packhouse run, this is the week that the fruit is packed */
  packingWeek?: Maybe<Scalars['String']>;
  /** The number of boxes that can be stacked on a pallet eg. 80 */
  palletStack?: Maybe<Scalars['Int']>;
  /** The quantity of the fruit that is planned to be packed by the producer. This quantity can takes precedence over the quantity field */
  plannedQuantity?: Maybe<Scalars['Int']>;
  /** The unit of the planned quantity, eg. cartons */
  plannedQuantityUnit?: Maybe<Scalars['String']>;
  /** The price of the fruit per unit */
  price?: Maybe<Money>;
  /**
   * The price of the fruit per unit in minor units i.e cents to avoid floating point precision issues
   * @deprecated use MoneyType `price` instead
   */
  priceMinorUnit?: Maybe<Scalars['Int']>;
  /** A financial agreement between parties, eg. Fixed, MPG or Consignment */
  priceTerm?: Maybe<Scalars['String']>;
  /** The unit of the price, eg. cartons */
  priceUnit?: Maybe<Scalars['String']>;
  /** An indicator of urgency/ preference of the line item */
  priority?: Maybe<Scalars['Int']>;
  /** The amound of fruit per unit requested by the buyer, can be overridden by the planned quantity */
  quantity?: Maybe<Scalars['Int']>;
  /** The unit of the quantity, eg. cartons */
  quantityUnit?: Maybe<Scalars['String']>;
  /** The order in which the line item appears in the order */
  rank?: Maybe<Scalars['Int']>;
  /** A unique identifier for the line item, set by the user */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Whether the line item has been selected */
  selected?: Maybe<Scalars['Boolean']>;
  /** The seller of the line item */
  seller?: Maybe<Company>;
  /** The seller of the line item */
  sellerId?: Maybe<Scalars['Int']>;
  /** The size of the fruit, determined by the number of items that can fit in the box, eg. 32 implies 32 items per box. Lower number implies bigger items */
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  /** The first week of a packhouse run, a system where all available fruit is packed for a given week range */
  startWeek?: Maybe<Scalars['String']>;
  /** The current state of the line item, eg. new, packed, accepted, etc. */
  state?: Maybe<Scalars['String']>;
  /** The state of the line item */
  stateUpdate?: Maybe<Array<Scalars['String']>>;
  /** The distribution of the line item states and quantities */
  statesDistribution?: Maybe<Array<LineItemState>>;
  /** The country code of the country that the fruit is being shipped to */
  targetCountry?: Maybe<Scalars['String']>;
  /** The market that the fruit is being shipped to */
  targetMarket?: Maybe<Scalars['String']>;
  /** The region code that the fruit is being shipped to eg. AFR (Africa), ASA (Asia), etc. linked to countries */
  targetRegion?: Maybe<Scalars['String']>;
  /** During a packhouse run, the quantity is not specified. Producers want to move all available fruit */
  unlimited?: Maybe<Scalars['Boolean']>;
  /** When the line item was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The variety of the fruit being ordered */
  variety?: Maybe<Variety>;
  /** The variety of the fruit being ordered */
  varietyId?: Maybe<Scalars['Int']>;
};


/** A line item contains the fruit specification, quantity and payment details of the product being ordered */
export type LineItemExpectedReturnSummaryArgs = {
  currency?: Maybe<CurrencyEnum>;
  incoterm?: Maybe<IncotermWithNscEnum>;
  unit?: Maybe<Scalars['String']>;
};

/** The connection type for LineItem. */
export type LineItemConnection = {
  __typename?: 'LineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LineItemEdge = {
  __typename?: 'LineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LineItem>;
};

/** Attributes to filter line items by */
export type LineItemFilterAttribute = {
  __typename?: 'LineItemFilterAttribute';
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** sellers you want to filter by */
  sellers?: Maybe<Array<Company>>;
  /** varieties you want to filter by */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes to filter line items by */
export type LineItemFilterAttributes = {
  /** currencies you want to filter by */
  currencies?: Maybe<Array<Scalars['String']>>;
  /** incoterms you want to filter by */
  incoterms?: Maybe<Array<IncotermEnum>>;
  /** buyers you want to filter by */
  buyerIds?: Maybe<Array<Scalars['ID']>>;
  /** sellers you want to filter by */
  sellerIds?: Maybe<Array<Scalars['ID']>>;
  /** states you want to filter by */
  states?: Maybe<Array<OrderStateEnum>>;
  /** commodities you want to filter by */
  commodityIds?: Maybe<Array<Scalars['ID']>>;
  /** varieties you want to filter by */
  varietyIds?: Maybe<Array<Scalars['ID']>>;
  /** start of packing week you want to filter by */
  packingWeekStart?: Maybe<Scalars['String']>;
  /** end of packing week you want to filter by */
  packingWeekEnd?: Maybe<Scalars['String']>;
  /** additional fields to filter by, keyed by field name with array of values */
  additionalFields?: Maybe<Scalars['Json']>;
};

export type LineItemGrouping = {
  __typename?: 'LineItemGrouping';
  /** List of fields that line items in this group have the same value for. */
  commonFields?: Maybe<Array<Scalars['String']>>;
  /** The date and time when the line item grouping was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The total cumulative number of units requested on this line item group (optional). */
  cumulativeQuantity?: Maybe<Scalars['Int']>;
  /** Descriptive information about the cumulative quantity for this line item. */
  cumulativeTooltip?: Maybe<Scalars['String']>;
  /** Indicates whether the line item grouping is marked as deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The unique identifier of the line item grouping. */
  id?: Maybe<Scalars['Int']>;
  /** List of line items belonging to this grouping. */
  lineItems?: Maybe<Array<LineItem>>;
  /** Total number of line items within the same grouping. */
  numberCumulativeSiblings?: Maybe<Scalars['Int']>;
  /** The unique identifier of the order associated with this line item grouping. */
  orderId?: Maybe<Scalars['Int']>;
  /** The unit of measurement for the cumulative quantity, such as cartons, pallets, or containers. */
  quantityType?: Maybe<Scalars['String']>;
  /** The rank or order of this line item grouping among others. */
  rank?: Maybe<Scalars['Int']>;
  /** The date and time when the line item grouping was last updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type LineItemGroupingLineItemsArgs = {
  commodityIds?: Maybe<Array<Scalars['Int']>>;
  lineItemStates?: Maybe<Array<Scalars['String']>>;
  packingWeekEnd?: Maybe<Scalars['String']>;
  packingWeekStart?: Maybe<Scalars['String']>;
  subCommodityIds?: Maybe<Array<Scalars['Int']>>;
  varietyIds?: Maybe<Array<Scalars['Int']>>;
  states?: Maybe<Array<StateFilter>>;
};

export type LineItemState = {
  __typename?: 'LineItemState';
  /** The number of items in this state */
  palletQuantity?: Maybe<Scalars['Int']>;
  /** Total number of items expected */
  palletQuantityTotal?: Maybe<Scalars['Int']>;
  /** The number of items in this state */
  quanity?: Maybe<Scalars['Int']>;
  /** Total number of items expected */
  quanityTotal?: Maybe<Scalars['Int']>;
  quanityType?: Maybe<Quantity>;
  /** The number of items in this state */
  quantity?: Maybe<Scalars['Int']>;
  /** Total number of items expected */
  quantityTotal?: Maybe<Scalars['Int']>;
  /** The name of this state type */
  state?: Maybe<Scalars['String']>;
  /** The index of its order in the supply chain, 0 = first */
  supplyChainOrder?: Maybe<Scalars['Int']>;
};

/** Represents a linked entity (either ReportGroup or Report) with its ID */
export type LinkedItem = {
  __typename?: 'LinkedItem';
  /** The ID of the linked entity (either ReportGroup or Report) */
  linkedId?: Maybe<Scalars['Int']>;
  /** Specifies the type of the linked entity (either ReportGroup or Report) */
  linkedType?: Maybe<LinkedTypeEnum>;
};

/** Specifies the linked_type, either ReportGroup or Report */
export enum LinkedTypeEnum {
  /** Represents a ReportGroup */
  ReportGroup = 'REPORT_GROUP',
  /** Represents a Report */
  Report = 'REPORT'
}

export type LoadOutAttributes = {
  /** Reference of booked container */
  bookingReference?: Maybe<Scalars['String']>;
  /** CGs associated with the LOI */
  cartonGroupingIds?: Maybe<Array<Scalars['Int']>>;
  /** LOI Pallet attributes to override CG values */
  loadOutInstructionPalletsAttributes?: Maybe<Array<LoadOutInstructionPalletAttributes>>;
  /** Contacts associated with the LOI */
  contactIds?: Maybe<Array<Scalars['Int']>>;
  /** Container unique identification number */
  containerNumber?: Maybe<Scalars['String']>;
  /** When the shipment is expected to be delivered */
  estimatedTimeOfDelivery?: Maybe<Scalars['ISO8601DateTime']>;
  /** Company exporting the goods */
  exporterId?: Maybe<Scalars['Int']>;
  /** Unique reference for exporting company */
  exportersReference?: Maybe<Scalars['String']>;
  /** Unique idetification number associated with the LOI */
  id?: Maybe<Scalars['Int']>;
  /** Unique LOI reference number */
  loadOutReference?: Maybe<Scalars['String']>;
  /** Additional information or special instructions for the LOI */
  notes?: Maybe<Scalars['String']>;
  /** Where the shipment is going */
  portOfDestinationId?: Maybe<Scalars['Int']>;
  /** Where the ship was loaded */
  portOfLoadingId?: Maybe<Scalars['Int']>;
  /** When the LOI was created */
  printedDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Storage configuration requirements */
  q67Reference?: Maybe<Scalars['String']>;
  /** Shipping company transporting the goods */
  shippingLine?: Maybe<Scalars['String']>;
  /** When the container was loaded */
  stuffDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Where the container was loaded */
  stuffLocationId?: Maybe<Scalars['Int']>;
  /** Temperature configuration */
  temperatureSetting?: Maybe<Scalars['String']>;
  /** The id of the vessel shipping the goods */
  vesselId?: Maybe<Scalars['Int']>;
  /** The name of the vessel shipping the goods */
  vesselName?: Maybe<Scalars['String']>;
  /** The vessel voyage */
  voyage?: Maybe<Scalars['String']>;
  /** The type of transport */
  transportType?: Maybe<TransportTypeEnum>;
  /** The trucking reference number */
  truckReference?: Maybe<Scalars['String']>;
  /** The loading point */
  loadingPointId?: Maybe<Scalars['Int']>;
  /** The offloading point */
  offloadingPointId?: Maybe<Scalars['Int']>;
  /** The file number associated with the LOI */
  fileNumber?: Maybe<Scalars['String']>;
  /** The air waybill no associated with this LOI */
  airWaybillNo?: Maybe<Scalars['String']>;
  /** The Shippers name */
  shipper?: Maybe<Scalars['String']>;
  /** The destination associated with the LOI */
  destination?: Maybe<Scalars['String']>;
  /** The allocated weight of the goods for the LOI */
  allocatedWeight?: Maybe<Scalars['Float']>;
  /** The flights routing */
  routing?: Maybe<Scalars['String']>;
  /** The flights date */
  flightDate?: Maybe<Scalars['ISO8601Date']>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: Maybe<Scalars['ISO8601Date']>;
  /** Defined equipment used */
  equipment?: Maybe<Scalars['String']>;
  /** The Phyto Certificate identifier */
  phytoCertificate?: Maybe<Scalars['String']>;
  /** Name of who prepared the order */
  orderPreparedBy?: Maybe<Scalars['String']>;
  /** Name of who picked up the order */
  orderPickedBy?: Maybe<Scalars['String']>;
  /** Checked at warehouse information */
  checked?: Maybe<Scalars['String']>;
  /** Air Freight SLI associated with the LOI */
  airFreightShipmentLineItemId?: Maybe<Scalars['ID']>;
  /** Whether the LOI is for transferring stock between FBOs */
  stockTransfer?: Maybe<Scalars['Boolean']>;
  /** Company responsible for transportation */
  transporterCompany?: Maybe<Scalars['String']>;
  /** The date the goods were loaded onto the truck */
  loadDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated date for dispatching the goods */
  estimatedDispatchDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated date for delivery of the goods */
  estimatedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique Reference used to determine the SLI group */
  consignmentReference?: Maybe<Scalars['String']>;
  /** Purchase Order reference number */
  orderReference?: Maybe<Scalars['String']>;
};

export type LoadOutInstruction = {
  __typename?: 'LoadOutInstruction';
  /** Actual time of arrival of the vessel */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']>;
  /** The Air Freight SLI that is associated with this load out information */
  airFreightShipmentLineItem?: Maybe<AirFreightShipmentLineItem>;
  /** The air waybill no associated with this LOI */
  airWaybillNo?: Maybe<Scalars['String']>;
  /** The allocated weight of the goods for the LOI */
  allocatedWeight?: Maybe<Scalars['Float']>;
  /** Numerical value assigned to the reservation of a ship */
  bookingReference?: Maybe<Scalars['String']>;
  /** Whether the LOI is for break bulk (left in for backwards compatibility) */
  breakBulk?: Maybe<Scalars['Boolean']>;
  /** The carton groupings that are associated with this load out information */
  cartonGroupings?: Maybe<Array<CartonGrouping>>;
  /** Checked at warehouse information */
  checked?: Maybe<Scalars['String']>;
  /** Client reference associated with LOI */
  clientReference?: Maybe<Scalars['String']>;
  /** Company associated with LOI */
  company?: Maybe<Company>;
  /** The connecting flight date if applicable */
  connectingFlightDate?: Maybe<Scalars['ISO8601Date']>;
  /** Unique Reference used to determine the SLI group */
  consignmentReference?: Maybe<Scalars['String']>;
  /** Contacts associated with LOI */
  contacts?: Maybe<Array<Contact>>;
  /** Unique identifier of a container */
  containerNumber?: Maybe<Scalars['String']>;
  /** The date and time at which the LOI was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The destination associated with the LOI */
  destination?: Maybe<Scalars['String']>;
  /** Additional dispatch details for trucking */
  dispatchDetails?: Maybe<Scalars['JSON']>;
  /** Defined equipment used */
  equipment?: Maybe<Scalars['String']>;
  /** Estimated date for delivery of the goods */
  estimatedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated date for dispatching the goods */
  estimatedDispatchDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimate of when goods are to be delivered */
  estimatedTimeOfDelivery?: Maybe<Scalars['ISO8601DateTime']>;
  /** Exporter associated with LOI */
  exporter?: Maybe<Company>;
  /** Name of the exporter associated with LOI */
  exporterName?: Maybe<Scalars['String']>;
  /** Unique identifier for exporters */
  exportersReference?: Maybe<Scalars['String']>;
  /** The file number associated with the LOI */
  fileNumber?: Maybe<Scalars['String']>;
  /** The flights date */
  flightDate?: Maybe<Scalars['ISO8601Date']>;
  /** Unique LOI identifier */
  id?: Maybe<Scalars['ID']>;
  /** The date the goods were loaded onto the truck */
  loadDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** A reference assigned to the LOI */
  loadOutReference?: Maybe<Scalars['String']>;
  /** The FBO where the goods are loaded */
  loadingPoint?: Maybe<FoodBusinessOperator>;
  /** The flattend carton groupings that are associated with this load out information */
  loiCartonGroupings?: Maybe<Array<LoiCartonGrouping>>;
  /** Additional information about a LOI */
  notes?: Maybe<Scalars['String']>;
  /** The FBO where the goods are unloaded */
  offloadingPoint?: Maybe<FoodBusinessOperator>;
  /** Name of who picked up the order */
  orderPickedBy?: Maybe<Scalars['String']>;
  /** Name of who prepared the order */
  orderPreparedBy?: Maybe<Scalars['String']>;
  /** Purchase Order reference number */
  orderReference?: Maybe<Scalars['String']>;
  /** The number of pallets assigned to the LOI */
  palletCount?: Maybe<Scalars['String']>;
  /** Pallet in linked to load out instruction */
  palletIn?: Maybe<PalletIn>;
  /** Whether user has PhytClean enabled */
  phytcleanEnabled?: Maybe<Scalars['Boolean']>;
  /** Phytclean result for loi */
  phytcleanResult?: Maybe<Result>;
  /** The Phyto Certificate identifier */
  phytoCertificate?: Maybe<Scalars['String']>;
  /** Where shipment is going */
  portOfDestination?: Maybe<SeaPort>;
  /** Name of the destination port */
  portOfDestinationName?: Maybe<Scalars['String']>;
  /** Where shipment was loaded onto a vessel */
  portOfLoading?: Maybe<SeaPort>;
  /** Name of the loading port */
  portOfLoadingName?: Maybe<Scalars['String']>;
  /** Date of LOI sticker */
  printedDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Q67 stipulates the temperature settings and other protocols that must be followed */
  q67Reference?: Maybe<Scalars['String']>;
  /** The flights routing */
  routing?: Maybe<Scalars['String']>;
  /** Emails in which this document was included */
  sentEmailList?: Maybe<Array<SentEmail>>;
  /** Shipment Line Item associated with the LOI */
  shipmentLineItem?: Maybe<ShipmentLineItem>;
  /** The Shippers name */
  shipper?: Maybe<Scalars['String']>;
  /** Company that operates the ships that transport the goods */
  shippingLine?: Maybe<Scalars['String']>;
  /** Source system that created the LOI (e.g. yield) */
  source?: Maybe<Scalars['String']>;
  /** The stack dates of the shipment associated with the associated shipment line item */
  stackDates?: Maybe<Scalars['ISO8601DateTime']>;
  /** The stack dates close of the shipment associated with the associated shipment line item */
  stackDatesClose?: Maybe<Scalars['ISO8601DateTime']>;
  /** Whether the LOI is for transferring stock between FBOs */
  stockTransfer?: Maybe<Scalars['Boolean']>;
  /** Date when shipment was loaded */
  stuffDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** FBO Associated with this LOI */
  stuffLocation?: Maybe<FoodBusinessOperator>;
  /** Temperature instructions */
  temperatureSetting?: Maybe<Scalars['String']>;
  /** Object containing information on the document generated for this load out information */
  templateOutput?: Maybe<TemplateOutput>;
  /** The type of transport used to transport the goods */
  transportType?: Maybe<TransportTypeEnum>;
  /** Company responsible for transportation */
  transporterCompany?: Maybe<Scalars['String']>;
  /** The truck reference that is associated with this LOI */
  truckReference?: Maybe<Scalars['String']>;
  /** The time at which the LOI was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Vessel associated with LOI */
  vessel?: Maybe<Vessel>;
  /** Vessel name associated with LOI */
  vesselName?: Maybe<Scalars['String']>;
  /** Vessel name directly from the record */
  vesselNameDirect?: Maybe<Scalars['String']>;
  /** Voyage that the associated vessel is taking */
  voyage?: Maybe<Scalars['String']>;
};


export type LoadOutInstructionSentEmailListArgs = {
  direction?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};

/** The connection type for LoadOutInstruction. */
export type LoadOutInstructionConnection = {
  __typename?: 'LoadOutInstructionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoadOutInstructionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LoadOutInstruction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LoadOutInstructionEdge = {
  __typename?: 'LoadOutInstructionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LoadOutInstruction>;
};

export type LoadOutInstructionError = {
  __typename?: 'LoadOutInstructionError';
  /** Attribute with error on */
  attribute: Scalars['String'];
  /** List of carton grouping ids that have failed phytclean inspection */
  cartonGroupingIds?: Maybe<Array<Scalars['ID']>>;
  /** Unique LOI identifier */
  id?: Maybe<Scalars['ID']>;
  /** List of orchard results */
  orchardResults?: Maybe<Array<OrchardResult>>;
  /** List of orchard names with errors */
  orchards?: Maybe<Array<Scalars['String']>>;
  /** Type of error present on attribute */
  type: Scalars['String'];
};

export type LoadOutInstructionFilterAttribute = {
  __typename?: 'LoadOutInstructionFilterAttribute';
  /** commodities found on this user's LOIs */
  commodities?: Maybe<Array<Commodity>>;
  /** Contacts for this user's LOI */
  contacts?: Maybe<Array<Contact>>;
  /** exporters found on this user's LOIs */
  exporters?: Maybe<Array<Company>>;
  /** List of unique FBOs used as loading points */
  loadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** List of unique FBOs used as offloading points */
  offloadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** varieties found on this user's LOIs */
  varieties?: Maybe<Array<Variety>>;
  /** Vessels associated with this this user's LOIs */
  vessels?: Maybe<Array<Vessel>>;
};

export type LoadOutInstructionPalletAttributes = {
  /** Carton Grouping ID for this pallet */
  cartonGroupingId: Scalars['ID'];
  /** LOI Net mass override for this pallet */
  netMass?: Maybe<Scalars['Float']>;
  /** LOI Gross mass override for this pallet */
  grossMass?: Maybe<Scalars['Float']>;
};

/** Filtering options for load out instructions */
export type LoadOutInstructionsFilters = {
  /** filter by the commodity ids */
  commodityIds?: Maybe<Array<Scalars['ID']>>;
  /** filter by the contact ids */
  contactIds?: Maybe<Array<Scalars['ID']>>;
  /** filter by the exporter ids */
  exporterIds?: Maybe<Array<Scalars['ID']>>;
  /** filter by the date the container started being stuffed */
  stuffDateStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** filter by the date the container finished being stuffed */
  stuffDateEnd?: Maybe<Scalars['ISO8601DateTime']>;
  /** filter by the variety ids */
  varietyIds?: Maybe<Array<Scalars['ID']>>;
  /** filter by the vessel ids */
  vesselIds?: Maybe<Array<Scalars['ID']>>;
  /** only show load out instructions that were loaded at one of the FBOs in this list */
  loadingPointIds?: Maybe<Array<Scalars['ID']>>;
  /** only show load out instructions that were offloaded at one of the FBOs in this list */
  offloadingPointIds?: Maybe<Array<Scalars['ID']>>;
  /** only show load out instructions printed after this date (inclusive) */
  printedDateStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** only show load out instructions printed before this date (inclusive) */
  printedDateEnd?: Maybe<Scalars['ISO8601DateTime']>;
  /** only show load out instructions of a certain transport type */
  transportTypes?: Maybe<Array<Scalars['String']>>;
  /** only show load out instructions created after this date (inclusive) */
  createdAtDateStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** only show load out instructions created before this date (inclusive) */
  createdAtDateEnd?: Maybe<Scalars['ISO8601DateTime']>;
};

export type LoadingPoint = {
  __typename?: 'LoadingPoint';
  /** Code representing the specific activity point for the loading process */
  activityPointCode?: Maybe<Scalars['String']>;
  /** Name of the activity point, fetched by the activity point code */
  activityPointName?: Maybe<Scalars['String']>;
  /** Type of container used for the shipment (e.g. 12M HC INTEGRAL REGULAR) */
  containerType?: Maybe<Scalars['String']>;
  /** Timestamp when the loading point record was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique ID associated with the loading point */
  id: Scalars['Int'];
  /** Flag indicating whether the items at this loading point have been loaded */
  isLoaded?: Maybe<Scalars['Boolean']>;
  /** The quantity of goods that have been loaded at this loading point */
  loadedQuantity?: Maybe<Scalars['Int']>;
  /** Date and time of loading */
  loadingDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the PPECB activity point related to the loading point */
  ppecbActivityPointId?: Maybe<Scalars['Int']>;
  /** Total quantity of goods to be loaded at this point */
  quantity?: Maybe<Scalars['Int']>;
  /** ID of the related shipment line item being loaded */
  shipmentLineItemId?: Maybe<Scalars['Int']>;
  /** Unit of measurement for the loaded quantity (e.g. CONTAINER, CARTON, PALLET) */
  unitOfMeasure?: Maybe<Scalars['String']>;
  /** Timestamp for when the loading point record was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type LoadingPointAttributes = {
  /** Code representing the specific activity point for the loading process */
  activityPointCode?: Maybe<Scalars['String']>;
  /** Type of container used for the shipment (e.g. 12M HC INTEGRAL REGULAR) */
  containerType?: Maybe<Scalars['String']>;
  /** Timestamp when the loading point record was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique ID associated with the loading point */
  id?: Maybe<Scalars['Int']>;
  /** Flag indicating if the items at this loading point have been loaded */
  isLoaded?: Maybe<Scalars['Boolean']>;
  /** The quantity of goods that have been loaded at this loading point */
  loadedQuantity?: Maybe<Scalars['Int']>;
  /** Date and time of loading */
  loadingDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the PPECB activity point related to the loading point */
  ppecbActivityPointId?: Maybe<Scalars['Int']>;
  /** Total quantity of goods to be loaded at this point */
  quantity?: Maybe<Scalars['Int']>;
  /** ID of the related shipment line item being loaded */
  shipmentLineItemId?: Maybe<Scalars['Int']>;
  /** Unit of measurement for the loaded quantity (e.g. CONTAINER, CARTON, PALLET) */
  unitOfMeasure?: Maybe<Scalars['String']>;
  /** Timestamp for when the loading point record was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Location = {
  __typename?: 'Location';
  createdAt: Scalars['ISO8601DateTime'];
  id?: Maybe<Scalars['ID']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
  voyage?: Maybe<Voyage>;
};

export type LocationMapping = {
  __typename?: 'LocationMapping';
  /** The ID of the facility */
  facilityId?: Maybe<Scalars['ID']>;
  /** The type of the facility */
  facilityType?: Maybe<Scalars['String']>;
  /** The ID of the location mapping */
  id?: Maybe<Scalars['ID']>;
  /** The location code of the location mapping */
  locationCode?: Maybe<Scalars['String']>;
};

/** Returns the location information of pallets at that location. */
export type LocationMillerFilter = {
  __typename?: 'LocationMillerFilter';
  /** ID of the Location */
  id?: Maybe<Scalars['ID']>;
  /** The location name class as a string */
  locationType?: Maybe<Scalars['String']>;
  /** Location name */
  name?: Maybe<Scalars['String']>;
  /** The total number of pallets at that location */
  totalPallets?: Maybe<Scalars['Int']>;
};

export type LoiCartonGrouping = {
  __typename?: 'LoiCartonGrouping';
  /** The batch number of the carton grouping */
  batchNumber?: Maybe<Scalars['String']>;
  /** Who the carton grouping was sold to */
  buyerName?: Maybe<Scalars['String']>;
  /** The number of cartons in the carton grouping */
  cartons?: Maybe<Scalars['Int']>;
  /** The name of the commodity */
  commodityName?: Maybe<Scalars['String']>;
  /** The consignment number of the carton grouping */
  consignmentNumber?: Maybe<Scalars['String']>;
  /** Whether the carton grouping has been loaded out previously */
  existingLoadOut?: Maybe<Scalars['String']>;
  /** The exporter code of the carton grouping */
  exporterCode?: Maybe<Scalars['String']>;
  /** The farm code of the carton grouping */
  farmCode?: Maybe<Scalars['String']>;
  /** The grade of the carton grouping */
  grade?: Maybe<Scalars['String']>;
  /** The ID of the carton grouping */
  id: Scalars['ID'];
  /** The inventory code of the carton grouping */
  inventoryCode?: Maybe<Scalars['String']>;
  /** Whether the carton grouping can be reassigned */
  isReassignable?: Maybe<Scalars['Boolean']>;
  /** The mark of the carton grouping */
  mark?: Maybe<Scalars['String']>;
  /** The net mass of the carton grouping */
  netMass?: Maybe<Scalars['Float']>;
  /** The orchard of the carton grouping */
  orchard?: Maybe<Scalars['String']>;
  /** The pack of the carton grouping */
  pack?: Maybe<Scalars['String']>;
  /** The packing week of the carton grouping */
  packingWeek?: Maybe<Scalars['String']>;
  /** How old the pallet is */
  palletAge?: Maybe<Scalars['Int']>;
  /** The pallet gross mass of the carton grouping */
  palletGrossMass?: Maybe<Scalars['Float']>;
  /** The pallet number of the carton grouping */
  palletNumber?: Maybe<Scalars['String']>;
  /** Who the carton grouping was sold by */
  sellerName?: Maybe<Scalars['String']>;
  /** Indicator of whether the carton grouping is part of a sequence appearing on the same pallet */
  sequenceNumber?: Maybe<Scalars['String']>;
  /** The size count of the carton grouping */
  sizeCount?: Maybe<Scalars['String']>;
  /** The state of the carton grouping */
  state?: Maybe<Scalars['String']>;
  /** The name of the sub commodity */
  subCommodityName?: Maybe<Scalars['String']>;
  /** The target market of the carton grouping */
  targetMarket?: Maybe<Scalars['String']>;
  /** The target region of the carton grouping */
  targetRegion?: Maybe<Scalars['String']>;
  /** The name of the variety */
  varietyName?: Maybe<Scalars['String']>;
};

export type MapPoint = {
  __typename?: 'MapPoint';
  containers?: Maybe<Array<MapPointContainer>>;
  location?: Maybe<MapPointLocatableUnion>;
  orders?: Maybe<Array<MapPointOrder>>;
  totalCartons?: Maybe<Scalars['Int']>;
};

export type MapPointContainer = {
  __typename?: 'MapPointContainer';
  containerNumber?: Maybe<Scalars['String']>;
  eta?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
  otherPartyName?: Maybe<Scalars['String']>;
  portOfDestination?: Maybe<Scalars['String']>;
  vesselName?: Maybe<Scalars['String']>;
};

export type MapPointLocatableUnion = FoodBusinessOperator | SeaPort | Vessel;

export type MapPointOrder = {
  __typename?: 'MapPointOrder';
  orderId?: Maybe<Scalars['Int']>;
  otherPartyName?: Maybe<Scalars['String']>;
  totalCartons?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of MarkAuditsAsViewedMutation. */
export type MarkAuditsAsViewedMutationPayload = {
  __typename?: 'MarkAuditsAsViewedMutationPayload';
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of MarkContainerClaimAsCompleted. */
export type MarkContainerClaimAsCompletedPayload = {
  __typename?: 'MarkContainerClaimAsCompletedPayload';
  /** The ID of the container claim that was marked as completed */
  containerClaimId?: Maybe<Scalars['ID']>;
  /** Errors that occurred during the mutation */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of MarkNotificationsAsRead. */
export type MarkNotificationsAsReadPayload = {
  __typename?: 'MarkNotificationsAsReadPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']>;
  /** The IDs of the notifications that were marked as read */
  ids?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of MarkNotificationsAsUnread. */
export type MarkNotificationsAsUnreadPayload = {
  __typename?: 'MarkNotificationsAsUnreadPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']>;
  /** The IDs of the notifications that were marked as unread */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type MasterfileConfig = {
  __typename?: 'MasterfileConfig';
  /** The id of the company */
  companyId?: Maybe<Scalars['Int']>;
  /** The timestamp of the creation of the masterfile config */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The id of the masterfile config */
  id?: Maybe<Scalars['ID']>;
  /** The masterfile entity */
  masterfileEntity?: Maybe<MasterfileEntityUnion>;
  /** The id of the masterfile entity */
  masterfileEntityId?: Maybe<Scalars['Int']>;
  /** The type of the masterfile entity */
  masterfileEntityType?: Maybe<MasterfileEntityTypeEnum>;
  /** The state of the masterfile config */
  state?: Maybe<MasterfileConfigStateEnum>;
  /** The timestamp of the last update to the masterfile config */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Input type for masterfile config company associations creation or update */
export type MasterfileConfigCompanyAssociationInput = {
  /** Unique identifier for the masterfile config company association */
  id: Scalars['ID'];
  /** The state of the masterfile config company association */
  state: MasterfileConfigStateEnum;
};

/** Attributes for masterfile config farm variety creation or update */
export type MasterfileConfigFarmVarietyAttributes = {
  /** The ID of the variety to create/ edit */
  varietyId: Scalars['Int'];
  /** ISO week format for packing start (e.g., "2025-W05") */
  packingStartWeek?: Maybe<Scalars['String']>;
  /** ISO week format for packing end (e.g., "2025-W24") */
  packingEndWeek?: Maybe<Scalars['String']>;
};

/** Input type for masterfile config farm variety creation or update */
export type MasterfileConfigFarmVarietyInput = {
  /** Unique identifier for the masterfile config farm variety */
  id?: Maybe<Scalars['ID']>;
  /** The farm variety attributes for creation or update */
  farmVariety?: Maybe<MasterfileConfigFarmVarietyAttributes>;
  /** The state of the masterfile config farm variety */
  state: MasterfileConfigStateEnum;
  /** The commodity ID for creating/updating commodity season */
  commodityId: Scalars['Int'];
  /** ISO week format for commodity season start (e.g., "2025-W05") */
  commoditySeasonStartWeek?: Maybe<Scalars['String']>;
  /** ISO week format for commodity season end (e.g., "2025-W24") */
  commoditySeasonEndWeek?: Maybe<Scalars['String']>;
};

export type MasterfileConfigFboInput = {
  /** The id of the masterfile config fbo */
  id: Scalars['ID'];
  /** The state of the masterfile config fbo */
  state: MasterfileConfigStateEnum;
  /** The latitude of the fbo */
  fboLatitude?: Maybe<Scalars['Float']>;
  /** The longitude of the fbo */
  fboLongitude?: Maybe<Scalars['Float']>;
  /** The address of the fbo */
  address?: Maybe<AddressInput>;
};

/** Attributes to filter masterfile configs by */
export type MasterfileConfigFilterAttributes = {
  /** states you want to filter by (needs_confirmation, confirmed, ignored, missing) */
  states?: Maybe<Array<MasterfileConfigStateEnum>>;
  /** masterfile entity types you want to filter by (FarmVariety, FoodBusinessOperator) */
  masterfileEntityTypes?: Maybe<Array<MasterfileEntityTypeEnum>>;
};

/** Attributes for confirming a masterfile config packhouse connection */
export type MasterfileConfigPackhouseConnectionAttributes = {
  /** The id of the masterfile config packhouse connection */
  id: Scalars['ID'];
  /** The state of the masterfile config packhouse connection */
  state: MasterfileConfigStateEnum;
};

/** The state of a masterfile config */
export enum MasterfileConfigStateEnum {
  /** Masterfile config is needs confirmation */
  NeedsConfirmation = 'needs_confirmation',
  /** Masterfile config is confirmed */
  Confirmed = 'confirmed',
  /** Masterfile config is ignored */
  Ignored = 'ignored',
  /** Masterfile config is missing */
  Missing = 'missing',
  /** Masterfile config is pending review */
  PendingReview = 'pending_review'
}

/** The type of masterfile entity */
export enum MasterfileEntityTypeEnum {
  /** Masterfile config is farm variety */
  FarmVariety = 'farm_variety',
  /** Masterfile config is food business operator */
  FoodBusinessOperator = 'food_business_operator',
  /** Masterfile config is packhouse connection */
  PackhouseConnection = 'packhouse_connection',
  /** Masterfile config is company association */
  CompanyAssociation = 'company_association'
}

/** Union of entities that can be masterfile entities */
export type MasterfileEntityUnion = CompanyAssociation | FarmVariety | FoodBusinessOperator | PackhouseConnection;

/** Union of FarmVariety and ClientChangeRequest */
export type MasterfileFarmVariety = FarmVariety | FarmVarietyRequest;

/** Union of FarmVariety and ClientChangeRequest */
export type MasterfileFoodBusinessOperator = FoodBusinessOperator | FoodBusinessOperatorRequest;

export type MatchCondition = {
  __typename?: 'MatchCondition';
  createdAt: Scalars['ISO8601DateTime'];
  expression?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  matchTypes?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['ISO8601DateTime'];
  values?: Maybe<Array<Scalars['String']>>;
  variables?: Maybe<Array<Scalars['String']>>;
};

export type MatchConditionAttributes = {
  /** The ID of the match condition */
  id?: Maybe<Scalars['ID']>;
  /** The expression to evaluate */
  expression?: Maybe<Scalars['String']>;
};

/** The domain of the report in the value chain (e.g. production, logistics etc.) */
export enum MetabaseDomainEnum {
  GlobalMarket = 'global_market',
  Production = 'production',
  MarketingAndSales = 'marketing_and_sales',
  Logistics = 'logistics',
  Claims = 'claims'
}

export type MetabaseReport = {
  __typename?: 'MetabaseReport';
  /** The badges associated with the report */
  badges?: Maybe<Array<Badge>>;
  /** The chart source of the report */
  chartSource?: Maybe<Scalars['String']>;
  /** The chart type of the report */
  chartType?: Maybe<Scalars['String']>;
  /** The description of the report */
  description?: Maybe<Scalars['String']>;
  /** The name of the report to display in the UI */
  displayName?: Maybe<Scalars['String']>;
  /** The domain of the report in the value chain (e.g. production, logistics etc.) */
  domain?: Maybe<MetabaseDomainEnum>;
  /** The unique identifier of the report */
  id?: Maybe<Scalars['Int']>;
  /** The name of the report */
  name?: Maybe<Scalars['String']>;
  /** Fetches the PowerBI report and returns embedding attributes. */
  powerbiEmbedAttributes?: Maybe<EmbeddedChart>;
  /** The production identifier of the report */
  productionId?: Maybe<Scalars['Int']>;
  /** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
  scope?: Maybe<MetabaseScopeEnum>;
  /** The metabase URL of the report */
  url?: Maybe<Scalars['String']>;
};

export type MetabaseReportFilters = {
  /** The badges to filter on */
  badgeIds?: Maybe<Array<Scalars['Int']>>;
  /** The domains to filter on */
  domains?: Maybe<Array<MetabaseDomainEnum>>;
  /** The scopes to filter on */
  scopes?: Maybe<Array<MetabaseScopeEnum>>;
};

export type MetabaseReportsFilterAttribute = {
  __typename?: 'MetabaseReportsFilterAttribute';
  /** The badges associated with the reports */
  badges?: Maybe<Array<Badge>>;
};

/** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
export enum MetabaseScopeEnum {
  Predictive = 'predictive',
  Operational = 'operational',
  Retrospective = 'retrospective'
}

/** Returns the miller column second level field values. */
export type MillerCollapsibleInLocation = {
  __typename?: 'MillerCollapsibleInLocation';
  /** The custom field to aggregate pallets in location by. */
  field?: Maybe<Scalars['String']>;
  /** Total pallets with value of the custom field. */
  totalPallets?: Maybe<Scalars['Int']>;
  /** The value of the custom field. */
  value?: Maybe<Scalars['String']>;
};

/** Attributes for the miller column to filter data */
export type MillerCollapsibleInLocationInput = {
  /** The ID of the location */
  locationId: Scalars['ID'];
  /** The class of the location object */
  locationType: Scalars['String'];
  /** The column field name to filter by */
  filterField: Scalars['String'];
  /** The column field value used to filter */
  filterValue?: Maybe<Scalars['String']>;
};

/** An object representing money, with an amount and currency. */
export type Money = {
  __typename?: 'Money';
  /** Numerical amount of the money (i.e. 3.50). */
  amount: Scalars['Float'];
  /** Currency of the money */
  currency: Currency;
  /** Displayable string (i.e. "$3.50"). */
  displayString: Scalars['String'];
  /** Fractional unit value of a given currency (i.e. 350). */
  fractional: Scalars['Int'];
};

/** Autogenerated return type of MoveSlisToNewShipment. */
export type MoveSlisToNewShipmentPayload = {
  __typename?: 'MoveSlisToNewShipmentPayload';
  shipment?: Maybe<Shipment>;
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
};

/** root mutation */
export type Mutation = {
  __typename?: 'Mutation';
  acceptLineItems?: Maybe<AcceptLineItemsPayload>;
  /** Accept a counter-offer as a supplier and allocates the inventory. */
  acceptOfferAsSupplier?: Maybe<AcceptOfferAsSupplierPayload>;
  /** Create a client change request for adding an internal packhouse */
  addInternalPackhouse?: Maybe<AddInternalPackhousePayload>;
  allocatePayments?: Maybe<AllocatePaymentsPayload>;
  allocateShipmentController?: Maybe<AllocateShipmentControllerPayload>;
  allocateSliContainer?: Maybe<AllocateSliContainerPayload>;
  /** Archive notifications */
  archiveNotifications?: Maybe<ArchiveNotificationsPayload>;
  calculateCommercials?: Maybe<CalculateCommercialsPayload>;
  calculateInvoiceIncoterm?: Maybe<CalculateInvoiceIncotermPayload>;
  /** Get the total estimated amount for the cost code for all passed CGs */
  calculatePalletCosts?: Maybe<CalculatePalletCostsPayload>;
  cancelAddendum?: Maybe<CancelAddendumPayload>;
  cancelAirAddendum?: Maybe<CancelAirAddendumPayload>;
  captureAccountSale?: Maybe<CaptureAccountSalePayload>;
  /** Capture Defect Percentages */
  captureDefectPercentages?: Maybe<CaptureDefectPercentagesPayload>;
  /** Close an offer as a supplier */
  closeOfferAsSupplier?: Maybe<CloseOfferAsSupplierPayload>;
  completeAirFreightShipment?: Maybe<CompleteAirFreightShipmentPayload>;
  completeShipment?: Maybe<CompleteShipmentPayload>;
  completeShipmentLineItem?: Maybe<CompleteShipmentLineItemPayload>;
  /** Send confirmation to PPECB for an already submitted ShipmentLineItem */
  confirmExportNotificationLineItem?: Maybe<ConfirmExportNotificationLineItemPayload>;
  /** Confirms the cold stores associated with a supplier-exporter association */
  confirmExporterColdStores?: Maybe<ConfirmExporterColdStoresPayload>;
  /** Confirm company association masterfile configs */
  confirmMasterfileConfigCompanyAssociations?: Maybe<ConfirmMasterfileConfigCompanyAssociationsPayload>;
  /** Confirm farm variety masterfile configs (updates existing or creates new farm varieties as needed) */
  confirmMasterfileConfigFarmVarieties?: Maybe<ConfirmMasterfileConfigFarmVarietiesPayload>;
  /** Confirm FBO masterfile configs */
  confirmMasterfileConfigFbo?: Maybe<ConfirmMasterfileConfigFboPayload>;
  /** Confirm packhouse connection masterfile configs */
  confirmMasterfileConfigPackhouseConnections?: Maybe<ConfirmMasterfileConfigPackhouseConnectionsPayload>;
  createAdditionalField?: Maybe<CreateAdditionalFieldPayload>;
  /** Creates a new cargo dues record and generates COPRAR EDI file */
  createCargoDue?: Maybe<CreateCargoDuePayload>;
  createCartonConversion?: Maybe<CreateCartonConversionPayload>;
  createClientChangeRequest?: Maybe<CreateClientChangeRequestPayload>;
  createComment?: Maybe<CreateCommentPayload>;
  createCommercialTermChangeRequest?: Maybe<CreateCommercialTermChangeRequestPayload>;
  createContact?: Maybe<CreateContactPayload>;
  /** Counter a buyer counter-offer as a supplier and notify the buyer via WhatsApp. */
  createCounterOfferAsSupplier?: Maybe<CreateCounterOfferAsSupplierPayload>;
  createCustomField?: Maybe<CreateCustomFieldPayload>;
  createExportNotificationBooking?: Maybe<CreateExportNotificationBookingPayload>;
  createExportNotificationLineItem?: Maybe<CreateExportNotificationLineItemPayload>;
  /** Create a single client change request for one exporter FBO with cold store IDs */
  createExporterAndColdStoreClientRequest?: Maybe<CreateExporterAndColdStoreClientRequestPayload>;
  /** Create client change requests for requested exporter cold store records */
  createExporterColdStoreRequest?: Maybe<CreateExporterColdStoreRequestPayload>;
  /** Create a new farm FBO */
  createFarmFbo?: Maybe<CreateFarmFboPayload>;
  createFarmVariety?: Maybe<CreateFarmVarietyPayload>;
  createFarmVarietyClientChangeRequest?: Maybe<CreateFarmVarietyRequestPayload>;
  /** Create a finance rule */
  createFinanceRule?: Maybe<CreateFinanceRulePayload>;
  createFoodBusinessOperatorClientChangeRequest?: Maybe<CreateFoodBusinessOperatorRequestPayload>;
  createIgnoreErrorRequest?: Maybe<CreateIgnoreErrorRequestPayload>;
  createIncotermLineItem?: Maybe<CreateIncotermLineItemPayload>;
  /** Creates multiple line items for a given incoterm, this is used to return the expected return summary for a given incoterm */
  createIncotermLineItems?: Maybe<CreateIncotermLineItemsPayload>;
  /** Mutation to create an invoice with a currency exchange rate */
  createInvoice?: Maybe<CreateInvoicePayload>;
  /** Create a new invoice from a batch of existing account system invoices */
  createInvoiceFromBatch?: Maybe<CreateInvoiceFromBatchPayload>;
  createLoadOutInstruction?: Maybe<CreateLoadOutInstructionPayload>;
  createNetReturnProgram?: Maybe<CreateNetReturnProgramPayload>;
  /** Create a broadcast offer as a supplier and dispatch it to the given buyers via WhatsApp */
  createOfferAsSupplier?: Maybe<CreateOfferAsSupplierPayload>;
  /** Mutation to create an order */
  createOrder?: Maybe<CreateOrderPayload>;
  /** Mutation to create an order program and associated program */
  createOrderProgram?: Maybe<CreateOrderProgramPayload>;
  /** Create a packhouse connection request */
  createPackhouseConnectionsRequest?: Maybe<CreatePackhouseConnectionsRequestPayload>;
  /** Mutation to create a payment with a currency exchange rate */
  createPayment?: Maybe<CreatePaymentPayload>;
  createQuickCost?: Maybe<CreateQuickCostPayload>;
  createReportGroup?: Maybe<CreateReportGroupPayload>;
  createShipment?: Maybe<CreateShipmentPayload>;
  createShipmentLineItem?: Maybe<CreateShipmentLineItemPayload>;
  /** Create a software update report */
  createSoftwareUpdateReport?: Maybe<CreateSoftwareUpdateReportPayload>;
  /** Create client change requests for a supplier-exporter relationship (to be CompanyAssociation when approved) */
  createSupplierExporterRequest?: Maybe<CreateSupplierExporterRequestPayload>;
  createUiConfig?: Maybe<CreateUiConfigPayload>;
  deleteAddendumLineItem?: Maybe<DeleteAddendumLineItemPayload>;
  deleteAdditionalField?: Maybe<DeleteAdditionalFieldPayload>;
  deleteCartonConversion?: Maybe<DeleteCartonConversionPayload>;
  deleteComment?: Maybe<DeleteCommentPayload>;
  deleteCompanyCertificate?: Maybe<DeleteCompanyCertificatePayload>;
  deleteContact?: Maybe<DeleteContactPayload>;
  /** Delete the exchange rate for an invoice or payment */
  deleteCurrencyExchangeRate?: Maybe<DeleteCurrencyExchangeRatePayload>;
  deleteCustomField?: Maybe<DeleteCustomFieldPayload>;
  deleteEmployee?: Maybe<DeleteEmployeePayload>;
  /** Delete an existing Ephyto and send a delete request to ecert */
  deleteEphyto?: Maybe<DeleteEphytoPayload>;
  deleteEphytoDocument?: Maybe<DeleteEphytoDocumentPayload>;
  deleteExportDocument?: Maybe<DeleteExportDocumentPayload>;
  deleteFarmVariety?: Maybe<DeleteFarmVarietyPayload>;
  deleteFarmVarietyImage?: Maybe<DeleteFarmVarietyImagePayload>;
  deleteFinanceRule?: Maybe<DeleteFinanceRulePayload>;
  deleteInvoice?: Maybe<DeleteInvoicePayload>;
  /** Delete a document from an invoice */
  deleteInvoiceDocument?: Maybe<DeleteInvoiceDocumentPayload>;
  deleteLoadOutInstruction?: Maybe<DeleteLoadOutInstructionPayload>;
  deleteNetReturnProgram?: Maybe<DeleteNetReturnProgramPayload>;
  /** Mutation to delete an order program and associated program */
  deleteOrderProgram?: Maybe<DeleteOrderProgramPayload>;
  deletePayment?: Maybe<DeletePaymentPayload>;
  deleteReportGroup?: Maybe<DeleteReportGroupPayload>;
  deleteShipmentDocument?: Maybe<DeleteShipmentDocumentPayload>;
  deleteShipmentLineItem?: Maybe<DeleteShipmentLineItemPayload>;
  /** Delete the document related to a task */
  deleteTaskDocument?: Maybe<DeleteTaskDocumentPayload>;
  deleteUiConfig?: Maybe<DeleteUiConfigPayload>;
  /** Downloads multiple documents as a zip file */
  downloadDocuments?: Maybe<DownloadDocumentsPayload>;
  /** Send an ephyto to ecert in a DRAFT state */
  draftEphyto?: Maybe<DraftEphytoPayload>;
  duplicateAddendumLineItem?: Maybe<DuplicateAddendumLineItemPayload>;
  /** Duplicate an existing Ephyto */
  duplicateEphyto?: Maybe<DuplicateEphytoPayload>;
  duplicateInvoice?: Maybe<DuplicateInvoicePayload>;
  /** Duplicate an existing ShipmentLineItem */
  duplicateShipmentLineItem?: Maybe<DuplicateShipmentLineItemPayload>;
  /** Mutation that sends an email to a list of recipients with a list of documents */
  emailDocuments?: Maybe<EmailDocumentsPayload>;
  /** sends an email to a list of recipients with a list of tasks documents */
  emailTaskDocuments?: Maybe<EmailTaskDocumentsPayload>;
  /** Fetch the status of a submitted Ephyto on eCert */
  fetchEphytoStatus?: Maybe<FetchEphytoStatusPayload>;
  /** Fetches transnet container operators */
  fetchTransnetContainerOperators?: Maybe<FetchTransnetContainerOperatorsPayload>;
  /** Fetches the visit list for a given port and date range */
  fetchTransnetVisitsByShipment?: Maybe<FetchTransnetVisitsByShipmentPayload>;
  /** Mutation used to finalise default costs */
  finaliseDefaultCosts?: Maybe<FinaliseDefaultCostsPayload>;
  /** Find or create a vessel */
  findOrCreateVessel?: Maybe<FindOrCreateVesselPayload>;
  /** Requests the generation of PDF & XLS for a specific account statement.Generation is done asyncronously */
  generateAccountStatementOutputFiles?: Maybe<GenerateAccountStatementOutputFilesPayload>;
  /** Requests the generation of a specific accounting export file.Generation is done asyncronously */
  generateAccountingExport?: Maybe<GenerateAccountingExportPayload>;
  generateAddendum?: Maybe<GenerateAddendumPayload>;
  /** Requests the generation of PDF & XLS for a specific addendum header.Generation is done asyncronously */
  generateAddendumHeaderOutputFiles?: Maybe<GenerateAddendumHeaderOutputFilesPayload>;
  /** Requests the generation of PDF & XLS for a specific UI screen that has an AG1 table component */
  generateAg1TableOutputFile?: Maybe<GenerateAg1TableOutputFilePayload>;
  /** Generate an addendum for the selected load out instructions */
  generateAirAddendum?: Maybe<GenerateAirAddendumPayload>;
  /** Generate arrival qcs for containerables */
  generateArrivalQcs?: Maybe<GenerateArrivalQcsPayload>;
  generateCommoditySeasons?: Maybe<GenerateCommoditySeasonsPayload>;
  /** Generates Output files for specified Data Preparation */
  generateDataOutputFiles?: Maybe<GenerateDataOutputFilesPayload>;
  /** Generate an Ephyto from existing AFSLI or SLIs */
  generateEphyto?: Maybe<GenerateEphytoPayload>;
  /** Generate Ephyto Trade Units for the Ephyto */
  generateEphytoTradeUnit?: Maybe<GenerateEphytoTradeUnitPayload>;
  /** Requests the generation of PDF & XLS for a specific invoice. Generation is done asyncronously */
  generateInvoiceOutputFiles?: Maybe<GenerateInvoiceOutputFilesPayload>;
  /** Requests the generation of PDF & XLS for a specific load out instruction. Generation is done asyncronously */
  generateLoadOutInstructionOutputFiles?: Maybe<GenerateLoadOutInstructionOutputFilesPayload>;
  /** Requests the generation of a pallet in EDI for a specific load out instruction. Generation is done asyncronously */
  generatePalletInOutputFiles?: Maybe<GeneratePalletInOutputFilesPayload>;
  /** Requests the generation of a pallet out EDI for a specific addendum header. Generation is done asyncronously */
  generatePalletOutOutputFiles?: Maybe<GeneratePalletOutOutputFilesPayload>;
  /** Generates a persisted producer statement (PDF or XLS) from selected P&L row CG IDs. Creates a ProducerStatement record, links CGs, and generates the document via Templatable. */
  generateProducerStatement?: Maybe<GenerateProducerStatementPayload>;
  /** Requests the generation of PDF & XLS for a specific shipment export notification.Generation is done asyncronously */
  generateShipmentExportNotificationOutputFiles?: Maybe<GenerateShipmentExportNotificationOutputFilesPayload>;
  inviteUser?: Maybe<InviteUserPayload>;
  lookupAndTranslate: Scalars['JSON'];
  /** Mark a carton grouping audit as viewed */
  markAuditsAsViewed?: Maybe<MarkAuditsAsViewedMutationPayload>;
  /** Marks a container claim as completed, removing it from active claims */
  markContainerClaimAsCompleted?: Maybe<MarkContainerClaimAsCompletedPayload>;
  /** Mark notifications as read */
  markNotificationsAsRead?: Maybe<MarkNotificationsAsReadPayload>;
  /** Mark notifications as unread */
  markNotificationsAsUnread?: Maybe<MarkNotificationsAsUnreadPayload>;
  /** Moves a set of SLIs to an existing shipment or creates a new shipment and reassigns the SLIs. */
  moveSlisToNewShipment?: Maybe<MoveSlisToNewShipmentPayload>;
  processEtlDocument?: Maybe<ProcessEtlDocumentPayload>;
  /** Push pack instructions to OnePack via NSOffice */
  pushPackInstructionsToOnepack?: Maybe<PushPackInstructionsToOnepackPayload>;
  queryAddendum?: Maybe<QueryAddendumPayload>;
  /** Queue async P&L report generation */
  queueProfitAndLossReport: ProfitAndLossReportPending;
  /** Queue a report group for PDF generation */
  queueReportGroupOutputFile?: Maybe<QueueReportGroupOutputFilePayload>;
  /** Reassign an SLIs Shipment Line Grouping. */
  reassignShipmentLineItemGrouping?: Maybe<ReassignShipmentLineItemGroupingPayload>;
  /** Reject a counter offer as a supplier and notify the buyer via WhatsApp */
  rejectOfferAsSupplier?: Maybe<RejectOfferAsSupplierPayload>;
  /** Removes a defect from all claim line items that belong to a given claim line item grouping */
  removeClaimLineItemGroupingDefect?: Maybe<RemoveClaimLineItemGroupingDefectPayload>;
  /** Removes expected claim from a claim line item grouping */
  removeClaimLineItemGroupingExpectedClaim?: Maybe<RemoveClaimLineItemGroupingExpectedClaimPayload>;
  /** Removes a defect from a claim line item */
  removeClaimLineItemPalletDefect?: Maybe<RemoveClaimLineItemPalletDefectPayload>;
  /** Remove an expected claim from a claim line item pallet */
  removeClaimLineItemPalletExpectedClaim?: Maybe<RemoveClaimLineItemPalletExpectedClaimPayload>;
  /** Mutation used to remove default costs */
  removeDefaultCosts?: Maybe<RemoveDefaultCostsPayload>;
  resendInvite?: Maybe<ResendInvitePayload>;
  /** Mutation used to resolve a CG error */
  resolveCgError?: Maybe<ResolveCgErrorPayload>;
  revertLineItemsToCreated?: Maybe<RevertLineItemsToCreatedPayload>;
  revertOrderChange?: Maybe<RevertOrderChangePayload>;
  revokeInvite?: Maybe<RevokeInvitePayload>;
  /**
   * Requests the emailing of (templatable, for now) documents, for a list of document IDs, a list of recipients, and a specific document type (Invoice/LOI/etc). Generation is done asyncronously
   * @deprecated This mutation is deprecated. TODO: remove
   */
  sendEmail?: Maybe<SendEmailPayload>;
  /** Soft deletes a container claim */
  softDeleteContainerClaim?: Maybe<SoftDeleteContainerClaimPayload>;
  /** Submit an Addendum to PPECB */
  submitAddendum?: Maybe<SubmitAddendumPayload>;
  /** Mark an existing Ephyto on ECERT as Submit for processing */
  submitEphyto?: Maybe<SubmitEphytoPayload>;
  /** Starts the job of submitting the shipment header and each ShipmentLineItem to PPEB */
  submitShipmentExportNotification?: Maybe<SubmitShipmentExportNotificationPayload>;
  /** Allows user to configure which of their notification rules they want to receive notifications for */
  subscribeToNotificationRules?: Maybe<SubscribeToNotificationRulesPayload>;
  /** Update an Addendum Header and its Line Items in our system */
  updateAddendum?: Maybe<UpdateAddendumPayload>;
  updateAdditionalField?: Maybe<UpdateAdditionalFieldPayload>;
  /** Update an Air Addendum Header and its Line Items in our system */
  updateAirAddendum?: Maybe<UpdateAirAddendumPayload>;
  /** Update an Air Freight Shipment controller in our system */
  updateAirFreightShipmentController?: Maybe<UpdateAirFreightShipmentControllerPayload>;
  /** Update the arrival qc capture datetime on the container claim */
  updateArrivalQcCaptureDatetime?: Maybe<UpdateArrivalQcCaptureDatetimePayload>;
  /** Updates the arrival qc grade of all claim line items in a claim line item grouping */
  updateArrivalQcClaimLineItemGroupingGrade?: Maybe<UpdateArrivalQcClaimLineItemGroupingGradePayload>;
  /** Mutations that updates the arrival qc grade of a claim line item pallet */
  updateArrivalQcClaimLineItemPalletGrade?: Maybe<UpdateArrivalQcClaimLineItemPalletGradePayload>;
  updateCartonConversion?: Maybe<UpdateCartonConversionPayload>;
  updateCartonGroupingTransactions?: Maybe<UpdateCartonGroupingTransactionsPayload>;
  /** Updates the comment on a claim line item grouping */
  updateClaimLineItemGroupingComment?: Maybe<UpdateClaimLineItemGroupingCommentPayload>;
  /** Updates the commodity defect on all claim line itemsin a claim line item grouping */
  updateClaimLineItemGroupingDefect?: Maybe<UpdateClaimLineItemGroupingDefectPayload>;
  /** Updates the expected claim of all claim line items in a claim line item grouping */
  updateClaimLineItemGroupingExpectedClaim?: Maybe<UpdateClaimLineItemGroupingExpectedClaimPayload>;
  /** Updates the arrival qc defect all claim line items in a claim line item pallet */
  updateClaimLineItemPalletDefect?: Maybe<UpdateClaimLineItemPalletDefectPayload>;
  /** Update the expected claim for a set of claim line items that belong to a claim line item pallet */
  updateClaimLineItemPalletExpectedClaim?: Maybe<UpdateClaimLineItemPalletExpectedClaimPayload>;
  /** Updates an on premises command with a result */
  updateCommandResult?: Maybe<UpdateCommandResultPayload>;
  updateCompanyDetails?: Maybe<UpdateCompanyDetailsPayload>;
  /** Mutation to update the onboarding step of a company */
  updateCompanyOnboardingStep?: Maybe<UpdateCompanyOnboardingStepPayload>;
  updateCompanyTradeRegions?: Maybe<UpdateCompanyTradeRegionsPayload>;
  updateContact?: Maybe<UpdateContactPayload>;
  /** Updates the grade of a container claim */
  updateContainerClaimGrade?: Maybe<UpdateContainerClaimGradePayload>;
  /** Updates the the container claim's note */
  updateContainerClaimNote?: Maybe<UpdateContainerClaimNotePayload>;
  updateCustomField?: Maybe<UpdateCustomFieldPayload>;
  /** Mutation that updates the custom date for a task. */
  updateCustomTaskDate?: Maybe<UpdateCustomTaskDatePayload>;
  /** Updates a Data Output */
  updateDataOutput?: Maybe<UpdateDataOutputPayload>;
  /** Update an Ephyto on eCert */
  updateDraftEphyto?: Maybe<UpdateDraftEphytoPayload>;
  /** Update an Ephyto and its related models in our system */
  updateEphyto?: Maybe<UpdateEphytoPayload>;
  updateEphytoDocument?: Maybe<UpdateEphytoDocumentPayload>;
  updateEstimates?: Maybe<UpdateEstimatesPayload>;
  updateExportDocument?: Maybe<UpdateExportDocumentPayload>;
  updateFarmVariety?: Maybe<UpdateFarmVarietyPayload>;
  /** Update a finance rule */
  updateFinanceRule?: Maybe<UpdateFinanceRulePayload>;
  /** Update the enabled state of a finance rule */
  updateFinanceRuleEnabledState?: Maybe<UpdateFinanceRuleEnabledStatePayload>;
  /** Mutation to update an invoice and its currency exchange rate */
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  updateInvoiceState?: Maybe<UpdateInvoiceStatePayload>;
  updateLineItems?: Maybe<UpdateLineItemsPayload>;
  updateLoadOutInstruction?: Maybe<UpdateLoadOutInstructionPayload>;
  updateLoadOutInstructionsFromSlis?: Maybe<UpdateLoadOutInstructionsFromSlisPayload>;
  updateNetReturnProgram?: Maybe<UpdateNetReturnProgramPayload>;
  updateOrchardSeasons?: Maybe<UpdateOrchardSeasonsPayload>;
  updateOrchardYields?: Maybe<UpdateOrchardYieldsPayload>;
  updateOrder?: Maybe<UpdateOrderPayload>;
  /** Mutation to update an order program and associated program */
  updateOrderProgram?: Maybe<UpdateOrderProgramPayload>;
  /**
   * Mutation that updates the priority on a pack
   *                                                        instruction line item
   */
  updatePackInstructionLineItemPriority?: Maybe<UpdatePackInstructionLineItemPriorityPayload>;
  /** Mutation to update a payment and its currency exchange rate */
  updatePayment?: Maybe<UpdatePaymentPayload>;
  updateReportGroup?: Maybe<UpdateReportGroupPayload>;
  updateShipment?: Maybe<UpdateShipmentPayload>;
  updateShipmentDocument?: Maybe<UpdateShipmentDocumentPayload>;
  updateShipmentLineItem?: Maybe<UpdateShipmentLineItemPayload>;
  /** Mutation that updates tasks dates */
  updateTasksDates?: Maybe<UpdateTasksDatesPayload>;
  updateUiConfig?: Maybe<UpdateUiConfigPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserFeedItem?: Maybe<UpdateUserFeedItemPayload>;
  updateUserFeedItems?: Maybe<UpdateUserFeedItemsPayload>;
  updateUserNotifications?: Maybe<UpdateUserNotificationsPayload>;
  /** Uploads files on a container claim */
  uploadClaimFiles?: Maybe<UploadClaimFilesPayload>;
  uploadCompanyCertificate?: Maybe<UploadCompanyCertificatePayload>;
  uploadCompanyLogo?: Maybe<UploadCompanyLogoPayload>;
  /** Upload of support ephyto documents on the UI, Ephyto tab specifically */
  uploadEphytoDocument?: Maybe<UploadEphytoDocumentPayload>;
  uploadEtlDocument?: Maybe<UploadEtlDocumentPayload>;
  uploadExportDocument?: Maybe<UploadExportDocumentPayload>;
  uploadFarmVarietyImage?: Maybe<UploadFarmVarietyImagePayload>;
  /** Upload documents (PDF and Excel files) to an invoice */
  uploadInvoiceDocuments?: Maybe<UploadInvoiceDocumentsPayload>;
  uploadOrderShipmentDocument?: Maybe<UploadOrderShipmentDocumentPayload>;
  /** Upload stock files from the stock screen */
  uploadStockFile?: Maybe<UploadStockFileMutationPayload>;
  /** Mutation that uploads a document to a task */
  uploadTaskDocument?: Maybe<UploadTaskDocumentPayload>;
  /** Upload a single document for a Task and associate it with multiple SLI Tasks */
  uploadTaskDocumentPerSli?: Maybe<UploadTaskDocumentPerSliPayload>;
  uploadUserAvatar?: Maybe<UploadUserAvatarPayload>;
  /** Creates or updates a CTI from the SLI and generates a PDF and XL documentGeneration is done asynchronously */
  upsertCertificateTransportInstruction?: Maybe<UpsertCertificateTransportInstructionPayload>;
  /** Upsert a commercial term */
  upsertCommercialTerm?: Maybe<UpsertCommercialTermPayload>;
  /** Upsert the exchange rate for an invoice or payment */
  upsertCurrencyExchangeRate?: Maybe<UpsertCurrencyExchangeRatePayload>;
  /** Upsert multiple finance rules */
  upsertFinanceRule?: Maybe<UpsertFinanceRulePayload>;
  wontPackLineItems?: Maybe<WontPackLineItemsPayload>;
};


/** root mutation */
export type MutationAcceptLineItemsArgs = {
  ids: Array<Scalars['Int']>;
};


/** root mutation */
export type MutationAcceptOfferAsSupplierArgs = {
  counterOfferId: Scalars['ID'];
};


/** root mutation */
export type MutationAddInternalPackhouseArgs = {
  attributes: AddInternalPackhouseAttributes;
};


/** root mutation */
export type MutationAllocatePaymentsArgs = {
  paymentAllocations: Array<PaymentAllocationAttributes>;
};


/** root mutation */
export type MutationAllocateShipmentControllerArgs = {
  shipmentId: Scalars['Int'];
  userId?: Maybe<Scalars['Int']>;
};


/** root mutation */
export type MutationAllocateSliContainerArgs = {
  isBreakBulk: Scalars['Boolean'];
  sliContainerId?: Maybe<Scalars['Int']>;
  sliId: Scalars['Int'];
};


/** root mutation */
export type MutationArchiveNotificationsArgs = {
  ids?: Maybe<Array<Scalars['ID']>>;
};


/** root mutation */
export type MutationCalculateCommercialsArgs = {
  attributes: InvoiceAttributes;
};


/** root mutation */
export type MutationCalculateInvoiceIncotermArgs = {
  attributes: InvoiceIncotermAttributes;
};


/** root mutation */
export type MutationCalculatePalletCostsArgs = {
  cgIds: Array<Scalars['Int']>;
  costId: Scalars['Int'];
};


/** root mutation */
export type MutationCancelAddendumArgs = {
  deleteAddendum: Scalars['Boolean'];
  id: Scalars['Int'];
};


/** root mutation */
export type MutationCancelAirAddendumArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationCaptureAccountSaleArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationCaptureDefectPercentagesArgs = {
  attributes: DefectPercentageCaptureAttributes;
};


/** root mutation */
export type MutationCloseOfferAsSupplierArgs = {
  offerId: Scalars['ID'];
};


/** root mutation */
export type MutationCompleteAirFreightShipmentArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationCompleteShipmentArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationCompleteShipmentLineItemArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationConfirmExportNotificationLineItemArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationConfirmExporterColdStoresArgs = {
  companyAssociationExportColdStoreAttributes: Array<CompanyAssociationExportColdStoreAttributes>;
  clientChangeRequestExportColdStoreAttributes: Array<ClientChangeRequestExportColdStoreAttributes>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigCompanyAssociationsArgs = {
  masterfileConfigs: Array<MasterfileConfigCompanyAssociationInput>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigFarmVarietiesArgs = {
  masterfileConfigs: Array<MasterfileConfigFarmVarietyInput>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigFboArgs = {
  masterfileConfigs: Array<MasterfileConfigFboInput>;
};


/** root mutation */
export type MutationConfirmMasterfileConfigPackhouseConnectionsArgs = {
  masterfileConfigs: Array<MasterfileConfigPackhouseConnectionAttributes>;
};


/** root mutation */
export type MutationCreateAdditionalFieldArgs = {
  attributes: CreateAdditionalFieldAttributes;
};


/** root mutation */
export type MutationCreateCargoDueArgs = {
  cargoDueData: Scalars['Json'];
  sliIds: Array<Scalars['ID']>;
  transnetVisit: Scalars['Json'];
  cargoDueId?: Maybe<Scalars['ID']>;
};


/** root mutation */
export type MutationCreateCartonConversionArgs = {
  actualMass?: Maybe<Scalars['Float']>;
  commodityId?: Maybe<Scalars['ID']>;
  conversionFactor?: Maybe<Scalars['Float']>;
  conversionType?: Maybe<Scalars['String']>;
  convertedSizeCount?: Maybe<Scalars['String']>;
  massConversion?: Maybe<Scalars['Float']>;
  pack?: Maybe<Scalars['String']>;
  sizeCount?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationCreateClientChangeRequestArgs = {
  action?: Maybe<Scalars['String']>;
  userContext?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['ID']>;
};


/** root mutation */
export type MutationCreateCommentArgs = {
  attributes: CreateCommentAttributes;
};


/** root mutation */
export type MutationCreateCommercialTermChangeRequestArgs = {
  attributes: CreateCommercialTermChangeRequestAttributes;
};


/** root mutation */
export type MutationCreateContactArgs = {
  attributes: ContactAttributes;
};


/** root mutation */
export type MutationCreateCounterOfferAsSupplierArgs = {
  previousOfferId: Scalars['ID'];
  attributes: CounterOfferAttributes;
};


/** root mutation */
export type MutationCreateCustomFieldArgs = {
  attributes: CustomFieldAttributes;
};


/** root mutation */
export type MutationCreateExportNotificationBookingArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationCreateExportNotificationLineItemArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationCreateExporterAndColdStoreClientRequestArgs = {
  exporterFboId: Scalars['ID'];
  coldStoreIds: Array<Scalars['ID']>;
  isPackhouseContainerised?: Maybe<Scalars['Boolean']>;
};


/** root mutation */
export type MutationCreateExporterColdStoreRequestArgs = {
  companyAssociationId: Scalars['ID'];
  coldStoreIds: Array<Scalars['ID']>;
  isPackhouseContainerisation: Scalars['Boolean'];
};


/** root mutation */
export type MutationCreateFarmFboArgs = {
  attributes: CreateFarmAttribute;
};


/** root mutation */
export type MutationCreateFarmVarietyArgs = {
  attributes: CreateFarmVarietyAttributes;
};


/** root mutation */
export type MutationCreateFarmVarietyClientChangeRequestArgs = {
  action?: Maybe<Scalars['String']>;
  commodityId?: Maybe<Scalars['Int']>;
  commodityName?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  varietyCode?: Maybe<Scalars['String']>;
  varietyId?: Maybe<Scalars['Int']>;
};


/** root mutation */
export type MutationCreateFinanceRuleArgs = {
  attributes: Array<FinanceRuleAttributes>;
};


/** root mutation */
export type MutationCreateFoodBusinessOperatorClientChangeRequestArgs = {
  action?: Maybe<Scalars['String']>;
  fboCode?: Maybe<Scalars['String']>;
  globalGapNumber?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  modelId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  producerName?: Maybe<Scalars['String']>;
  productionRegion?: Maybe<Scalars['String']>;
  typeOfBusiness?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationCreateIgnoreErrorRequestArgs = {
  action?: Maybe<Scalars['String']>;
  errorToIgnore?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationCreateIncotermLineItemArgs = {
  attributes: CreateLineItemAttributes;
  buyerId?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
};


/** root mutation */
export type MutationCreateIncotermLineItemsArgs = {
  lineItemAttributes: Array<CreateLineItemAttributes>;
};


/** root mutation */
export type MutationCreateInvoiceArgs = {
  attributes: InvoiceAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
};


/** root mutation */
export type MutationCreateInvoiceFromBatchArgs = {
  invoiceIds: Array<Scalars['ID']>;
  documentType: Scalars['String'];
};


/** root mutation */
export type MutationCreateLoadOutInstructionArgs = {
  attributes: LoadOutAttributes;
};


/** root mutation */
export type MutationCreateNetReturnProgramArgs = {
  attributes: NetReturnProgramAttributes;
};


/** root mutation */
export type MutationCreateOfferAsSupplierArgs = {
  attributes: OfferAttributes;
};


/** root mutation */
export type MutationCreateOrderArgs = {
  attributes: CreateOrderAttributes;
};


/** root mutation */
export type MutationCreateOrderProgramArgs = {
  attributes: OrderProgramAttributes;
};


/** root mutation */
export type MutationCreatePackhouseConnectionsRequestArgs = {
  attributes: CreatePackhouseConnectionsAttribute;
};


/** root mutation */
export type MutationCreatePaymentArgs = {
  attributes: PaymentAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
};


/** root mutation */
export type MutationCreateQuickCostArgs = {
  attributes: QuickCostAttributes;
};


/** root mutation */
export type MutationCreateReportGroupArgs = {
  attributes: ReportGroupAttributes;
};


/** root mutation */
export type MutationCreateShipmentArgs = {
  attributes: ShipmentAttributes;
};


/** root mutation */
export type MutationCreateShipmentLineItemArgs = {
  attributes: ShipmentLineItemAttributes;
};


/** root mutation */
export type MutationCreateSoftwareUpdateReportArgs = {
  softwareUpdateReport: Array<Scalars['String']>;
};


/** root mutation */
export type MutationCreateSupplierExporterRequestArgs = {
  attributes: CreateSupplierExporterRequestAttribute;
};


/** root mutation */
export type MutationCreateUiConfigArgs = {
  attributes: CreateUpdateUiConfigAttributes;
};


/** root mutation */
export type MutationDeleteAddendumLineItemArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteAdditionalFieldArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteCartonConversionArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationDeleteCommentArgs = {
  commentId: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteCompanyCertificateArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteContactArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteCurrencyExchangeRateArgs = {
  currencyExchangeRateId: Scalars['ID'];
};


/** root mutation */
export type MutationDeleteCustomFieldArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteEmployeeArgs = {
  employeeId: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteEphytoArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteEphytoDocumentArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteExportDocumentArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteFarmVarietyArgs = {
  companyId: Scalars['Int'];
  varietyId: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteFarmVarietyImageArgs = {
  varietyId: Scalars['Int'];
  imageId: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteFinanceRuleArgs = {
  ids: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationDeleteInvoiceArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteInvoiceDocumentArgs = {
  invoiceId: Scalars['ID'];
  documentId: Scalars['ID'];
};


/** root mutation */
export type MutationDeleteLoadOutInstructionArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteNetReturnProgramArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationDeleteOrderProgramArgs = {
  orderProgramId: Scalars['ID'];
};


/** root mutation */
export type MutationDeletePaymentArgs = {
  paymentId: Scalars['ID'];
};


/** root mutation */
export type MutationDeleteReportGroupArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteShipmentDocumentArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteShipmentLineItemArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDeleteTaskDocumentArgs = {
  id: Scalars['ID'];
  shipmentLineItemId: Scalars['ID'];
};


/** root mutation */
export type MutationDeleteUiConfigArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDownloadDocumentsArgs = {
  documentAttributes: Array<DownloadDocumentAttributes>;
  zippedFilename: Scalars['String'];
};


/** root mutation */
export type MutationDraftEphytoArgs = {
  ephytoId: Scalars['Int'];
};


/** root mutation */
export type MutationDuplicateAddendumLineItemArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDuplicateEphytoArgs = {
  applicationType: Scalars['Int'];
  id: Scalars['Int'];
};


/** root mutation */
export type MutationDuplicateInvoiceArgs = {
  documentType: Scalars['String'];
  id: Scalars['ID'];
  shouldDuplicateLineItems: Scalars['Boolean'];
};


/** root mutation */
export type MutationDuplicateShipmentLineItemArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationEmailDocumentsArgs = {
  attributes: EmailDocumentsAttributes;
};


/** root mutation */
export type MutationEmailTaskDocumentsArgs = {
  attributes: EmailTaskDocumentsAttributes;
};


/** root mutation */
export type MutationFetchEphytoStatusArgs = {
  ephytoId: Scalars['Int'];
};


/** root mutation */
export type MutationFetchTransnetVisitsByShipmentArgs = {
  portId?: Maybe<Scalars['ID']>;
  shipmentId: Scalars['ID'];
};


/** root mutation */
export type MutationFinaliseDefaultCostsArgs = {
  attributes: FinaliseDefaultCostAttributes;
};


/** root mutation */
export type MutationFindOrCreateVesselArgs = {
  vesselName: Scalars['String'];
};


/** root mutation */
export type MutationGenerateAccountStatementOutputFilesArgs = {
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  fromDate?: Maybe<Scalars['ISO8601Date']>;
};


/** root mutation */
export type MutationGenerateAccountingExportArgs = {
  invoiceIds: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationGenerateAddendumArgs = {
  bookingReference?: Maybe<Scalars['String']>;
  sliIds?: Maybe<Array<Scalars['Int']>>;
  shipmentId?: Maybe<Scalars['ID']>;
};


/** root mutation */
export type MutationGenerateAddendumHeaderOutputFilesArgs = {
  addendumHeaderId: Scalars['ID'];
};


/** root mutation */
export type MutationGenerateAg1TableOutputFileArgs = {
  data: Scalars['Json'];
  fields: Array<Ag1TableFieldAttribute>;
  fileFormat: TemplateFileFormatEnum;
  tableName: Scalars['String'];
  filterValues?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationGenerateAirAddendumArgs = {
  loiIds: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationGenerateArrivalQcsArgs = {
  containerableIds: Array<Scalars['ID']>;
  containerableType: ContainerableTypeEnum;
};


/** root mutation */
export type MutationGenerateCommoditySeasonsArgs = {
  seasonYear: Scalars['Int'];
};


/** root mutation */
export type MutationGenerateDataOutputFilesArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationGenerateEphytoArgs = {
  bookingReference?: Maybe<Scalars['String']>;
  ephytoId?: Maybe<Scalars['Int']>;
  isEntireBooking: Scalars['Boolean'];
  shipmentType: Scalars['String'];
  sliIds?: Maybe<Array<Scalars['Int']>>;
};


/** root mutation */
export type MutationGenerateEphytoTradeUnitArgs = {
  shipmentType: Scalars['String'];
  ephytoId?: Maybe<Scalars['Int']>;
};


/** root mutation */
export type MutationGenerateInvoiceOutputFilesArgs = {
  invoiceId: Scalars['ID'];
};


/** root mutation */
export type MutationGenerateLoadOutInstructionOutputFilesArgs = {
  loadoutinstructionid: Scalars['ID'];
};


/** root mutation */
export type MutationGeneratePalletInOutputFilesArgs = {
  loadOutInstructionId: Scalars['ID'];
};


/** root mutation */
export type MutationGeneratePalletOutOutputFilesArgs = {
  addendumHeaderId: Scalars['ID'];
};


/** root mutation */
export type MutationGenerateProducerStatementArgs = {
  cartonGroupingIds: Array<Scalars['Int']>;
  fileFormat: TemplateFileFormatEnum;
  reportingCurrency?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationGenerateShipmentExportNotificationOutputFilesArgs = {
  shipmentId: Scalars['ID'];
};


/** root mutation */
export type MutationInviteUserArgs = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationLookupAndTranslateArgs = {
  englishTexts: Array<Scalars['String']>;
  locale: Scalars['String'];
};


/** root mutation */
export type MutationMarkAuditsAsViewedArgs = {
  auditIds: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationMarkContainerClaimAsCompletedArgs = {
  containerClaimId: Scalars['ID'];
};


/** root mutation */
export type MutationMarkNotificationsAsReadArgs = {
  ids: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationMarkNotificationsAsUnreadArgs = {
  ids?: Maybe<Array<Scalars['ID']>>;
};


/** root mutation */
export type MutationMoveSlisToNewShipmentArgs = {
  shipmentId?: Maybe<Scalars['ID']>;
  sliIds: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationProcessEtlDocumentArgs = {
  documentId: Scalars['Int'];
};


/** root mutation */
export type MutationPushPackInstructionsToOnepackArgs = {
  clientCode: Scalars['String'];
  packInstructionsAttributes: PackInstructionsAttributes;
};


/** root mutation */
export type MutationQueryAddendumArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationQueueProfitAndLossReportArgs = {
  requestId: Scalars['String'];
  filters: ProfitAndLossFilters;
};


/** root mutation */
export type MutationQueueReportGroupOutputFileArgs = {
  reportGroupId: Scalars['ID'];
  requestId: Scalars['String'];
  queryParams?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationReassignShipmentLineItemGroupingArgs = {
  id: Scalars['ID'];
  sligId: Scalars['ID'];
};


/** root mutation */
export type MutationRejectOfferAsSupplierArgs = {
  counterOfferId: Scalars['ID'];
};


/** root mutation */
export type MutationRemoveClaimLineItemGroupingDefectArgs = {
  claimLineItemGroupingId: Scalars['ID'];
  defectId: Scalars['ID'];
};


/** root mutation */
export type MutationRemoveClaimLineItemGroupingExpectedClaimArgs = {
  claimLineItemGroupingId: Scalars['ID'];
  expectedClaim: ExpectedClaimEnum;
};


/** root mutation */
export type MutationRemoveClaimLineItemPalletDefectArgs = {
  claimLineItemIds: Array<Scalars['ID']>;
  defectId: Scalars['ID'];
  claimLineItemGroupingId: Scalars['ID'];
};


/** root mutation */
export type MutationRemoveClaimLineItemPalletExpectedClaimArgs = {
  claimLineItemIds: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationRemoveDefaultCostsArgs = {
  attributes: RemoveDefaultCostAttributes;
};


/** root mutation */
export type MutationResendInviteArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationResolveCgErrorArgs = {
  id: Scalars['ID'];
  resolution: CgErrorResolutionInput;
  userContext?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationRevertLineItemsToCreatedArgs = {
  ids: Array<Scalars['Int']>;
};


/** root mutation */
export type MutationRevertOrderChangeArgs = {
  startId: Scalars['Int'];
  endId: Scalars['Int'];
  orderId: Scalars['Int'];
};


/** root mutation */
export type MutationRevokeInviteArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationSendEmailArgs = {
  attributes: SendEmailAttributes;
};


/** root mutation */
export type MutationSoftDeleteContainerClaimArgs = {
  containerClaimId: Scalars['ID'];
};


/** root mutation */
export type MutationSubmitAddendumArgs = {
  id: Scalars['Int'];
};


/** root mutation */
export type MutationSubmitEphytoArgs = {
  ephytoId: Scalars['Int'];
};


/** root mutation */
export type MutationSubmitShipmentExportNotificationArgs = {
  id: Scalars['ID'];
};


/** root mutation */
export type MutationSubscribeToNotificationRulesArgs = {
  notificationRuleSubscriptionAttributes: Array<NotificationRuleSubscriptionAttributes>;
};


/** root mutation */
export type MutationUpdateAddendumArgs = {
  addendumHeader: AddendumHeaderAttributes;
  addendumLineItems: Array<AddendumLineItemAttributes>;
};


/** root mutation */
export type MutationUpdateAdditionalFieldArgs = {
  id: Scalars['Int'];
  attributes: UpdateAdditionalFieldAttributes;
};


/** root mutation */
export type MutationUpdateAirAddendumArgs = {
  addendumHeader: AddendumHeaderAttributes;
  addendumLineItems: Array<AddendumLineItemAttributes>;
};


/** root mutation */
export type MutationUpdateAirFreightShipmentControllerArgs = {
  airFreightShipmentId: Scalars['Int'];
  controllerId?: Maybe<Scalars['Int']>;
  controllerName?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationUpdateArrivalQcCaptureDatetimeArgs = {
  containerClaimId: Scalars['ID'];
  arrivalQcCaptureDatetime?: Maybe<Scalars['ISO8601DateTime']>;
};


/** root mutation */
export type MutationUpdateArrivalQcClaimLineItemGroupingGradeArgs = {
  claimLineItemGroupingId: Scalars['ID'];
  arrivalQcGrade: ArrivalQcGradeEnum;
};


/** root mutation */
export type MutationUpdateArrivalQcClaimLineItemPalletGradeArgs = {
  claimLineItemIds: Array<Scalars['ID']>;
  arrivalQcGrade: ArrivalQcGradeEnum;
};


/** root mutation */
export type MutationUpdateCartonConversionArgs = {
  actualMass?: Maybe<Scalars['Float']>;
  conversionFactor?: Maybe<Scalars['Float']>;
  convertedSizeCount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  massConversion?: Maybe<Scalars['Float']>;
};


/** root mutation */
export type MutationUpdateCartonGroupingTransactionsArgs = {
  deleteData?: Maybe<Array<Scalars['Int']>>;
};


/** root mutation */
export type MutationUpdateClaimLineItemGroupingCommentArgs = {
  claimLineItemGroupingId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationUpdateClaimLineItemGroupingDefectArgs = {
  claimLineItemGroupingId: Scalars['ID'];
  defectId: Scalars['ID'];
};


/** root mutation */
export type MutationUpdateClaimLineItemGroupingExpectedClaimArgs = {
  claimLineItemGroupingId: Scalars['ID'];
  expectedClaim: ExpectedClaimEnum;
};


/** root mutation */
export type MutationUpdateClaimLineItemPalletDefectArgs = {
  claimLineItemIds: Array<Scalars['ID']>;
  defectId: Scalars['ID'];
};


/** root mutation */
export type MutationUpdateClaimLineItemPalletExpectedClaimArgs = {
  claimLineItemIds: Array<Scalars['ID']>;
  expectedClaim: ExpectedClaimEnum;
};


/** root mutation */
export type MutationUpdateCommandResultArgs = {
  attributes: CommandResultAttributes;
};


/** root mutation */
export type MutationUpdateCompanyDetailsArgs = {
  attributes: UpdateCompanyAttributes;
};


/** root mutation */
export type MutationUpdateCompanyOnboardingStepArgs = {
  onboardingStep: CompanyOnboardingStepEnum;
};


/** root mutation */
export type MutationUpdateCompanyTradeRegionsArgs = {
  addTradeRegions: Array<TradeRegionAttributes>;
  removeTradeRegions: Array<TradeRegionAttributes>;
};


/** root mutation */
export type MutationUpdateContactArgs = {
  attributes: ContactAttributes;
};


/** root mutation */
export type MutationUpdateContainerClaimGradeArgs = {
  containerClaimId: Scalars['ID'];
  arrivalQcState: ArrivalQcStateEnum;
  arrivalQcGrade: ArrivalQcGradeEnum;
};


/** root mutation */
export type MutationUpdateContainerClaimNoteArgs = {
  containerClaimId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
};


/** root mutation */
export type MutationUpdateCustomFieldArgs = {
  attributes: CustomFieldAttributes;
};


/** root mutation */
export type MutationUpdateCustomTaskDateArgs = {
  customDate?: Maybe<Scalars['ISO8601Date']>;
  shipmentLineItemId: Scalars['ID'];
  taskId: Scalars['ID'];
};


/** root mutation */
export type MutationUpdateDataOutputArgs = {
  attributes: DataOutputAttributes;
};


/** root mutation */
export type MutationUpdateDraftEphytoArgs = {
  ephytoId: Scalars['Int'];
};


/** root mutation */
export type MutationUpdateEphytoArgs = {
  ephyto: EphytoAttributes;
  ephytoConsignmentItems?: Maybe<Array<EphytoConsignmentItemAttributes>>;
};


/** root mutation */
export type MutationUpdateEphytoDocumentArgs = {
  id: Scalars['Int'];
  type: Scalars['String'];
};


/** root mutation */
export type MutationUpdateEstimatesArgs = {
  createData?: Maybe<Array<EstimateAttributes>>;
  deleteData?: Maybe<Array<Scalars['Int']>>;
  updateData?: Maybe<Array<EstimateAttributes>>;
};


/** root mutation */
export type MutationUpdateExportDocumentArgs = {
  id: Scalars['Int'];
  type: Scalars['String'];
};


/** root mutation */
export type MutationUpdateFarmVarietyArgs = {
  attributes: UpdateFarmVarietyAttributes;
};


/** root mutation */
export type MutationUpdateFinanceRuleArgs = {
  attributes: Array<FinanceRuleAttributes>;
  deleteIds?: Maybe<Array<Scalars['ID']>>;
};


/** root mutation */
export type MutationUpdateFinanceRuleEnabledStateArgs = {
  updateIds: Array<Scalars['ID']>;
  state: Scalars['Boolean'];
};


/** root mutation */
export type MutationUpdateInvoiceArgs = {
  attributes: InvoiceAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
};


/** root mutation */
export type MutationUpdateInvoiceStateArgs = {
  id: Scalars['Int'];
  state: Scalars['String'];
};


/** root mutation */
export type MutationUpdateLineItemsArgs = {
  attributes: Array<UpdateLineItemAttributes>;
};


/** root mutation */
export type MutationUpdateLoadOutInstructionArgs = {
  attributes: LoadOutAttributes;
};


/** root mutation */
export type MutationUpdateLoadOutInstructionsFromSlisArgs = {
  sliIds: Array<Scalars['ID']>;
};


/** root mutation */
export type MutationUpdateNetReturnProgramArgs = {
  attributes: NetReturnProgramAttributes;
};


/** root mutation */
export type MutationUpdateOrchardSeasonsArgs = {
  deleteData?: Maybe<Array<Scalars['Int']>>;
  updateData?: Maybe<Array<OrchardSeasonAttributes>>;
};


/** root mutation */
export type MutationUpdateOrchardYieldsArgs = {
  createData?: Maybe<Array<OrchardYieldAttributes>>;
  deleteData?: Maybe<Array<Scalars['Int']>>;
  updateData?: Maybe<Array<OrchardYieldAttributes>>;
};


/** root mutation */
export type MutationUpdateOrderArgs = {
  attributes: UpdateOrderAttributes;
};


/** root mutation */
export type MutationUpdateOrderProgramArgs = {
  orderProgramId: Scalars['ID'];
  attributes: OrderProgramAttributes;
};


/** root mutation */
export type MutationUpdatePackInstructionLineItemPriorityArgs = {
  packInstructionLineItemId: Scalars['ID'];
  priority?: Maybe<Scalars['Int']>;
};


/** root mutation */
export type MutationUpdatePaymentArgs = {
  attributes: PaymentAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
  paymentId: Scalars['ID'];
};


/** root mutation */
export type MutationUpdateReportGroupArgs = {
  attributes: ReportGroupAttributes;
};


/** root mutation */
export type MutationUpdateShipmentArgs = {
  attributes: ShipmentAttributes;
};


/** root mutation */
export type MutationUpdateShipmentDocumentArgs = {
  id: Scalars['Int'];
  type: Scalars['String'];
};


/** root mutation */
export type MutationUpdateShipmentLineItemArgs = {
  attributes: ShipmentLineItemAttributes;
};


/** root mutation */
export type MutationUpdateTasksDatesArgs = {
  updateValues: Scalars['Json'];
};


/** root mutation */
export type MutationUpdateUiConfigArgs = {
  attributes: CreateUpdateUiConfigAttributes;
};


/** root mutation */
export type MutationUpdateUserArgs = {
  id: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  notifyEmail: Scalars['Boolean'];
  notifyBrowserPush: Scalars['Boolean'];
  useV2: Scalars['Boolean'];
};


/** root mutation */
export type MutationUpdateUserFeedItemArgs = {
  attributes: UpdateUserFeedItemAttributes;
};


/** root mutation */
export type MutationUpdateUserFeedItemsArgs = {
  attributes: Array<UpdateUserFeedItemAttributes>;
};


/** root mutation */
export type MutationUpdateUserNotificationsArgs = {
  id: Scalars['Int'];
  notifyEmail: Scalars['Boolean'];
  notifyBrowserPush: Scalars['Boolean'];
};


/** root mutation */
export type MutationUploadClaimFilesArgs = {
  containerClaimId: Scalars['ID'];
  files?: Maybe<Array<Scalars['Upload']>>;
};


/** root mutation */
export type MutationUploadCompanyCertificateArgs = {
  companyId: Scalars['Int'];
  file: Scalars['Upload'];
  expiryDate: Scalars['String'];
  certificateTypeId: Scalars['Int'];
};


/** root mutation */
export type MutationUploadCompanyLogoArgs = {
  companyId: Scalars['Int'];
  file: Scalars['Upload'];
};


/** root mutation */
export type MutationUploadEphytoDocumentArgs = {
  ephytoId: Scalars['Int'];
  file: Scalars['Upload'];
};


/** root mutation */
export type MutationUploadEtlDocumentArgs = {
  documentId: Scalars['Int'];
  file: Scalars['Upload'];
};


/** root mutation */
export type MutationUploadExportDocumentArgs = {
  attributes: ShipmentLineItemAttributes;
  file: Scalars['Upload'];
};


/** root mutation */
export type MutationUploadFarmVarietyImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


/** root mutation */
export type MutationUploadInvoiceDocumentsArgs = {
  invoiceId: Scalars['ID'];
  files: Array<Scalars['Upload']>;
};


/** root mutation */
export type MutationUploadOrderShipmentDocumentArgs = {
  orderid: Scalars['Int'];
  type: Scalars['String'];
  file: Scalars['Upload'];
};


/** root mutation */
export type MutationUploadStockFileArgs = {
  file: Scalars['Upload'];
};


/** root mutation */
export type MutationUploadTaskDocumentArgs = {
  customDate?: Maybe<Scalars['ISO8601DateTime']>;
  file: Scalars['Upload'];
  taskId: Scalars['Int'];
  uploadDate?: Maybe<Scalars['ISO8601DateTime']>;
};


/** root mutation */
export type MutationUploadTaskDocumentPerSliArgs = {
  file: Scalars['Upload'];
  selectedSliIds: Array<Scalars['ID']>;
  shipmentLineItemId: Scalars['ID'];
  taskId: Scalars['ID'];
};


/** root mutation */
export type MutationUploadUserAvatarArgs = {
  file: Scalars['Upload'];
};


/** root mutation */
export type MutationUpsertCertificateTransportInstructionArgs = {
  shipmentLineItemId: Scalars['ID'];
};


/** root mutation */
export type MutationUpsertCommercialTermArgs = {
  attributes: CommercialTermAttributes;
};


/** root mutation */
export type MutationUpsertCurrencyExchangeRateArgs = {
  currencyExchangeRateAttributes: CurrencyExchangeRateAttributes;
};


/** root mutation */
export type MutationUpsertFinanceRuleArgs = {
  attributesList: Array<FinanceRuleAttributes>;
};


/** root mutation */
export type MutationWontPackLineItemsArgs = {
  ids: Array<Scalars['Int']>;
};

export type NetReturnProgram = {
  __typename?: 'NetReturnProgram';
  /** The additional fields associated with the net return program */
  additionalFields?: Maybe<Scalars['String']>;
  /** The batch number associated with the net return program */
  batchNumber?: Maybe<Scalars['String']>;
  /** The buyer associated with the net return program */
  buyer?: Maybe<Company>;
  /** The ID of the buyer associated with the net return program */
  buyerId?: Maybe<Scalars['ID']>;
  /** The name of the buyer associated with the net return program */
  buyerName?: Maybe<Scalars['String']>;
  /** The carton type associated with the net return program */
  cartonType?: Maybe<CartonType>;
  /** The ID of the carton type associated with the net return program */
  cartonTypeId: Scalars['ID'];
  /** The name of the carton type associated with the net return program */
  cartonTypeName: Scalars['String'];
  /** The commodity associated with the net return program */
  commodity?: Maybe<Commodity>;
  /** The ID of the commodity associated with the net return program */
  commodityId: Scalars['ID'];
  /** The name of the commodity associated with the net return program */
  commodityName: Scalars['String'];
  /** The configured currency associated with the net return program */
  configuredCurrency?: Maybe<Scalars['String']>;
  /** The configured unit associated with the net return program */
  configuredUnit?: Maybe<Scalars['String']>;
  /** The created at date of the net return program */
  createdAt: Scalars['ISO8601DateTime'];
  /** The currency associated with the net return program */
  currency: Scalars['String'];
  /** The ID of the net return program */
  id: Scalars['ID'];
  /** The incoterm associated with the net return program */
  incoterm: Scalars['String'];
  /** The inventory code associated with the net return program */
  inventoryCode?: Maybe<Scalars['String']>;
  /** The packing week associated with the net return program */
  packingWeek: Scalars['String'];
  /** The price minor unit associated with the net return program */
  priceMinorUnit: Scalars['Int'];
  /** The price term associated with the net return program */
  priceTerm: Scalars['String'];
  /** The price unit associated with the net return program */
  priceUnit: Scalars['String'];
  /** The ID of the program */
  programId: Scalars['ID'];
  /** The name of the program */
  programName: Scalars['String'];
  /** The visibility of the program */
  programVisibility: Scalars['String'];
  /** The quantity associated with the net return program */
  quantity: Scalars['Int'];
  /** The quantity unit associated with the net return program */
  quantityUnit: Scalars['String'];
  /** The reference number associated with the net return program */
  referenceNumber?: Maybe<Scalars['String']>;
  /** The seller associated with the net return program */
  seller?: Maybe<Company>;
  /** The ID of the seller associated with the net return program */
  sellerId?: Maybe<Scalars['ID']>;
  /** The name of the seller associated with the net return program */
  sellerName?: Maybe<Scalars['String']>;
  /** The size counts associated with the net return program */
  sizeCounts: Scalars['String'];
  /** The stack size associated with the net return program */
  stackSize: Scalars['Int'];
  /** The target market associated with the net return program */
  targetMarket?: Maybe<Scalars['String']>;
  /** The trade country associated with the net return program */
  tradeCountry?: Maybe<TradeCountry>;
  /** The ID of the trade country associated with the net return program */
  tradeCountryId?: Maybe<Scalars['ID']>;
  /** The name of the trade country associated with the net return program */
  tradeCountryName?: Maybe<Scalars['String']>;
  /** The trade region associated with the net return program */
  tradeRegion?: Maybe<TradeRegion>;
  /** The ID of the trade region associated with the net return program */
  tradeRegionId: Scalars['ID'];
  /** The name of the trade region associated with the net return program */
  tradeRegionName: Scalars['String'];
  /** The updated at date of the net return program */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The variety associated with the net return program */
  variety?: Maybe<Variety>;
  /** The ID of the variety associated with the net return program */
  varietyId: Scalars['ID'];
  /** The name of the variety associated with the net return program */
  varietyName: Scalars['String'];
};

/** Attributes for creating a net return program and its associated program */
export type NetReturnProgramAttributes = {
  /** The ID of the net return program */
  id?: Maybe<Scalars['ID']>;
  /** The name of the program */
  programName: Scalars['String'];
  /** The visibility of the program */
  programVisibility: Scalars['String'];
  /** The ID of the commodity associated with the program */
  commodityId: Scalars['ID'];
  /** The ID of the variety associated with the program */
  varietyId: Scalars['ID'];
  /** The name of the carton type associated with the program */
  cartonTypeName: Scalars['String'];
  /** The ID of the trade region associated with the program */
  tradeRegionId: Scalars['ID'];
  /** The ID of the trade country associated with the program */
  tradeCountryId?: Maybe<Scalars['ID']>;
  /** The ID of the seller associated with the program */
  sellerId?: Maybe<Scalars['ID']>;
  /** The ID of the buyer associated with the program */
  buyerId?: Maybe<Scalars['ID']>;
  /** The additional fields associated with the program */
  additionalFields: Scalars['String'];
  /** The batch number associated with the program */
  batchNumber?: Maybe<Scalars['String']>;
  /** The currency associated with the program */
  currency: Scalars['String'];
  /** The Incoterm associated with the program */
  incoterm: Scalars['String'];
  /** The inventory code associated with the program */
  inventoryCode?: Maybe<Scalars['String']>;
  /** The packing week associated with the program */
  packingWeek: Scalars['String'];
  /** The stack size associated with the program */
  stackSize: Scalars['Int'];
  /** The price minor unit associated with the program */
  priceMinorUnit: Scalars['Int'];
  /** The price term associated with the program */
  priceTerm: Scalars['String'];
  /** The price unit associated with the program */
  priceUnit: Scalars['String'];
  /** The quantity associated with the program */
  quantity: Scalars['Int'];
  /** The quantity unit associated with the program */
  quantityUnit: Scalars['String'];
  /** The reference number associated with the program */
  referenceNumber?: Maybe<Scalars['String']>;
  /** The size counts associated with the program */
  sizeCounts: Array<Scalars['String']>;
  /** The target market associated with the program */
  targetMarket?: Maybe<Scalars['String']>;
  /** The configured unit associated with the program */
  configuredUnit?: Maybe<Scalars['String']>;
  /** The configured currency associated with the program */
  configuredCurrency?: Maybe<Scalars['String']>;
};

export type NonEphytoShipmentLineItem = {
  __typename?: 'NonEphytoShipmentLineItem';
  /** Unique identifier for the shipment line item */
  id: Scalars['Int'];
  /** Label displayed to easily identify the SLI */
  labelDisplay?: Maybe<Scalars['String']>;
  /** This could be Shipment or AirFreightShipment related */
  type?: Maybe<Scalars['String']>;
};

export type NotifiableUnion = Comment;

/** returns details notification item model */
export type NotificationItem = {
  __typename?: 'NotificationItem';
  /** the unique identifier for the entity that the notification item is associated with */
  entityId?: Maybe<Scalars['ID']>;
  /** the type of the entity that the notification item is associated with */
  entityType?: Maybe<Scalars['String']>;
  /** the unique identifier for the notification item */
  id?: Maybe<Scalars['ID']>;
};

/** returns details notification rule model */
export type NotificationRule = {
  __typename?: 'NotificationRule';
  /** Overridable time thresholds from rule conditions, as [{ field, operator, value }]. Each field can be overridden per-user via subscription config. */
  defaultThresholds: Scalars['JSON'];
  /** the description of the notification rule */
  description?: Maybe<Scalars['String']>;
  /** the unique identifier for the channel notification */
  id?: Maybe<Scalars['ID']>;
  /** the name of the notification rule */
  name?: Maybe<Scalars['String']>;
  /** the subscription for the notification rule */
  notificationRuleSubscription?: Maybe<NotificationRuleSubscription>;
  /** unique human readable identifier for the notification rule */
  notificationSlug?: Maybe<NotificationSlugEnum>;
  /** the severity of the notification rule */
  severity?: Maybe<NotificationRuleSeverityEnum>;
};

/** Severity level of a notification rule */
export enum NotificationRuleSeverityEnum {
  /** Notification rule severity is info */
  Info = 'info',
  /** Notification rule severity is warning */
  Warning = 'warning',
  /** Notification rule severity is critical */
  Critical = 'critical',
  /** Notification rule severity is alert */
  Alert = 'alert'
}

/** returns details of a notification rule subscription */
export type NotificationRuleSubscription = {
  __typename?: 'NotificationRuleSubscription';
  /** Per-user configuration for this subscription, e.g. { threshold: { field, value } } for time-based rules */
  config: Scalars['JSON'];
  /** whether the subscription is enabled */
  enabled: Scalars['Boolean'];
  /** the unique identifier for the notification rule subscription */
  id?: Maybe<Scalars['ID']>;
  /** Last successful scheduled run time for this subscription */
  lastRunAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Next scheduled run time for this subscription */
  nextRunAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the notification rule that the subscription is for */
  notificationRule?: Maybe<NotificationRule>;
  /** whether the user wants to receive email notifications for this rule */
  notifyEmail: Scalars['Boolean'];
  /** whether the user wants to receive mobile notifications for this rule */
  notifyMobile: Scalars['Boolean'];
  /** whether the user wants to receive web notifications for this rule */
  notifyWeb: Scalars['Boolean'];
  /** whether the user wants to receive WhatsApp notifications for this rule */
  notifyWhatsapp: Scalars['Boolean'];
  /** Optional per-user cron override for scheduled rules */
  scheduleCron?: Maybe<Scalars['String']>;
};

/** Attributes for a notification rule subscription */
export type NotificationRuleSubscriptionAttributes = {
  /** The slug of the notification rule to subscribe to/update */
  notificationRuleSlug: Scalars['String'];
  /** Whether the user wants to receive notifications for this rule */
  enabled: Scalars['Boolean'];
  /** Whether the user wants to receive email notifications for this rule */
  notifyEmail: Scalars['Boolean'];
  /** Whether the user wants to receive web notifications for this rule */
  notifyWeb: Scalars['Boolean'];
  /** Whether the user wants to receive WhatsApp notifications for this rule */
  notifyWhatsapp: Scalars['Boolean'];
  /** Whether the user wants to receive mobile notifications for this rule */
  notifyMobile?: Maybe<Scalars['Boolean']>;
  /** Optional per-user cron override for scheduled rules (uses rule default when blank) */
  scheduleCron?: Maybe<Scalars['String']>;
  /** The configuration for the notification rule subscription eg. time duration */
  config?: Maybe<Scalars['JSON']>;
};

export enum NotificationSlugEnum {
  /** The notification slug: example */
  Example = 'example',
  /** The notification slug: client_change_request */
  ClientChangeRequest = 'client_change_request',
  /** The notification slug: offer */
  Offer = 'offer'
}

export enum NotificationTypeEnum {
  Update = 'update',
  Alert = 'alert'
}

/** returns details about an offer between a buyer and a supplier */
export type Offer = {
  __typename?: 'Offer';
  /** the buyer of the offer */
  buyer?: Maybe<Company>;
  /** the ID of the buyer of the offer */
  buyerId?: Maybe<Scalars['ID']>;
  /** the company that created the offer */
  company?: Maybe<Company>;
  /** the ID of the company that created the offer */
  companyId?: Maybe<Scalars['ID']>;
  /** Offers that were created in response to this one */
  counterOffers?: Maybe<Array<Offer>>;
  /** when the offer was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the currency of the offer */
  currency?: Maybe<CurrencyEnum>;
  /** the description of the offer */
  description?: Maybe<Scalars['String']>;
  /** when the offer expires */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the unique identifier for the offer */
  id: Scalars['ID'];
  /** the incoterm of the offer */
  incoterm?: Maybe<IncotermEnum>;
  /** the initial quantity of the offer */
  initialQuantity?: Maybe<Scalars['Int']>;
  /** whether the root offer was created with the pricing deferred to the buyer */
  isRootOfferOpenPrice?: Maybe<Scalars['Boolean']>;
  /** whether the root offer was created with the quantity deferred to the buyer */
  isRootOfferOpenQuantity?: Maybe<Scalars['Boolean']>;
  /** the items associated with the offer */
  offerItems?: Maybe<Array<OfferItem>>;
  /** the recipients of the offer */
  offerRecipients?: Maybe<Array<OfferRecipient>>;
  /** the order that was created from the offer */
  order?: Maybe<Order>;
  /** the ID of the order that was created from the offer */
  orderId?: Maybe<Scalars['ID']>;
  /** the pack type of the offer */
  packType?: Maybe<Scalars['String']>;
  /** the packing week of the offer */
  packingWeek?: Maybe<Scalars['String']>;
  /** the pallet stack of the offer */
  palletStack?: Maybe<Scalars['Int']>;
  /** the previous offer in the negotiation chain */
  previousOffer?: Maybe<Offer>;
  /** the previous offer in the negotiation chain */
  previousOfferId?: Maybe<Scalars['ID']>;
  /** the price term of the offer */
  priceTerm?: Maybe<OfferPriceTermEnum>;
  /** the quantity available/ requested for the offer */
  quantity?: Maybe<Scalars['Int']>;
  /** the quantity unit for the available/ requested/ initial quantity of the offer */
  quantityUnit?: Maybe<OfferQuantityUnitEnum>;
  /** the root offer that started this negotiation chain */
  rootOffer?: Maybe<Offer>;
  /** the root offer that started this negotiation chain */
  rootOfferId?: Maybe<Scalars['ID']>;
  /** the seller of the offer */
  seller?: Maybe<Company>;
  /** the ID of the seller of the offer */
  sellerId?: Maybe<Scalars['ID']>;
  /** the state of the offer eg. active or closed */
  state?: Maybe<OfferStateEnum>;
  /** the title of the offer */
  title?: Maybe<Scalars['String']>;
  /** the trade region of the offer */
  tradeRegion?: Maybe<TradeRegion>;
  /** the ID of the trade region of the offer */
  tradeRegionId?: Maybe<Scalars['ID']>;
  /** when the offer was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the user that created the offer */
  user?: Maybe<User>;
  /** the variety of the offer */
  variety?: Maybe<Variety>;
  /** the ID of the variety of the offer */
  varietyId?: Maybe<Scalars['ID']>;
};

/** Attributes used by a supplier to create a new broadcast offer */
export type OfferAttributes = {
  /** The ID of the seller */
  sellerId: Scalars['ID'];
  /** The title of the offer */
  title: Scalars['String'];
  /** The description of the offer */
  description?: Maybe<Scalars['String']>;
  /** The ID of the variety of the offer */
  varietyId: Scalars['ID'];
  /** The ID of the trade region of the offer */
  tradeRegionId: Scalars['ID'];
  /** The currency of the offer */
  currency: CurrencyEnum;
  /** The incoterm of the offer */
  incoterm: IncotermEnum;
  /** The packing week of the offer */
  packingWeek: Scalars['String'];
  /** The pack type of the offer e.g. A15C */
  packType: Scalars['String'];
  /** The pallet stack of the offer */
  palletStack: Scalars['Int'];
  /** The price term of the offer */
  priceTerm: OfferPriceTermEnum;
  /** When the offer expires */
  expiresAt: Scalars['ISO8601DateTime'];
  /** The initial quantity of the offer */
  initialQuantity: Scalars['Int'];
  /** The quantity available/ requested for the offer */
  quantity: Scalars['Int'];
  /** The quantity unit for the available/ requested/ initial quantity of the offer */
  quantityUnit: OfferQuantityUnitEnum;
  /** The items associated with the offer containing fruit spec and quantity; pricing lives in nested offer_item_prices */
  offerItems: Array<OfferItemAttributes>;
  /** The recipients of the offer */
  offerRecipients: Array<OfferRecipientAttributes>;
};

/** The connection type for Offer. */
export type OfferConnection = {
  __typename?: 'OfferConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfferEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Offer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OfferEdge = {
  __typename?: 'OfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Offer>;
};

/** Attributes to filter offers by */
export type OfferFilterAttribute = {
  __typename?: 'OfferFilterAttribute';
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** ports of destination you want to filter by */
  portsOfDestination?: Maybe<Array<SeaPort>>;
  /** trade regions you want to filter by */
  tradeRegions?: Maybe<Array<TradeRegion>>;
  /** varieties you want to filter by */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes to filter offers by */
export type OfferFilterAttributes = {
  /** buyers you want to filter by (matches offers broadcast to these buyers via offer recipients) */
  buyerIds?: Maybe<Array<Scalars['ID']>>;
  /** commodities you want to filter by (resolves through variety -> commodity) */
  commodityIds?: Maybe<Array<Scalars['ID']>>;
  /** varieties you want to filter by */
  varietyIds?: Maybe<Array<Scalars['ID']>>;
  /** trade regions you want to filter by */
  tradeRegionIds?: Maybe<Array<Scalars['ID']>>;
  /** ports of destination you want to filter by (matches the recipient's pinned port — the buyer's port is set by the supplier at broadcast time) */
  portOfDestinationIds?: Maybe<Array<Scalars['ID']>>;
};

/** returns details about an offer item associated with an offer */
export type OfferItem = {
  __typename?: 'OfferItem';
  /** the date and time when the offer item was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the grade for the offer item (A, B, C, etc.) */
  grade?: Maybe<Scalars['String']>;
  /** the unique identifier for the offer item */
  id: Scalars['ID'];
  /** the initial quantity for the offer item */
  initialQuantity?: Maybe<Scalars['Int']>;
  /** the offer that the offer item is associated with */
  offer?: Maybe<Offer>;
  /** the ID of the offer that the offer item is associated with */
  offerId?: Maybe<Scalars['ID']>;
  /** pricing associated with the offer item; CIF and DIP prices are captured here based on port of destination */
  offerItemPrices?: Maybe<Array<OfferItemPrice>>;
  /** the quantity for the offer item */
  quantity?: Maybe<Scalars['Int']>;
  /** the quantity unit for the offer item */
  quantityUnit?: Maybe<OfferItemQuantityUnitEnum>;
  /** the size counts for the offer item */
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  /** the date and time when the offer item was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Attributes used by a supplier to create an offer item */
export type OfferItemAttributes = {
  /** The size counts for the offer item */
  sizeCounts: Array<Scalars['String']>;
  /** The grade for the offer item (A, B, C, etc.) */
  grade: Scalars['String'];
  /** The quantity for the offer item */
  quantity: Scalars['Int'];
  /** The quantity unit for the offer item */
  quantityUnit: OfferItemQuantityUnitEnum;
  /** pricing associated with the offer item; CIF and DIP prices are captured here based on port of destination */
  offerItemPrices: Array<OfferItemPriceAttributes>;
};

/** returns details about an offer item price associated with an offer item */
export type OfferItemPrice = {
  __typename?: 'OfferItemPrice';
  /** the CIF price amount for the offer item, can be blank if the buyer sets the price */
  cifPriceAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** the DIP price amount for the offer item, what the seller needs to net from the trade after shipping costs */
  dipPriceAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Net return for the CIF price converted to a target incoterm/currency/unit */
  expectedReturnSummary?: Maybe<OfferItemPriceExpectedReturn>;
  /** the unique identifier for the offer item price */
  id: Scalars['ID'];
  /** the offer item that the offer item price is associated with */
  offerItem?: Maybe<OfferItem>;
  /** the ID of the offer item that the offer item price is associated with */
  offerItemId?: Maybe<Scalars['ID']>;
  /** port of destination this price applies to, used for incoterm calculations */
  portOfDestination?: Maybe<SeaPort>;
  /** the ID of the port of destination this price applies to */
  portOfDestinationId?: Maybe<Scalars['ID']>;
  /** the price unit for the offer item price */
  priceUnit?: Maybe<OfferItemPricePriceUnitEnum>;
};


/** returns details about an offer item price associated with an offer item */
export type OfferItemPriceExpectedReturnSummaryArgs = {
  currency?: Maybe<CurrencyEnum>;
  incoterm?: Maybe<IncotermWithNscEnum>;
  unit?: Maybe<Scalars['String']>;
};

/** Attributes used by a supplier to create an offer item price */
export type OfferItemPriceAttributes = {
  /** port of destination this price applies to (required); used for incoterm calculations */
  portOfDestinationId: Scalars['ID'];
  /** the DIP price amount for the offer item, what the seller needs to net from the trade after shipping costs */
  dipPriceAmountMajorUnit: Scalars['BigDecimal'];
  /** the CIF price amount for the offer item, can be blank if the buyer sets the price */
  cifPriceAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** The price unit for the offer item price */
  priceUnit: OfferItemPricePriceUnitEnum;
};

/** Expected return for an offer item price converted to a target incoterm */
export type OfferItemPriceExpectedReturn = {
  __typename?: 'OfferItemPriceExpectedReturn';
  conversionPriceAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  currency?: Maybe<Scalars['String']>;
  incoterm?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

/** The price unit available for offer item prices. */
export enum OfferItemPricePriceUnitEnum {
  /** The offer item price price unit is carton */
  Carton = 'carton'
}

/** The quantity unit available for offer items. */
export enum OfferItemQuantityUnitEnum {
  /** The offer item quantity unit is pallet */
  Pallet = 'pallet'
}

/** The different price terms available for offers. */
export enum OfferPriceTermEnum {
  /** The offer price term is mgp */
  Mgp = 'mgp',
  /** The offer price term is fixed */
  Fixed = 'fixed',
  /** The offer price term is consignment */
  Consignment = 'consignment'
}

/** The quantity unit available for offers. */
export enum OfferQuantityUnitEnum {
  /** The offer quantity unit is pallet */
  Pallet = 'pallet'
}

/** returns details about an offer recipient associated with an offer */
export type OfferRecipient = {
  __typename?: 'OfferRecipient';
  /** the buyer that the offer recipient is associated with */
  buyer?: Maybe<Company>;
  /** the ID of the buyer that the offer recipient is associated with */
  buyerId?: Maybe<Scalars['ID']>;
  /** who should be notified about the offer */
  contactUser?: Maybe<User>;
  /** the ID of the user that should be notified about the offer */
  contactUserId?: Maybe<Scalars['ID']>;
  /** when the offer recipient was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the unique identifier for the offer recipient */
  id: Scalars['ID'];
  /** the offer that the offer recipient is associated with */
  offer?: Maybe<Offer>;
  /** the ID of the offer that the offer recipient is associated with */
  offerId?: Maybe<Scalars['ID']>;
  /** port of destination associated with the offer recipient, used to link buyer to offer item prices */
  portOfDestination?: Maybe<SeaPort>;
  /** the ID of the port of destination associated with the offer recipient */
  portOfDestinationId?: Maybe<Scalars['ID']>;
  /** the state of the negotiation between the buyer and the supplier eg. pending_buyer, pending_supplier, won, lost */
  state?: Maybe<OfferRecipientStateEnum>;
  /** when the offer recipient was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Attributes used by a supplier to create a new offer recipient */
export type OfferRecipientAttributes = {
  /** The ID of the buyer */
  buyerId: Scalars['ID'];
  /** port the supplier pins this buyer to (required); buyers cannot change their port — it carries forward through every counter in the chain */
  portOfDestinationId: Scalars['ID'];
};

/** The different states available for offer recipients. */
export enum OfferRecipientStateEnum {
  /** The offer recipient state is pending_buyer */
  PendingBuyer = 'pending_buyer',
  /** The offer recipient state is pending_supplier */
  PendingSupplier = 'pending_supplier',
  /** The offer recipient state is won */
  Won = 'won',
  /** The offer recipient state is lost */
  Lost = 'lost',
  /** The offer recipient state is superseded */
  Superseded = 'superseded'
}

/** The different states available for offers. */
export enum OfferStateEnum {
  /** The offer state is active */
  Active = 'active',
  /** The offer state is closed */
  Closed = 'closed'
}

/** OnePack client code for pushing pack instructions to NSOffice */
export type OnepackClientCode = {
  __typename?: 'OnepackClientCode';
  /** Client code used when pushing pack instructions to OnePack */
  clientCode: Scalars['String'];
  /** Unique identifier for the OnePack client code */
  id: Scalars['ID'];
  /** Display label for the client code */
  label: Scalars['String'];
};

/** A OnePack pack-instruction push to NSOffice;HTTP status, response message, and whether it succeeded */
export type OnepackPackInstructionSyncCall = {
  __typename?: 'OnepackPackInstructionSyncCall';
  /** Client code from request metadata */
  clientCode?: Maybe<Scalars['String']>;
  /** When the request was made */
  createdAt: Scalars['ISO8601DateTime'];
  /** Platform API call id */
  id: Scalars['ID'];
  /** Number of pack instruction line items in the request */
  itemsCount: Scalars['Int'];
  /** Response message and validation detail when present */
  message?: Maybe<Scalars['String']>;
  /** HTTP status code */
  statusCode?: Maybe<Scalars['String']>;
  /** Whether the HTTP response indicates success */
  syncSucceeded: Scalars['Boolean'];
  /** Request URL */
  url: Scalars['String'];
};

export type OrchardResult = {
  __typename?: 'OrchardResult';
  /** Whether it has applied for eu status */
  applied: Scalars['String'];
  /** Flag if it passed BD test */
  bd: Scalars['String'];
  /** Flag if it passed CBS test */
  cbs: Scalars['String'];
  /** Current status whether commodity can go to EU market */
  currentEuStatus: Scalars['String'];
  /** Flag whether commodity is for EU */
  eu: Scalars['String'];
  /** PUC identifier */
  farmCode: Scalars['String'];
  /** Flag if it passed FMS test */
  fms: Scalars['String'];
  /** Unique Orchard identifier */
  id?: Maybe<Scalars['ID']>;
  /** Orchard name */
  orchardName: Scalars['String'];
  /** Phyto data for orchard */
  phytoData: Scalars['String'];
  /** Whether orchard has been verified */
  verified: Scalars['String'];
};

export type OrchardSeason = {
  __typename?: 'OrchardSeason';
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  fboOrchard: FboOrchard;
  foodBusinessOperator: FoodBusinessOperator;
  hectares: Scalars['Float'];
  id: Scalars['Int'];
  plantedDate?: Maybe<Scalars['ISO8601DateTime']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Basic attributes for updating an Orchard Season */
export type OrchardSeasonAttributes = {
  endDate: Scalars['ISO8601DateTime'];
  hectares: Scalars['Float'];
  id: Scalars['Int'];
  plantedDate: Scalars['ISO8601DateTime'];
  startDate: Scalars['ISO8601DateTime'];
};

export type OrchardYield = {
  __typename?: 'OrchardYield';
  captureDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  orchardSeasonId: Scalars['Int'];
  weight: Scalars['Float'];
  weightPerBin?: Maybe<Scalars['Float']>;
};

/** Basic attributes for creating & updating an orchard yield */
export type OrchardYieldAttributes = {
  captureDate: Scalars['ISO8601DateTime'];
  id?: Maybe<Scalars['Int']>;
  orchardSeasonId?: Maybe<Scalars['Int']>;
  weight: Scalars['Float'];
  weightPerBin?: Maybe<Scalars['Float']>;
};

/** returns details about the order model */
export type Order = {
  __typename?: 'Order';
  /** the audit trail associated with the order */
  audits?: Maybe<Array<Audit>>;
  /** the buyer associated with the order */
  buyer?: Maybe<Company>;
  /** the comments associated with the order */
  comments?: Maybe<Array<Comment>>;
  /** when the order was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Deal sheet fields when this order is a deal sheet */
  dealSheetDetail?: Maybe<YieldDealSheetDetail>;
  /** child orders (deal sheets) when this order is a parent */
  dealSheets?: Maybe<Array<Order>>;
  /** the unique identifier for the order */
  id?: Maybe<Scalars['Int']>;
  /** whether the order is a packhouse run, packhouse runs are ordersrequesting all the fruit from a specific packhouse */
  isPackhouseRun?: Maybe<Scalars['Boolean']>;
  /** the line item groupings associated with the order */
  lineItemGroupings?: Maybe<Array<LineItemGrouping>>;
  /** the line items associated with the order */
  lineItems?: Maybe<Array<LineItem>>;
  /** the parent order when this order is a deal sheet */
  parentOrder?: Maybe<Order>;
  /** ID of the parent order when this order is a deal sheet */
  parentOrderId?: Maybe<Scalars['ID']>;
  /** the seller associated with the order */
  seller?: Maybe<Company>;
  /** the shipment documents associated with the order */
  shipmentDocuments?: Maybe<Array<ShipmentDocument>>;
  /** the state of the order */
  state?: Maybe<Scalars['String']>;
  /** when the order was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the user associated with the order */
  user?: Maybe<User>;
};

export type OrderBy = {
  column?: Maybe<OrderByColumn>;
  direction?: Maybe<OrderByDirection>;
};

export enum OrderByColumn {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at',
  ReferenceNumber = 'reference_number',
  SellerName = 'seller_name',
  BuyerName = 'buyer_name',
  Id = 'id',
  State = 'state'
}

export enum OrderByDirection {
  Asc = 'asc',
  Desc = 'desc'
}

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderFilter = {
  buyercontains?: Maybe<Scalars['String']>;
  buyerids?: Maybe<Array<Scalars['Int']>>;
  commoditycontains?: Maybe<Scalars['String']>;
  commodityseasonids?: Maybe<Array<Scalars['Int']>>;
  ordering?: Maybe<Array<OrderBy>>;
  packingweekcontains?: Maybe<Scalars['String']>;
  packingweekends?: Maybe<Scalars['String']>;
  packingweekstarts?: Maybe<Scalars['String']>;
  referencestartswith?: Maybe<Scalars['String']>;
  sellercontains?: Maybe<Scalars['String']>;
  sellerids?: Maybe<Array<Scalars['Int']>>;
  /** only return orders with this state */
  states?: Maybe<Array<StateFilter>>;
  /** only include orders that one of these companies participate in */
  companyIds?: Maybe<Array<Scalars['Int']>>;
};

/** Attributes to filter orders by */
export type OrderFilterAttribute = {
  __typename?: 'OrderFilterAttribute';
  /** buyers you want to filter by */
  buyers?: Maybe<Array<Company>>;
  /** commodities you want to filter by */
  commodities?: Maybe<Array<Commodity>>;
  /** sellers you want to filter by */
  sellers?: Maybe<Array<Company>>;
  /** varieties you want to filter by */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes to filter orders by */
export type OrderFilterAttributes = {
  /** buyers you want to filter by */
  buyerIds?: Maybe<Array<Scalars['ID']>>;
  /** sellers you want to filter by */
  sellerIds?: Maybe<Array<Scalars['ID']>>;
  /** states you want to filter by */
  states?: Maybe<Array<OrderStateEnum>>;
  /** commodities you want to filter by */
  commodityIds?: Maybe<Array<Scalars['ID']>>;
  /** varieties you want to filter by */
  varietyIds?: Maybe<Array<Scalars['ID']>>;
  /** start of packing week you want to filter by */
  packingWeekStart?: Maybe<Scalars['String']>;
  /** end of packing week you want to filter by */
  packingWeekEnd?: Maybe<Scalars['String']>;
};

/** returns details about the order program model */
export type OrderProgram = {
  __typename?: 'OrderProgram';
  /** A list of default values for extra fields that are not part of the standard fields, set by the user */
  additionalFields?: Maybe<Scalars['Json']>;
  /** the batch number associated with the order program */
  batchNumber?: Maybe<Scalars['String']>;
  /** the id of the carton count associated with the order program */
  cartonCountId?: Maybe<Scalars['ID']>;
  /** the carton type associated with the order program */
  cartonType?: Maybe<CartonType>;
  /** the id of the carton type associated with the order program */
  cartonTypeId?: Maybe<Scalars['ID']>;
  /** the name of the carton type associated with the order program */
  cartonTypeName?: Maybe<Scalars['String']>;
  /** the commodity associated with the order program */
  commodity?: Maybe<Commodity>;
  /** the id of the commodity associated with the order program */
  commodityId?: Maybe<Scalars['ID']>;
  /** the name of the commodity associated with the order program */
  commodityName?: Maybe<Scalars['String']>;
  /** the company associated with the order program */
  company?: Maybe<Company>;
  /** the id of the company associated with the order program */
  companyId?: Maybe<Scalars['ID']>;
  /** the url of the company associated with the order program logo */
  companyLogoImageUrl?: Maybe<Scalars['String']>;
  /** the name of the company associated with the order program */
  companyName?: Maybe<Scalars['String']>;
  /** when the order program was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the currency of the order program */
  currency?: Maybe<Scalars['String']>;
  /** the grade associated with the order program */
  grade?: Maybe<Scalars['String']>;
  /** the fields that are hidden from the user */
  hiddenFields?: Maybe<Array<Scalars['String']>>;
  /** the unique identifier for the order program */
  id?: Maybe<Scalars['ID']>;
  /** the incoterm associated with the order program */
  incoterm?: Maybe<Scalars['String']>;
  /** the inventory code associated with the order program */
  inventoryCode?: Maybe<Scalars['String']>;
  /** the mark associated with the order program */
  mark?: Maybe<Scalars['String']>;
  /** the port of destination associated with the order program */
  portOfDestination?: Maybe<SeaPort>;
  /** the id of the port of destination associated with the order program */
  portOfDestinationId?: Maybe<Scalars['ID']>;
  /** the name of the port of destination associated with the order program */
  portOfDestinationName?: Maybe<Scalars['String']>;
  /** the port of loading associated with the order program */
  portOfLoading?: Maybe<SeaPort>;
  /** the id of the port of loading associated with the order program */
  portOfLoadingId?: Maybe<Scalars['ID']>;
  /** the name of the port of loading associated with the order program */
  portOfLoadingName?: Maybe<Scalars['String']>;
  /** the price amount in the major unit of the currency for a given price unit */
  priceAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** the price term of the order program, e.g. "Fixed", "Consignment" or "MGP */
  priceTerm?: Maybe<Scalars['String']>;
  /** the price unit of the order program, e.g. "carton" or "ton" */
  priceUnit?: Maybe<Scalars['String']>;
  /** the priority associated with the order program */
  priority?: Maybe<Scalars['String']>;
  /** the program associated with the order program */
  program?: Maybe<Program>;
  /** the id of the program associated with the order program */
  programId?: Maybe<Scalars['ID']>;
  /** the name of the program associated with the order program */
  programName?: Maybe<Scalars['String']>;
  /** the visibility of the program associated with the order program */
  programVisibility?: Maybe<ProgramVisibilityEnum>;
  /** the quantity of the goods being ordered per quantity unit */
  quantity?: Maybe<Scalars['Int']>;
  /** the quantity unit of the order program, e.g. "carton", "pallet" or "containers" */
  quantityUnit?: Maybe<Scalars['String']>;
  /** the reference number associated with the order program */
  referenceNumber?: Maybe<Scalars['String']>;
  /** the size counts associated with the order program */
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  /** the stack size associated with the order program */
  stackSize?: Maybe<Scalars['Int']>;
  /** the target market where the fruit will be shipped to in the order */
  targetMarket?: Maybe<Scalars['String']>;
  /** the country where the fruit will be shipped to in the order */
  tradeCountry?: Maybe<TradeCountry>;
  /** the code of the trade country associated with the order program */
  tradeCountryCode?: Maybe<Scalars['String']>;
  /** the id of the trade country associated with the order program */
  tradeCountryId?: Maybe<Scalars['ID']>;
  /** the name of the trade country associated with the order program */
  tradeCountryName?: Maybe<Scalars['String']>;
  /** where the fruit will be shipped to in the order */
  tradeRegion?: Maybe<TradeRegion>;
  /** the code of the trade region associated with the order program */
  tradeRegionCode?: Maybe<Scalars['String']>;
  /** the id of the trade region associated with the order program */
  tradeRegionId?: Maybe<Scalars['ID']>;
  /** the name of the trade region associated with the order program */
  tradeRegionName?: Maybe<Scalars['String']>;
  /** when the order program was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the variety associated with the order program */
  variety?: Maybe<Variety>;
  /** the code of the variety associated with the order program */
  varietyCode?: Maybe<Scalars['String']>;
  /** the id of the variety associated with the order program */
  varietyId?: Maybe<Scalars['ID']>;
  /** the name of the variety associated with the order program */
  varietyName?: Maybe<Scalars['String']>;
};

/** Attributes for creating an order program and associated program */
export type OrderProgramAttributes = {
  /** The name of the program */
  programName: Scalars['String'];
  /** The id of the company associated with the order program */
  companyId?: Maybe<Scalars['ID']>;
  /** The id of the trade region associated with the order program */
  tradeRegionId?: Maybe<Scalars['ID']>;
  /** The visibility of the program */
  programVisibility: ProgramVisibilityEnum;
  /** the fields that are hidden from the user */
  hiddenFields?: Maybe<Array<Scalars['String']>>;
  /** The priority of the order program */
  priority?: Maybe<Scalars['String']>;
  /** The batch number of the order program */
  batchNumber?: Maybe<Scalars['String']>;
  /** The reference number of the order program */
  referenceNumber?: Maybe<Scalars['String']>;
  /** The inventory code of the order program */
  inventoryCode?: Maybe<Scalars['String']>;
  /** The id of the trade country associated with the order program */
  tradeCountryId?: Maybe<Scalars['ID']>;
  /** The target market of the order program */
  targetMarket?: Maybe<Scalars['String']>;
  /** The id of the port of loading associated with the order program */
  portOfLoadingId?: Maybe<Scalars['ID']>;
  /** The id of the port of destination associated with the order program */
  portOfDestinationId?: Maybe<Scalars['ID']>;
  /** The id of the commodity associated with the order program */
  commodityId: Scalars['ID'];
  /** The id of the variety associated with the order program */
  varietyId: Scalars['ID'];
  /** The id of the carton type associated with the order program */
  cartonTypeId: Scalars['ID'];
  /** The size counts of the order program */
  sizeCounts: Array<Scalars['String']>;
  /** The stack size of the order program */
  stackSize: Scalars['Int'];
  /** The grade of the order program */
  grade: Scalars['String'];
  /** The mark of the order program */
  mark?: Maybe<Scalars['String']>;
  /** The incoterm of the order program */
  incoterm: IncotermEnum;
  /** The currency of the order program */
  currency: CurrencyEnum;
  /** the price term of the order program, e.g. "Fixed", "Consignment" or "MGP */
  priceTerm?: Maybe<Scalars['String']>;
  /** the price unit of the order program, e.g. "carton" or "ton" */
  priceUnit?: Maybe<Scalars['String']>;
  /** the price amount in the major unit of the currency for a given price unit */
  priceAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** the quantity unit of the order program, e.g. "carton", "pallet" or "containers" */
  quantityUnit?: Maybe<Scalars['String']>;
  /** the quantity of the goods being ordered per quantity unit */
  quantity?: Maybe<Scalars['Int']>;
  /** the additional field default values of the order program */
  additionalFields: Scalars['String'];
};

/** Attributes to filter order programs by */
export type OrderProgramFilterAttributes = {
  /** companies you want to filter programs by */
  companyIds?: Maybe<Array<Scalars['ID']>>;
  /** target regions you want to filter by */
  targetRegions?: Maybe<Array<Scalars['String']>>;
  /** commodities you want to filter by */
  commodityIds?: Maybe<Array<Scalars['ID']>>;
  /** varieties you want to filter by */
  varietyIds?: Maybe<Array<Scalars['ID']>>;
  /** inventory codes you want to filter by */
  inventoryCodes?: Maybe<Array<Scalars['String']>>;
  /** target countries you want to filter by */
  targetCountries?: Maybe<Array<Scalars['String']>>;
  /** target markets you want to filter by */
  targetMarkets?: Maybe<Array<Scalars['String']>>;
  /** incoterms you want to filter by */
  incoterms?: Maybe<Array<Scalars['String']>>;
  /** currencies you want to filter by */
  currencies?: Maybe<Array<Scalars['String']>>;
  /** grades you want to filter by */
  grades?: Maybe<Array<Scalars['String']>>;
};

export type OrderSearch = {
  __typename?: 'OrderSearch';
  orders?: Maybe<Array<Order>>;
  totalFiltered?: Maybe<Scalars['Int']>;
  totalOrders?: Maybe<Scalars['Int']>;
};


export type OrderSearchOrdersArgs = {
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

export enum OrderStateEnum {
  Accepted = 'ACCEPTED',
  AtColdStore = 'AT_COLD_STORE',
  AtOriginPort = 'AT_ORIGIN_PORT',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Expired = 'EXPIRED',
  InTransit = 'IN_TRANSIT',
  Packed = 'PACKED',
  PartiallyAccepted = 'PARTIALLY_ACCEPTED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartiallyPacked = 'PARTIALLY_PACKED',
  WontPack = 'WONT_PACK'
}

export type OrdersSearchFilterAttributes = {
  __typename?: 'OrdersSearchFilterAttributes';
  /** unique set of commodities used on line items */
  commodities?: Maybe<Array<Commodity>>;
  /** unique set of trade partners that appear on line items */
  companies?: Maybe<Array<Company>>;
  /** unique set of sub-commodities used on line items */
  subCommodities?: Maybe<Array<SubCommodity>>;
  /** unique set of varieties used on line items */
  varieties?: Maybe<Array<Variety>>;
};

export type OutputFile = {
  __typename?: 'OutputFile';
  /** Unique identifier for the blob */
  blobId: Scalars['ID'];
  /** MIME type of the file */
  contentType: Scalars['String'];
  /** Original filename */
  filename: Scalars['String'];
  /** Unique identifier for the file */
  id: Scalars['ID'];
  /** Timestamp when the file was uploaded */
  uploadedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** URL for the file */
  v2Url: Scalars['String'];
};

export type PackInstructionLineItem = {
  __typename?: 'PackInstructionLineItem';
  /** arbitrary fields saved onto a line item */
  additionalFields?: Maybe<Scalars['Json']>;
  /** arbitrary grouping of line items */
  batchNumber?: Maybe<Scalars['String']>;
  /** purchasing company name */
  buyer?: Maybe<Scalars['String']>;
  /** line item comments */
  comments?: Maybe<Array<Comment>>;
  /** commodity name */
  commodity?: Maybe<Scalars['String']>;
  /** Currency of the price major unit field */
  currency?: Maybe<Scalars['String']>;
  /** price in major unit, including currency symbol and price unit, e.g. $1 / carton */
  formattedPrice?: Maybe<Scalars['String']>;
  /** quality indicator */
  grade?: Maybe<Scalars['String']>;
  /** unique identifier showing cumulative grouping */
  groupId?: Maybe<Scalars['Int']>;
  /** unique identifier */
  id?: Maybe<Scalars['Int']>;
  incoterm?: Maybe<Scalars['String']>;
  /** inventory code */
  inventoryCode?: Maybe<Scalars['String']>;
  /** identifying word or number on freight */
  mark?: Maybe<Scalars['String']>;
  /** order identifier */
  orderId?: Maybe<Scalars['Int']>;
  /** code indicating which box to pack fruit into */
  pack?: Maybe<Scalars['String']>;
  /** isoweek when fruit is going to be or was packed */
  packingWeek?: Maybe<Scalars['String']>;
  /** number of cartons on a pallet */
  palletStack?: Maybe<Scalars['Int']>;
  /** the price of a unit expressed in the major unit of the currency */
  priceMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** specifies the price term (fixed, mgp or consignment) */
  priceTerm?: Maybe<Scalars['String']>;
  /** the unit being priced, can be per carton or per ton */
  priceUnit?: Maybe<Scalars['String']>;
  /** priority of order */
  priority?: Maybe<Scalars['Int']>;
  /** quantities packed per size count */
  quantitesPacked?: Maybe<Array<Scalars['Int']>>;
  /** quantities requested */
  quantityRequested?: Maybe<Scalars['Int']>;
  /** quantity unit */
  quantityUnit?: Maybe<Scalars['String']>;
  /** reference number */
  referenceNumber?: Maybe<Scalars['String']>;
  /** selling company name */
  seller?: Maybe<Scalars['String']>;
  /** indication of commodity size */
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  /** state */
  state?: Maybe<Scalars['String']>;
  /** sub commodity name */
  subCommodity?: Maybe<Scalars['String']>;
  /** target country */
  targetCountry?: Maybe<Scalars['String']>;
  /** target market */
  targetMarket?: Maybe<Scalars['String']>;
  /** target region */
  targetRegion?: Maybe<Scalars['String']>;
  /** variety name */
  variety?: Maybe<Scalars['String']>;
  /** main code associated with the seller farm variety */
  varietyCode?: Maybe<Scalars['String']>;
};

export enum PackInstructionStateEnum {
  Overdue = 'OVERDUE',
  Packed = 'PACKED',
  PackhouseRun = 'PACKHOUSE_RUN',
  PartiallyPacked = 'PARTIALLY_PACKED',
  ToPack = 'TO_PACK',
  OverPacked = 'OVER_PACKED'
}

export type PackInstructionsAttributes = {
  /** Packing Week to filter on */
  endWeek: Scalars['String'];
  /** Packing Week to filter on */
  startWeek: Scalars['String'];
  /** States to filter on */
  states?: Maybe<Array<PackInstructionStateEnum>>;
  /** Varieties to filter on */
  varietyIds?: Maybe<Array<Scalars['Int']>>;
  /** Commmodities to filter on */
  commodityIds?: Maybe<Array<Scalars['Int']>>;
  /** Buyers to filter on */
  buyerIds?: Maybe<Array<Scalars['Int']>>;
  /** Sellers to filter on */
  sellerIds?: Maybe<Array<Scalars['Int']>>;
  /** Sub Commodities to filter on */
  subCommodityIds?: Maybe<Array<Scalars['Int']>>;
  /** Only return entries that contain these reference numbers (wild card, case insensitive) */
  referenceNumbers?: Maybe<Array<Scalars['String']>>;
};

export type PackInstructionsFilterAttribute = {
  __typename?: 'PackInstructionsFilterAttribute';
  /** this company's buyers */
  buyers?: Maybe<Array<Company>>;
  /** this company's commodityes */
  commodities?: Maybe<Array<Commodity>>;
  /** this company's sellers */
  sellers?: Maybe<Array<Company>>;
  /** this company's commodityes */
  subCommodities?: Maybe<Array<SubCommodity>>;
  /** this company's varieties */
  varieties?: Maybe<Array<Variety>>;
};

/** Represents a packhouse connection allowing a company to monitor/view packhouse data */
export type PackhouseConnection = {
  __typename?: 'PackhouseConnection';
  /** The ID of the on-prem server (electron app) for this connection */
  apiUserId: Scalars['Int'];
  /** The company that has monitoring/visibility rights for this connection */
  company: Company;
  /** Whether the server is currently connected */
  connected: Scalars['Boolean'];
  /** When this connection record was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The packhouse this connection serves */
  foodBusinessOperator: FoodBusinessOperator;
  /** Unique identifier for this connection */
  id: Scalars['ID'];
  /** Most recent datetime processed from packhouse database */
  lastProcessedDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The masterfile config associated with this packhouse connection */
  masterfileConfig?: Maybe<MasterfileConfig>;
  /** User-friendly name for this connection (e.g., "Packhouse A - Main Server") */
  name: Scalars['String'];
  /** The type of on-prem system this connection is connected to */
  onPremSystem?: Maybe<Scalars['String']>;
  /** When the installation is scheduled for */
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Details of when installation was scheduled via Hubspot */
  scheduledFor?: Maybe<Scalars['String']>;
  /** Connection state: pending_verification, scheduled, or installed */
  state: Scalars['String'];
  /** When this connection record was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A client change request for a packhouse connection */
export type PackhouseConnectionClientChangeRequest = {
  __typename?: 'PackhouseConnectionClientChangeRequest';
  /** The company that has monitoring/visibility rights for this connection */
  company?: Maybe<Company>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The packhouse this connection serves */
  foodBusinessOperator?: Maybe<FoodBusinessOperator>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['ID']>;
  /** The ID of the packhouse */
  packhouseId?: Maybe<Scalars['ID']>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Contains information on pallet ins */
export type PalletIn = {
  __typename?: 'PalletIn';
  /** Unique identifier of the Pallet In */
  id?: Maybe<Scalars['ID']>;
  /** Unique identifier of the load out instruction associated with this pallet in */
  loadOutInstructionId?: Maybe<Scalars['ID']>;
  /** The document produced for this pallet in */
  outputFile?: Maybe<Document>;
  /** State of the template generation (created, processing, completed) */
  state?: Maybe<Scalars['String']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Contains information on pallet outs */
export type PalletOut = {
  __typename?: 'PalletOut';
  /** Unique identifier of the addendum header associated with this pallet out */
  addendumHeaderId?: Maybe<Scalars['ID']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']>;
  /** The document produced for this pallet out */
  outputFile?: Maybe<Document>;
  /** State of the template generation (created, processing, completed) */
  state?: Maybe<Scalars['String']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Returns the Cg erros as errors from pallet rules validations. */
export type PalletRuleError = {
  __typename?: 'PalletRuleError';
  /** ID of the cg error */
  id?: Maybe<Scalars['ID']>;
  /** The reason why the rule failed */
  reason?: Maybe<Scalars['Int']>;
  /** The rule that failed as an error type */
  ruleError?: Maybe<Scalars['String']>;
  /** The resolution status of this error */
  state?: Maybe<Scalars['String']>;
};

/** Fields available on a payment */
export type Payment = {
  __typename?: 'Payment';
  /** Allocated amount of money paid in major unit */
  allocatedAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Bank charges for the payment in major unit */
  bankChargesMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Split of bank charges between the companies */
  bankChargesSplit?: Maybe<BankChargeSplitEnum>;
  /** Reference to the cashbook entry in client system */
  cashbookReference?: Maybe<Scalars['String']>;
  /** The company that made/ received the payment */
  company?: Maybe<Company>;
  /** Identifier of the company that made/ received the payment */
  companyId?: Maybe<Scalars['ID']>;
  /** Name of the company that made/ received the payment */
  companyName?: Maybe<Scalars['String']>;
  /** The contact involved in the transaction */
  contact?: Maybe<Contact>;
  /** Identifier of the contact involved in the transaction */
  contactId?: Maybe<Scalars['ID']>;
  /** Name of the contact involved in the transaction */
  contactName?: Maybe<Scalars['String']>;
  /** Date and time the payment was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Currency the payment was made in */
  currency?: Maybe<Scalars['String']>;
  /** Currency exchange rate for the payment */
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** Description of the payment */
  description?: Maybe<Scalars['String']>;
  /** Exchange rate for the payment */
  exchangeRate?: Maybe<Scalars['String']>;
  /** Unique payment identifier */
  id?: Maybe<Scalars['ID']>;
  /** Payment allocations per invoice */
  invoicePaymentAllocations?: Maybe<Array<InvoicePaymentAllocation>>;
  /** Invoices ascociated with the payment */
  invoices?: Maybe<Array<Invoice>>;
  /** Date the payment was made */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Type of payment, i.e. Receipt, Disbursement, etc. */
  paymentType?: Maybe<PaymentTypeEnum>;
  /** Remaining amount of money paid in major unit */
  remainingAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** State of the payment */
  state?: Maybe<PaymentStateEnum>;
  /** Total amount of money paid in major unit */
  totalAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Date and time the payment was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Attributes for creating or updating a payment allocation */
export type PaymentAllocationAttributes = {
  /** Amount to be allocated */
  amount: Scalars['BigDecimal'];
  /** ID of the invoice to allocate the payment to */
  invoiceId: Scalars['ID'];
  /** ID of the payment to be allocated */
  paymentId: Scalars['ID'];
  /** Remove allocation if true */
  removeAllocation?: Maybe<Scalars['Boolean']>;
};

/** Attributes for creating a payment */
export type PaymentAttributes = {
  /** Paid amount in major unit */
  totalAmountMajorUnit: Scalars['BigDecimal'];
  /** Allocated amount in major unit */
  allocatedAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Remaining amount in major unit */
  remainingAmountMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Amount of bank charges */
  bankChargesMajorUnit?: Maybe<Scalars['BigDecimal']>;
  /** Split of bank charges */
  bankChargesSplit?: Maybe<Scalars['String']>;
  /** Reference to the current company's cashbook */
  cashbookReference?: Maybe<Scalars['String']>;
  /** ID of the current company */
  companyId: Scalars['ID'];
  /** Currency of the payment */
  currency: Scalars['String'];
  /** Description of the payment */
  description?: Maybe<Scalars['String']>;
  /** ID of the contact involved in the transaction */
  contactId: Scalars['ID'];
  /** Date of the payment */
  paymentDate: Scalars['ISO8601DateTime'];
  /** Type of payment eg. 'credit', 'debit' */
  paymentType: Scalars['String'];
};

/** The connection type for Payment. */
export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Payment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Payment>;
};

/** Payment filter attribute for populating frontend filters */
export type PaymentFilterAttribute = {
  __typename?: 'PaymentFilterAttribute';
  /** Contacts for this user's payments */
  contacts?: Maybe<Array<Contact>>;
};

export enum PaymentStateEnum {
  Unallocated = 'unallocated',
  PartiallyAllocated = 'partially_allocated',
  Allocated = 'allocated'
}

export enum PaymentTypeEnum {
  Incoming = 'incoming',
  Outgoing = 'outgoing'
}

/** Filtering options for payments */
export type PaymentsFilters = {
  /** filter by the contact id */
  contactIds?: Maybe<Array<Scalars['ID']>>;
  /** filter by the currency */
  currencies?: Maybe<Array<Scalars['String']>>;
  /** filter by the payment type */
  paymentTypes?: Maybe<Array<Scalars['String']>>;
  /** filter by the payment state */
  states?: Maybe<Array<Scalars['String']>>;
  /** only fetch unallocated or partially allocated payments */
  unallocatedOrPartiallyAllocated?: Maybe<Scalars['Boolean']>;
  /** only fetch payments with payment_date on or after this date (inclusive) */
  fromDate?: Maybe<Scalars['ISO8601Date']>;
  /** only fetch payments with payment_date on or before this date (inclusive) */
  toDate?: Maybe<Scalars['ISO8601Date']>;
};

export type Permission = {
  __typename?: 'Permission';
  key?: Maybe<PermissionEnum>;
  value?: Maybe<Scalars['Boolean']>;
};

export enum PermissionEnum {
  /** Whether the Demo page is available */
  PagesDemo = 'pages_demo',
  /** Whether the Dashboard page is available */
  PagesDashboard = 'pages_dashboard',
  /** Whether the Settings page is available */
  PagesSettings = 'pages_settings',
  /** Whether the Company page is available */
  PagesCompany = 'pages_company',
  /** Whether the Orders page is available */
  PagesOrders = 'pages_orders',
  /** Whether the Vieworder page is available */
  PagesViewOrder = 'pages_viewOrder',
  /** Whether the Neworder page is available */
  PagesNewOrder = 'pages_newOrder',
  /** Whether the Partners page is available */
  PagesPartners = 'pages_partners',
  /** Whether the Planning page is available */
  PagesPlanning = 'pages_planning',
  /** Whether the Packinstructions page is available */
  PagesPackInstructions = 'pages_packInstructions',
  /** Whether the Cashflow page is available */
  PagesCashFlow = 'pages_cashFlow',
  /** Whether the Commercialterms page is available */
  PagesCommercialTerms = 'pages_commercialTerms',
  /** Whether the Insights page is available */
  PagesInsights = 'pages_insights',
  /** Whether the Loadoutinstructions page is available */
  PagesLoadOutInstructions = 'pages_loadOutInstructions',
  /** Whether the Commercialinvoices page is available */
  PagesCommercialInvoices = 'pages_commercialInvoices',
  /** Whether the Estimations page is available */
  PagesEstimations = 'pages_estimations',
  /** Whether the Shipments page is available */
  PagesShipments = 'pages_shipments',
  /** Whether the Airfreightshipments page is available */
  PagesAirFreightShipments = 'pages_airFreightShipments',
  /** Whether the Dataexports page is available */
  PagesDataExports = 'pages_dataExports',
  /** Whether the Financepipeline page is available */
  PagesFinancePipeline = 'pages_financePipeline',
  /** Whether the Customerinvoices page is available */
  PagesCustomerInvoices = 'pages_customerInvoices',
  /** Whether the Defaultcosts page is available */
  PagesDefaultCosts = 'pages_defaultCosts',
  /** Whether the Payments page is available */
  PagesPayments = 'pages_payments',
  /** Whether the Stock page is available */
  PagesStock = 'pages_stock',
  /** Whether the Financeindex page is available */
  PagesFinanceIndex = 'pages_financeIndex',
  /** Whether the Profitandloss page is available */
  PagesProfitAndLoss = 'pages_profitAndLoss',
  /** Whether the Masterfiles page is available */
  PagesMasterfiles = 'pages_masterfiles',
  /** Whether the Financerulemanagement page is available */
  PagesFinanceRuleManagement = 'pages_financeRuleManagement',
  /** Whether the Vendorinvoices page is available */
  PagesVendorInvoices = 'pages_vendorInvoices',
  /** Whether the Claims page is available */
  PagesClaims = 'pages_claims',
  /** Whether the Incotermcalculator page is available */
  PagesIncotermCalculator = 'pages_incotermCalculator',
  /** Whether the Knowledgebase page is available */
  PagesKnowledgeBase = 'pages_knowledgeBase',
  /** Whether the Inspections page is available */
  PagesInspections = 'pages_inspections',
  /**
   * Whether the Orders
   * page should allow the Viewprice
   * action for this user
   */
  OrdersViewPrice = 'orders_viewPrice',
  /**
   * Whether the Orders
   * page should allow the Duplicateorder
   * action for this user
   */
  OrdersDuplicateOrder = 'orders_duplicateOrder',
  /**
   * Whether the Vieworder
   * page should allow the Acceptandwontpacktoggle
   * action for this user
   */
  ViewOrderAcceptAndWontPackToggle = 'viewOrder_acceptAndWontPackToggle',
  /**
   * Whether the Vieworder
   * page should allow the Addorremovelineitem
   * action for this user
   */
  ViewOrderAddOrRemoveLineItem = 'viewOrder_addOrRemoveLineItem',
  /**
   * Whether the Vieworder
   * page should allow the Addorremovelineitemgroup
   * action for this user
   */
  ViewOrderAddOrRemoveLineItemGroup = 'viewOrder_addOrRemoveLineItemGroup',
  /**
   * Whether the Vieworder
   * page should allow the Duplicateorder
   * action for this user
   */
  ViewOrderDuplicateOrder = 'viewOrder_duplicateOrder',
  /**
   * Whether the Vieworder
   * page should allow the Editbatchnumber
   * action for this user
   */
  ViewOrderEditBatchNumber = 'viewOrder_editBatchNumber',
  /**
   * Whether the Vieworder
   * page should allow the Editcommodity
   * action for this user
   */
  ViewOrderEditCommodity = 'viewOrder_editCommodity',
  /**
   * Whether the Vieworder
   * page should allow the Editgrade
   * action for this user
   */
  ViewOrderEditGrade = 'viewOrder_editGrade',
  /**
   * Whether the Vieworder
   * page should allow the Editincoterm
   * action for this user
   */
  ViewOrderEditIncoterm = 'viewOrder_editIncoterm',
  /**
   * Whether the Vieworder
   * page should allow the Editinventorycode
   * action for this user
   */
  ViewOrderEditInventoryCode = 'viewOrder_editInventoryCode',
  /**
   * Whether the Vieworder
   * page should allow the Editmark
   * action for this user
   */
  ViewOrderEditMark = 'viewOrder_editMark',
  /**
   * Whether the Vieworder
   * page should allow the Editorder
   * action for this user
   */
  ViewOrderEditOrder = 'viewOrder_editOrder',
  /**
   * Whether the Vieworder
   * page should allow the Editpackingweek
   * action for this user
   */
  ViewOrderEditPackingWeek = 'viewOrder_editPackingWeek',
  /**
   * Whether the Vieworder
   * page should allow the Editpacktype
   * action for this user
   */
  ViewOrderEditPackType = 'viewOrder_editPackType',
  /**
   * Whether the Vieworder
   * page should allow the Editplannedquantity
   * action for this user
   */
  ViewOrderEditPlannedQuantity = 'viewOrder_editPlannedQuantity',
  /**
   * Whether the Vieworder
   * page should allow the Editpriority
   * action for this user
   */
  ViewOrderEditPriority = 'viewOrder_editPriority',
  /**
   * Whether the Vieworder
   * page should allow the Editreferencenumber
   * action for this user
   */
  ViewOrderEditReferenceNumber = 'viewOrder_editReferenceNumber',
  /**
   * Whether the Vieworder
   * page should allow the Editrequestedquantity
   * action for this user
   */
  ViewOrderEditRequestedQuantity = 'viewOrder_editRequestedQuantity',
  /**
   * Whether the Vieworder
   * page should allow the Editsizecounts
   * action for this user
   */
  ViewOrderEditSizeCounts = 'viewOrder_editSizeCounts',
  /**
   * Whether the Vieworder
   * page should allow the Editstacksize
   * action for this user
   */
  ViewOrderEditStackSize = 'viewOrder_editStackSize',
  /**
   * Whether the Vieworder
   * page should allow the Edittargetcountry
   * action for this user
   */
  ViewOrderEditTargetCountry = 'viewOrder_editTargetCountry',
  /**
   * Whether the Vieworder
   * page should allow the Edittargetmarket
   * action for this user
   */
  ViewOrderEditTargetMarket = 'viewOrder_editTargetMarket',
  /**
   * Whether the Vieworder
   * page should allow the Edittargetregion
   * action for this user
   */
  ViewOrderEditTargetRegion = 'viewOrder_editTargetRegion',
  /**
   * Whether the Vieworder
   * page should allow the Editvariety
   * action for this user
   */
  ViewOrderEditVariety = 'viewOrder_editVariety',
  /**
   * Whether the Vieworder
   * page should allow the Grouplineitemtoggle
   * action for this user
   */
  ViewOrderGroupLineItemToggle = 'viewOrder_groupLineItemToggle',
  /**
   * Whether the Vieworder
   * page should allow the Viewcomments
   * action for this user
   */
  ViewOrderViewComments = 'viewOrder_viewComments',
  /**
   * Whether the Vieworder
   * page should allow the Viewpallets
   * action for this user
   */
  ViewOrderViewPallets = 'viewOrder_viewPallets',
  /**
   * Whether the Vieworder
   * page should allow the Viewprice
   * action for this user
   */
  ViewOrderViewPrice = 'viewOrder_viewPrice',
  /**
   * Whether the Vieworder
   * page should allow the Viewtimeline
   * action for this user
   */
  ViewOrderViewTimeline = 'viewOrder_viewTimeline',
  /**
   * Whether the Vieworder
   * page should allow the Staticorderlineitemtable additionalfield
   * action for this user
   */
  ViewOrderStaticOrderLineItemTableAdditionalField = 'viewOrder_staticOrderLineItemTable_additionalField',
  /**
   * Whether the Planning
   * page should allow the Allocatable
   * action for this user
   */
  PlanningAllocatable = 'planning_allocatable',
  /**
   * Whether the Packinstructions
   * page should allow the Onepackpush
   * action for this user
   */
  PackInstructionsOnepackPush = 'packInstructions_onepackPush',
  /**
   * Whether the Estimations
   * page should allow the Edit
   * action for this user
   */
  EstimationsEdit = 'estimations_edit',
  /**
   * Whether the General
   * page should allow the Netreturnscalc
   * action for this user
   */
  GeneralNetReturnsCalc = 'general_netReturnsCalc',
  /**
   * Whether the General
   * page should allow the Exportactions
   * action for this user
   */
  GeneralExportActions = 'general_exportActions',
  /**
   * Whether the General
   * page should allow the Accountingexportpermission
   * action for this user
   */
  GeneralAccountingExportPermission = 'general_accountingExportPermission',
  /**
   * Whether the General
   * page should allow the Accountingsupplierexportpermission
   * action for this user
   */
  GeneralAccountingSupplierExportPermission = 'general_accountingSupplierExportPermission',
  /**
   * Whether the General
   * page should allow the Accountsalepermission
   * action for this user
   */
  GeneralAccountSalePermission = 'general_accountSalePermission',
  /**
   * Whether the Loadoutinstructions
   * page should allow the Viewloioceantab
   * action for this user
   */
  LoadOutInstructionsViewLoiOceanTab = 'loadOutInstructions_viewLoiOceanTab',
  /**
   * Whether the Loadoutinstructions
   * page should allow the Viewloiroadtab
   * action for this user
   */
  LoadOutInstructionsViewLoiRoadTab = 'loadOutInstructions_viewLoiRoadTab',
  /**
   * Whether the Loadoutinstructions
   * page should allow the Viewloiairtab
   * action for this user
   */
  LoadOutInstructionsViewLoiAirTab = 'loadOutInstructions_viewLoiAirTab',
  /**
   * Whether the Oceanshipments
   * page should allow the Exporttoppecb
   * action for this user
   */
  OceanShipmentsExportToPpecb = 'oceanShipments_exportToPPECB',
  /**
   * Whether the Oceanshipments
   * page should allow the Exportnotificationtab
   * action for this user
   */
  OceanShipmentsExportNotificationTab = 'oceanShipments_exportNotificationTab',
  /**
   * Whether the Oceanshipments
   * page should allow the Addendumtab
   * action for this user
   */
  OceanShipmentsAddendumTab = 'oceanShipments_addendumTab',
  /**
   * Whether the Oceanshipments
   * page should allow the Ephytotab
   * action for this user
   */
  OceanShipmentsEphytoTab = 'oceanShipments_ephytoTab',
  /**
   * Whether the Oceanshipments
   * page should allow the Rmsvoyages
   * action for this user
   */
  OceanShipmentsRmsVoyages = 'oceanShipments_rmsVoyages',
  /**
   * Whether the Oceanshipments
   * page should allow the Phytcleanvalidation
   * action for this user
   */
  OceanShipmentsPhytcleanValidation = 'oceanShipments_phytcleanValidation',
  /**
   * Whether the Oceanshipments
   * page should allow the Cargoduestab
   * action for this user
   */
  OceanShipmentsCargoDuesTab = 'oceanShipments_cargoDuesTab',
  /**
   * Whether the Oceanshipments
   * page should allow the Roadshipmentstab
   * action for this user
   */
  OceanShipmentsRoadShipmentsTab = 'oceanShipments_roadShipmentsTab',
  /**
   * Whether the Oceanshipments
   * page should allow the Oceanshipmentstab
   * action for this user
   */
  OceanShipmentsOceanShipmentsTab = 'oceanShipments_oceanShipmentsTab',
  /**
   * Whether the Oceanshipments
   * page should allow the Airshipmentstab
   * action for this user
   */
  OceanShipmentsAirShipmentsTab = 'oceanShipments_airShipmentsTab',
  /**
   * Whether the Masterfiles
   * page should allow the Farmvarieties
   * action for this user
   */
  MasterfilesFarmVarieties = 'masterfiles_farmVarieties',
  /**
   * Whether the Masterfiles
   * page should allow the Orchards
   * action for this user
   */
  MasterfilesOrchards = 'masterfiles_orchards',
  /**
   * Whether the Masterfiles
   * page should allow the Foodbusinessoperators
   * action for this user
   */
  MasterfilesFoodBusinessOperators = 'masterfiles_foodBusinessOperators',
  /**
   * Whether the Masterfiles
   * page should allow the Cartonconversions
   * action for this user
   */
  MasterfilesCartonConversions = 'masterfiles_cartonConversions',
  /**
   * Whether the Masterfiles
   * page should allow the Errors
   * action for this user
   */
  MasterfilesErrors = 'masterfiles_errors',
  /**
   * Whether the Masterfiles
   * page should allow the Packhouses
   * action for this user
   */
  MasterfilesPackhouses = 'masterfiles_packhouses',
  /**
   * Whether the Inspections
   * page should allow the Manager
   * action for this user
   */
  InspectionsManager = 'inspections_manager',
  /**
   * Whether the Offers
   * page should allow the Whatsapprecipient
   * action for this user
   */
  OffersWhatsappRecipient = 'offers_whatsappRecipient'
}

export type Permissions = {
  __typename?: 'Permissions';
  landingPage?: Maybe<PermissionEnum>;
  permissions?: Maybe<Array<Permission>>;
};

export type PnlLinkedRecord = {
  __typename?: 'PnlLinkedRecord';
  amountMajorUnit?: Maybe<Scalars['Float']>;
  /** Total cartons (producer statements only) */
  cartons?: Maybe<Scalars['Int']>;
  /** Number of CGs on this record */
  cgCount?: Maybe<Scalars['Int']>;
  contactName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['ISO8601Date']>;
  documentType?: Maybe<Scalars['String']>;
  /** URL to download the document (producer statements only) */
  downloadUrl?: Maybe<Scalars['String']>;
  /** FX rate used to convert amount to reporting currency (same logic as P&L report) */
  exchangeRateToReporting?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  invoiceNumber?: Maybe<Scalars['String']>;
  isPayment: Scalars['Boolean'];
  rawDocumentType?: Maybe<Scalars['String']>;
  /** invoice or payment */
  recordType: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type PopulateContainer = {
  __typename?: 'PopulateContainer';
  /** Commercial term related to the CGs in container */
  commercialTerm?: Maybe<CommercialTerm>;
  /** Invoice Line Item built from container data */
  invoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** POD associated to the container */
  portOfDestination?: Maybe<SeaPort>;
  /** POL associated to the container */
  portOfLoading?: Maybe<SeaPort>;
  /** Vessel that the container is loaded on */
  vessel?: Maybe<Vessel>;
  /** Voyage related to the vessel */
  voyage?: Maybe<Scalars['String']>;
};

export type PortArrival = {
  __typename?: 'PortArrival';
  /** The date that the vessel will be arriving */
  arrivalDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date that this information was received */
  observedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The port that the vessel will be arriving at */
  seaPort?: Maybe<SeaPort>;
  /** The vessel that is going to be arriving */
  vessel?: Maybe<Vessel>;
  /** The outgoing voyage number for the incoming vessel */
  voyage?: Maybe<Scalars['String']>;
};

export type PpecbActivityPoint = {
  __typename?: 'PpecbActivityPoint';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PpecbContainerType = {
  __typename?: 'PpecbContainerType';
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PpecbCountry = {
  __typename?: 'PpecbCountry';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PpecbExporter = {
  __typename?: 'PpecbExporter';
  /** Company associated with the PPECB exporter */
  company?: Maybe<Company>;
  /** Code representing the exporter FBO */
  exporterFboCode?: Maybe<Scalars['String']>;
  /** Unique ID associated with the PPECB exporter */
  id: Scalars['ID'];
  /** Code representing the registered exporter in PPECB */
  ppecbRegisteredExporterCode?: Maybe<Scalars['String']>;
};

export type PpecbPort = {
  __typename?: 'PpecbPort';
  /** Timestamp when this record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for this PpecbPort record. */
  id: Scalars['ID'];
  /** The code assigned to the port, used to match against SeaPort's unlocode. */
  portCode?: Maybe<Scalars['String']>;
  /** The name of the port according to PPECB. */
  portName?: Maybe<Scalars['String']>;
  /** Timestamp when this record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PpecbProduct = {
  __typename?: 'PpecbProduct';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PpecbRegimeCode = {
  __typename?: 'PpecbRegimeCode';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  loadSpecification?: Maybe<Scalars['String']>;
  maxProductTemp?: Maybe<Scalars['Float']>;
  minProductTemp?: Maybe<Scalars['Float']>;
  recipeDescription?: Maybe<Scalars['String']>;
  regimeCode?: Maybe<Scalars['String']>;
  regimeDescription?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PpecbUser = {
  __typename?: 'PpecbUser';
  /** Code representing the agent FBO */
  agentFboCode?: Maybe<Scalars['String']>;
  /** Unique ID associated with the PPECB user */
  id: Scalars['ID'];
  /** List of exporters associated with the PPECB user */
  ppecbExporters?: Maybe<Array<PpecbExporter>>;
  /** Code representing the registered agent in PPECB */
  ppecbRegisteredAgentCode?: Maybe<Scalars['String']>;
  /** User associated with the PPECB user */
  user?: Maybe<User>;
};

export type PpecbVent = {
  __typename?: 'PpecbVent';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PpecbVoyageNumber = {
  __typename?: 'PpecbVoyageNumber';
  /** Unique ID associated with the PPECB voyage */
  id: Scalars['ID'];
  /** PPECB registered voyage number */
  ppecbVoyageNumber?: Maybe<Scalars['String']>;
  /** Name of the vessel */
  vesselName?: Maybe<Scalars['String']>;
  /** Identifier for the voyage */
  voyageNumber?: Maybe<Scalars['String']>;
};

export type PpecbWorldPort = {
  __typename?: 'PpecbWorldPort';
  /** Timestamp when this record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for this PpecbWorldPort record. */
  id: Scalars['ID'];
  /** The code assigned to the port, used to match against SeaPort's unlocode. */
  portCode?: Maybe<Scalars['String']>;
  /** The name of the port according to PPECB. */
  portName?: Maybe<Scalars['String']>;
  /** Timestamp when this record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum PriceUnitEnum {
  /** The line item is priced per ton */
  Ton = 'ton',
  /** The line item is priced per carton */
  Carton = 'carton',
  /** The line item is priced per pallet */
  Pallet = 'pallet',
  /** Cost line only: amount is allocated to revenue line items proportionally by their gross revenue contribution. Only valid on account sales. */
  Revenue = 'revenue'
}

/** Autogenerated return type of ProcessEtlDocument. */
export type ProcessEtlDocumentPayload = {
  __typename?: 'ProcessEtlDocumentPayload';
  document?: Maybe<EtlDocument>;
};

export type ProductionRegion = {
  __typename?: 'ProductionRegion';
  /** The country code of the production region */
  countryCode: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for this production region */
  id: Scalars['ID'];
  /** The name of the production region */
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ProfitAndLossCostCategory = {
  __typename?: 'ProfitAndLossCostCategory';
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
};

export type ProfitAndLossExtendedFieldKey = {
  __typename?: 'ProfitAndLossExtendedFieldKey';
  /** Internal field name (e.g. pallet_base) */
  key: Scalars['String'];
  /** Human-readable label from external_field_name */
  label?: Maybe<Scalars['String']>;
  /** Distinct values for filter dropdown */
  values?: Maybe<Array<Scalars['String']>>;
};

export type ProfitAndLossFilterAttributes = {
  __typename?: 'ProfitAndLossFilterAttributes';
  buyers?: Maybe<Array<IdName>>;
  commodities?: Maybe<Array<IdName>>;
  containers?: Maybe<Array<IdName>>;
  exporterCodes?: Maybe<Array<Scalars['String']>>;
  /** Extended field keys with distinct values for filter dropdowns */
  extendedFieldKeys?: Maybe<Array<ProfitAndLossExtendedFieldKey>>;
  farmCodes?: Maybe<Array<Scalars['String']>>;
  /** Available financial year options for the FY filter dropdown */
  financialYearOptions?: Maybe<Array<FinancialYearOption>>;
  grades?: Maybe<Array<Scalars['String']>>;
  inventoryCodes?: Maybe<Array<Scalars['String']>>;
  marks?: Maybe<Array<Scalars['String']>>;
  packTypes?: Maybe<Array<Scalars['String']>>;
  /** Distinct PO Numbers across non-voided invoices for the company. Returned verbatim (no whitespace normalisation, no case folding). */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  sellers?: Maybe<Array<IdName>>;
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  targetCountries?: Maybe<Array<Scalars['String']>>;
  targetMarkets?: Maybe<Array<Scalars['String']>>;
  targetRegions?: Maybe<Array<Scalars['String']>>;
  varieties?: Maybe<Array<IdName>>;
  vessels?: Maybe<Array<IdName>>;
};

export type ProfitAndLossFilters = {
  startDate?: Maybe<Scalars['ISO8601Date']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  /** Financial year identified by the calendar year the FY ends in (end-year convention, e.g. 2025 = Mar 2024 - Feb 2025 on a Mar-Feb company). Used as default when no start/end date. */
  financialYear?: Maybe<Scalars['Int']>;
  /** Columns to GROUP BY in the SQL aggregation */
  groupBy?: Maybe<Array<Scalars['String']>>;
  /** Filter to specific carton grouping IDs. Used for producer statement generation from selected P&L rows. */
  cartonGroupingIds?: Maybe<Array<Scalars['Int']>>;
  farmCodes?: Maybe<Array<Scalars['String']>>;
  containerIds?: Maybe<Array<Scalars['ID']>>;
  /** Text search fallback — prefer container_ids for dropdown filters */
  containerNumbers?: Maybe<Array<Scalars['String']>>;
  commodityIds?: Maybe<Array<Scalars['ID']>>;
  varietyIds?: Maybe<Array<Scalars['ID']>>;
  /** AR counterparty (invoice party) company IDs. Filter to CGs with income CGTs from these buyers. */
  buyerIds?: Maybe<Array<Scalars['ID']>>;
  /** Producer (farm) company IDs from CGO. Filter to CGs where a CGO has company_id IN list and type farm. */
  sellerIds?: Maybe<Array<Scalars['ID']>>;
  batchNumbers?: Maybe<Array<Scalars['String']>>;
  palletNumbers?: Maybe<Array<Scalars['String']>>;
  exporterCodes?: Maybe<Array<Scalars['String']>>;
  grades?: Maybe<Array<Scalars['String']>>;
  targetRegions?: Maybe<Array<Scalars['String']>>;
  targetMarkets?: Maybe<Array<Scalars['String']>>;
  targetCountries?: Maybe<Array<Scalars['String']>>;
  /** Packing week range start (ISO format: YYYY-WNN) */
  packingWeekStart?: Maybe<Scalars['String']>;
  /** Packing week range end (ISO format: YYYY-WNN) */
  packingWeekEnd?: Maybe<Scalars['String']>;
  marks?: Maybe<Array<Scalars['String']>>;
  packTypes?: Maybe<Array<Scalars['String']>>;
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  inventoryCodes?: Maybe<Array<Scalars['String']>>;
  /** Filter by vessel IDs (from sea_journeys pol_vessel_id/pod_vessel_id) */
  vesselIds?: Maybe<Array<Scalars['ID']>>;
  /** Free text filter on vessel name (ILIKE match via sea_journeys) */
  vesselName?: Maybe<Scalars['String']>;
  /** Free text filter on voyage number (ILIKE match via sea_journeys) */
  voyageNumber?: Maybe<Scalars['String']>;
  /** Shipping week range start (ISO format: YYYY-WNN) */
  shippingWeekStart?: Maybe<Scalars['String']>;
  /** Shipping week range end (ISO format: YYYY-WNN) */
  shippingWeekEnd?: Maybe<Scalars['String']>;
  /** Filter to CGs on specific producer statement numbers */
  paymentAdviceNumbers?: Maybe<Array<Scalars['String']>>;
  /** Filter to rows where at least one CG has a non-voided invoice with po_number in this list (exact string match) */
  poNumbers?: Maybe<Array<Scalars['String']>>;
  /** Per-CG filter: when true, only CGs with a statement. When false, only unstamped CGs. */
  hasPaymentAdvice?: Maybe<Scalars['Boolean']>;
  /** Row-level filter: when false, hides rows where ALL CGs have a statement (shows only rows with at least one unstamped CG). */
  hasProducerStatement?: Maybe<Scalars['Boolean']>;
  /** Target currency for FX conversion (default: company reporting_currency or ZAR) */
  reportingCurrency?: Maybe<Scalars['String']>;
  /** Enable/disable FX conversion */
  fxEnabled?: Maybe<Scalars['Boolean']>;
  /** Page number (1-based) */
  page?: Maybe<Scalars['Int']>;
  /** Rows per page (max 500 per page when paging). Use 0 to return all rows (e.g. Excel export). */
  perPage?: Maybe<Scalars['Int']>;
  /** Sort fields and directions */
  orderByFields?: Maybe<Array<ProfitAndLossOrderBy>>;
  /** When true, include revenue_advance, revenue_final, revenue_credit_note, revenue_debit_note on each row */
  includeRevenueBreakdown?: Maybe<Scalars['Boolean']>;
  /** Filter by extended field values. Key = internal_field_name, value = array of allowed values. */
  extendedFieldFilters?: Maybe<Scalars['JSON']>;
};

export type ProfitAndLossMeta = {
  __typename?: 'ProfitAndLossMeta';
  companyId?: Maybe<Scalars['Int']>;
  costCategories?: Maybe<Array<ProfitAndLossCostCategory>>;
  extendedFieldKeys?: Maybe<Array<Scalars['String']>>;
  fxEnabled?: Maybe<Scalars['Boolean']>;
  groupBy?: Maybe<Array<Scalars['String']>>;
  materializeMs?: Maybe<Scalars['Float']>;
  reportingCurrency?: Maybe<Scalars['String']>;
  rowCount?: Maybe<Scalars['Int']>;
  sqlBuildMs?: Maybe<Scalars['Float']>;
  sqlMs?: Maybe<Scalars['Float']>;
  totalMs?: Maybe<Scalars['Float']>;
};

export type ProfitAndLossOrderBy = {
  /** Column name to sort by */
  field: Scalars['String'];
  /** asc or desc */
  direction?: Maybe<Scalars['String']>;
};

export type ProfitAndLossPageInfo = {
  __typename?: 'ProfitAndLossPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ProfitAndLossReport = {
  __typename?: 'ProfitAndLossReport';
  meta?: Maybe<ProfitAndLossMeta>;
  nodes?: Maybe<Array<ProfitAndLossRow>>;
  pageInfo?: Maybe<ProfitAndLossPageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProfitAndLossReportCompleted = {
  __typename?: 'ProfitAndLossReportCompleted';
  report: ProfitAndLossReport;
  requestId: Scalars['String'];
};

export type ProfitAndLossReportError = {
  __typename?: 'ProfitAndLossReportError';
  error: Scalars['String'];
  requestId: Scalars['String'];
};

export type ProfitAndLossReportNotFound = {
  __typename?: 'ProfitAndLossReportNotFound';
  requestId: Scalars['String'];
};

/** Async P&L report generation outcome */
export type ProfitAndLossReportOutcomeUnion = ProfitAndLossReportCompleted | ProfitAndLossReportError | ProfitAndLossReportNotFound | ProfitAndLossReportPending;

export type ProfitAndLossReportPending = {
  __typename?: 'ProfitAndLossReportPending';
  requestId: Scalars['String'];
};

export type ProfitAndLossRow = {
  __typename?: 'ProfitAndLossRow';
  accountsReceivable?: Maybe<Scalars['Float']>;
  /** True if all CGs in this row have at least one producer statement */
  allOnStatement?: Maybe<Scalars['Boolean']>;
  arrivalWeek?: Maybe<Scalars['String']>;
  batchNumber?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  cashReceived?: Maybe<Scalars['Float']>;
  cashReceivedPerCarton?: Maybe<Scalars['Float']>;
  cashReceivedPerStdCarton?: Maybe<Scalars['Float']>;
  cgCount?: Maybe<Scalars['Int']>;
  /** Total CIF Cost (Freight + Marine Insurance + Receiver Commission + Receiver Cost ex Commission + Repacking) */
  cifCosts?: Maybe<Scalars['Float']>;
  cifCostsInclVat?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['String']>;
  containerNumber?: Maybe<Scalars['String']>;
  /** Original invoice currency (distinct from reporting currency used for amounts) */
  contractCurrency?: Maybe<Scalars['String']>;
  costBreakdown?: Maybe<Scalars['JSON']>;
  /** Total DIP Costs (Certificate Fees + Documentation Fee + Coldstore Cost + Handling Cost + Local Transport + Admin Costs) */
  dipCosts?: Maybe<Scalars['Float']>;
  dipCostsInclVat?: Maybe<Scalars['Float']>;
  dischargePort?: Maybe<Scalars['String']>;
  exporterCode?: Maybe<Scalars['String']>;
  extendedFields?: Maybe<Scalars['JSON']>;
  /** Total EXW Costs (Royalties Pack + Royalties EXW + Royalties FOB) */
  exwCosts?: Maybe<Scalars['Float']>;
  exwCostsInclVat?: Maybe<Scalars['Float']>;
  farmCode?: Maybe<Scalars['String']>;
  /** Total FOB Cost (Temperature Monitoring + Freight Shipment Cost) */
  fobCosts?: Maybe<Scalars['Float']>;
  fobCostsInclVat?: Maybe<Scalars['Float']>;
  grade?: Maybe<Scalars['String']>;
  /** Equal to Net EXW */
  growerFinalPayment?: Maybe<Scalars['Float']>;
  /** Incoterm from highest-priority invoice (tax > advance > account sale > commercial > line item) */
  incoterm?: Maybe<Scalars['String']>;
  inventoryCode?: Maybe<Scalars['String']>;
  linkedBbcIds?: Maybe<Array<Scalars['Int']>>;
  linkedCgIds?: Maybe<Array<Scalars['Int']>>;
  linkedContainerIds?: Maybe<Array<Scalars['Int']>>;
  linkedRecordsCount?: Maybe<Scalars['Int']>;
  /** @deprecated Use fobCosts + dipCosts instead */
  localCosts?: Maybe<Scalars['Float']>;
  /** @deprecated Use fobCostsInclVat + dipCostsInclVat instead */
  localCostsInclVat?: Maybe<Scalars['Float']>;
  mark?: Maybe<Scalars['String']>;
  /** Revenue - Total CIF Cost */
  netCif?: Maybe<Scalars['Float']>;
  netCifInclVat?: Maybe<Scalars['Float']>;
  netCifInclVatPerCarton?: Maybe<Scalars['Float']>;
  netCifInclVatPerStdCarton?: Maybe<Scalars['Float']>;
  netCifPerCarton?: Maybe<Scalars['Float']>;
  netCifPerStdCarton?: Maybe<Scalars['Float']>;
  /** Net FOB - Total DIP Costs */
  netDip?: Maybe<Scalars['Float']>;
  netDipInclVat?: Maybe<Scalars['Float']>;
  netDipInclVatPerCarton?: Maybe<Scalars['Float']>;
  netDipInclVatPerStdCarton?: Maybe<Scalars['Float']>;
  netDipPerCarton?: Maybe<Scalars['Float']>;
  netDipPerStdCarton?: Maybe<Scalars['Float']>;
  /** Net DIP - Total EXW Costs */
  netExw?: Maybe<Scalars['Float']>;
  netExwInclVat?: Maybe<Scalars['Float']>;
  netExwInclVatPerCarton?: Maybe<Scalars['Float']>;
  netExwInclVatPerStdCarton?: Maybe<Scalars['Float']>;
  /** EXW / Raw Carton */
  netExwPerCarton?: Maybe<Scalars['Float']>;
  /** EXW / Standard Carton */
  netExwPerStdCarton?: Maybe<Scalars['Float']>;
  /** Net CIF - Total FOB Cost */
  netFob?: Maybe<Scalars['Float']>;
  netFobInclVat?: Maybe<Scalars['Float']>;
  netFobInclVatPerCarton?: Maybe<Scalars['Float']>;
  netFobInclVatPerStdCarton?: Maybe<Scalars['Float']>;
  netFobPerCarton?: Maybe<Scalars['Float']>;
  netFobPerStdCarton?: Maybe<Scalars['Float']>;
  /** @deprecated Use cifCosts instead */
  overseasCosts?: Maybe<Scalars['Float']>;
  /** @deprecated Use cifCostsInclVat instead */
  overseasCostsInclVat?: Maybe<Scalars['Float']>;
  packType?: Maybe<Scalars['String']>;
  packingWeek?: Maybe<Scalars['String']>;
  palletCount?: Maybe<Scalars['Int']>;
  palletNumber?: Maybe<Scalars['String']>;
  /** Download URL for the latest producer statement on this row */
  paymentAdviceDownloadUrl?: Maybe<Scalars['String']>;
  /** Latest producer statement number for these CGs */
  paymentAdviceNumber?: Maybe<Scalars['String']>;
  /** Highest-priority non-voided invoice PO Number for the row's CG (tax > advance > account_sale > commercial) */
  poNumber?: Maybe<Scalars['String']>;
  revenue?: Maybe<Scalars['Float']>;
  revenueAdvance?: Maybe<Scalars['Float']>;
  revenueCreditNote?: Maybe<Scalars['Float']>;
  revenueDebitNote?: Maybe<Scalars['Float']>;
  revenueFinal?: Maybe<Scalars['Float']>;
  revenueInclVat?: Maybe<Scalars['Float']>;
  revenueInclVatPerCarton?: Maybe<Scalars['Float']>;
  revenueInclVatPerKg?: Maybe<Scalars['Float']>;
  revenueInclVatPerStdCarton?: Maybe<Scalars['Float']>;
  revenuePerCarton?: Maybe<Scalars['Float']>;
  revenuePerKg?: Maybe<Scalars['Float']>;
  revenuePerStdCarton?: Maybe<Scalars['Float']>;
  sellerName?: Maybe<Scalars['String']>;
  shippingWeek?: Maybe<Scalars['String']>;
  sizeCount?: Maybe<Scalars['String']>;
  targetCountry?: Maybe<Scalars['String']>;
  targetMarket?: Maybe<Scalars['String']>;
  targetRegion?: Maybe<Scalars['String']>;
  totalCartons?: Maybe<Scalars['Int']>;
  totalKilograms?: Maybe<Scalars['Float']>;
  totalStdCartons?: Maybe<Scalars['Float']>;
  variety?: Maybe<Scalars['String']>;
  vatTotalCosts?: Maybe<Scalars['Float']>;
  vatTotalRevenue?: Maybe<Scalars['Float']>;
  /** Vessel name when grouped by vessel */
  vesselId?: Maybe<Scalars['String']>;
  vesselName?: Maybe<Scalars['String']>;
  voyageNumber?: Maybe<Scalars['String']>;
};

/** returns details about the program model */
export type Program = {
  __typename?: 'Program';
  /** the company that created the program */
  company?: Maybe<Company>;
  /** the id of the company that created the program */
  companyId?: Maybe<Scalars['ID']>;
  /** when the program was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the unique identifier for the program */
  id?: Maybe<Scalars['ID']>;
  /** the unique user identifiable name of the program */
  name?: Maybe<Scalars['String']>;
  /** the id of the object that the program is associated with */
  programmableId?: Maybe<Scalars['ID']>;
  /** the type of the program eg. OrderProgram */
  programmableType?: Maybe<Scalars['String']>;
  /** when the program was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the user that created the program */
  user?: Maybe<User>;
  /** the id of the user that created the program */
  userId?: Maybe<Scalars['ID']>;
  /** the visibility of the program eg. 'Public', 'Company' or 'Private' */
  visibility?: Maybe<ProgramVisibilityEnum>;
};

export enum ProgramVisibilityEnum {
  Private = 'PRIVATE',
  Company = 'COMPANY',
  Public = 'PUBLIC'
}

/** Autogenerated return type of PushPackInstructionsToOnepack. */
export type PushPackInstructionsToOnepackPayload = {
  __typename?: 'PushPackInstructionsToOnepackPayload';
  /** Whether the push resulted in a platform (from our system) error. If true, then the export did not occur. */
  isPlatformError: Scalars['Boolean'];
  /** Human-readable message when the push did not succeed or for partial failures. */
  message?: Maybe<Scalars['String']>;
  /** Pack instruction reference sent to OnePack (header.pack_instruction_ref). */
  packInstructionRef?: Maybe<Scalars['String']>;
  /** Whether the push to OnePack succeeded. */
  success: Scalars['Boolean'];
};

export enum Quantity {
  Carton = 'CARTON',
  Pallet = 'PALLET',
  Container = 'CONTAINER'
}

/** root query */
export type Query = {
  __typename?: 'Query';
  /** Fetches the specific account statement */
  accountStatement?: Maybe<AccountStatement>;
  /** Fetches a specific accounting export */
  accountingExport?: Maybe<AccountingExport>;
  /** Fetches Addendum */
  addendumHeaderById?: Maybe<AddendumHeader>;
  /** Fetches Addendum Line Items for specific addendum */
  addendumLineItemsByHeaderId?: Maybe<Array<AddendumLineItem>>;
  /** Fetches Addendums on a air freight shipment */
  addendumsOnAirFreightShipment?: Maybe<Array<AddendumHeader>>;
  /** Fetches Addendums on a shipment */
  addendumsOnShipment?: Maybe<Array<AddendumHeader>>;
  /** Gets additional fields configured for companies */
  additionalFields?: Maybe<Array<AdditionalField>>;
  /** Fetches Air Freight Shipment by Id */
  airFreightShipmentById?: Maybe<AirFreightShipment>;
  /** Fetches attributes for air freight shipments filters */
  airFreightShipmentLineItemsByShipment?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Fetches all air freight SLIs with no LOI and `In progress` state */
  airFreightShipmentLineItemsWithNoLoi?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Gets all load out instructions associated with a shipment */
  airFreightShipmentLois?: Maybe<Array<LoadOutInstruction>>;
  /** fetches air freight shipments based on filters or search term */
  airFreightShipments?: Maybe<AirFreightShipmentConnection>;
  /** Fetches attributes for air freight shipments filters */
  airFreightShipmentsFilterAttributes?: Maybe<AirFreightShipmentsFilterAttribute>;
  /** List of allowed currencies */
  allowedCurrencies: Array<Scalars['String']>;
  /** List of allowed incoterms */
  allowedIncoterms: Array<Scalars['String']>;
  /** List of allowed match types */
  allowedMatchTypes: Array<Scalars['String']>;
  /** List of allowed units */
  allowedUnits: Array<Scalars['String']>;
  /** Fetches break bulk containers eligible for arrival QC */
  breakBulkContainersForArrivalQc?: Maybe<Array<BreakBulkContainer>>;
  /** fetches all valid shipment line items that can have Cargo Dues */
  cargoDues?: Maybe<ShipmentLineItemConnection>;
  /** Fetches attributes for Carton Conversion filters */
  cartonConversionFilterAttributes?: Maybe<Array<CartonConversionFilterAttribute>>;
  /** All Carton Conversions for the seller */
  cartonConversions: Array<CartonConversion>;
  /** get all carton counts */
  cartonCounts?: Maybe<Array<CartonCount>>;
  /** All the audits for the specified carton grouping */
  cartonGroupingAudits?: Maybe<Array<CartonGroupingAudit>>;
  cartonGroupingsForLineItem?: Maybe<Array<CartonGrouping>>;
  /** get cartons groupings for a specific week */
  cartonGroupingsForWeek?: Maybe<Array<CartonGrouping>>;
  /**
   * fetchs a list of carton groupings based on the defined search requirements,
   * also returns the total amount of cartons found and
   * the distinct values of certain columns to be used for filters
   */
  cartonGroupingsSearch?: Maybe<CartonGroupingSearch>;
  /** Gets all carton types for a given commodity */
  cartonTypesByCommodity?: Maybe<Array<CartonType>>;
  /** get the iframe url for the cartons per buyer chart for the current user */
  cartonsPerBuyerChartUrl?: Maybe<Scalars['String']>;
  /** get the iframe url for the cartons per seller chart for the current user */
  cartonsPerSellerChartUrl?: Maybe<Scalars['String']>;
  /** Fetches the specific certificate transport instruction */
  certificateTransportInstruction?: Maybe<CertificateTransportInstruction>;
  /** get a list of all known certificate types */
  certificateTypes?: Maybe<Array<CertificateType>>;
  /** Fetches attributes for Cg Error filters */
  cgErrorFilterAttributes?: Maybe<Array<CgErrorFilterAttribute>>;
  /** All Carton Conversions for the seller */
  cgErrors: Array<CgError>;
  /** Gets a channel notification by ID */
  channelNotificationById?: Maybe<ChannelNotification>;
  /** Gets all channel notifications for the current user */
  channelNotifications?: Maybe<ChannelNotificationConnection>;
  /** Gets the count of all channel notifications for the current user */
  channelNotificationsCount?: Maybe<Scalars['Int']>;
  checkTranslationUpdates: Scalars['JSON'];
  /** Fetches all of a company's claims */
  claims?: Maybe<Claims>;
  /** Fetches attributes for commercial term filters */
  commercialTermFilterAttributes?: Maybe<CommercialTermFilterAttribute>;
  /** get all commercial terms */
  commercialTerms?: Maybe<CommercialTermConnection>;
  /** Get all commodities */
  commodities?: Maybe<Array<Commodity>>;
  /** Get all commodity default seasons */
  commodityDefaultSeasons?: Maybe<Array<CommodityDefaultSeason>>;
  /** get the iframe url for the commodity split chart for the current user */
  commoditySplitChartUrl?: Maybe<Scalars['String']>;
  /** Gets a single company */
  company?: Maybe<Company>;
  /** Fetches all Cost Codes configured for the company */
  companyCostCodes?: Maybe<Array<CostCode>>;
  /** Fetches all company payments for the current company */
  companyPayments?: Maybe<Array<CompanyPayment>>;
  /** Fetches attributes for company payment filters */
  companyPaymentsFilterAttributes?: Maybe<CompanyPaymentFilterAttribute>;
  /** Company contacts */
  contacts?: Maybe<Array<Contact>>;
  /** Container */
  containers?: Maybe<Array<Container>>;
  /** Fetches containers eligible for arrival QC */
  containersForArrivalQc?: Maybe<Array<ContainersForArrivalQc>>;
  /** Fetches all containers for a given finance rule */
  containersForFinanceRule?: Maybe<Array<Container>>;
  /** Fetches attributes for cost code filters */
  costCodesFilterAttributes?: Maybe<CostCodeFilterAttribute>;
  /** Fetches the cost line items for the specific invoice */
  costInvoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** Gets counter offers based on search and filter criteria */
  counterOffers?: Maybe<OfferConnection>;
  /** Fetches a currency conversion based on the provided attributes */
  currencyConversion?: Maybe<CurrencyConversion>;
  /** Fetches a currency conversion using the id */
  currencyConversionById?: Maybe<CurrencyConversion>;
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** Get all active map locations for a specific Order */
  currentMapPointsForOrder?: Maybe<Array<MapPoint>>;
  /** Fetches all existing shipment clients for the current company */
  currentShipmentClients?: Maybe<Array<Scalars['String']>>;
  /** Fetches all existing shipment controllers for the current company */
  currentShipmentControllers?: Maybe<Array<Scalars['String']>>;
  /** Fetches all transport companies for the current company */
  currentTransportCompanies?: Maybe<Array<Scalars['String']>>;
  /** Fetches all truck references for the current company */
  currentTruckReferences?: Maybe<Array<Scalars['String']>>;
  /** Fetches all custom fields for the selected company */
  customFields?: Maybe<Array<CustomField>>;
  /** get filtering data for the dashboard */
  dashboardFilters?: Maybe<DashboardFilters>;
  /** Search all active carton groupings */
  dashboardSearch?: Maybe<ElasticSearchResult>;
  /** Get all active carton groupings */
  dashboardTrackingData?: Maybe<DashboardTrackingData>;
  /** Fetches the data preparation for the user */
  dataPreparation?: Maybe<DataPreparation>;
  /** Fetches the data preparations for the user */
  dataPreparations?: Maybe<Array<DataPreparation>>;
  /** Fetches specific default cost */
  defaultCost?: Maybe<DefaultCost>;
  /** Fetch default costs based on filter criteria */
  defaultCosts?: Maybe<DefaultCostConnection>;
  /** Gets a specific document */
  document: EtlDocument;
  /** Gets document rows for a specific document. Only returns rows for documents the user has access to (via DocumentOwner) and only for vendor_invoice, account_sale, or unmapped documents. */
  documentRows: EtlDocumentRowConnection;
  /** Gets documents for a company */
  documents: EtlDocumentConnection;
  /** Gets all company employees information */
  employees?: Maybe<Array<Employee>>;
  /** Fetches the Agreemet Codes from ecert */
  ephytoAgreementCodes?: Maybe<Array<EphytoAgreementCode>>;
  /** Fetches the applied chemicals from ecert */
  ephytoAppliedChemicals?: Maybe<Array<Scalars['String']>>;
  /** Fetches Ephyto by ID */
  ephytoById?: Maybe<Ephyto>;
  /** Fetches the ephyto certificate */
  ephytoCertificateUrl?: Maybe<Scalars['String']>;
  /** Fetches the country ISOs from ecert */
  ephytoCountries?: Maybe<Array<EphytoCountry>>;
  /** Fetches the Ephyto Document Types */
  ephytoDocumentTypes?: Maybe<Array<Scalars['String']>>;
  /** Fetches attributes for Ephyto Filters */
  ephytoFilterAttributes?: Maybe<EphytoFilterAttribute>;
  /** Fetches the Ephyto Locations from eCert */
  ephytoLocations?: Maybe<Array<EphytoLocation>>;
  /** Fetches the package types from eCert */
  ephytoPackageTypes?: Maybe<Array<EphytoPackage>>;
  /** Fetches the Ephyto Port of Entries from eCert */
  ephytoPortOfEntries?: Maybe<Array<EphytoPortOfEntry>>;
  /** Fetches the transport means from ecert */
  ephytoTransportMeans?: Maybe<Array<Scalars['String']>>;
  /** Fetches the treatment levels from ecert */
  ephytoTreatments?: Maybe<Array<EphytoTreatment>>;
  /** Fetches the unit of measure codes from ecert */
  ephytoUnitOfMeasureCodes?: Maybe<Array<Scalars['String']>>;
  /** Fetches all Ephytos for the user */
  ephytos?: Maybe<EphytoConnection>;
  /** Gets all estimates for a company for a given season */
  estimates?: Maybe<Array<Estimate>>;
  /** Evaluates whether updating the SLI will affect its shipment and whether a new shipment is needed. */
  evaluateShipmentImpact: ShipmentImpact;
  /** Fetches the Export Document Types */
  exportDocumentTypes?: Maybe<Array<Scalars['String']>>;
  /** Gets available FBOs that are of type exporter for the current company */
  exporterFbos?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches exporters */
  exporters?: Maybe<Array<Company>>;
  /** All Farm Varieties */
  farmVarieties: Array<FarmVariety>;
  /** Farm Variety Change requests from clients */
  farmVarietyClientChangeRequests: Array<FarmVarietyRequest>;
  /** Fetches attributes for farm variety and farm variety client change request filters */
  farmVarietyFilterAttributes?: Maybe<FarmVarietyFilterAttribute>;
  /** Returns the active orchards for the current user's company */
  fboOrchards?: Maybe<Array<FboOrchard>>;
  fetchCgCommercialTerm?: Maybe<CommercialTerm>;
  fetchReportResult?: Maybe<Scalars['Json']>;
  /** Fetches cg based financial items for report purposes */
  financeReport?: Maybe<FinanceReport>;
  /** Fetches a single finance rule */
  financeRule?: Maybe<FinanceRule>;
  /** Fetch finance rules with optional filters, search, and sorting */
  financeRules?: Maybe<FinanceRuleConnection>;
  /** Fetches attributes for finance rule filters */
  financeRulesFilterAttributes?: Maybe<FinanceRuleFilterAttribute>;
  /** Food Business Operator Change requests from clients */
  foodBusinessOperatorClientChangeRequests?: Maybe<Array<FoodBusinessOperatorRequest>>;
  /** Fetches attributes for food business operators and client change request filters */
  foodBusinessOperatorFilterAttributes?: Maybe<FoodBusinessOperatorFilterAttribute>;
  /** Returns food business operators for the current user's company */
  foodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches all business specific FBOs for the user */
  foodBusinessOperatorsByType?: Maybe<Array<FoodBusinessOperator>>;
  /** Calculate historical market volume percentages for delivered orders in the last year */
  historicalMarketVolumes?: Maybe<Array<HistoricalMarketVolume>>;
  /** Fetches the revenue line items for the specific invoice */
  incomeInvoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  /** Gets pending client change requests for internal packhouses for a given company */
  internalPackhouseClientChangeRequests?: Maybe<Array<InternalPackhouseClientChangeRequest>>;
  /** Fetches the specific invoice */
  invoice?: Maybe<Invoice>;
  /** Fetches the CGTs for the Invoice */
  invoiceCartonGroupingTransactions?: Maybe<Array<CartonGroupingTransaction>>;
  /** A default reference to be used */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Fetches all invoice payments for the current company */
  invoicePayments?: Maybe<Array<InvoicePayment>>;
  /** gets all trade countries */
  invoiceScrollTradeCountries?: Maybe<TradeCountryConnection>;
  /** Fetches all invoices for the selected company */
  invoices?: Maybe<InvoiceConnection>;
  /** Fetches attributes for invoice filters */
  invoicesFilterAttributes?: Maybe<InvoiceFilterAttribute>;
  /** Gets the latest currency conversion */
  latestCurrencyConversion?: Maybe<CurrencyConversion>;
  /** Retrieve an Order Line Item by line item ID */
  lineItem?: Maybe<LineItem>;
  /** Gets line items based on search and filter criteria */
  lineItems?: Maybe<LineItemConnection>;
  /** Fetches attributes for line item filters */
  lineItemsFilterAttributes?: Maybe<LineItemFilterAttribute>;
  /** Get all food business operators */
  listFoodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** Get all varieties */
  listVarieties?: Maybe<Array<Variety>>;
  /** Fetches the specific load out instruction */
  loadOutInstruction?: Maybe<LoadOutInstruction>;
  /** Load Out Instructions Carton Groupings with reassignable flag */
  loadOutInstructionCgs: Array<LoiCartonGrouping>;
  /** A default reference to be used */
  loadOutInstructionReference?: Maybe<Scalars['String']>;
  /** Gets load out instructions based on search and filter criteria */
  loadOutInstructions?: Maybe<LoadOutInstructionConnection>;
  /** Fetches attributes for load out instruction filters */
  loadOutInstructionsFilterAttributes?: Maybe<LoadOutInstructionFilterAttribute>;
  /** Fetch masterfile configurations with filtering and search capabilities */
  masterfileConfigs?: Maybe<Array<MasterfileConfig>>;
  /** Fetch a combination of farm varieties and client change requests */
  masterfileFarmVarieties?: Maybe<Array<MasterfileFarmVariety>>;
  /** Fetch a combination of food business operators and client change requests */
  masterfileFoodBusinessOperators?: Maybe<Array<MasterfileFoodBusinessOperator>>;
  /** get metabase report */
  metabaseReport?: Maybe<MetabaseReport>;
  /** Fetches attributes for metabase report filters */
  metabaseReportFilterAttributes?: Maybe<MetabaseReportsFilterAttribute>;
  /** get metabase reports */
  metabaseReports?: Maybe<Array<MetabaseReport>>;
  /** get the signed in users company */
  myCompany?: Maybe<Company>;
  /** get the signed in user */
  myUser?: Maybe<User>;
  /** Fetches air freight shipment line items for parent */
  nestedAirFreightShipmentLineItems?: Maybe<Array<AirFreightShipmentLineItem>>;
  /** Gets applicable additional field filters for applicable finance rules for a given date */
  netReturnAdditionalFields?: Maybe<Array<AdditionalField>>;
  /** Gets all net return programs for a given company */
  netReturnPrograms?: Maybe<Array<NetReturnProgram>>;
  /** Gets applicable standard field filters for applicable finance rules for a given date */
  netReturnStandardFields?: Maybe<Array<Scalars['String']>>;
  /** Fetches SLIs without an addendum on a shipment */
  nonAddendumShipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
  /** Fetches SLIs without an addendum on a shipment */
  nonEphytoShipmentLineItems?: Maybe<Array<NonEphytoShipmentLineItem>>;
  /** Gets all notification rules, filtered by notification slugs if provided */
  notificationRules?: Maybe<Array<NotificationRule>>;
  /** Gets an offer by its ID */
  offerById?: Maybe<Offer>;
  /** Fetches attributes for offer filters */
  offerFilterAttributes?: Maybe<OfferFilterAttribute>;
  /** Gets the linear history of an offer chain ending at the specified offer ID */
  offerHistoryById?: Maybe<Array<Offer>>;
  /** Gets offers based on search and filter criteria */
  offers?: Maybe<OfferConnection>;
  /** OnePack client codes for the current user company */
  onepackClientCodes: Array<OnepackClientCode>;
  /** Recent company-scoped outgoing OnePack pack-instruction API calls to NS Office (platform_api_calls), newest first */
  onepackPackInstructionSyncCalls: Array<OnepackPackInstructionSyncCall>;
  /** Gets all OneSwitch facilitated company associations where the parent company is the seller. */
  oneswitchBuyers?: Maybe<Array<Company>>;
  /** Gets all orchard seasons for given company and season */
  orchardSeasons?: Maybe<Array<OrchardSeason>>;
  /** Gets all orchard yields in a given range */
  orchardYields?: Maybe<Array<OrchardYield>>;
  /** Find an order by its ID */
  order?: Maybe<Order>;
  /** Gets order programs based on search and filter criteria */
  orderPrograms?: Maybe<Array<OrderProgram>>;
  /** Gets all orders */
  orders?: Maybe<Array<Order>>;
  /** Fetches attributes for order filters */
  ordersFilterAttributes?: Maybe<OrderFilterAttribute>;
  /** Gets orders based on search criteria */
  ordersSearch?: Maybe<OrderSearch>;
  /** Fetches attributes that orders can be filtered on */
  ordersSearchFilterAttributes?: Maybe<OrdersSearchFilterAttributes>;
  /** Gets orders based on search and filter criteria */
  ordersV3?: Maybe<OrderConnection>;
  /** creates pack instructions based on applied filters */
  packInstructions?: Maybe<Array<PackInstructionLineItem>>;
  /** Fetches attributes for pack instruction filters */
  packInstructionsFilterAttributes?: Maybe<PackInstructionsFilterAttribute>;
  /** Gets packhouse connections for the current company */
  packhouseConnections?: Maybe<Array<PackhouseConnection>>;
  /** Gets packhouse connections client change requests for the current company */
  packhouseConnectionsClientChangeRequests?: Maybe<Array<PackhouseConnectionClientChangeRequest>>;
  /** Fetches all packhouse software update reports */
  packhouseSoftwareUpdateReports?: Maybe<Array<SoftwareUpdateReportRequest>>;
  /** Fetches the specific payment */
  payment?: Maybe<Payment>;
  /** Fetches all payments for the company based on search and filter criteria */
  payments?: Maybe<PaymentConnection>;
  /** Fetches attributes for payment filters */
  paymentsFilterAttributes?: Maybe<PaymentFilterAttribute>;
  /** Linked records (invoices, payments) from CGT sources for given identifiers */
  pnlLinkedRecords: Array<PnlLinkedRecord>;
  populateInvoiceContainerData?: Maybe<PopulateContainer>;
  /** Populate and return a new invoice from a parent invoice */
  populateInvoiceFromParent?: Maybe<ChildInvoice>;
  /** Fetches port arrivals */
  portArrivals?: Maybe<PortArrival>;
  /** Fetches all ppecb_activity_points for the user */
  ppecbActivityPoints?: Maybe<Array<PpecbActivityPoint>>;
  /** Fetches all ppecb_container_types for the user */
  ppecbContainerTypes?: Maybe<Array<PpecbContainerType>>;
  /** Fetches all ppecb_countries for the user */
  ppecbCountries?: Maybe<Array<PpecbCountry>>;
  /** Fetches ppecb_exporter belonging to the shipment */
  ppecbExporterByShipment?: Maybe<PpecbExporter>;
  /** Fetches all ppecb_ports for the user */
  ppecbPorts?: Maybe<Array<PpecbPort>>;
  /** Fetches all ppecb_products for the user */
  ppecbProducts?: Maybe<Array<PpecbProduct>>;
  /** Fetches all ppecb_regime_codes for the user */
  ppecbRegimeCodes?: Maybe<Array<PpecbRegimeCode>>;
  /** Fetches ppecb_user belonging to the shipment */
  ppecbUserByShipment?: Maybe<PpecbUser>;
  /** Fetches ppecb_user data for a specific User */
  ppecbUserByUserId?: Maybe<PpecbUser>;
  /** Fetches all ppecb_users for the user */
  ppecbUsers?: Maybe<Array<PpecbUser>>;
  /** Fetches all ppecb_vents for the user */
  ppecbVents?: Maybe<Array<PpecbVent>>;
  /** Fetches all ppecb_voyage_numbers for the user */
  ppecbVoyageNumbers?: Maybe<Array<PpecbVoyageNumber>>;
  /** Fetches all ppecb_world_ports for the user */
  ppecbWorldPorts?: Maybe<Array<PpecbWorldPort>>;
  /** Gets all prodcution regions */
  productionRegions?: Maybe<Array<ProductionRegion>>;
  /** Filter options for P&L report dropdowns */
  profitAndLossFilterAttributes?: Maybe<ProfitAndLossFilterAttributes>;
  /** P&L report with dynamic FX conversion to reporting currency */
  profitAndLossReport?: Maybe<ProfitAndLossReport>;
  /** Poll async P&L report generation outcome by request id (correlates with queueProfitAndLossReport) */
  profitAndLossReportOutcome: ProfitAndLossReportOutcomeUnion;
  /** Quantity types for line items */
  quantityType?: Maybe<Quantity>;
  /** Gets recent root offers for the current user */
  recentRootOffers?: Maybe<Array<Offer>>;
  /** Fetches the report configuration */
  report?: Maybe<Report>;
  /** Fetches the report group for the user */
  reportGroup?: Maybe<ReportGroup>;
  /** Fetches a single report group cycle by ID */
  reportGroupCycle?: Maybe<ReportGroupCycle>;
  /** Gets report groups based on search and filter criteria */
  reportGroups?: Maybe<Array<ReportGroup>>;
  /** Runs the report for the user for a given report */
  runReport?: Maybe<Scalars['Json']>;
  /** Runs the report for the user for a given report */
  runReportAsync?: Maybe<Scalars['Json']>;
  /** Fetches a particular sea port based on its id */
  seaPort?: Maybe<SeaPort>;
  /** Fetches sea ports */
  seaPorts?: Maybe<Array<SeaPort>>;
  /** Fetches sea ports based on search and filter criteria */
  seaPortsV2?: Maybe<Array<SeaPort>>;
  /** Fetches all company users that have ppecb user credentials */
  seaShipmentControllers?: Maybe<Array<User>>;
  /** Fetches the specific shipment */
  shipment?: Maybe<Shipment>;
  /** Fetches Addendums on a shipment */
  shipmentBookingReferences?: Maybe<Array<Scalars['String']>>;
  /** Fetches the specific shipment */
  shipmentLineItemById?: Maybe<ShipmentLineItem>;
  /** Fetches attributes for Shipment Line Item Filters */
  shipmentLineItemFilterAttributes?: Maybe<ShipmentLineItemFilterAttribute>;
  /** Fetches shipment_line_item_groupings for a specific shipment */
  shipmentLineItemGroupingsByShipment?: Maybe<Array<ShipmentLineItemGrouping>>;
  /** Fetches shipment_line_items based on applied filters */
  shipmentLineItems?: Maybe<ShipmentLineItemConnection>;
  /** Fetches shipment_line_items for a specific shipment */
  shipmentLineItemsByShipment?: Maybe<Array<ShipmentLineItem>>;
  /** Fetches shipment_line_items for a specific shipment_line_item_grouping */
  shipmentLineItemsBySlig?: Maybe<Array<ShipmentLineItem>>;
  /** Fetches shipments and shipment line items */
  shipmentsAndShipmentLineItems?: Maybe<ShipmentsAndShipmentLineItems>;
  /** Fetches shipments a set of shipment line items can be moved to */
  shipmentsToChooseFrom?: Maybe<Array<Shipment>>;
  /** Fetches attributes shipped stock can be filtered on */
  shippedStockFilterAttributes?: Maybe<StockFilterAttributes>;
  /** Fetches all Shipment Line Item Break Bulks */
  sliBreakBulks?: Maybe<Array<SliBreakBulk>>;
  /** Fetches all Shipment Line Item Containers */
  sliContainers?: Maybe<Array<SliContainer>>;
  /** Fetches SLI Container based on booking ref */
  sliContainersByBookingReference?: Maybe<Array<SliContainer>>;
  /** Fetches the carton groupings for the company. */
  stockAtLocation?: Maybe<StockModuleData>;
  /** Returns the stock errors for the company. */
  stockErrors?: Maybe<Array<StockDiscrepancies>>;
  /** Fetches attributes that stock can be filtered on */
  stockFilterAttributes?: Maybe<StockFilterAttributes>;
  /** Fetches carton groupings on a particular vessel */
  stockOnVessel?: Maybe<ShippedStockModuleData>;
  /** Fetches stuff locations */
  stuffLocations?: Maybe<Array<FoodBusinessOperator>>;
  /** Gets supplier-exporter associations and pending client change requests for the current company */
  supplierExporters?: Maybe<SupplierExporters>;
  /** get the iframe url for the target market split chart for the current user */
  targetMarketSplitChartUrl?: Maybe<Scalars['String']>;
  /** Fetch all tasks for a given ShipmentLineItem */
  tasksByShipmentLineItem: Array<TaskableTask>;
  /** Fetches template output files by template_output id */
  templateOutputFiles?: Maybe<TemplateOutput>;
  /** Fetch template output files based on the data source type and data source id */
  templateOutputFilesBySource?: Maybe<Array<TemplateOutput>>;
  /** Fetches all Terminals */
  terminals?: Maybe<Array<Terminal>>;
  /** gets all trade countries */
  tradeCountries?: Maybe<Array<TradeCountry>>;
  /** Gets all company associations */
  tradePartners?: Maybe<Array<Company>>;
  /** gets all trade regions */
  tradeRegions?: Maybe<Array<TradeRegion>>;
  /** Fetches all transnet accounts for the current user */
  transnetAccounts?: Maybe<Array<TransnetAccount>>;
  /** Fetches all Transnet Terminals */
  transnetTerminals?: Maybe<Array<TransnetTerminal>>;
  /** Fetches trucking onload points */
  truckingLoadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches trucking offload points */
  truckingOffloadingPoints?: Maybe<Array<FoodBusinessOperator>>;
  /** Fetches a UI config data available to the user */
  uiConfig?: Maybe<UiConfig>;
  /** Fetches all remote UI config data available to the user */
  uiConfigs?: Maybe<Array<UiConfig>>;
  /** Fetches all unallocated air freight shipment line items */
  unallocatedAirFreightShipmentLineItems?: Maybe<AirFreightShipmentLineItemConnection>;
  /** Gets the count of unread channel notifications for the current user */
  unreadChannelNotificationsCount?: Maybe<Scalars['Int']>;
  /** All the stock files uploaded by the user */
  uploadedStockFiles?: Maybe<Array<DocumentProcessingProgress>>;
  /** get a list of all signed in user UserFeedItem paging */
  userFeedConnection: UserFeedItemConnection;
  /** get the amount of unseen user feed items */
  userFeedUnseenCount: Scalars['Int'];
  /** Get all varieties */
  varieties?: Maybe<Array<Variety>>;
  /** All configured VAT Types */
  vatTypes?: Maybe<Array<VatType>>;
  /** Fetches vessels */
  vessels?: Maybe<Array<Vessel>>;
  /** Returns voyages for a certain vessel and potentially a port of departure */
  voyages?: Maybe<Array<Scalars['String']>>;
};


/** root query */
export type QueryAccountStatementArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryAccountingExportArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryAddendumHeaderByIdArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryAddendumLineItemsByHeaderIdArgs = {
  addendumHeaderId: Scalars['Int'];
};


/** root query */
export type QueryAddendumsOnAirFreightShipmentArgs = {
  airFreightShipmentId: Scalars['Int'];
};


/** root query */
export type QueryAddendumsOnShipmentArgs = {
  shipmentId: Scalars['Int'];
};


/** root query */
export type QueryAdditionalFieldsArgs = {
  companyIds: Array<Scalars['Int']>;
};


/** root query */
export type QueryAirFreightShipmentByIdArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryAirFreightShipmentLineItemsByShipmentArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryAirFreightShipmentLoisArgs = {
  airFreightShipmentId: Scalars['ID'];
};


/** root query */
export type QueryAirFreightShipmentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: AirFreightShipmentsFilter;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryBreakBulkContainersForArrivalQcArgs = {
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCargoDuesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<CargoDuesFilterAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCartonConversionsArgs = {
  filterAttributes?: Maybe<CartonConversionFilters>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCartonGroupingAuditsArgs = {
  cartonGroupingId: Scalars['ID'];
};


/** root query */
export type QueryCartonGroupingsForLineItemArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryCartonGroupingsForWeekArgs = {
  week: Scalars['String'];
};


/** root query */
export type QueryCartonGroupingsSearchArgs = {
  attributes: CartonGroupingSearchAttributes;
};


/** root query */
export type QueryCartonTypesByCommodityArgs = {
  commodityId: Scalars['ID'];
};


/** root query */
export type QueryCertificateTransportInstructionArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryCgErrorsArgs = {
  filterAttributes?: Maybe<CgErrorFilters>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryChannelNotificationByIdArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryChannelNotificationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<ChannelNotificationFilterAttributes>;
};


/** root query */
export type QueryChannelNotificationsCountArgs = {
  severity?: Maybe<NotificationRuleSeverityEnum>;
};


/** root query */
export type QueryCheckTranslationUpdatesArgs = {
  locale: Scalars['String'];
  updatedAt: Scalars['String'];
};


/** root query */
export type QueryClaimsArgs = {
  claimLineItemGroupingId?: Maybe<Scalars['ID']>;
  containerClaimId?: Maybe<Scalars['ID']>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
  tab: ArrivalQcTabEnum;
};


/** root query */
export type QueryCommercialTermsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<CommercialTermFilterAttributes>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCommoditiesArgs = {
  onlyOperational?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryCompanyPaymentsArgs = {
  filterAttributes?: Maybe<CompanyPaymentFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryContainersArgs = {
  containernumber?: Maybe<Scalars['String']>;
  eventsafter?: Maybe<Scalars['ISO8601DateTime']>;
  excludesassignedinvlis?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  onlytrackingenabled?: Maybe<Scalars['Boolean']>;
  originportid?: Maybe<Scalars['Int']>;
};


/** root query */
export type QueryContainersForArrivalQcArgs = {
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryContainersForFinanceRuleArgs = {
  financeRuleId: Scalars['ID'];
};


/** root query */
export type QueryCostInvoiceLineItemsArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryCounterOffersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: OfferFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryCurrencyConversionArgs = {
  currencyConversionAttributes: CurrencyConversionAttributes;
};


/** root query */
export type QueryCurrencyConversionByIdArgs = {
  currencyConversionId: Scalars['ID'];
};


/** root query */
export type QueryCurrencyExchangeRateArgs = {
  exchangeableId: Scalars['ID'];
  exchangeableType: Scalars['String'];
};


/** root query */
export type QueryCurrentMapPointsForOrderArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryCustomFieldsArgs = {
  excludedCustomFieldIds?: Maybe<Array<Scalars['Int']>>;
};


/** root query */
export type QueryDashboardSearchArgs = {
  commodityGroups?: Maybe<Array<CommodityGroupEnum>>;
  fields?: Maybe<Array<DashboardSearchFieldsEnum>>;
  searchTerm?: Maybe<Scalars['String']>;
};


/** root query */
export type QueryDashboardTrackingDataArgs = {
  commoditygroups?: Maybe<Array<CommodityGroupEnum>>;
  containerId?: Maybe<Scalars['Int']>;
  forExport?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['Int']>;
};


/** root query */
export type QueryDataPreparationArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryDefaultCostArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryDefaultCostsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<DefaultCostFilters>;
};


/** root query */
export type QueryDocumentArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryDocumentRowsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  documentId: Scalars['Int'];
  states?: Maybe<Array<EtlDocumentRowStateEnum>>;
};


/** root query */
export type QueryDocumentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  dateAfter?: Maybe<Scalars['ISO8601DateTime']>;
  dateBefore?: Maybe<Scalars['ISO8601DateTime']>;
  states?: Maybe<Array<EtlDocumentStateEnum>>;
  documentTypes?: Maybe<Array<Scalars['String']>>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTo?: Maybe<Scalars['String']>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryEphytoByIdArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryEphytoCertificateUrlArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryEphytoLocationsArgs = {
  countryCodes: Array<Scalars['String']>;
};


/** root query */
export type QueryEphytoPortOfEntriesArgs = {
  countryCodes: Array<Scalars['String']>;
};


/** root query */
export type QueryEphytosArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: EphytoFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryEstimatesArgs = {
  endWeek?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['Int']>;
  startWeek?: Maybe<Scalars['String']>;
  weeks?: Maybe<Scalars['Boolean']>;
  commodityIds?: Maybe<Array<Scalars['Int']>>;
  subCommodityIds?: Maybe<Array<Scalars['Int']>>;
  varietyIds?: Maybe<Array<Scalars['Int']>>;
  onlyEditableEstimates?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryEvaluateShipmentImpactArgs = {
  loiAttributes: LoadOutAttributes;
  sliId: Scalars['ID'];
};


/** root query */
export type QueryExportersArgs = {
  companyname?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  orderbyloi?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryFboOrchardsArgs = {
  includeSellers?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryFetchCgCommercialTermArgs = {
  cgId: Scalars['ID'];
};


/** root query */
export type QueryFetchReportResultArgs = {
  requestUuid: Scalars['String'];
};


/** root query */
export type QueryFinanceReportArgs = {
  attributes: FinanceReportFilterAttributes;
};


/** root query */
export type QueryFinanceRuleArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryFinanceRulesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<FinanceRuleFilters>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: Maybe<SearchAttributes>;
  grouped?: Maybe<Scalars['Boolean']>;
  groupType?: Maybe<Scalars['String']>;
};


/** root query */
export type QueryFoodBusinessOperatorsArgs = {
  businessTypes?: Maybe<Array<Scalars['Int']>>;
  includeSellers?: Maybe<Scalars['Boolean']>;
  includeThirdPartyPackhouses?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryFoodBusinessOperatorsByTypeArgs = {
  typeOfBusiness: Scalars['Int'];
};


/** root query */
export type QueryHistoricalMarketVolumesArgs = {
  companyId: Scalars['ID'];
  commodityId: Scalars['ID'];
  regionCode: Scalars['String'];
};


/** root query */
export type QueryIncomeInvoiceLineItemsArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryInvoiceArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryInvoiceCartonGroupingTransactionsArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryInvoiceNumberArgs = {
  documenttype?: Maybe<Scalars['String']>;
};


/** root query */
export type QueryInvoiceScrollTradeCountriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
};


/** root query */
export type QueryInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: InvoicesFilters;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
  page: Scalars['String'];
};


/** root query */
export type QueryInvoicesFilterAttributesArgs = {
  page: Scalars['String'];
};


/** root query */
export type QueryLineItemArgs = {
  lineItemId: Scalars['ID'];
};


/** root query */
export type QueryLineItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: LineItemFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryLoadOutInstructionArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryLoadOutInstructionCgsArgs = {
  attributes: CartonGroupingSearchAttributes;
  hideReassignable?: Maybe<Scalars['Boolean']>;
  loadingPointId?: Maybe<Scalars['Int']>;
  portOfLoadingId?: Maybe<Scalars['Int']>;
  transportType?: Maybe<Scalars['String']>;
};


/** root query */
export type QueryLoadOutInstructionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<LoadOutInstructionsFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryMasterfileConfigsArgs = {
  filterAttributes?: Maybe<MasterfileConfigFilterAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryMasterfileFarmVarietiesArgs = {
  filterAttributes?: Maybe<FarmVarietyFilters>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: Maybe<SearchAttributes>;
};


/** root query */
export type QueryMasterfileFoodBusinessOperatorsArgs = {
  filterAttributes?: Maybe<FoodBusinessOperatorFilters>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: Maybe<SearchAttributes>;
};


/** root query */
export type QueryMetabaseReportArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryMetabaseReportsArgs = {
  filters: MetabaseReportFilters;
  searchField: Scalars['String'];
  searchTerm: Scalars['String'];
};


/** root query */
export type QueryNestedAirFreightShipmentLineItemsArgs = {
  airFreightShipmentId: Scalars['ID'];
};


/** root query */
export type QueryNetReturnAdditionalFieldsArgs = {
  packingWeek: Scalars['String'];
};


/** root query */
export type QueryNetReturnStandardFieldsArgs = {
  packingWeek: Scalars['String'];
};


/** root query */
export type QueryNonAddendumShipmentLineItemsArgs = {
  bookingRef?: Maybe<Scalars['String']>;
  shipmentId: Scalars['Int'];
};


/** root query */
export type QueryNonEphytoShipmentLineItemsArgs = {
  shipmentId: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};


/** root query */
export type QueryNotificationRulesArgs = {
  notificationSlugs?: Maybe<Array<NotificationSlugEnum>>;
};


/** root query */
export type QueryOfferByIdArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryOfferHistoryByIdArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryOffersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: OfferFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryOnepackPackInstructionSyncCallsArgs = {
  clientCode?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


/** root query */
export type QueryOrchardSeasonsArgs = {
  season: Scalars['Int'];
};


/** root query */
export type QueryOrchardYieldsArgs = {
  capturedAfter: Scalars['ISO8601DateTime'];
  capturedBefore: Scalars['ISO8601DateTime'];
  orchardSeasonId?: Maybe<Scalars['ID']>;
};


/** root query */
export type QueryOrderArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryOrderProgramsArgs = {
  orderProgramIds?: Maybe<Array<Scalars['ID']>>;
  filterAttributes: OrderProgramFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryOrdersSearchArgs = {
  filter?: Maybe<OrderFilter>;
};


/** root query */
export type QueryOrdersV3Args = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: OrderFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryPackInstructionsArgs = {
  attributes: PackInstructionsAttributes;
};


/** root query */
export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<PaymentsFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryPnlLinkedRecordsArgs = {
  cartonGroupingIds?: Maybe<Array<Scalars['Int']>>;
  containerIds?: Maybe<Array<Scalars['Int']>>;
  breakBulkContainerIds?: Maybe<Array<Scalars['Int']>>;
  reportingCurrency?: Maybe<Scalars['String']>;
  fxEnabled?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryPopulateInvoiceContainerDataArgs = {
  cgIds?: Maybe<Array<Scalars['Int']>>;
  commercialTermId?: Maybe<Scalars['Int']>;
  containerId: Scalars['Int'];
  invoiceType: Scalars['String'];
  selectedCurrency: Scalars['String'];
};


/** root query */
export type QueryPopulateInvoiceFromParentArgs = {
  documentType: Scalars['String'];
  parentInvoiceId: Scalars['Int'];
};


/** root query */
export type QueryPpecbExporterByShipmentArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryPpecbUserByShipmentArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryPpecbUserByUserIdArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryProfitAndLossReportArgs = {
  filters: ProfitAndLossFilters;
};


/** root query */
export type QueryProfitAndLossReportOutcomeArgs = {
  requestId: Scalars['String'];
};


/** root query */
export type QueryReportArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryReportGroupArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryReportGroupCycleArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryReportGroupsArgs = {
  filterAttributes: ReportGroupFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryRunReportArgs = {
  gridRequest?: Maybe<GridRequest>;
  id: Scalars['Int'];
  outputType?: Maybe<RunReportOutputTypeEnum>;
  reportFilters?: Maybe<Array<Filter>>;
};


/** root query */
export type QueryRunReportAsyncArgs = {
  id: Scalars['Int'];
  requestUuid: Scalars['String'];
  gridRequest?: Maybe<GridRequest>;
  reportFilters?: Maybe<Array<Filter>>;
};


/** root query */
export type QuerySeaPortArgs = {
  seaPortId: Scalars['ID'];
};


/** root query */
export type QuerySeaPortsArgs = {
  isportofloading?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  orderbyinv?: Maybe<Scalars['Boolean']>;
  orderbyloi?: Maybe<Scalars['Boolean']>;
  seaportname?: Maybe<Scalars['String']>;
  stufflocationid?: Maybe<Scalars['Int']>;
};


/** root query */
export type QuerySeaPortsV2Args = {
  filterAttributes: SeaPortFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryShipmentArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryShipmentBookingReferencesArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryShipmentLineItemByIdArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryShipmentLineItemGroupingsByShipmentArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryShipmentLineItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterAttributes: ShipmentLineItemFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryShipmentLineItemsByShipmentArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryShipmentLineItemsBySligArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryShipmentsAndShipmentLineItemsArgs = {
  shipmentId?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<ShipmentLineItemFilterAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryShipmentsToChooseFromArgs = {
  shipmentId?: Maybe<Scalars['Int']>;
};


/** root query */
export type QuerySliContainersByBookingReferenceArgs = {
  bookingReference: Scalars['String'];
};


/** root query */
export type QueryStockAtLocationArgs = {
  filterAttributes?: Maybe<StockFilterInputAttributes>;
  millerAttributes?: Maybe<MillerCollapsibleInLocationInput>;
  orderAttributes?: Maybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: Maybe<SearchAttributes>;
};


/** root query */
export type QueryStockOnVesselArgs = {
  filterAttributes?: Maybe<StockFilterInputAttributes>;
  orderAttributes?: Maybe<Array<ColumnOrderAttributes>>;
  searchAttributes?: Maybe<SearchAttributes>;
  vesselId?: Maybe<Scalars['Int']>;
};


/** root query */
export type QueryStuffLocationsArgs = {
  fboname?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  orderbyloi?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QuerySupplierExportersArgs = {
  filterAttributes?: Maybe<SupplierExporterFilterAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryTasksByShipmentLineItemArgs = {
  sliId: Scalars['Int'];
};


/** root query */
export type QueryTemplateOutputFilesArgs = {
  id: Scalars['Int'];
};


/** root query */
export type QueryTemplateOutputFilesBySourceArgs = {
  dataSourceId: Scalars['Int'];
  dataSourceType: Scalars['String'];
};


/** root query */
export type QueryTradeCountriesArgs = {
  tradeRegionId?: Maybe<Scalars['ID']>;
};


/** root query */
export type QueryTradePartnersArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryTruckingLoadingPointsArgs = {
  fboName?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  orderByLoi?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryTruckingOffloadingPointsArgs = {
  fboName?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  orderByLoi?: Maybe<Scalars['Boolean']>;
};


/** root query */
export type QueryUiConfigArgs = {
  id: Scalars['ID'];
};


/** root query */
export type QueryUiConfigsArgs = {
  configType?: Maybe<Scalars['String']>;
  visibility?: Maybe<UiConfigVisibilityEnum>;
};


/** root query */
export type QueryUnallocatedAirFreightShipmentLineItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes>>;
};


/** root query */
export type QueryUnreadChannelNotificationsCountArgs = {
  severity?: Maybe<NotificationRuleSeverityEnum>;
};


/** root query */
export type QueryUserFeedConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** root query */
export type QueryVarietiesArgs = {
  onlyOperational?: Maybe<Scalars['Boolean']>;
  skipMixedVarieties?: Maybe<Scalars['Boolean']>;
  commodityId?: Maybe<Scalars['ID']>;
};


/** root query */
export type QueryVesselsArgs = {
  limit?: Maybe<Scalars['Int']>;
  seaportid?: Maybe<Scalars['Int']>;
  vesselname?: Maybe<Scalars['String']>;
};


/** root query */
export type QueryVoyagesArgs = {
  seaportid?: Maybe<Scalars['Int']>;
  vesselid: Scalars['Int'];
};

/** Autogenerated return type of QueryAddendum. */
export type QueryAddendumPayload = {
  __typename?: 'QueryAddendumPayload';
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of QueueReportGroupOutputFile. */
export type QueueReportGroupOutputFilePayload = {
  __typename?: 'QueueReportGroupOutputFilePayload';
  errors: Array<Scalars['String']>;
  requestId: Scalars['String'];
  status: Scalars['String'];
};

export type QuickCostAttributes = {
  /** Carton Groupings Linked to the Cost Captured */
  cartonGroupingIds: Array<Scalars['ID']>;
  /** Cost Type associated with the quick cost capture */
  costCodeId: Scalars['ID'];
  /** Invoice Reference related to the quick cost captured */
  reference: Scalars['String'];
  /** Currency related to the quick cost captured */
  currency: Scalars['String'];
  /** Exchange Currency related to the quick cost captured */
  exchangeCurrency?: Maybe<Scalars['String']>;
  /** Exchange Rate related to the quick cost captured */
  exchangeRate?: Maybe<Scalars['Float']>;
  /** The date associated to the invoice */
  invoiceDate?: Maybe<Scalars['ISO8601Date']>;
  /** Amount related to the quick cost captured */
  amount: Scalars['Float'];
  /** Quantity Unit related to the quick cost captured */
  priceUnit: Scalars['String'];
  /** The associated VAT Type on the cost */
  vatTypeId?: Maybe<Scalars['ID']>;
  /** The IDs of the contacts associated with the invoice */
  invoicePartyId: Scalars['Int'];
};

/** Autogenerated return type of ReassignShipmentLineItemGrouping. */
export type ReassignShipmentLineItemGroupingPayload = {
  __typename?: 'ReassignShipmentLineItemGroupingPayload';
  errors?: Maybe<Scalars['String']>;
};

/** A credit or debit note created during account sale reconciliation */
export type ReconciliationDocument = {
  __typename?: 'ReconciliationDocument';
  /** The document type (credit_note or debit_note) */
  documentType: Scalars['String'];
  /** The document ID */
  id: Scalars['ID'];
  /** The document invoice number */
  invoiceNumber: Scalars['String'];
};

/** Autogenerated return type of RejectOfferAsSupplier. */
export type RejectOfferAsSupplierPayload = {
  __typename?: 'RejectOfferAsSupplierPayload';
  /** The counter offer that was rejected */
  counterOffer?: Maybe<Offer>;
  /** What went wrong when rejecting the counter offer */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of RemoveClaimLineItemGroupingDefect. */
export type RemoveClaimLineItemGroupingDefectPayload = {
  __typename?: 'RemoveClaimLineItemGroupingDefectPayload';
  /** Errors that occurred while updating the arrival QC grade of the claim line items */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveClaimLineItemGroupingExpectedClaim. */
export type RemoveClaimLineItemGroupingExpectedClaimPayload = {
  __typename?: 'RemoveClaimLineItemGroupingExpectedClaimPayload';
  /** Errors that occurred while removing the expected claim on a claim line item grouping */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveClaimLineItemPalletDefect. */
export type RemoveClaimLineItemPalletDefectPayload = {
  __typename?: 'RemoveClaimLineItemPalletDefectPayload';
  /** Errors that occurred while removing the defect from the claim line item */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveClaimLineItemPalletExpectedClaim. */
export type RemoveClaimLineItemPalletExpectedClaimPayload = {
  __typename?: 'RemoveClaimLineItemPalletExpectedClaimPayload';
  /** Errors that occurred while removing the expected claim from the claim line item */
  errors?: Maybe<Scalars['String']>;
};

/** Attributes for removing default costs */
export type RemoveDefaultCostAttributes = {
  /** The ID of the Finance Rule being used to remove the default costs */
  financeRuleId: Scalars['ID'];
  /** Container Ids to remove */
  containerIds?: Maybe<Array<Scalars['ID']>>;
  /** Pallet numbers to remove */
  palletNumbers?: Maybe<Array<Scalars['String']>>;
  /** Whether we want to remove finalised costs or unfinalised costs */
  finalisedCosts: Scalars['Boolean'];
};

/** Autogenerated return type of RemoveDefaultCosts. */
export type RemoveDefaultCostsPayload = {
  __typename?: 'RemoveDefaultCostsPayload';
  /** Removed CGT IDs associated with this finance rule */
  cgtIds?: Maybe<Array<Scalars['ID']>>;
  /** Error information when attempting to remove default costs */
  errors?: Maybe<Scalars['String']>;
};

/** A report */
export type Report = {
  __typename?: 'Report';
  /** configs associated with the report */
  configs?: Maybe<Array<Config>>;
  /** The date and time the report was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the data preparation used to generate the report */
  dataPreparationId?: Maybe<Scalars['Int']>;
  /** A longer description of the report */
  description?: Maybe<Scalars['String']>;
  /** The ID of the report */
  id?: Maybe<Scalars['ID']>;
  /** The name of the report */
  name?: Maybe<Scalars['String']>;
  /** How the report should be displayed: 'grid' or 'chart' */
  reportType?: Maybe<Scalars['String']>;
  /** The date and time the report was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ReportGroup = {
  __typename?: 'ReportGroup';
  /** The badges associated with the report */
  badges?: Maybe<Array<Badge>>;
  /** configs associated with the report group */
  configs?: Maybe<Array<Config>>;
  /** report group created at */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** report group description */
  description?: Maybe<Scalars['String']>;
  /** The domain of the report in the value chain (e.g. production, logistics etc.) */
  domain?: Maybe<ReportGroupDomainEnum>;
  /** report group unique identifier */
  id?: Maybe<Scalars['Int']>;
  /** layout represents the structure of the reports appearing on the report group. If there is only one report in your report group, you would most likely just want the layout to be [[your_report_id]] */
  layout?: Maybe<Scalars['String']>;
  /** report group name */
  name?: Maybe<Scalars['String']>;
  /** report group cycle items associated with this report group, used for automated cycling between different report groups */
  reportGroupCycleItems?: Maybe<Array<ReportGroupCycleItem>>;
  /** reports associated with the report group */
  reports?: Maybe<Array<Report>>;
  /** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
  scope?: Maybe<ReportGroupScopeEnum>;
  /** switch_units associated with the report group */
  switchUnit?: Maybe<SwitchUnit>;
  /** report group updated at */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ReportGroupAttributes = {
  /** The default filters of the new report group */
  defaultFilters?: Maybe<Scalars['String']>;
  /** The description of the new report group */
  description?: Maybe<Scalars['String']>;
  /** The id of the reportGroup */
  id?: Maybe<Scalars['Int']>;
  /** The name of the new report group */
  name?: Maybe<Scalars['String']>;
};

export type ReportGroupCycle = {
  __typename?: 'ReportGroupCycle';
  /** When the report group cycle was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The description of the report group cycle */
  description?: Maybe<Scalars['String']>;
  /** How long to display each report group(in seconds) */
  durationSeconds?: Maybe<Scalars['Int']>;
  /** The unique identifier for the report group cycle */
  id?: Maybe<Scalars['Int']>;
  /** The items in this report group cycle */
  items?: Maybe<Array<ReportGroupCycleItem>>;
  /** The name of the report group cycle */
  name?: Maybe<Scalars['String']>;
  /** When the report group cycle was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ReportGroupCycleItem = {
  __typename?: 'ReportGroupCycleItem';
  /** When the report group cycle item was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier for the report group cycle item */
  id?: Maybe<Scalars['Int']>;
  /** The order of this item in the cycle */
  order?: Maybe<Scalars['Int']>;
  /** URL parameters for this report group in JSON format */
  params?: Maybe<Scalars['String']>;
  /** The report group for this item */
  reportGroup?: Maybe<ReportGroup>;
  /** The report group cycle this item belongs to */
  reportGroupCycleId?: Maybe<Scalars['Int']>;
  /** The report group ID for this item */
  reportGroupId?: Maybe<Scalars['Int']>;
  /** When the report group cycle item was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The domain of the report in the value chain (e.g. production, logistics etc.) */
export enum ReportGroupDomainEnum {
  GlobalMarket = 'global_market',
  Production = 'production',
  MarketingAndSales = 'marketing_and_sales',
  Logistics = 'logistics',
  Claims = 'claims'
}

/** Attributes to filter report groups by */
export type ReportGroupFilterAttributes = {
  /** The badges to filter on */
  badgeIds?: Maybe<Array<Scalars['Int']>>;
  /** The domains to filter on */
  domains?: Maybe<Array<ReportGroupDomainEnum>>;
  /** The scopes to filter on */
  scopes?: Maybe<Array<ReportGroupScopeEnum>>;
};

/** The perspective of a report on a time dimension (e.g. predictive, operational etc.) */
export enum ReportGroupScopeEnum {
  Predictive = 'predictive',
  Operational = 'operational',
  Retrospective = 'retrospective'
}

export type ReportOutputFileStatus = {
  __typename?: 'ReportOutputFileStatus';
  error?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  requestId: Scalars['String'];
  status: Scalars['String'];
};

/** Autogenerated return type of ResendInvite. */
export type ResendInvitePayload = {
  __typename?: 'ResendInvitePayload';
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of ResolveCgError. */
export type ResolveCgErrorPayload = {
  __typename?: 'ResolveCgErrorPayload';
  /** The Cg Error being resolved */
  cgError: CgError;
  /** Errors that occurred during the mutation */
  errors: Array<Scalars['String']>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean'];
};

export type Result = {
  __typename?: 'Result';
  /** DateTime when phytclean result will expire */
  dataExpirationDatetime: Scalars['ISO8601DateTime'];
  /** Port of load unlocode */
  port?: Maybe<Scalars['String']>;
  /** Temperature setting for loi */
  regimeCode?: Maybe<Scalars['String']>;
  /** DateTime when loi was submitted to phytclean */
  reportDatetime: Scalars['ISO8601DateTime'];
  /** Verification key for result */
  verificationKey: Scalars['String'];
};

/** Autogenerated return type of RevertLineItemsToCreated. */
export type RevertLineItemsToCreatedPayload = {
  __typename?: 'RevertLineItemsToCreatedPayload';
  orders?: Maybe<Array<Order>>;
};

/** Autogenerated return type of RevertOrderChange. */
export type RevertOrderChangePayload = {
  __typename?: 'RevertOrderChangePayload';
  errors?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of RevokeInvite. */
export type RevokeInvitePayload = {
  __typename?: 'RevokeInvitePayload';
  id?: Maybe<Scalars['Int']>;
};

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['Int']>;
  resourceType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum RunReportOutputTypeEnum {
  /** report output will be JSON */
  Json = 'json',
  /** report output will be a string to a URL for a PDF */
  Pdf = 'pdf',
  /** report output will be a string to a URL for a xls */
  Xls = 'xls'
}

export type SeaPort = {
  __typename?: 'SeaPort';
  /** The country code where the sea port is located */
  country?: Maybe<Scalars['String']>;
  /** The date and time when the sea port record was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The display name of the sea port */
  displayName?: Maybe<Scalars['String']>;
  /** The unique identifier for the sea port */
  id?: Maybe<Scalars['Int']>;
  /** The latitude coordinate of the sea port's location */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude coordinate of the sea port's location */
  longitude?: Maybe<Scalars['Float']>;
  /** The name of the sea port */
  name?: Maybe<Scalars['String']>;
  /** The UN/LOCODE identifier for the sea port */
  unLocode?: Maybe<Scalars['String']>;
  /** The date and time when the sea port record was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes to search on sea ports */
export type SeaPortFilterAttributes = {
  /** The ids of the sea ports to filter on */
  ids?: Maybe<Array<Scalars['ID']>>;
  /** The name of the sea port eg. "Durban" */
  name?: Maybe<Scalars['String']>;
  /** The country code of the sea port eg. "ZA" */
  country?: Maybe<Scalars['String']>;
  /** The region code of the sea port eg. "ASA" */
  regionCode?: Maybe<Scalars['String']>;
};

/** Attributes to search on */
export type SearchAttributes = {
  /** term you want to search for */
  searchTerm: Scalars['String'];
  /** field you want to search on */
  searchField: Scalars['String'];
};

export type SendEmailAttributes = {
  /** Body of the email */
  body: Scalars['String'];
  /** IDs of the records within abovementioned model */
  docIds: Array<Scalars['Int']>;
  /** Comma-seperated list of types of documents to send e.g. "PDF","Excel" */
  docTypes: Array<Scalars['String']>;
  /** The templatable model from which documents should be retrieved and sent */
  model: Scalars['String'];
  /** Comma-seperated list of recipient email address */
  recipientEmailAddresses: Array<Scalars['String']>;
  /** Subject of the email */
  subject: Scalars['String'];
};

/** Autogenerated return type of SendEmail. */
export type SendEmailPayload = {
  __typename?: 'SendEmailPayload';
  /** Any errors that occured during processing */
  errors?: Maybe<Scalars['String']>;
  /** Return Message */
  message: Scalars['String'];
};

export type SentEmail = {
  __typename?: 'SentEmail';
  attachments?: Maybe<Scalars['JSON']>;
  body?: Maybe<Scalars['String']>;
  /** DateTime when the email was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Record ID */
  id: Scalars['ID'];
  /** Email address of the receiver */
  recipient?: Maybe<Scalars['String']>;
  /** Email address of the sender */
  sender?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Subject of the email */
  subject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Shipment = {
  __typename?: 'Shipment';
  /** The actual time of arrival for the shipment */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601Date']>;
  /** The actual time of departure for the shipment */
  actualTimeOfDeparture?: Maybe<Scalars['ISO8601Date']>;
  /** The party responsible for paying the bill */
  billToParty?: Maybe<Scalars['String']>;
  /** The CF code for the shipment */
  cfCode?: Maybe<Scalars['String']>;
  /** The client for the shipment */
  client?: Maybe<Scalars['String']>;
  /** Any additional comments related to the shipment */
  comments?: Maybe<Scalars['String']>;
  /** Company associated with this Shipment */
  company?: Maybe<Company>;
  /** Controller (PPECB Registered User/Company User) of the shipment */
  controller?: Maybe<Scalars['String']>;
  /** The date and time when the shipment was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date when the shipment was created */
  dateCreated?: Maybe<Scalars['ISO8601Date']>;
  /** The estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601Date']>;
  /** The estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: Maybe<Scalars['String']>;
  /** The code for the exporter */
  exporterCode?: Maybe<Scalars['String']>;
  /** The unique identifier for the shipment */
  id: Scalars['ID'];
  /** The port where the shipment is loaded */
  loadPort?: Maybe<Scalars['String']>;
  /** The phone number associated with the shipment */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The port where the shipment is loaded */
  portOfLoading?: Maybe<SeaPort>;
  /** The PPECB booking reference number */
  ppecbBookingReference?: Maybe<Scalars['Int']>;
  /** The PPECB registered code for the agent */
  ppecbRegisteredAgentCode?: Maybe<Scalars['String']>;
  /** The PPECB registered code for the exporter */
  ppecbRegisteredExporterCode?: Maybe<Scalars['String']>;
  /** The voyage number provided by PPECB */
  ppecbVoyageNumber?: Maybe<Scalars['String']>;
  /** List of line items for the shipment */
  shipmentLineItems?: Maybe<Array<ShipmentLineItem>>;
  /** Type of the shipment (e.g., OCEAN, ROAD, AIR) */
  shipmentType?: Maybe<ShipmentTypeEnum>;
  /** The party who is shipping the goods */
  shipper?: Maybe<Scalars['String']>;
  /** The shipping line for the shipment */
  shippingLine?: Maybe<Scalars['String']>;
  /** The voyage number provided by the shipping line */
  shippingLineVoyageNumber?: Maybe<Scalars['String']>;
  /** The dates when the shipments stacks open */
  stackDates?: Maybe<Scalars['ISO8601Date']>;
  /** The dates when the shipments stacks close */
  stackDatesClose?: Maybe<Scalars['ISO8601Date']>;
  /** The status of the shipments stacks close */
  stackDatesCloseStatus?: Maybe<Scalars['String']>;
  /** The status of the shipments stacks open */
  stackDatesOpenStatus?: Maybe<Scalars['String']>;
  /** The current state of the shipment */
  state?: Maybe<Scalars['String']>;
  /** The current status of the shipment */
  status?: Maybe<Scalars['String']>;
  /** Object containing information on the document generated for this shipment */
  templateOutput?: Maybe<TemplateOutput>;
  /** The terminal associated with the shipment */
  terminal?: Maybe<Terminal>;
  /** The trucks unique identifier */
  truckReference?: Maybe<Scalars['String']>;
  /** The date and time when the shipment was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The username of the person who created the shipment */
  userName?: Maybe<Scalars['String']>;
  /** The code of the vessel carrying the shipment */
  vesselCode?: Maybe<Scalars['String']>;
  /** The name of the vessel carrying the shipment */
  vesselName?: Maybe<Scalars['String']>;
  /** The original estimated date of departure for the vessel */
  vesselOriginalEstimatedDateOfDeparture?: Maybe<Scalars['ISO8601Date']>;
  /** The voyage number for the shipment */
  voyageNumber?: Maybe<Scalars['String']>;
};

export type ShipmentAttributes = {
  /** Unique ID associated with Shipment */
  id?: Maybe<Scalars['Int']>;
  /** Booking Reference provided by PPECB */
  ppecbBookingReference?: Maybe<Scalars['String']>;
  /** Shipping line transporting goods */
  shippingLine?: Maybe<Scalars['String']>;
  /** Indentifier for the voyage */
  voyageNumber?: Maybe<Scalars['String']>;
  /** Combination of Shipping line and voyage nr */
  shippingLineVoyageNumber?: Maybe<Scalars['String']>;
  /** Port where goods are loaded */
  loadPort?: Maybe<Scalars['String']>;
  /** Registered code of the party that will be billed */
  billToParty?: Maybe<Scalars['String']>;
  /** Registered Exporter Code */
  exporterCode?: Maybe<Scalars['String']>;
  /** Agent FBO Code */
  cfCode?: Maybe<Scalars['String']>;
  /** PPECB registered Exporter Code */
  ppecbRegisteredExporterCode?: Maybe<Scalars['String']>;
  /** PPECB registered Agent Code */
  ppecbRegisteredAgentCode?: Maybe<Scalars['String']>;
  /** Contact details for agent */
  phoneNumber?: Maybe<Scalars['String']>;
  /** PPECB registered user name */
  userName?: Maybe<Scalars['String']>;
  /** Date of booking creation */
  dateCreated?: Maybe<Scalars['ISO8601DateTime']>;
  /** Vessel planned departure date */
  vesselOriginalEstimatedDateOfDeparture?: Maybe<Scalars['ISO8601DateTime']>;
  /** Planned opening stack dates */
  stackDates?: Maybe<Scalars['ISO8601DateTime']>;
  /** Planned closing stack dates */
  stackDatesClose?: Maybe<Scalars['ISO8601DateTime']>;
  /** Name of the shipper */
  shipper?: Maybe<Scalars['String']>;
  /** Status of the booking */
  status?: Maybe<Scalars['String']>;
  /** Name of the vessel */
  vesselName?: Maybe<Scalars['String']>;
  /** Code to identify the vessel */
  vesselCode?: Maybe<Scalars['String']>;
  /** PPECB registered voyage number */
  ppecbVoyageNumber?: Maybe<Scalars['String']>;
  /** Controller (PPECB Registered User/Company User) of the shipment */
  controller?: Maybe<Scalars['String']>;
  /** Client of the shipment */
  client?: Maybe<Scalars['String']>;
  /** Port of loading ID (PPECB registered Port) of the shipment */
  portOfLoadingId?: Maybe<Scalars['Int']>;
  /** Comments made on the shipment */
  comments?: Maybe<Scalars['String']>;
  /** Terminal ID of the shipment */
  terminalId?: Maybe<Scalars['Int']>;
  /** Estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601Date']>;
  /** Actual time of departure for the shipment */
  actualTimeOfDeparture?: Maybe<Scalars['ISO8601Date']>;
  /** Estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601Date']>;
  /** Actual time of arrival for the shipment */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601Date']>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: Maybe<Scalars['String']>;
  /** ID of the PPECB Exporter */
  ppecbExporterId?: Maybe<Scalars['Int']>;
  /** ID of the PPECB User */
  ppecbUserId?: Maybe<Scalars['Int']>;
  /** Type of the shipment (e.g., OCEAN, ROAD, AIR) */
  shipmentType?: Maybe<Scalars['String']>;
  /** Truck reference for road shipments */
  truckReference?: Maybe<Scalars['String']>;
};

export type ShipmentDocument = {
  __typename?: 'ShipmentDocument';
  documentType?: Maybe<Scalars['String']>;
  file?: Maybe<Document>;
  id?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Represents the result of evaluating whether a shipment will be affected by updated LOI attributes. */
export type ShipmentImpact = {
  __typename?: 'ShipmentImpact';
  /** Client name for the new or affected shipment. */
  client?: Maybe<Scalars['String']>;
  /** Name of the new or affected shipment’s port of loading. */
  portOfLoading?: Maybe<Scalars['String']>;
  /** ID of the shipment that the SLI will be moved to, if applicable. */
  shipmentId?: Maybe<Scalars['ID']>;
  /** Shipping line name for the new or affected shipment. */
  shippingLine?: Maybe<Scalars['String']>;
  /** Name of the vessel for the new or affected shipment. */
  vesselName?: Maybe<Scalars['String']>;
  /** Voyage number of the new or affected shipment. */
  voyage?: Maybe<Scalars['String']>;
  /** Indicates whether the current SLI changes will affect the existing shipment. */
  willAffectShipment: Scalars['Boolean'];
  /** True if the SLI must be moved to a new shipment instead of an existing one. */
  willCreateNewShipment: Scalars['Boolean'];
};

export type ShipmentLineItem = {
  __typename?: 'ShipmentLineItem';
  /** Actual time of arrival for the shipment */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']>;
  /** Actual time of departure for the shipment */
  actualTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']>;
  /** Booking reference for the shipment */
  bookingReference?: Maybe<Scalars['String']>;
  /** Break Bulk container name */
  breakBulkContainerNamesIn?: Maybe<Scalars['String']>;
  /** The Cargo Due submitted for this SLI */
  cargoDue?: Maybe<CargoDue>;
  /** The Verified Gross Mass (VGM) of the cargo */
  cargoVgm?: Maybe<Scalars['String']>;
  /** The certificate transport instruction generated for this shipment line item */
  certificateTransportInstruction?: Maybe<CertificateTransportInstruction>;
  /** The Checklist associated with this SLI */
  checklist?: Maybe<TaskableChecklist>;
  /** The reference number provided by the client */
  clientReference?: Maybe<Scalars['String']>;
  /** The date when the shipment was collected */
  collectionDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Any additional comments or details about the shipment */
  comments?: Maybe<Scalars['String']>;
  /** The party to whom the shipment is consigned */
  consignee?: Maybe<Scalars['String']>;
  /** The name of the group the SLI belongs to */
  consignmentGroupName?: Maybe<Scalars['String']>;
  /** Unique indentifier for the goods being shipped */
  consignmentReference?: Maybe<Scalars['String']>;
  /** The combined number of the container and its corresponding seal */
  containerAndSealNumber?: Maybe<Scalars['String']>;
  /** The container number specific to the shipment line item */
  containerNumber?: Maybe<Scalars['String']>;
  /** When the shipment line item was first created in the system */
  createdAt: Scalars['ISO8601DateTime'];
  /** Customer reference number or code */
  customerReference?: Maybe<Scalars['String']>;
  /** When the shipment line item was created */
  dateCreated?: Maybe<Scalars['ISO8601DateTime']>;
  /** The depot where the shipment is stored or prepared */
  depot?: Maybe<Scalars['String']>;
  /** The number of documents belonging to the SLI */
  documentCount?: Maybe<Scalars['Int']>;
  /** The depot where the empty containers are located */
  emptyDepot?: Maybe<FoodBusinessOperator>;
  /** Estimated date and time of delivery */
  estimatedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated date and time of dispatch */
  estimatedDispatchDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']>;
  /** The documents required for export */
  exportDocuments?: Maybe<Array<ExportDocument>>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: Maybe<Scalars['String']>;
  /** Exporter as named on the certificate */
  exporterOnCertificate?: Maybe<Scalars['String']>;
  /** Final country of destination for the shipment */
  finalCountryOfDestination?: Maybe<Scalars['String']>;
  /**
   * Final port where the shipment will be discharged
   * @deprecated Use port_of_discharge instead
   */
  finalPortOfDischarge?: Maybe<Scalars['String']>;
  /** PPECB fruit origin code (maps to FruitOriginCode in export notification) */
  fruitOriginCode?: Maybe<Scalars['String']>;
  /** PPECB fruit origin name (maps to FruitOriginName in export notification) */
  fruitOriginName?: Maybe<Scalars['String']>;
  /** Fumigation treatment indicator for export notification */
  fumigation?: Maybe<Scalars['String']>;
  /** The gross weight of the shipment line item */
  grossWeight?: Maybe<Scalars['Float']>;
  /** Whether this shipment line item has an associated load out instruction */
  hasLoadOutInstruction?: Maybe<Scalars['Boolean']>;
  /** The type of haulage used for the shipment */
  haulageType?: Maybe<Scalars['String']>;
  /** Humidity conditions within the shipping environment */
  humidity?: Maybe<Scalars['String']>;
  /** Unique identifier for the shipment line item */
  id: Scalars['ID'];
  /** Import permit number for the shipment */
  importPermitNumber?: Maybe<Scalars['String']>;
  /** Boolean value indicating if the shipment requires cold treatment */
  isColdTreatment?: Maybe<Scalars['Boolean']>;
  /** Boolean value indicating if the shipment uses conventional shipping methods */
  isConventionalShipping?: Maybe<Scalars['Boolean']>;
  /** Boolean value indicating if a generator set is required */
  isGensetRequired?: Maybe<Scalars['Boolean']>;
  /** Boolean value indicating if the shipment is a transhipment */
  isTranshipment?: Maybe<Scalars['Boolean']>;
  /** Date and time the goods were loaded */
  loadDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The loading instruction number associated with the shipment */
  loadingInstructionNumber?: Maybe<Scalars['String']>;
  /** The FBO where the goods are loaded */
  loadingPoint?: Maybe<FoodBusinessOperator>;
  /** The points at which the shipment will be loaded */
  loadingPoints?: Maybe<Array<LoadingPoint>>;
  /** Derived market section mapping from linked load out instruction */
  marketSectionAssignments?: Maybe<Scalars['JSON']>;
  /** The net weight of the shipment line item */
  nettWeight?: Maybe<Scalars['Float']>;
  /** The number of containers with the same shipping line reference */
  numberOfContainers?: Maybe<Scalars['Int']>;
  /** The FBO where the goods are unloaded */
  offloadingPoint?: Maybe<FoodBusinessOperator>;
  /** Purchase order reference */
  orderReference?: Maybe<Scalars['String']>;
  /** The number of pallets belonging to the SLI */
  palletCount?: Maybe<Scalars['Int']>;
  /** The terms of payment agreed upon for the shipment */
  paymentTerms?: Maybe<Scalars['String']>;
  /** The final destination port of the shipment */
  portOfDestination?: Maybe<SeaPort>;
  /** The name of the final destination port of the shipment */
  portOfDestinationName?: Maybe<Scalars['String']>;
  /** The final discharge port of the shipment */
  portOfDischarge?: Maybe<SeaPort>;
  /** The name of the final discharge port of the shipment */
  portOfDischargeName?: Maybe<Scalars['String']>;
  /** Name of the port of loading */
  portOfLoadingName?: Maybe<Scalars['String']>;
  /** PPECB booking item reference number */
  ppecbBookingItemReference?: Maybe<Scalars['Int']>;
  /** PPECB booking reference number */
  ppecbBookingReference?: Maybe<Scalars['Int']>;
  /** The product codes associated with the shipment line item */
  productCodes?: Maybe<Scalars['String']>;
  /** The agreed number of days as per the protocol for the shipment */
  protocolDays?: Maybe<Scalars['Int']>;
  /** The agreed temperature as per the protocol for the shipment */
  protocolTemperature?: Maybe<Scalars['Float']>;
  /** Whether radiation treatment applies for export notification */
  radiation?: Maybe<Scalars['Boolean']>;
  /** The individual or company designated to receive the shipment */
  receiver?: Maybe<Scalars['String']>;
  /** Regime code for the shipment */
  regimeCode?: Maybe<Scalars['String']>;
  /** The seal number specific to the shipment line item */
  sealNumber?: Maybe<Scalars['String']>;
  /** The number of the service contract for the shipment */
  serviceContractNumber?: Maybe<Scalars['String']>;
  /** The overall shipment to which this line item belongs */
  shipment?: Maybe<Shipment>;
  /** The unique identifier of the overall shipment */
  shipmentId?: Maybe<Scalars['Int']>;
  /** ID of the Shipment Line Item Grouping it belongs to */
  shipmentLineItemGroupingId?: Maybe<Scalars['ID']>;
  /** The type of shipment (e.g., ocean, road, air) */
  shipmentType?: Maybe<ShipmentTypeEnum>;
  /** Contact number for the shipping line */
  shippingLineContactNumber?: Maybe<Scalars['String']>;
  /** Shipping line reference number or code */
  shippingLineReference?: Maybe<Scalars['String']>;
  /** The Break Bulk linked to the SLI */
  sliBreakBulk?: Maybe<SliBreakBulk>;
  /** The Container linked to the SLI */
  sliContainer?: Maybe<SliContainer>;
  /** Compliance status with the Safety of Life at Sea (SOLAS) convention */
  solas?: Maybe<Scalars['String']>;
  /** Special instructions given for the shipment */
  specialInstruction?: Maybe<Scalars['String']>;
  /** Stack dates */
  stackDates?: Maybe<Scalars['String']>;
  /** Stack dates close for this shipment line item */
  stackDatesClose?: Maybe<Scalars['String']>;
  /** The status of the shipments stacks close */
  stackDatesCloseStatus?: Maybe<Scalars['String']>;
  /** The status of the shipments stacks open */
  stackDatesOpenStatus?: Maybe<Scalars['String']>;
  /** The current state of the shipment line item */
  state?: Maybe<Scalars['String']>;
  /** The current status of the shipment line item */
  status?: Maybe<Scalars['String']>;
  /** Tare weight of the goods */
  tareWeight?: Maybe<Scalars['Float']>;
  /** The state of task completion */
  taskCompletion?: Maybe<TaskCompletion>;
  /** The tasks related to this SLI */
  tasks?: Maybe<Array<TaskableTask>>;
  /** The device used to measure and control the temperature during the shipment */
  tempDevice?: Maybe<Scalars['String']>;
  /** Temperature sensor used in the shipment */
  tempSensor?: Maybe<Scalars['String']>;
  /** Total Cartons on this SLI */
  totalCartons?: Maybe<Scalars['Int']>;
  /** Port used for transhipment */
  transhipmentPort?: Maybe<Scalars['String']>;
  /** Name of the vessel used for transhipment */
  transhipmentVesselName?: Maybe<Scalars['String']>;
  /** Voyage number for the transhipment */
  transhipmentVoyageNumber?: Maybe<Scalars['String']>;
  /** The company or individual responsible for transporting the shipment */
  transporter?: Maybe<Scalars['String']>;
  /** Treatment type code for export notification (maps to treatmentType) */
  treatmentType?: Maybe<Scalars['String']>;
  /** The trucks unique identifier */
  truckReference?: Maybe<Scalars['String']>;
  /** When the shipment line item was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Name of the user who created or last modified the shipment */
  userName?: Maybe<Scalars['String']>;
  /** The settings of the ventilation system within the shipment */
  ventSetting?: Maybe<Scalars['String']>;
  /** The name of the vessel for this shipment */
  vesselName?: Maybe<Scalars['String']>;
  /** Information about the void plugs used in the shipment */
  voidPlugs?: Maybe<Scalars['String']>;
  /** Voyage number associated with this shipment line item */
  voyageNumber?: Maybe<Scalars['String']>;
};

export type ShipmentLineItemAttributes = {
  /** Unique identifier for the data entry */
  id?: Maybe<Scalars['Int']>;
  /** Reference number for the PPECB booking */
  ppecbBookingReference?: Maybe<Scalars['Int']>;
  /** Reference number for the PPECB booking item */
  ppecbBookingItemReference?: Maybe<Scalars['Int']>;
  /** Reference string for the shipping line */
  shippingLineReference?: Maybe<Scalars['String']>;
  /** Reference string for the customer */
  customerReference?: Maybe<Scalars['String']>;
  /** Code that represents the trade regime */
  regimeCode?: Maybe<Scalars['String']>;
  /** Country where the shipment is destined */
  finalCountryOfDestination?: Maybe<Scalars['String']>;
  /** Number for the import permit */
  importPermitNumber?: Maybe<Scalars['String']>;
  /** Exporter's name on the certificate */
  exporterOnCertificate?: Maybe<Scalars['String']>;
  /** Indicates if a generator set is required */
  isGensetRequired?: Maybe<Scalars['Boolean']>;
  /** Indicates if shipment is a transhipment */
  isTranshipment?: Maybe<Scalars['Boolean']>;
  /** Indicates if cold treatment is needed for shipment */
  isColdTreatment?: Maybe<Scalars['Boolean']>;
  /** Name of the vessel used for transhipment */
  transhipmentVesselName?: Maybe<Scalars['String']>;
  /** Number of the voyage used for transhipment */
  transhipmentVoyageNumber?: Maybe<Scalars['String']>;
  /** Port used for transhipment */
  transhipmentPort?: Maybe<Scalars['String']>;
  /** Identifier for the port of discharge */
  portOfDischargeId?: Maybe<Scalars['Int']>;
  /** Type of temperature sensor used */
  tempSensor?: Maybe<Scalars['String']>;
  /** Name of the user creating the shipment record */
  userName?: Maybe<Scalars['String']>;
  /** When the shipment was created */
  dateCreated?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if the shipping is conventional */
  isConventionalShipping?: Maybe<Scalars['Boolean']>;
  /** Depot where shipment is stored */
  depot?: Maybe<Scalars['String']>;
  /** Date when the shipment was collected */
  collectionDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Loading instruction number for shipment */
  loadingInstructionNumber?: Maybe<Scalars['String']>;
  /** Type of haulage used for transportation */
  haulageType?: Maybe<Scalars['String']>;
  /** Transporter involved in shipment */
  transporter?: Maybe<Scalars['String']>;
  /** Receiver of the shipment */
  receiver?: Maybe<Scalars['String']>;
  /** Verified Gross Mass (VGM) of the cargo */
  cargoVgm?: Maybe<Scalars['String']>;
  /** Safety of Life at Sea (SOLAS) requirement for shipment */
  solas?: Maybe<Scalars['String']>;
  /** Temperature device used in shipment */
  tempDevice?: Maybe<Scalars['String']>;
  /** Estimated time of departure for the shipment */
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']>;
  /** Actual time of departure for the shipment */
  actualTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated time of arrival for the shipment */
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']>;
  /** Actual time of arrival for the shipment */
  actualTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']>;
  /** Container and seal number for the shipment */
  containerAndSealNumber?: Maybe<Scalars['String']>;
  /** Payment terms for the shipment */
  paymentTerms?: Maybe<Scalars['String']>;
  /** Contact number of the shipping line */
  shippingLineContactNumber?: Maybe<Scalars['String']>;
  /** Humidity condition for shipment */
  humidity?: Maybe<Scalars['String']>;
  /** Information about void plugs used in shipment */
  voidPlugs?: Maybe<Scalars['String']>;
  /** Ventilation setting for the shipment */
  ventSetting?: Maybe<Scalars['String']>;
  /** Protocol temperature for the shipment */
  protocolTemperature?: Maybe<Scalars['Float']>;
  /** Protocol days for the shipment */
  protocolDays?: Maybe<Scalars['Int']>;
  /** Special instructions for the shipment */
  specialInstruction?: Maybe<Scalars['String']>;
  /** Current status of the shipment */
  status?: Maybe<Scalars['String']>;
  /** Product codes included in the shipment */
  productCodes?: Maybe<Scalars['String']>;
  /** Timestamp when the shipment record was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp when the shipment record was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the shipment */
  shipmentId?: Maybe<Scalars['Int']>;
  /** Loading points for the shipment */
  loadingPoints?: Maybe<Array<LoadingPointAttributes>>;
  /** Number of the container used for shipment */
  containerNumber?: Maybe<Scalars['String']>;
  /** Number of the seal used for shipment */
  sealNumber?: Maybe<Scalars['String']>;
  /** Gross weight of the shipment */
  grossWeight?: Maybe<Scalars['Float']>;
  /** Nett weight of the shipment */
  nettWeight?: Maybe<Scalars['Float']>;
  /** Current state of the shipment */
  state?: Maybe<Scalars['String']>;
  /** Comments regarding the shipment */
  comments?: Maybe<Scalars['String']>;
  /** Party to whom the shipment will be delivered */
  consignee?: Maybe<Scalars['String']>;
  /** PPECB fruit origin code (maps to FruitOriginCode in export notification) */
  fruitOriginCode?: Maybe<Scalars['String']>;
  /** PPECB fruit origin name (maps to FruitOriginName in export notification) */
  fruitOriginName?: Maybe<Scalars['String']>;
  /** Whether radiation treatment applies for export notification */
  radiation?: Maybe<Scalars['Boolean']>;
  /** Fumigation treatment indicator for export notification */
  fumigation?: Maybe<Scalars['String']>;
  /** Treatment type code for export notification (maps to treatmentType) */
  treatmentType?: Maybe<Scalars['String']>;
  /** Service contract number for the shipment */
  serviceContractNumber?: Maybe<Scalars['String']>;
  /** Identifier for the port of destination */
  portOfDestinationId?: Maybe<Scalars['Int']>;
  /** Reference number or string from the client */
  clientReference?: Maybe<Scalars['String']>;
  /** Identifier for the depot where the container is stored when empty */
  emptyDepotId?: Maybe<Scalars['Int']>;
  /** Total Cartons on this SLI */
  totalCartons?: Maybe<Scalars['Int']>;
  /** PPECB Error for Export Notification Submissions */
  exportNotificationError?: Maybe<Scalars['String']>;
  /** Tare weight of the goods */
  tareWeight?: Maybe<Scalars['Float']>;
  /** ID of the Shipment Line Item Grouping it belongs to */
  shipmentLineItemGroupingId?: Maybe<Scalars['ID']>;
  /** Type of the shipment (e.g., ocean, road, air) */
  shipmentType?: Maybe<Scalars['String']>;
  /** con */
  consignmentReference?: Maybe<Scalars['String']>;
  /** Date and time the goods were loaded */
  loadDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Purchase order reference */
  orderReference?: Maybe<Scalars['String']>;
  /** The trucks unique identifier */
  truckReference?: Maybe<Scalars['String']>;
};

/** The connection type for ShipmentLineItem. */
export type ShipmentLineItemConnection = {
  __typename?: 'ShipmentLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShipmentLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShipmentLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ShipmentLineItemEdge = {
  __typename?: 'ShipmentLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ShipmentLineItem>;
};

export type ShipmentLineItemFilterAttribute = {
  __typename?: 'ShipmentLineItemFilterAttribute';
  /** this shipments clients */
  clients?: Maybe<Array<Scalars['String']>>;
  /** this shipments controllers */
  controllers?: Maybe<Array<Scalars['String']>>;
  /** this shipments type */
  shipmentTypes?: Maybe<Array<Scalars['String']>>;
  /** this shipments booking_references */
  shippingLineReferences?: Maybe<Array<Scalars['String']>>;
  /** the status of the stack dates */
  stackDatesStatus?: Maybe<Array<Scalars['String']>>;
  /** this shipments state */
  states?: Maybe<Array<Scalars['String']>>;
  /** this shipments vessels */
  vessels?: Maybe<Array<Scalars['String']>>;
};

export type ShipmentLineItemFilterAttributes = {
  /** this shipments clients */
  clients?: Maybe<Array<Scalars['String']>>;
  /** this shipments controllers */
  controllers?: Maybe<Array<Scalars['String']>>;
  /** this shipments booking references */
  shippingLineReferences?: Maybe<Array<Scalars['String']>>;
  /** this shipments state */
  states?: Maybe<Array<Scalars['String']>>;
  /** the status of the stack dates */
  stackDatesStatus?: Maybe<Array<Scalars['String']>>;
  /** this shipments vessels */
  vessels?: Maybe<Array<Scalars['String']>>;
  /** this shipments type */
  shipmentTypes?: Maybe<Array<Scalars['String']>>;
};

export type ShipmentLineItemGrouping = {
  __typename?: 'ShipmentLineItemGrouping';
  /** Unique identifier for the Company associated with this SLIG */
  companyId: Scalars['ID'];
  /** When the shipment line item grouping was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the shipment line item grouping */
  id: Scalars['ID'];
  /** Unique identifier for the Shipment associated with this SLIG */
  shipmentId: Scalars['ID'];
  /** The fields the SLIG is grouped on */
  sligFields?: Maybe<Scalars['JSON']>;
  /** Summation of all the SLIs cartons belonging to this SLIG */
  totalCartons?: Maybe<Scalars['Int']>;
  /** Summation of all the SLIs gross weight belonging to this SLIG */
  totalGrossWeight?: Maybe<Scalars['Float']>;
  /** Summation of all the SLIs nett weight belonging to this SLIG */
  totalNettWeight?: Maybe<Scalars['Float']>;
  /** When the shipment line item grouping was last updated in the system */
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum ShipmentTypeEnum {
  /** Ocean shipment */
  Ocean = 'OCEAN',
  /** Air shipment */
  Air = 'AIR',
  /** Road shipment */
  Road = 'ROAD'
}

export type ShipmentsAndShipmentLineItems = {
  __typename?: 'ShipmentsAndShipmentLineItems';
  /** The shipment line items returned by the resolver */
  shipmentLineItems: ShipmentLineItemConnection;
  /** The shipments returned by the resolver */
  shipments: Array<Shipment>;
};


export type ShipmentsAndShipmentLineItemsShipmentLineItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Returns the name of the vessel and CG states at that vessel. */
export type ShippedStockModuleData = {
  __typename?: 'ShippedStockModuleData';
  /** Vessels that appear in the miller column */
  allVessels?: Maybe<Array<VesselMillerFilter>>;
  /** Cartons groupings with location and vessel */
  results?: Maybe<CartonGroupingWithLocationConnection>;
};


/** Returns the name of the vessel and CG states at that vessel. */
export type ShippedStockModuleDataResultsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type SliBreakBulk = {
  __typename?: 'SliBreakBulk';
  /** Break Bulk Container joined on the SliBreakBulk record */
  breakBulkContainer?: Maybe<BreakBulkContainer>;
  /** Internal Id of the SliBreakBulk join */
  id: Scalars['ID'];
};

export type SliContainer = {
  __typename?: 'SliContainer';
  container?: Maybe<Container>;
  id: Scalars['ID'];
};

/** Autogenerated return type of SoftDeleteContainerClaim. */
export type SoftDeleteContainerClaimPayload = {
  __typename?: 'SoftDeleteContainerClaimPayload';
  /** The ID of the container claim that was soft deleted */
  containerClaimId?: Maybe<Scalars['ID']>;
  /** Error message that occurred during the mutation */
  error?: Maybe<Scalars['String']>;
};

/** A software update report request */
export type SoftwareUpdateReportRequest = {
  __typename?: 'SoftwareUpdateReportRequest';
  /** The company that requested the software update report */
  company?: Maybe<Company>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']>;
  /** The software update report */
  softwareUpdateReport?: Maybe<Array<Scalars['String']>>;
};

export enum StateFilter {
  Expired = 'expired',
  WontPack = 'wont_pack',
  Created = 'created',
  Accepted = 'accepted',
  PartiallyPacked = 'partially_packed',
  Packed = 'packed',
  AtColdStore = 'at_cold_store',
  AtRailDepot = 'at_rail_depot',
  AtOriginPort = 'at_origin_port',
  InTransit = 'in_transit',
  AtDestinationPort = 'at_destination_port',
  Delivered = 'delivered',
  PartiallyDelivered = 'partially_delivered',
  PartiallyAccepted = 'partially_accepted',
  Allocated = 'allocated',
  ToPack = 'to_pack'
}

export type Status = {
  __typename?: 'Status';
  requestUuid: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

/** Returns the Cg errors as errors. */
export type StockDiscrepancies = {
  __typename?: 'StockDiscrepancies';
  /** The number of errors of this type */
  errorCount?: Maybe<Scalars['Int']>;
  /** The error message */
  errorMessage?: Maybe<Scalars['String']>;
  /** The resolution status of this error */
  status?: Maybe<Scalars['String']>;
};

/** Attributes for filtering stock */
export type StockFilterAttributes = {
  __typename?: 'StockFilterAttributes';
  /** batch numbers to filter on */
  batchNumbers?: Maybe<Array<Scalars['String']>>;
  /** buyers to filter on */
  buyers?: Maybe<Array<Company>>;
  /** commodities to filter on */
  commodities?: Maybe<Array<Commodity>>;
  /** On the FE -> Allocation statuses but these are document statuses */
  documentStatuses?: Maybe<Array<Scalars['String']>>;
  /** exporter codes to filter on */
  exporterCodes?: Maybe<Array<Scalars['String']>>;
  /** grades to filter on */
  grades?: Maybe<Array<Scalars['String']>>;
  /** inventory codes to filter on */
  inventoryCodes?: Maybe<Array<Scalars['String']>>;
  /** marks to filter on */
  marks?: Maybe<Array<Scalars['String']>>;
  /** pack types to filter on */
  packTypes?: Maybe<Array<Scalars['String']>>;
  /** sellers to filter on */
  sellers?: Maybe<Array<Company>>;
  /** size counts to filter on */
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  /** states to filter on */
  states?: Maybe<Array<Scalars['String']>>;
  /** sub-commodities to filter on */
  subCommodities?: Maybe<Array<SubCommodity>>;
  /** target markets to filter on */
  targetMarkets?: Maybe<Array<Scalars['String']>>;
  /** varieties to filter on */
  varieties?: Maybe<Array<Variety>>;
};

/** Attributes for filtering stock */
export type StockFilterInputAttributes = {
  /** Batch numbers to filter on */
  batchNumbers?: Maybe<Array<Scalars['String']>>;
  /** Buyer IDs to filter on */
  buyerId?: Maybe<Array<Scalars['ID']>>;
  /** Commodity IDs to filter on */
  commodityId?: Maybe<Array<Scalars['ID']>>;
  /** Exporter codes to filter on */
  exporterCodes?: Maybe<Array<Scalars['String']>>;
  /** Document status to filter on */
  allocationStatuses?: Maybe<Array<Scalars['String']>>;
  /** Grades to filter on */
  grades?: Maybe<Array<Scalars['String']>>;
  /** Inspection date end */
  inspectionDateEnd?: Maybe<Scalars['ISO8601DateTime']>;
  /** Inspection date start */
  inspectionDateStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** Inventory codes to filter on */
  inventoryCodes?: Maybe<Array<Scalars['String']>>;
  /** Marks to filter on */
  marks?: Maybe<Array<Scalars['String']>>;
  /** Pack types to filter on */
  packs?: Maybe<Array<Scalars['String']>>;
  /** Sellers to filter on */
  sellerId?: Maybe<Array<Scalars['ID']>>;
  /** Size counts to filter on */
  sizeCounts?: Maybe<Array<Scalars['String']>>;
  /** States to filter on */
  states?: Maybe<Array<Scalars['String']>>;
  /** Sub-commodities to filter on */
  subCommodityId?: Maybe<Array<Scalars['ID']>>;
  /** Target markets to filter on */
  targetMarkets?: Maybe<Array<Scalars['String']>>;
  /** Variety IDs to filter on */
  varietyId?: Maybe<Array<Scalars['ID']>>;
};

/** Returns the name of the location and CG states at that location. */
export type StockModuleData = {
  __typename?: 'StockModuleData';
  /** Locations miller column. */
  allLocations?: Maybe<Array<LocationMillerFilter>>;
  /** Vessels miller column. */
  allVessels?: Maybe<Array<VesselMillerFilter>>;
  /** The Miller column second level which further aggregates the carton groupings/stock. */
  millerCollapsibleForLocation?: Maybe<Array<MillerCollapsibleInLocation>>;
  /** Cartons groupings with location */
  results?: Maybe<Array<CartonGroupingWithLocation>>;
};


/** Returns the name of the location and CG states at that location. */
export type StockModuleDataMillerCollapsibleForLocationArgs = {
  millerColumnAttributes?: Maybe<MillerCollapsibleInLocationInput>;
};

export type SubCommodity = {
  __typename?: 'SubCommodity';
  commodity?: Maybe<Commodity>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of SubmitAddendum. */
export type SubmitAddendumPayload = {
  __typename?: 'SubmitAddendumPayload';
  /** The Addendum Header */
  addendumHeader?: Maybe<AddendumHeader>;
  /**
   * Errors
   * @deprecated no longer used
   */
  errors?: Maybe<Scalars['String']>;
  /** Validation information */
  validation?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SubmitEphyto. */
export type SubmitEphytoPayload = {
  __typename?: 'SubmitEphytoPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to submit */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SubmitShipmentExportNotification. */
export type SubmitShipmentExportNotificationPayload = {
  __typename?: 'SubmitShipmentExportNotificationPayload';
  /** The errors that occured */
  errors?: Maybe<Scalars['String']>;
  /** The current shipment */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of SubscribeToNotificationRules. */
export type SubscribeToNotificationRulesPayload = {
  __typename?: 'SubscribeToNotificationRulesPayload';
  /** The errors that occurred during the mutation */
  errors?: Maybe<Scalars['String']>;
  /** The notification rule subscriptions that were updated */
  notificationRuleSubscriptions: Array<NotificationRuleSubscription>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when a new in-app (web) notification is delivered for the current user */
  newInAppNotification: InAppNotification;
  newOrder: Order;
  newUserFeedItem: UserFeedItem;
  onAcceptLineItems: Order;
  /** Triggered on state change for Account Statement file generation */
  onAccountStatementStateChange: AccountStatement;
  /** Triggered when an accounting export state changes */
  onAccountingExportStateChange: AccountingExport;
  /** Triggered on state change for Addendum generation */
  onAddendumHeaderStateChange: AddendumHeader;
  /** Triggered during the generation of an Arrival QC */
  onArrivalQcGenerationStateChange: ArrivalQcGeneration;
  /** Triggered on state change for Pallet In file generation */
  onPalletInOutputStateChange: PalletIn;
  /** Triggered on state change for Pallet Out file generation */
  onPalletOutOutputStateChange: PalletOut;
  onPremCommands: Array<Command>;
  /** Terminal async P&L report outcome (completed or error) for a request id */
  onProfitAndLossReportComplete: ProfitAndLossReportOutcomeUnion;
  /** Triggered when data for a given report is a powerbi report and API tokens are refreshed. */
  onRefreshReport: MetabaseReport;
  /** Triggered when data for a given report is ready */
  onReportComplete: Status;
  /** A subscription for report output file generation completion */
  onReportOutputFileComplete: ReportOutputFileStatus;
  onRevertLineItemsToCreated: Order;
  /** Triggered on state change for Export Notification */
  onShipmentStateChange: Shipment;
  /** Triggered on state change for template output */
  onTemplateOutputStateChange: TemplateOutput;
  /** Triggered when a WhatsApp message fails to deliver */
  onWhatsappInteractionFailedToDeliver: WhatsappInteractionStatus;
  onWontPackLineItems: Order;
};


export type SubscriptionOnProfitAndLossReportCompleteArgs = {
  requestId: Scalars['String'];
};


export type SubscriptionOnReportOutputFileCompleteArgs = {
  requestId: Scalars['String'];
};

/** A supplier-exporter company association with additional exporter-specific data */
export type SupplierExporter = {
  __typename?: 'SupplierExporter';
  /** The client change requests for the cold stores associated with this association */
  coldStoreClientChangeRequests?: Maybe<Array<ExporterColdStoreClientChangeRequest>>;
  /** The cold stores associated with this association */
  coldStores?: Maybe<Array<FoodBusinessOperator>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The exporter company in the association */
  exporter?: Maybe<Company>;
  /** Exporter codes associated with this supplier-exporter relationship */
  exporterCodes?: Maybe<Array<ExporterCode>>;
  /** The URL of the exporter company logo */
  exporterLogoImageUrl?: Maybe<Scalars['String']>;
  /** The exporter food business operators associated with the child (exporter) company */
  foodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** Unique identifier for the company association */
  id?: Maybe<Scalars['Int']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: Maybe<Scalars['Boolean']>;
  /** The masterfile configuration for this association */
  masterfileConfig?: Maybe<MasterfileConfig>;
  /** The display name of the supplier-exporter association */
  name?: Maybe<Scalars['String']>;
  /** Whether the association is facilitated by OneSwitch */
  oneswitchFacilitated?: Maybe<Scalars['Boolean']>;
  /** The type of relationship between the companies */
  relation?: Maybe<CompanyAssociationRelationTypeEnum>;
  /** The supplier company in the association */
  supplier?: Maybe<Company>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** A client change request for a supplier-exporter relationship */
export type SupplierExporterClientChangeRequest = {
  __typename?: 'SupplierExporterClientChangeRequest';
  /** The cold stores associated with this association */
  coldStores?: Maybe<Array<FoodBusinessOperator>>;
  /** The timestamp when the client change request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The exporter company if the company is known */
  exporter?: Maybe<Company>;
  /** The exporter codes for the exporter company */
  exporterCodes?: Maybe<Array<ExporterCode>>;
  /** The URL of the exporter company logo */
  exporterLogoImageUrl?: Maybe<Scalars['String']>;
  /** The name of the exporter if the company is unknown */
  exporterName?: Maybe<Scalars['String']>;
  /** The ID of the FBO */
  fboId?: Maybe<Scalars['Int']>;
  /** The food business operators associated with the client change request */
  foodBusinessOperators?: Maybe<Array<FoodBusinessOperator>>;
  /** The ID of the client change request */
  id?: Maybe<Scalars['Int']>;
  /** Whether the exporter loads on-farm/packhouse */
  isPackhouseContainerised?: Maybe<Scalars['Boolean']>;
  /** Whether the association is facilitated by OneSwitch */
  oneswitchFacilitated?: Maybe<Scalars['Boolean']>;
  /** The type of relationship between the companies */
  relation?: Maybe<Scalars['String']>;
  /** The supplier company */
  supplier?: Maybe<Company>;
  /** The timestamp when the client change request was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Filter attributes for supplier exporters company associations */
export type SupplierExporterFilterAttributes = {
  /** Filter by status (for company associations or client change requests) */
  status?: Maybe<Array<Scalars['String']>>;
  /** Filter by relation type */
  relation?: Maybe<Array<Scalars['String']>>;
  /** Filter by OneSwitch facilitation */
  oneswitchFacilitated?: Maybe<Scalars['Boolean']>;
  /** Filter by supplier company IDs */
  supplierIds?: Maybe<Array<Scalars['ID']>>;
  /** Filter by exporter company IDs */
  exporterIds?: Maybe<Array<Scalars['ID']>>;
};

/** Container for supplier-exporter associations and related client change requests */
export type SupplierExporters = {
  __typename?: 'SupplierExporters';
  /** The pending client change requests for supplier-exporter associations */
  clientChangeRequests: Array<SupplierExporterClientChangeRequest>;
  /** The existing supplier-exporter associations */
  supplierExporters: Array<SupplierExporter>;
};

/** A report */
export type SwitchUnit = {
  __typename?: 'SwitchUnit';
  /** The date and time the report was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The default value used to initialise the cards */
  defaultValue?: Maybe<Scalars['String']>;
  /** The ID of the switch_unit */
  id?: Maybe<Scalars['ID']>;
  /** The linked entity (either ReportGroup or Report) */
  linked?: Maybe<LinkedItem>;
  /** The name of the switchUnit */
  name?: Maybe<Scalars['String']>;
  /** Options associated with the switch_unit */
  switchUnitOptions?: Maybe<Array<SwitchUnitOption>>;
  /** The date and time the report was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** An option linked to a switch unit */
export type SwitchUnitOption = {
  __typename?: 'SwitchUnitOption';
  /** The date and time the option was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the switch_unit_option */
  id?: Maybe<Scalars['ID']>;
  /** The name of the switch_unit_option */
  label?: Maybe<Scalars['String']>;
  /** Optional order in which options should be rendered on the frontend */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The ID of the switch unit this option belongs to */
  switchUnitId?: Maybe<Scalars['ID']>;
  /** The date and time the option was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The value of the switch_unit_option */
  value?: Maybe<Scalars['String']>;
};

/** State of task completion */
export type TaskCompletion = {
  __typename?: 'TaskCompletion';
  /** Number of tasks completed */
  complete?: Maybe<Scalars['Int']>;
  /** Number of tasks in progress */
  inProgress?: Maybe<Scalars['Int']>;
  /** Number of tasks not started */
  notStarted?: Maybe<Scalars['Int']>;
  /** Total number of tasks */
  total?: Maybe<Scalars['Int']>;
};

export enum TaskLevelEnum {
  /** Task associated with a shipment */
  Shipment = 'SHIPMENT',
  /** Task associated with a container */
  Container = 'CONTAINER',
  /** Task associated with a specific client reference */
  ClientReference = 'CLIENT_REFERENCE',
  /** Task associated with a specific shipping line reference */
  ShippingLineReference = 'SHIPPING_LINE_REFERENCE',
  /** Task associated with a specific consignment reference */
  ConsignmentReference = 'CONSIGNMENT_REFERENCE'
}

export enum TaskStateEnum {
  Complete = 'complete',
  InProgress = 'in_progress',
  NotStarted = 'not_started'
}

export type TaskableChecklist = {
  __typename?: 'TaskableChecklist';
  /** Dynamic email subject for this checklist */
  emailSubject?: Maybe<Scalars['String']>;
  /** Unique identifier for the task */
  id: Scalars['ID'];
  /** Title of the checklist */
  title?: Maybe<Scalars['String']>;
};

export type TaskableTask = {
  __typename?: 'TaskableTask';
  /** DateTime when this document was uploaded. Null if never */
  customDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** DateTime when this task was completed. */
  dateOfCompletion?: Maybe<Scalars['ISO8601DateTime']>;
  /** The id of the Document that was uploaded against this task */
  documentId?: Maybe<Scalars['Int']>;
  /** The document that was uploaded against this task */
  file?: Maybe<Document>;
  /** Whether this task requires a document */
  hasDocument?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for the task */
  id: Scalars['ID'];
  /** Index indicating order of tasks */
  index: Scalars['Int'];
  /** List of platform-generated documents attached to this task */
  platformDocuments?: Maybe<Array<OutputFile>>;
  /** Whether this task has documents generated on platform */
  platformTask: Scalars['Boolean'];
  /** State of the task */
  state?: Maybe<TaskStateEnum>;
  /** Task Level */
  taskLevel: TaskLevelEnum;
  /** The id to which this task belongs */
  taskableId: Scalars['ID'];
  /** The class to which this task belongs */
  taskableType: Scalars['String'];
  /** Platform generated documents that are attached to this task */
  templateOutput?: Maybe<TemplateOutput>;
  /** Title of the task */
  title: Scalars['String'];
  /** DateTime when this document was uploaded. Null if never */
  uploadedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum TemplateFileFormatEnum {
  Pdf = 'pdf',
  Xls = 'xls'
}

/** Contains information on template generation output */
export type TemplateOutput = {
  __typename?: 'TemplateOutput';
  /** Provides further detail if state is errored */
  errorReason?: Maybe<Scalars['String']>;
  /** Unique identifier of this object */
  id?: Maybe<Scalars['ID']>;
  /** The documents produced from template generation */
  outputFiles?: Maybe<Array<Document>>;
  /** State of the template generation (created, processing, completed) */
  state?: Maybe<Scalars['String']>;
  /** Unique identifier of the data source associated with this template output */
  templateDataSourceId?: Maybe<Scalars['String']>;
  /** Data source type associated with this template output */
  templateDataSourceType?: Maybe<Scalars['String']>;
  /** Document variant generated for this template output */
  templateVariant?: Maybe<Scalars['String']>;
  /** Timestamp representing the date this document was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Terminal = {
  __typename?: 'Terminal';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Fields describing a trade country */
export type TradeCountry = {
  __typename?: 'TradeCountry';
  /** code of the trade country, eg. ZA */
  code?: Maybe<Scalars['String']>;
  /** unique identifier of the trade country */
  id?: Maybe<Scalars['Int']>;
  /** name of the trade country, eg. South Africa */
  name?: Maybe<Scalars['String']>;
};

/** The connection type for TradeCountry. */
export type TradeCountryConnection = {
  __typename?: 'TradeCountryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TradeCountryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TradeCountry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TradeCountryEdge = {
  __typename?: 'TradeCountryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TradeCountry>;
};

export type TradeRegion = {
  __typename?: 'TradeRegion';
  code?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<TradeCountry>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type TradeRegionAttributes = {
  id: Scalars['Int'];
  name: Scalars['String'];
  code: Scalars['String'];
};

export type TransnetAccount = {
  __typename?: 'TransnetAccount';
  /** The id of the transnet account */
  id: Scalars['ID'];
  /** Unique Transnet account number that identifies which company is creating the Cargo Due */
  number: Scalars['String'];
  /** The sea port the transnet account belongs to */
  seaPort: SeaPort;
  /** The company the transnet account belongs to */
  user: User;
};

export type TransnetTerminal = {
  __typename?: 'TransnetTerminal';
  /** Port Terminal code */
  code?: Maybe<Scalars['String']>;
  /** Port Terminal name */
  name?: Maybe<Scalars['String']>;
  /** The name of the port the terminal belongs to */
  portName?: Maybe<Scalars['String']>;
};

export enum TransportTypeEnum {
  /** The transport type trucking */
  Trucking = 'trucking',
  /** The transport type break_bulk */
  BreakBulk = 'break_bulk',
  /** The transport type container */
  Container = 'container',
  /** The transport type air */
  Air = 'air'
}

export type UiConfig = {
  __typename?: 'UiConfig';
  configType: Scalars['String'];
  data: Scalars['Json'];
  id: Scalars['Int'];
  readonly: Scalars['Boolean'];
  visibility: UiConfigVisibilityEnum;
};

export enum UiConfigVisibilityEnum {
  Private = 'Private',
  Company = 'Company',
  Public = 'Public'
}

/** Autogenerated return type of UpdateAddendum. */
export type UpdateAddendumPayload = {
  __typename?: 'UpdateAddendumPayload';
  /** Errors that occurred while updating the Addendum */
  errors?: Maybe<Scalars['String']>;
};

/** Basic attributes for updating an additional field */
export type UpdateAdditionalFieldAttributes = {
  description?: Maybe<Scalars['String']>;
  fieldtype: Scalars['String'];
  ispackinginstruction?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parameters?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateAdditionalField. */
export type UpdateAdditionalFieldPayload = {
  __typename?: 'UpdateAdditionalFieldPayload';
  additionalField?: Maybe<AdditionalField>;
};

/** Autogenerated return type of UpdateAirAddendum. */
export type UpdateAirAddendumPayload = {
  __typename?: 'UpdateAirAddendumPayload';
  /** Errors that occurred while updating the Addendum */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateAirFreightShipmentController. */
export type UpdateAirFreightShipmentControllerPayload = {
  __typename?: 'UpdateAirFreightShipmentControllerPayload';
  /** Errors that occurred while updating the Air Freight Shipment controller */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateArrivalQcCaptureDatetime. */
export type UpdateArrivalQcCaptureDatetimePayload = {
  __typename?: 'UpdateArrivalQcCaptureDatetimePayload';
  /** The updated container claim */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the note of the container claim */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateArrivalQcClaimLineItemGroupingGrade. */
export type UpdateArrivalQcClaimLineItemGroupingGradePayload = {
  __typename?: 'UpdateArrivalQcClaimLineItemGroupingGradePayload';
  /** The container claim that was updated */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the arrival QC grade of the claim line items */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateArrivalQcClaimLineItemPalletGrade. */
export type UpdateArrivalQcClaimLineItemPalletGradePayload = {
  __typename?: 'UpdateArrivalQcClaimLineItemPalletGradePayload';
  /** The container claim that was updated */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the arrival qc grade of the claim line items */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCartonConversion. */
export type UpdateCartonConversionPayload = {
  __typename?: 'UpdateCartonConversionPayload';
  cartonConversion?: Maybe<CartonConversion>;
  /** The errors resulting from the mutation */
  errors?: Maybe<Scalars['String']>;
  /** false if mutation failed */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of UpdateCartonGroupingTransactions. */
export type UpdateCartonGroupingTransactionsPayload = {
  __typename?: 'UpdateCartonGroupingTransactionsPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

/** Autogenerated return type of UpdateClaimLineItemGroupingComment. */
export type UpdateClaimLineItemGroupingCommentPayload = {
  __typename?: 'UpdateClaimLineItemGroupingCommentPayload';
  /** Errors that occurred while updating the comment of the claim line item grouping */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateClaimLineItemGroupingDefect. */
export type UpdateClaimLineItemGroupingDefectPayload = {
  __typename?: 'UpdateClaimLineItemGroupingDefectPayload';
  /** Errors that occurred while updating the defect associated with the claim line items */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateClaimLineItemGroupingExpectedClaim. */
export type UpdateClaimLineItemGroupingExpectedClaimPayload = {
  __typename?: 'UpdateClaimLineItemGroupingExpectedClaimPayload';
  /** Errors that occurred while updating the expected claim of the claim line item grouping */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateClaimLineItemPalletDefect. */
export type UpdateClaimLineItemPalletDefectPayload = {
  __typename?: 'UpdateClaimLineItemPalletDefectPayload';
  /** Errors that occurred while updating the arrival qc grade of the claim line items */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateClaimLineItemPalletExpectedClaim. */
export type UpdateClaimLineItemPalletExpectedClaimPayload = {
  __typename?: 'UpdateClaimLineItemPalletExpectedClaimPayload';
  /** Errors that occurred while updating the expected claim of the claim line items */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCommandResult. */
export type UpdateCommandResultPayload = {
  __typename?: 'UpdateCommandResultPayload';
  result?: Maybe<Scalars['String']>;
};

/** Basic attributes for a updating company */
export type UpdateCompanyAttributes = {
  id: Scalars['Int'];
  name: Scalars['String'];
  about?: Maybe<Scalars['String']>;
  registrationnumber: Scalars['String'];
  vatnumber: Scalars['String'];
  address?: Maybe<AddressAttributes>;
};

/** Autogenerated return type of UpdateCompanyDetails. */
export type UpdateCompanyDetailsPayload = {
  __typename?: 'UpdateCompanyDetailsPayload';
  company?: Maybe<Company>;
};

/** Autogenerated return type of UpdateCompanyOnboardingStep. */
export type UpdateCompanyOnboardingStepPayload = {
  __typename?: 'UpdateCompanyOnboardingStepPayload';
  company?: Maybe<Company>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UpdateCompanyTradeRegions. */
export type UpdateCompanyTradeRegionsPayload = {
  __typename?: 'UpdateCompanyTradeRegionsPayload';
  company?: Maybe<Company>;
};

/** Autogenerated return type of UpdateContact. */
export type UpdateContactPayload = {
  __typename?: 'UpdateContactPayload';
  contact?: Maybe<Contact>;
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateContainerClaimGrade. */
export type UpdateContainerClaimGradePayload = {
  __typename?: 'UpdateContainerClaimGradePayload';
  /** The container claim that was updated */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the container claim grade */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateContainerClaimNote. */
export type UpdateContainerClaimNotePayload = {
  __typename?: 'UpdateContainerClaimNotePayload';
  /** The updated container claim */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred while updating the note of the claim line item grouping */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCustomField. */
export type UpdateCustomFieldPayload = {
  __typename?: 'UpdateCustomFieldPayload';
  /** The custom field */
  customField?: Maybe<CustomField>;
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCustomTaskDate. */
export type UpdateCustomTaskDatePayload = {
  __typename?: 'UpdateCustomTaskDatePayload';
  /** Errors that occurred during the update */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Tasks for the given Shipment Line Item (after update) */
  tasks?: Maybe<Array<TaskableTask>>;
};

/** Autogenerated return type of UpdateDataOutput. */
export type UpdateDataOutputPayload = {
  __typename?: 'UpdateDataOutputPayload';
  /** The updated Data Output */
  dataOutput?: Maybe<DataOutput>;
  /** Errors that occurred during the update */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateDraftEphyto. */
export type UpdateDraftEphytoPayload = {
  __typename?: 'UpdateDraftEphytoPayload';
  /** The Ephyto */
  ephyto?: Maybe<Ephyto>;
  /** Any errors when attempting to update the draft */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEphytoDocument. */
export type UpdateEphytoDocumentPayload = {
  __typename?: 'UpdateEphytoDocumentPayload';
  /** Any errors when updating the Ephyto Document */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEphyto. */
export type UpdateEphytoPayload = {
  __typename?: 'UpdateEphytoPayload';
  /** Errors that occurred while updating the Ephyto */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEstimates. */
export type UpdateEstimatesPayload = {
  __typename?: 'UpdateEstimatesPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

/** Autogenerated return type of UpdateExportDocument. */
export type UpdateExportDocumentPayload = {
  __typename?: 'UpdateExportDocumentPayload';
  exportDocument?: Maybe<ExportDocument>;
};

/** Basic attributes for updating a FarmVariety */
export type UpdateFarmVarietyAttributes = {
  companyId: Scalars['Int'];
  hectares?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  packingend: Scalars['String'];
  packingstart: Scalars['String'];
  peakcount?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateFarmVariety. */
export type UpdateFarmVarietyPayload = {
  __typename?: 'UpdateFarmVarietyPayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of UpdateFinanceRuleEnabledState. */
export type UpdateFinanceRuleEnabledStatePayload = {
  __typename?: 'UpdateFinanceRuleEnabledStatePayload';
  /** Error information when attempting to update finance rules */
  errors?: Maybe<Scalars['String']>;
  /** Finance rules returned after update */
  financeRules?: Maybe<Array<FinanceRule>>;
};

/** Autogenerated return type of UpdateFinanceRule. */
export type UpdateFinanceRulePayload = {
  __typename?: 'UpdateFinanceRulePayload';
  /** Error information when attempting to update finance rules */
  errors?: Maybe<Scalars['String']>;
  /** Finance rules returned after update */
  financeRules?: Maybe<Array<FinanceRule>>;
};

/** Autogenerated return type of UpdateInvoice. */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  /** What went wrong when updating an invoice */
  errors?: Maybe<Scalars['String']>;
  /** The invoice that was updated */
  invoice?: Maybe<Invoice>;
  /** Credit/debit notes created during account sale reconciliation */
  reconciliationDocuments?: Maybe<Array<ReconciliationDocument>>;
};

/** Autogenerated return type of UpdateInvoiceState. */
export type UpdateInvoiceStatePayload = {
  __typename?: 'UpdateInvoiceStatePayload';
  /** Return errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Return Invoice */
  invoice?: Maybe<Invoice>;
};

export type UpdateLineItemAttributes = {
  id?: Maybe<Scalars['Int']>;
  varietyid: Scalars['Int'];
  commodityid: Scalars['Int'];
  quantity?: Maybe<Scalars['Int']>;
  plannedquantity?: Maybe<Scalars['Int']>;
  plannedquantityunit?: Maybe<Scalars['String']>;
  quantityunit?: Maybe<Scalars['String']>;
  priceminorunit?: Maybe<Scalars['Int']>;
  priceunit?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  sizecounts: Array<Scalars['String']>;
  pack: Scalars['String'];
  priceterm: Scalars['String'];
  additionalfields: Scalars['String'];
  palletstack: Scalars['Int'];
  unlimited: Scalars['Boolean'];
  targetmarket?: Maybe<Scalars['String']>;
  targetregion: Scalars['String'];
  targetcountry?: Maybe<Scalars['String']>;
  packingweek?: Maybe<Scalars['String']>;
  startweek?: Maybe<Scalars['String']>;
  endweek?: Maybe<Scalars['String']>;
  incoterm: Scalars['String'];
  grade?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  mark?: Maybe<Scalars['String']>;
  referencenumber?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  batchnumber?: Maybe<Scalars['String']>;
  inventorycode?: Maybe<Scalars['String']>;
  orderid?: Maybe<Scalars['Int']>;
  lineitemgroupingid?: Maybe<Scalars['Int']>;
  selected?: Maybe<Scalars['Boolean']>;
  stateupdate?: Maybe<Array<Scalars['String']>>;
  newsellerid?: Maybe<Scalars['Int']>;
  departureportid?: Maybe<Scalars['Int']>;
  destinationportid?: Maybe<Scalars['Int']>;
};

export type UpdateLineItemGroupingAttributes = {
  id?: Maybe<Scalars['Int']>;
  cumulativequantity?: Maybe<Scalars['Int']>;
  quantitytype?: Maybe<Scalars['String']>;
  commonfields: Array<Scalars['String']>;
  lineitems: Array<UpdateLineItemAttributes>;
  deleted?: Maybe<Scalars['Boolean']>;
  rank?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateLineItems. */
export type UpdateLineItemsPayload = {
  __typename?: 'UpdateLineItemsPayload';
  errors?: Maybe<Scalars['String']>;
  lineItems?: Maybe<Array<LineItem>>;
};

/** Autogenerated return type of UpdateLoadOutInstruction. */
export type UpdateLoadOutInstructionPayload = {
  __typename?: 'UpdateLoadOutInstructionPayload';
  errors?: Maybe<Array<LoadOutInstructionError>>;
  loadOutInstruction?: Maybe<LoadOutInstruction>;
};

/** Autogenerated return type of UpdateLoadOutInstructionsFromSlis. */
export type UpdateLoadOutInstructionsFromSlisPayload = {
  __typename?: 'UpdateLoadOutInstructionsFromSlisPayload';
  loadOutInstructions?: Maybe<Array<LoadOutInstruction>>;
};

/** Autogenerated return type of UpdateNetReturnProgram. */
export type UpdateNetReturnProgramPayload = {
  __typename?: 'UpdateNetReturnProgramPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  netReturnProgram?: Maybe<NetReturnProgram>;
};

/** Autogenerated return type of UpdateOrchardSeasons. */
export type UpdateOrchardSeasonsPayload = {
  __typename?: 'UpdateOrchardSeasonsPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

/** Autogenerated return type of UpdateOrchardYields. */
export type UpdateOrchardYieldsPayload = {
  __typename?: 'UpdateOrchardYieldsPayload';
  /** Summarized result of create changes. */
  createSummary?: Maybe<CudSummary>;
  /** Summarized result of delete changes. */
  deleteSummary?: Maybe<CudSummary>;
  /** Summarized result of update changes. */
  updateSummary?: Maybe<CudSummary>;
};

export type UpdateOrderAttributes = {
  id: Scalars['Int'];
  ispackhouserun: Scalars['Boolean'];
  commonfields?: Maybe<Array<Scalars['String']>>;
  lineitemgroupings?: Maybe<Array<UpdateLineItemGroupingAttributes>>;
};

/** Autogenerated return type of UpdateOrder. */
export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  errors?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of UpdateOrderProgram. */
export type UpdateOrderProgramPayload = {
  __typename?: 'UpdateOrderProgramPayload';
  /** What went wrong when updating an order program */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The order program that was updated */
  orderProgram?: Maybe<OrderProgram>;
};

/** Autogenerated return type of UpdatePackInstructionLineItemPriority. */
export type UpdatePackInstructionLineItemPriorityPayload = {
  __typename?: 'UpdatePackInstructionLineItemPriorityPayload';
  /** Errors that occurred while updating the priority of the pack instruction line item */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdatePayment. */
export type UpdatePaymentPayload = {
  __typename?: 'UpdatePaymentPayload';
  /** What went wrong when updating a payment */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The payment that was updated */
  payment?: Maybe<Payment>;
};

/** Autogenerated return type of UpdateReportGroup. */
export type UpdateReportGroupPayload = {
  __typename?: 'UpdateReportGroupPayload';
  /** The errors that occurred */
  errors?: Maybe<Scalars['String']>;
  /** The report group */
  reportGroup?: Maybe<ReportGroup>;
};

/** Autogenerated return type of UpdateShipmentDocument. */
export type UpdateShipmentDocumentPayload = {
  __typename?: 'UpdateShipmentDocumentPayload';
  shipmentDocument?: Maybe<ShipmentDocument>;
};

/** Autogenerated return type of UpdateShipmentLineItem. */
export type UpdateShipmentLineItemPayload = {
  __typename?: 'UpdateShipmentLineItemPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  shipmentLineItem?: Maybe<ShipmentLineItem>;
};

/** Autogenerated return type of UpdateShipment. */
export type UpdateShipmentPayload = {
  __typename?: 'UpdateShipmentPayload';
  /**
   * A list of error messages encountered during the mutation execution.
   *                              Null if the update is successful.
   */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The updated shipment object. Null if the update fails. */
  shipment?: Maybe<Shipment>;
};

/** Autogenerated return type of UpdateTasksDates. */
export type UpdateTasksDatesPayload = {
  __typename?: 'UpdateTasksDatesPayload';
  /** Error information when attempting to update task dates */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateUiConfig. */
export type UpdateUiConfigPayload = {
  __typename?: 'UpdateUiConfigPayload';
  config?: Maybe<UiConfig>;
};

/** Basic attributes for a updating UserFeedItem */
export type UpdateUserFeedItemAttributes = {
  id: Scalars['Int'];
  read?: Maybe<Scalars['Boolean']>;
  seen?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateUserFeedItem. */
export type UpdateUserFeedItemPayload = {
  __typename?: 'UpdateUserFeedItemPayload';
  userFeedItem?: Maybe<UserFeedItem>;
};

/** Autogenerated return type of UpdateUserFeedItems. */
export type UpdateUserFeedItemsPayload = {
  __typename?: 'UpdateUserFeedItemsPayload';
  userFeedItems?: Maybe<Array<UserFeedItem>>;
};

/** Autogenerated return type of UpdateUserNotifications. */
export type UpdateUserNotificationsPayload = {
  __typename?: 'UpdateUserNotificationsPayload';
  /** The errors that occurred while updating the user notifications */
  errors?: Maybe<Array<Scalars['String']>>;
  /** The updated user */
  user?: Maybe<User>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user?: Maybe<User>;
};


/** Autogenerated return type of UploadClaimFiles. */
export type UploadClaimFilesPayload = {
  __typename?: 'UploadClaimFilesPayload';
  /** The updated container claim */
  containerClaim?: Maybe<ContainerClaim>;
  /** Errors that occurred during upload */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UploadCompanyCertificate. */
export type UploadCompanyCertificatePayload = {
  __typename?: 'UploadCompanyCertificatePayload';
  certificate?: Maybe<CompanyCertificate>;
};

/** Autogenerated return type of UploadCompanyLogo. */
export type UploadCompanyLogoPayload = {
  __typename?: 'UploadCompanyLogoPayload';
  company?: Maybe<Company>;
};

/** Autogenerated return type of UploadEphytoDocument. */
export type UploadEphytoDocumentPayload = {
  __typename?: 'UploadEphytoDocumentPayload';
  /** Ephyto docs on ephyto returned to update UI */
  ephytoDocuments?: Maybe<Array<EphytoDocument>>;
  /** Error information when attempting to upload documents */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UploadEtlDocument. */
export type UploadEtlDocumentPayload = {
  __typename?: 'UploadEtlDocumentPayload';
  document?: Maybe<EtlDocument>;
};

/** Autogenerated return type of UploadExportDocument. */
export type UploadExportDocumentPayload = {
  __typename?: 'UploadExportDocumentPayload';
  errors?: Maybe<Scalars['String']>;
  shipmentLineItem?: Maybe<ShipmentLineItem>;
};

/** Autogenerated return type of UploadFarmVarietyImage. */
export type UploadFarmVarietyImagePayload = {
  __typename?: 'UploadFarmVarietyImagePayload';
  farmVariety?: Maybe<FarmVariety>;
};

/** Autogenerated return type of UploadInvoiceDocuments. */
export type UploadInvoiceDocumentsPayload = {
  __typename?: 'UploadInvoiceDocumentsPayload';
  /** Errors that occurred during upload */
  errors: Array<Scalars['String']>;
  /** The updated invoice with attached documents */
  invoice?: Maybe<Invoice>;
  /** Warnings about replaced files */
  warnings?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UploadOrderShipmentDocument. */
export type UploadOrderShipmentDocumentPayload = {
  __typename?: 'UploadOrderShipmentDocumentPayload';
  order?: Maybe<Order>;
};

/** Autogenerated return type of UploadStockFileMutation. */
export type UploadStockFileMutationPayload = {
  __typename?: 'UploadStockFileMutationPayload';
  errors?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of UploadTaskDocument. */
export type UploadTaskDocumentPayload = {
  __typename?: 'UploadTaskDocumentPayload';
  /** Error information when attempting to upload documents */
  errors?: Maybe<Scalars['String']>;
  /** Task returned to update UI */
  task?: Maybe<TaskableTask>;
};

/** Autogenerated return type of UploadTaskDocumentPerSli. */
export type UploadTaskDocumentPerSliPayload = {
  __typename?: 'UploadTaskDocumentPerSliPayload';
  /** Errors that occurred during the update */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Tasks for the given Shipment Line Item (after update) */
  tasks?: Maybe<Array<TaskableTask>>;
};

/** Autogenerated return type of UploadUserAvatar. */
export type UploadUserAvatarPayload = {
  __typename?: 'UploadUserAvatarPayload';
  user?: Maybe<User>;
};

/** Autogenerated return type of UpsertCertificateTransportInstruction. */
export type UpsertCertificateTransportInstructionPayload = {
  __typename?: 'UpsertCertificateTransportInstructionPayload';
  /** The CTI together with the state of the file generation */
  certificateTransportInstruction?: Maybe<CertificateTransportInstruction>;
  /** Errors received if upsert fails */
  errors?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpsertCommercialTerm. */
export type UpsertCommercialTermPayload = {
  __typename?: 'UpsertCommercialTermPayload';
  /** The commercial term that was upserted */
  commercialTerm?: Maybe<CommercialTerm>;
  /** Errors that occurred while upserting the commercial term */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UpsertCurrencyExchangeRate. */
export type UpsertCurrencyExchangeRatePayload = {
  __typename?: 'UpsertCurrencyExchangeRatePayload';
  /** The currency exchange rate that was set */
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  /** Errors that occurred while setting the exchange rate */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UpsertFinanceRule. */
export type UpsertFinanceRulePayload = {
  __typename?: 'UpsertFinanceRulePayload';
  /** The errors that occurred */
  errors?: Maybe<Array<FinanceRuleError>>;
  /** The finance rules that were created or updated */
  financeRules?: Maybe<Array<FinanceRule>>;
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  avatarFile?: Maybe<Document>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  email?: Maybe<Scalars['String']>;
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['Int']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isCurrentUser?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  notifyBrowserPush?: Maybe<Scalars['Boolean']>;
  notifyEmail?: Maybe<Scalars['Boolean']>;
  /** Aggregates all email recipients for sent emails by the user */
  pastEmailRecipients?: Maybe<Array<Scalars['String']>>;
  permissions?: Maybe<Permissions>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  useV2?: Maybe<Scalars['Boolean']>;
};

export type UserFeedItem = {
  __typename?: 'UserFeedItem';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  notifiable?: Maybe<NotifiableUnion>;
  read?: Maybe<Scalars['Boolean']>;
  seen?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for UserFeedItem. */
export type UserFeedItemConnection = {
  __typename?: 'UserFeedItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserFeedItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserFeedItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserFeedItemEdge = {
  __typename?: 'UserFeedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserFeedItem>;
};

export type Variety = {
  __typename?: 'Variety';
  /** The commodity record associated with the variety */
  commodity?: Maybe<Commodity>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for this variety */
  id?: Maybe<Scalars['Int']>;
  /** The full name of the variety, including sub-commodity and variety code */
  name?: Maybe<Scalars['String']>;
  /** The sub commodity record associated with the variety */
  subCommodity?: Maybe<SubCommodity>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The variety code stored on the variety */
  varietyCode?: Maybe<Scalars['String']>;
  /** The name of the variety */
  varietyName?: Maybe<Scalars['String']>;
};

export type VarietyAttributes = {
  /** The ID of the passed Variety */
  id: Scalars['ID'];
  /** Name of the variety */
  name?: Maybe<Scalars['String']>;
};

export type VatType = {
  __typename?: 'VatType';
  /** Description of the VAT Type */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the VAT Type */
  id: Scalars['ID'];
  /** The name of the VAT Type */
  name?: Maybe<Scalars['String']>;
  /** Percentage of the VAT Type */
  percentage?: Maybe<Scalars['Float']>;
};

export type VatTypeAttributes = {
  /** The ID of the passed Vat Type */
  id: Scalars['ID'];
  /** Name of the Vat Type */
  name?: Maybe<Scalars['String']>;
};

export type Vessel = {
  __typename?: 'Vessel';
  destination?: Maybe<Scalars['String']>;
  eta?: Maybe<Scalars['String']>;
  finalDestination?: Maybe<Scalars['String']>;
  finalEta?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  locationType?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['Float']>;
  origin?: Maybe<Scalars['String']>;
  vesselName?: Maybe<Scalars['String']>;
  voyageNumber?: Maybe<Scalars['String']>;
};

export type VesselAttributes = {
  id?: Maybe<Scalars['Int']>;
  vesselname?: Maybe<Scalars['String']>;
};

/** Returns the vessel information of pallets belonging to that particular vessel. */
export type VesselMillerFilter = {
  __typename?: 'VesselMillerFilter';
  /** ID of the vessel */
  id?: Maybe<Scalars['ID']>;
  /** The name of the vessel */
  name?: Maybe<Scalars['String']>;
  /**  The number of pallets on the vessel */
  totalPallets?: Maybe<Scalars['Int']>;
  /** The ETA of the vessel */
  vesselEta?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Visit = {
  __typename?: 'Visit';
  /** The arrival date of the visit */
  arrivalDate?: Maybe<Scalars['String']>;
  /** The arrival number of the visit */
  arrivalNumber?: Maybe<Scalars['String']>;
  /** The departure date of the visit */
  departureDate?: Maybe<Scalars['String']>;
  /** The IMO number of the vessel */
  imoNumber?: Maybe<Scalars['String']>;
  /** The port of the visit */
  port?: Maybe<Scalars['String']>;
  /** The vessel call sign */
  vesselCallSign?: Maybe<Scalars['String']>;
  /** The vessel name */
  vesselName?: Maybe<Scalars['String']>;
  /** The voyage number in of the visit */
  voyageNumberIn?: Maybe<Scalars['String']>;
  /** The voyage number out of the visit */
  voyageNumberOut?: Maybe<Scalars['String']>;
};

export type Voyage = {
  __typename?: 'Voyage';
  arrivalTime?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  departureTime?: Maybe<Scalars['ISO8601DateTime']>;
  estimatedTimeOfArrival?: Maybe<Scalars['ISO8601DateTime']>;
  estimatedTimeOfDeparture?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  locations?: Maybe<Array<Location>>;
  portOfDestination?: Maybe<SeaPort>;
  portOfOrigin?: Maybe<SeaPort>;
  updatedAt: Scalars['ISO8601DateTime'];
  vesselCallSign?: Maybe<Scalars['String']>;
  vesselImo?: Maybe<Scalars['String']>;
  vesselMmsi?: Maybe<Scalars['String']>;
  vesselName?: Maybe<Scalars['String']>;
  voyageNumber?: Maybe<Scalars['String']>;
};

/** Payload emitted when a WhatsApp message fails to deliver */
export type WhatsappInteractionStatus = {
  __typename?: 'WhatsappInteractionStatus';
  /** The ID of the buyer that received the WhatsApp message that failed to deliver */
  buyerId: Scalars['String'];
  /** The name of the buyer that received the WhatsApp message that failed to deliver */
  buyerName: Scalars['String'];
  /** WhatsappInteraction ID that failed to deliver */
  id: Scalars['String'];
  /** The recipient of the WhatsApp message that failed to deliver */
  offerRecipientId: Scalars['String'];
};

/** Autogenerated return type of WontPackLineItems. */
export type WontPackLineItemsPayload = {
  __typename?: 'WontPackLineItemsPayload';
  orders?: Maybe<Array<Order>>;
};

/** Deal sheet fields for an order that is a deal sheet */
export type YieldDealSheetDetail = {
  __typename?: 'YieldDealSheetDetail';
  /** When the record was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Deal number */
  dealNumber?: Maybe<Scalars['String']>;
  /** Gross sale */
  grossSale?: Maybe<Scalars['Float']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Associated order id */
  orderId: Scalars['ID'];
  /** Payment terms */
  paymentTerms?: Maybe<Scalars['String']>;
  /** Total buyer price */
  totalBuyerPrice?: Maybe<Scalars['Float']>;
  /** Total producer price */
  totalProducerPrice?: Maybe<Scalars['Float']>;
  /** The transport cost bearer */
  transportCostBearer?: Maybe<CompanyPersonaEnum>;
  /** Transport details for trucking */
  transportDetails?: Maybe<Scalars['JSON']>;
  /** The transport organiser */
  transportOrganiser?: Maybe<CompanyPersonaEnum>;
  /** When the record was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** VAT */
  vat?: Maybe<Scalars['Float']>;
};

/** Deal sheet fields for a line item that is part of a deal sheet */
export type YieldDealSheetLineItemDetail = {
  __typename?: 'YieldDealSheetLineItemDetail';
  /** Additional fees as key-value */
  additionalFees?: Maybe<Scalars['Json']>;
  /** Commission */
  commission?: Maybe<Scalars['Float']>;
  /** When the record was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Discount */
  discount?: Maybe<Scalars['Float']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Associated line item id */
  lineItemId: Scalars['ID'];
  /** Pallet price */
  palletPrice?: Maybe<Scalars['Float']>;
  /** Producer price per unit */
  producerPricePerUnit?: Maybe<Scalars['Float']>;
  /** Sale price per unit */
  salePricePerUnit?: Maybe<Scalars['Float']>;
  /** When the record was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AccountStatementTemplateOutputFieldsFragment = (
  { __typename?: 'TemplateOutput' }
  & Pick<TemplateOutput, 'state' | 'errorReason'>
  & { outputFiles?: Maybe<Array<(
    { __typename?: 'Document' }
    & Pick<Document, 'v2Url'>
  )>> }
);

export type GenerateAccountStatementOutputFilesMutationVariables = Exact<{
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  fromDate?: Maybe<Scalars['ISO8601Date']>;
}>;


export type GenerateAccountStatementOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generateAccountStatementOutputFiles?: Maybe<(
    { __typename?: 'GenerateAccountStatementOutputFilesPayload' }
    & { accountStatement?: Maybe<(
      { __typename?: 'AccountStatement' }
      & Pick<AccountStatement, 'id'>
      & { templateOutput?: Maybe<(
        { __typename?: 'TemplateOutput' }
        & AccountStatementTemplateOutputFieldsFragment
      )> }
    )> }
  )> }
);

export type OnAccountStatementStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAccountStatementStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onAccountStatementStateChange: (
    { __typename?: 'AccountStatement' }
    & Pick<AccountStatement, 'id'>
    & { templateOutput?: Maybe<(
      { __typename?: 'TemplateOutput' }
      & AccountStatementTemplateOutputFieldsFragment
    )> }
  ) }
);

export type AccountStatementQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountStatementQuery = (
  { __typename?: 'Query' }
  & { accountStatement?: Maybe<(
    { __typename?: 'AccountStatement' }
    & Pick<AccountStatement, 'id'>
    & { templateOutput?: Maybe<(
      { __typename?: 'TemplateOutput' }
      & AccountStatementTemplateOutputFieldsFragment
    )> }
  )> }
);

export type ExportErrorFieldsFragment = (
  { __typename?: 'AccountingExportError' }
  & Pick<AccountingExportError, 'invoiceId' | 'invoiceNumber' | 'errorMessage' | 'errorType'>
);

export type GenerateAccountingExportMutationVariables = Exact<{
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GenerateAccountingExportMutation = (
  { __typename?: 'Mutation' }
  & { generateAccountingExport?: Maybe<(
    { __typename?: 'GenerateAccountingExportPayload' }
    & { accountingExport?: Maybe<(
      { __typename?: 'AccountingExport' }
      & Pick<AccountingExport, 'id'>
    )> }
  )> }
);

export type AccountingExportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountingExportQuery = (
  { __typename?: 'Query' }
  & { accountingExport?: Maybe<(
    { __typename?: 'AccountingExport' }
    & Pick<AccountingExport, 'id' | 'exportStatus' | 'exportedAt'>
    & { exportFile: (
      { __typename?: 'Document' }
      & Pick<Document, 'v2Url'>
    ), exportErrors?: Maybe<Array<(
      { __typename?: 'AccountingExportError' }
      & ExportErrorFieldsFragment
    )>> }
  )> }
);

export type OnAccountingExportStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAccountingExportStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onAccountingExportStateChange: (
    { __typename?: 'AccountingExport' }
    & Pick<AccountingExport, 'id' | 'exportStatus' | 'exportedAt'>
    & { exportFile: (
      { __typename?: 'Document' }
      & Pick<Document, 'v2Url'>
    ), exportErrors?: Maybe<Array<(
      { __typename?: 'AccountingExportError' }
      & ExportErrorFieldsFragment
    )>> }
  ) }
);

export type CreateAdditionalFieldMutationVariables = Exact<{
  attributes: CreateAdditionalFieldAttributes;
}>;


export type CreateAdditionalFieldMutation = (
  { __typename?: 'Mutation' }
  & { createAdditionalField?: Maybe<(
    { __typename?: 'CreateAdditionalFieldPayload' }
    & { additionalField?: Maybe<(
      { __typename?: 'AdditionalField' }
      & Pick<AdditionalField, 'id' | 'companyId' | 'name' | 'description' | 'fieldType' | 'parameters' | 'isPackingInstruction' | 'private'>
    )> }
  )> }
);

export type DeleteAdditionalFieldMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAdditionalFieldMutation = (
  { __typename?: 'Mutation' }
  & { deleteAdditionalField?: Maybe<(
    { __typename?: 'DeleteAdditionalFieldPayload' }
    & Pick<DeleteAdditionalFieldPayload, 'id'>
  )> }
);

export type UpdateAdditionalFieldMutationVariables = Exact<{
  id: Scalars['Int'];
  attributes: UpdateAdditionalFieldAttributes;
}>;


export type UpdateAdditionalFieldMutation = (
  { __typename?: 'Mutation' }
  & { updateAdditionalField?: Maybe<(
    { __typename?: 'UpdateAdditionalFieldPayload' }
    & { additionalField?: Maybe<(
      { __typename?: 'AdditionalField' }
      & Pick<AdditionalField, 'id' | 'name' | 'description' | 'fieldType' | 'parameters' | 'isPackingInstruction' | 'private'>
    )> }
  )> }
);

export type AdditionalFieldsQueryVariables = Exact<{
  companyids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type AdditionalFieldsQuery = (
  { __typename?: 'Query' }
  & { additionalFields?: Maybe<Array<(
    { __typename?: 'AdditionalField' }
    & Pick<AdditionalField, 'id' | 'name' | 'description' | 'fieldType' | 'parameters' | 'isPackingInstruction' | 'private'>
  )>> }
);

export type NetReturnFieldsQueryVariables = Exact<{
  packingWeek: Scalars['String'];
}>;


export type NetReturnFieldsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'netReturnStandardFields'>
  & { netReturnAdditionalFields?: Maybe<Array<(
    { __typename?: 'AdditionalField' }
    & Pick<AdditionalField, 'companyId' | 'createdAt' | 'description' | 'fieldType' | 'id' | 'isPackingInstruction' | 'name' | 'parameters' | 'updatedAt'>
  )>> }
);

export type GenerateAg1TableOutputFileMutationVariables = Exact<{
  data: Scalars['Json'];
  fields: Array<Ag1TableFieldAttribute> | Ag1TableFieldAttribute;
  fileformat: TemplateFileFormatEnum;
  tablename: Scalars['String'];
  filtervalues?: Maybe<Scalars['String']>;
}>;


export type GenerateAg1TableOutputFileMutation = (
  { __typename?: 'Mutation' }
  & { generateAg1TableOutputFile?: Maybe<(
    { __typename?: 'GenerateAg1TableOutputFilePayload' }
    & Pick<GenerateAg1TableOutputFilePayload, 'fileUrl'>
  )> }
);

export type AirAddendumHeaderByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AirAddendumHeaderByIdQuery = (
  { __typename?: 'Query' }
  & { addendumHeaderById?: Maybe<(
    { __typename?: 'AddendumHeader' }
    & { addendumLineItems?: Maybe<Array<(
      { __typename?: 'AddendumLineItem' }
      & AirAddendumLineItemFieldsFragment
    )>> }
    & AirAddendumHeaderFieldsFragment
  )> }
);

export type AddendumsOnAirFreightShipmentQueryVariables = Exact<{
  airFreightShipmentId: Scalars['Int'];
}>;


export type AddendumsOnAirFreightShipmentQuery = (
  { __typename?: 'Query' }
  & { addendumsOnAirFreightShipment?: Maybe<Array<(
    { __typename?: 'AddendumHeader' }
    & Pick<AddendumHeader, 'id'>
    & { loadOutInstructions?: Maybe<Array<(
      { __typename?: 'LoadOutInstruction' }
      & Pick<LoadOutInstruction, 'id' | 'loadOutReference'>
      & { airFreightShipmentLineItem?: Maybe<(
        { __typename?: 'AirFreightShipmentLineItem' }
        & Pick<AirFreightShipmentLineItem, 'externalShipmentId'>
        & { airFreightShipment?: Maybe<(
          { __typename?: 'AirFreightShipment' }
          & Pick<AirFreightShipment, 'masterWaybillNumber'>
        )> }
      )> }
    )>> }
  )>> }
);

export type AirFreightShipmentLoisQueryVariables = Exact<{
  airFreightShipmentId: Scalars['ID'];
}>;


export type AirFreightShipmentLoisQuery = (
  { __typename?: 'Query' }
  & { airFreightShipmentLois?: Maybe<Array<(
    { __typename?: 'LoadOutInstruction' }
    & Pick<LoadOutInstruction, 'id' | 'loadOutReference' | 'airWaybillNo'>
  )>> }
);

export type GenerateAirAddendumMutationVariables = Exact<{
  loiIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GenerateAirAddendumMutation = (
  { __typename?: 'Mutation' }
  & { generateAirAddendum?: Maybe<(
    { __typename?: 'GenerateAirAddendumPayload' }
    & Pick<GenerateAirAddendumPayload, 'errors'>
    & { addendumHeader?: Maybe<(
      { __typename?: 'AddendumHeader' }
      & { addendumLineItems?: Maybe<Array<(
        { __typename?: 'AddendumLineItem' }
        & AirAddendumLineItemFieldsFragment
      )>> }
      & AirAddendumHeaderFieldsFragment
    )> }
  )> }
);

export type UpdateAirAddendumMutationVariables = Exact<{
  addendumLineItems: Array<AddendumLineItemAttributes> | AddendumLineItemAttributes;
  addendumHeader: AddendumHeaderAttributes;
}>;


export type UpdateAirAddendumMutation = (
  { __typename?: 'Mutation' }
  & { updateAirAddendum?: Maybe<(
    { __typename?: 'UpdateAirAddendumPayload' }
    & Pick<UpdateAirAddendumPayload, 'errors'>
  )> }
);

export type CancelAirAddendumMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CancelAirAddendumMutation = (
  { __typename?: 'Mutation' }
  & { cancelAirAddendum?: Maybe<(
    { __typename?: 'CancelAirAddendumPayload' }
    & Pick<CancelAirAddendumPayload, 'id' | 'message'>
  )> }
);

export type GenerateAddendumHeaderOutputFilesMutationVariables = Exact<{
  addendumHeaderId: Scalars['ID'];
}>;


export type GenerateAddendumHeaderOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generateAddendumHeaderOutputFiles?: Maybe<(
    { __typename?: 'GenerateAddendumHeaderOutputFilesPayload' }
    & { templateOutput?: Maybe<Array<(
      { __typename?: 'TemplateOutput' }
      & Pick<TemplateOutput, 'errorReason' | 'id' | 'state'>
    )>> }
  )> }
);

export type GeneratePalletOutOutputFilesMutationVariables = Exact<{
  addendumHeaderId: Scalars['ID'];
}>;


export type GeneratePalletOutOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generatePalletOutOutputFiles?: Maybe<(
    { __typename?: 'GeneratePalletOutOutputFilesPayload' }
    & Pick<GeneratePalletOutOutputFilesPayload, 'palletOutId'>
  )> }
);

export type OnPalletOutOutputStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPalletOutOutputStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onPalletOutOutputStateChange: (
    { __typename?: 'PalletOut' }
    & PalletOutFieldsFragment
  ) }
);

export type PalletOutFieldsFragment = (
  { __typename?: 'PalletOut' }
  & Pick<PalletOut, 'id' | 'addendumHeaderId' | 'state' | 'updatedAt'>
  & { outputFile?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'contentType' | 'filename' | 'v2Url' | 'id' | 'url'>
  )> }
);

export type AirAddendumHeaderFieldsFragment = (
  { __typename?: 'AddendumHeader' }
  & Pick<AddendumHeader, 'id' | 'requestId' | 'exporterCode' | 'cfCode' | 'lspCode' | 'transportType' | 'vesselName' | 'vesselType' | 'voyageNumber' | 'exportCertificateNumber' | 'exportFromCapeTown' | 'exportFromDurban' | 'exportFromMaputo' | 'exportFromOther' | 'exportFromPortElizabeth' | 'exporterAgentDate' | 'exporterAgentName' | 'forwardingAgentDate' | 'forwardingAgentName' | 'disAgentDate' | 'disAgentName' | 'inlandInspectorDate' | 'inlandInspectorName' | 'portInspectorDate' | 'portInspectorName' | 'shippingBookingReference' | 'loadPort' | 'dischargePort' | 'shippedTargetCountry' | 'shippedTargetRegion' | 'locationOfIssue' | 'estimatedDepartureDate' | 'regimeCode' | 'eCertAgreementCode' | 'verificationStatus' | 'addendumStatus' | 'ecertStatus' | 'transactionId' | 'errorReason' | 'state' | 'printedName' | 'ppecbCertificateNumber'>
  & { templateOutput?: Maybe<Array<(
    { __typename?: 'TemplateOutput' }
    & TemplateOutputFieldsFragment
  )>>, palletOut?: Maybe<(
    { __typename?: 'PalletOut' }
    & PalletOutFieldsFragment
  )> }
);

export type AirAddendumLineItemFieldsFragment = (
  { __typename?: 'AddendumLineItem' }
  & Pick<AddendumLineItem, 'id' | 'stuffLoadDate' | 'loadPointFboCode' | 'consignmentNumber' | 'phc' | 'inspectedSscc' | 'clientRef' | 'upn' | 'inspectedTargetRegion' | 'inspectedTargetCountry' | 'commodityCode' | 'varietyCode' | 'productClass' | 'nettWeight' | 'grossWeight' | 'ssccNettWeight' | 'ssccGrossWeight' | 'cartonQuantity' | 'inspectionPoint' | 'inspectorCode' | 'inspectionDate' | 'containerNumber' | 'sequenceNumberOfInspectedSscc' | 'puc' | 'orchard' | 'productionArea' | 'phytoData' | 'sizeCountBerrySize' | 'packCode' | 'palletQuantity' | 'fleshColor' | 'inspectionManifestNumber'>
);

export type AirFreightShipmentsQueryVariables = Exact<{
  filterAttributes: AirFreightShipmentsFilter;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type AirFreightShipmentsQuery = (
  { __typename?: 'Query' }
  & { airFreightShipments?: Maybe<(
    { __typename?: 'AirFreightShipmentConnection' }
    & Pick<AirFreightShipmentConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'AirFreightShipment' }
      & AirFreightShipmentFieldsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type AirFreightShipmentsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type AirFreightShipmentsFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { airFreightShipmentsFilterAttributes?: Maybe<(
    { __typename?: 'AirFreightShipmentsFilterAttribute' }
    & Pick<AirFreightShipmentsFilterAttribute, 'carrierNames' | 'controllers' | 'flightNumbers' | 'states' | 'shippers' | 'masterWaybillNumbers'>
  )> }
);

export type AirFreightShipmentLineItemsByShipmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AirFreightShipmentLineItemsByShipmentQuery = (
  { __typename?: 'Query' }
  & { airFreightShipmentLineItemsByShipment?: Maybe<Array<(
    { __typename?: 'AirFreightShipmentLineItem' }
    & { airFreightShipment?: Maybe<(
      { __typename?: 'AirFreightShipment' }
      & Pick<AirFreightShipment, 'id'>
    )> }
    & AirFreightShipmentLineItemFieldsFragment
  )>> }
);

export type AirFreightShipmentByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AirFreightShipmentByIdQuery = (
  { __typename?: 'Query' }
  & { airFreightShipmentById?: Maybe<(
    { __typename?: 'AirFreightShipment' }
    & { airFreightShipmentLineItems?: Maybe<Array<(
      { __typename?: 'AirFreightShipmentLineItem' }
      & AirFreightShipmentLineItemFieldsFragment
    )>> }
    & AirFreightShipmentFieldsFragment
  )> }
);

export type NestedAirFreightShipmentLineItemsQueryVariables = Exact<{
  airFreightShipmentId: Scalars['ID'];
}>;


export type NestedAirFreightShipmentLineItemsQuery = (
  { __typename?: 'Query' }
  & { nestedAirFreightShipmentLineItems?: Maybe<Array<(
    { __typename?: 'AirFreightShipmentLineItem' }
    & Pick<AirFreightShipmentLineItem, 'bookingReference' | 'collectionDate' | 'comments' | 'commodityCode' | 'consignee' | 'consignor' | 'eta' | 'externalShipmentId' | 'finalDestinationCode' | 'finalDestinationLocation' | 'finalPortOfDischargeCode' | 'finalPortOfDischargeLocation' | 'goodsDescription' | 'grossDimensions' | 'grossWeight' | 'housebill' | 'id' | 'isTransshipment' | 'natureOfGoods' | 'packageQuantity' | 'packageType' | 'orderReference' | 'specialHandling' | 'transshipmentPort' | 'transshipmentCarrierName' | 'transshipmentFlightNumber' | 'volume' | 'lastStatusMessage' | 'state'>
  )>> }
);

export type UnallocatedAirFreightShipmentLineItemsQueryVariables = Exact<{
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type UnallocatedAirFreightShipmentLineItemsQuery = (
  { __typename?: 'Query' }
  & { unallocatedAirFreightShipmentLineItems?: Maybe<(
    { __typename?: 'AirFreightShipmentLineItemConnection' }
    & Pick<AirFreightShipmentLineItemConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'AirFreightShipmentLineItem' }
      & Pick<AirFreightShipmentLineItem, 'bookingReference' | 'collectionDate' | 'comments' | 'commodityCode' | 'consignee' | 'consignor' | 'createdAt' | 'eta' | 'externalShipmentId' | 'finalDestinationCode' | 'finalDestinationLocation' | 'finalPortOfDischargeCode' | 'finalPortOfDischargeLocation' | 'goodsDescription' | 'grossDimensions' | 'grossWeight' | 'housebill' | 'id' | 'isTransshipment' | 'natureOfGoods' | 'packageQuantity' | 'packageType' | 'orderReference' | 'specialHandling' | 'lastStatusMessage' | 'state' | 'transshipmentPort' | 'transshipmentCarrierName' | 'transshipmentFlightNumber' | 'updatedAt' | 'volume'>
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type EmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeesQuery = (
  { __typename?: 'Query' }
  & { employees?: Maybe<Array<(
    { __typename?: 'Employee' }
    & Pick<Employee, 'id' | 'userFirstName' | 'userLastName'>
  )>> }
);

export type AirFreightShipmentFieldsFragment = (
  { __typename?: 'AirFreightShipment' }
  & Pick<AirFreightShipment, 'id' | 'externalTransportMasterId' | 'createdAt' | 'updatedAt' | 'shipmentType' | 'carrierName' | 'flightNumber' | 'masterWaybillNumber' | 'shipper' | 'consignor' | 'consignee' | 'portOfLoadingCode' | 'portOfLoadingLocation' | 'forwarderName' | 'departureAirport' | 'estimatedDepartureTime' | 'actualDepartureTime' | 'portOfDestination' | 'estimatedArrivalTime' | 'actualArrivalTime' | 'controller' | 'userName' | 'phoneNumber' | 'state' | 'billToParty' | 'exporterCode' | 'fboCode'>
);

export type AirFreightShipmentLineItemFieldsFragment = (
  { __typename?: 'AirFreightShipmentLineItem' }
  & Pick<AirFreightShipmentLineItem, 'id' | 'externalShipmentId' | 'orderReference' | 'bookingReference' | 'consignee' | 'consignor' | 'finalPortOfDischargeCode' | 'finalPortOfDischargeLocation' | 'finalDestinationCode' | 'finalDestinationLocation' | 'eta' | 'collectionDate' | 'isTransshipment' | 'transshipmentCarrierName' | 'transshipmentFlightNumber' | 'transshipmentPort' | 'specialHandling' | 'comments' | 'packageType' | 'packageQuantity' | 'commodityCode' | 'goodsDescription' | 'natureOfGoods' | 'grossWeight' | 'volume' | 'grossDimensions' | 'housebill' | 'lastStatusMessage' | 'state'>
);

export type CompleteAirFreightShipmentMutationVariables = Exact<{
  completeAirFreightShipmentId: Scalars['Int'];
}>;


export type CompleteAirFreightShipmentMutation = (
  { __typename?: 'Mutation' }
  & { completeAirFreightShipment?: Maybe<(
    { __typename?: 'CompleteAirFreightShipmentPayload' }
    & Pick<CompleteAirFreightShipmentPayload, 'errors'>
  )> }
);

export type UpdateAirFreightShipmentControllerMutationVariables = Exact<{
  airFreightShipmentId: Scalars['Int'];
  controllerId?: Maybe<Scalars['Int']>;
  controllerName?: Maybe<Scalars['String']>;
}>;


export type UpdateAirFreightShipmentControllerMutation = (
  { __typename?: 'Mutation' }
  & { updateAirFreightShipmentController?: Maybe<(
    { __typename?: 'UpdateAirFreightShipmentControllerPayload' }
    & Pick<UpdateAirFreightShipmentControllerPayload, 'errors'>
  )> }
);

export type FetchTransnetVisitsByShipmentIdMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;


export type FetchTransnetVisitsByShipmentIdMutation = (
  { __typename?: 'Mutation' }
  & { fetchTransnetVisitsByShipment?: Maybe<(
    { __typename?: 'FetchTransnetVisitsByShipmentPayload' }
    & { visitList?: Maybe<Array<(
      { __typename?: 'Visit' }
      & Pick<Visit, 'arrivalNumber' | 'vesselName' | 'port' | 'vesselCallSign' | 'imoNumber' | 'arrivalDate' | 'departureDate' | 'voyageNumberIn' | 'voyageNumberOut'>
    )>> }
  )> }
);

export type FetchTransnetContainerOperatorsMutationVariables = Exact<{ [key: string]: never; }>;


export type FetchTransnetContainerOperatorsMutation = (
  { __typename?: 'Mutation' }
  & { fetchTransnetContainerOperators?: Maybe<(
    { __typename?: 'FetchTransnetContainerOperatorsPayload' }
    & Pick<FetchTransnetContainerOperatorsPayload, 'containerOperators'>
  )> }
);

export type FetchTransnetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchTransnetAccountsQuery = (
  { __typename?: 'Query' }
  & { transnetAccounts?: Maybe<Array<(
    { __typename?: 'TransnetAccount' }
    & Pick<TransnetAccount, 'id' | 'number'>
    & { seaPort: (
      { __typename?: 'SeaPort' }
      & Pick<SeaPort, 'id' | 'unLocode' | 'name' | 'country'>
    ) }
  )>> }
);

export type CreateCargoDueMutationVariables = Exact<{
  cargoDueData: Scalars['Json'];
  sliIds: Array<Scalars['ID']> | Scalars['ID'];
  transnetVisit: Scalars['Json'];
}>;


export type CreateCargoDueMutation = (
  { __typename?: 'Mutation' }
  & { createCargoDue?: Maybe<(
    { __typename?: 'CreateCargoDuePayload' }
    & Pick<CreateCargoDuePayload, 'errors'>
    & { cargoDue?: Maybe<(
      { __typename?: 'CargoDue' }
      & Pick<CargoDue, 'id' | 'status'>
    )> }
  )> }
);

export type CargoDuesQueryVariables = Exact<{
  filterAttributes: CargoDuesFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type CargoDuesQuery = (
  { __typename?: 'Query' }
  & { cargoDues?: Maybe<(
    { __typename?: 'ShipmentLineItemConnection' }
    & Pick<ShipmentLineItemConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'ShipmentLineItem' }
      & Pick<ShipmentLineItem, 'shipmentId' | 'clientReference' | 'shippingLineReference' | 'estimatedTimeOfDeparture' | 'actualTimeOfDeparture' | 'numberOfContainers'>
      & { sliContainer?: Maybe<(
        { __typename?: 'SliContainer' }
        & Pick<SliContainer, 'id'>
      )>, cargoDue?: Maybe<(
        { __typename?: 'CargoDue' }
        & Pick<CargoDue, 'id' | 'status' | 'submissionDate'>
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  )> }
);

export type TransnetTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransnetTerminalsQuery = (
  { __typename?: 'Query' }
  & { transnetTerminals?: Maybe<Array<(
    { __typename?: 'TransnetTerminal' }
    & Pick<TransnetTerminal, 'name' | 'code' | 'portName'>
  )>> }
);

export type CartonCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CartonCountsQuery = (
  { __typename?: 'Query' }
  & { cartonCounts?: Maybe<Array<(
    { __typename?: 'CartonCount' }
    & Pick<CartonCount, 'id' | 'name' | 'commodityId' | 'cartonTypeId' | 'counts' | 'priceMetric' | 'stackSizes'>
  )>> }
);

export type BaseCartonGroupingFieldsFragment = (
  { __typename?: 'CartonGrouping' }
  & Pick<CartonGrouping, 'id' | 'containerNumber' | 'state' | 'cartons' | 'palletNumber' | 'grade' | 'batchNumber' | 'sizeCount' | 'advancePrice' | 'finalPrice' | 'advanceDueDate' | 'finalDueDate'>
  & { lineItem?: Maybe<(
    { __typename?: 'LineItem' }
    & Pick<LineItem, 'currency' | 'incoterm' | 'mark' | 'orderId' | 'priceMinorUnit' | 'priceUnit' | 'referenceNumber'>
  )>, buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, seller?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )> }
);

export type CartonGroupingFragment = (
  { __typename?: 'CartonGrouping' }
  & Pick<CartonGrouping, 'targetRegion' | 'targetMarket' | 'targetCountry' | 'pack' | 'palletStack' | 'packhouseCode' | 'orchard' | 'containerNumber' | 'exporterCode' | 'farmCode' | 'packingWeek' | 'lineItemId' | 'consignmentNumber' | 'inventoryCode' | 'sequenceNumber' | 'coldStore' | 'productCharacteristic'>
  & { variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )> }
  )> }
  & BaseCartonGroupingFieldsFragment
);

export type CashFlowCartonGroupingFragment = (
  { __typename?: 'CartonGrouping' }
  & Pick<CartonGrouping, 'targetRegion' | 'targetMarket' | 'palletGrossMass'>
  & BaseCartonGroupingFieldsFragment
);

export type CartonGroupingsQueryVariables = Exact<{
  attributes: CartonGroupingSearchAttributes;
}>;


export type CartonGroupingsQuery = (
  { __typename?: 'Query' }
  & { cartonGroupingsSearch?: Maybe<(
    { __typename?: 'CartonGroupingSearch' }
    & { cartonGroupings: Array<(
      { __typename?: 'CartonGrouping' }
      & CartonGroupingFragment
    )> }
  )> }
);

export type CashFlowCartonGroupingsQueryVariables = Exact<{
  attributes: CartonGroupingSearchAttributes;
}>;


export type CashFlowCartonGroupingsQuery = (
  { __typename?: 'Query' }
  & { cartonGroupingsSearch?: Maybe<(
    { __typename?: 'CartonGroupingSearch' }
    & { cartonGroupings: Array<(
      { __typename?: 'CartonGrouping' }
      & CashFlowCartonGroupingFragment
    )> }
  )> }
);

export type ContainerClaimFieldsFragment = (
  { __typename?: 'ContainerClaim' }
  & Pick<ContainerClaim, 'id' | 'completedAt' | 'state' | 'companyId' | 'containerArrivalDate' | 'notes' | 'arrivalQcDatetime' | 'updatedAt' | 'containerableType' | 'vesselName' | 'voyageNumber' | 'containerableId'>
  & { container?: Maybe<(
    { __typename?: 'Container' }
    & Pick<Container, 'containerNumber'>
  )>, photos?: Maybe<Array<(
    { __typename?: 'Image' }
    & Pick<Image, 'id' | 'filename' | 'v2Url' | 'contentType'>
  )>>, documents?: Maybe<Array<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'filename' | 'v2Url' | 'contentType'>
  )>>, counterParty?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )> }
);

export type ClaimLineItemGroupingFieldsFragment = (
  { __typename?: 'ClaimLineItemGrouping' }
  & Pick<ClaimLineItemGrouping, 'id' | 'palletCount' | 'farmCode' | 'sizeCount' | 'grade' | 'arrivalQcGrade' | 'expectedClaims' | 'comment' | 'progressiveDefectPercentage' | 'cosmeticDefectPercentage' | 'otherDefectPercentage'>
  & { commodity?: Maybe<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name'>
  )>, variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'name'>
  )>, progressiveClaimLineItemDefects?: Maybe<Array<(
    { __typename?: 'ClaimLineItemDefect' }
    & ClaimLineItemDefectFieldsFragment
  )>>, progressiveDefectOptions?: Maybe<Array<(
    { __typename?: 'Defect' }
    & DefectFieldsFragment
  )>>, cosmeticClaimLineItemDefects?: Maybe<Array<(
    { __typename?: 'ClaimLineItemDefect' }
    & ClaimLineItemDefectFieldsFragment
  )>>, cosmeticDefectOptions?: Maybe<Array<(
    { __typename?: 'Defect' }
    & DefectFieldsFragment
  )>>, otherClaimLineItemDefects?: Maybe<Array<(
    { __typename?: 'ClaimLineItemDefect' }
    & ClaimLineItemDefectFieldsFragment
  )>>, otherDefectOptions?: Maybe<Array<(
    { __typename?: 'Defect' }
    & DefectFieldsFragment
  )>> }
);

export type DefectFieldsFragment = (
  { __typename?: 'Defect' }
  & Pick<Defect, 'id' | 'name' | 'category'>
);

export type ClaimLineItemDefectFieldsFragment = (
  { __typename?: 'ClaimLineItemDefect' }
  & Pick<ClaimLineItemDefect, 'defectPercentage'>
  & { defect: (
    { __typename?: 'Defect' }
    & DefectFieldsFragment
  ) }
);

export type ContainerClaimsQueryVariables = Exact<{
  containerClaimId?: Maybe<Scalars['ID']>;
  claimLineItemGroupingId?: Maybe<Scalars['ID']>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  tab: ArrivalQcTabEnum;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ContainerClaimsQuery = (
  { __typename?: 'Query' }
  & { claims?: Maybe<(
    { __typename?: 'Claims' }
    & { containerClaims: (
      { __typename?: 'ContainerClaimConnection' }
      & Pick<ContainerClaimConnection, 'totalCount'>
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'ContainerClaim' }
        & ContainerClaimFieldsFragment
      )>>>, pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
      ) }
    ) }
  )> }
);

export type ClaimLineItemGroupingsQueryVariables = Exact<{
  containerClaimId?: Maybe<Scalars['ID']>;
  claimLineItemGroupingId?: Maybe<Scalars['ID']>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  tab: ArrivalQcTabEnum;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ClaimLineItemGroupingsQuery = (
  { __typename?: 'Query' }
  & { claims?: Maybe<(
    { __typename?: 'Claims' }
    & { containerClaims: (
      { __typename?: 'ContainerClaimConnection' }
      & Pick<ContainerClaimConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
      ) }
    ), claimLineItemGroupings: Array<(
      { __typename?: 'ClaimLineItemGrouping' }
      & ClaimLineItemGroupingFieldsFragment
    )> }
  )> }
);

export type ClaimLineItemPalletsQueryVariables = Exact<{
  containerClaimId?: Maybe<Scalars['ID']>;
  claimLineItemGroupingId?: Maybe<Scalars['ID']>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  tab: ArrivalQcTabEnum;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ClaimLineItemPalletsQuery = (
  { __typename?: 'Query' }
  & { claims?: Maybe<(
    { __typename?: 'Claims' }
    & { containerClaims: (
      { __typename?: 'ContainerClaimConnection' }
      & Pick<ContainerClaimConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
      ) }
    ), claimLineItemPallets: Array<(
      { __typename?: 'ClaimLineItemPallet' }
      & Pick<ClaimLineItemPallet, 'id' | 'palletNumber' | 'arrivalQcGrade' | 'expectedClaim' | 'claimLineItemGroupingId'>
      & { claimLineItems?: Maybe<Array<(
        { __typename?: 'ClaimLineItem' }
        & Pick<ClaimLineItem, 'id'>
      )>>, progressiveClaimLineItemDefects?: Maybe<Array<(
        { __typename?: 'ClaimLineItemDefect' }
        & ClaimLineItemDefectFieldsFragment
      )>>, progressiveDefectOptions?: Maybe<Array<(
        { __typename?: 'Defect' }
        & DefectFieldsFragment
      )>>, cosmeticClaimLineItemDefects?: Maybe<Array<(
        { __typename?: 'ClaimLineItemDefect' }
        & ClaimLineItemDefectFieldsFragment
      )>>, cosmeticDefectOptions?: Maybe<Array<(
        { __typename?: 'Defect' }
        & DefectFieldsFragment
      )>>, otherClaimLineItemDefects?: Maybe<Array<(
        { __typename?: 'ClaimLineItemDefect' }
        & ClaimLineItemDefectFieldsFragment
      )>>, otherDefectOptions?: Maybe<Array<(
        { __typename?: 'Defect' }
        & DefectFieldsFragment
      )>>, commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type ContainersForArrivalQcQueryVariables = Exact<{
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type ContainersForArrivalQcQuery = (
  { __typename?: 'Query' }
  & { containersForArrivalQc?: Maybe<Array<(
    { __typename?: 'ContainersForArrivalQc' }
    & Pick<ContainersForArrivalQc, 'id' | 'containerNumber' | 'vesselName' | 'voyageNumber'>
  )>> }
);

export type BreakBulkContainersForArrivalQcQueryVariables = Exact<{
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type BreakBulkContainersForArrivalQcQuery = (
  { __typename?: 'Query' }
  & { breakBulkContainersForArrivalQc?: Maybe<Array<(
    { __typename?: 'BreakBulkContainer' }
    & Pick<BreakBulkContainer, 'id' | 'voyageNumber' | 'vesselName'>
    & { counterParty?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )> }
  )>> }
);

export type UpdateArrivalQcClaimLineItemPalletGradeMutationVariables = Exact<{
  claimLineItemIds: Array<Scalars['ID']> | Scalars['ID'];
  arrivalQcGrade: ArrivalQcGradeEnum;
}>;


export type UpdateArrivalQcClaimLineItemPalletGradeMutation = (
  { __typename?: 'Mutation' }
  & { updateArrivalQcClaimLineItemPalletGrade?: Maybe<(
    { __typename?: 'UpdateArrivalQcClaimLineItemPalletGradePayload' }
    & Pick<UpdateArrivalQcClaimLineItemPalletGradePayload, 'errors'>
    & { containerClaim?: Maybe<(
      { __typename?: 'ContainerClaim' }
      & ContainerClaimFieldsFragment
    )> }
  )> }
);

export type UpdateArrivalQcClaimLineItemGroupingGradeMutationVariables = Exact<{
  claimLineItemGroupingId: Scalars['ID'];
  arrivalQcGrade: ArrivalQcGradeEnum;
}>;


export type UpdateArrivalQcClaimLineItemGroupingGradeMutation = (
  { __typename?: 'Mutation' }
  & { updateArrivalQcClaimLineItemGroupingGrade?: Maybe<(
    { __typename?: 'UpdateArrivalQcClaimLineItemGroupingGradePayload' }
    & Pick<UpdateArrivalQcClaimLineItemGroupingGradePayload, 'errors'>
    & { containerClaim?: Maybe<(
      { __typename?: 'ContainerClaim' }
      & ContainerClaimFieldsFragment
    )> }
  )> }
);

export type UpdateClaimLineItemGroupingExpectedClaimMutationVariables = Exact<{
  claimLineItemGroupingId: Scalars['ID'];
  expectedClaim: ExpectedClaimEnum;
}>;


export type UpdateClaimLineItemGroupingExpectedClaimMutation = (
  { __typename?: 'Mutation' }
  & { updateClaimLineItemGroupingExpectedClaim?: Maybe<(
    { __typename?: 'UpdateClaimLineItemGroupingExpectedClaimPayload' }
    & Pick<UpdateClaimLineItemGroupingExpectedClaimPayload, 'errors'>
  )> }
);

export type UpdateClaimLineItemPalletExpectedClaimMutationVariables = Exact<{
  claimLineItemIds: Array<Scalars['ID']> | Scalars['ID'];
  expectedClaim: ExpectedClaimEnum;
}>;


export type UpdateClaimLineItemPalletExpectedClaimMutation = (
  { __typename?: 'Mutation' }
  & { updateClaimLineItemPalletExpectedClaim?: Maybe<(
    { __typename?: 'UpdateClaimLineItemPalletExpectedClaimPayload' }
    & Pick<UpdateClaimLineItemPalletExpectedClaimPayload, 'errors'>
  )> }
);

export type UpdateClaimLineItemGroupingCommentMutationVariables = Exact<{
  claimLineItemGroupingId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
}>;


export type UpdateClaimLineItemGroupingCommentMutation = (
  { __typename?: 'Mutation' }
  & { updateClaimLineItemGroupingComment?: Maybe<(
    { __typename?: 'UpdateClaimLineItemGroupingCommentPayload' }
    & Pick<UpdateClaimLineItemGroupingCommentPayload, 'errors'>
  )> }
);

export type UpdateClaimLineItemGroupingDefectMutationVariables = Exact<{
  claimLineItemGroupingId: Scalars['ID'];
  defectId: Scalars['ID'];
}>;


export type UpdateClaimLineItemGroupingDefectMutation = (
  { __typename?: 'Mutation' }
  & { updateClaimLineItemGroupingDefect?: Maybe<(
    { __typename?: 'UpdateClaimLineItemGroupingDefectPayload' }
    & Pick<UpdateClaimLineItemGroupingDefectPayload, 'errors'>
  )> }
);

export type UpdateClaimLineItemPalletDefectMutationVariables = Exact<{
  claimLineItemIds: Array<Scalars['ID']> | Scalars['ID'];
  defectId: Scalars['ID'];
}>;


export type UpdateClaimLineItemPalletDefectMutation = (
  { __typename?: 'Mutation' }
  & { updateClaimLineItemPalletDefect?: Maybe<(
    { __typename?: 'UpdateClaimLineItemPalletDefectPayload' }
    & Pick<UpdateClaimLineItemPalletDefectPayload, 'errors'>
  )> }
);

export type UpdateContainerClaimNoteMutationVariables = Exact<{
  containerClaimId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
}>;


export type UpdateContainerClaimNoteMutation = (
  { __typename?: 'Mutation' }
  & { updateContainerClaimNote?: Maybe<(
    { __typename?: 'UpdateContainerClaimNotePayload' }
    & Pick<UpdateContainerClaimNotePayload, 'errors'>
    & { containerClaim?: Maybe<(
      { __typename?: 'ContainerClaim' }
      & ContainerClaimFieldsFragment
    )> }
  )> }
);

export type UpdateArrivalQcCaptureDatetimeMutationVariables = Exact<{
  containerClaimId: Scalars['ID'];
  arrivalQcCaptureDatetime?: Maybe<Scalars['ISO8601DateTime']>;
}>;


export type UpdateArrivalQcCaptureDatetimeMutation = (
  { __typename?: 'Mutation' }
  & { updateArrivalQcCaptureDatetime?: Maybe<(
    { __typename?: 'UpdateArrivalQcCaptureDatetimePayload' }
    & Pick<UpdateArrivalQcCaptureDatetimePayload, 'errors'>
    & { containerClaim?: Maybe<(
      { __typename?: 'ContainerClaim' }
      & ContainerClaimFieldsFragment
    )> }
  )> }
);

export type MarkContainerClaimAsCompletedMutationVariables = Exact<{
  containerClaimId: Scalars['ID'];
}>;


export type MarkContainerClaimAsCompletedMutation = (
  { __typename?: 'Mutation' }
  & { markContainerClaimAsCompleted?: Maybe<(
    { __typename?: 'MarkContainerClaimAsCompletedPayload' }
    & Pick<MarkContainerClaimAsCompletedPayload, 'errors' | 'containerClaimId'>
  )> }
);

export type UpdateContainerClaimGradeMutationVariables = Exact<{
  containerClaimId: Scalars['ID'];
  arrivalQcState: ArrivalQcStateEnum;
  arrivalQcGrade: ArrivalQcGradeEnum;
}>;


export type UpdateContainerClaimGradeMutation = (
  { __typename?: 'Mutation' }
  & { updateContainerClaimGrade?: Maybe<(
    { __typename?: 'UpdateContainerClaimGradePayload' }
    & Pick<UpdateContainerClaimGradePayload, 'errors'>
    & { containerClaim?: Maybe<(
      { __typename?: 'ContainerClaim' }
      & ContainerClaimFieldsFragment
    )> }
  )> }
);

export type CaptureDefectPercentagesMutationVariables = Exact<{
  attributes: DefectPercentageCaptureAttributes;
}>;


export type CaptureDefectPercentagesMutation = (
  { __typename?: 'Mutation' }
  & { captureDefectPercentages?: Maybe<(
    { __typename?: 'CaptureDefectPercentagesPayload' }
    & Pick<CaptureDefectPercentagesPayload, 'errors'>
  )> }
);

export type RemoveClaimLineItemGroupingDefectMutationVariables = Exact<{
  claimLineItemGroupingId: Scalars['ID'];
  defectId: Scalars['ID'];
}>;


export type RemoveClaimLineItemGroupingDefectMutation = (
  { __typename?: 'Mutation' }
  & { removeClaimLineItemGroupingDefect?: Maybe<(
    { __typename?: 'RemoveClaimLineItemGroupingDefectPayload' }
    & Pick<RemoveClaimLineItemGroupingDefectPayload, 'errors'>
  )> }
);

export type RemoveClaimLineItemPalletDefectMutationVariables = Exact<{
  claimLineItemIds: Array<Scalars['ID']> | Scalars['ID'];
  defectId: Scalars['ID'];
  claimLineItemGroupingId: Scalars['ID'];
}>;


export type RemoveClaimLineItemPalletDefectMutation = (
  { __typename?: 'Mutation' }
  & { removeClaimLineItemPalletDefect?: Maybe<(
    { __typename?: 'RemoveClaimLineItemPalletDefectPayload' }
    & Pick<RemoveClaimLineItemPalletDefectPayload, 'errors'>
  )> }
);

export type RemoveClaimLineItemGroupingExpectedClaimMutationVariables = Exact<{
  claimLineItemGroupingId: Scalars['ID'];
  expectedClaim: ExpectedClaimEnum;
}>;


export type RemoveClaimLineItemGroupingExpectedClaimMutation = (
  { __typename?: 'Mutation' }
  & { removeClaimLineItemGroupingExpectedClaim?: Maybe<(
    { __typename?: 'RemoveClaimLineItemGroupingExpectedClaimPayload' }
    & Pick<RemoveClaimLineItemGroupingExpectedClaimPayload, 'errors'>
  )> }
);

export type RemoveClaimLineItemPalletExpectedClaimMutationVariables = Exact<{
  claimLineItemIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveClaimLineItemPalletExpectedClaimMutation = (
  { __typename?: 'Mutation' }
  & { removeClaimLineItemPalletExpectedClaim?: Maybe<(
    { __typename?: 'RemoveClaimLineItemPalletExpectedClaimPayload' }
    & Pick<RemoveClaimLineItemPalletExpectedClaimPayload, 'errors'>
  )> }
);

export type SoftDeleteContainerClaimMutationVariables = Exact<{
  containerClaimId: Scalars['ID'];
}>;


export type SoftDeleteContainerClaimMutation = (
  { __typename?: 'Mutation' }
  & { softDeleteContainerClaim?: Maybe<(
    { __typename?: 'SoftDeleteContainerClaimPayload' }
    & Pick<SoftDeleteContainerClaimPayload, 'error' | 'containerClaimId'>
  )> }
);

export type UploadClaimFilesMutationVariables = Exact<{
  containerClaimId: Scalars['ID'];
  files: Array<Scalars['Upload']> | Scalars['Upload'];
}>;


export type UploadClaimFilesMutation = (
  { __typename?: 'Mutation' }
  & { uploadClaimFiles?: Maybe<(
    { __typename?: 'UploadClaimFilesPayload' }
    & Pick<UploadClaimFilesPayload, 'errors'>
    & { containerClaim?: Maybe<(
      { __typename?: 'ContainerClaim' }
      & ContainerClaimFieldsFragment
    )> }
  )> }
);

export type GenerateArrivalQcsMutationVariables = Exact<{
  containerableIds: Array<Scalars['ID']> | Scalars['ID'];
  containerableType: ContainerableTypeEnum;
}>;


export type GenerateArrivalQcsMutation = (
  { __typename?: 'Mutation' }
  & { generateArrivalQcs?: Maybe<(
    { __typename?: 'GenerateArrivalQcsPayload' }
    & Pick<GenerateArrivalQcsPayload, 'success' | 'errors'>
  )> }
);

export type OnArrivalQcGenerationStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnArrivalQcGenerationStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onArrivalQcGenerationStateChange: (
    { __typename?: 'ArrivalQcGeneration' }
    & Pick<ArrivalQcGeneration, 'containerableId' | 'containerableType' | 'containerNumber' | 'vesselName' | 'voyageNumber' | 'status' | 'errorMessage' | 'containerClaimId'>
    & { counterParty?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )> }
  ) }
);

export type CommentFieldsFragment = (
  { __typename?: 'Comment' }
  & Pick<Comment, 'id' | 'commentText' | 'isDeleted' | 'createdAt' | 'updatedAt'>
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
    & { avatarFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'url'>
    )> }
  )> }
);

export type CreateCommentMutationVariables = Exact<{
  attributes: CreateCommentAttributes;
}>;


export type CreateCommentMutation = (
  { __typename?: 'Mutation' }
  & { createComment?: Maybe<(
    { __typename?: 'CreateCommentPayload' }
    & { comment?: Maybe<(
      { __typename?: 'Comment' }
      & CommentFieldsFragment
    )> }
  )> }
);

export type DeleteCommentMutationVariables = Exact<{
  commentid: Scalars['Int'];
}>;


export type DeleteCommentMutation = (
  { __typename?: 'Mutation' }
  & { deleteComment?: Maybe<(
    { __typename?: 'DeleteCommentPayload' }
    & { comment?: Maybe<(
      { __typename?: 'Comment' }
      & CommentFieldsFragment
    )> }
  )> }
);

export type CommercialTermChangeRequestFieldsFragment = (
  { __typename?: 'CommercialTermChangeRequest' }
  & Pick<CommercialTermChangeRequest, 'id' | 'message' | 'flag'>
  & { commercialTerm?: Maybe<(
    { __typename?: 'CommercialTerm' }
    & Pick<CommercialTerm, 'id'>
  )> }
);

export type CreateCommercialTermChangeRequestMutationVariables = Exact<{
  attributes: CreateCommercialTermChangeRequestAttributes;
}>;


export type CreateCommercialTermChangeRequestMutation = (
  { __typename?: 'Mutation' }
  & { createCommercialTermChangeRequest?: Maybe<(
    { __typename?: 'CreateCommercialTermChangeRequestPayload' }
    & { changeRequest?: Maybe<(
      { __typename?: 'CommercialTermChangeRequest' }
      & Pick<CommercialTermChangeRequest, 'id'>
    )> }
  )> }
);

export type CommercialTermFragment = (
  { __typename?: 'CommercialTerm' }
  & Pick<CommercialTerm, 'id' | 'startDate' | 'endDate' | 'targetRegion' | 'advanceType' | 'advanceUnit' | 'buyerId' | 'deleted' | 'pack' | 'grade' | 'paymentTerm' | 'advanceCreditTerm' | 'finalCreditTerm' | 'advanceEvent' | 'finalEvent' | 'advanceAmount' | 'rankOneAdvanceEvent' | 'rankOneFinalEvent' | 'advanceCurrency' | 'finalCurrency' | 'targetCountry' | 'exporterCode' | 'commodityName' | 'varietyName' | 'buyerName'>
  & { commodity?: Maybe<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name'>
  )>, buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name'>
  )> }
);

export type CommercialTermsQueryVariables = Exact<{
  filterAttributes: CommercialTermFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type CommercialTermsQuery = (
  { __typename?: 'Query' }
  & { commercialTerms?: Maybe<(
    { __typename?: 'CommercialTermConnection' }
    & Pick<CommercialTermConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'CommercialTerm' }
      & CommercialTermFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type CommercialTermFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommercialTermFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { commercialTermFilterAttributes?: Maybe<(
    { __typename?: 'CommercialTermFilterAttribute' }
    & Pick<CommercialTermFilterAttribute, 'targetRegions' | 'advanceTypes' | 'advanceUnits' | 'events'>
    & { commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>> }
  )> }
);

export type CartonTypesByCommodityQueryVariables = Exact<{
  commodityId: Scalars['ID'];
}>;


export type CartonTypesByCommodityQuery = (
  { __typename?: 'Query' }
  & { cartonTypesByCommodity?: Maybe<Array<(
    { __typename?: 'CartonType' }
    & Pick<CartonType, 'id' | 'name'>
  )>> }
);

export type UpsertCommercialTermMutationVariables = Exact<{
  attributes: CommercialTermAttributes;
}>;


export type UpsertCommercialTermMutation = (
  { __typename?: 'Mutation' }
  & { upsertCommercialTerm?: Maybe<(
    { __typename?: 'UpsertCommercialTermPayload' }
    & Pick<UpsertCommercialTermPayload, 'errors'>
    & { commercialTerm?: Maybe<(
      { __typename?: 'CommercialTerm' }
      & CommercialTermFragment
    )> }
  )> }
);

export type CommoditiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommoditiesQuery = (
  { __typename?: 'Query' }
  & { commodities?: Maybe<Array<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name'>
    & { varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name' | 'varietyName' | 'varietyCode'>
    )>> }
  )>> }
);

export type ExportersQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportersQuery = (
  { __typename?: 'Query' }
  & { supplierExporters?: Maybe<(
    { __typename?: 'SupplierExporters' }
    & { supplierExporters: Array<(
      { __typename?: 'SupplierExporter' }
      & Pick<SupplierExporter, 'id' | 'name' | 'exporterLogoImageUrl' | 'isPackhouseContainerised'>
      & { exporterCodes?: Maybe<Array<(
        { __typename?: 'ExporterCode' }
        & Pick<ExporterCode, 'id' | 'exporterCode'>
      )>>, exporter?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, foodBusinessOperators?: Maybe<Array<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id' | 'fboCode' | 'createdAt' | 'updatedAt'>
      )>>, coldStores?: Maybe<Array<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'createdAt' | 'updatedAt'>
      )>>, coldStoreClientChangeRequests?: Maybe<Array<(
        { __typename?: 'ExporterColdStoreClientChangeRequest' }
        & Pick<ExporterColdStoreClientChangeRequest, 'id' | 'status'>
        & { companyAssociation?: Maybe<(
          { __typename?: 'CompanyAssociation' }
          & Pick<CompanyAssociation, 'id' | 'name' | 'createdAt' | 'updatedAt'>
        )>, coldStore?: Maybe<(
          { __typename?: 'FoodBusinessOperator' }
          & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'createdAt' | 'updatedAt'>
        )> }
      )>>, masterfileConfig?: Maybe<(
        { __typename?: 'MasterfileConfig' }
        & Pick<MasterfileConfig, 'id' | 'state'>
      )> }
    )>, clientChangeRequests: Array<(
      { __typename?: 'SupplierExporterClientChangeRequest' }
      & Pick<SupplierExporterClientChangeRequest, 'id' | 'exporterLogoImageUrl' | 'relation' | 'oneswitchFacilitated' | 'exporterName' | 'fboId' | 'isPackhouseContainerised' | 'createdAt' | 'updatedAt'>
      & { supplier?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, exporter?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, exporterCodes?: Maybe<Array<(
        { __typename?: 'ExporterCode' }
        & Pick<ExporterCode, 'id' | 'exporterCode'>
      )>>, foodBusinessOperators?: Maybe<Array<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id' | 'fboCode' | 'createdAt' | 'updatedAt'>
      )>>, coldStores?: Maybe<Array<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'createdAt' | 'updatedAt'>
      )>> }
    )> }
  )> }
);

export type ExporterFbosQueryVariables = Exact<{ [key: string]: never; }>;


export type ExporterFbosQuery = (
  { __typename?: 'Query' }
  & { exporterFbos?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'companyLogoImageUrl' | 'name'>
      & { exporterCodes?: Maybe<Array<(
        { __typename?: 'ExporterCode' }
        & Pick<ExporterCode, 'id' | 'exporterCode'>
      )>> }
    )> }
  )>> }
);

export type CreateExporterAndColdStoreClientRequestMutationVariables = Exact<{
  exporterFboId: Scalars['ID'];
  coldStoreIds: Array<Scalars['ID']> | Scalars['ID'];
  isPackhouseContainerised?: Maybe<Scalars['Boolean']>;
}>;


export type CreateExporterAndColdStoreClientRequestMutation = (
  { __typename?: 'Mutation' }
  & { createExporterAndColdStoreClientRequest?: Maybe<(
    { __typename?: 'CreateExporterAndColdStoreClientRequestPayload' }
    & Pick<CreateExporterAndColdStoreClientRequestPayload, 'errors'>
    & { clientChangeRequest?: Maybe<(
      { __typename?: 'SupplierExporterClientChangeRequest' }
      & Pick<SupplierExporterClientChangeRequest, 'id' | 'fboId' | 'isPackhouseContainerised'>
      & { coldStores?: Maybe<Array<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id'>
      )>> }
    )> }
  )> }
);

export type ConfirmMasterfileConfigCompanyAssociationsMutationVariables = Exact<{
  masterfileConfigs: Array<MasterfileConfigCompanyAssociationInput> | MasterfileConfigCompanyAssociationInput;
}>;


export type ConfirmMasterfileConfigCompanyAssociationsMutation = (
  { __typename?: 'Mutation' }
  & { confirmMasterfileConfigCompanyAssociations?: Maybe<(
    { __typename?: 'ConfirmMasterfileConfigCompanyAssociationsPayload' }
    & Pick<ConfirmMasterfileConfigCompanyAssociationsPayload, 'errors'>
    & { masterfileConfigs?: Maybe<Array<(
      { __typename?: 'MasterfileConfig' }
      & Pick<MasterfileConfig, 'id' | 'state'>
    )>> }
  )> }
);

export type CreateSupplierExporterRequestMutationVariables = Exact<{
  attributes: CreateSupplierExporterRequestAttribute;
}>;


export type CreateSupplierExporterRequestMutation = (
  { __typename?: 'Mutation' }
  & { createSupplierExporterRequest?: Maybe<(
    { __typename?: 'CreateSupplierExporterRequestPayload' }
    & Pick<CreateSupplierExporterRequestPayload, 'errors'>
    & { clientChangeRequests?: Maybe<Array<(
      { __typename?: 'SupplierExporterClientChangeRequest' }
      & Pick<SupplierExporterClientChangeRequest, 'id' | 'exporterLogoImageUrl' | 'exporterName' | 'relation' | 'oneswitchFacilitated' | 'isPackhouseContainerised' | 'fboId' | 'createdAt' | 'updatedAt'>
      & { supplier?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, exporter?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, exporterCodes?: Maybe<Array<(
        { __typename?: 'ExporterCode' }
        & Pick<ExporterCode, 'id' | 'exporterCode'>
      )>>, foodBusinessOperators?: Maybe<Array<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id' | 'fboCode' | 'createdAt' | 'updatedAt'>
      )>> }
    )>> }
  )> }
);

export type ConfirmExporterColdStoresMutationVariables = Exact<{
  companyAssociationExportColdStoreAttributes: Array<CompanyAssociationExportColdStoreAttributes> | CompanyAssociationExportColdStoreAttributes;
  clientChangeRequestExportColdStoreAttributes: Array<ClientChangeRequestExportColdStoreAttributes> | ClientChangeRequestExportColdStoreAttributes;
}>;


export type ConfirmExporterColdStoresMutation = (
  { __typename?: 'Mutation' }
  & { confirmExporterColdStores?: Maybe<(
    { __typename?: 'ConfirmExporterColdStoresPayload' }
    & Pick<ConfirmExporterColdStoresPayload, 'errors' | 'success'>
  )> }
);

export type CreateExporterColdStoreRequestMutationVariables = Exact<{
  companyAssociationId: Scalars['ID'];
  coldStoreIds: Array<Scalars['ID']> | Scalars['ID'];
  isPackhouseContainerisation: Scalars['Boolean'];
}>;


export type CreateExporterColdStoreRequestMutation = (
  { __typename?: 'Mutation' }
  & { createExporterColdStoreRequest?: Maybe<(
    { __typename?: 'CreateExporterColdStoreRequestPayload' }
    & Pick<CreateExporterColdStoreRequestPayload, 'success' | 'errors'>
    & { clientChangeRequests?: Maybe<Array<(
      { __typename?: 'ExporterColdStoreClientChangeRequest' }
      & Pick<ExporterColdStoreClientChangeRequest, 'status'>
      & { companyAssociation?: Maybe<(
        { __typename?: 'CompanyAssociation' }
        & Pick<CompanyAssociation, 'id'>
      )>, coldStore?: Maybe<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id'>
      )> }
    )>> }
  )> }
);

export type UploadCompanyCertificateMutationVariables = Exact<{
  file: Scalars['Upload'];
  expirydate: Scalars['String'];
  companyid: Scalars['Int'];
  certificatetypeid: Scalars['Int'];
}>;


export type UploadCompanyCertificateMutation = (
  { __typename?: 'Mutation' }
  & { uploadCompanyCertificate?: Maybe<(
    { __typename?: 'UploadCompanyCertificatePayload' }
    & { certificate?: Maybe<(
      { __typename?: 'CompanyCertificate' }
      & Pick<CompanyCertificate, 'id' | 'expiryDate' | 'createdAt'>
      & { certificate?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'url' | 'v2Url'>
      )>, certificateType?: Maybe<(
        { __typename?: 'CertificateType' }
        & Pick<CertificateType, 'name' | 'id'>
      )> }
    )> }
  )> }
);

export type DeleteCompanyCertificateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCompanyCertificateMutation = (
  { __typename?: 'Mutation' }
  & { deleteCompanyCertificate?: Maybe<(
    { __typename?: 'DeleteCompanyCertificatePayload' }
    & Pick<DeleteCompanyCertificatePayload, 'id'>
  )> }
);

export type CertificateTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificateTypeQuery = (
  { __typename?: 'Query' }
  & { certificateTypes?: Maybe<Array<(
    { __typename?: 'CertificateType' }
    & Pick<CertificateType, 'id' | 'name'>
  )>> }
);

export type CommoditySeasonFragment = (
  { __typename?: 'CommoditySeason' }
  & Pick<CommoditySeason, 'id' | 'startDate' | 'endDate' | 'createdAt' | 'updatedAt'>
  & { commodity?: Maybe<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name' | 'commodityGroup'>
    & { icon?: Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'v2Url'>
    )> }
  )> }
);

export type MyCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCompanyQuery = (
  { __typename?: 'Query' }
  & { myCompany?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'about' | 'registrationNumber' | 'vatNumber' | 'createdAt' | 'state' | 'onboardingStep' | 'defaultLocale' | 'isSeller' | 'isBuyer'>
    & { logoFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'url'>
    )>, address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'addressLine1' | 'addressLine2' | 'city' | 'postalCode' | 'country'>
    )>, tradeRegions?: Maybe<Array<(
      { __typename?: 'TradeRegion' }
      & Pick<TradeRegion, 'id' | 'name' | 'code'>
      & { countries?: Maybe<Array<(
        { __typename?: 'TradeCountry' }
        & Pick<TradeCountry, 'id' | 'name' | 'code'>
      )>> }
    )>>, certificates?: Maybe<Array<(
      { __typename?: 'CompanyCertificate' }
      & Pick<CompanyCertificate, 'id' | 'expiryDate' | 'createdAt' | 'updatedAt'>
      & { certificate?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'url' | 'v2Url'>
      )>, certificateType?: Maybe<(
        { __typename?: 'CertificateType' }
        & Pick<CertificateType, 'name' | 'id'>
      )> }
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'FarmVariety' }
      & Pick<FarmVariety, 'id' | 'varietyId' | 'name' | 'peakCount' | 'hectares' | 'packingStart' | 'packingEnd'>
      & { variety?: Maybe<(
        { __typename?: 'Variety' }
        & Pick<Variety, 'id' | 'name' | 'varietyCode'>
      )>, commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
        & { icon?: Maybe<(
          { __typename?: 'Image' }
          & Pick<Image, 'v2Url'>
        )> }
      )>, images?: Maybe<Array<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'url' | 'v2Url' | 'filename' | 'thumbnailUrl' | 'v2ThumbnailUrl'>
      )>> }
    )>>, sellerVarieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
      & { commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
      )> }
    )>>, additionalFields?: Maybe<Array<(
      { __typename?: 'AdditionalField' }
      & Pick<AdditionalField, 'id' | 'companyId' | 'name' | 'description' | 'fieldType' | 'parameters' | 'createdAt' | 'updatedAt' | 'isPackingInstruction' | 'private'>
    )>>, activeUsers?: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'phoneNumber' | 'email' | 'state' | 'role'>
      & { roles?: Maybe<Array<(
        { __typename?: 'Role' }
        & Pick<Role, 'id' | 'name' | 'resourceType' | 'resourceId' | 'createdAt' | 'updatedAt'>
      )>>, employee?: Maybe<(
        { __typename?: 'Employee' }
        & Pick<Employee, 'id'>
      )> }
    )>>, invites?: Maybe<Array<(
      { __typename?: 'Invite' }
      & Pick<Invite, 'id' | 'email' | 'state'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, commoditySeasons?: Maybe<Array<(
      { __typename?: 'CommoditySeason' }
      & CommoditySeasonFragment
    )>> }
  )> }
);

export type TradePartnersForMyCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type TradePartnersForMyCompanyQuery = (
  { __typename?: 'Query' }
  & { myCompany?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'isBuyer' | 'isSeller'>
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>> }
  )> }
);

export type UpdateCompanyDetailsMutationVariables = Exact<{
  attributes: UpdateCompanyAttributes;
}>;


export type UpdateCompanyDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateCompanyDetails?: Maybe<(
    { __typename?: 'UpdateCompanyDetailsPayload' }
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name' | 'about' | 'registrationNumber' | 'vatNumber'>
      & { address?: Maybe<(
        { __typename?: 'Address' }
        & Pick<Address, 'addressLine1' | 'addressLine2' | 'city' | 'postalCode' | 'country'>
      )> }
    )> }
  )> }
);

export type UploadCompanyLogoMutationVariables = Exact<{
  file: Scalars['Upload'];
  companyid: Scalars['Int'];
}>;


export type UploadCompanyLogoMutation = (
  { __typename?: 'Mutation' }
  & { uploadCompanyLogo?: Maybe<(
    { __typename?: 'UploadCompanyLogoPayload' }
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & { logoFile?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'url'>
      )> }
    )> }
  )> }
);

export type UpdateCompanyTradeRegionsMutationVariables = Exact<{
  addtraderegions: Array<TradeRegionAttributes> | TradeRegionAttributes;
  removetraderegions: Array<TradeRegionAttributes> | TradeRegionAttributes;
}>;


export type UpdateCompanyTradeRegionsMutation = (
  { __typename?: 'Mutation' }
  & { updateCompanyTradeRegions?: Maybe<(
    { __typename?: 'UpdateCompanyTradeRegionsPayload' }
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & { tradeRegions?: Maybe<Array<(
        { __typename?: 'TradeRegion' }
        & Pick<TradeRegion, 'id' | 'name' | 'code'>
      )>> }
    )> }
  )> }
);

export type CurrencyConversionQueryVariables = Exact<{
  currencyConversionAttributes: CurrencyConversionAttributes;
}>;


export type CurrencyConversionQuery = (
  { __typename?: 'Query' }
  & { currencyConversion?: Maybe<(
    { __typename?: 'CurrencyConversion' }
    & Pick<CurrencyConversion, 'id' | 'rates' | 'timestamp'>
  )> }
);

export type CurrencyConversionByIdQueryVariables = Exact<{
  currencyConversionId: Scalars['ID'];
}>;


export type CurrencyConversionByIdQuery = (
  { __typename?: 'Query' }
  & { currencyConversionById?: Maybe<(
    { __typename?: 'CurrencyConversion' }
    & Pick<CurrencyConversion, 'id' | 'rates' | 'timestamp'>
  )> }
);

export type UpsertCurrencyExchangeRateMutationVariables = Exact<{
  currencyExchangeRateAttributes: CurrencyExchangeRateAttributes;
}>;


export type UpsertCurrencyExchangeRateMutation = (
  { __typename?: 'Mutation' }
  & { upsertCurrencyExchangeRate?: Maybe<(
    { __typename?: 'UpsertCurrencyExchangeRatePayload' }
    & Pick<UpsertCurrencyExchangeRatePayload, 'errors'>
    & { currencyExchangeRate?: Maybe<(
      { __typename?: 'CurrencyExchangeRate' }
      & Pick<CurrencyExchangeRate, 'id' | 'toCurrency' | 'fromCurrency' | 'exchangeRate' | 'exchangeRateType' | 'exchangeRateDate' | 'currencyConversionId' | 'exchangeableId' | 'exchangeableType'>
    )> }
  )> }
);

export type DeleteCurrencyExchangeRateMutationVariables = Exact<{
  currencyExchangeRateId: Scalars['ID'];
}>;


export type DeleteCurrencyExchangeRateMutation = (
  { __typename?: 'Mutation' }
  & { deleteCurrencyExchangeRate?: Maybe<(
    { __typename?: 'DeleteCurrencyExchangeRatePayload' }
    & Pick<DeleteCurrencyExchangeRatePayload, 'currencyExchangeRateId' | 'errors'>
  )> }
);

export type CurrencyExchangeRateQueryVariables = Exact<{
  exchangeableId: Scalars['ID'];
  exchangeableType: Scalars['String'];
}>;


export type CurrencyExchangeRateQuery = (
  { __typename?: 'Query' }
  & { currencyExchangeRate?: Maybe<(
    { __typename?: 'CurrencyExchangeRate' }
    & Pick<CurrencyExchangeRate, 'id' | 'toCurrency' | 'fromCurrency' | 'exchangeRate' | 'exchangeRateType' | 'exchangeRateDate' | 'currencyConversionId' | 'exchangeableId' | 'exchangeableType'>
  )> }
);

export type DashboardQueryQueryVariables = Exact<{
  locationId?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['Int']>;
  commoditygroups?: Maybe<Array<CommodityGroupEnum> | CommodityGroupEnum>;
  forExport?: Maybe<Scalars['Boolean']>;
}>;


export type DashboardQueryQuery = (
  { __typename?: 'Query' }
  & { dashboardTrackingData?: Maybe<(
    { __typename?: 'DashboardTrackingData' }
    & { cartonGroupings?: Maybe<Array<(
      { __typename?: 'DashboardCartonGrouping' }
      & Pick<DashboardCartonGrouping, 'batchNumber' | 'cartons' | 'commodityName' | 'consignmentNumber' | 'containerId' | 'exporterCode' | 'farmCode' | 'grade' | 'id' | 'inspectionDate' | 'inventoryCode' | 'locationId' | 'mark' | 'netMass' | 'orchard' | 'packhouseCode' | 'packingWeek' | 'palletGrossMass' | 'palletNumber' | 'productCharacteristic' | 'sequenceNumber' | 'state' | 'targetMarket' | 'targetCountry' | 'targetRegion' | 'varietyName'>
    )>>, containers?: Maybe<Array<(
      { __typename?: 'DashboardContainer' }
      & Pick<DashboardContainer, 'arrivalDate' | 'arrivalEventClassifier' | 'cartons' | 'cartonsInTransit' | 'containerId' | 'containerNumber' | 'containerType' | 'departureDate' | 'departureEventClassifier' | 'finalDestinationId' | 'finalDeliveryDatetime' | 'finalDestinationName' | 'finalDestinationType' | 'locationId' | 'id' | 'nextDeliveryDatetime' | 'nextDestinationId' | 'nextDestinationName' | 'nextDestinationType' | 'pallets' | 'palletsInTransit' | 'state' | 'stateInTransit'>
    )>>, locations?: Maybe<Array<(
      { __typename?: 'DashboardLocation' }
      & Pick<DashboardLocation, 'id' | 'cartons' | 'cartonsInTransit' | 'containers' | 'containersInTransit' | 'locationId' | 'locationType' | 'name' | 'pallets' | 'palletsInTransit' | 'unallocated' | 'unallocatedInTransit'>
      & { geoLocation?: Maybe<(
        { __typename?: 'GeoLocation' }
        & Pick<GeoLocation, 'lat' | 'lon'>
      )> }
    )>> }
  )> }
);

export type DashboardSearchQueryVariables = Exact<{
  fields?: Maybe<Array<DashboardSearchFieldsEnum> | DashboardSearchFieldsEnum>;
  searchTerm?: Maybe<Scalars['String']>;
  commodityGroups?: Maybe<Array<CommodityGroupEnum> | CommodityGroupEnum>;
}>;


export type DashboardSearchQuery = (
  { __typename?: 'Query' }
  & { dashboardSearch?: Maybe<(
    { __typename?: 'ElasticSearchResult' }
    & Pick<ElasticSearchResult, 'raw'>
    & { hits?: Maybe<Array<(
      { __typename?: 'ElasticHit' }
      & Pick<ElasticHit, 'score' | 'highlight'>
      & { source?: Maybe<(
        { __typename?: 'DashboardCartonGrouping' }
        & Pick<DashboardCartonGrouping, 'batchNumber' | 'cartons' | 'commodityName' | 'consignmentNumber' | 'containerId' | 'containerNumber' | 'exporterCode' | 'farmCode' | 'grade' | 'id' | 'inspectionDate' | 'inventoryCode' | 'locationId' | 'mark' | 'netMass' | 'orchard' | 'packhouseCode' | 'packingWeek' | 'palletGrossMass' | 'palletNumber' | 'productCharacteristic' | 'sequenceNumber' | 'state' | 'targetCountry' | 'targetMarket' | 'targetRegion' | 'varietyName'>
      ) | (
        { __typename?: 'DashboardContainer' }
        & Pick<DashboardContainer, 'arrivalDate' | 'cartons' | 'cartonsInTransit' | 'collectionDatetime' | 'containerId' | 'containerNumber' | 'containerType' | 'departureDate' | 'finalDeliveryDatetime' | 'finalDestinationId' | 'finalDestinationLatitude' | 'finalDestinationLongitude' | 'finalDestinationName' | 'finalDestinationType' | 'id' | 'locationId' | 'nextDeliveryDatetime' | 'nextDestinationId' | 'nextDestinationLatitude' | 'nextDestinationLongitude' | 'nextDestinationName' | 'nextDestinationType' | 'pallets' | 'palletsInTransit' | 'state' | 'stateInTransit'>
      ) | (
        { __typename?: 'DashboardLocation' }
        & Pick<DashboardLocation, 'cartons' | 'cartonsInTransit' | 'containers' | 'containersInTransit' | 'id' | 'locationId' | 'locationType' | 'name' | 'pallets' | 'palletsInTransit' | 'unallocated' | 'unallocatedInTransit'>
      )> }
    )>>, total?: Maybe<(
      { __typename?: 'ElasticTotal' }
      & Pick<ElasticTotal, 'relation' | 'value'>
    )> }
  )> }
);

export type DashboardFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardFiltersQuery = (
  { __typename?: 'Query' }
  & { dashboardFilters?: Maybe<(
    { __typename?: 'DashboardFilters' }
    & { commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name' | 'commodityGroup'>
    )>> }
  )> }
);

export type DataPreparationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataPreparationsQuery = (
  { __typename?: 'Query' }
  & { dataPreparations?: Maybe<Array<(
    { __typename?: 'DataPreparation' }
    & Pick<DataPreparation, 'id' | 'name'>
  )>> }
);

export type DataPreparationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DataPreparationQuery = (
  { __typename?: 'Query' }
  & { dataPreparation?: Maybe<(
    { __typename?: 'DataPreparation' }
    & Pick<DataPreparation, 'error' | 'id' | 'description' | 'name' | 'status' | 'updatedAt'>
    & { dataOutputs?: Maybe<Array<(
      { __typename?: 'DataOutput' }
      & Pick<DataOutput, 'createdAt' | 'downloadedAt' | 'fileType' | 'id'>
      & { outputFile?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'contentType' | 'filename' | 'id' | 'url' | 'v2Url'>
      )> }
    )>> }
  )> }
);

export type GenerateDataOutputFilesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenerateDataOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generateDataOutputFiles?: Maybe<(
    { __typename?: 'GenerateDataOutputFilesPayload' }
    & { dataPreparation?: Maybe<(
      { __typename?: 'DataPreparation' }
      & Pick<DataPreparation, 'status'>
    )> }
  )> }
);

export type UpdateDataOutputMutationVariables = Exact<{
  attributes: DataOutputAttributes;
}>;


export type UpdateDataOutputMutation = (
  { __typename?: 'Mutation' }
  & { updateDataOutput?: Maybe<(
    { __typename?: 'UpdateDataOutputPayload' }
    & Pick<UpdateDataOutputPayload, 'errors'>
    & { dataOutput?: Maybe<(
      { __typename?: 'DataOutput' }
      & Pick<DataOutput, 'id' | 'downloadedAt'>
    )> }
  )> }
);

export type DefaultCostsQueryVariables = Exact<{
  filterAttributes?: Maybe<DefaultCostFilters>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type DefaultCostsQuery = (
  { __typename?: 'Query' }
  & { defaultCosts?: Maybe<(
    { __typename?: 'DefaultCostConnection' }
    & Pick<DefaultCostConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'DefaultCost' }
      & { cartonGroupingTransaction?: Maybe<(
        { __typename?: 'CartonGroupingTransaction' }
        & Pick<CartonGroupingTransaction, 'id' | 'currency' | 'amountMajorUnit' | 'isActual' | 'quantityPriceMajorUnit' | 'quantityAmount' | 'quantityType'>
        & { cartonGrouping?: Maybe<(
          { __typename?: 'CartonGrouping' }
          & Pick<CartonGrouping, 'palletNumber' | 'containerNumber'>
        )> }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type FinanceRuleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FinanceRuleQuery = (
  { __typename?: 'Query' }
  & { financeRule?: Maybe<(
    { __typename?: 'FinanceRule' }
    & Pick<FinanceRule, 'id' | 'name' | 'amountCents' | 'ruleDescription' | 'createdAt' | 'endDate' | 'enabled' | 'isDefaultCost' | 'defaultCgtsFinalised' | 'defaultCgtsPendingReview' | 'currency' | 'unit' | 'percentage' | 'humanReadableExpression' | 'incotermForPercentageCalculation'>
    & { costCode?: Maybe<(
      { __typename?: 'CostCode' }
      & Pick<CostCode, 'id' | 'name'>
    )>, groupedCostCodes?: Maybe<Array<(
      { __typename?: 'GroupedCostCode' }
      & Pick<GroupedCostCode, 'startDate' | 'endDate'>
      & { costCode: (
        { __typename?: 'CostCode' }
        & Pick<CostCode, 'id' | 'name'>
      ) }
    )>> }
  )> }
);

export type RemoveDefaultCostsMutationVariables = Exact<{
  attributes: RemoveDefaultCostAttributes;
}>;


export type RemoveDefaultCostsMutation = (
  { __typename?: 'Mutation' }
  & { removeDefaultCosts?: Maybe<(
    { __typename?: 'RemoveDefaultCostsPayload' }
    & Pick<RemoveDefaultCostsPayload, 'errors' | 'cgtIds'>
  )> }
);

export type FinaliseDefaultCostsMutationVariables = Exact<{
  attributes: FinaliseDefaultCostAttributes;
}>;


export type FinaliseDefaultCostsMutation = (
  { __typename?: 'Mutation' }
  & { finaliseDefaultCosts?: Maybe<(
    { __typename?: 'FinaliseDefaultCostsPayload' }
    & Pick<FinaliseDefaultCostsPayload, 'errors' | 'cgtIds'>
  )> }
);

export type ContainersForFinanceRuleQueryVariables = Exact<{
  financeRuleId: Scalars['ID'];
}>;


export type ContainersForFinanceRuleQuery = (
  { __typename?: 'Query' }
  & { containersForFinanceRule?: Maybe<Array<(
    { __typename?: 'Container' }
    & Pick<Container, 'id' | 'containerNumber'>
  )>> }
);

export type DownloadDocumentsMutationVariables = Exact<{
  documentAttributes: Array<DownloadDocumentAttributes> | DownloadDocumentAttributes;
  zippedFilename: Scalars['String'];
}>;


export type DownloadDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { downloadDocuments?: Maybe<(
    { __typename?: 'DownloadDocumentsPayload' }
    & Pick<DownloadDocumentsPayload, 'url' | 'errors'>
  )> }
);

export type SendEmailMutationVariables = Exact<{
  attributes: SendEmailAttributes;
}>;


export type SendEmailMutation = (
  { __typename?: 'Mutation' }
  & { sendEmail?: Maybe<(
    { __typename?: 'SendEmailPayload' }
    & Pick<SendEmailPayload, 'errors' | 'message'>
  )> }
);

export type EmailDocumentsMutationVariables = Exact<{
  attributes: EmailDocumentsAttributes;
}>;


export type EmailDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { emailDocuments?: Maybe<(
    { __typename?: 'EmailDocumentsPayload' }
    & Pick<EmailDocumentsPayload, 'errors' | 'message'>
  )> }
);

export type EmailTaskDocumentsMutationVariables = Exact<{
  attributes: EmailTaskDocumentsAttributes;
}>;


export type EmailTaskDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { emailTaskDocuments?: Maybe<(
    { __typename?: 'EmailTaskDocumentsPayload' }
    & Pick<EmailTaskDocumentsPayload, 'errors' | 'message'>
  )> }
);

export type DuplicateEphytoMutationVariables = Exact<{
  id: Scalars['Int'];
  applicationType: Scalars['Int'];
}>;


export type DuplicateEphytoMutation = (
  { __typename?: 'Mutation' }
  & { duplicateEphyto?: Maybe<(
    { __typename?: 'DuplicateEphytoPayload' }
    & Pick<DuplicateEphytoPayload, 'id'>
  )> }
);

export type DeleteEphytoMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteEphytoMutation = (
  { __typename?: 'Mutation' }
  & { deleteEphyto?: Maybe<(
    { __typename?: 'DeleteEphytoPayload' }
    & Pick<DeleteEphytoPayload, 'message'>
  )> }
);

export type UpdateEphytoDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
  type: Scalars['String'];
}>;


export type UpdateEphytoDocumentMutation = (
  { __typename?: 'Mutation' }
  & { updateEphytoDocument?: Maybe<(
    { __typename?: 'UpdateEphytoDocumentPayload' }
    & Pick<UpdateEphytoDocumentPayload, 'errors'>
  )> }
);

export type UploadEphytoDocumentMutationVariables = Exact<{
  ephytoId: Scalars['Int'];
  file: Scalars['Upload'];
}>;


export type UploadEphytoDocumentMutation = (
  { __typename?: 'Mutation' }
  & { uploadEphytoDocument?: Maybe<(
    { __typename?: 'UploadEphytoDocumentPayload' }
    & Pick<UploadEphytoDocumentPayload, 'errors'>
    & { ephytoDocuments?: Maybe<Array<(
      { __typename?: 'EphytoDocument' }
      & EphytoDocumentFieldsFragment
    )>> }
  )> }
);

export type DeleteEphytoDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteEphytoDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteEphytoDocument?: Maybe<(
    { __typename?: 'DeleteEphytoDocumentPayload' }
    & Pick<DeleteEphytoDocumentPayload, 'id'>
  )> }
);

export type UpdateDraftEphytoMutationVariables = Exact<{
  ephytoId: Scalars['Int'];
}>;


export type UpdateDraftEphytoMutation = (
  { __typename?: 'Mutation' }
  & { updateDraftEphyto?: Maybe<(
    { __typename?: 'UpdateDraftEphytoPayload' }
    & Pick<UpdateDraftEphytoPayload, 'errors'>
    & { ephyto?: Maybe<(
      { __typename?: 'Ephyto' }
      & { ephytoTradeUnits?: Maybe<Array<(
        { __typename?: 'EphytoTradeUnit' }
        & EphytoTradeUnitCommonFieldsFragment
      )>>, ephytoConsignmentItems?: Maybe<Array<(
        { __typename?: 'EphytoConsignmentItem' }
        & EphytoConsignmentItemCommonFieldsFragment
      )>>, ephytoDocuments?: Maybe<Array<(
        { __typename?: 'EphytoDocument' }
        & EphytoDocumentFieldsFragment
      )>> }
      & EphytoCommonFieldsFragment
    )> }
  )> }
);

export type SubmitEphytoMutationVariables = Exact<{
  ephytoId: Scalars['Int'];
}>;


export type SubmitEphytoMutation = (
  { __typename?: 'Mutation' }
  & { submitEphyto?: Maybe<(
    { __typename?: 'SubmitEphytoPayload' }
    & Pick<SubmitEphytoPayload, 'errors'>
    & { ephyto?: Maybe<(
      { __typename?: 'Ephyto' }
      & { ephytoTradeUnits?: Maybe<Array<(
        { __typename?: 'EphytoTradeUnit' }
        & EphytoTradeUnitCommonFieldsFragment
      )>>, ephytoConsignmentItems?: Maybe<Array<(
        { __typename?: 'EphytoConsignmentItem' }
        & EphytoConsignmentItemCommonFieldsFragment
      )>>, ephytoDocuments?: Maybe<Array<(
        { __typename?: 'EphytoDocument' }
        & EphytoDocumentFieldsFragment
      )>> }
      & EphytoCommonFieldsFragment
    )> }
  )> }
);

export type DraftEphytoMutationVariables = Exact<{
  ephytoId: Scalars['Int'];
}>;


export type DraftEphytoMutation = (
  { __typename?: 'Mutation' }
  & { draftEphyto?: Maybe<(
    { __typename?: 'DraftEphytoPayload' }
    & Pick<DraftEphytoPayload, 'errors'>
    & { ephyto?: Maybe<(
      { __typename?: 'Ephyto' }
      & { ephytoTradeUnits?: Maybe<Array<(
        { __typename?: 'EphytoTradeUnit' }
        & EphytoTradeUnitCommonFieldsFragment
      )>>, ephytoConsignmentItems?: Maybe<Array<(
        { __typename?: 'EphytoConsignmentItem' }
        & EphytoConsignmentItemCommonFieldsFragment
      )>>, ephytoDocuments?: Maybe<Array<(
        { __typename?: 'EphytoDocument' }
        & EphytoDocumentFieldsFragment
      )>> }
      & EphytoCommonFieldsFragment
    )> }
  )> }
);

export type FetchEphytoStatusMutationVariables = Exact<{
  ephytoId: Scalars['Int'];
}>;


export type FetchEphytoStatusMutation = (
  { __typename?: 'Mutation' }
  & { fetchEphytoStatus?: Maybe<(
    { __typename?: 'FetchEphytoStatusPayload' }
    & Pick<FetchEphytoStatusPayload, 'errors'>
    & { ephyto?: Maybe<(
      { __typename?: 'Ephyto' }
      & { ephytoTradeUnits?: Maybe<Array<(
        { __typename?: 'EphytoTradeUnit' }
        & EphytoTradeUnitCommonFieldsFragment
      )>>, ephytoConsignmentItems?: Maybe<Array<(
        { __typename?: 'EphytoConsignmentItem' }
        & EphytoConsignmentItemCommonFieldsFragment
      )>>, ephytoDocuments?: Maybe<Array<(
        { __typename?: 'EphytoDocument' }
        & EphytoDocumentFieldsFragment
      )>> }
      & EphytoCommonFieldsFragment
    )> }
  )> }
);

export type GenerateEphytoMutationVariables = Exact<{
  isEntireBooking: Scalars['Boolean'];
  shipmentType: Scalars['String'];
  bookingReference?: Maybe<Scalars['String']>;
  ephytoId?: Maybe<Scalars['Int']>;
  sliIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GenerateEphytoMutation = (
  { __typename?: 'Mutation' }
  & { generateEphyto?: Maybe<(
    { __typename?: 'GenerateEphytoPayload' }
    & Pick<GenerateEphytoPayload, 'errors'>
    & { ephyto?: Maybe<(
      { __typename?: 'Ephyto' }
      & { ephytoTradeUnits?: Maybe<Array<(
        { __typename?: 'EphytoTradeUnit' }
        & EphytoTradeUnitCommonFieldsFragment
      )>>, ephytoConsignmentItems?: Maybe<Array<(
        { __typename?: 'EphytoConsignmentItem' }
        & EphytoConsignmentItemCommonFieldsFragment
      )>>, ephytoDocuments?: Maybe<Array<(
        { __typename?: 'EphytoDocument' }
        & EphytoDocumentFieldsFragment
      )>> }
      & EphytoCommonFieldsFragment
    )> }
  )> }
);

export type GenerateEphytoTradeUnitMutationVariables = Exact<{
  shipmentType: Scalars['String'];
  ephytoId?: Maybe<Scalars['Int']>;
}>;


export type GenerateEphytoTradeUnitMutation = (
  { __typename?: 'Mutation' }
  & { generateEphytoTradeUnit?: Maybe<(
    { __typename?: 'GenerateEphytoTradeUnitPayload' }
    & Pick<GenerateEphytoTradeUnitPayload, 'errors'>
    & { ephytoTradeUnits?: Maybe<Array<(
      { __typename?: 'EphytoTradeUnit' }
      & EphytoTradeUnitCommonFieldsFragment
    )>> }
  )> }
);

export type UpdateEphytoMutationVariables = Exact<{
  ephyto: EphytoAttributes;
  ephytoConsignmentItems: Array<EphytoConsignmentItemAttributes> | EphytoConsignmentItemAttributes;
}>;


export type UpdateEphytoMutation = (
  { __typename?: 'Mutation' }
  & { updateEphyto?: Maybe<(
    { __typename?: 'UpdateEphytoPayload' }
    & Pick<UpdateEphytoPayload, 'errors'>
  )> }
);

export type EphytoPackageTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoPackageTypesQuery = (
  { __typename?: 'Query' }
  & { ephytoPackageTypes?: Maybe<Array<(
    { __typename?: 'EphytoPackage' }
    & Pick<EphytoPackage, 'name' | 'code'>
  )>> }
);

export type EphytoAppliedChemicalsQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoAppliedChemicalsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'ephytoAppliedChemicals'>
);

export type EphytoTransportMeansQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoTransportMeansQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'ephytoTransportMeans'>
);

export type EphytoUnitOfMeasureCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoUnitOfMeasureCodesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'ephytoUnitOfMeasureCodes'>
);

export type EphytoTreatmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoTreatmentsQuery = (
  { __typename?: 'Query' }
  & { ephytoTreatments?: Maybe<Array<(
    { __typename?: 'EphytoTreatment' }
    & Pick<EphytoTreatment, 'firstLevel' | 'firstLevelCode' | 'secondLevel' | 'secondLevelCode'>
  )>> }
);

export type EphytoCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoCountriesQuery = (
  { __typename?: 'Query' }
  & { ephytoCountries?: Maybe<Array<(
    { __typename?: 'EphytoCountry' }
    & Pick<EphytoCountry, 'isoCode' | 'name'>
  )>> }
);

export type EphytoAgreementCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoAgreementCodesQuery = (
  { __typename?: 'Query' }
  & { ephytoAgreementCodes?: Maybe<Array<(
    { __typename?: 'EphytoAgreementCode' }
    & Pick<EphytoAgreementCode, 'agreementCode' | 'agreementName'>
  )>> }
);

export type EphytoLocationsQueryVariables = Exact<{
  countryCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type EphytoLocationsQuery = (
  { __typename?: 'Query' }
  & { ephytoLocations?: Maybe<Array<(
    { __typename?: 'EphytoLocation' }
    & Pick<EphytoLocation, 'name' | 'code'>
  )>> }
);

export type EphytoPortOfEntriesQueryVariables = Exact<{
  countryCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type EphytoPortOfEntriesQuery = (
  { __typename?: 'Query' }
  & { ephytoPortOfEntries?: Maybe<Array<(
    { __typename?: 'EphytoPortOfEntry' }
    & Pick<EphytoPortOfEntry, 'name' | 'code'>
  )>> }
);

export type EphytoContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoContactsQuery = (
  { __typename?: 'Query' }
  & { contacts?: Maybe<Array<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'id' | 'name' | 'info' | 'contactType'>
  )>> }
);

export type NonEphytoShipmentLineItemsQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
  type: Scalars['String'];
}>;


export type NonEphytoShipmentLineItemsQuery = (
  { __typename?: 'Query' }
  & { nonEphytoShipmentLineItems?: Maybe<Array<(
    { __typename?: 'NonEphytoShipmentLineItem' }
    & Pick<NonEphytoShipmentLineItem, 'id' | 'labelDisplay' | 'type'>
  )>> }
);

export type EphytosQueryVariables = Exact<{
  filterAttributes: EphytoFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type EphytosQuery = (
  { __typename?: 'Query' }
  & { ephytos?: Maybe<(
    { __typename?: 'EphytoConnection' }
    & Pick<EphytoConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Ephyto' }
      & Pick<Ephyto, 'id' | 'agreementCode' | 'applicationStatus' | 'state' | 'targetCountry' | 'unloadingBaseportLocation' | 'customReferenceNo' | 'applicationReferenceNo' | 'desiredIssueLocation' | 'departureDate' | 'applicationType' | 'consignorName' | 'consigneeName' | 'updatedAt'>
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type EphytoFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { ephytoFilterAttributes?: Maybe<(
    { __typename?: 'EphytoFilterAttribute' }
    & Pick<EphytoFilterAttribute, 'statuses' | 'customerReferences' | 'entryPorts' | 'consignees' | 'consignors' | 'vessels'>
  )> }
);

export type EphytoCertificateUrlQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type EphytoCertificateUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'ephytoCertificateUrl'>
);

export type ExportDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportDocumentTypesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'exportDocumentTypes'>
);

export type EphytoDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoDocumentTypesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'ephytoDocumentTypes'>
);

export type EphytoByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type EphytoByIdQuery = (
  { __typename?: 'Query' }
  & { ephytoById?: Maybe<(
    { __typename?: 'Ephyto' }
    & { ephytoTradeUnits?: Maybe<Array<(
      { __typename?: 'EphytoTradeUnit' }
      & EphytoTradeUnitCommonFieldsFragment
    )>>, ephytoConsignmentItems?: Maybe<Array<(
      { __typename?: 'EphytoConsignmentItem' }
      & EphytoConsignmentItemCommonFieldsFragment
    )>>, ephytoDocuments?: Maybe<Array<(
      { __typename?: 'EphytoDocument' }
      & EphytoDocumentFieldsFragment
    )>> }
    & EphytoCommonFieldsFragment
  )> }
);

export type EphytoCommonFieldsFragment = (
  { __typename?: 'Ephyto' }
  & Pick<Ephyto, 'id' | 'applicationReferenceNo' | 'applicationType' | 'applicationStatus' | 'cbrId' | 'cbrBillingId' | 'customReferenceNo' | 'agreementCode' | 'desiredIssueLocation' | 'notificationEmail' | 'consignorId' | 'consignorName' | 'consignorAddressLine1' | 'consignorAddressLine2' | 'consignorAddressLine3' | 'consigneeId' | 'consigneeName' | 'consigneeAddressLine1' | 'consigneeAddressLine2' | 'consigneeAddressLine3' | 'consigneeCountryId' | 'importCountryId' | 'targetCountryId' | 'unloadingBaseportLocation' | 'transportModeCode' | 'transportMeans' | 'paymentType' | 'dalrrdAccNum' | 'loadSeaPoint' | 'targetCountry' | 'targetRegion' | 'portOfEntry' | 'bookingRef' | 'vessel' | 'voyageNumber' | 'departureDate' | 'numberAndDescriptionOfPackage' | 'botanicalName' | 'distinguishingMarks' | 'placeOfOrigin' | 'declaredMeansOfConveyance' | 'declaredPointOfEntry' | 'nameOfProductAndDeclaredQuantity' | 'treatmentDate' | 'treatment' | 'chemical' | 'durationAndTemperature' | 'concentration' | 'additionalInformation' | 'state' | 'errorReason' | 'stuffDate' | 'temperatureRegime' | 'originalPhytoDate' | 'originalPhytoNo' | 'reexportPlaceOfOrigin' | 'originalPhyto' | 'rePacked' | 'originalContainer' | 'basedOnOriginalPhyto' | 'additionalInspection' | 'cbsFreeArea' | 'vatNo' | 'regimeCode' | 'importPermitNo' | 'importPermitDate'>
);

export type EphytoTradeUnitCommonFieldsFragment = (
  { __typename?: 'EphytoTradeUnit' }
  & Pick<EphytoTradeUnit, 'id' | 'tradeUnitId' | 'clientRef' | 'orchard' | 'phc' | 'productionArea' | 'commodity' | 'marketingIndication' | 'fleshColour' | 'tuClass' | 'containerNumber' | 'numberOfPackagedItems' | 'netTradeUnitWeight' | 'nettPalletWeight' | 'ppecbInspectionDate' | 'stuffDate' | 'inspectionManifestNo' | 'inspectionPointLocationCode'>
);

export type EphytoConsignmentItemCommonFieldsFragment = (
  { __typename?: 'EphytoConsignmentItem' }
  & Pick<EphytoConsignmentItem, 'id' | 'description' | 'commonName' | 'scientificName' | 'netWeightMeasureCode' | 'netWeightMeasure' | 'grossWeightMeasureCode' | 'grossWeightMeasure' | 'customsHarmonizedSystemClass' | 'commodityVegetablePart' | 'commodityConditionClass' | 'commodityIntentOfUseClass' | 'appliedProcessStartDate' | 'appliedProcessEndDate' | 'durationMeasureCode' | 'durationMeasure' | 'appliedProcessTreatmentTypeLevel1' | 'appliedProcessTreatmentTypeLevel2' | 'appliedProcessChemicalCode' | 'appliedProcessTemperatureUnitCode' | 'appliedProcessTemperature' | 'appliedProcessConcentrationUnitCode' | 'appliedProcessConcentration' | 'appliedProcessAdditionalNote' | 'fullTreatmentInformation' | 'packageLevelCode' | 'packageTypeCode' | 'packageItemUnitCode' | 'packageItemQuantity' | 'packageShippingMarks' | 'additionalConsignmentNotes' | 'sequenceNumeric'>
);

export type EphytoDocumentFieldsFragment = (
  { __typename?: 'EphytoDocument' }
  & Pick<EphytoDocument, 'id' | 'documentType'>
  & { file?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'filename' | 'v2Url'>
  )> }
);

export type EstimateConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type EstimateConfigQuery = (
  { __typename?: 'Query' }
  & { uiConfigs?: Maybe<Array<(
    { __typename?: 'UiConfig' }
    & Pick<UiConfig, 'id' | 'data'>
  )>> }
);

export type EstimateOptionsQueryVariables = Exact<{
  season: Scalars['Int'];
}>;


export type EstimateOptionsQuery = (
  { __typename?: 'Query' }
  & { myCompany?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
    & { sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, allCompanies?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>> }
  )>, commodities?: Maybe<Array<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name'>
  )>>, varieties?: Maybe<Array<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id'>
    )> }
  )>>, productionUnits?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'typeOfBusiness' | 'fboCode'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )> }
  )>>, packhouses?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'typeOfBusiness' | 'fboCode'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id'>
    )> }
  )>>, fboOrchards?: Maybe<Array<(
    { __typename?: 'FboOrchard' }
    & Pick<FboOrchard, 'id' | 'hectares' | 'orchard' | 'block'>
    & { variety: (
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
      & { commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
      )> }
    ), foodBusinessOperator: (
      { __typename?: 'FoodBusinessOperator' }
      & Pick<FoodBusinessOperator, 'id' | 'fboCode' | 'name'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )> }
    ) }
  )>>, cartonCounts?: Maybe<Array<(
    { __typename?: 'CartonCount' }
    & Pick<CartonCount, 'id' | 'name' | 'commodityId' | 'cartonTypeId' | 'counts' | 'priceMetric' | 'stackSizes'>
  )>>, commodityDefaultSeasons?: Maybe<Array<(
    { __typename?: 'CommodityDefaultSeason' }
    & Pick<CommodityDefaultSeason, 'commodityId' | 'minWeek' | 'maxWeek'>
  )>> }
);

export type EstimatesQueryVariables = Exact<{
  endWeek?: Maybe<Scalars['String']>;
  startWeek?: Maybe<Scalars['String']>;
  weeks?: Maybe<Scalars['Boolean']>;
  season?: Maybe<Scalars['Int']>;
  matchCols?: Maybe<Array<EstimateMatchModeEnum> | EstimateMatchModeEnum>;
  commodityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  subCommodityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  varietyIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  onlyEditableEstimates?: Maybe<Scalars['Boolean']>;
}>;


export type EstimatesQuery = (
  { __typename?: 'Query' }
  & { estimates?: Maybe<Array<(
    { __typename?: 'Estimate' }
    & Pick<Estimate, 'id' | 'week' | 'season'>
    & { provider?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, fboOrchard?: Maybe<(
      { __typename?: 'FboOrchard' }
      & Pick<FboOrchard, 'id' | 'orchard' | 'hectares'>
      & { foodBusinessOperator: (
        { __typename?: 'FoodBusinessOperator' }
        & { company?: Maybe<(
          { __typename?: 'Company' }
          & Pick<Company, 'id'>
        )> }
      ) }
    )>, cartonType: (
      { __typename?: 'CartonType' }
      & Pick<CartonType, 'id' | 'name'>
    ), commodity: (
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    ), variety?: Maybe<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
      & { subCommodity?: Maybe<(
        { __typename?: 'SubCommodity' }
        & Pick<SubCommodity, 'name'>
      )> }
    )>, productionUnit?: Maybe<(
      { __typename?: 'FoodBusinessOperator' }
      & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'typeOfBusiness'>
    )>, packHouse?: Maybe<(
      { __typename?: 'FoodBusinessOperator' }
      & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'typeOfBusiness'>
    )>, visibleCompanies?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, estimateValues?: Maybe<Array<(
      { __typename?: 'EstimateValue' }
      & Pick<EstimateValue, 'id' | 'estType' | 'value' | 'conversionWeight' | 'grade' | 'sizeCounts' | 'acceptedValue' | 'inSeasonValue'>
    )>> }
  )>> }
);

export type OrchardSeasonsQueryVariables = Exact<{
  season: Scalars['Int'];
}>;


export type OrchardSeasonsQuery = (
  { __typename?: 'Query' }
  & { orchardSeasons?: Maybe<Array<(
    { __typename?: 'OrchardSeason' }
    & Pick<OrchardSeason, 'id' | 'startDate' | 'endDate' | 'hectares' | 'plantedDate'>
    & { fboOrchard: (
      { __typename?: 'FboOrchard' }
      & Pick<FboOrchard, 'orchard'>
      & { foodBusinessOperator: (
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'fboCode'>
      ), variety: (
        { __typename?: 'Variety' }
        & Pick<Variety, 'name'>
        & { commodity?: Maybe<(
          { __typename?: 'Commodity' }
          & Pick<Commodity, 'id'>
        )> }
      ) }
    ) }
  )>> }
);

export type OrchardYieldsQueryVariables = Exact<{
  orchardSeasonId?: Maybe<Scalars['ID']>;
  capturedBefore: Scalars['ISO8601DateTime'];
  capturedAfter: Scalars['ISO8601DateTime'];
}>;


export type OrchardYieldsQuery = (
  { __typename?: 'Query' }
  & { orchardYields?: Maybe<Array<(
    { __typename?: 'OrchardYield' }
    & Pick<OrchardYield, 'id' | 'weight' | 'weightPerBin' | 'orchardSeasonId' | 'captureDate'>
  )>> }
);

export type UpdateOrchardSeasonsMutationVariables = Exact<{
  updateData?: Maybe<Array<OrchardSeasonAttributes> | OrchardSeasonAttributes>;
  deleteData?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type UpdateOrchardSeasonsMutation = (
  { __typename?: 'Mutation' }
  & { updateOrchardSeasons?: Maybe<(
    { __typename?: 'UpdateOrchardSeasonsPayload' }
    & { createSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )>, updateSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )>, deleteSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )> }
  )> }
);

export type GenerateCommoditySeasonsMutationVariables = Exact<{
  season: Scalars['Int'];
}>;


export type GenerateCommoditySeasonsMutation = (
  { __typename?: 'Mutation' }
  & { generateCommoditySeasons?: Maybe<(
    { __typename?: 'GenerateCommoditySeasonsPayload' }
    & Pick<GenerateCommoditySeasonsPayload, 'error' | 'failures' | 'successes'>
  )> }
);

export type UpdateOrchardYieldsMutationVariables = Exact<{
  createData?: Maybe<Array<OrchardYieldAttributes> | OrchardYieldAttributes>;
  updateData?: Maybe<Array<OrchardYieldAttributes> | OrchardYieldAttributes>;
  deleteData?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type UpdateOrchardYieldsMutation = (
  { __typename?: 'Mutation' }
  & { updateOrchardYields?: Maybe<(
    { __typename?: 'UpdateOrchardYieldsPayload' }
    & { createSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'errors' | 'failed' | 'succeeded'>
    )>, updateSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )>, deleteSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )> }
  )> }
);

export type UpdateEstimatesMutationVariables = Exact<{
  createData?: Maybe<Array<EstimateAttributes> | EstimateAttributes>;
  deleteData?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  updateData?: Maybe<Array<EstimateAttributes> | EstimateAttributes>;
}>;


export type UpdateEstimatesMutation = (
  { __typename?: 'Mutation' }
  & { updateEstimates?: Maybe<(
    { __typename?: 'UpdateEstimatesPayload' }
    & { createSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )>, updateSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )>, deleteSummary?: Maybe<(
      { __typename?: 'CudSummary' }
      & Pick<CudSummary, 'succeeded' | 'failed' | 'errors'>
    )> }
  )> }
);

export type DocumentsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  dateAfter?: Maybe<Scalars['ISO8601DateTime']>;
  dateBefore?: Maybe<Scalars['ISO8601DateTime']>;
  states?: Maybe<Array<EtlDocumentStateEnum> | EtlDocumentStateEnum>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTo?: Maybe<Scalars['String']>;
  documentTypes?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type DocumentsQuery = (
  { __typename?: 'Query' }
  & { documents: (
    { __typename?: 'EtlDocumentConnection' }
    & Pick<EtlDocumentConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'EtlDocument' }
      & DocumentFieldsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type DocumentQueryVariables = Exact<{
  documentId: Scalars['Int'];
}>;


export type DocumentQuery = (
  { __typename?: 'Query' }
  & { document: (
    { __typename?: 'EtlDocument' }
    & DocumentFieldsFragment
  ) }
);

export type DocumentRowsQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  documentId: Scalars['Int'];
  states?: Maybe<Array<EtlDocumentRowStateEnum> | EtlDocumentRowStateEnum>;
}>;


export type DocumentRowsQuery = (
  { __typename?: 'Query' }
  & { documentRows: (
    { __typename?: 'EtlDocumentRowConnection' }
    & Pick<EtlDocumentRowConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'EtlDocumentRow' }
      & Pick<EtlDocumentRow, 'createdAt' | 'errorReason' | 'id' | 'processOutput' | 'state' | 'value'>
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type UploadEtlDocumentMutationVariables = Exact<{
  documentId: Scalars['Int'];
  file: Scalars['Upload'];
}>;


export type UploadEtlDocumentMutation = (
  { __typename?: 'Mutation' }
  & { uploadEtlDocument?: Maybe<(
    { __typename?: 'UploadEtlDocumentPayload' }
    & { document?: Maybe<(
      { __typename?: 'EtlDocument' }
      & DocumentFieldsFragment
    )> }
  )> }
);

export type ProcessEtlDocumentMutationVariables = Exact<{
  documentId: Scalars['Int'];
}>;


export type ProcessEtlDocumentMutation = (
  { __typename?: 'Mutation' }
  & { processEtlDocument?: Maybe<(
    { __typename?: 'ProcessEtlDocumentPayload' }
    & { document?: Maybe<(
      { __typename?: 'EtlDocument' }
      & DocumentFieldsFragment
    )> }
  )> }
);

export type DocumentFieldsFragment = (
  { __typename?: 'EtlDocument' }
  & Pick<EtlDocument, 'createdAt' | 'updatedAt' | 'errorReason' | 'erroredRows' | 'fileUrl' | 'filename' | 'id' | 'processedRows' | 'rows' | 'state' | 'source' | 'documentType'>
  & { invoices?: Maybe<Array<(
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'id' | 'invoiceNumber' | 'invoiceDate' | 'state' | 'currency' | 'netAmountMajorUnit' | 'remittableAmountMajorUnit' | 'documentType'>
  )>>, invoiceEtlStates?: Maybe<Array<(
    { __typename?: 'EtlInvoiceState' }
    & Pick<EtlInvoiceState, 'invoiceId' | 'state' | 'processOutput'>
  )>> }
);

export type FarmVarietyFragment = (
  { __typename?: 'FarmVariety' }
  & Pick<FarmVariety, 'id' | 'varietyId' | 'name' | 'peakCount' | 'hectares' | 'packingStart' | 'packingEnd'>
  & { commodity?: Maybe<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name'>
  )>, images?: Maybe<Array<(
    { __typename?: 'Image' }
    & Pick<Image, 'id' | 'url' | 'v2Url' | 'filename' | 'thumbnailUrl' | 'v2ThumbnailUrl'>
  )>> }
);

export type CreateFarmVarietyMutationVariables = Exact<{
  attributes: CreateFarmVarietyAttributes;
}>;


export type CreateFarmVarietyMutation = (
  { __typename?: 'Mutation' }
  & { createFarmVariety?: Maybe<(
    { __typename?: 'CreateFarmVarietyPayload' }
    & { farmVariety?: Maybe<(
      { __typename?: 'FarmVariety' }
      & FarmVarietyFragment
    )> }
  )> }
);

export type UpdateFarmVarietyMutationVariables = Exact<{
  attributes: UpdateFarmVarietyAttributes;
}>;


export type UpdateFarmVarietyMutation = (
  { __typename?: 'Mutation' }
  & { updateFarmVariety?: Maybe<(
    { __typename?: 'UpdateFarmVarietyPayload' }
    & { farmVariety?: Maybe<(
      { __typename?: 'FarmVariety' }
      & FarmVarietyFragment
    )> }
  )> }
);

export type DeleteFarmVarietyMutationVariables = Exact<{
  varietyid: Scalars['Int'];
  companyId: Scalars['Int'];
}>;


export type DeleteFarmVarietyMutation = (
  { __typename?: 'Mutation' }
  & { deleteFarmVariety?: Maybe<(
    { __typename?: 'DeleteFarmVarietyPayload' }
    & { farmVariety?: Maybe<(
      { __typename?: 'FarmVariety' }
      & FarmVarietyFragment
    )> }
  )> }
);

export type UploadFarmVarietyImageMutationVariables = Exact<{
  id: Scalars['Int'];
  image: Scalars['Upload'];
}>;


export type UploadFarmVarietyImageMutation = (
  { __typename?: 'Mutation' }
  & { uploadFarmVarietyImage?: Maybe<(
    { __typename?: 'UploadFarmVarietyImagePayload' }
    & { farmVariety?: Maybe<(
      { __typename?: 'FarmVariety' }
      & FarmVarietyFragment
    )> }
  )> }
);

export type DeleteFarmVarietyImageMutationVariables = Exact<{
  varietyid: Scalars['Int'];
  imageid: Scalars['Int'];
}>;


export type DeleteFarmVarietyImageMutation = (
  { __typename?: 'Mutation' }
  & { deleteFarmVarietyImage?: Maybe<(
    { __typename?: 'DeleteFarmVarietyImagePayload' }
    & { farmVariety?: Maybe<(
      { __typename?: 'FarmVariety' }
      & FarmVarietyFragment
    )> }
  )> }
);

export type FinanceReportQueryVariables = Exact<{
  attributes: FinanceReportFilterAttributes;
}>;


export type FinanceReportQuery = (
  { __typename?: 'Query' }
  & { financeReport?: Maybe<(
    { __typename?: 'FinanceReport' }
    & { items?: Maybe<Array<(
      { __typename?: 'FinanceReportItem' }
      & Pick<FinanceReportItem, 'commodity' | 'variety' | 'amount' | 'amountPerCarton' | 'batchNumber' | 'buyer' | 'packType' | 'cartons' | 'stdCartons' | 'containerNumber' | 'currency' | 'exchangeRate' | 'exporterCode' | 'farmCode' | 'grade' | 'incoterm' | 'isActual' | 'palletNumber' | 'liReferenceNumber' | 'txReferenceNumber' | 'seller' | 'sizeCount' | 'state' | 'targetMarket' | 'targetRegion' | 'transactionDate' | 'transactionType' | 'transactionWeek' | 'shippingWeek' | 'packingWeek' | 'generalLedgerName' | 'secondaryCategory' | 'primaryCategory' | 'zarAmount' | 'zarPerCarton'>
    )>> }
  )> }
);

export type LatestCurrencyConversionQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestCurrencyConversionQuery = (
  { __typename?: 'Query' }
  & { latestCurrencyConversion?: Maybe<(
    { __typename?: 'CurrencyConversion' }
    & Pick<CurrencyConversion, 'rates' | 'timestamp'>
  )> }
);

export type GetFinanceRulesQueryVariables = Exact<{
  filterAttributes: FinanceRuleFilters;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  grouped?: Maybe<Scalars['Boolean']>;
  groupType?: Maybe<Scalars['String']>;
}>;


export type GetFinanceRulesQuery = (
  { __typename?: 'Query' }
  & { financeRules?: Maybe<(
    { __typename?: 'FinanceRuleConnection' }
    & Pick<FinanceRuleConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'FinanceRule' }
      & Pick<FinanceRule, 'id' | 'name' | 'amountCents' | 'createdAt' | 'currency' | 'enabled' | 'endDate' | 'incotermForPercentageCalculation' | 'simpleExpression' | 'simpleExpressionFields' | 'simpleExpressionMatchTypes' | 'simpleExpressionValues' | 'humanReadableExpression' | 'percentage' | 'startDate' | 'unit' | 'isDefaultCost' | 'ruleDescription' | 'updatedAt' | 'defaultCgtsPendingReview' | 'defaultCgtsFinalised' | 'formattedCost'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, costCode?: Maybe<(
        { __typename?: 'CostCode' }
        & Pick<CostCode, 'id' | 'name'>
      )>, matchCondition?: Maybe<(
        { __typename?: 'MatchCondition' }
        & Pick<MatchCondition, 'id'>
      )>, groupedCostCodes?: Maybe<Array<(
        { __typename?: 'GroupedCostCode' }
        & Pick<GroupedCostCode, 'financeRuleId' | 'startDate' | 'endDate'>
        & { costCode: (
          { __typename?: 'CostCode' }
          & Pick<CostCode, 'id' | 'name'>
        ) }
      )>> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type FinanceRulesFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceRulesFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { financeRulesFilterAttributes?: Maybe<(
    { __typename?: 'FinanceRuleFilterAttribute' }
    & Pick<FinanceRuleFilterAttribute, 'ruleNames' | 'currencies' | 'units' | 'startDates' | 'endDates' | 'enabled' | 'isDefaultCost'>
    & { costCodes?: Maybe<Array<(
      { __typename?: 'CostCode' }
      & Pick<CostCode, 'id' | 'name'>
    )>> }
  )> }
);

export type UpsertFinanceRulesMutationVariables = Exact<{
  attributesList: Array<FinanceRuleAttributes> | FinanceRuleAttributes;
}>;


export type UpsertFinanceRulesMutation = (
  { __typename?: 'Mutation' }
  & { upsertFinanceRule?: Maybe<(
    { __typename?: 'UpsertFinanceRulePayload' }
    & Pick<UpsertFinanceRulePayload, 'success'>
    & { errors?: Maybe<Array<(
      { __typename?: 'FinanceRuleError' }
      & Pick<FinanceRuleError, 'message'>
    )>>, financeRules?: Maybe<Array<(
      { __typename?: 'FinanceRule' }
      & Pick<FinanceRule, 'id' | 'name' | 'unit' | 'amountCents' | 'currency' | 'incotermForPercentageCalculation' | 'percentage' | 'startDate' | 'endDate' | 'createdAt' | 'updatedAt'>
    )>> }
  )> }
);

export type DeleteFinanceRuleMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteFinanceRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteFinanceRule?: Maybe<(
    { __typename?: 'DeleteFinanceRulePayload' }
    & Pick<DeleteFinanceRulePayload, 'success' | 'errors'>
  )> }
);

export type GetAllowedOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowedOptionsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'allowedUnits' | 'allowedIncoterms' | 'allowedCurrencies' | 'allowedMatchTypes'>
);

export type CreateFinanceRuleMutationVariables = Exact<{
  attributes: Array<FinanceRuleAttributes> | FinanceRuleAttributes;
}>;


export type CreateFinanceRuleMutation = (
  { __typename?: 'Mutation' }
  & { createFinanceRule?: Maybe<(
    { __typename?: 'CreateFinanceRulePayload' }
    & Pick<CreateFinanceRulePayload, 'errors'>
    & { financeRules?: Maybe<Array<(
      { __typename?: 'FinanceRule' }
      & Pick<FinanceRule, 'id'>
    )>> }
  )> }
);

export type UpdateFinanceRuleMutationVariables = Exact<{
  attributes: Array<FinanceRuleAttributes> | FinanceRuleAttributes;
  deleteIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateFinanceRuleMutation = (
  { __typename?: 'Mutation' }
  & { updateFinanceRule?: Maybe<(
    { __typename?: 'UpdateFinanceRulePayload' }
    & Pick<UpdateFinanceRulePayload, 'errors'>
    & { financeRules?: Maybe<Array<(
      { __typename?: 'FinanceRule' }
      & Pick<FinanceRule, 'id'>
    )>> }
  )> }
);

export type UpdateFinanceRuleEnabledStateMutationVariables = Exact<{
  updateIds: Array<Scalars['ID']> | Scalars['ID'];
  state: Scalars['Boolean'];
}>;


export type UpdateFinanceRuleEnabledStateMutation = (
  { __typename?: 'Mutation' }
  & { updateFinanceRuleEnabledState?: Maybe<(
    { __typename?: 'UpdateFinanceRuleEnabledStatePayload' }
    & Pick<UpdateFinanceRuleEnabledStatePayload, 'errors'>
    & { financeRules?: Maybe<Array<(
      { __typename?: 'FinanceRule' }
      & Pick<FinanceRule, 'id'>
    )>> }
  )> }
);

export type TradeCompaniesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TradeCompaniesQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'FarmVariety' }
      & Pick<FarmVariety, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, tradeRegions?: Maybe<Array<(
      { __typename?: 'TradeRegion' }
      & Pick<TradeRegion, 'id' | 'name' | 'code'>
      & { countries?: Maybe<Array<(
        { __typename?: 'TradeCountry' }
        & Pick<TradeCountry, 'id' | 'name' | 'code'>
      )>> }
    )>> }
  )> }
);

export type GenerateProducerStatementMutationVariables = Exact<{
  cartonGroupingIds: Array<Scalars['Int']> | Scalars['Int'];
  fileFormat: TemplateFileFormatEnum;
  reportingCurrency?: Maybe<Scalars['String']>;
}>;


export type GenerateProducerStatementMutation = (
  { __typename?: 'Mutation' }
  & { generateProducerStatement?: Maybe<(
    { __typename?: 'GenerateProducerStatementPayload' }
    & Pick<GenerateProducerStatementPayload, 'fileUrl' | 'statementNumber'>
  )> }
);

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
}>;


export type InviteUserMutation = (
  { __typename?: 'Mutation' }
  & { inviteUser?: Maybe<(
    { __typename?: 'InviteUserPayload' }
    & { invite?: Maybe<(
      { __typename?: 'Invite' }
      & Pick<Invite, 'id' | 'email' | 'state' | 'message' | 'createdAt' | 'updatedAt'>
    )> }
  )> }
);

export type RevokeInviteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RevokeInviteMutation = (
  { __typename?: 'Mutation' }
  & { revokeInvite?: Maybe<(
    { __typename?: 'RevokeInvitePayload' }
    & Pick<RevokeInvitePayload, 'id'>
  )> }
);

export type ResendInviteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ResendInviteMutation = (
  { __typename?: 'Mutation' }
  & { resendInvite?: Maybe<(
    { __typename?: 'ResendInvitePayload' }
    & Pick<ResendInvitePayload, 'id'>
  )> }
);

export type InvoicesSummaryQueryVariables = Exact<{
  filterAttributes: InvoicesFilters;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  page: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type InvoicesSummaryQuery = (
  { __typename?: 'Query' }
  & { invoices?: Maybe<(
    { __typename?: 'InvoiceConnection' }
    & Pick<InvoiceConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Invoice' }
      & InvoicesSummaryFieldsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type PopulateInvoiceContainerDataQueryVariables = Exact<{
  containerId: Scalars['Int'];
  selectedCurrency: Scalars['String'];
  invoiceType: Scalars['String'];
  cgIds: Array<Scalars['Int']> | Scalars['Int'];
  commercialTermId?: Maybe<Scalars['Int']>;
}>;


export type PopulateInvoiceContainerDataQuery = (
  { __typename?: 'Query' }
  & { populateInvoiceContainerData?: Maybe<(
    { __typename?: 'PopulateContainer' }
    & Pick<PopulateContainer, 'voyage'>
    & { invoiceLineItems?: Maybe<Array<(
      { __typename?: 'InvoiceLineItem' }
      & InvliCommonFieldsFragment
    )>>, portOfLoading?: Maybe<(
      { __typename?: 'SeaPort' }
      & InvPortFieldsFragment
    )>, portOfDestination?: Maybe<(
      { __typename?: 'SeaPort' }
      & InvPortFieldsFragment
    )>, vessel?: Maybe<(
      { __typename?: 'Vessel' }
      & Pick<Vessel, 'id' | 'vesselName'>
    )>, commercialTerm?: Maybe<(
      { __typename?: 'CommercialTerm' }
      & Pick<CommercialTerm, 'id' | 'paymentTerm' | 'advanceAmount' | 'advanceCreditTerm' | 'advanceType' | 'advanceUnit' | 'finalCreditTerm'>
    )> }
  )> }
);

export type InvoicesSummaryFieldsFragment = (
  { __typename?: 'Invoice' }
  & Pick<Invoice, 'invoiceNumber' | 'invoiceDate' | 'incoterm' | 'id' | 'currency' | 'totalIncoterm' | 'totalCostsMajorUnit' | 'netAmountMajorUnit' | 'advancePayment' | 'finalPayment' | 'exchangeRate' | 'allocatedAmountMajorUnit' | 'remainingAmountMajorUnit' | 'remittableAmountMajorUnit' | 'palletCount' | 'transportType' | 'documentType' | 'state' | 'updatedAt' | 'createdAt' | 'costs' | 'dueDate' | 'dueDateFinal' | 'dueDateAdvance' | 'poNumber'>
  & { portOfLoading?: Maybe<(
    { __typename?: 'SeaPort' }
    & InvPortFieldsFragment
  )>, portOfDestination?: Maybe<(
    { __typename?: 'SeaPort' }
    & InvPortFieldsFragment
  )>, vessel?: Maybe<(
    { __typename?: 'Vessel' }
    & Pick<Vessel, 'id' | 'vesselName'>
  )>, containers?: Maybe<Array<(
    { __typename?: 'Container' }
    & Pick<Container, 'containerNumber'>
  )>>, contacts?: Maybe<Array<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'name' | 'contactType' | 'createdByUserId'>
  )>>, templateOutput?: Maybe<Array<(
    { __typename?: 'TemplateOutput' }
    & TemplateOutputFieldsFragment
  )>>, linkedRecords?: Maybe<Array<(
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'id' | 'invoiceNumber' | 'documentType' | 'finalPayment' | 'state' | 'invoiceDate' | 'currency' | 'netAmountMajorUnit'>
  )>>, invoicePayments?: Maybe<Array<(
    { __typename?: 'InvoicePayment' }
    & Pick<InvoicePayment, 'id' | 'amountMajorUnit' | 'createdAt'>
    & { payment: (
      { __typename?: 'Payment' }
      & Pick<Payment, 'id' | 'description' | 'paymentDate' | 'totalAmountMajorUnit' | 'currency' | 'paymentType' | 'state'>
    ) }
  )>>, childInvoices?: Maybe<Array<(
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'id' | 'invoiceNumber' | 'documentType' | 'finalPayment' | 'state'>
  )>>, parentInvoice?: Maybe<(
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'id' | 'invoiceNumber' | 'documentType' | 'state'>
  )>, sentEmailList?: Maybe<Array<(
    { __typename?: 'SentEmail' }
    & Pick<SentEmail, 'id' | 'createdAt' | 'recipient' | 'attachments'>
  )>>, attachedDocuments?: Maybe<Array<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'v2Url' | 'filename' | 'contentType' | 'uploadedAt'>
  )>>, accountingExports?: Maybe<Array<(
    { __typename?: 'AccountingExport' }
    & Pick<AccountingExport, 'id' | 'exportedAt'>
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    ) }
  )>> }
);

export type InvoiceQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InvoiceQuery = (
  { __typename?: 'Query' }
  & { invoice?: Maybe<(
    { __typename?: 'Invoice' }
    & { invoiceLineItems?: Maybe<Array<(
      { __typename?: 'InvoiceLineItem' }
      & InvliCommonFieldsFragment
    )>>, currencyExchangeRate?: Maybe<(
      { __typename?: 'CurrencyExchangeRate' }
      & Pick<CurrencyExchangeRate, 'id' | 'fromCurrency' | 'toCurrency' | 'exchangeRate' | 'exchangeRateDate' | 'exchangeRateType'>
      & { currencyConversion?: Maybe<(
        { __typename?: 'CurrencyConversion' }
        & Pick<CurrencyConversion, 'id' | 'rates' | 'timestamp'>
      )> }
    )>, attachedDocuments?: Maybe<Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'v2Url' | 'filename' | 'contentType'>
    )>>, linkedAdvanceInvoice?: Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id' | 'invoiceNumber' | 'advancePayment'>
    )>, overRecoveryCreditNote?: Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id' | 'invoiceNumber' | 'totalIncoterm'>
    )> }
    & InvCommonFieldsFragment
  )> }
);

export type PopulateInvoiceFromParentQueryVariables = Exact<{
  parentInvoiceId: Scalars['Int'];
  documentType: Scalars['String'];
}>;


export type PopulateInvoiceFromParentQuery = (
  { __typename?: 'Query' }
  & { populateInvoiceFromParent?: Maybe<(
    { __typename?: 'ChildInvoice' }
    & Pick<ChildInvoice, 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & InvCommonFieldsFragment
    )>, revenueLineItems?: Maybe<Array<(
      { __typename?: 'InvoiceLineItem' }
      & InvliCommonFieldsFragment
    )>> }
  )> }
);

export type IncomeInvoiceLineItemsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IncomeInvoiceLineItemsQuery = (
  { __typename?: 'Query' }
  & { incomeInvoiceLineItems?: Maybe<Array<(
    { __typename?: 'InvoiceLineItem' }
    & InvliCommonFieldsFragment
  )>> }
);

export type CostInvoiceLineItemsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CostInvoiceLineItemsQuery = (
  { __typename?: 'Query' }
  & { costInvoiceLineItems?: Maybe<Array<(
    { __typename?: 'InvoiceLineItem' }
    & InvliCommonFieldsFragment
  )>> }
);

export type InvoiceCartonGroupingTransactionsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InvoiceCartonGroupingTransactionsQuery = (
  { __typename?: 'Query' }
  & { invoiceCartonGroupingTransactions?: Maybe<Array<(
    { __typename?: 'CartonGroupingTransaction' }
    & Pick<CartonGroupingTransaction, 'amountMajorUnit' | 'currency' | 'quantityType' | 'quantityPriceMajorUnit'>
    & { cartonGrouping?: Maybe<(
      { __typename?: 'CartonGrouping' }
      & Pick<CartonGrouping, 'palletNumber' | 'cartons'>
    )> }
  )>> }
);

export type InvoiceFilterAttributesQueryVariables = Exact<{
  page: Scalars['String'];
}>;


export type InvoiceFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { invoicesFilterAttributes?: Maybe<(
    { __typename?: 'InvoiceFilterAttribute' }
    & Pick<InvoiceFilterAttribute, 'incoterms' | 'states' | 'targetCountries' | 'invoiceNumbers' | 'transportTypes' | 'containers' | 'palletNumbers' | 'costCodes' | 'exportStatuses'>
    & { vessels?: Maybe<Array<(
      { __typename?: 'Vessel' }
      & Pick<Vessel, 'id' | 'vesselName'>
    )>>, contacts?: Maybe<Array<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'name' | 'contactType' | 'createdByUserId'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, documentTypes: Array<(
      { __typename?: 'InvoiceDocument' }
      & Pick<InvoiceDocument, 'type' | 'name'>
    )>, financialYearOptions?: Maybe<Array<(
      { __typename?: 'FinancialYearOption' }
      & Pick<FinancialYearOption, 'year' | 'label' | 'startDate' | 'endDate'>
    )>> }
  )> }
);

export type InvoiceNumberQueryVariables = Exact<{
  documenttype?: Maybe<Scalars['String']>;
}>;


export type InvoiceNumberQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'invoiceNumber'>
);

export type InvoiceSeaPortsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  seaportname?: Maybe<Scalars['String']>;
  isportofloading?: Maybe<Scalars['Boolean']>;
  orderbyinv?: Maybe<Scalars['Boolean']>;
}>;


export type InvoiceSeaPortsQuery = (
  { __typename?: 'Query' }
  & { seaPorts?: Maybe<Array<(
    { __typename?: 'SeaPort' }
    & InvPortFieldsFragment
  )>> }
);

export type InvoiceScrollTradeCountriesQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type InvoiceScrollTradeCountriesQuery = (
  { __typename?: 'Query' }
  & { invoiceScrollTradeCountries?: Maybe<(
    { __typename?: 'TradeCountryConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'TradeCountry' }
      & Pick<TradeCountry, 'id' | 'name'>
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type InvoiceVesselsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  seaportid?: Maybe<Scalars['Int']>;
  vesselname?: Maybe<Scalars['String']>;
}>;


export type InvoiceVesselsQuery = (
  { __typename?: 'Query' }
  & { vessels?: Maybe<Array<(
    { __typename?: 'Vessel' }
    & Pick<Vessel, 'id' | 'vesselName'>
  )>> }
);

export type InvoiceVoyagesQueryVariables = Exact<{
  vesselid: Scalars['Int'];
  seaportid?: Maybe<Scalars['Int']>;
}>;


export type InvoiceVoyagesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'voyages'>
);

export type InvoiceContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoiceContactsQuery = (
  { __typename?: 'Query' }
  & { contacts?: Maybe<Array<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'id' | 'name' | 'info' | 'contactType' | 'createdByUserId'>
  )>> }
);

export type VatTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type VatTypesQuery = (
  { __typename?: 'Query' }
  & { vatTypes?: Maybe<Array<(
    { __typename?: 'VatType' }
    & Pick<VatType, 'id' | 'name' | 'percentage'>
  )>> }
);

export type InvoiceContainersQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  port?: Maybe<Scalars['Int']>;
  containernumber?: Maybe<Scalars['String']>;
  excludesassignedinvlis?: Maybe<Scalars['Boolean']>;
  onlytrackingenabled?: Maybe<Scalars['Boolean']>;
}>;


export type InvoiceContainersQuery = (
  { __typename?: 'Query' }
  & { containers?: Maybe<Array<(
    { __typename?: 'Container' }
    & Pick<Container, 'containerNumber' | 'id' | 'stuffDate'>
  )>> }
);

export type InvoiceUnassignedCGsQueryVariables = Exact<{
  attributes: CartonGroupingSearchAttributes;
}>;


export type InvoiceUnassignedCGsQuery = (
  { __typename?: 'Query' }
  & { cartonGroupingsSearch?: Maybe<(
    { __typename?: 'CartonGroupingSearch' }
    & { cartonGroupings: Array<(
      { __typename?: 'CartonGrouping' }
      & InvCommonCgFieldsFragment
    )>, filterValues?: Maybe<(
      { __typename?: 'CartonGroupingFilters' }
      & Pick<CartonGroupingFilters, 'batchNumber' | 'consignmentNumber' | 'packingWeek' | 'targetMarket' | 'exporterCode' | 'voyageNumber'>
      & { vessel?: Maybe<Array<(
        { __typename?: 'Vessel' }
        & Pick<Vessel, 'id' | 'vesselName'>
      )>>, variety?: Maybe<Array<(
        { __typename?: 'Variety' }
        & Pick<Variety, 'id' | 'name'>
      )>>, seller?: Maybe<Array<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>>, buyer?: Maybe<Array<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>> }
    )> }
  )> }
);

export type FetchCgCommercialTermQueryVariables = Exact<{
  cgId: Scalars['ID'];
}>;


export type FetchCgCommercialTermQuery = (
  { __typename?: 'Query' }
  & { fetchCgCommercialTerm?: Maybe<(
    { __typename?: 'CommercialTerm' }
    & Pick<CommercialTerm, 'id' | 'paymentTerm' | 'advanceAmount' | 'advanceCreditTerm' | 'advanceType' | 'advanceUnit'>
  )> }
);

export type InvoiceCustomFieldsQueryVariables = Exact<{
  excludedCustomFieldIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type InvoiceCustomFieldsQuery = (
  { __typename?: 'Query' }
  & { customFields?: Maybe<Array<(
    { __typename?: 'CustomField' }
    & Pick<CustomField, 'id' | 'name' | 'required' | 'isDefault' | 'defaultValue'>
  )>> }
);

export type CompanyCostCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyCostCodesQuery = (
  { __typename?: 'Query' }
  & { companyCostCodes?: Maybe<Array<(
    { __typename?: 'CostCode' }
    & Pick<CostCode, 'id' | 'name'>
  )>> }
);

export type CreateQuickCostMutationVariables = Exact<{
  attributes: QuickCostAttributes;
}>;


export type CreateQuickCostMutation = (
  { __typename?: 'Mutation' }
  & { createQuickCost?: Maybe<(
    { __typename?: 'CreateQuickCostPayload' }
    & Pick<CreateQuickCostPayload, 'errors'>
  )> }
);

export type CalculatePalletCostsMutationVariables = Exact<{
  cgIds: Array<Scalars['Int']> | Scalars['Int'];
  costId: Scalars['Int'];
}>;


export type CalculatePalletCostsMutation = (
  { __typename?: 'Mutation' }
  & { calculatePalletCosts?: Maybe<(
    { __typename?: 'CalculatePalletCostsPayload' }
    & Pick<CalculatePalletCostsPayload, 'estimatePalletCosts' | 'errors'>
  )> }
);

export type CreateContactMutationVariables = Exact<{
  attributes: ContactAttributes;
}>;


export type CreateContactMutation = (
  { __typename?: 'Mutation' }
  & { createContact?: Maybe<(
    { __typename?: 'CreateContactPayload' }
    & Pick<CreateContactPayload, 'errors'>
    & { contact?: Maybe<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'name' | 'info' | 'contactType'>
    )> }
  )> }
);

export type UpdateContactMutationVariables = Exact<{
  attributes: ContactAttributes;
}>;


export type UpdateContactMutation = (
  { __typename?: 'Mutation' }
  & { updateContact?: Maybe<(
    { __typename?: 'UpdateContactPayload' }
    & Pick<UpdateContactPayload, 'errors'>
    & { contact?: Maybe<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'name' | 'info' | 'contactType'>
    )> }
  )> }
);

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteContactMutation = (
  { __typename?: 'Mutation' }
  & { deleteContact?: Maybe<(
    { __typename?: 'DeleteContactPayload' }
    & Pick<DeleteContactPayload, 'success' | 'errors'>
  )> }
);

export type CreateCustomFieldMutationVariables = Exact<{
  attributes: CustomFieldAttributes;
}>;


export type CreateCustomFieldMutation = (
  { __typename?: 'Mutation' }
  & { createCustomField?: Maybe<(
    { __typename?: 'CreateCustomFieldPayload' }
    & Pick<CreateCustomFieldPayload, 'errors'>
    & { customField?: Maybe<(
      { __typename?: 'CustomField' }
      & Pick<CustomField, 'id' | 'name' | 'required' | 'isDefault' | 'defaultValue'>
    )> }
  )> }
);

export type UpdateCustomFieldMutationVariables = Exact<{
  attributes: CustomFieldAttributes;
}>;


export type UpdateCustomFieldMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomField?: Maybe<(
    { __typename?: 'UpdateCustomFieldPayload' }
    & Pick<UpdateCustomFieldPayload, 'errors'>
    & { customField?: Maybe<(
      { __typename?: 'CustomField' }
      & Pick<CustomField, 'id' | 'name' | 'required' | 'isDefault' | 'defaultValue'>
    )> }
  )> }
);

export type DeleteCustomFieldMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCustomFieldMutation = (
  { __typename?: 'Mutation' }
  & { deleteCustomField?: Maybe<(
    { __typename?: 'DeleteCustomFieldPayload' }
    & Pick<DeleteCustomFieldPayload, 'success' | 'errors'>
  )> }
);

export type CreateInvoiceMutationVariables = Exact<{
  attributes: InvoiceAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
}>;


export type CreateInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { createInvoice?: Maybe<(
    { __typename?: 'CreateInvoicePayload' }
    & Pick<CreateInvoicePayload, 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & { cartonGroupings?: Maybe<Array<(
        { __typename?: 'CartonGrouping' }
        & InvCommonCgFieldsFragment
      )>>, invoiceLineItems?: Maybe<Array<(
        { __typename?: 'InvoiceLineItem' }
        & InvliCommonFieldsFragment
      )>> }
      & InvCommonFieldsFragment
    )> }
  )> }
);

export type CalculateCommercialsMutationVariables = Exact<{
  attributes: InvoiceAttributes;
}>;


export type CalculateCommercialsMutation = (
  { __typename?: 'Mutation' }
  & { calculateCommercials?: Maybe<(
    { __typename?: 'CalculateCommercialsPayload' }
    & Pick<CalculateCommercialsPayload, 'errors' | 'advancePayment' | 'finalPayment' | 'advanceCreditTerm' | 'finalCreditTerm'>
  )> }
);

export type DuplicateInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
  documentType: Scalars['String'];
  shouldDuplicateLineItems: Scalars['Boolean'];
}>;


export type DuplicateInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { duplicateInvoice?: Maybe<(
    { __typename?: 'DuplicateInvoicePayload' }
    & Pick<DuplicateInvoicePayload, 'errors' | 'id'>
  )> }
);

export type CaptureAccountSaleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CaptureAccountSaleMutation = (
  { __typename?: 'Mutation' }
  & { captureAccountSale?: Maybe<(
    { __typename?: 'CaptureAccountSalePayload' }
    & Pick<CaptureAccountSalePayload, 'errors' | 'id'>
  )> }
);

export type CreateInvoiceFromBatchMutationVariables = Exact<{
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
  documentType: Scalars['String'];
}>;


export type CreateInvoiceFromBatchMutation = (
  { __typename?: 'Mutation' }
  & { createInvoiceFromBatch?: Maybe<(
    { __typename?: 'CreateInvoiceFromBatchPayload' }
    & Pick<CreateInvoiceFromBatchPayload, 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id'>
    )> }
  )> }
);

export type UpdateInvoiceMutationVariables = Exact<{
  attributes: InvoiceAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
}>;


export type UpdateInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { updateInvoice?: Maybe<(
    { __typename?: 'UpdateInvoicePayload' }
    & Pick<UpdateInvoicePayload, 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & { cartonGroupings?: Maybe<Array<(
        { __typename?: 'CartonGrouping' }
        & InvCommonCgFieldsFragment
      )>>, invoiceLineItems?: Maybe<Array<(
        { __typename?: 'InvoiceLineItem' }
        & InvliCommonFieldsFragment
      )>> }
      & InvCommonFieldsFragment
    )>, reconciliationDocuments?: Maybe<Array<(
      { __typename?: 'ReconciliationDocument' }
      & Pick<ReconciliationDocument, 'id' | 'invoiceNumber' | 'documentType'>
    )>> }
  )> }
);

export type DeleteInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { deleteInvoice?: Maybe<(
    { __typename?: 'DeleteInvoicePayload' }
    & Pick<DeleteInvoicePayload, 'errors'>
  )> }
);

export type CalculateInvoiceTotalsMutationVariables = Exact<{
  attributes: InvoiceIncotermAttributes;
}>;


export type CalculateInvoiceTotalsMutation = (
  { __typename?: 'Mutation' }
  & { calculateInvoiceIncoterm?: Maybe<(
    { __typename?: 'CalculateInvoiceIncotermPayload' }
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id' | 'cartonCount' | 'currency' | 'freightCost' | 'insuranceCost' | 'localCosts' | 'palletCount' | 'totalFob' | 'totalIncoterm' | 'incoterm' | 'invoiceDate' | 'advancePayment' | 'advanceCreditTerm' | 'finalPayment' | 'finalCreditTerm' | 'state'>
    )> }
  )> }
);

export type GenerateInvoiceOutputFilesMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type GenerateInvoiceOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generateInvoiceOutputFiles?: Maybe<(
    { __typename?: 'GenerateInvoiceOutputFilesPayload' }
    & { templateOutput?: Maybe<Array<(
      { __typename?: 'TemplateOutput' }
      & Pick<TemplateOutput, 'errorReason' | 'id' | 'state' | 'templateVariant'>
    )>> }
  )> }
);

export type CgtCommonFieldsFragment = (
  { __typename?: 'CartonGroupingTransaction' }
  & Pick<CartonGroupingTransaction, 'id' | 'transactionDate' | 'amountMajorUnit' | 'currency' | 'exchangeRate' | 'exchangeCurrency' | 'externalReferenceNum' | 'isActual' | 'createdAt' | 'updatedAt' | 'quantityType' | 'quantityPriceMajorUnit' | 'quantityAmount' | 'netMass' | 'palletGrossMass' | 'accountType' | 'cartons' | 'targetMarket' | 'advanceTransactionUnitPrice'>
  & { cartonGrouping?: Maybe<(
    { __typename?: 'CartonGrouping' }
    & InvCommonCgFieldsFragment
  )> }
);

export type InvliCommonFieldsFragment = (
  { __typename?: 'InvoiceLineItem' }
  & Pick<InvoiceLineItem, 'id' | 'cartons' | 'currency' | 'netMass' | 'palletGrossMass' | 'priceUnit' | 'targetMarket' | 'sizeCount' | 'grade' | 'mark' | 'pack' | 'priceMinorUnit' | 'quantityAmount' | 'amount'>
  & { cartonGroupingTransactions?: Maybe<Array<(
    { __typename?: 'CartonGroupingTransaction' }
    & CgtCommonFieldsFragment
  )>>, variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )> }
  )>, costCode?: Maybe<(
    { __typename?: 'CostCode' }
    & Pick<CostCode, 'id' | 'name' | 'costType' | 'fieldName'>
  )>, vatType?: Maybe<(
    { __typename?: 'VatType' }
    & Pick<VatType, 'id' | 'name'>
  )> }
);

export type InvCommonFieldsFragment = (
  { __typename?: 'Invoice' }
  & Pick<Invoice, 'cartonCount' | 'convertTonToKg' | 'currency' | 'localCosts' | 'insuranceCost' | 'freightCost' | 'invoiceNumber' | 'invoiceDate' | 'incoterm' | 'totalFob' | 'advancePayment' | 'advanceCreditTerm' | 'finalPayment' | 'allocatedAmountMajorUnit' | 'finalCreditTerm' | 'dueDateFinal' | 'subTotal' | 'vat' | 'id' | 'palletCount' | 'poNumber' | 'totalIncoterm' | 'totalCostsMajorUnit' | 'netAmountMajorUnit' | 'ucrNumber' | 'voyage' | 'transportType' | 'documentType' | 'state' | 'airWaybillNo' | 'shipper' | 'destination' | 'allocatedWeight' | 'routing' | 'flightDate' | 'connectingFlightDate' | 'vehicleNumber' | 'saleType' | 'parentInvoiceId'>
  & { invoiceCustomFields?: Maybe<Array<(
    { __typename?: 'InvoiceCustomField' }
    & Pick<InvoiceCustomField, 'customFieldId' | 'name' | 'required' | 'value' | 'defaultValue' | 'isDefault' | 'customFieldDeleted'>
  )>>, countryOfOrigin?: Maybe<(
    { __typename?: 'TradeCountry' }
    & Pick<TradeCountry, 'id' | 'name'>
  )>, contacts?: Maybe<Array<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'id' | 'info' | 'name' | 'contactType' | 'createdByUserId'>
  )>>, containers?: Maybe<Array<(
    { __typename?: 'Container' }
    & Pick<Container, 'containerNumber' | 'id'>
  )>>, portOfLoading?: Maybe<(
    { __typename?: 'SeaPort' }
    & InvPortFieldsFragment
  )>, portOfDestination?: Maybe<(
    { __typename?: 'SeaPort' }
    & InvPortFieldsFragment
  )>, vessel?: Maybe<(
    { __typename?: 'Vessel' }
    & Pick<Vessel, 'id' | 'vesselName'>
  )>, templateOutput?: Maybe<Array<(
    { __typename?: 'TemplateOutput' }
    & TemplateOutputFieldsFragment
  )>>, childInvoices?: Maybe<Array<(
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'id' | 'invoiceNumber' | 'documentType' | 'finalPayment' | 'state'>
  )>>, stuffLocation?: Maybe<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name'>
  )>, loadingPoint?: Maybe<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name'>
  )>, offloadingPoint?: Maybe<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name'>
  )>, vatType?: Maybe<(
    { __typename?: 'VatType' }
    & Pick<VatType, 'id' | 'name' | 'percentage'>
  )>, parentInvoice?: Maybe<(
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'id' | 'invoiceNumber' | 'documentType' | 'advancePayment' | 'finalPayment' | 'state'>
  )>, commercialTerm?: Maybe<(
    { __typename?: 'CommercialTerm' }
    & Pick<CommercialTerm, 'id' | 'paymentTerm' | 'advanceAmount' | 'advanceCreditTerm' | 'advanceType' | 'advanceUnit' | 'finalCreditTerm'>
  )> }
);

export type InvCommonCgFieldsFragment = (
  { __typename?: 'CartonGrouping' }
  & Pick<CartonGrouping, 'batchNumber' | 'containerNumber' | 'cartons' | 'consignmentNumber' | 'exporterCode' | 'farmCode' | 'grade' | 'id' | 'inventoryCode' | 'mark' | 'netMass' | 'orchard' | 'pack' | 'packhouseCode' | 'packingWeek' | 'palletGrossMass' | 'palletNumber' | 'sequenceNumber' | 'sizeCount' | 'state' | 'targetCountry' | 'targetMarket' | 'targetRegion' | 'advancePrice' | 'finalPrice'>
  & { buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'name'>
  )>, invoiceLineItems?: Maybe<Array<(
    { __typename?: 'InvoiceLineItem' }
    & Pick<InvoiceLineItem, 'invoiceId' | 'priceUnit' | 'currency' | 'documentType'>
  )>>, lineItem?: Maybe<(
    { __typename?: 'LineItem' }
    & Pick<LineItem, 'priceUnit' | 'priceMinorUnit' | 'currency' | 'orderId'>
  )>, seller?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'name'>
  )>, variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>, subCommodity?: Maybe<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'name'>
    )> }
  )> }
);

export type InvPortFieldsFragment = (
  { __typename?: 'SeaPort' }
  & Pick<SeaPort, 'id' | 'name' | 'country' | 'createdAt' | 'updatedAt'>
);

export type UpdateInvoiceStateMutationVariables = Exact<{
  id: Scalars['Int'];
  state: Scalars['String'];
}>;


export type UpdateInvoiceStateMutation = (
  { __typename?: 'Mutation' }
  & { updateInvoiceState?: Maybe<(
    { __typename?: 'UpdateInvoiceStatePayload' }
    & Pick<UpdateInvoiceStatePayload, 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id' | 'state'>
    )> }
  )> }
);

export type UploadInvoiceDocumentsMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  files: Array<Scalars['Upload']> | Scalars['Upload'];
}>;


export type UploadInvoiceDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { uploadInvoiceDocuments?: Maybe<(
    { __typename?: 'UploadInvoiceDocumentsPayload' }
    & Pick<UploadInvoiceDocumentsPayload, 'errors' | 'warnings'>
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id'>
    )> }
  )> }
);

export type DeleteInvoiceDocumentMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  documentId: Scalars['ID'];
}>;


export type DeleteInvoiceDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteInvoiceDocument?: Maybe<(
    { __typename?: 'DeleteInvoiceDocumentPayload' }
    & Pick<DeleteInvoiceDocumentPayload, 'errors'>
    & { invoice?: Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id'>
    )> }
  )> }
);

export type LineItemQueryVariables = Exact<{
  lineItemId: Scalars['ID'];
  unit?: Maybe<Scalars['String']>;
  currency?: Maybe<CurrencyEnum>;
  incoterm?: Maybe<IncotermWithNscEnum>;
}>;


export type LineItemQuery = (
  { __typename?: 'Query' }
  & { lineItem?: Maybe<(
    { __typename?: 'LineItem' }
    & { expectedReturnSummary?: Maybe<(
      { __typename?: 'ExpectedReturnSummary' }
      & Pick<ExpectedReturnSummary, 'unit' | 'error'>
      & { pricePoints?: Maybe<Array<(
        { __typename?: 'IncotermPrice' }
        & Pick<IncotermPrice, 'incoterm'>
        & { moneyAmount: (
          { __typename?: 'Money' }
          & Pick<Money, 'displayString' | 'fractional' | 'amount'>
          & { currency: (
            { __typename?: 'Currency' }
            & Pick<Currency, 'symbol' | 'isoCode' | 'smallestDenomination' | 'subunitToUnit'>
          ) }
        ), chargesApplied?: Maybe<Array<(
          { __typename?: 'ChargeApplied' }
          & Pick<ChargeApplied, 'name'>
          & { moneyAmount: (
            { __typename?: 'Money' }
            & Pick<Money, 'displayString' | 'fractional' | 'amount'>
            & { currency: (
              { __typename?: 'Currency' }
              & Pick<Currency, 'symbol' | 'isoCode' | 'smallestDenomination' | 'subunitToUnit'>
            ) }
          ) }
        )>> }
      )>> }
    )> }
  )> }
);

export type HistoricalMarketVolumesQueryVariables = Exact<{
  companyId: Scalars['ID'];
  commodityId: Scalars['ID'];
  regionCode: Scalars['String'];
}>;


export type HistoricalMarketVolumesQuery = (
  { __typename?: 'Query' }
  & { historicalMarketVolumes?: Maybe<Array<(
    { __typename?: 'HistoricalMarketVolume' }
    & Pick<HistoricalMarketVolume, 'companyName' | 'targetRegion' | 'commodityName' | 'grade'>
  )>> }
);

export type ExpectedReturnSummaryFieldsFragment = (
  { __typename?: 'ExpectedReturnSummary' }
  & Pick<ExpectedReturnSummary, 'unit' | 'error'>
  & { pricePoints?: Maybe<Array<(
    { __typename?: 'IncotermPrice' }
    & Pick<IncotermPrice, 'incoterm'>
    & { moneyAmount: (
      { __typename?: 'Money' }
      & Pick<Money, 'displayString' | 'fractional' | 'amount'>
      & { currency: (
        { __typename?: 'Currency' }
        & Pick<Currency, 'symbol' | 'isoCode' | 'smallestDenomination' | 'subunitToUnit'>
      ) }
    ), chargesApplied?: Maybe<Array<(
      { __typename?: 'ChargeApplied' }
      & Pick<ChargeApplied, 'name'>
      & { moneyAmount: (
        { __typename?: 'Money' }
        & Pick<Money, 'displayString' | 'fractional' | 'amount'>
        & { currency: (
          { __typename?: 'Currency' }
          & Pick<Currency, 'symbol' | 'isoCode' | 'smallestDenomination' | 'subunitToUnit'>
        ) }
      ) }
    )>> }
  )>> }
);

export type CreateIncotermLineItemMutationVariables = Exact<{
  attributes: CreateLineItemAttributes;
  buyerId?: Maybe<Scalars['ID']>;
  sellerId?: Maybe<Scalars['ID']>;
  currency?: Maybe<CurrencyEnum>;
  unit?: Maybe<Scalars['String']>;
  incoterm?: Maybe<IncotermWithNscEnum>;
}>;


export type CreateIncotermLineItemMutation = (
  { __typename?: 'Mutation' }
  & { createIncotermLineItem?: Maybe<(
    { __typename?: 'CreateIncotermLineItemPayload' }
    & Pick<CreateIncotermLineItemPayload, 'errors'>
    & { lineItem?: Maybe<(
      { __typename?: 'LineItem' }
      & { expectedReturnSummary?: Maybe<(
        { __typename?: 'ExpectedReturnSummary' }
        & ExpectedReturnSummaryFieldsFragment
      )> }
    )> }
  )> }
);

export type CreateIncotermLineItemsMutationVariables = Exact<{
  lineItemAttributes: Array<CreateLineItemAttributes> | CreateLineItemAttributes;
  currency?: Maybe<CurrencyEnum>;
  unit?: Maybe<Scalars['String']>;
  incoterm?: Maybe<IncotermWithNscEnum>;
}>;


export type CreateIncotermLineItemsMutation = (
  { __typename?: 'Mutation' }
  & { createIncotermLineItems?: Maybe<(
    { __typename?: 'CreateIncotermLineItemsPayload' }
    & Pick<CreateIncotermLineItemsPayload, 'errors'>
    & { lineItems?: Maybe<Array<(
      { __typename?: 'LineItem' }
      & { expectedReturnSummary?: Maybe<(
        { __typename?: 'ExpectedReturnSummary' }
        & ExpectedReturnSummaryFieldsFragment
      )> }
    )>> }
  )> }
);

export type LoisSummaryQueryVariables = Exact<{
  filterAttributes?: Maybe<LoadOutInstructionsFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type LoisSummaryQuery = (
  { __typename?: 'Query' }
  & { loadOutInstructions?: Maybe<(
    { __typename?: 'LoadOutInstructionConnection' }
    & Pick<LoadOutInstructionConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'LoadOutInstruction' }
      & Pick<LoadOutInstruction, 'loadOutReference' | 'bookingReference' | 'containerNumber' | 'transportType' | 'exportersReference' | 'shippingLine' | 'clientReference' | 'voyage' | 'portOfLoadingName' | 'portOfDestinationName' | 'estimatedTimeOfDelivery' | 'exporterName' | 'stuffDate' | 'vesselName' | 'truckReference' | 'consignmentReference' | 'orderReference' | 'loadDate' | 'id' | 'fileNumber' | 'airWaybillNo' | 'shipper' | 'destination' | 'flightDate' | 'updatedAt' | 'createdAt' | 'palletCount' | 'stackDates' | 'stackDatesClose'>
      & { contacts?: Maybe<Array<(
        { __typename?: 'Contact' }
        & Pick<Contact, 'name' | 'contactType' | 'createdByUserId'>
      )>>, loadingPoint?: Maybe<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'name'>
      )>, offloadingPoint?: Maybe<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'name'>
      )>, sentEmailList?: Maybe<Array<(
        { __typename?: 'SentEmail' }
        & Pick<SentEmail, 'id' | 'createdAt' | 'recipient' | 'attachments'>
      )>>, templateOutput?: Maybe<(
        { __typename?: 'TemplateOutput' }
        & { outputFiles?: Maybe<Array<(
          { __typename?: 'Document' }
          & Pick<Document, 'id' | 'filename'>
        )>> }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type LoiFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type LoiFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { loadOutInstructionsFilterAttributes?: Maybe<(
    { __typename?: 'LoadOutInstructionFilterAttribute' }
    & { commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, vessels?: Maybe<Array<(
      { __typename?: 'Vessel' }
      & Pick<Vessel, 'id' | 'vesselName'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
    )>>, exporters?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, contacts?: Maybe<Array<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'name' | 'contactType' | 'createdByUserId'>
    )>>, loadingPoints?: Maybe<Array<(
      { __typename?: 'FoodBusinessOperator' }
      & Pick<FoodBusinessOperator, 'id' | 'name'>
    )>>, offloadingPoints?: Maybe<Array<(
      { __typename?: 'FoodBusinessOperator' }
      & Pick<FoodBusinessOperator, 'id' | 'name'>
    )>> }
  )> }
);

export type LoiReferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type LoiReferenceQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'loadOutInstructionReference'>
);

export type AirFreightShipmentLineItemsWithNoLoiQueryVariables = Exact<{ [key: string]: never; }>;


export type AirFreightShipmentLineItemsWithNoLoiQuery = (
  { __typename?: 'Query' }
  & { airFreightShipmentLineItemsWithNoLoi?: Maybe<Array<(
    { __typename?: 'AirFreightShipmentLineItem' }
    & Pick<AirFreightShipmentLineItem, 'id' | 'orderReference' | 'bookingReference' | 'finalDestinationLocation' | 'externalShipmentId' | 'eta' | 'finalDestinationCode' | 'goodsDescription'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, airFreightShipment?: Maybe<(
      { __typename?: 'AirFreightShipment' }
      & Pick<AirFreightShipment, 'masterWaybillNumber' | 'shipper' | 'estimatedDepartureTime' | 'controller' | 'portOfLoadingCode'>
    )> }
  )>> }
);

export type LoiExportersQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  orderbyloi?: Maybe<Scalars['Boolean']>;
  companyname?: Maybe<Scalars['String']>;
}>;


export type LoiExportersQuery = (
  { __typename?: 'Query' }
  & { exporters?: Maybe<Array<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>> }
);

export type LoiStuffLocationsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  orderbyloi?: Maybe<Scalars['Boolean']>;
  fboname?: Maybe<Scalars['String']>;
}>;


export type LoiStuffLocationsQuery = (
  { __typename?: 'Query' }
  & { stuffLocations?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type LoiTruckingLoadingPointsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  orderByLoi?: Maybe<Scalars['Boolean']>;
  fboName?: Maybe<Scalars['String']>;
}>;


export type LoiTruckingLoadingPointsQuery = (
  { __typename?: 'Query' }
  & { truckingLoadingPoints?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type LoiTruckingOffloadingPointsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  orderByLoi?: Maybe<Scalars['Boolean']>;
  fboName?: Maybe<Scalars['String']>;
}>;


export type LoiTruckingOffloadingPointsQuery = (
  { __typename?: 'Query' }
  & { truckingOffloadingPoints?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type LoiSeaPortsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  orderbyloi?: Maybe<Scalars['Boolean']>;
  seaportname?: Maybe<Scalars['String']>;
  isportofloading?: Maybe<Scalars['Boolean']>;
  stufflocationid?: Maybe<Scalars['Int']>;
}>;


export type LoiSeaPortsQuery = (
  { __typename?: 'Query' }
  & { seaPorts?: Maybe<Array<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'country' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type LoiVesselsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  vesselname?: Maybe<Scalars['String']>;
  seaportid?: Maybe<Scalars['Int']>;
}>;


export type LoiVesselsQuery = (
  { __typename?: 'Query' }
  & { vessels?: Maybe<Array<(
    { __typename?: 'Vessel' }
    & Pick<Vessel, 'id' | 'vesselName'>
  )>> }
);

export type LoiVoyagesQueryVariables = Exact<{
  vesselid: Scalars['Int'];
  seaportid?: Maybe<Scalars['Int']>;
}>;


export type LoiVoyagesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'voyages'>
);

export type LoiContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoiContactsQuery = (
  { __typename?: 'Query' }
  & { contacts?: Maybe<Array<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'id' | 'name' | 'info' | 'contactType' | 'createdByUserId'>
  )>> }
);

export type LoiUnassignedCgFilterAttributesQueryVariables = Exact<{
  attributes: CartonGroupingSearchAttributes;
}>;


export type LoiUnassignedCgFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { cartonGroupingsSearch?: Maybe<(
    { __typename?: 'CartonGroupingSearch' }
    & { filterValues?: Maybe<(
      { __typename?: 'CartonGroupingFilters' }
      & Pick<CartonGroupingFilters, 'batchNumber' | 'consignmentNumber' | 'packingWeek' | 'targetMarket'>
      & { variety?: Maybe<Array<(
        { __typename?: 'Variety' }
        & Pick<Variety, 'id' | 'name'>
      )>>, seller?: Maybe<Array<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>> }
    )> }
  )> }
);

export type LoiUnassignedCartonGroupingsQueryVariables = Exact<{
  attributes: CartonGroupingSearchAttributes;
  loadingPointId?: Maybe<Scalars['Int']>;
  portOfLoadingId?: Maybe<Scalars['Int']>;
  transportType?: Maybe<Scalars['String']>;
  hideReassignable?: Maybe<Scalars['Boolean']>;
}>;


export type LoiUnassignedCartonGroupingsQuery = (
  { __typename?: 'Query' }
  & { loadOutInstructionCgs: Array<(
    { __typename?: 'LoiCartonGrouping' }
    & Pick<LoiCartonGrouping, 'id' | 'batchNumber' | 'buyerName' | 'cartons' | 'consignmentNumber' | 'commodityName' | 'exporterCode' | 'farmCode' | 'inventoryCode' | 'mark' | 'orchard' | 'grade' | 'pack' | 'packingWeek' | 'palletNumber' | 'sellerName' | 'sequenceNumber' | 'sizeCount' | 'state' | 'subCommodityName' | 'targetMarket' | 'targetRegion' | 'varietyName' | 'palletAge' | 'existingLoadOut' | 'isReassignable' | 'netMass' | 'palletGrossMass'>
  )> }
);

export type LoiUnassignedCGsQueryVariables = Exact<{
  attributes: CartonGroupingSearchAttributes;
}>;


export type LoiUnassignedCGsQuery = (
  { __typename?: 'Query' }
  & { cartonGroupingsSearch?: Maybe<(
    { __typename?: 'CartonGroupingSearch' }
    & Pick<CartonGroupingSearch, 'totalCount' | 'totalCountPallets'>
    & { cartonGroupings: Array<(
      { __typename?: 'CartonGrouping' }
      & Pick<CartonGrouping, 'batchNumber' | 'cartons' | 'consignmentNumber' | 'exporterCode' | 'farmCode' | 'grade' | 'id' | 'inventoryCode' | 'mark' | 'netMass' | 'orchard' | 'pack' | 'packhouseCode' | 'packingWeek' | 'palletGrossMass' | 'palletNumber' | 'sequenceNumber' | 'sizeCount' | 'state' | 'targetCountry' | 'targetMarket' | 'targetRegion' | 'palletAge'>
      & { buyer?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name'>
      )>, seller?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name'>
      )>, variety?: Maybe<(
        { __typename?: 'Variety' }
        & Pick<Variety, 'name'>
        & { commodity?: Maybe<(
          { __typename?: 'Commodity' }
          & Pick<Commodity, 'name'>
        )>, subCommodity?: Maybe<(
          { __typename?: 'SubCommodity' }
          & Pick<SubCommodity, 'name'>
        )> }
      )>, loadOutInstructions?: Maybe<Array<(
        { __typename?: 'LoadOutInstruction' }
        & Pick<LoadOutInstruction, 'loadOutReference' | 'transportType'>
        & { loadingPoint?: Maybe<(
          { __typename?: 'FoodBusinessOperator' }
          & Pick<FoodBusinessOperator, 'id' | 'name' | 'createdAt' | 'updatedAt'>
        )>, portOfLoading?: Maybe<(
          { __typename?: 'SeaPort' }
          & LoiPortFieldsFragment
        )> }
      )>> }
    )>, filterValues?: Maybe<(
      { __typename?: 'CartonGroupingFilters' }
      & Pick<CartonGroupingFilters, 'batchNumber' | 'consignmentNumber' | 'packingWeek' | 'targetMarket'>
      & { variety?: Maybe<Array<(
        { __typename?: 'Variety' }
        & Pick<Variety, 'id' | 'name'>
      )>>, seller?: Maybe<Array<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>> }
    )> }
  )> }
);

export type LoiQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoiQuery = (
  { __typename?: 'Query' }
  & { loadOutInstruction?: Maybe<(
    { __typename?: 'LoadOutInstruction' }
    & { airFreightShipmentLineItem?: Maybe<(
      { __typename?: 'AirFreightShipmentLineItem' }
      & Pick<AirFreightShipmentLineItem, 'id' | 'orderReference' | 'bookingReference' | 'externalShipmentId' | 'updatedAt' | 'createdAt'>
    )>, shipmentLineItem?: Maybe<(
      { __typename?: 'ShipmentLineItem' }
      & Pick<ShipmentLineItem, 'id' | 'updatedAt' | 'createdAt'>
    )>, cartonGroupings?: Maybe<Array<(
      { __typename?: 'CartonGrouping' }
      & CgCommonFieldsFragment
    )>>, loiCartonGroupings?: Maybe<Array<(
      { __typename?: 'LoiCartonGrouping' }
      & Pick<LoiCartonGrouping, 'id' | 'batchNumber' | 'buyerName' | 'cartons' | 'consignmentNumber' | 'commodityName' | 'exporterCode' | 'farmCode' | 'inventoryCode' | 'mark' | 'orchard' | 'grade' | 'pack' | 'packingWeek' | 'palletNumber' | 'sellerName' | 'sequenceNumber' | 'sizeCount' | 'state' | 'subCommodityName' | 'targetMarket' | 'targetRegion' | 'varietyName' | 'palletAge' | 'existingLoadOut' | 'isReassignable' | 'netMass' | 'palletGrossMass'>
    )>> }
    & LoiCommonFieldsFragment
  )> }
);

export type CreateLoiMutationVariables = Exact<{
  attributes: LoadOutAttributes;
}>;


export type CreateLoiMutation = (
  { __typename?: 'Mutation' }
  & { createLoadOutInstruction?: Maybe<(
    { __typename?: 'CreateLoadOutInstructionPayload' }
    & { errors?: Maybe<Array<(
      { __typename?: 'LoadOutInstructionError' }
      & LoiErrorFieldsFragment
    )>>, loadOutInstruction?: Maybe<(
      { __typename?: 'LoadOutInstruction' }
      & { cartonGroupings?: Maybe<Array<(
        { __typename?: 'CartonGrouping' }
        & Pick<CartonGrouping, 'id'>
      )>> }
      & LoiCommonFieldsFragment
    )> }
  )> }
);

export type UpdateLoiMutationVariables = Exact<{
  attributes: LoadOutAttributes;
}>;


export type UpdateLoiMutation = (
  { __typename?: 'Mutation' }
  & { updateLoadOutInstruction?: Maybe<(
    { __typename?: 'UpdateLoadOutInstructionPayload' }
    & { errors?: Maybe<Array<(
      { __typename?: 'LoadOutInstructionError' }
      & LoiErrorFieldsFragment
    )>>, loadOutInstruction?: Maybe<(
      { __typename?: 'LoadOutInstruction' }
      & { cartonGroupings?: Maybe<Array<(
        { __typename?: 'CartonGrouping' }
        & Pick<CartonGrouping, 'id'>
      )>> }
      & LoiCommonFieldsFragment
    )> }
  )> }
);

export type DeleteLoiMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLoiMutation = (
  { __typename?: 'Mutation' }
  & { deleteLoadOutInstruction?: Maybe<(
    { __typename?: 'DeleteLoadOutInstructionPayload' }
    & Pick<DeleteLoadOutInstructionPayload, 'success'>
  )> }
);

export type GenerateLoadOutInstructionOutputFilesMutationVariables = Exact<{
  loadoutinstructionid: Scalars['ID'];
}>;


export type GenerateLoadOutInstructionOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generateLoadOutInstructionOutputFiles?: Maybe<(
    { __typename?: 'GenerateLoadOutInstructionOutputFilesPayload' }
    & { templateOutput?: Maybe<Array<(
      { __typename?: 'TemplateOutput' }
      & Pick<TemplateOutput, 'errorReason' | 'id' | 'state'>
    )>> }
  )> }
);

export type GeneratePalletInOutputFilesMutationVariables = Exact<{
  loadOutInstructionId: Scalars['ID'];
}>;


export type GeneratePalletInOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generatePalletInOutputFiles?: Maybe<(
    { __typename?: 'GeneratePalletInOutputFilesPayload' }
    & Pick<GeneratePalletInOutputFilesPayload, 'palletInId'>
  )> }
);

export type OnPalletInOutputStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPalletInOutputStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onPalletInOutputStateChange: (
    { __typename?: 'PalletIn' }
    & PalletInFieldsFragment
  ) }
);

export type EvaluateShipmentImpactQueryVariables = Exact<{
  sliId: Scalars['ID'];
  loiAttributes: LoadOutAttributes;
}>;


export type EvaluateShipmentImpactQuery = (
  { __typename?: 'Query' }
  & { evaluateShipmentImpact: (
    { __typename?: 'ShipmentImpact' }
    & Pick<ShipmentImpact, 'willAffectShipment' | 'willCreateNewShipment' | 'shipmentId' | 'portOfLoading' | 'vesselName' | 'voyage' | 'shippingLine' | 'client'>
  ) }
);

export type MoveSlisToNewShipmentMutationVariables = Exact<{
  sliIds: Array<Scalars['ID']> | Scalars['ID'];
  shipmentId?: Maybe<Scalars['ID']>;
}>;


export type MoveSlisToNewShipmentMutation = (
  { __typename?: 'Mutation' }
  & { moveSlisToNewShipment?: Maybe<(
    { __typename?: 'MoveSlisToNewShipmentPayload' }
    & { shipment?: Maybe<(
      { __typename?: 'Shipment' }
      & Pick<Shipment, 'id'>
    )>, shipmentLineItems?: Maybe<Array<(
      { __typename?: 'ShipmentLineItem' }
      & Pick<ShipmentLineItem, 'id' | 'shipmentId'>
    )>> }
  )> }
);

export type PalletInFieldsFragment = (
  { __typename?: 'PalletIn' }
  & Pick<PalletIn, 'id' | 'loadOutInstructionId' | 'state' | 'updatedAt'>
  & { outputFile?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'contentType' | 'filename' | 'v2Url' | 'id' | 'url'>
  )> }
);

export type LoiErrorFieldsFragment = (
  { __typename?: 'LoadOutInstructionError' }
  & Pick<LoadOutInstructionError, 'attribute' | 'type' | 'cartonGroupingIds' | 'orchards'>
  & { orchardResults?: Maybe<Array<(
    { __typename?: 'OrchardResult' }
    & Pick<OrchardResult, 'id' | 'farmCode' | 'orchardName' | 'currentEuStatus' | 'eu' | 'bd' | 'cbs' | 'fms' | 'applied' | 'verified' | 'phytoData'>
  )>> }
);

export type LoiCommonFieldsFragment = (
  { __typename?: 'LoadOutInstruction' }
  & Pick<LoadOutInstruction, 'bookingReference' | 'transportType' | 'containerNumber' | 'estimatedTimeOfDelivery' | 'exportersReference' | 'id' | 'loadOutReference' | 'notes' | 'portOfDestinationName' | 'portOfLoadingName' | 'printedDate' | 'q67Reference' | 'shippingLine' | 'stuffDate' | 'temperatureSetting' | 'voyage' | 'truckReference' | 'fileNumber' | 'airWaybillNo' | 'shipper' | 'destination' | 'allocatedWeight' | 'routing' | 'flightDate' | 'connectingFlightDate' | 'equipment' | 'phytoCertificate' | 'orderPreparedBy' | 'orderPickedBy' | 'checked' | 'stockTransfer' | 'consignmentReference' | 'transporterCompany' | 'estimatedDispatchDate' | 'loadDate' | 'orderReference'>
  & { contacts?: Maybe<Array<(
    { __typename?: 'Contact' }
    & Pick<Contact, 'id' | 'name' | 'info' | 'contactType' | 'createdByUserId'>
  )>>, exporter?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, portOfDestination?: Maybe<(
    { __typename?: 'SeaPort' }
    & LoiPortFieldsFragment
  )>, portOfLoading?: Maybe<(
    { __typename?: 'SeaPort' }
    & LoiPortFieldsFragment
  )>, stuffLocation?: Maybe<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'createdAt' | 'updatedAt'>
  )>, vessel?: Maybe<(
    { __typename?: 'Vessel' }
    & Pick<Vessel, 'id' | 'vesselName'>
  )>, templateOutput?: Maybe<(
    { __typename?: 'TemplateOutput' }
    & TemplateOutputFieldsFragment
  )>, palletIn?: Maybe<(
    { __typename?: 'PalletIn' }
    & PalletInFieldsFragment
  )>, loadingPoint?: Maybe<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'createdAt' | 'updatedAt'>
  )>, offloadingPoint?: Maybe<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'createdAt' | 'updatedAt'>
  )> }
);

export type CgCommonFieldsFragment = (
  { __typename?: 'CartonGrouping' }
  & Pick<CartonGrouping, 'batchNumber' | 'cartons' | 'consignmentNumber' | 'exporterCode' | 'farmCode' | 'grade' | 'id' | 'inventoryCode' | 'mark' | 'netMass' | 'orchard' | 'pack' | 'packhouseCode' | 'packingWeek' | 'palletGrossMass' | 'palletNumber' | 'sequenceNumber' | 'sizeCount' | 'state' | 'targetCountry' | 'targetMarket' | 'targetRegion' | 'palletAge'>
  & { buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'name'>
  )>, seller?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'name'>
  )>, variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'name'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'name'>
    )>, subCommodity?: Maybe<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'name'>
    )> }
  )> }
);

export type LoiPortFieldsFragment = (
  { __typename?: 'SeaPort' }
  & Pick<SeaPort, 'id' | 'name' | 'country' | 'createdAt' | 'updatedAt'>
);

export type VesselMapFragment = (
  { __typename?: 'Vessel' }
  & Pick<Vessel, 'vesselName' | 'voyageNumber' | 'lat' | 'long'>
);

export type SeaPortMapFragment = (
  { __typename?: 'SeaPort' }
  & Pick<SeaPort, 'id' | 'name' | 'country' | 'unLocode' | 'latitude' | 'longitude' | 'createdAt' | 'updatedAt'>
);

export type FboMapFragment = (
  { __typename?: 'FoodBusinessOperator' }
  & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'typeOfBusiness' | 'latitude' | 'longitude' | 'createdAt' | 'updatedAt'>
);

export type CurrentMapPointsForOrderQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CurrentMapPointsForOrderQuery = (
  { __typename?: 'Query' }
  & { currentMapPointsForOrder?: Maybe<Array<(
    { __typename?: 'MapPoint' }
    & Pick<MapPoint, 'totalCartons'>
    & { containers?: Maybe<Array<(
      { __typename?: 'MapPointContainer' }
      & Pick<MapPointContainer, 'id' | 'containerNumber' | 'orderId' | 'otherPartyName' | 'vesselName' | 'portOfDestination' | 'eta'>
    )>>, orders?: Maybe<Array<(
      { __typename?: 'MapPointOrder' }
      & Pick<MapPointOrder, 'orderId' | 'otherPartyName' | 'totalCartons'>
    )>>, location?: Maybe<(
      { __typename: 'FoodBusinessOperator' }
      & FboMapFragment
    ) | (
      { __typename: 'SeaPort' }
      & SeaPortMapFragment
    ) | (
      { __typename: 'Vessel' }
      & VesselMapFragment
    )> }
  )>> }
);

export type CartonConversionsQueryVariables = Exact<{
  filterAttributes?: Maybe<CartonConversionFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type CartonConversionsQuery = (
  { __typename?: 'Query' }
  & { cartonConversions: Array<(
    { __typename?: 'CartonConversion' }
    & Pick<CartonConversion, 'id' | 'commodityName' | 'conversionFactor' | 'actualMass' | 'massConversion' | 'pack' | 'sizeCount' | 'convertedSizeCount' | 'conversionType'>
  )> }
);

export type CreateCartonConversionsMutationVariables = Exact<{
  actualMass?: Maybe<Scalars['Float']>;
  commodityId?: Maybe<Scalars['ID']>;
  conversionFactor?: Maybe<Scalars['Float']>;
  conversionType?: Maybe<Scalars['String']>;
  convertedSizeCount?: Maybe<Scalars['String']>;
  massConversion?: Maybe<Scalars['Float']>;
  pack?: Maybe<Scalars['String']>;
  sizeCount?: Maybe<Scalars['String']>;
}>;


export type CreateCartonConversionsMutation = (
  { __typename?: 'Mutation' }
  & { createCartonConversion?: Maybe<(
    { __typename?: 'CreateCartonConversionPayload' }
    & { cartonConversion?: Maybe<(
      { __typename?: 'CartonConversion' }
      & Pick<CartonConversion, 'id' | 'commodityName' | 'conversionFactor' | 'actualMass' | 'massConversion' | 'pack' | 'sizeCount' | 'convertedSizeCount' | 'conversionType'>
    )> }
  )> }
);

export type UpdateCartonConversionsMutationVariables = Exact<{
  id: Scalars['ID'];
  actualMass?: Maybe<Scalars['Float']>;
  conversionFactor?: Maybe<Scalars['Float']>;
  convertedSizeCount?: Maybe<Scalars['String']>;
  massConversion?: Maybe<Scalars['Float']>;
}>;


export type UpdateCartonConversionsMutation = (
  { __typename?: 'Mutation' }
  & { updateCartonConversion?: Maybe<(
    { __typename?: 'UpdateCartonConversionPayload' }
    & { cartonConversion?: Maybe<(
      { __typename?: 'CartonConversion' }
      & Pick<CartonConversion, 'id' | 'commodityName' | 'conversionFactor' | 'actualMass' | 'massConversion' | 'pack' | 'sizeCount' | 'convertedSizeCount' | 'conversionType'>
    )> }
  )> }
);

export type DeleteCartonConversionsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCartonConversionsMutation = (
  { __typename?: 'Mutation' }
  & { deleteCartonConversion?: Maybe<(
    { __typename?: 'DeleteCartonConversionPayload' }
    & { cartonConversion?: Maybe<(
      { __typename?: 'CartonConversion' }
      & Pick<CartonConversion, 'id' | 'commodityName' | 'conversionFactor' | 'actualMass' | 'massConversion' | 'pack' | 'sizeCount' | 'convertedSizeCount' | 'conversionType'>
    )> }
  )> }
);

export type CartonConversionFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CartonConversionFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { cartonConversionFilterAttributes?: Maybe<Array<(
    { __typename?: 'CartonConversionFilterAttribute' }
    & Pick<CartonConversionFilterAttribute, 'conversionType' | 'commodityName'>
  )>> }
);

export type CgErrorsQueryVariables = Exact<{
  filterAttributes?: Maybe<CgErrorFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type CgErrorsQuery = (
  { __typename?: 'Query' }
  & { cgErrors: Array<(
    { __typename?: 'CgError' }
    & Pick<CgError, 'id' | 'errorContext' | 'errorMessage' | 'errorType' | 'errorSubtype' | 'state'>
  )> }
);

export type ResolveCgErrorMutationVariables = Exact<{
  id: Scalars['ID'];
  resolution: CgErrorResolutionInput;
  userContext?: Maybe<Scalars['String']>;
}>;


export type ResolveCgErrorMutation = (
  { __typename?: 'Mutation' }
  & { resolveCgError?: Maybe<(
    { __typename?: 'ResolveCgErrorPayload' }
    & { cgError: (
      { __typename?: 'CgError' }
      & Pick<CgError, 'state'>
    ) }
  )> }
);

export type CgErrorFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CgErrorFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { cgErrorFilterAttributes?: Maybe<Array<(
    { __typename?: 'CgErrorFilterAttribute' }
    & Pick<CgErrorFilterAttribute, 'errorType' | 'state'>
  )>> }
);

export type CreateIgnoreErrorRequestMutationVariables = Exact<{
  action: Scalars['String'];
  errorToIgnore: Scalars['String'];
}>;


export type CreateIgnoreErrorRequestMutation = (
  { __typename?: 'Mutation' }
  & { createIgnoreErrorRequest?: Maybe<(
    { __typename?: 'CreateIgnoreErrorRequestPayload' }
    & { clientChangeRequest?: Maybe<(
      { __typename?: 'ClientChangeRequest' }
      & Pick<ClientChangeRequest, 'id'>
    )> }
  )> }
);

export type CreateClientChangeRequestMutationVariables = Exact<{
  action: Scalars['String'];
  userContext?: Maybe<Scalars['String']>;
  modelId: Scalars['ID'];
}>;


export type CreateClientChangeRequestMutation = (
  { __typename?: 'Mutation' }
  & { createClientChangeRequest?: Maybe<(
    { __typename?: 'CreateClientChangeRequestPayload' }
    & { clientChangeRequest?: Maybe<(
      { __typename?: 'ClientChangeRequest' }
      & Pick<ClientChangeRequest, 'id'>
    )> }
  )> }
);

export type MasterfileFarmVarietiesQueryVariables = Exact<{
  filterAttributes?: Maybe<FarmVarietyFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type MasterfileFarmVarietiesQuery = (
  { __typename?: 'Query' }
  & { masterfileFarmVarieties?: Maybe<Array<(
    { __typename?: 'FarmVariety' }
    & Pick<FarmVariety, 'id' | 'varietyCode' | 'commodityName' | 'hectares' | 'peakCount' | 'packingStart' | 'packingEnd' | 'status'>
    & { name: FarmVariety['varietyName'] }
  ) | (
    { __typename?: 'FarmVarietyRequest' }
    & Pick<FarmVarietyRequest, 'modelId' | 'name' | 'commodityName' | 'varietyCode' | 'status'>
  )>> }
);

export type ListVarietiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListVarietiesQuery = (
  { __typename?: 'Query' }
  & { listVarieties?: Maybe<Array<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'varietyName' | 'varietyCode'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>, subCommodity?: Maybe<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'id' | 'name'>
    )> }
  )>> }
);

export type FarmVarietyFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmVarietyFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { farmVarietyFilterAttributes?: Maybe<(
    { __typename?: 'FarmVarietyFilterAttribute' }
    & Pick<FarmVarietyFilterAttribute, 'status' | 'commodityName'>
  )> }
);

export type CreateFarmVarietyClienChangeRequestMutationVariables = Exact<{
  modelId: Scalars['Int'];
  name: Scalars['String'];
  varietyId: Scalars['Int'];
  varietyCode: Scalars['String'];
  commodityName: Scalars['String'];
  commodityId: Scalars['Int'];
  action: Scalars['String'];
}>;


export type CreateFarmVarietyClienChangeRequestMutation = (
  { __typename?: 'Mutation' }
  & { createFarmVarietyClientChangeRequest?: Maybe<(
    { __typename?: 'CreateFarmVarietyRequestPayload' }
    & { clientChangeRequest?: Maybe<(
      { __typename?: 'FarmVarietyRequest' }
      & Pick<FarmVarietyRequest, 'id' | 'status' | 'name' | 'varietyCode' | 'commodityName'>
    )> }
  )> }
);

export type FarmVarietiesQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmVarietiesQuery = (
  { __typename?: 'Query' }
  & { farmVarieties: Array<(
    { __typename?: 'FarmVariety' }
    & Pick<FarmVariety, 'id' | 'varietyCode' | 'commodityName' | 'hectares' | 'peakCount' | 'packingStart' | 'packingEnd' | 'updatedAt'>
    & { name: FarmVariety['varietyName'] }
  )> }
);

export type FarmVarietyClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmVarietyClientChangeRequestsQuery = (
  { __typename?: 'Query' }
  & { farmVarietyClientChangeRequests: Array<(
    { __typename?: 'FarmVarietyRequest' }
    & Pick<FarmVarietyRequest, 'name' | 'status' | 'varietyCode' | 'commodityName'>
  )> }
);

export type MasterfileFoodBusinessOperatorsQueryVariables = Exact<{
  filterAttributes?: Maybe<FoodBusinessOperatorFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type MasterfileFoodBusinessOperatorsQuery = (
  { __typename?: 'Query' }
  & { masterfileFoodBusinessOperators?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'typeOfBusiness' | 'producerName' | 'latitude' | 'longitude' | 'globalGapNumber' | 'productionRegion' | 'updatedAt' | 'status'>
  ) | (
    { __typename?: 'FoodBusinessOperatorRequest' }
    & Pick<FoodBusinessOperatorRequest, 'fboCode' | 'name' | 'globalGapNumber' | 'latitude' | 'longitude' | 'modelId' | 'status' | 'producerName' | 'productionRegion' | 'typeOfBusiness'>
  )>> }
);

export type FoodBusinessOperatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type FoodBusinessOperatorsQuery = (
  { __typename?: 'Query' }
  & { foodBusinessOperators?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'typeOfBusiness' | 'producerName' | 'latitude' | 'longitude' | 'globalGapNumber' | 'productionRegion' | 'updatedAt'>
  )>> }
);

export type FoodBusinessOperatorClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type FoodBusinessOperatorClientChangeRequestsQuery = (
  { __typename?: 'Query' }
  & { foodBusinessOperatorClientChangeRequests?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperatorRequest' }
    & Pick<FoodBusinessOperatorRequest, 'fboCode' | 'name' | 'globalGapNumber' | 'latitude' | 'longitude' | 'modelId' | 'status' | 'producerName' | 'productionRegion' | 'typeOfBusiness'>
  )>> }
);

export type CreateFoodBusinessOperatorClientChangeRequestMutationVariables = Exact<{
  modelId: Scalars['Int'];
  name: Scalars['String'];
  action: Scalars['String'];
  fboCode: Scalars['String'];
  globalGapNumber: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  producerName: Scalars['String'];
  productionRegion: Scalars['String'];
  typeOfBusiness: Scalars['String'];
}>;


export type CreateFoodBusinessOperatorClientChangeRequestMutation = (
  { __typename?: 'Mutation' }
  & { createFoodBusinessOperatorClientChangeRequest?: Maybe<(
    { __typename?: 'CreateFoodBusinessOperatorRequestPayload' }
    & { clientChangeRequest?: Maybe<(
      { __typename?: 'FoodBusinessOperatorRequest' }
      & Pick<FoodBusinessOperatorRequest, 'id' | 'fboCode' | 'name' | 'globalGapNumber' | 'latitude' | 'longitude' | 'modelId' | 'producerName' | 'productionRegion' | 'status' | 'typeOfBusiness'>
    )> }
  )> }
);

export type FoodBusinessOperatorFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FoodBusinessOperatorFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { foodBusinessOperatorFilterAttributes?: Maybe<(
    { __typename?: 'FoodBusinessOperatorFilterAttribute' }
    & Pick<FoodBusinessOperatorFilterAttribute, 'status' | 'typeOfBusiness'>
  )> }
);

export type ProductionRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductionRegionsQuery = (
  { __typename?: 'Query' }
  & { productionRegions?: Maybe<Array<(
    { __typename?: 'ProductionRegion' }
    & Pick<ProductionRegion, 'id' | 'name' | 'countryCode'>
  )>> }
);

export type ListFoodBusinessOperatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFoodBusinessOperatorsQuery = (
  { __typename?: 'Query' }
  & { listFoodBusinessOperators?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'fboCode'>
  )>> }
);

export type FoodBusinessOperatorsByTypeQueryVariables = Exact<{
  typeOfBusiness: Scalars['Int'];
}>;


export type FoodBusinessOperatorsByTypeQuery = (
  { __typename?: 'Query' }
  & { foodBusinessOperatorsByType?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'producerName' | 'fboCode' | 'productionRegion' | 'createdAt' | 'updatedAt'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id'>
    )>, locationMappings?: Maybe<Array<(
      { __typename?: 'LocationMapping' }
      & Pick<LocationMapping, 'locationCode'>
    )>> }
  )>> }
);

export type FarmVarietyFieldsFragment = (
  { __typename?: 'FarmVariety' }
  & Pick<FarmVariety, 'id' | 'name' | 'varietyCode' | 'hectares' | 'commodityName' | 'packingStart' | 'packingEnd' | 'peakCount'>
  & { variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'varietyName'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )> }
  )>, commodity?: Maybe<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name'>
  )> }
);

export type AddressFieldsFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'addressLine1' | 'addressLine2' | 'city' | 'postalCode' | 'country' | 'placeId'>
);

export type FoodBusinessOperatorFieldsFragment = (
  { __typename?: 'FoodBusinessOperator' }
  & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'producerName' | 'typeOfBusiness' | 'productionRegion' | 'globalGapNumber' | 'latitude' | 'longitude' | 'status'>
  & { address?: Maybe<(
    { __typename?: 'Address' }
    & AddressFieldsFragment
  )>, company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, packhouseConnections?: Maybe<Array<(
    { __typename?: 'PackhouseConnection' }
    & Pick<PackhouseConnection, 'id' | 'name' | 'state' | 'scheduledFor' | 'scheduledAt' | 'createdAt' | 'updatedAt' | 'apiUserId' | 'connected' | 'lastProcessedDatetime' | 'onPremSystem'>
  )>> }
);

export type SoftwareUpdateReportFieldsFragment = (
  { __typename?: 'SoftwareUpdateReportRequest' }
  & Pick<SoftwareUpdateReportRequest, 'id' | 'softwareUpdateReport'>
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )> }
);

export type PackhouseConnectionFieldsFragment = (
  { __typename?: 'PackhouseConnection' }
  & Pick<PackhouseConnection, 'id' | 'name' | 'state' | 'scheduledFor' | 'scheduledAt' | 'createdAt' | 'updatedAt' | 'apiUserId' | 'connected' | 'lastProcessedDatetime' | 'onPremSystem'>
);

export type CompanyAssociationFieldsFragment = (
  { __typename?: 'CompanyAssociation' }
  & Pick<CompanyAssociation, 'id' | 'name'>
);

export type MasterfileConfigFieldsFragment = (
  { __typename?: 'MasterfileConfig' }
  & Pick<MasterfileConfig, 'id' | 'state' | 'masterfileEntityType' | 'masterfileEntityId' | 'companyId'>
);

export type MasterfileConfigsQueryVariables = Exact<{
  filterAttributes?: Maybe<MasterfileConfigFilterAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type MasterfileConfigsQuery = (
  { __typename?: 'Query' }
  & { masterfileConfigs?: Maybe<Array<(
    { __typename?: 'MasterfileConfig' }
    & { masterfileEntity?: Maybe<(
      { __typename?: 'CompanyAssociation' }
      & CompanyAssociationFieldsFragment
    ) | (
      { __typename?: 'FarmVariety' }
      & FarmVarietyFieldsFragment
    ) | (
      { __typename?: 'FoodBusinessOperator' }
      & FoodBusinessOperatorFieldsFragment
    ) | { __typename?: 'PackhouseConnection' }> }
    & MasterfileConfigFieldsFragment
  )>> }
);

export type InternalPackhouseClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalPackhouseClientChangeRequestsQuery = (
  { __typename?: 'Query' }
  & { internalPackhouseClientChangeRequests?: Maybe<Array<(
    { __typename?: 'InternalPackhouseClientChangeRequest' }
    & Pick<InternalPackhouseClientChangeRequest, 'id' | 'status'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, packhouse?: Maybe<(
      { __typename?: 'FoodBusinessOperator' }
      & FoodBusinessOperatorFieldsFragment
    )> }
  )>> }
);

export type CreateSoftwareUpdateReportMutationVariables = Exact<{
  softwareUpdateReport: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateSoftwareUpdateReportMutation = (
  { __typename?: 'Mutation' }
  & { createSoftwareUpdateReport?: Maybe<(
    { __typename?: 'CreateSoftwareUpdateReportPayload' }
    & Pick<CreateSoftwareUpdateReportPayload, 'errors'>
    & { clientChangeRequest?: Maybe<(
      { __typename?: 'SoftwareUpdateReportRequest' }
      & SoftwareUpdateReportFieldsFragment
    )> }
  )> }
);

export type PackhouseSoftwareUpdateReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackhouseSoftwareUpdateReportsQuery = (
  { __typename?: 'Query' }
  & { packhouseSoftwareUpdateReports?: Maybe<Array<(
    { __typename?: 'SoftwareUpdateReportRequest' }
    & SoftwareUpdateReportFieldsFragment
  )>> }
);

export type ConfirmMasterfileConfigFboMutationVariables = Exact<{
  masterfileConfigs: Array<MasterfileConfigFboInput> | MasterfileConfigFboInput;
}>;


export type ConfirmMasterfileConfigFboMutation = (
  { __typename?: 'Mutation' }
  & { confirmMasterfileConfigFbo?: Maybe<(
    { __typename?: 'ConfirmMasterfileConfigFboPayload' }
    & Pick<ConfirmMasterfileConfigFboPayload, 'errors'>
    & { masterfileConfigs?: Maybe<Array<(
      { __typename?: 'MasterfileConfig' }
      & { masterfileEntity?: Maybe<{ __typename?: 'CompanyAssociation' } | { __typename?: 'FarmVariety' } | (
        { __typename?: 'FoodBusinessOperator' }
        & FoodBusinessOperatorFieldsFragment
      ) | { __typename?: 'PackhouseConnection' }> }
      & MasterfileConfigFieldsFragment
    )>> }
  )> }
);

export type ConfirmMasterfileConfigPackhouseConnectionsMutationVariables = Exact<{
  masterfileConfigs: Array<MasterfileConfigPackhouseConnectionAttributes> | MasterfileConfigPackhouseConnectionAttributes;
}>;


export type ConfirmMasterfileConfigPackhouseConnectionsMutation = (
  { __typename?: 'Mutation' }
  & { confirmMasterfileConfigPackhouseConnections?: Maybe<(
    { __typename?: 'ConfirmMasterfileConfigPackhouseConnectionsPayload' }
    & Pick<ConfirmMasterfileConfigPackhouseConnectionsPayload, 'errors'>
    & { masterfileConfigs?: Maybe<Array<(
      { __typename?: 'MasterfileConfig' }
      & { masterfileEntity?: Maybe<{ __typename?: 'CompanyAssociation' } | { __typename?: 'FarmVariety' } | { __typename?: 'FoodBusinessOperator' } | (
        { __typename?: 'PackhouseConnection' }
        & PackhouseConnectionFieldsFragment
      )> }
      & MasterfileConfigFieldsFragment
    )>> }
  )> }
);

export type ConfirmMasterfileConfigFarmVarietiesMutationVariables = Exact<{
  masterfileConfigs: Array<MasterfileConfigFarmVarietyInput> | MasterfileConfigFarmVarietyInput;
}>;


export type ConfirmMasterfileConfigFarmVarietiesMutation = (
  { __typename?: 'Mutation' }
  & { confirmMasterfileConfigFarmVarieties?: Maybe<(
    { __typename?: 'ConfirmMasterfileConfigFarmVarietiesPayload' }
    & Pick<ConfirmMasterfileConfigFarmVarietiesPayload, 'errors'>
    & { masterfileConfigs?: Maybe<Array<(
      { __typename?: 'MasterfileConfig' }
      & { masterfileEntity?: Maybe<{ __typename?: 'CompanyAssociation' } | (
        { __typename?: 'FarmVariety' }
        & FarmVarietyFieldsFragment
      ) | { __typename?: 'FoodBusinessOperator' } | { __typename?: 'PackhouseConnection' }> }
      & MasterfileConfigFieldsFragment
    )>> }
  )> }
);

export type CreateFarmFboMutationVariables = Exact<{
  attributes: CreateFarmAttribute;
}>;


export type CreateFarmFboMutation = (
  { __typename?: 'Mutation' }
  & { createFarmFbo?: Maybe<(
    { __typename?: 'CreateFarmFboPayload' }
    & Pick<CreateFarmFboPayload, 'errors'>
    & { foodBusinessOperator?: Maybe<(
      { __typename?: 'FoodBusinessOperator' }
      & FoodBusinessOperatorFieldsFragment
    )>, masterfileConfig?: Maybe<(
      { __typename?: 'MasterfileConfig' }
      & MasterfileConfigFieldsFragment
    )> }
  )> }
);

export type AddInternalPackhouseMutationVariables = Exact<{
  attributes: AddInternalPackhouseAttributes;
}>;


export type AddInternalPackhouseMutation = (
  { __typename?: 'Mutation' }
  & { addInternalPackhouse?: Maybe<(
    { __typename?: 'AddInternalPackhousePayload' }
    & Pick<AddInternalPackhousePayload, 'errors'>
    & { clientChangeRequest?: Maybe<(
      { __typename?: 'InternalPackhouseClientChangeRequest' }
      & Pick<InternalPackhouseClientChangeRequest, 'id' | 'status'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, packhouse?: Maybe<(
        { __typename?: 'FoodBusinessOperator' }
        & FoodBusinessOperatorFieldsFragment
      )> }
    )> }
  )> }
);

export type MetabaseReportFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type MetabaseReportFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { metabaseReportFilterAttributes?: Maybe<(
    { __typename?: 'MetabaseReportsFilterAttribute' }
    & { badges?: Maybe<Array<(
      { __typename?: 'Badge' }
      & Pick<Badge, 'id' | 'text'>
    )>> }
  )> }
);

export type MetabaseReportsQueryVariables = Exact<{
  filters: MetabaseReportFilters;
  searchTerm: Scalars['String'];
  searchField: Scalars['String'];
}>;


export type MetabaseReportsQuery = (
  { __typename?: 'Query' }
  & { metabaseReports?: Maybe<Array<(
    { __typename?: 'MetabaseReport' }
    & MetabaseReportFieldsFragment
  )>> }
);

export type MetabaseReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MetabaseReportQuery = (
  { __typename?: 'Query' }
  & { metabaseReport?: Maybe<(
    { __typename?: 'MetabaseReport' }
    & MetabaseReportFieldsFragment
  )> }
);

export type MetabaseReportFieldsFragment = (
  { __typename?: 'MetabaseReport' }
  & Pick<MetabaseReport, 'chartSource' | 'description' | 'domain' | 'id' | 'name' | 'displayName' | 'scope' | 'url'>
  & { badges?: Maybe<Array<(
    { __typename?: 'Badge' }
    & Pick<Badge, 'color' | 'text'>
  )>>, powerbiEmbedAttributes?: Maybe<(
    { __typename?: 'EmbeddedChart' }
    & Pick<EmbeddedChart, 'embedToken' | 'embedUrl' | 'reportId'>
  )> }
);

export type NetReturnProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type NetReturnProgramsQuery = (
  { __typename?: 'Query' }
  & { netReturnPrograms?: Maybe<Array<(
    { __typename?: 'NetReturnProgram' }
    & Pick<NetReturnProgram, 'additionalFields' | 'buyerId' | 'batchNumber' | 'cartonTypeName' | 'cartonTypeId' | 'commodityId' | 'commodityName' | 'configuredCurrency' | 'configuredUnit' | 'createdAt' | 'currency' | 'id' | 'incoterm' | 'inventoryCode' | 'packingWeek' | 'priceMinorUnit' | 'priceTerm' | 'priceUnit' | 'programId' | 'programName' | 'programVisibility' | 'quantity' | 'quantityUnit' | 'referenceNumber' | 'sizeCounts' | 'stackSize' | 'sellerId' | 'targetMarket' | 'tradeCountryId' | 'tradeCountryName' | 'tradeRegionId' | 'tradeRegionName' | 'updatedAt' | 'varietyId' | 'varietyName'>
  )>> }
);

export type CreateNetReturnProgramMutationVariables = Exact<{
  attributes: NetReturnProgramAttributes;
}>;


export type CreateNetReturnProgramMutation = (
  { __typename?: 'Mutation' }
  & { createNetReturnProgram?: Maybe<(
    { __typename?: 'CreateNetReturnProgramPayload' }
    & Pick<CreateNetReturnProgramPayload, 'errors'>
    & { netReturnProgram?: Maybe<(
      { __typename?: 'NetReturnProgram' }
      & Pick<NetReturnProgram, 'id' | 'programName'>
    )> }
  )> }
);

export type UpdateNetReturnProgramMutationVariables = Exact<{
  attributes: NetReturnProgramAttributes;
}>;


export type UpdateNetReturnProgramMutation = (
  { __typename?: 'Mutation' }
  & { updateNetReturnProgram?: Maybe<(
    { __typename?: 'UpdateNetReturnProgramPayload' }
    & Pick<UpdateNetReturnProgramPayload, 'errors'>
    & { netReturnProgram?: Maybe<(
      { __typename?: 'NetReturnProgram' }
      & Pick<NetReturnProgram, 'id' | 'programName'>
    )> }
  )> }
);

export type DeleteNetReturnProgramMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNetReturnProgramMutation = (
  { __typename?: 'Mutation' }
  & { deleteNetReturnProgram?: Maybe<(
    { __typename?: 'DeleteNetReturnProgramPayload' }
    & Pick<DeleteNetReturnProgramPayload, 'errors'>
    & { netReturnProgram?: Maybe<(
      { __typename?: 'NetReturnProgram' }
      & Pick<NetReturnProgram, 'id' | 'programName'>
    )> }
  )> }
);

export type NotificationRuleFieldsFragment = (
  { __typename?: 'NotificationRule' }
  & Pick<NotificationRule, 'id' | 'name' | 'description' | 'notificationSlug' | 'severity' | 'defaultThresholds'>
  & { notificationRuleSubscription?: Maybe<(
    { __typename?: 'NotificationRuleSubscription' }
    & NotificationRuleSubscriptionFieldsFragment
  )> }
);

export type NotificationItemFieldsFragment = (
  { __typename?: 'NotificationItem' }
  & Pick<NotificationItem, 'id' | 'entityType' | 'entityId'>
);

export type ChannelNotificationFieldsFragment = (
  { __typename?: 'ChannelNotification' }
  & Pick<ChannelNotification, 'id' | 'channelMetadata' | 'sentAt' | 'readAt' | 'archivedAt' | 'deliveredAt' | 'title' | 'body'>
  & { notificationRule?: Maybe<(
    { __typename?: 'NotificationRule' }
    & NotificationRuleFieldsFragment
  )>, notificationItems?: Maybe<Array<(
    { __typename?: 'NotificationItem' }
    & NotificationItemFieldsFragment
  )>> }
);

export type NotificationRuleSubscriptionFieldsFragment = (
  { __typename?: 'NotificationRuleSubscription' }
  & Pick<NotificationRuleSubscription, 'id' | 'enabled' | 'notifyEmail' | 'notifyWeb' | 'notifyMobile' | 'notifyWhatsapp' | 'config'>
);

export type OnNotificationEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNotificationEventSubscription = (
  { __typename?: 'Subscription' }
  & { newInAppNotification: (
    { __typename?: 'InAppNotification' }
    & Pick<InAppNotification, 'id'>
  ) }
);

export type GetChannelNotificationsQueryVariables = Exact<{
  filterAttributes: ChannelNotificationFilterAttributes;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type GetChannelNotificationsQuery = (
  { __typename?: 'Query' }
  & { channelNotifications?: Maybe<(
    { __typename?: 'ChannelNotificationConnection' }
    & Pick<ChannelNotificationConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'ChannelNotification' }
      & ChannelNotificationFieldsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type GetUnreadChannelNotificationsCountQueryVariables = Exact<{
  severity?: Maybe<NotificationRuleSeverityEnum>;
}>;


export type GetUnreadChannelNotificationsCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'unreadChannelNotificationsCount'>
);

export type GetTotalChannelNotificationsCountQueryVariables = Exact<{
  severity?: Maybe<NotificationRuleSeverityEnum>;
}>;


export type GetTotalChannelNotificationsCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'channelNotificationsCount'>
);

export type GetChannelNotificationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetChannelNotificationQuery = (
  { __typename?: 'Query' }
  & { channelNotificationById?: Maybe<(
    { __typename?: 'ChannelNotification' }
    & ChannelNotificationFieldsFragment
  )> }
);

export type NotificationRulesQueryVariables = Exact<{
  notificationSlugs: Array<NotificationSlugEnum> | NotificationSlugEnum;
}>;


export type NotificationRulesQuery = (
  { __typename?: 'Query' }
  & { notificationRules?: Maybe<Array<(
    { __typename?: 'NotificationRule' }
    & NotificationRuleFieldsFragment
  )>> }
);

export type MarkNotificationsAsReadMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkNotificationsAsReadMutation = (
  { __typename?: 'Mutation' }
  & { markNotificationsAsRead?: Maybe<(
    { __typename?: 'MarkNotificationsAsReadPayload' }
    & Pick<MarkNotificationsAsReadPayload, 'ids' | 'errors'>
  )> }
);

export type MarkNotificationsAsUnreadMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkNotificationsAsUnreadMutation = (
  { __typename?: 'Mutation' }
  & { markNotificationsAsUnread?: Maybe<(
    { __typename?: 'MarkNotificationsAsUnreadPayload' }
    & Pick<MarkNotificationsAsUnreadPayload, 'ids' | 'errors'>
  )> }
);

export type ArchiveNotificationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ArchiveNotificationsMutation = (
  { __typename?: 'Mutation' }
  & { archiveNotifications?: Maybe<(
    { __typename?: 'ArchiveNotificationsPayload' }
    & Pick<ArchiveNotificationsPayload, 'ids' | 'errors'>
  )> }
);

export type SubscribeToNotificationRulesMutationVariables = Exact<{
  notificationRuleSubscriptionAttributes: Array<NotificationRuleSubscriptionAttributes> | NotificationRuleSubscriptionAttributes;
}>;


export type SubscribeToNotificationRulesMutation = (
  { __typename?: 'Mutation' }
  & { subscribeToNotificationRules?: Maybe<(
    { __typename?: 'SubscribeToNotificationRulesPayload' }
    & Pick<SubscribeToNotificationRulesPayload, 'errors'>
    & { notificationRuleSubscriptions: Array<(
      { __typename?: 'NotificationRuleSubscription' }
      & NotificationRuleSubscriptionFieldsFragment
    )> }
  )> }
);

export type OfferFieldsFragment = (
  { __typename?: 'Offer' }
  & Pick<Offer, 'id' | 'isRootOfferOpenPrice' | 'isRootOfferOpenQuantity' | 'state' | 'title' | 'description' | 'currency' | 'packingWeek' | 'rootOfferId' | 'previousOfferId' | 'orderId' | 'incoterm' | 'companyId' | 'packType' | 'palletStack' | 'priceTerm' | 'expiresAt' | 'initialQuantity' | 'quantity' | 'quantityUnit' | 'createdAt' | 'updatedAt'>
  & { offerItems?: Maybe<Array<(
    { __typename?: 'OfferItem' }
    & OfferItemFieldsFragment
  )>>, offerRecipients?: Maybe<Array<(
    { __typename?: 'OfferRecipient' }
    & OfferRecipientFieldsFragment
  )>>, rootOffer?: Maybe<(
    { __typename?: 'Offer' }
    & Pick<Offer, 'id' | 'companyId'>
  )>, buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, tradeRegion?: Maybe<(
    { __typename?: 'TradeRegion' }
    & Pick<TradeRegion, 'id' | 'name' | 'code'>
  )>, variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name' | 'varietyName' | 'varietyCode'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id'>
    )> }
  )>, user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  )>, company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )> }
);

export type OfferItemFieldsFragment = (
  { __typename?: 'OfferItem' }
  & Pick<OfferItem, 'id' | 'offerId' | 'sizeCounts' | 'grade' | 'quantity' | 'quantityUnit' | 'createdAt' | 'updatedAt'>
  & { offerItemPrices?: Maybe<Array<(
    { __typename?: 'OfferItemPrice' }
    & OfferItemPriceFieldsFragment
  )>> }
);

export type OfferRecipientFieldsFragment = (
  { __typename?: 'OfferRecipient' }
  & Pick<OfferRecipient, 'id' | 'state' | 'contactUserId' | 'portOfDestinationId'>
  & { buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, portOfDestination?: Maybe<(
    { __typename?: 'SeaPort' }
    & PortDisplayFieldsFragment
  )> }
);

export type OfferItemPriceFieldsFragment = (
  { __typename?: 'OfferItemPrice' }
  & Pick<OfferItemPrice, 'id' | 'portOfDestinationId' | 'dipPriceAmountMajorUnit' | 'cifPriceAmountMajorUnit' | 'priceUnit'>
  & { portOfDestination?: Maybe<(
    { __typename?: 'SeaPort' }
    & PortDisplayFieldsFragment
  )> }
);

export type OfferItemPriceExpectedReturnFieldsFragment = (
  { __typename?: 'OfferItemPriceExpectedReturn' }
  & Pick<OfferItemPriceExpectedReturn, 'incoterm' | 'unit' | 'currency' | 'conversionPriceAmountMajorUnit'>
);

export type PortDisplayFieldsFragment = (
  { __typename?: 'SeaPort' }
  & Pick<SeaPort, 'id' | 'name' | 'displayName' | 'country' | 'createdAt' | 'updatedAt'>
);

export type RecentRootOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentRootOffersQuery = (
  { __typename?: 'Query' }
  & { recentRootOffers?: Maybe<Array<(
    { __typename?: 'Offer' }
    & OfferFieldsFragment
  )>> }
);

export type OffersQueryVariables = Exact<{
  filterAttributes: OfferFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type OffersQuery = (
  { __typename?: 'Query' }
  & { offers?: Maybe<(
    { __typename?: 'OfferConnection' }
    & Pick<OfferConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Offer' }
      & OfferFieldsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type CounterOffersQueryVariables = Exact<{
  filterAttributes: OfferFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  currency?: Maybe<CurrencyEnum>;
  incoterm?: Maybe<IncotermWithNscEnum>;
  unit?: Maybe<Scalars['String']>;
}>;


export type CounterOffersQuery = (
  { __typename?: 'Query' }
  & { counterOffers?: Maybe<(
    { __typename?: 'OfferConnection' }
    & Pick<OfferConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Offer' }
      & { offerItems?: Maybe<Array<(
        { __typename?: 'OfferItem' }
        & { offerItemPrices?: Maybe<Array<(
          { __typename?: 'OfferItemPrice' }
          & { expectedReturnSummary?: Maybe<(
            { __typename?: 'OfferItemPriceExpectedReturn' }
            & OfferItemPriceExpectedReturnFieldsFragment
          )> }
        )>> }
      )>> }
      & OfferFieldsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type OfferFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfferFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { offerFilterAttributes?: Maybe<(
    { __typename?: 'OfferFilterAttribute' }
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name' | 'varietyCode'>
    )>>, tradeRegions?: Maybe<Array<(
      { __typename?: 'TradeRegion' }
      & Pick<TradeRegion, 'id' | 'name' | 'code'>
    )>>, portsOfDestination?: Maybe<Array<(
      { __typename?: 'SeaPort' }
      & PortDisplayFieldsFragment
    )>> }
  )> }
);

export type OfferByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OfferByIdQuery = (
  { __typename?: 'Query' }
  & { offerById?: Maybe<(
    { __typename?: 'Offer' }
    & { rootOffer?: Maybe<(
      { __typename?: 'Offer' }
      & Pick<Offer, 'id' | 'companyId'>
      & { offerItems?: Maybe<Array<(
        { __typename?: 'OfferItem' }
        & OfferItemFieldsFragment
      )>> }
    )> }
    & OfferFieldsFragment
  )> }
);

export type OfferHistoryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OfferHistoryByIdQuery = (
  { __typename?: 'Query' }
  & { offerHistoryById?: Maybe<Array<(
    { __typename?: 'Offer' }
    & Pick<Offer, 'id' | 'currency' | 'companyId' | 'createdAt' | 'quantity'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, offerItems?: Maybe<Array<(
      { __typename?: 'OfferItem' }
      & Pick<OfferItem, 'id' | 'sizeCounts'>
      & { offerItemPrices?: Maybe<Array<(
        { __typename?: 'OfferItemPrice' }
        & Pick<OfferItemPrice, 'id' | 'cifPriceAmountMajorUnit' | 'portOfDestinationId'>
      )>> }
    )>>, offerRecipients?: Maybe<Array<(
      { __typename?: 'OfferRecipient' }
      & Pick<OfferRecipient, 'id' | 'portOfDestinationId'>
      & { buyer?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )> }
    )>> }
  )>> }
);

export type CreateOfferAsSupplierMutationVariables = Exact<{
  attributes: OfferAttributes;
}>;


export type CreateOfferAsSupplierMutation = (
  { __typename?: 'Mutation' }
  & { createOfferAsSupplier?: Maybe<(
    { __typename?: 'CreateOfferAsSupplierPayload' }
    & Pick<CreateOfferAsSupplierPayload, 'errors'>
    & { offer?: Maybe<(
      { __typename?: 'Offer' }
      & OfferFieldsFragment
    )> }
  )> }
);

export type CloseOfferAsSupplierMutationVariables = Exact<{
  offerId: Scalars['ID'];
}>;


export type CloseOfferAsSupplierMutation = (
  { __typename?: 'Mutation' }
  & { closeOfferAsSupplier?: Maybe<(
    { __typename?: 'CloseOfferAsSupplierPayload' }
    & Pick<CloseOfferAsSupplierPayload, 'errors'>
    & { offer?: Maybe<(
      { __typename?: 'Offer' }
      & OfferFieldsFragment
    )> }
  )> }
);

export type RejectOfferAsSupplierMutationVariables = Exact<{
  counterOfferId: Scalars['ID'];
}>;


export type RejectOfferAsSupplierMutation = (
  { __typename?: 'Mutation' }
  & { rejectOfferAsSupplier?: Maybe<(
    { __typename?: 'RejectOfferAsSupplierPayload' }
    & Pick<RejectOfferAsSupplierPayload, 'errors'>
    & { counterOffer?: Maybe<(
      { __typename?: 'Offer' }
      & OfferFieldsFragment
    )> }
  )> }
);

export type AcceptOfferAsSupplierMutationVariables = Exact<{
  counterOfferId: Scalars['ID'];
}>;


export type AcceptOfferAsSupplierMutation = (
  { __typename?: 'Mutation' }
  & { acceptOfferAsSupplier?: Maybe<(
    { __typename?: 'AcceptOfferAsSupplierPayload' }
    & Pick<AcceptOfferAsSupplierPayload, 'errors'>
    & { counterOffer?: Maybe<(
      { __typename?: 'Offer' }
      & OfferFieldsFragment
    )> }
  )> }
);

export type CreateCounterOfferAsSupplierMutationVariables = Exact<{
  previousOfferId: Scalars['ID'];
  attributes: CounterOfferAttributes;
}>;


export type CreateCounterOfferAsSupplierMutation = (
  { __typename?: 'Mutation' }
  & { createCounterOfferAsSupplier?: Maybe<(
    { __typename?: 'CreateCounterOfferAsSupplierPayload' }
    & Pick<CreateCounterOfferAsSupplierPayload, 'errors'>
    & { counterOffer?: Maybe<(
      { __typename?: 'Offer' }
      & OfferFieldsFragment
    )> }
  )> }
);

export type OnWhatsappInteractionFailedToDeliverSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnWhatsappInteractionFailedToDeliverSubscription = (
  { __typename?: 'Subscription' }
  & { onWhatsappInteractionFailedToDeliver: (
    { __typename?: 'WhatsappInteractionStatus' }
    & Pick<WhatsappInteractionStatus, 'id' | 'offerRecipientId' | 'buyerName' | 'buyerId'>
  ) }
);

export type UpdateCompanyOnboardingStepMutationVariables = Exact<{
  onboardingStep: CompanyOnboardingStepEnum;
}>;


export type UpdateCompanyOnboardingStepMutation = (
  { __typename?: 'Mutation' }
  & { updateCompanyOnboardingStep?: Maybe<(
    { __typename?: 'UpdateCompanyOnboardingStepPayload' }
    & Pick<UpdateCompanyOnboardingStepPayload, 'errors'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'onboardingStep'>
    )> }
  )> }
);

export type OrderProgramsQueryVariables = Exact<{
  filterAttributes: OrderProgramFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  orderProgramIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OrderProgramsQuery = (
  { __typename?: 'Query' }
  & { orderPrograms?: Maybe<Array<(
    { __typename?: 'OrderProgram' }
    & Pick<OrderProgram, 'batchNumber' | 'cartonCountId' | 'cartonTypeId' | 'cartonTypeName' | 'commodityId' | 'commodityName' | 'companyId' | 'companyLogoImageUrl' | 'companyName' | 'createdAt' | 'currency' | 'grade' | 'hiddenFields' | 'id' | 'incoterm' | 'inventoryCode' | 'mark' | 'portOfDestinationId' | 'portOfDestinationName' | 'portOfLoadingId' | 'portOfLoadingName' | 'priceTerm' | 'priceUnit' | 'priceAmountMajorUnit' | 'priority' | 'programId' | 'programName' | 'programVisibility' | 'quantityUnit' | 'quantity' | 'referenceNumber' | 'sizeCounts' | 'stackSize' | 'targetMarket' | 'tradeCountryId' | 'tradeCountryCode' | 'tradeCountryName' | 'tradeRegionId' | 'tradeRegionCode' | 'tradeRegionName' | 'updatedAt' | 'varietyCode' | 'varietyId' | 'varietyName' | 'additionalFields'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>, portOfDestination?: Maybe<(
      { __typename?: 'SeaPort' }
      & Pick<SeaPort, 'id' | 'name' | 'displayName' | 'createdAt' | 'updatedAt'>
    )>, portOfLoading?: Maybe<(
      { __typename?: 'SeaPort' }
      & Pick<SeaPort, 'id' | 'name' | 'displayName' | 'createdAt' | 'updatedAt'>
    )>, variety?: Maybe<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name' | 'varietyCode'>
    )> }
  )>> }
);

export type OrderProgramCommoditiesQueryVariables = Exact<{
  onlyOperational?: Maybe<Scalars['Boolean']>;
}>;


export type OrderProgramCommoditiesQuery = (
  { __typename?: 'Query' }
  & { commodities?: Maybe<Array<(
    { __typename?: 'Commodity' }
    & Pick<Commodity, 'id' | 'name'>
  )>> }
);

export type OrderProgramVarietiesQueryVariables = Exact<{
  onlyOperational?: Maybe<Scalars['Boolean']>;
  skipMixedVarieties?: Maybe<Scalars['Boolean']>;
  commodityId?: Maybe<Scalars['ID']>;
}>;


export type OrderProgramVarietiesQuery = (
  { __typename?: 'Query' }
  & { varieties?: Maybe<Array<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name' | 'varietyCode'>
  )>> }
);

export type OrderProgramSeaPortQueryVariables = Exact<{
  seaPortId: Scalars['ID'];
}>;


export type OrderProgramSeaPortQuery = (
  { __typename?: 'Query' }
  & { seaPort?: Maybe<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'country' | 'displayName' | 'createdAt' | 'updatedAt'>
  )> }
);

export type OrderProgramSeaPortsQueryVariables = Exact<{
  filterAttributes: SeaPortFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type OrderProgramSeaPortsQuery = (
  { __typename?: 'Query' }
  & { seaPortsV2?: Maybe<Array<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'country' | 'displayName' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type OrderProgramTradeCountriesQueryVariables = Exact<{
  tradeRegionId?: Maybe<Scalars['ID']>;
}>;


export type OrderProgramTradeCountriesQuery = (
  { __typename?: 'Query' }
  & { tradeCountries?: Maybe<Array<(
    { __typename?: 'TradeCountry' }
    & Pick<TradeCountry, 'id' | 'code' | 'name'>
  )>> }
);

export type CreateOrderProgramMutationVariables = Exact<{
  attributes: OrderProgramAttributes;
}>;


export type CreateOrderProgramMutation = (
  { __typename?: 'Mutation' }
  & { createOrderProgram?: Maybe<(
    { __typename?: 'CreateOrderProgramPayload' }
    & Pick<CreateOrderProgramPayload, 'errors'>
    & { orderProgram?: Maybe<(
      { __typename?: 'OrderProgram' }
      & Pick<OrderProgram, 'id'>
    )> }
  )> }
);

export type UpdateOrderProgramMutationVariables = Exact<{
  orderProgramId: Scalars['ID'];
  attributes: OrderProgramAttributes;
}>;


export type UpdateOrderProgramMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderProgram?: Maybe<(
    { __typename?: 'UpdateOrderProgramPayload' }
    & Pick<UpdateOrderProgramPayload, 'errors'>
    & { orderProgram?: Maybe<(
      { __typename?: 'OrderProgram' }
      & Pick<OrderProgram, 'id'>
    )> }
  )> }
);

export type DeleteOrderProgramMutationVariables = Exact<{
  orderProgramId: Scalars['ID'];
}>;


export type DeleteOrderProgramMutation = (
  { __typename?: 'Mutation' }
  & { deleteOrderProgram?: Maybe<(
    { __typename?: 'DeleteOrderProgramPayload' }
    & Pick<DeleteOrderProgramPayload, 'errors'>
    & { orderProgram?: Maybe<(
      { __typename?: 'OrderProgram' }
      & Pick<OrderProgram, 'id'>
    )> }
  )> }
);

export type LineItemsQueryVariables = Exact<{
  filterAttributes: LineItemFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  currency?: Maybe<CurrencyEnum>;
  unit?: Maybe<Scalars['String']>;
  incoterm?: Maybe<IncotermWithNscEnum>;
}>;


export type LineItemsQuery = (
  { __typename?: 'Query' }
  & { lineItems?: Maybe<(
    { __typename?: 'LineItemConnection' }
    & Pick<LineItemConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'LineItem' }
      & SingleLineItemFieldsFragment
      & ExpectedNetReturnFieldsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type OrdersV3QueryVariables = Exact<{
  filterAttributes: OrderFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type OrdersV3Query = (
  { __typename?: 'Query' }
  & { ordersV3?: Maybe<(
    { __typename?: 'OrderConnection' }
    & Pick<OrderConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Order' }
      & Pick<Order, 'id' | 'state' | 'updatedAt' | 'createdAt'>
      & { seller?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, buyer?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )>, lineItemGroupings?: Maybe<Array<(
        { __typename?: 'LineItemGrouping' }
        & Pick<LineItemGrouping, 'commonFields' | 'cumulativeQuantity' | 'cumulativeTooltip' | 'deleted' | 'id' | 'numberCumulativeSiblings' | 'quantityType' | 'rank'>
        & { lineItems?: Maybe<Array<(
          { __typename?: 'LineItem' }
          & SingleLineItemFieldsFragment
          & StatesDistributionFieldsFragment
        )>> }
      )>> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type LineItemsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineItemsFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { lineItemsFilterAttributes?: Maybe<(
    { __typename?: 'LineItemFilterAttribute' }
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name' | 'varietyCode'>
    )>> }
  )> }
);

export type OrdersFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { ordersFilterAttributes?: Maybe<(
    { __typename?: 'OrderFilterAttribute' }
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name' | 'varietyCode'>
    )>> }
  )> }
);

export type ShipmentDocumentFieldsFragment = (
  { __typename?: 'ShipmentDocument' }
  & Pick<ShipmentDocument, 'id' | 'documentType'>
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id'>
    )> }
  )>, file?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'filename' | 'v2Url'>
  )> }
);

export type SingleLineItemFieldsFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'id' | 'additionalFields' | 'packingWeek' | 'startWeek' | 'endWeek' | 'targetRegion' | 'targetCountry' | 'targetMarket' | 'quantity' | 'plannedQuantity' | 'plannedQuantityUnit' | 'incoterm' | 'pack' | 'palletStack' | 'priority' | 'quantityUnit' | 'priceMinorUnit' | 'sizeCounts' | 'priceTerm' | 'currency' | 'state' | 'priceUnit' | 'grade' | 'mark' | 'commodityId' | 'varietyId' | 'packedCartons' | 'packedPallets' | 'referenceNumber' | 'rank' | 'batchNumber' | 'inventoryCode' | 'unlimited' | 'orderId' | 'lineItemGroupingId' | 'createdAt' | 'updatedAt' | 'departurePortId' | 'destinationPortId' | 'cumulativeQuantity'>
  & { variety?: Maybe<(
    { __typename?: 'Variety' }
    & Pick<Variety, 'id' | 'name' | 'varietyCode'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>, subCommodity?: Maybe<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'id' | 'name'>
    )> }
  )>, seller?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
  )>, departurePort?: Maybe<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'displayName' | 'createdAt' | 'updatedAt'>
  )>, destinationPort?: Maybe<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'displayName' | 'createdAt' | 'updatedAt'>
  )> }
);

export type StatesDistributionFieldsFragment = (
  { __typename?: 'LineItem' }
  & { statesDistribution?: Maybe<Array<(
    { __typename?: 'LineItemState' }
    & Pick<LineItemState, 'quantity' | 'quantityTotal' | 'palletQuantity' | 'palletQuantityTotal' | 'state' | 'supplyChainOrder'>
  )>> }
);

export type ExpectedNetReturnFieldsFragment = (
  { __typename?: 'LineItem' }
  & { expectedReturnSummary?: Maybe<(
    { __typename?: 'ExpectedReturnSummary' }
    & Pick<ExpectedReturnSummary, 'unit' | 'error'>
    & { equivalentPrice?: Maybe<(
      { __typename?: 'IncotermPrice' }
      & Pick<IncotermPrice, 'incoterm'>
      & { moneyAmount: (
        { __typename?: 'Money' }
        & Pick<Money, 'displayString'>
      ) }
    )>, pricePoints?: Maybe<Array<(
      { __typename?: 'IncotermPrice' }
      & Pick<IncotermPrice, 'incoterm'>
      & { moneyAmount: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
        & { currency: (
          { __typename?: 'Currency' }
          & Pick<Currency, 'symbol'>
        ) }
      ), chargesApplied?: Maybe<Array<(
        { __typename?: 'ChargeApplied' }
        & Pick<ChargeApplied, 'name'>
        & { moneyAmount: (
          { __typename?: 'Money' }
          & Pick<Money, 'amount'>
        ) }
      )>> }
    )>> }
  )> }
);

export type QuantityTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type QuantityTypeQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'quantityType'>
);

export type SingleOrderFieldsWithNetReturnFragment = (
  { __typename?: 'Order' }
  & { lineItemGroupings?: Maybe<Array<(
    { __typename?: 'LineItemGrouping' }
    & { lineItems?: Maybe<Array<(
      { __typename?: 'LineItem' }
      & ExpectedNetReturnFieldsFragment
    )>> }
  )>> }
  & SingleOrderFieldsFragment
);

export type SingleOrderFieldsFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'state' | 'isPackhouseRun' | 'createdAt' | 'updatedAt'>
  & { comments?: Maybe<Array<(
    { __typename?: 'Comment' }
    & CommentFieldsFragment
  )>>, buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
    & { logoFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'v2Url'>
    )>, additionalFields?: Maybe<Array<(
      { __typename?: 'AdditionalField' }
      & Pick<AdditionalField, 'id' | 'name'>
    )>>, sellerVarieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
      & { commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
      )> }
    )>> }
  )>, seller?: Maybe<(
    { __typename?: 'Company' }
    & SellerCompanyFieldsFragment
  )>, lineItems?: Maybe<Array<(
    { __typename?: 'LineItem' }
    & SingleLineItemFieldsFragment
  )>>, lineItemGroupings?: Maybe<Array<(
    { __typename?: 'LineItemGrouping' }
    & Pick<LineItemGrouping, 'id' | 'cumulativeQuantity' | 'quantityType' | 'commonFields' | 'deleted' | 'rank'>
    & { lineItems?: Maybe<Array<(
      { __typename?: 'LineItem' }
      & SingleLineItemFieldsFragment
      & StatesDistributionFieldsFragment
    )>> }
  )>>, audits?: Maybe<Array<(
    { __typename?: 'Audit' }
    & Pick<Audit, 'id' | 'action' | 'auditableType' | 'auditableId' | 'associatedType' | 'associatedId' | 'createdAt' | 'auditedChanges' | 'version'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )> }
    )> }
  )>>, shipmentDocuments?: Maybe<Array<(
    { __typename?: 'ShipmentDocument' }
    & ShipmentDocumentFieldsFragment
  )>> }
);

export type MultipleOrderFieldsFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'state' | 'isPackhouseRun' | 'updatedAt' | 'createdAt'>
  & { lineItemGroupings?: Maybe<Array<(
    { __typename?: 'LineItemGrouping' }
    & Pick<LineItemGrouping, 'commonFields' | 'cumulativeQuantity' | 'cumulativeTooltip' | 'deleted' | 'id' | 'numberCumulativeSiblings' | 'quantityType' | 'rank'>
    & { lineItems?: Maybe<Array<(
      { __typename?: 'LineItem' }
      & SingleLineItemFieldsFragment
      & StatesDistributionFieldsFragment
      & ExpectedNetReturnFieldsFragment
    )>> }
  )>>, buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
    & { logoFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'v2Url'>
    )>, sellerVarieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
      & { commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
      )> }
    )>> }
  )>, seller?: Maybe<(
    { __typename?: 'Company' }
    & SellerCompanyFieldsFragment
  )> }
);

export type SellerCompanyFieldsFragment = (
  { __typename?: 'Company' }
  & Pick<Company, 'id' | 'name'>
  & { logoFile?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'filename' | 'v2Url'>
  )>, varieties?: Maybe<Array<(
    { __typename?: 'FarmVariety' }
    & Pick<FarmVariety, 'id' | 'varietyId' | 'name'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )> }
  )>>, additionalFields?: Maybe<Array<(
    { __typename?: 'AdditionalField' }
    & Pick<AdditionalField, 'id' | 'name'>
  )>> }
);

export type DuplicateOrderFieldsFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'isPackhouseRun'>
  & { lineItemGroupings?: Maybe<Array<(
    { __typename?: 'LineItemGrouping' }
    & Pick<LineItemGrouping, 'id' | 'cumulativeQuantity' | 'quantityType' | 'commonFields' | 'deleted' | 'rank'>
    & { lineItems?: Maybe<Array<(
      { __typename?: 'LineItem' }
      & SingleLineItemFieldsFragment
    )>> }
  )>>, buyer?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name'>
    & { logoFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'v2Url'>
    )>, sellerVarieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
      & { commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
      )> }
    )>> }
  )>, seller?: Maybe<(
    { __typename?: 'Company' }
    & SellerCompanyFieldsFragment
  )> }
);

export type CreateOrderMutationVariables = Exact<{
  attributes: CreateOrderAttributes;
  lineItemStates?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  packingWeekStart?: Maybe<Scalars['String']>;
  packingWeekEnd?: Maybe<Scalars['String']>;
  varietyIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  commodityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  subCommodityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  states?: Maybe<Array<StateFilter> | StateFilter>;
  currency?: Maybe<CurrencyEnum>;
  unit?: Maybe<Scalars['String']>;
  incoterm?: Maybe<IncotermWithNscEnum>;
}>;


export type CreateOrderMutation = (
  { __typename?: 'Mutation' }
  & { createOrder?: Maybe<(
    { __typename?: 'CreateOrderPayload' }
    & Pick<CreateOrderPayload, 'errors'>
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & MultipleOrderFieldsFragment
    )> }
  )> }
);

export type OrdersSearchQueryVariables = Exact<{
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  filter: OrderFilter;
  lineItemStates?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  packingWeekStart?: Maybe<Scalars['String']>;
  packingWeekEnd?: Maybe<Scalars['String']>;
  varietyIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  commodityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  subCommodityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  states?: Maybe<Array<StateFilter> | StateFilter>;
  currency?: Maybe<CurrencyEnum>;
  unit?: Maybe<Scalars['String']>;
  incoterm?: Maybe<IncotermWithNscEnum>;
}>;


export type OrdersSearchQuery = (
  { __typename?: 'Query' }
  & { ordersSearch?: Maybe<(
    { __typename?: 'OrderSearch' }
    & Pick<OrderSearch, 'totalOrders' | 'totalFiltered'>
    & { orders?: Maybe<Array<(
      { __typename?: 'Order' }
      & MultipleOrderFieldsFragment
    )>> }
  )> }
);

export type OrdersSearchFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersSearchFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { ordersSearchFilterAttributes?: Maybe<(
    { __typename?: 'OrdersSearchFilterAttributes' }
    & { commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
    )>>, subCommodities?: Maybe<Array<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'id' | 'name'>
    )>>, companies?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>> }
  )> }
);

export type OrderQueryVariables = Exact<{
  id: Scalars['ID'];
  currency?: Maybe<CurrencyEnum>;
  unit?: Maybe<Scalars['String']>;
  incoterm?: Maybe<IncotermWithNscEnum>;
}>;


export type OrderQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & SingleOrderFieldsWithNetReturnFragment
  )> }
);

export type DuplicateOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateOrderQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & DuplicateOrderFieldsFragment
  )> }
);

export type UpdateOrderMutationVariables = Exact<{
  attributes: UpdateOrderAttributes;
}>;


export type UpdateOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateOrder?: Maybe<(
    { __typename?: 'UpdateOrderPayload' }
    & Pick<UpdateOrderPayload, 'errors'>
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & SingleOrderFieldsFragment
    )> }
  )> }
);

export type UpdateLineItemsMutationVariables = Exact<{
  attributes: Array<UpdateLineItemAttributes> | UpdateLineItemAttributes;
}>;


export type UpdateLineItemsMutation = (
  { __typename?: 'Mutation' }
  & { updateLineItems?: Maybe<(
    { __typename?: 'UpdateLineItemsPayload' }
    & Pick<UpdateLineItemsPayload, 'errors'>
    & { lineItems?: Maybe<Array<(
      { __typename?: 'LineItem' }
      & SingleLineItemFieldsFragment
    )>> }
  )> }
);

export type AcceptLineItemsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type AcceptLineItemsMutation = (
  { __typename?: 'Mutation' }
  & { acceptLineItems?: Maybe<(
    { __typename?: 'AcceptLineItemsPayload' }
    & { orders?: Maybe<Array<(
      { __typename?: 'Order' }
      & SingleOrderFieldsFragment
    )>> }
  )> }
);

export type WontPackLineItemsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type WontPackLineItemsMutation = (
  { __typename?: 'Mutation' }
  & { wontPackLineItems?: Maybe<(
    { __typename?: 'WontPackLineItemsPayload' }
    & { orders?: Maybe<Array<(
      { __typename?: 'Order' }
      & SingleOrderFieldsFragment
    )>> }
  )> }
);

export type RevertLineItemsToCreatedMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type RevertLineItemsToCreatedMutation = (
  { __typename?: 'Mutation' }
  & { revertLineItemsToCreated?: Maybe<(
    { __typename?: 'RevertLineItemsToCreatedPayload' }
    & { orders?: Maybe<Array<(
      { __typename?: 'Order' }
      & SingleOrderFieldsFragment
    )>> }
  )> }
);

export type RevertOrderChangeMutationVariables = Exact<{
  startid: Scalars['Int'];
  endid: Scalars['Int'];
  orderid: Scalars['Int'];
}>;


export type RevertOrderChangeMutation = (
  { __typename?: 'Mutation' }
  & { revertOrderChange?: Maybe<(
    { __typename?: 'RevertOrderChangePayload' }
    & Pick<RevertOrderChangePayload, 'errors'>
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & SingleOrderFieldsFragment
    )> }
  )> }
);

export type UploadOrderShipmentDocumentMutationVariables = Exact<{
  orderid: Scalars['Int'];
  type: Scalars['String'];
  file: Scalars['Upload'];
}>;


export type UploadOrderShipmentDocumentMutation = (
  { __typename?: 'Mutation' }
  & { uploadOrderShipmentDocument?: Maybe<(
    { __typename?: 'UploadOrderShipmentDocumentPayload' }
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & { shipmentDocuments?: Maybe<Array<(
        { __typename?: 'ShipmentDocument' }
        & ShipmentDocumentFieldsFragment
      )>> }
    )> }
  )> }
);

export type NewOrderSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewOrderSubscription = (
  { __typename?: 'Subscription' }
  & { newOrder: (
    { __typename?: 'Order' }
    & SingleOrderFieldsFragment
  ) }
);

export type OnAcceptLineItemsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAcceptLineItemsSubscription = (
  { __typename?: 'Subscription' }
  & { onAcceptLineItems: (
    { __typename?: 'Order' }
    & SingleOrderFieldsFragment
  ) }
);

export type OnWontPackLineItemsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnWontPackLineItemsSubscription = (
  { __typename?: 'Subscription' }
  & { onWontPackLineItems: (
    { __typename?: 'Order' }
    & SingleOrderFieldsFragment
  ) }
);

export type OnRevertLineItemsToCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnRevertLineItemsToCreatedSubscription = (
  { __typename?: 'Subscription' }
  & { onRevertLineItemsToCreated: (
    { __typename?: 'Order' }
    & SingleOrderFieldsFragment
  ) }
);

export type PackInstructionsLineItemsQueryVariables = Exact<{
  attributes: PackInstructionsAttributes;
}>;


export type PackInstructionsLineItemsQuery = (
  { __typename?: 'Query' }
  & { packInstructions?: Maybe<Array<(
    { __typename?: 'PackInstructionLineItem' }
    & Pick<PackInstructionLineItem, 'groupId' | 'priority' | 'batchNumber' | 'buyer' | 'commodity' | 'grade' | 'id' | 'inventoryCode' | 'mark' | 'orderId' | 'pack' | 'packingWeek' | 'palletStack' | 'quantitesPacked' | 'quantityRequested' | 'quantityUnit' | 'referenceNumber' | 'seller' | 'sizeCounts' | 'state' | 'subCommodity' | 'targetMarket' | 'targetRegion' | 'targetCountry' | 'variety' | 'varietyCode' | 'additionalFields' | 'incoterm' | 'priceUnit' | 'priceMajorUnit' | 'currency' | 'priceTerm' | 'formattedPrice'>
    & { comments?: Maybe<Array<(
      { __typename?: 'Comment' }
      & Pick<Comment, 'commentText' | 'id' | 'userId' | 'commentableType' | 'updatedAt' | 'isDeleted' | 'createdAt' | 'commentableId'>
      & { user?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'firstName' | 'lastName' | 'id'>
        & { avatarFile?: Maybe<(
          { __typename?: 'Document' }
          & Pick<Document, 'id' | 'filename' | 'url'>
        )> }
      )> }
    )>> }
  )>> }
);

export type PackInstructionsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type PackInstructionsFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { packInstructionsFilterAttributes?: Maybe<(
    { __typename?: 'PackInstructionsFilterAttribute' }
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, subCommodities?: Maybe<Array<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name'>
    )>> }
  )> }
);

export type OnePackClientCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type OnePackClientCodesQuery = (
  { __typename?: 'Query' }
  & { onepackClientCodes: Array<(
    { __typename?: 'OnepackClientCode' }
    & Pick<OnepackClientCode, 'id' | 'clientCode' | 'label'>
  )> }
);

export type OnepackSyncCallsQueryVariables = Exact<{
  clientCode?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type OnepackSyncCallsQuery = (
  { __typename?: 'Query' }
  & { onepackPackInstructionSyncCalls: Array<(
    { __typename?: 'OnepackPackInstructionSyncCall' }
    & Pick<OnepackPackInstructionSyncCall, 'id' | 'clientCode' | 'url' | 'message' | 'statusCode' | 'syncSucceeded' | 'itemsCount' | 'createdAt'>
  )> }
);

export type UpdatePackInstructionLineItemPriorityMutationVariables = Exact<{
  packInstructionLineItemId: Scalars['ID'];
  priority?: Maybe<Scalars['Int']>;
}>;


export type UpdatePackInstructionLineItemPriorityMutation = (
  { __typename?: 'Mutation' }
  & { updatePackInstructionLineItemPriority?: Maybe<(
    { __typename?: 'UpdatePackInstructionLineItemPriorityPayload' }
    & Pick<UpdatePackInstructionLineItemPriorityPayload, 'errors'>
  )> }
);

export type PushPackInstructionsToOnepackMutationVariables = Exact<{
  clientCode: Scalars['String'];
  packInstructionsAttributes: PackInstructionsAttributes;
}>;


export type PushPackInstructionsToOnepackMutation = (
  { __typename?: 'Mutation' }
  & { pushPackInstructionsToOnepack?: Maybe<(
    { __typename?: 'PushPackInstructionsToOnepackPayload' }
    & Pick<PushPackInstructionsToOnepackPayload, 'success' | 'message' | 'isPlatformError' | 'packInstructionRef'>
  )> }
);

export type CompanyFieldsFragment = (
  { __typename?: 'Company' }
  & Pick<Company, 'id' | 'name'>
);

export type PackhouseConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackhouseConnectionsQuery = (
  { __typename?: 'Query' }
  & { packhouseConnections?: Maybe<Array<(
    { __typename?: 'PackhouseConnection' }
    & Pick<PackhouseConnection, 'id' | 'name' | 'state' | 'scheduledFor' | 'scheduledAt' | 'createdAt' | 'updatedAt' | 'apiUserId' | 'connected' | 'lastProcessedDatetime' | 'onPremSystem'>
    & { company: (
      { __typename?: 'Company' }
      & CompanyFieldsFragment
    ), foodBusinessOperator: (
      { __typename?: 'FoodBusinessOperator' }
      & FoodBusinessOperatorFieldsFragment
    ), masterfileConfig?: Maybe<(
      { __typename?: 'MasterfileConfig' }
      & MasterfileConfigFieldsFragment
    )> }
  )>> }
);

export type PackhouseConnectionsClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackhouseConnectionsClientChangeRequestsQuery = (
  { __typename?: 'Query' }
  & { packhouseConnectionsClientChangeRequests?: Maybe<Array<(
    { __typename?: 'PackhouseConnectionClientChangeRequest' }
    & Pick<PackhouseConnectionClientChangeRequest, 'id' | 'createdAt' | 'updatedAt'>
    & { foodBusinessOperator?: Maybe<(
      { __typename?: 'FoodBusinessOperator' }
      & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'producerName' | 'typeOfBusiness' | 'productionRegion' | 'createdAt' | 'updatedAt'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id' | 'name'>
      )> }
    )>, company?: Maybe<(
      { __typename?: 'Company' }
      & CompanyFieldsFragment
    )> }
  )>> }
);

export type CreatePackhouseConnectionsRequestMutationVariables = Exact<{
  attributes: CreatePackhouseConnectionsAttribute;
}>;


export type CreatePackhouseConnectionsRequestMutation = (
  { __typename?: 'Mutation' }
  & { createPackhouseConnectionsRequest?: Maybe<(
    { __typename?: 'CreatePackhouseConnectionsRequestPayload' }
    & Pick<CreatePackhouseConnectionsRequestPayload, 'errors'>
    & { clientChangeRequests?: Maybe<Array<(
      { __typename?: 'PackhouseConnectionClientChangeRequest' }
      & Pick<PackhouseConnectionClientChangeRequest, 'id' | 'createdAt' | 'updatedAt'>
      & { foodBusinessOperator?: Maybe<(
        { __typename?: 'FoodBusinessOperator' }
        & Pick<FoodBusinessOperator, 'id' | 'name' | 'fboCode' | 'producerName' | 'typeOfBusiness' | 'productionRegion' | 'createdAt' | 'updatedAt'>
        & { company?: Maybe<(
          { __typename?: 'Company' }
          & Pick<Company, 'id' | 'name'>
        )> }
      )>, company?: Maybe<(
        { __typename?: 'Company' }
        & CompanyFieldsFragment
      )> }
    )>> }
  )> }
);

export type PaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentQuery = (
  { __typename?: 'Query' }
  & { payment?: Maybe<(
    { __typename?: 'Payment' }
    & Pick<Payment, 'totalAmountMajorUnit' | 'allocatedAmountMajorUnit' | 'remainingAmountMajorUnit' | 'bankChargesMajorUnit' | 'bankChargesSplit' | 'cashbookReference' | 'companyName' | 'companyId' | 'createdAt' | 'currency' | 'description' | 'id' | 'contactName' | 'contactId' | 'paymentDate' | 'paymentType' | 'updatedAt' | 'state'>
    & { invoices?: Maybe<Array<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id' | 'invoiceNumber' | 'documentType' | 'currency' | 'allocatedAmountMajorUnit' | 'remainingAmountMajorUnit' | 'containerNumbers' | 'state' | 'totalIncoterm' | 'remittableAmountMajorUnit' | 'updatedAt'>
      & { invoicePayments?: Maybe<Array<(
        { __typename?: 'InvoicePayment' }
        & Pick<InvoicePayment, 'id' | 'invoiceId' | 'paymentId' | 'amountMajorUnit'>
      )>> }
    )>>, invoicePaymentAllocations?: Maybe<Array<(
      { __typename?: 'InvoicePaymentAllocation' }
      & Pick<InvoicePaymentAllocation, 'invoiceId' | 'totalAmountMajorUnit'>
    )>>, currencyExchangeRate?: Maybe<(
      { __typename?: 'CurrencyExchangeRate' }
      & Pick<CurrencyExchangeRate, 'id' | 'fromCurrency' | 'toCurrency' | 'exchangeRate' | 'exchangeRateDate' | 'exchangeRateType'>
      & { currencyConversion?: Maybe<(
        { __typename?: 'CurrencyConversion' }
        & Pick<CurrencyConversion, 'id' | 'rates' | 'timestamp'>
      )> }
    )> }
  )> }
);

export type PaymentsQueryVariables = Exact<{
  filterAttributes?: Maybe<PaymentsFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type PaymentsQuery = (
  { __typename?: 'Query' }
  & { payments?: Maybe<(
    { __typename?: 'PaymentConnection' }
    & Pick<PaymentConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Payment' }
      & Pick<Payment, 'totalAmountMajorUnit' | 'allocatedAmountMajorUnit' | 'remainingAmountMajorUnit' | 'bankChargesMajorUnit' | 'bankChargesSplit' | 'cashbookReference' | 'companyName' | 'companyId' | 'createdAt' | 'currency' | 'description' | 'id' | 'contactName' | 'contactId' | 'paymentDate' | 'paymentType' | 'updatedAt' | 'state' | 'exchangeRate'>
      & { currencyExchangeRate?: Maybe<(
        { __typename?: 'CurrencyExchangeRate' }
        & Pick<CurrencyExchangeRate, 'id' | 'fromCurrency' | 'toCurrency' | 'exchangeRate' | 'exchangeRateDate' | 'exchangeRateType'>
        & { currencyConversion?: Maybe<(
          { __typename?: 'CurrencyConversion' }
          & Pick<CurrencyConversion, 'id' | 'rates' | 'timestamp'>
        )> }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type PaymentsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentsFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { paymentsFilterAttributes?: Maybe<(
    { __typename?: 'PaymentFilterAttribute' }
    & { contacts?: Maybe<Array<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'name'>
    )>> }
  )> }
);

export type CompanyPaymentsQueryVariables = Exact<{
  filterAttributes?: Maybe<CompanyPaymentFilters>;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type CompanyPaymentsQuery = (
  { __typename?: 'Query' }
  & { companyPayments?: Maybe<Array<(
    { __typename?: 'CompanyPayment' }
    & Pick<CompanyPayment, 'incomingAmountDueMajorUnit' | 'outgoingAmountDueMajorUnit' | 'currency' | 'companyName' | 'companyId' | 'invoicesDue' | 'contactName' | 'contactId' | 'incomingUnallocatedAmountMajorUnit' | 'outgoingUnallocatedAmountMajorUnit' | 'unallocatedPayments' | 'updatedAt'>
    & { contact?: Maybe<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'name'>
    )> }
  )>> }
);

export type CompanyPaymentsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyPaymentsFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { companyPaymentsFilterAttributes?: Maybe<(
    { __typename?: 'CompanyPaymentFilterAttribute' }
    & { contacts?: Maybe<Array<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'id' | 'name'>
    )>> }
  )> }
);

export type InvoicesQueryVariables = Exact<{
  filterAttributes: InvoicesFilters;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  page: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type InvoicesQuery = (
  { __typename?: 'Query' }
  & { invoices?: Maybe<(
    { __typename?: 'InvoiceConnection' }
    & Pick<InvoiceConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Invoice' }
      & Pick<Invoice, 'id' | 'invoiceNumber' | 'documentType' | 'currency' | 'allocatedAmountMajorUnit' | 'remainingAmountMajorUnit' | 'remittableAmountMajorUnit' | 'containerNumbers' | 'state' | 'totalIncoterm' | 'updatedAt'>
      & { invoicePayments?: Maybe<Array<(
        { __typename?: 'InvoicePayment' }
        & Pick<InvoicePayment, 'id' | 'invoiceId' | 'paymentId' | 'amountMajorUnit'>
      )>> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type CreatePaymentMutationVariables = Exact<{
  attributes: PaymentAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
}>;


export type CreatePaymentMutation = (
  { __typename?: 'Mutation' }
  & { createPayment?: Maybe<(
    { __typename?: 'CreatePaymentPayload' }
    & Pick<CreatePaymentPayload, 'errors'>
    & { payment?: Maybe<(
      { __typename?: 'Payment' }
      & Pick<Payment, 'id'>
    )> }
  )> }
);

export type UpdatePaymentMutationVariables = Exact<{
  paymentId: Scalars['ID'];
  attributes: PaymentAttributes;
  currencyExchangeRateAttributes?: Maybe<CurrencyExchangeRateAttributes>;
}>;


export type UpdatePaymentMutation = (
  { __typename?: 'Mutation' }
  & { updatePayment?: Maybe<(
    { __typename?: 'UpdatePaymentPayload' }
    & Pick<UpdatePaymentPayload, 'errors'>
    & { payment?: Maybe<(
      { __typename?: 'Payment' }
      & Pick<Payment, 'id'>
    )> }
  )> }
);

export type DeletePaymentMutationVariables = Exact<{
  paymentId: Scalars['ID'];
}>;


export type DeletePaymentMutation = (
  { __typename?: 'Mutation' }
  & { deletePayment?: Maybe<(
    { __typename?: 'DeletePaymentPayload' }
    & Pick<DeletePaymentPayload, 'errors'>
    & { payment?: Maybe<(
      { __typename?: 'Payment' }
      & Pick<Payment, 'id'>
    )> }
  )> }
);

export type AllocatePaymentsMutationVariables = Exact<{
  paymentAllocations: Array<PaymentAllocationAttributes> | PaymentAllocationAttributes;
}>;


export type AllocatePaymentsMutation = (
  { __typename?: 'Mutation' }
  & { allocatePayments?: Maybe<(
    { __typename?: 'AllocatePaymentsPayload' }
    & Pick<AllocatePaymentsPayload, 'errors' | 'success'>
  )> }
);

export type PnlLinkedRecordsQueryVariables = Exact<{
  cartonGroupingIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  containerIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  breakBulkContainerIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  reportingCurrency?: Maybe<Scalars['String']>;
  fxEnabled?: Maybe<Scalars['Boolean']>;
}>;


export type PnlLinkedRecordsQuery = (
  { __typename?: 'Query' }
  & { pnlLinkedRecords: Array<(
    { __typename?: 'PnlLinkedRecord' }
    & Pick<PnlLinkedRecord, 'id' | 'recordType' | 'invoiceNumber' | 'documentType' | 'rawDocumentType' | 'state' | 'date' | 'currency' | 'amountMajorUnit' | 'isPayment' | 'contactName' | 'exchangeRateToReporting' | 'cartons' | 'cgCount' | 'downloadUrl'>
  )> }
);

export type ProfitAndLossReportQueryVariables = Exact<{
  filters: ProfitAndLossFilters;
}>;


export type ProfitAndLossReportQuery = (
  { __typename?: 'Query' }
  & { profitAndLossReport?: Maybe<(
    { __typename?: 'ProfitAndLossReport' }
    & { nodes?: Maybe<Array<(
      { __typename?: 'ProfitAndLossRow' }
      & Pick<ProfitAndLossRow, 'farmCode' | 'containerNumber' | 'commodity' | 'variety' | 'packType' | 'sizeCount' | 'grade' | 'targetRegion' | 'targetMarket' | 'targetCountry' | 'buyerName' | 'sellerName' | 'batchNumber' | 'palletNumber' | 'exporterCode' | 'mark' | 'inventoryCode' | 'packingWeek' | 'voyageNumber' | 'extendedFields' | 'totalCartons' | 'totalStdCartons' | 'totalKilograms' | 'cgCount' | 'palletCount' | 'shippingWeek' | 'arrivalWeek' | 'dischargePort' | 'vesselName' | 'incoterm' | 'contractCurrency' | 'paymentAdviceNumber' | 'poNumber' | 'allOnStatement' | 'paymentAdviceDownloadUrl' | 'revenue' | 'cifCosts' | 'netCif' | 'fobCosts' | 'netFob' | 'dipCosts' | 'netDip' | 'exwCosts' | 'netExw' | 'growerFinalPayment' | 'overseasCosts' | 'localCosts' | 'revenueAdvance' | 'revenueFinal' | 'revenueCreditNote' | 'revenueDebitNote' | 'revenuePerCarton' | 'revenuePerStdCarton' | 'revenuePerKg' | 'netCifPerCarton' | 'netCifPerStdCarton' | 'netFobPerCarton' | 'netFobPerStdCarton' | 'netDipPerCarton' | 'netDipPerStdCarton' | 'netExwPerCarton' | 'netExwPerStdCarton' | 'cashReceived' | 'accountsReceivable' | 'cashReceivedPerCarton' | 'cashReceivedPerStdCarton' | 'revenueInclVat' | 'cifCostsInclVat' | 'fobCostsInclVat' | 'dipCostsInclVat' | 'exwCostsInclVat' | 'netCifInclVat' | 'netFobInclVat' | 'netDipInclVat' | 'netExwInclVat' | 'overseasCostsInclVat' | 'localCostsInclVat' | 'vatTotalRevenue' | 'vatTotalCosts' | 'revenueInclVatPerCarton' | 'revenueInclVatPerStdCarton' | 'revenueInclVatPerKg' | 'netCifInclVatPerCarton' | 'netCifInclVatPerStdCarton' | 'netFobInclVatPerCarton' | 'netFobInclVatPerStdCarton' | 'netDipInclVatPerCarton' | 'netDipInclVatPerStdCarton' | 'netExwInclVatPerCarton' | 'netExwInclVatPerStdCarton' | 'costBreakdown' | 'linkedRecordsCount' | 'linkedCgIds' | 'linkedContainerIds' | 'linkedBbcIds'>
    )>>, pageInfo?: Maybe<(
      { __typename?: 'ProfitAndLossPageInfo' }
      & Pick<ProfitAndLossPageInfo, 'hasNextPage'>
    )>, meta?: Maybe<(
      { __typename?: 'ProfitAndLossMeta' }
      & Pick<ProfitAndLossMeta, 'rowCount' | 'sqlMs' | 'totalMs' | 'reportingCurrency' | 'extendedFieldKeys'>
      & { costCategories?: Maybe<Array<(
        { __typename?: 'ProfitAndLossCostCategory' }
        & Pick<ProfitAndLossCostCategory, 'key' | 'label' | 'section'>
      )>> }
    )> }
  )> }
);

export type ProfitAndLossReportFieldsFragment = (
  { __typename?: 'ProfitAndLossReport' }
  & { nodes?: Maybe<Array<(
    { __typename?: 'ProfitAndLossRow' }
    & Pick<ProfitAndLossRow, 'farmCode' | 'containerNumber' | 'commodity' | 'variety' | 'packType' | 'sizeCount' | 'grade' | 'targetRegion' | 'targetMarket' | 'targetCountry' | 'buyerName' | 'sellerName' | 'batchNumber' | 'palletNumber' | 'exporterCode' | 'mark' | 'inventoryCode' | 'packingWeek' | 'voyageNumber' | 'extendedFields' | 'totalCartons' | 'totalStdCartons' | 'totalKilograms' | 'cgCount' | 'palletCount' | 'shippingWeek' | 'arrivalWeek' | 'dischargePort' | 'vesselName' | 'incoterm' | 'contractCurrency' | 'paymentAdviceNumber' | 'poNumber' | 'allOnStatement' | 'paymentAdviceDownloadUrl' | 'revenue' | 'cifCosts' | 'netCif' | 'fobCosts' | 'netFob' | 'dipCosts' | 'netDip' | 'exwCosts' | 'netExw' | 'growerFinalPayment' | 'overseasCosts' | 'localCosts' | 'revenueAdvance' | 'revenueFinal' | 'revenueCreditNote' | 'revenueDebitNote' | 'revenuePerCarton' | 'revenuePerStdCarton' | 'revenuePerKg' | 'netCifPerCarton' | 'netCifPerStdCarton' | 'netFobPerCarton' | 'netFobPerStdCarton' | 'netDipPerCarton' | 'netDipPerStdCarton' | 'netExwPerCarton' | 'netExwPerStdCarton' | 'cashReceived' | 'accountsReceivable' | 'cashReceivedPerCarton' | 'cashReceivedPerStdCarton' | 'revenueInclVat' | 'cifCostsInclVat' | 'fobCostsInclVat' | 'dipCostsInclVat' | 'exwCostsInclVat' | 'netCifInclVat' | 'netFobInclVat' | 'netDipInclVat' | 'netExwInclVat' | 'overseasCostsInclVat' | 'localCostsInclVat' | 'vatTotalRevenue' | 'vatTotalCosts' | 'revenueInclVatPerCarton' | 'revenueInclVatPerStdCarton' | 'revenueInclVatPerKg' | 'netCifInclVatPerCarton' | 'netCifInclVatPerStdCarton' | 'netFobInclVatPerCarton' | 'netFobInclVatPerStdCarton' | 'netDipInclVatPerCarton' | 'netDipInclVatPerStdCarton' | 'netExwInclVatPerCarton' | 'netExwInclVatPerStdCarton' | 'costBreakdown' | 'linkedRecordsCount' | 'linkedCgIds' | 'linkedContainerIds' | 'linkedBbcIds'>
  )>>, pageInfo?: Maybe<(
    { __typename?: 'ProfitAndLossPageInfo' }
    & Pick<ProfitAndLossPageInfo, 'hasNextPage'>
  )>, meta?: Maybe<(
    { __typename?: 'ProfitAndLossMeta' }
    & Pick<ProfitAndLossMeta, 'rowCount' | 'sqlMs' | 'totalMs' | 'reportingCurrency' | 'extendedFieldKeys'>
    & { costCategories?: Maybe<Array<(
      { __typename?: 'ProfitAndLossCostCategory' }
      & Pick<ProfitAndLossCostCategory, 'key' | 'label' | 'section'>
    )>> }
  )> }
);

export type QueueProfitAndLossReportMutationVariables = Exact<{
  requestId: Scalars['String'];
  filters: ProfitAndLossFilters;
}>;


export type QueueProfitAndLossReportMutation = (
  { __typename?: 'Mutation' }
  & { queueProfitAndLossReport: (
    { __typename: 'ProfitAndLossReportPending' }
    & Pick<ProfitAndLossReportPending, 'requestId'>
  ) }
);

export type ProfitAndLossReportOutcomeQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type ProfitAndLossReportOutcomeQuery = (
  { __typename?: 'Query' }
  & { profitAndLossReportOutcome: (
    { __typename: 'ProfitAndLossReportCompleted' }
    & Pick<ProfitAndLossReportCompleted, 'requestId'>
    & { report: (
      { __typename?: 'ProfitAndLossReport' }
      & ProfitAndLossReportFieldsFragment
    ) }
  ) | (
    { __typename: 'ProfitAndLossReportError' }
    & Pick<ProfitAndLossReportError, 'requestId' | 'error'>
  ) | (
    { __typename: 'ProfitAndLossReportNotFound' }
    & Pick<ProfitAndLossReportNotFound, 'requestId'>
  ) | (
    { __typename: 'ProfitAndLossReportPending' }
    & Pick<ProfitAndLossReportPending, 'requestId'>
  ) }
);

export type OnProfitAndLossReportCompleteSubscriptionVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type OnProfitAndLossReportCompleteSubscription = (
  { __typename?: 'Subscription' }
  & { onProfitAndLossReportComplete: (
    { __typename: 'ProfitAndLossReportCompleted' }
    & Pick<ProfitAndLossReportCompleted, 'requestId'>
    & { report: (
      { __typename?: 'ProfitAndLossReport' }
      & ProfitAndLossReportFieldsFragment
    ) }
  ) | (
    { __typename: 'ProfitAndLossReportError' }
    & Pick<ProfitAndLossReportError, 'requestId' | 'error'>
  ) | (
    { __typename: 'ProfitAndLossReportNotFound' }
    & Pick<ProfitAndLossReportNotFound, 'requestId'>
  ) | (
    { __typename: 'ProfitAndLossReportPending' }
    & Pick<ProfitAndLossReportPending, 'requestId'>
  ) }
);

export type ProfitAndLossFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfitAndLossFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { profitAndLossFilterAttributes?: Maybe<(
    { __typename?: 'ProfitAndLossFilterAttributes' }
    & Pick<ProfitAndLossFilterAttributes, 'farmCodes' | 'grades' | 'targetRegions' | 'targetMarkets' | 'targetCountries' | 'packTypes' | 'sizeCounts' | 'marks' | 'exporterCodes' | 'inventoryCodes' | 'poNumbers'>
    & { extendedFieldKeys?: Maybe<Array<(
      { __typename?: 'ProfitAndLossExtendedFieldKey' }
      & Pick<ProfitAndLossExtendedFieldKey, 'key' | 'label' | 'values'>
    )>>, containers?: Maybe<Array<(
      { __typename?: 'IdName' }
      & Pick<IdName, 'id' | 'name'>
    )>>, vessels?: Maybe<Array<(
      { __typename?: 'IdName' }
      & Pick<IdName, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'IdName' }
      & Pick<IdName, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'IdName' }
      & Pick<IdName, 'id' | 'name'>
    )>>, buyers?: Maybe<Array<(
      { __typename?: 'IdName' }
      & Pick<IdName, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'IdName' }
      & Pick<IdName, 'id' | 'name'>
    )>>, financialYearOptions?: Maybe<Array<(
      { __typename?: 'FinancialYearOption' }
      & Pick<FinancialYearOption, 'year' | 'label' | 'startDate' | 'endDate'>
    )>> }
  )> }
);

export type RunReportQueryVariables = Exact<{
  reportId: Scalars['Int'];
  gridRequest?: Maybe<GridRequest>;
  reportFilters?: Maybe<Array<Filter> | Filter>;
  outputType?: Maybe<RunReportOutputTypeEnum>;
}>;


export type RunReportQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'runReport'>
);

export type RunReportAsyncQueryVariables = Exact<{
  reportId: Scalars['Int'];
  gridRequest?: Maybe<GridRequest>;
  reportFilters?: Maybe<Array<Filter> | Filter>;
  requestUuid: Scalars['String'];
}>;


export type RunReportAsyncQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'runReportAsync'>
);

export type ReportQueryVariables = Exact<{
  reportId: Scalars['Int'];
}>;


export type ReportQuery = (
  { __typename?: 'Query' }
  & { report?: Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'createdAt' | 'dataPreparationId' | 'description' | 'id' | 'name' | 'updatedAt'>
    & { configs?: Maybe<Array<(
      { __typename?: 'Config' }
      & Pick<Config, 'name' | 'value'>
    )>> }
  )> }
);

export type ReportGroupsQueryVariables = Exact<{
  filterAttributes: ReportGroupFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
}>;


export type ReportGroupsQuery = (
  { __typename?: 'Query' }
  & { reportGroups?: Maybe<Array<(
    { __typename?: 'ReportGroup' }
    & Pick<ReportGroup, 'name' | 'description' | 'id' | 'domain' | 'scope'>
    & { badges?: Maybe<Array<(
      { __typename?: 'Badge' }
      & Pick<Badge, 'id' | 'text' | 'color'>
    )>> }
  )>> }
);

export type ReportGroupQueryVariables = Exact<{
  reportGroupId: Scalars['Int'];
}>;


export type ReportGroupQuery = (
  { __typename?: 'Query' }
  & { reportGroup?: Maybe<(
    { __typename?: 'ReportGroup' }
    & Pick<ReportGroup, 'id' | 'layout' | 'name' | 'description'>
    & { configs?: Maybe<Array<(
      { __typename?: 'Config' }
      & Pick<Config, 'name' | 'value'>
    )>>, reports?: Maybe<Array<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'reportType' | 'name'>
    )>>, switchUnit?: Maybe<(
      { __typename?: 'SwitchUnit' }
      & Pick<SwitchUnit, 'id' | 'name' | 'defaultValue'>
      & { switchUnitOptions?: Maybe<Array<(
        { __typename?: 'SwitchUnitOption' }
        & Pick<SwitchUnitOption, 'id' | 'label' | 'value' | 'sortOrder'>
      )>> }
    )> }
  )> }
);

export type FetchReportResultQueryVariables = Exact<{
  requestUuid: Scalars['String'];
}>;


export type FetchReportResultQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fetchReportResult'>
);

export type ReportGroupCycleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportGroupCycleQuery = (
  { __typename?: 'Query' }
  & { reportGroupCycle?: Maybe<(
    { __typename?: 'ReportGroupCycle' }
    & Pick<ReportGroupCycle, 'id' | 'name' | 'description' | 'durationSeconds'>
    & { items?: Maybe<Array<(
      { __typename?: 'ReportGroupCycleItem' }
      & Pick<ReportGroupCycleItem, 'id' | 'reportGroupId' | 'params'>
      & { reportGroup?: Maybe<(
        { __typename?: 'ReportGroup' }
        & Pick<ReportGroup, 'id' | 'name' | 'description'>
      )> }
    )>> }
  )> }
);

export type CreateReportGroupMutationVariables = Exact<{
  attributes: ReportGroupAttributes;
}>;


export type CreateReportGroupMutation = (
  { __typename?: 'Mutation' }
  & { createReportGroup?: Maybe<(
    { __typename?: 'CreateReportGroupPayload' }
    & Pick<CreateReportGroupPayload, 'errors'>
    & { reportGroup?: Maybe<(
      { __typename?: 'ReportGroup' }
      & Pick<ReportGroup, 'description' | 'id' | 'name'>
    )> }
  )> }
);

export type UpdateReportGroupMutationVariables = Exact<{
  attributes: ReportGroupAttributes;
}>;


export type UpdateReportGroupMutation = (
  { __typename?: 'Mutation' }
  & { updateReportGroup?: Maybe<(
    { __typename?: 'UpdateReportGroupPayload' }
    & Pick<UpdateReportGroupPayload, 'errors'>
    & { reportGroup?: Maybe<(
      { __typename?: 'ReportGroup' }
      & Pick<ReportGroup, 'description' | 'id' | 'name'>
    )> }
  )> }
);

export type DeleteReportGroupMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteReportGroupMutation = (
  { __typename?: 'Mutation' }
  & { deleteReportGroup?: Maybe<(
    { __typename?: 'DeleteReportGroupPayload' }
    & Pick<DeleteReportGroupPayload, 'success' | 'errors'>
  )> }
);

export type OnReportCompleteSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnReportCompleteSubscription = (
  { __typename?: 'Subscription' }
  & { onReportComplete: (
    { __typename?: 'Status' }
    & Pick<Status, 'requestUuid' | 'status'>
  ) }
);

export type OnRefreshReportSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnRefreshReportSubscription = (
  { __typename?: 'Subscription' }
  & { onRefreshReport: (
    { __typename?: 'MetabaseReport' }
    & Pick<MetabaseReport, 'chartSource' | 'description' | 'domain' | 'id' | 'name' | 'displayName' | 'scope' | 'url'>
    & { powerbiEmbedAttributes?: Maybe<(
      { __typename?: 'EmbeddedChart' }
      & Pick<EmbeddedChart, 'embedToken' | 'embedUrl' | 'reportId'>
    )> }
  ) }
);

export type QueueReportGroupOutputFileMutationVariables = Exact<{
  reportGroupId: Scalars['ID'];
  requestId: Scalars['String'];
  queryParams?: Maybe<Scalars['String']>;
}>;


export type QueueReportGroupOutputFileMutation = (
  { __typename?: 'Mutation' }
  & { queueReportGroupOutputFile?: Maybe<(
    { __typename?: 'QueueReportGroupOutputFilePayload' }
    & Pick<QueueReportGroupOutputFilePayload, 'requestId' | 'status' | 'errors'>
  )> }
);

export type OnReportOutputFileCompleteSubscriptionVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type OnReportOutputFileCompleteSubscription = (
  { __typename?: 'Subscription' }
  & { onReportOutputFileComplete: (
    { __typename?: 'ReportOutputFileStatus' }
    & Pick<ReportOutputFileStatus, 'requestId' | 'status' | 'pdfUrl' | 'error'>
  ) }
);

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = (
  { __typename?: 'Query' }
  & { myUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'phoneNumber' | 'email' | 'state' | 'notifyEmail' | 'notifyBrowserPush' | 'createdAt' | 'updatedAt' | 'useV2' | 'avatar' | 'role'>
    & { avatarFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'url'>
    )>, company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, roles?: Maybe<Array<(
      { __typename?: 'Role' }
      & Pick<Role, 'name'>
    )>> }
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['Int'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  phonenumber: Scalars['String'];
  notifyemail: Scalars['Boolean'];
  notifybrowserpush: Scalars['Boolean'];
  usev2: Scalars['Boolean'];
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'UpdateUserPayload' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'phoneNumber' | 'state' | 'notifyEmail' | 'notifyBrowserPush' | 'useV2'>
    )> }
  )> }
);

export type UpdateUserNotificationsMutationVariables = Exact<{
  id: Scalars['Int'];
  notifyEmail: Scalars['Boolean'];
  notifyBrowserPush: Scalars['Boolean'];
}>;


export type UpdateUserNotificationsMutation = (
  { __typename?: 'Mutation' }
  & { updateUserNotifications?: Maybe<(
    { __typename?: 'UpdateUserNotificationsPayload' }
    & Pick<UpdateUserNotificationsPayload, 'errors'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'notifyEmail' | 'notifyBrowserPush'>
    )> }
  )> }
);

export type UploadUserAvatarMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadUserAvatarMutation = (
  { __typename?: 'Mutation' }
  & { uploadUserAvatar?: Maybe<(
    { __typename?: 'UploadUserAvatarPayload' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & { avatarFile?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'url'>
      )> }
    )> }
  )> }
);

export type UpdateShipmentDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
  type: Scalars['String'];
}>;


export type UpdateShipmentDocumentMutation = (
  { __typename?: 'Mutation' }
  & { updateShipmentDocument?: Maybe<(
    { __typename?: 'UpdateShipmentDocumentPayload' }
    & { shipmentDocument?: Maybe<(
      { __typename?: 'ShipmentDocument' }
      & Pick<ShipmentDocument, 'id' | 'documentType' | 'state'>
      & { user?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
        & { company?: Maybe<(
          { __typename?: 'Company' }
          & Pick<Company, 'id'>
        )> }
      )>, file?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'v2Url'>
      )> }
    )> }
  )> }
);

export type DeleteShipmentDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteShipmentDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteShipmentDocument?: Maybe<(
    { __typename?: 'DeleteShipmentDocumentPayload' }
    & Pick<DeleteShipmentDocumentPayload, 'id'>
  )> }
);

export type CreateShipmentMutationVariables = Exact<{
  attributes: ShipmentAttributes;
}>;


export type CreateShipmentMutation = (
  { __typename?: 'Mutation' }
  & { createShipment?: Maybe<(
    { __typename?: 'CreateShipmentPayload' }
    & Pick<CreateShipmentPayload, 'errors'>
    & { shipment?: Maybe<(
      { __typename?: 'Shipment' }
      & ShipmentCommonFieldsFragment
    )> }
  )> }
);

export type UpdateShipmentMutationVariables = Exact<{
  attributes: ShipmentAttributes;
}>;


export type UpdateShipmentMutation = (
  { __typename?: 'Mutation' }
  & { updateShipment?: Maybe<(
    { __typename?: 'UpdateShipmentPayload' }
    & Pick<UpdateShipmentPayload, 'errors'>
    & { shipment?: Maybe<(
      { __typename?: 'Shipment' }
      & ShipmentCommonFieldsFragment
    )> }
  )> }
);

export type CreateShipmentLineItemMutationVariables = Exact<{
  attributes: ShipmentLineItemAttributes;
}>;


export type CreateShipmentLineItemMutation = (
  { __typename?: 'Mutation' }
  & { createShipmentLineItem?: Maybe<(
    { __typename?: 'CreateShipmentLineItemPayload' }
    & Pick<CreateShipmentLineItemPayload, 'errors'>
    & { shipmentLineItem?: Maybe<(
      { __typename?: 'ShipmentLineItem' }
      & SliCommonFieldsFragment
    )> }
  )> }
);

export type DuplicateShipmentLineItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateShipmentLineItemMutation = (
  { __typename?: 'Mutation' }
  & { duplicateShipmentLineItem?: Maybe<(
    { __typename?: 'DuplicateShipmentLineItemPayload' }
    & { shipmentLineItems?: Maybe<Array<(
      { __typename?: 'ShipmentLineItem' }
      & SliCommonFieldsFragment
    )>> }
  )> }
);

export type UpdateShipmentLineItemMutationVariables = Exact<{
  attributes: ShipmentLineItemAttributes;
}>;


export type UpdateShipmentLineItemMutation = (
  { __typename?: 'Mutation' }
  & { updateShipmentLineItem?: Maybe<(
    { __typename?: 'UpdateShipmentLineItemPayload' }
    & Pick<UpdateShipmentLineItemPayload, 'errors'>
    & { shipmentLineItem?: Maybe<(
      { __typename?: 'ShipmentLineItem' }
      & SliCommonFieldsFragment
    )> }
  )> }
);

export type CreateExportNotificationBookingMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CreateExportNotificationBookingMutation = (
  { __typename?: 'Mutation' }
  & { createExportNotificationBooking?: Maybe<(
    { __typename?: 'CreateExportNotificationBookingPayload' }
    & Pick<CreateExportNotificationBookingPayload, 'errors'>
  )> }
);

export type CreateExportNotificationLineItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CreateExportNotificationLineItemMutation = (
  { __typename?: 'Mutation' }
  & { createExportNotificationLineItem?: Maybe<(
    { __typename?: 'CreateExportNotificationLineItemPayload' }
    & Pick<CreateExportNotificationLineItemPayload, 'errors'>
  )> }
);

export type UpdateAddendumMutationVariables = Exact<{
  addendumLineItems: Array<AddendumLineItemAttributes> | AddendumLineItemAttributes;
  addendumHeader: AddendumHeaderAttributes;
}>;


export type UpdateAddendumMutation = (
  { __typename?: 'Mutation' }
  & { updateAddendum?: Maybe<(
    { __typename?: 'UpdateAddendumPayload' }
    & Pick<UpdateAddendumPayload, 'errors'>
  )> }
);

export type GenerateAddendumMutationVariables = Exact<{
  sliIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  bookingReference?: Maybe<Scalars['String']>;
  shipmentId?: Maybe<Scalars['ID']>;
}>;


export type GenerateAddendumMutation = (
  { __typename?: 'Mutation' }
  & { generateAddendum?: Maybe<(
    { __typename?: 'GenerateAddendumPayload' }
    & Pick<GenerateAddendumPayload, 'errors'>
    & { addendumHeader?: Maybe<(
      { __typename?: 'AddendumHeader' }
      & { addendumLineItems?: Maybe<Array<(
        { __typename?: 'AddendumLineItem' }
        & AddendumLineItemFieldsFragment
      )>> }
      & AddendumHeaderFieldsFragment
    )> }
  )> }
);

export type CancelAddendumMutationVariables = Exact<{
  id: Scalars['Int'];
  deleteAddendum: Scalars['Boolean'];
}>;


export type CancelAddendumMutation = (
  { __typename?: 'Mutation' }
  & { cancelAddendum?: Maybe<(
    { __typename?: 'CancelAddendumPayload' }
    & Pick<CancelAddendumPayload, 'id' | 'message'>
  )> }
);

export type ConfirmExportNotificationLineItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ConfirmExportNotificationLineItemMutation = (
  { __typename?: 'Mutation' }
  & { confirmExportNotificationLineItem?: Maybe<(
    { __typename?: 'ConfirmExportNotificationLineItemPayload' }
    & Pick<ConfirmExportNotificationLineItemPayload, 'errors'>
    & { shipment?: Maybe<(
      { __typename?: 'Shipment' }
      & { portOfLoading?: Maybe<(
        { __typename?: 'SeaPort' }
        & Pick<SeaPort, 'id' | 'name' | 'unLocode'>
      )>, shipmentLineItems?: Maybe<Array<(
        { __typename?: 'ShipmentLineItem' }
        & SliCommonFieldsFragment
      )>> }
      & ShipmentCommonFieldsFragment
    )> }
  )> }
);

export type CompleteShipmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompleteShipmentMutation = (
  { __typename?: 'Mutation' }
  & { completeShipment?: Maybe<(
    { __typename?: 'CompleteShipmentPayload' }
    & Pick<CompleteShipmentPayload, 'errors'>
  )> }
);

export type CompleteShipmentLineItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompleteShipmentLineItemMutation = (
  { __typename?: 'Mutation' }
  & { completeShipmentLineItem?: Maybe<(
    { __typename?: 'CompleteShipmentLineItemPayload' }
    & Pick<CompleteShipmentLineItemPayload, 'errors'>
  )> }
);

export type SubmitAddendumMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SubmitAddendumMutation = (
  { __typename?: 'Mutation' }
  & { submitAddendum?: Maybe<(
    { __typename?: 'SubmitAddendumPayload' }
    & Pick<SubmitAddendumPayload, 'errors' | 'validation'>
    & { addendumHeader?: Maybe<(
      { __typename?: 'AddendumHeader' }
      & { addendumLineItems?: Maybe<Array<(
        { __typename?: 'AddendumLineItem' }
        & AddendumLineItemFieldsFragment
      )>> }
      & AddendumHeaderFieldsFragment
    )> }
  )> }
);

export type QueryAddendumMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type QueryAddendumMutation = (
  { __typename?: 'Mutation' }
  & { queryAddendum?: Maybe<(
    { __typename?: 'QueryAddendumPayload' }
    & Pick<QueryAddendumPayload, 'errors'>
  )> }
);

export type AllocateSliContainerMutationVariables = Exact<{
  sliId: Scalars['Int'];
  sliContainerId?: Maybe<Scalars['Int']>;
  isBreakBulk: Scalars['Boolean'];
}>;


export type AllocateSliContainerMutation = (
  { __typename?: 'Mutation' }
  & { allocateSliContainer?: Maybe<(
    { __typename?: 'AllocateSliContainerPayload' }
    & Pick<AllocateSliContainerPayload, 'errors'>
  )> }
);

export type DeleteShipmentLineItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteShipmentLineItemMutation = (
  { __typename?: 'Mutation' }
  & { deleteShipmentLineItem?: Maybe<(
    { __typename?: 'DeleteShipmentLineItemPayload' }
    & Pick<DeleteShipmentLineItemPayload, 'id' | 'errors'>
  )> }
);

export type DeleteAddendumLineItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAddendumLineItemMutation = (
  { __typename?: 'Mutation' }
  & { deleteAddendumLineItem?: Maybe<(
    { __typename?: 'DeleteAddendumLineItemPayload' }
    & Pick<DeleteAddendumLineItemPayload, 'errors'>
    & { addendumLineItems?: Maybe<Array<(
      { __typename?: 'AddendumLineItem' }
      & AddendumLineItemFieldsFragment
    )>> }
  )> }
);

export type DuplicateAddendumLineItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DuplicateAddendumLineItemMutation = (
  { __typename?: 'Mutation' }
  & { duplicateAddendumLineItem?: Maybe<(
    { __typename?: 'DuplicateAddendumLineItemPayload' }
    & { addendumLineItems?: Maybe<Array<(
      { __typename?: 'AddendumLineItem' }
      & AddendumLineItemFieldsFragment
    )>> }
  )> }
);

export type DeleteExportDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteExportDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteExportDocument?: Maybe<(
    { __typename?: 'DeleteExportDocumentPayload' }
    & Pick<DeleteExportDocumentPayload, 'id'>
  )> }
);

export type UploadExportDocumentMutationVariables = Exact<{
  attributes: ShipmentLineItemAttributes;
  file: Scalars['Upload'];
}>;


export type UploadExportDocumentMutation = (
  { __typename?: 'Mutation' }
  & { uploadExportDocument?: Maybe<(
    { __typename?: 'UploadExportDocumentPayload' }
    & Pick<UploadExportDocumentPayload, 'errors'>
    & { shipmentLineItem?: Maybe<(
      { __typename?: 'ShipmentLineItem' }
      & { exportDocuments?: Maybe<Array<(
        { __typename?: 'ExportDocument' }
        & ExportDocumentFieldsFragment
      )>> }
    )> }
  )> }
);

export type UpdateExportDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
  type: Scalars['String'];
}>;


export type UpdateExportDocumentMutation = (
  { __typename?: 'Mutation' }
  & { updateExportDocument?: Maybe<(
    { __typename?: 'UpdateExportDocumentPayload' }
    & { exportDocument?: Maybe<(
      { __typename?: 'ExportDocument' }
      & Pick<ExportDocument, 'id' | 'documentType'>
      & { user?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName'>
        & { company?: Maybe<(
          { __typename?: 'Company' }
          & Pick<Company, 'id'>
        )> }
      )>, file?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'v2Url'>
      )> }
    )> }
  )> }
);

export type ExportDocumentFieldsFragment = (
  { __typename?: 'ExportDocument' }
  & Pick<ExportDocument, 'id' | 'documentType'>
  & { file?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'filename' | 'v2Url'>
  )> }
);

export type ShipmentCommonFieldsFragment = (
  { __typename?: 'Shipment' }
  & Pick<Shipment, 'id' | 'shipmentType' | 'ppecbBookingReference' | 'shippingLine' | 'voyageNumber' | 'shippingLineVoyageNumber' | 'loadPort' | 'billToParty' | 'exporterCode' | 'cfCode' | 'ppecbRegisteredExporterCode' | 'ppecbRegisteredAgentCode' | 'phoneNumber' | 'userName' | 'dateCreated' | 'vesselOriginalEstimatedDateOfDeparture' | 'stackDates' | 'stackDatesClose' | 'stackDatesOpenStatus' | 'stackDatesCloseStatus' | 'shipper' | 'status' | 'vesselName' | 'vesselCode' | 'ppecbVoyageNumber' | 'controller' | 'client' | 'comments' | 'estimatedTimeOfDeparture' | 'actualTimeOfDeparture' | 'exportNotificationError'>
);

export type SliCommonFieldsFragment = (
  { __typename?: 'ShipmentLineItem' }
  & Pick<ShipmentLineItem, 'id' | 'ppecbBookingReference' | 'ppecbBookingItemReference' | 'shippingLineReference' | 'customerReference' | 'truckReference' | 'orderReference' | 'loadDate' | 'consignmentReference' | 'regimeCode' | 'finalCountryOfDestination' | 'importPermitNumber' | 'exporterOnCertificate' | 'isGensetRequired' | 'isTranshipment' | 'isColdTreatment' | 'transhipmentVesselName' | 'transhipmentVoyageNumber' | 'transhipmentPort' | 'finalPortOfDischarge' | 'tempSensor' | 'userName' | 'dateCreated' | 'isConventionalShipping' | 'depot' | 'collectionDate' | 'loadingInstructionNumber' | 'haulageType' | 'transporter' | 'receiver' | 'cargoVgm' | 'solas' | 'tempDevice' | 'estimatedTimeOfDeparture' | 'actualTimeOfDeparture' | 'estimatedTimeOfArrival' | 'actualTimeOfArrival' | 'containerAndSealNumber' | 'paymentTerms' | 'shippingLineContactNumber' | 'humidity' | 'voidPlugs' | 'ventSetting' | 'protocolTemperature' | 'protocolDays' | 'specialInstruction' | 'status' | 'productCodes' | 'containerNumber' | 'sealNumber' | 'nettWeight' | 'grossWeight' | 'state' | 'comments' | 'consignee' | 'fruitOriginCode' | 'fruitOriginName' | 'radiation' | 'fumigation' | 'treatmentType' | 'serviceContractNumber' | 'totalCartons' | 'exportNotificationError' | 'tareWeight' | 'clientReference' | 'shipmentLineItemGroupingId'>
  & { loadingPoints?: Maybe<Array<(
    { __typename?: 'LoadingPoint' }
    & Pick<LoadingPoint, 'activityPointCode' | 'loadingDate' | 'quantity' | 'containerType' | 'unitOfMeasure'>
  )>>, portOfDestination?: Maybe<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'unLocode'>
  )>, portOfDischarge?: Maybe<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'unLocode'>
  )>, emptyDepot?: Maybe<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'producerName' | 'name' | 'fboCode'>
  )>, exportDocuments?: Maybe<Array<(
    { __typename?: 'ExportDocument' }
    & ExportDocumentFieldsFragment
  )>>, certificateTransportInstruction?: Maybe<(
    { __typename?: 'CertificateTransportInstruction' }
    & Pick<CertificateTransportInstruction, 'id'>
    & { templateOutput?: Maybe<(
      { __typename?: 'TemplateOutput' }
      & Pick<TemplateOutput, 'state'>
      & TemplateOutputFieldsFragment
    )> }
  )>, tasks?: Maybe<Array<(
    { __typename?: 'TaskableTask' }
    & Pick<TaskableTask, 'id' | 'index' | 'taskLevel' | 'uploadedAt' | 'customDate' | 'hasDocument' | 'platformTask' | 'title' | 'documentId'>
    & { file?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'v2Url'>
    )>, templateOutput?: Maybe<(
      { __typename?: 'TemplateOutput' }
      & { outputFiles?: Maybe<Array<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'v2Url'>
      )>> }
    )> }
  )>>, checklist?: Maybe<(
    { __typename?: 'TaskableChecklist' }
    & Pick<TaskableChecklist, 'emailSubject' | 'title'>
  )> }
);

export type IndexShipmentLineItemFieldssFragment = (
  { __typename?: 'ShipmentLineItem' }
  & Pick<ShipmentLineItem, 'id' | 'shipmentType' | 'containerNumber' | 'sealNumber' | 'grossWeight' | 'nettWeight' | 'comments' | 'shippingLineReference' | 'customerReference' | 'consignee' | 'serviceContractNumber' | 'clientReference' | 'voyageNumber' | 'finalPortOfDischarge' | 'state' | 'status' | 'totalCartons' | 'productCodes' | 'estimatedTimeOfDeparture' | 'actualTimeOfDeparture' | 'estimatedTimeOfArrival' | 'actualTimeOfArrival' | 'createdAt'>
  & { portOfDestination?: Maybe<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'name' | 'unLocode'>
  )>, portOfDischarge?: Maybe<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'name' | 'unLocode'>
  )>, shipment?: Maybe<(
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id' | 'controller' | 'client' | 'vesselName' | 'stackDates' | 'stackDatesClose' | 'stackDatesOpenStatus' | 'stackDatesCloseStatus' | 'estimatedTimeOfDeparture' | 'actualTimeOfDeparture' | 'estimatedTimeOfArrival' | 'actualTimeOfArrival' | 'shipmentType'>
    & { portOfLoading?: Maybe<(
      { __typename?: 'SeaPort' }
      & Pick<SeaPort, 'name'>
    )> }
  )>, sliContainer?: Maybe<(
    { __typename?: 'SliContainer' }
    & Pick<SliContainer, 'id'>
    & { container?: Maybe<(
      { __typename?: 'Container' }
      & Pick<Container, 'containerNumber' | 'containerSize' | 'containerType'>
      & { cartonGroupings?: Maybe<Array<(
        { __typename?: 'CartonGrouping' }
        & { commodity?: Maybe<(
          { __typename?: 'Commodity' }
          & Pick<Commodity, 'name'>
        )> }
      )>> }
    )> }
  )>, sliBreakBulk?: Maybe<(
    { __typename?: 'SliBreakBulk' }
    & Pick<SliBreakBulk, 'id'>
    & { breakBulkContainer?: Maybe<(
      { __typename?: 'BreakBulkContainer' }
      & Pick<BreakBulkContainer, 'name'>
    )> }
  )>, tasks?: Maybe<Array<(
    { __typename?: 'TaskableTask' }
    & Pick<TaskableTask, 'id' | 'index' | 'taskLevel' | 'documentId' | 'uploadedAt' | 'customDate' | 'hasDocument' | 'platformTask' | 'title'>
    & { file?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'v2Url'>
    )>, templateOutput?: Maybe<(
      { __typename?: 'TemplateOutput' }
      & { outputFiles?: Maybe<Array<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'v2Url'>
      )>> }
    )> }
  )>>, checklist?: Maybe<(
    { __typename?: 'TaskableChecklist' }
    & Pick<TaskableChecklist, 'emailSubject' | 'title'>
  )> }
);

export type AddendumHeaderFieldsFragment = (
  { __typename?: 'AddendumHeader' }
  & Pick<AddendumHeader, 'id' | 'requestId' | 'exporterCode' | 'cfCode' | 'lspCode' | 'transportType' | 'vesselName' | 'vesselType' | 'voyageNumber' | 'regimeCode' | 'shippingBookingReference' | 'loadPort' | 'dischargePort' | 'shippedTargetCountry' | 'shippedTargetRegion' | 'locationOfIssue' | 'estimatedDepartureDate' | 'eCertAgreementCode' | 'verificationStatus' | 'addendumStatus' | 'ecertStatus' | 'transactionId' | 'errorReason' | 'state'>
);

export type AddendumLineItemFieldsFragment = (
  { __typename?: 'AddendumLineItem' }
  & Pick<AddendumLineItem, 'id' | 'stuffLoadDate' | 'loadPointFboCode' | 'consignmentNumber' | 'phc' | 'inspectedSscc' | 'clientRef' | 'upn' | 'inspectedTargetRegion' | 'inspectedTargetCountry' | 'commodityCode' | 'varietyCode' | 'productClass' | 'nettWeight' | 'grossWeight' | 'ssccNettWeight' | 'ssccGrossWeight' | 'cartonQuantity' | 'inspectionPoint' | 'inspectorCode' | 'inspectionDate' | 'inspectionManifestNumber' | 'containerNumber' | 'sequenceNumberOfInspectedSscc' | 'puc' | 'orchard' | 'productionArea' | 'phytoData' | 'sizeCountBerrySize' | 'packCode' | 'palletQuantity'>
);

export type ShipmentLineItemFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentLineItemFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { shipmentLineItemFilterAttributes?: Maybe<(
    { __typename?: 'ShipmentLineItemFilterAttribute' }
    & Pick<ShipmentLineItemFilterAttribute, 'controllers' | 'shippingLineReferences' | 'clients' | 'vessels' | 'states' | 'stackDatesStatus' | 'shipmentTypes'>
  )> }
);

export type ShipmentPpecbVoyageNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbVoyageNumbersQuery = (
  { __typename?: 'Query' }
  & { ppecbVoyageNumbers?: Maybe<Array<(
    { __typename?: 'PpecbVoyageNumber' }
    & Pick<PpecbVoyageNumber, 'id' | 'voyageNumber' | 'vesselName' | 'ppecbVoyageNumber'>
  )>> }
);

export type ShipmentPpecbCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbCountriesQuery = (
  { __typename?: 'Query' }
  & { ppecbCountries?: Maybe<Array<(
    { __typename?: 'PpecbCountry' }
    & Pick<PpecbCountry, 'code' | 'name'>
  )>> }
);

export type ShipmentPpecbActivityPointsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbActivityPointsQuery = (
  { __typename?: 'Query' }
  & { ppecbActivityPoints?: Maybe<Array<(
    { __typename?: 'PpecbActivityPoint' }
    & Pick<PpecbActivityPoint, 'code' | 'name'>
  )>> }
);

export type ShipmentPpecbWorldPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbWorldPortsQuery = (
  { __typename?: 'Query' }
  & { ppecbWorldPorts?: Maybe<Array<(
    { __typename?: 'PpecbWorldPort' }
    & Pick<PpecbWorldPort, 'id' | 'portCode' | 'portName'>
  )>> }
);

export type ShipmentPpecbContainerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbContainerTypesQuery = (
  { __typename?: 'Query' }
  & { ppecbContainerTypes?: Maybe<Array<(
    { __typename?: 'PpecbContainerType' }
    & Pick<PpecbContainerType, 'description'>
  )>> }
);

export type ShipmentPpecbProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbProductsQuery = (
  { __typename?: 'Query' }
  & { ppecbProducts?: Maybe<Array<(
    { __typename?: 'PpecbProduct' }
    & Pick<PpecbProduct, 'code' | 'name'>
  )>> }
);

export type ShipmentPpecbVentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbVentsQuery = (
  { __typename?: 'Query' }
  & { ppecbVents?: Maybe<Array<(
    { __typename?: 'PpecbVent' }
    & Pick<PpecbVent, 'code' | 'description'>
  )>> }
);

export type ShipmentPpecbRegimeCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbRegimeCodesQuery = (
  { __typename?: 'Query' }
  & { ppecbRegimeCodes?: Maybe<Array<(
    { __typename?: 'PpecbRegimeCode' }
    & Pick<PpecbRegimeCode, 'regimeCode'>
  )>> }
);

export type ShipmentPpecbPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbPortsQuery = (
  { __typename?: 'Query' }
  & { ppecbPorts?: Maybe<Array<(
    { __typename?: 'PpecbPort' }
    & Pick<PpecbPort, 'id' | 'portCode' | 'portName'>
  )>> }
);

export type ShipmentTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentTerminalsQuery = (
  { __typename?: 'Query' }
  & { terminals?: Maybe<Array<(
    { __typename?: 'Terminal' }
    & Pick<Terminal, 'id' | 'name' | 'code'>
  )>> }
);

export type SliContainersQueryVariables = Exact<{ [key: string]: never; }>;


export type SliContainersQuery = (
  { __typename?: 'Query' }
  & { sliContainers?: Maybe<Array<(
    { __typename?: 'SliContainer' }
    & Pick<SliContainer, 'id'>
    & { container?: Maybe<(
      { __typename?: 'Container' }
      & Pick<Container, 'id' | 'containerNumber'>
    )> }
  )>> }
);

export type SliBreakBulksQueryVariables = Exact<{ [key: string]: never; }>;


export type SliBreakBulksQuery = (
  { __typename?: 'Query' }
  & { sliBreakBulks?: Maybe<Array<(
    { __typename?: 'SliBreakBulk' }
    & Pick<SliBreakBulk, 'id'>
    & { breakBulkContainer?: Maybe<(
      { __typename?: 'BreakBulkContainer' }
      & Pick<BreakBulkContainer, 'id' | 'name'>
    )> }
  )>> }
);

export type SeaShipmentControllersQueryVariables = Exact<{ [key: string]: never; }>;


export type SeaShipmentControllersQuery = (
  { __typename?: 'Query' }
  & { seaShipmentControllers?: Maybe<Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  )>> }
);

export type AllocateShipmentControllerMutationVariables = Exact<{
  shipmentId: Scalars['Int'];
  userId?: Maybe<Scalars['Int']>;
}>;


export type AllocateShipmentControllerMutation = (
  { __typename?: 'Mutation' }
  & { allocateShipmentController?: Maybe<(
    { __typename?: 'AllocateShipmentControllerPayload' }
    & Pick<AllocateShipmentControllerPayload, 'errors'>
  )> }
);

export type ShipmentContainerDepotsQueryVariables = Exact<{
  typeOfBusiness: Scalars['Int'];
}>;


export type ShipmentContainerDepotsQuery = (
  { __typename?: 'Query' }
  & { foodBusinessOperatorsByType?: Maybe<Array<(
    { __typename?: 'FoodBusinessOperator' }
    & Pick<FoodBusinessOperator, 'id' | 'name' | 'producerName' | 'fboCode'>
  )>> }
);

export type AddendumHeaderByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AddendumHeaderByIdQuery = (
  { __typename?: 'Query' }
  & { addendumHeaderById?: Maybe<(
    { __typename?: 'AddendumHeader' }
    & { addendumLineItems?: Maybe<Array<(
      { __typename?: 'AddendumLineItem' }
      & AddendumLineItemFieldsFragment
    )>> }
    & AddendumHeaderFieldsFragment
  )> }
);

export type AddendumLineItemsByHeaderIdQueryVariables = Exact<{
  addendumHeaderId: Scalars['Int'];
}>;


export type AddendumLineItemsByHeaderIdQuery = (
  { __typename?: 'Query' }
  & { addendumLineItemsByHeaderId?: Maybe<Array<(
    { __typename?: 'AddendumLineItem' }
    & AddendumLineItemFieldsFragment
  )>> }
);

export type AddendumsOnShipmentQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
}>;


export type AddendumsOnShipmentQuery = (
  { __typename?: 'Query' }
  & { addendumsOnShipment?: Maybe<Array<(
    { __typename?: 'AddendumHeader' }
    & Pick<AddendumHeader, 'id' | 'shippingBookingReference' | 'verificationStatus' | 'state' | 'addendumStatus'>
  )>> }
);

export type NonAddendumShipmentLineItemsQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
  bookingRef?: Maybe<Scalars['String']>;
}>;


export type NonAddendumShipmentLineItemsQuery = (
  { __typename?: 'Query' }
  & { nonAddendumShipmentLineItems?: Maybe<Array<(
    { __typename?: 'ShipmentLineItem' }
    & Pick<ShipmentLineItem, 'id' | 'containerNumber' | 'breakBulkContainerNamesIn' | 'customerReference' | 'shippingLineReference'>
  )>> }
);

export type SliContainersByBookingReferenceQueryVariables = Exact<{
  bookingReference: Scalars['String'];
}>;


export type SliContainersByBookingReferenceQuery = (
  { __typename?: 'Query' }
  & { sliContainersByBookingReference?: Maybe<Array<(
    { __typename?: 'SliContainer' }
    & Pick<SliContainer, 'id'>
    & { container?: Maybe<(
      { __typename?: 'Container' }
      & Pick<Container, 'containerNumber'>
    )> }
  )>> }
);

export type ShipmentLineItemsQueryVariables = Exact<{
  filterAttributes: ShipmentLineItemFilterAttributes;
  searchAttributes: SearchAttributes;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ShipmentLineItemsQuery = (
  { __typename?: 'Query' }
  & { shipmentLineItems?: Maybe<(
    { __typename?: 'ShipmentLineItemConnection' }
    & Pick<ShipmentLineItemConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'ShipmentLineItem' }
      & IndexShipmentLineItemFieldssFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type ShipmentLineItemsByShipmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentLineItemsByShipmentQuery = (
  { __typename?: 'Query' }
  & { shipmentLineItemsByShipment?: Maybe<Array<(
    { __typename?: 'ShipmentLineItem' }
    & Pick<ShipmentLineItem, 'hasLoadOutInstruction'>
    & SliCommonFieldsFragment
  )>> }
);

export type ShipmentLineItemGroupingsByShipmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShipmentLineItemGroupingsByShipmentQuery = (
  { __typename?: 'Query' }
  & { shipmentLineItemGroupingsByShipment?: Maybe<Array<(
    { __typename?: 'ShipmentLineItemGrouping' }
    & Pick<ShipmentLineItemGrouping, 'companyId' | 'id' | 'shipmentId' | 'sligFields' | 'totalCartons' | 'totalGrossWeight' | 'totalNettWeight' | 'updatedAt' | 'createdAt'>
  )>> }
);

export type ShipmentLineItemsBySligQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShipmentLineItemsBySligQuery = (
  { __typename?: 'Query' }
  & { shipmentLineItemsBySlig?: Maybe<Array<(
    { __typename?: 'ShipmentLineItem' }
    & { sliContainer?: Maybe<(
      { __typename?: 'SliContainer' }
      & Pick<SliContainer, 'id'>
    )> }
    & SliCommonFieldsFragment
  )>> }
);

export type ReassignShipmentLineItemGroupingMutationVariables = Exact<{
  id: Scalars['ID'];
  sligId: Scalars['ID'];
}>;


export type ReassignShipmentLineItemGroupingMutation = (
  { __typename?: 'Mutation' }
  & { reassignShipmentLineItemGrouping?: Maybe<(
    { __typename?: 'ReassignShipmentLineItemGroupingPayload' }
    & Pick<ReassignShipmentLineItemGroupingPayload, 'errors'>
  )> }
);

export type ShipmentBookingReferencesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentBookingReferencesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'shipmentBookingReferences'>
);

export type PpecbUserByUserIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PpecbUserByUserIdQuery = (
  { __typename?: 'Query' }
  & { ppecbUserByUserId?: Maybe<(
    { __typename?: 'PpecbUser' }
    & Pick<PpecbUser, 'id' | 'agentFboCode' | 'ppecbRegisteredAgentCode'>
    & { ppecbExporters?: Maybe<Array<(
      { __typename?: 'PpecbExporter' }
      & Pick<PpecbExporter, 'id' | 'exporterFboCode' | 'ppecbRegisteredExporterCode'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name'>
      )> }
    )>>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  )> }
);

export type PpecbExporterByShipmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PpecbExporterByShipmentQuery = (
  { __typename?: 'Query' }
  & { ppecbExporterByShipment?: Maybe<(
    { __typename?: 'PpecbExporter' }
    & Pick<PpecbExporter, 'id' | 'exporterFboCode' | 'ppecbRegisteredExporterCode'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'name'>
    )> }
  )> }
);

export type CurrentShipmentClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentShipmentClientsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'currentShipmentClients'>
);

export type CurrentShipmentControllersQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentShipmentControllersQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'currentShipmentControllers'>
);

export type CurrentTruckReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTruckReferencesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'currentTruckReferences'>
);

export type CurrentTransportCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTransportCompaniesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'currentTransportCompanies'>
);

export type PpecbUserByShipmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PpecbUserByShipmentQuery = (
  { __typename?: 'Query' }
  & { ppecbUserByShipment?: Maybe<(
    { __typename?: 'PpecbUser' }
    & Pick<PpecbUser, 'id' | 'agentFboCode' | 'ppecbRegisteredAgentCode'>
    & { ppecbExporters?: Maybe<Array<(
      { __typename?: 'PpecbExporter' }
      & Pick<PpecbExporter, 'id' | 'exporterFboCode' | 'ppecbRegisteredExporterCode'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name'>
      )> }
    )>>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  )> }
);

export type PpecbUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type PpecbUsersQuery = (
  { __typename?: 'Query' }
  & { ppecbUsers?: Maybe<Array<(
    { __typename?: 'PpecbUser' }
    & Pick<PpecbUser, 'id' | 'agentFboCode' | 'ppecbRegisteredAgentCode'>
    & { ppecbExporters?: Maybe<Array<(
      { __typename?: 'PpecbExporter' }
      & Pick<PpecbExporter, 'id' | 'exporterFboCode' | 'ppecbRegisteredExporterCode'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name'>
      )> }
    )>>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName'>
    )> }
  )>> }
);

export type ShipmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentQuery = (
  { __typename?: 'Query' }
  & { shipment?: Maybe<(
    { __typename?: 'Shipment' }
    & { portOfLoading?: Maybe<(
      { __typename?: 'SeaPort' }
      & Pick<SeaPort, 'id' | 'name' | 'unLocode'>
    )>, terminal?: Maybe<(
      { __typename?: 'Terminal' }
      & Pick<Terminal, 'id' | 'name' | 'code'>
    )>, shipmentLineItems?: Maybe<Array<(
      { __typename?: 'ShipmentLineItem' }
      & SliCommonFieldsFragment
    )>>, templateOutput?: Maybe<(
      { __typename?: 'TemplateOutput' }
      & Pick<TemplateOutput, 'state'>
      & TemplateOutputFieldsFragment
    )> }
    & ShipmentCommonFieldsFragment
  )> }
);

export type ShipmentLineItemQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentLineItemQuery = (
  { __typename?: 'Query' }
  & { shipmentLineItemById?: Maybe<(
    { __typename?: 'ShipmentLineItem' }
    & Pick<ShipmentLineItem, 'shipmentId'>
    & { shipment?: Maybe<(
      { __typename?: 'Shipment' }
      & Pick<Shipment, 'id' | 'ppecbBookingReference'>
    )> }
    & SliCommonFieldsFragment
  )> }
);

export type ShipmentSeaPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentSeaPortsQuery = (
  { __typename?: 'Query' }
  & { seaPorts?: Maybe<Array<(
    { __typename?: 'SeaPort' }
    & Pick<SeaPort, 'id' | 'name' | 'country' | 'unLocode'>
  )>> }
);

export type OnAddendumHeaderStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAddendumHeaderStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onAddendumHeaderStateChange: (
    { __typename?: 'AddendumHeader' }
    & { addendumLineItems?: Maybe<Array<(
      { __typename?: 'AddendumLineItem' }
      & AddendumLineItemFieldsFragment
    )>> }
    & AddendumHeaderFieldsFragment
  ) }
);

export type OnShipmentStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnShipmentStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onShipmentStateChange: (
    { __typename?: 'Shipment' }
    & { shipmentLineItems?: Maybe<Array<(
      { __typename?: 'ShipmentLineItem' }
      & SliCommonFieldsFragment
    )>> }
    & ShipmentCommonFieldsFragment
  ) }
);

export type SubmitShipmentExportNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmitShipmentExportNotificationMutation = (
  { __typename?: 'Mutation' }
  & { submitShipmentExportNotification?: Maybe<(
    { __typename?: 'SubmitShipmentExportNotificationPayload' }
    & Pick<SubmitShipmentExportNotificationPayload, 'errors'>
    & { shipment?: Maybe<(
      { __typename?: 'Shipment' }
      & { shipmentLineItems?: Maybe<Array<(
        { __typename?: 'ShipmentLineItem' }
        & SliCommonFieldsFragment
      )>> }
      & ShipmentCommonFieldsFragment
    )> }
  )> }
);

export type UpdateLoadOutInstructionsFromSlisMutationVariables = Exact<{
  sliIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateLoadOutInstructionsFromSlisMutation = (
  { __typename?: 'Mutation' }
  & { updateLoadOutInstructionsFromSlis?: Maybe<(
    { __typename?: 'UpdateLoadOutInstructionsFromSlisPayload' }
    & { loadOutInstructions?: Maybe<Array<(
      { __typename?: 'LoadOutInstruction' }
      & Pick<LoadOutInstruction, 'id' | 'voyage' | 'shippingLine'>
      & { vessel?: Maybe<(
        { __typename?: 'Vessel' }
        & Pick<Vessel, 'id' | 'vesselName'>
      )>, portOfLoading?: Maybe<(
        { __typename?: 'SeaPort' }
        & Pick<SeaPort, 'id' | 'name'>
      )> }
    )>> }
  )> }
);

export type GenerateShipmentExportNotificationOutputFilesMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;


export type GenerateShipmentExportNotificationOutputFilesMutation = (
  { __typename?: 'Mutation' }
  & { generateShipmentExportNotificationOutputFiles?: Maybe<(
    { __typename?: 'GenerateShipmentExportNotificationOutputFilesPayload' }
    & { shipment?: Maybe<(
      { __typename?: 'Shipment' }
      & Pick<Shipment, 'id'>
      & { templateOutput?: Maybe<(
        { __typename?: 'TemplateOutput' }
        & Pick<TemplateOutput, 'state'>
        & TemplateOutputFieldsFragment
      )> }
    )> }
  )> }
);

export type CertificateTransportInstructionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CertificateTransportInstructionQuery = (
  { __typename?: 'Query' }
  & { certificateTransportInstruction?: Maybe<(
    { __typename?: 'CertificateTransportInstruction' }
    & Pick<CertificateTransportInstruction, 'id'>
    & { templateOutput?: Maybe<(
      { __typename?: 'TemplateOutput' }
      & Pick<TemplateOutput, 'state'>
      & TemplateOutputFieldsFragment
    )> }
  )> }
);

export type UpsertCertificateTransportInstructionMutationVariables = Exact<{
  shipmentLineItemId: Scalars['ID'];
}>;


export type UpsertCertificateTransportInstructionMutation = (
  { __typename?: 'Mutation' }
  & { upsertCertificateTransportInstruction?: Maybe<(
    { __typename?: 'UpsertCertificateTransportInstructionPayload' }
    & { certificateTransportInstruction?: Maybe<(
      { __typename?: 'CertificateTransportInstruction' }
      & Pick<CertificateTransportInstruction, 'id'>
      & { templateOutput?: Maybe<(
        { __typename?: 'TemplateOutput' }
        & Pick<TemplateOutput, 'state'>
        & TemplateOutputFieldsFragment
      )> }
    )> }
  )> }
);

export type ShipmentsToChooseFromQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
}>;


export type ShipmentsToChooseFromQuery = (
  { __typename?: 'Query' }
  & { shipmentsToChooseFrom?: Maybe<Array<(
    { __typename?: 'Shipment' }
    & Pick<Shipment, 'id' | 'vesselName' | 'client' | 'voyageNumber'>
  )>> }
);

export type ShipmentsAndShipmentLineItemsQueryVariables = Exact<{
  filterAttributes?: Maybe<ShipmentLineItemFilterAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderByFields?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  shipmentId?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ShipmentsAndShipmentLineItemsQuery = (
  { __typename?: 'Query' }
  & { shipmentsAndShipmentLineItems?: Maybe<(
    { __typename?: 'ShipmentsAndShipmentLineItems' }
    & { shipments: Array<(
      { __typename?: 'Shipment' }
      & Pick<Shipment, 'id' | 'vesselName' | 'voyageNumber' | 'client' | 'truckReference'>
    )>, shipmentLineItems: (
      { __typename?: 'ShipmentLineItemConnection' }
      & Pick<ShipmentLineItemConnection, 'totalCount'>
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'ShipmentLineItem' }
        & Pick<ShipmentLineItem, 'id' | 'vesselName' | 'voyageNumber' | 'truckReference' | 'consignmentReference' | 'portOfLoadingName' | 'portOfDischargeName' | 'stackDates' | 'stackDatesClose' | 'stackDatesOpenStatus' | 'stackDatesCloseStatus' | 'estimatedDispatchDate' | 'estimatedDeliveryDate' | 'bookingReference' | 'documentCount' | 'clientReference' | 'customerReference' | 'shippingLineReference' | 'containerNumber' | 'consignmentGroupName' | 'palletCount' | 'state' | 'updatedAt' | 'portOfDestinationName' | 'estimatedTimeOfDeparture' | 'actualTimeOfDeparture' | 'estimatedTimeOfArrival' | 'actualTimeOfArrival'>
        & { loadingPoint?: Maybe<(
          { __typename?: 'FoodBusinessOperator' }
          & Pick<FoodBusinessOperator, 'name'>
        )>, offloadingPoint?: Maybe<(
          { __typename?: 'FoodBusinessOperator' }
          & Pick<FoodBusinessOperator, 'name'>
        )>, checklist?: Maybe<(
          { __typename?: 'TaskableChecklist' }
          & Pick<TaskableChecklist, 'emailSubject' | 'title'>
        )>, taskCompletion?: Maybe<(
          { __typename?: 'TaskCompletion' }
          & Pick<TaskCompletion, 'complete' | 'inProgress' | 'notStarted' | 'total'>
        )>, portOfDestination?: Maybe<(
          { __typename?: 'SeaPort' }
          & Pick<SeaPort, 'id' | 'name' | 'unLocode'>
        )>, shipment?: Maybe<(
          { __typename?: 'Shipment' }
          & Pick<Shipment, 'id' | 'ppecbVoyageNumber' | 'vesselName' | 'voyageNumber' | 'client' | 'controller' | 'shipmentType' | 'stackDates' | 'stackDatesClose' | 'estimatedTimeOfDeparture' | 'actualTimeOfDeparture' | 'estimatedTimeOfArrival' | 'actualTimeOfArrival' | 'comments' | 'state'>
          & { terminal?: Maybe<(
            { __typename?: 'Terminal' }
            & Pick<Terminal, 'id' | 'name' | 'code'>
          )>, portOfLoading?: Maybe<(
            { __typename?: 'SeaPort' }
            & Pick<SeaPort, 'id' | 'name' | 'unLocode'>
          )> }
        )>, sliContainer?: Maybe<(
          { __typename?: 'SliContainer' }
          & Pick<SliContainer, 'id'>
          & { container?: Maybe<(
            { __typename?: 'Container' }
            & Pick<Container, 'containerNumber'>
          )> }
        )>, sliBreakBulk?: Maybe<(
          { __typename?: 'SliBreakBulk' }
          & Pick<SliBreakBulk, 'id'>
          & { breakBulkContainer?: Maybe<(
            { __typename?: 'BreakBulkContainer' }
            & Pick<BreakBulkContainer, 'name'>
          )> }
        )> }
      )>>>, pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
      ) }
    ) }
  )> }
);

export type StockAtLocationQueryVariables = Exact<{
  filterAttributes?: Maybe<StockFilterInputAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderAttributes?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  millerAttributes?: Maybe<MillerCollapsibleInLocationInput>;
}>;


export type StockAtLocationQuery = (
  { __typename?: 'Query' }
  & { stockAtLocation?: Maybe<(
    { __typename?: 'StockModuleData' }
    & { allLocations?: Maybe<Array<(
      { __typename?: 'LocationMillerFilter' }
      & Pick<LocationMillerFilter, 'locationType' | 'totalPallets' | 'name' | 'id'>
    )>>, allVessels?: Maybe<Array<(
      { __typename?: 'VesselMillerFilter' }
      & Pick<VesselMillerFilter, 'name' | 'id' | 'totalPallets' | 'vesselEta'>
    )>>, millerCollapsibleForLocation?: Maybe<Array<(
      { __typename?: 'MillerCollapsibleInLocation' }
      & Pick<MillerCollapsibleInLocation, 'field' | 'value' | 'totalPallets'>
    )>>, results?: Maybe<Array<(
      { __typename?: 'CartonGroupingWithLocation' }
      & Pick<CartonGroupingWithLocation, 'previousLocationName' | 'currentLocationName' | 'nextLocationName' | 'extendedFields' | 'commodityId' | 'batchNumber' | 'buyerId' | 'buyerName' | 'consignmentNumber' | 'subCommodityName' | 'varietyVarietyCode' | 'cartons' | 'commodityName' | 'documentStatus' | 'exporterCode' | 'farmCode' | 'grade' | 'id' | 'inspectionDate' | 'inventoryCode' | 'loadOutReference' | 'loadOutInstructionId' | 'mark' | 'netMass' | 'orchard' | 'pack' | 'packhouseCode' | 'packingWeek' | 'palletNumber' | 'palletAge' | 'palletGrossMass' | 'productCharacteristic' | 'sequenceNumber' | 'state' | 'status' | 'sizeCount' | 'sellerName' | 'targetMarket' | 'targetRegion' | 'targetCountry' | 'varietyName' | 'varietyId'>
      & { fileUpdates?: Maybe<Array<(
        { __typename?: 'CartonGroupingAudit' }
        & Pick<CartonGroupingAudit, 'changeDescription' | 'currentValue' | 'id' | 'oldValue' | 'viewedByIds'>
      )>> }
    )>> }
  )> }
);

export type StockFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type StockFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { stockFilterAttributes?: Maybe<(
    { __typename?: 'StockFilterAttributes' }
    & Pick<StockFilterAttributes, 'batchNumbers' | 'documentStatuses' | 'exporterCodes' | 'grades' | 'inventoryCodes' | 'marks' | 'packTypes' | 'sizeCounts' | 'states' | 'targetMarkets'>
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, subCommodities?: Maybe<Array<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name' | 'varietyCode'>
    )>> }
  )> }
);

export type StockErrorsQueryVariables = Exact<{ [key: string]: never; }>;


export type StockErrorsQuery = (
  { __typename?: 'Query' }
  & { stockErrors?: Maybe<Array<(
    { __typename?: 'StockDiscrepancies' }
    & Pick<StockDiscrepancies, 'errorMessage' | 'errorCount' | 'status'>
  )>> }
);

export type UploadedStockFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type UploadedStockFilesQuery = (
  { __typename?: 'Query' }
  & { uploadedStockFiles?: Maybe<Array<(
    { __typename?: 'DocumentProcessingProgress' }
    & Pick<DocumentProcessingProgress, 'documentId' | 'filename' | 'filesize' | 'filetype' | 'status' | 'updatedAt'>
  )>> }
);

export type UploadStockFileMutationMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadStockFileMutationMutation = (
  { __typename?: 'Mutation' }
  & { uploadStockFile?: Maybe<(
    { __typename?: 'UploadStockFileMutationPayload' }
    & Pick<UploadStockFileMutationPayload, 'errors' | 'success'>
  )> }
);

export type MarkAuditsAsViewedMutationMutationVariables = Exact<{
  auditIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkAuditsAsViewedMutationMutation = (
  { __typename?: 'Mutation' }
  & { markAuditsAsViewed?: Maybe<(
    { __typename?: 'MarkAuditsAsViewedMutationPayload' }
    & Pick<MarkAuditsAsViewedMutationPayload, 'errors' | 'success'>
  )> }
);

export type StockOnVesselQueryVariables = Exact<{
  vesselId?: Maybe<Scalars['Int']>;
  filterAttributes?: Maybe<StockFilterInputAttributes>;
  searchAttributes?: Maybe<SearchAttributes>;
  orderAttributes?: Maybe<Array<ColumnOrderAttributes> | ColumnOrderAttributes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type StockOnVesselQuery = (
  { __typename?: 'Query' }
  & { stockOnVessel?: Maybe<(
    { __typename?: 'ShippedStockModuleData' }
    & { allVessels?: Maybe<Array<(
      { __typename?: 'VesselMillerFilter' }
      & Pick<VesselMillerFilter, 'name' | 'id' | 'totalPallets' | 'vesselEta'>
    )>>, results?: Maybe<(
      { __typename?: 'CartonGroupingWithLocationConnection' }
      & Pick<CartonGroupingWithLocationConnection, 'totalCount'>
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'CartonGroupingWithLocation' }
        & Pick<CartonGroupingWithLocation, 'previousLocationName' | 'currentLocationName' | 'nextLocationName' | 'commodityId' | 'batchNumber' | 'buyerId' | 'buyerName' | 'consignmentNumber' | 'containerNumber' | 'subCommodityName' | 'loadOutReference' | 'varietyVarietyCode' | 'cartons' | 'commodityName' | 'exporterCode' | 'extendedFields' | 'farmCode' | 'grade' | 'id' | 'inspectionDate' | 'inventoryCode' | 'mark' | 'netMass' | 'orchard' | 'pack' | 'packhouseCode' | 'packingWeek' | 'palletNumber' | 'palletAge' | 'palletGrossMass' | 'productCharacteristic' | 'sequenceNumber' | 'state' | 'status' | 'sizeCount' | 'sellerName' | 'targetMarket' | 'targetRegion' | 'targetCountry' | 'varietyName' | 'varietyId' | 'vesselId' | 'vesselName'>
      )>>>, pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
      ) }
    )> }
  )> }
);

export type ShippedStockFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippedStockFilterAttributesQuery = (
  { __typename?: 'Query' }
  & { shippedStockFilterAttributes?: Maybe<(
    { __typename?: 'StockFilterAttributes' }
    & Pick<StockFilterAttributes, 'batchNumbers' | 'exporterCodes' | 'grades' | 'inventoryCodes' | 'marks' | 'packTypes' | 'sizeCounts' | 'states' | 'targetMarkets'>
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, commodities?: Maybe<Array<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, subCommodities?: Maybe<Array<(
      { __typename?: 'SubCommodity' }
      & Pick<SubCommodity, 'id' | 'name'>
    )>>, varieties?: Maybe<Array<(
      { __typename?: 'Variety' }
      & Pick<Variety, 'id' | 'name' | 'varietyCode'>
    )>> }
  )> }
);

export type TasksByShipmentLineItemQueryVariables = Exact<{
  sliId: Scalars['Int'];
}>;


export type TasksByShipmentLineItemQuery = (
  { __typename?: 'Query' }
  & { tasksByShipmentLineItem: Array<(
    { __typename?: 'TaskableTask' }
    & TaskCommonFieldsFragment
  )> }
);

export type UploadTaskDocumentMutationVariables = Exact<{
  taskId: Scalars['Int'];
  file: Scalars['Upload'];
  uploadDate?: Maybe<Scalars['ISO8601DateTime']>;
  customDate?: Maybe<Scalars['ISO8601DateTime']>;
}>;


export type UploadTaskDocumentMutation = (
  { __typename?: 'Mutation' }
  & { uploadTaskDocument?: Maybe<(
    { __typename?: 'UploadTaskDocumentPayload' }
    & Pick<UploadTaskDocumentPayload, 'errors'>
    & { task?: Maybe<(
      { __typename?: 'TaskableTask' }
      & Pick<TaskableTask, 'id' | 'customDate' | 'uploadedAt' | 'documentId'>
      & { file?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'filename' | 'v2Url'>
      )> }
    )> }
  )> }
);

export type DeleteTaskDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  shipmentLineItemId: Scalars['ID'];
}>;


export type DeleteTaskDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteTaskDocument?: Maybe<(
    { __typename?: 'DeleteTaskDocumentPayload' }
    & Pick<DeleteTaskDocumentPayload, 'errors'>
    & { tasks?: Maybe<Array<(
      { __typename?: 'TaskableTask' }
      & TaskCommonFieldsFragment
    )>> }
  )> }
);

export type UpdateTasksDatesMutationVariables = Exact<{
  updateValues: Scalars['Json'];
}>;


export type UpdateTasksDatesMutation = (
  { __typename?: 'Mutation' }
  & { updateTasksDates?: Maybe<(
    { __typename?: 'UpdateTasksDatesPayload' }
    & Pick<UpdateTasksDatesPayload, 'errors'>
  )> }
);

export type UpdateCustomTaskDateMutationVariables = Exact<{
  taskId: Scalars['ID'];
  customDate?: Maybe<Scalars['ISO8601Date']>;
  shipmentLineItemId: Scalars['ID'];
}>;


export type UpdateCustomTaskDateMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomTaskDate?: Maybe<(
    { __typename?: 'UpdateCustomTaskDatePayload' }
    & Pick<UpdateCustomTaskDatePayload, 'errors'>
    & { tasks?: Maybe<Array<(
      { __typename?: 'TaskableTask' }
      & TaskCommonFieldsFragment
    )>> }
  )> }
);

export type UploadTaskDocumentPerSliMutationVariables = Exact<{
  taskId: Scalars['ID'];
  shipmentLineItemId: Scalars['ID'];
  file: Scalars['Upload'];
  selectedSliIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UploadTaskDocumentPerSliMutation = (
  { __typename?: 'Mutation' }
  & { uploadTaskDocumentPerSli?: Maybe<(
    { __typename?: 'UploadTaskDocumentPerSliPayload' }
    & Pick<UploadTaskDocumentPerSliPayload, 'errors'>
    & { tasks?: Maybe<Array<(
      { __typename?: 'TaskableTask' }
      & TaskCommonFieldsFragment
    )>> }
  )> }
);

export type TaskCommonFieldsFragment = (
  { __typename?: 'TaskableTask' }
  & Pick<TaskableTask, 'id' | 'index' | 'taskLevel' | 'uploadedAt' | 'customDate' | 'hasDocument' | 'platformTask' | 'title' | 'documentId' | 'state' | 'dateOfCompletion' | 'taskableId' | 'taskableType'>
  & { platformDocuments?: Maybe<Array<(
    { __typename?: 'OutputFile' }
    & Pick<OutputFile, 'id' | 'blobId' | 'filename' | 'contentType' | 'v2Url' | 'uploadedAt'>
  )>>, file?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'filename' | 'v2Url' | 'uploadedAt'>
  )>, templateOutput?: Maybe<(
    { __typename?: 'TemplateOutput' }
    & Pick<TemplateOutput, 'updatedAt'>
    & { outputFiles?: Maybe<Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'v2Url'>
    )>> }
  )> }
);

export type OnTemplateOutputStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnTemplateOutputStateChangeSubscription = (
  { __typename?: 'Subscription' }
  & { onTemplateOutputStateChange: (
    { __typename?: 'TemplateOutput' }
    & TemplateOutputFieldsFragment
  ) }
);

export type TemplateOutputFieldsFragment = (
  { __typename?: 'TemplateOutput' }
  & Pick<TemplateOutput, 'id' | 'updatedAt' | 'templateDataSourceType' | 'templateDataSourceId' | 'templateVariant'>
  & { outputFiles?: Maybe<Array<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'v2Url' | 'filename' | 'contentType'>
  )>> }
);

export type TemplateOutputFilesQueryVariables = Exact<{
  templateOutputFilesId: Scalars['Int'];
}>;


export type TemplateOutputFilesQuery = (
  { __typename?: 'Query' }
  & { templateOutputFiles?: Maybe<(
    { __typename?: 'TemplateOutput' }
    & Pick<TemplateOutput, 'errorReason' | 'id' | 'state' | 'templateDataSourceId' | 'templateDataSourceType' | 'updatedAt'>
    & { outputFiles?: Maybe<Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'contentType' | 'filename' | 'id' | 'url' | 'v2Url'>
    )>> }
  )> }
);

export type TemplateOutputFilesBySourceQueryVariables = Exact<{
  dataSourceId: Scalars['Int'];
  dataSourceType: Scalars['String'];
}>;


export type TemplateOutputFilesBySourceQuery = (
  { __typename?: 'Query' }
  & { templateOutputFilesBySource?: Maybe<Array<(
    { __typename?: 'TemplateOutput' }
    & Pick<TemplateOutput, 'errorReason' | 'id' | 'state' | 'templateDataSourceId' | 'templateDataSourceType' | 'updatedAt'>
    & { outputFiles?: Maybe<Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'contentType' | 'filename' | 'id' | 'url' | 'v2Url'>
    )>> }
  )>> }
);

export type TradePartnerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TradePartnerQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'about' | 'isBuyer' | 'isSeller' | 'registrationNumber' | 'vatNumber' | 'createdAt'>
    & { logoFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'url'>
    )>, address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'addressLine1' | 'addressLine2' | 'city' | 'postalCode' | 'country'>
    )>, varieties?: Maybe<Array<(
      { __typename?: 'FarmVariety' }
      & Pick<FarmVariety, 'id' | 'varietyId' | 'name' | 'packingStart' | 'packingEnd' | 'peakCount' | 'hectares'>
      & { images?: Maybe<Array<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'url' | 'thumbnailUrl'>
      )>>, commodity?: Maybe<(
        { __typename?: 'Commodity' }
        & Pick<Commodity, 'id' | 'name'>
        & { icon?: Maybe<(
          { __typename?: 'Image' }
          & Pick<Image, 'v2Url'>
        )> }
      )> }
    )>>, certificates?: Maybe<Array<(
      { __typename?: 'CompanyCertificate' }
      & Pick<CompanyCertificate, 'id' | 'companyId' | 'expiryDate'>
      & { certificate?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'url' | 'filename'>
      )>, certificateType?: Maybe<(
        { __typename?: 'CertificateType' }
        & Pick<CertificateType, 'name' | 'id'>
      )> }
    )>>, tradeRegions?: Maybe<Array<(
      { __typename?: 'TradeRegion' }
      & Pick<TradeRegion, 'name' | 'code'>
    )>> }
  )> }
);

export type CompanyInformationFragment = (
  { __typename?: 'Company' }
  & Pick<Company, 'id' | 'name'>
  & { logoFile?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'url'>
  )>, varieties?: Maybe<Array<(
    { __typename?: 'FarmVariety' }
    & Pick<FarmVariety, 'id' | 'varietyId' | 'name'>
    & { commodity?: Maybe<(
      { __typename?: 'Commodity' }
      & Pick<Commodity, 'id' | 'name'>
      & { icon?: Maybe<(
        { __typename?: 'Image' }
        & Pick<Image, 'v2Url'>
      )> }
    )> }
  )>>, certificates?: Maybe<Array<(
    { __typename?: 'CompanyCertificate' }
    & { certificateType?: Maybe<(
      { __typename?: 'CertificateType' }
      & Pick<CertificateType, 'name'>
    )> }
  )>>, tradeRegions?: Maybe<Array<(
    { __typename?: 'TradeRegion' }
    & Pick<TradeRegion, 'name' | 'code'>
  )>> }
);

export type TradePartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type TradePartnersQuery = (
  { __typename?: 'Query' }
  & { myCompany?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'isBuyer' | 'isSeller'>
    & { buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & CompanyInformationFragment
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & CompanyInformationFragment
    )>> }
  )> }
);

export type OneswitchBuyersQueryVariables = Exact<{ [key: string]: never; }>;


export type OneswitchBuyersQuery = (
  { __typename?: 'Query' }
  & { oneswitchBuyers?: Maybe<Array<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'companyLogoImageUrl'>
    & { tradeRegions?: Maybe<Array<(
      { __typename?: 'TradeRegion' }
      & Pick<TradeRegion, 'id' | 'name' | 'code'>
    )>> }
  )>> }
);

export type AllTradeRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTradeRegionsQuery = (
  { __typename?: 'Query' }
  & { tradeRegions?: Maybe<Array<(
    { __typename?: 'TradeRegion' }
    & Pick<TradeRegion, 'id' | 'name' | 'code'>
    & { countries?: Maybe<Array<(
      { __typename?: 'TradeCountry' }
      & Pick<TradeCountry, 'id' | 'code' | 'name'>
    )>> }
  )>> }
);

export type UiConfigsQueryVariables = Exact<{
  visibility?: Maybe<UiConfigVisibilityEnum>;
  configType?: Maybe<Scalars['String']>;
}>;


export type UiConfigsQuery = (
  { __typename?: 'Query' }
  & { uiConfigs?: Maybe<Array<(
    { __typename?: 'UiConfig' }
    & Pick<UiConfig, 'id' | 'configType' | 'visibility' | 'data' | 'readonly'>
  )>>, myUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'email'>
  )> }
);

export type UiConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UiConfigQuery = (
  { __typename?: 'Query' }
  & { uiConfig?: Maybe<(
    { __typename?: 'UiConfig' }
    & Pick<UiConfig, 'id' | 'configType' | 'visibility' | 'data' | 'readonly'>
  )>, myUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'email'>
  )> }
);

export type CreateUiConfigMutationVariables = Exact<{
  attributes: CreateUpdateUiConfigAttributes;
}>;


export type CreateUiConfigMutation = (
  { __typename?: 'Mutation' }
  & { createUiConfig?: Maybe<(
    { __typename?: 'CreateUiConfigPayload' }
    & { config?: Maybe<(
      { __typename?: 'UiConfig' }
      & Pick<UiConfig, 'id' | 'configType' | 'visibility' | 'data' | 'readonly'>
    )> }
  )> }
);

export type DeleteUiConfigMutationVariables = Exact<{
  deleteUiConfigId: Scalars['Int'];
}>;


export type DeleteUiConfigMutation = (
  { __typename?: 'Mutation' }
  & { deleteUiConfig?: Maybe<(
    { __typename?: 'DeleteUiConfigPayload' }
    & Pick<DeleteUiConfigPayload, 'id'>
  )> }
);

export type UpdateUiConfigMutationVariables = Exact<{
  attributes: CreateUpdateUiConfigAttributes;
}>;


export type UpdateUiConfigMutation = (
  { __typename?: 'Mutation' }
  & { updateUiConfig?: Maybe<(
    { __typename?: 'UpdateUiConfigPayload' }
    & { config?: Maybe<(
      { __typename?: 'UiConfig' }
      & Pick<UiConfig, 'id' | 'configType' | 'visibility' | 'data' | 'readonly'>
    )> }
  )> }
);

export type UserFeedItemFragment = (
  { __typename?: 'UserFeedItem' }
  & Pick<UserFeedItem, 'id' | 'message' | 'read' | 'seen' | 'createdAt'>
  & { notifiable?: Maybe<(
    { __typename: 'Comment' }
    & Pick<Comment, 'id'>
    & { commentable?: Maybe<{ __typename?: 'LineItem' } | (
      { __typename: 'Order' }
      & Pick<Order, 'id'>
    )> }
  )> }
);

export type UserFeedItemsConnectionQueryVariables = Exact<{
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
}>;


export type UserFeedItemsConnectionQuery = (
  { __typename?: 'Query' }
  & { userFeedConnection: (
    { __typename?: 'UserFeedItemConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasPreviousPage' | 'hasNextPage'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'UserFeedItemEdge' }
      & Pick<UserFeedItemEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'UserFeedItem' }
        & UserFeedItemFragment
      )> }
    )>>> }
  ) }
);

export type UserFeedUnseenCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFeedUnseenCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'userFeedUnseenCount'>
);

export type UpdateUserFeedItemMutationVariables = Exact<{
  attributes: UpdateUserFeedItemAttributes;
}>;


export type UpdateUserFeedItemMutation = (
  { __typename?: 'Mutation' }
  & { updateUserFeedItem?: Maybe<(
    { __typename?: 'UpdateUserFeedItemPayload' }
    & { userFeedItem?: Maybe<(
      { __typename?: 'UserFeedItem' }
      & Pick<UserFeedItem, 'id' | 'seen' | 'read'>
    )> }
  )> }
);

export type UpdateUserFeedItemsMutationVariables = Exact<{
  attributes: Array<UpdateUserFeedItemAttributes> | UpdateUserFeedItemAttributes;
}>;


export type UpdateUserFeedItemsMutation = (
  { __typename?: 'Mutation' }
  & { updateUserFeedItems?: Maybe<(
    { __typename?: 'UpdateUserFeedItemsPayload' }
    & { userFeedItems?: Maybe<Array<(
      { __typename?: 'UserFeedItem' }
      & Pick<UserFeedItem, 'id' | 'seen' | 'read'>
    )>> }
  )> }
);

export type NewUserFeedItemSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewUserFeedItemSubscription = (
  { __typename?: 'Subscription' }
  & { newUserFeedItem: (
    { __typename?: 'UserFeedItem' }
    & Pick<UserFeedItem, 'id'>
  ) }
);

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { myUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'phoneNumber' | 'email' | 'state' | 'notifyEmail' | 'notifyBrowserPush' | 'pastEmailRecipients' | 'createdAt' | 'updatedAt' | 'useV2' | 'locale' | 'externalIdentifier' | 'role'>
    & { avatarFile?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'filename' | 'url'>
    )>, company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>, roles?: Maybe<Array<(
      { __typename?: 'Role' }
      & Pick<Role, 'name'>
    )>>, permissions?: Maybe<(
      { __typename?: 'Permissions' }
      & Pick<Permissions, 'landingPage'>
      & { permissions?: Maybe<Array<(
        { __typename?: 'Permission' }
        & Pick<Permission, 'key' | 'value'>
      )>> }
    )> }
  )>, myCompany?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id' | 'name' | 'defaultLocale' | 'isBuyer' | 'isSeller' | 'state' | 'onboardingStep'>
    & { certificates?: Maybe<Array<(
      { __typename?: 'CompanyCertificate' }
      & Pick<CompanyCertificate, 'id' | 'expiryDate' | 'createdAt' | 'updatedAt'>
      & { certificate?: Maybe<(
        { __typename?: 'Document' }
        & Pick<Document, 'id' | 'filename' | 'url'>
      )>, certificateType?: Maybe<(
        { __typename?: 'CertificateType' }
        & Pick<CertificateType, 'id' | 'name'>
      )> }
    )>>, sellers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>>, buyers?: Maybe<Array<(
      { __typename?: 'Company' }
      & Pick<Company, 'id' | 'name'>
    )>> }
  )> }
);

export type DeleteEmployeeMutationVariables = Exact<{
  employeeid: Scalars['Int'];
}>;


export type DeleteEmployeeMutation = (
  { __typename?: 'Mutation' }
  & { deleteEmployee?: Maybe<(
    { __typename?: 'DeleteEmployeePayload' }
    & Pick<DeleteEmployeePayload, 'employeeId'>
  )> }
);

export type FindOrCreateVesselMutationVariables = Exact<{
  vesselName: Scalars['String'];
}>;


export type FindOrCreateVesselMutation = (
  { __typename?: 'Mutation' }
  & { findOrCreateVessel?: Maybe<(
    { __typename?: 'FindOrCreateVesselPayload' }
    & Pick<FindOrCreateVesselPayload, 'errors'>
    & { vessel?: Maybe<(
      { __typename?: 'Vessel' }
      & Pick<Vessel, 'id' | 'vesselName'>
    )> }
  )> }
);

export const AccountStatementTemplateOutputFieldsFragmentDoc = gql`
    fragment accountStatementTemplateOutputFields on TemplateOutput {
  outputFiles {
    v2Url
  }
  state
  errorReason
}
    `;
export const ExportErrorFieldsFragmentDoc = gql`
    fragment exportErrorFields on AccountingExportError {
  invoiceId
  invoiceNumber
  errorMessage
  errorType
}
    `;
export const TemplateOutputFieldsFragmentDoc = gql`
    fragment templateOutputFields on TemplateOutput {
  id
  updatedAt
  templateDataSourceType
  templateDataSourceId
  templateVariant
  outputFiles {
    id
    v2Url
    filename
    contentType
  }
}
    `;
export const PalletOutFieldsFragmentDoc = gql`
    fragment palletOutFields on PalletOut {
  id
  addendumHeaderId
  state
  updatedAt
  outputFile {
    contentType
    filename
    v2Url
    id
    url
  }
}
    `;
export const AirAddendumHeaderFieldsFragmentDoc = gql`
    fragment airAddendumHeaderFields on AddendumHeader {
  templateOutput {
    ...templateOutputFields
  }
  palletOut {
    ...palletOutFields
  }
  id
  requestId
  exporterCode
  cfCode
  lspCode
  transportType
  vesselName
  vesselType
  voyageNumber
  exportCertificateNumber
  exportFromCapeTown
  exportFromDurban
  exportFromMaputo
  exportFromOther
  exportFromPortElizabeth
  exporterAgentDate
  exporterAgentName
  forwardingAgentDate
  forwardingAgentName
  disAgentDate
  disAgentName
  inlandInspectorDate
  inlandInspectorName
  portInspectorDate
  portInspectorName
  shippingBookingReference
  loadPort
  dischargePort
  shippedTargetCountry
  shippedTargetRegion
  locationOfIssue
  estimatedDepartureDate
  regimeCode
  eCertAgreementCode
  verificationStatus
  addendumStatus
  ecertStatus
  transactionId
  errorReason
  state
  printedName
  ppecbCertificateNumber
}
    ${TemplateOutputFieldsFragmentDoc}
${PalletOutFieldsFragmentDoc}`;
export const AirAddendumLineItemFieldsFragmentDoc = gql`
    fragment airAddendumLineItemFields on AddendumLineItem {
  id
  stuffLoadDate
  loadPointFboCode
  consignmentNumber
  phc
  inspectedSscc
  clientRef
  upn
  inspectedTargetRegion
  inspectedTargetCountry
  commodityCode
  varietyCode
  productClass
  nettWeight
  grossWeight
  ssccNettWeight
  ssccGrossWeight
  cartonQuantity
  inspectionPoint
  inspectorCode
  inspectionDate
  containerNumber
  sequenceNumberOfInspectedSscc
  puc
  orchard
  productionArea
  phytoData
  sizeCountBerrySize
  packCode
  palletQuantity
  fleshColor
  inspectionManifestNumber
}
    `;
export const AirFreightShipmentFieldsFragmentDoc = gql`
    fragment airFreightShipmentFields on AirFreightShipment {
  id
  externalTransportMasterId
  createdAt
  updatedAt
  shipmentType
  carrierName
  flightNumber
  masterWaybillNumber
  shipper
  consignor
  consignee
  portOfLoadingCode
  portOfLoadingLocation
  forwarderName
  departureAirport
  estimatedDepartureTime
  actualDepartureTime
  portOfDestination
  estimatedArrivalTime
  actualArrivalTime
  controller
  userName
  phoneNumber
  state
  billToParty
  exporterCode
  fboCode
}
    `;
export const AirFreightShipmentLineItemFieldsFragmentDoc = gql`
    fragment airFreightShipmentLineItemFields on AirFreightShipmentLineItem {
  id
  externalShipmentId
  orderReference
  bookingReference
  consignee
  consignor
  finalPortOfDischargeCode
  finalPortOfDischargeLocation
  finalDestinationCode
  finalDestinationLocation
  eta
  collectionDate
  isTransshipment
  transshipmentCarrierName
  transshipmentFlightNumber
  transshipmentPort
  specialHandling
  comments
  packageType
  packageQuantity
  commodityCode
  goodsDescription
  natureOfGoods
  grossWeight
  volume
  grossDimensions
  housebill
  lastStatusMessage
  state
}
    `;
export const BaseCartonGroupingFieldsFragmentDoc = gql`
    fragment baseCartonGroupingFields on CartonGrouping {
  id
  containerNumber
  state
  cartons
  palletNumber
  grade
  batchNumber
  sizeCount
  advancePrice
  finalPrice
  advanceDueDate
  finalDueDate
  lineItem {
    currency
    incoterm
    mark
    orderId
    priceMinorUnit
    priceUnit
    referenceNumber
  }
  buyer {
    id
    name
  }
  seller {
    id
    name
  }
}
    `;
export const CartonGroupingFragmentDoc = gql`
    fragment cartonGrouping on CartonGrouping {
  ...baseCartonGroupingFields
  targetRegion
  targetMarket
  targetCountry
  pack
  palletStack
  packhouseCode
  orchard
  containerNumber
  exporterCode
  farmCode
  packingWeek
  lineItemId
  consignmentNumber
  inventoryCode
  sequenceNumber
  coldStore
  productCharacteristic
  variety {
    id
    name
    commodity {
      id
      name
    }
  }
}
    ${BaseCartonGroupingFieldsFragmentDoc}`;
export const CashFlowCartonGroupingFragmentDoc = gql`
    fragment cashFlowCartonGrouping on CartonGrouping {
  ...baseCartonGroupingFields
  targetRegion
  targetMarket
  palletGrossMass
}
    ${BaseCartonGroupingFieldsFragmentDoc}`;
export const ContainerClaimFieldsFragmentDoc = gql`
    fragment ContainerClaimFields on ContainerClaim {
  id
  completedAt
  state
  companyId
  containerArrivalDate
  notes
  container {
    containerNumber
  }
  arrivalQcDatetime
  updatedAt
  containerableType
  vesselName
  voyageNumber
  containerableId
  photos {
    id
    filename
    v2Url
    contentType
  }
  documents {
    id
    filename
    v2Url
    contentType
  }
  counterParty {
    id
    name
  }
}
    `;
export const DefectFieldsFragmentDoc = gql`
    fragment DefectFields on Defect {
  id
  name
  category
}
    `;
export const ClaimLineItemDefectFieldsFragmentDoc = gql`
    fragment ClaimLineItemDefectFields on ClaimLineItemDefect {
  defect {
    ...DefectFields
  }
  defectPercentage
}
    ${DefectFieldsFragmentDoc}`;
export const ClaimLineItemGroupingFieldsFragmentDoc = gql`
    fragment ClaimLineItemGroupingFields on ClaimLineItemGrouping {
  id
  palletCount
  commodity {
    id
    name
  }
  variety {
    name
  }
  farmCode
  sizeCount
  grade
  arrivalQcGrade
  expectedClaims
  comment
  progressiveClaimLineItemDefects {
    ...ClaimLineItemDefectFields
  }
  progressiveDefectOptions {
    ...DefectFields
  }
  cosmeticClaimLineItemDefects {
    ...ClaimLineItemDefectFields
  }
  cosmeticDefectOptions {
    ...DefectFields
  }
  otherClaimLineItemDefects {
    ...ClaimLineItemDefectFields
  }
  otherDefectOptions {
    ...DefectFields
  }
  progressiveDefectPercentage
  cosmeticDefectPercentage
  otherDefectPercentage
}
    ${ClaimLineItemDefectFieldsFragmentDoc}
${DefectFieldsFragmentDoc}`;
export const CommercialTermChangeRequestFieldsFragmentDoc = gql`
    fragment CommercialTermChangeRequestFields on CommercialTermChangeRequest {
  id
  message
  flag
  commercialTerm {
    id
  }
}
    `;
export const CommercialTermFragmentDoc = gql`
    fragment commercialTerm on CommercialTerm {
  id
  startDate
  endDate
  targetRegion
  advanceType
  advanceUnit
  buyerId
  deleted
  pack
  grade
  paymentTerm
  advanceCreditTerm
  finalCreditTerm
  advanceEvent
  finalEvent
  advanceAmount
  rankOneAdvanceEvent
  rankOneFinalEvent
  advanceCurrency
  finalCurrency
  targetCountry
  exporterCode
  commodityName
  varietyName
  buyerName
  commodity {
    id
    name
  }
  buyer {
    id
    name
  }
  variety {
    id
    name
  }
}
    `;
export const CommoditySeasonFragmentDoc = gql`
    fragment commoditySeason on CommoditySeason {
  id
  startDate
  endDate
  commodity {
    id
    name
    icon {
      v2Url
    }
    commodityGroup
  }
  createdAt
  updatedAt
}
    `;
export const EphytoCommonFieldsFragmentDoc = gql`
    fragment ephytoCommonFields on Ephyto {
  id
  applicationReferenceNo
  applicationType
  applicationStatus
  cbrId
  cbrBillingId
  customReferenceNo
  agreementCode
  desiredIssueLocation
  notificationEmail
  consignorId
  consignorName
  consignorAddressLine1
  consignorAddressLine2
  consignorAddressLine3
  consigneeId
  consigneeName
  consigneeAddressLine1
  consigneeAddressLine2
  consigneeAddressLine3
  consigneeCountryId
  importCountryId
  targetCountryId
  unloadingBaseportLocation
  transportModeCode
  transportMeans
  paymentType
  dalrrdAccNum
  loadSeaPoint
  targetCountry
  targetRegion
  portOfEntry
  bookingRef
  vessel
  voyageNumber
  departureDate
  numberAndDescriptionOfPackage
  botanicalName
  distinguishingMarks
  placeOfOrigin
  declaredMeansOfConveyance
  declaredPointOfEntry
  nameOfProductAndDeclaredQuantity
  treatmentDate
  treatment
  chemical
  durationAndTemperature
  concentration
  additionalInformation
  state
  errorReason
  stuffDate
  temperatureRegime
  originalPhytoDate
  originalPhytoNo
  reexportPlaceOfOrigin
  originalPhyto
  rePacked
  originalContainer
  basedOnOriginalPhyto
  additionalInspection
  cbsFreeArea
  vatNo
  regimeCode
  importPermitNo
  importPermitDate
}
    `;
export const EphytoTradeUnitCommonFieldsFragmentDoc = gql`
    fragment ephytoTradeUnitCommonFields on EphytoTradeUnit {
  id
  tradeUnitId
  clientRef
  orchard
  phc
  productionArea
  commodity
  marketingIndication
  fleshColour
  tuClass
  containerNumber
  numberOfPackagedItems
  netTradeUnitWeight
  nettPalletWeight
  ppecbInspectionDate
  stuffDate
  inspectionManifestNo
  inspectionPointLocationCode
}
    `;
export const EphytoConsignmentItemCommonFieldsFragmentDoc = gql`
    fragment ephytoConsignmentItemCommonFields on EphytoConsignmentItem {
  id
  description
  commonName
  scientificName
  netWeightMeasureCode
  netWeightMeasure
  grossWeightMeasureCode
  grossWeightMeasure
  customsHarmonizedSystemClass
  commodityVegetablePart
  commodityConditionClass
  commodityIntentOfUseClass
  appliedProcessStartDate
  appliedProcessEndDate
  durationMeasureCode
  durationMeasure
  appliedProcessTreatmentTypeLevel1
  appliedProcessTreatmentTypeLevel2
  appliedProcessChemicalCode
  appliedProcessTemperatureUnitCode
  appliedProcessTemperature
  appliedProcessConcentrationUnitCode
  appliedProcessConcentration
  appliedProcessAdditionalNote
  fullTreatmentInformation
  packageLevelCode
  packageTypeCode
  packageItemUnitCode
  packageItemQuantity
  packageShippingMarks
  additionalConsignmentNotes
  sequenceNumeric
}
    `;
export const EphytoDocumentFieldsFragmentDoc = gql`
    fragment ephytoDocumentFields on EphytoDocument {
  id
  documentType
  file {
    id
    filename
    v2Url
  }
}
    `;
export const DocumentFieldsFragmentDoc = gql`
    fragment documentFields on EtlDocument {
  createdAt
  updatedAt
  errorReason
  erroredRows
  fileUrl
  filename
  id
  processedRows
  rows
  state
  source
  documentType
  invoices {
    id
    invoiceNumber
    invoiceDate
    state
    currency
    netAmountMajorUnit
    remittableAmountMajorUnit
    documentType
  }
  invoiceEtlStates {
    invoiceId
    state
    processOutput
  }
}
    `;
export const FarmVarietyFragmentDoc = gql`
    fragment farmVariety on FarmVariety {
  id
  varietyId
  name
  peakCount
  hectares
  packingStart
  packingEnd
  commodity {
    id
    name
  }
  images {
    id
    url
    v2Url
    filename
    thumbnailUrl
    v2ThumbnailUrl
  }
}
    `;
export const InvPortFieldsFragmentDoc = gql`
    fragment invPortFields on SeaPort {
  id
  name
  country
  createdAt
  updatedAt
}
    `;
export const InvoicesSummaryFieldsFragmentDoc = gql`
    fragment invoicesSummaryFields on Invoice {
  invoiceNumber
  invoiceDate
  portOfLoading {
    ...invPortFields
  }
  portOfDestination {
    ...invPortFields
  }
  vessel {
    id
    vesselName
  }
  incoterm
  containers {
    containerNumber
  }
  contacts {
    name
    contactType
    createdByUserId
  }
  id
  currency
  totalIncoterm
  totalCostsMajorUnit
  netAmountMajorUnit
  advancePayment
  finalPayment
  exchangeRate
  allocatedAmountMajorUnit
  remainingAmountMajorUnit
  remittableAmountMajorUnit
  palletCount
  transportType
  documentType
  state
  updatedAt
  createdAt
  templateOutput {
    ...templateOutputFields
  }
  linkedRecords {
    id
    invoiceNumber
    documentType
    finalPayment
    state
    invoiceDate
    currency
    netAmountMajorUnit
  }
  invoicePayments {
    id
    amountMajorUnit
    createdAt
    payment {
      id
      description
      paymentDate
      totalAmountMajorUnit
      currency
      paymentType
      state
    }
  }
  costs
  childInvoices {
    id
    invoiceNumber
    documentType
    finalPayment
    state
  }
  parentInvoice {
    id
    invoiceNumber
    documentType
    state
  }
  sentEmailList {
    id
    createdAt
    recipient
    attachments
  }
  attachedDocuments {
    id
    v2Url
    filename
    contentType
    uploadedAt
  }
  dueDate
  dueDateFinal
  dueDateAdvance
  exchangeRate
  poNumber
  accountingExports {
    id
    exportedAt
    user {
      id
      firstName
      lastName
    }
  }
}
    ${InvPortFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;
export const InvCommonCgFieldsFragmentDoc = gql`
    fragment invCommonCGFields on CartonGrouping {
  batchNumber
  buyer {
    name
  }
  invoiceLineItems {
    invoiceId
    priceUnit
    currency
    documentType
  }
  containerNumber
  cartons
  consignmentNumber
  exporterCode
  farmCode
  grade
  id
  inventoryCode
  lineItem {
    priceUnit
    priceMinorUnit
    currency
    orderId
  }
  mark
  netMass
  orchard
  pack
  packhouseCode
  packingWeek
  palletGrossMass
  palletNumber
  seller {
    name
  }
  sequenceNumber
  sizeCount
  state
  targetCountry
  targetMarket
  targetRegion
  variety {
    id
    commodity {
      id
      name
    }
    name
    subCommodity {
      name
    }
  }
  advancePrice
  finalPrice
}
    `;
export const CgtCommonFieldsFragmentDoc = gql`
    fragment cgtCommonFields on CartonGroupingTransaction {
  id
  transactionDate
  amountMajorUnit
  currency
  exchangeRate
  exchangeCurrency
  externalReferenceNum
  isActual
  createdAt
  updatedAt
  quantityType
  quantityPriceMajorUnit
  quantityAmount
  netMass
  palletGrossMass
  accountType
  cartons
  targetMarket
  advanceTransactionUnitPrice
  cartonGrouping {
    ...invCommonCGFields
  }
}
    ${InvCommonCgFieldsFragmentDoc}`;
export const InvliCommonFieldsFragmentDoc = gql`
    fragment invliCommonFields on InvoiceLineItem {
  cartonGroupingTransactions {
    ...cgtCommonFields
  }
  id
  cartons
  currency
  netMass
  palletGrossMass
  priceUnit
  targetMarket
  sizeCount
  grade
  mark
  pack
  priceMinorUnit
  quantityAmount
  amount
  variety {
    id
    name
    commodity {
      id
      name
    }
  }
  costCode {
    id
    name
    costType
    fieldName
  }
  vatType {
    id
    name
  }
}
    ${CgtCommonFieldsFragmentDoc}`;
export const InvCommonFieldsFragmentDoc = gql`
    fragment invCommonFields on Invoice {
  cartonCount
  invoiceCustomFields {
    customFieldId
    name
    required
    value
    defaultValue
    isDefault
    customFieldDeleted
  }
  convertTonToKg
  countryOfOrigin {
    id
    name
  }
  currency
  localCosts
  insuranceCost
  freightCost
  invoiceNumber
  invoiceDate
  incoterm
  totalFob
  advancePayment
  advanceCreditTerm
  finalPayment
  allocatedAmountMajorUnit
  finalCreditTerm
  dueDateFinal
  subTotal
  vat
  contacts {
    id
    info
    name
    contactType
    createdByUserId
  }
  containers {
    containerNumber
    id
  }
  id
  palletCount
  poNumber
  portOfLoading {
    ...invPortFields
  }
  portOfDestination {
    ...invPortFields
  }
  totalIncoterm
  totalCostsMajorUnit
  netAmountMajorUnit
  ucrNumber
  vessel {
    id
    vesselName
  }
  voyage
  templateOutput {
    ...templateOutputFields
  }
  transportType
  documentType
  state
  airWaybillNo
  shipper
  destination
  allocatedWeight
  routing
  flightDate
  connectingFlightDate
  vehicleNumber
  saleType
  parentInvoiceId
  childInvoices {
    id
    invoiceNumber
    documentType
    finalPayment
    state
  }
  stuffLocation {
    id
    name
  }
  loadingPoint {
    id
    name
  }
  offloadingPoint {
    id
    name
  }
  vatType {
    id
    name
    percentage
  }
  parentInvoice {
    id
    invoiceNumber
    documentType
    advancePayment
    finalPayment
    state
  }
  commercialTerm {
    id
    paymentTerm
    advanceAmount
    advanceCreditTerm
    advanceType
    advanceUnit
    finalCreditTerm
  }
}
    ${InvPortFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;
export const ExpectedReturnSummaryFieldsFragmentDoc = gql`
    fragment expectedReturnSummaryFields on ExpectedReturnSummary {
  unit
  error
  pricePoints {
    incoterm
    moneyAmount {
      currency {
        symbol
        isoCode
        smallestDenomination
        subunitToUnit
      }
      displayString
      fractional
      amount
    }
    chargesApplied {
      name
      moneyAmount {
        currency {
          symbol
          isoCode
          smallestDenomination
          subunitToUnit
        }
        displayString
        fractional
        amount
      }
    }
  }
}
    `;
export const LoiErrorFieldsFragmentDoc = gql`
    fragment LoiErrorFields on LoadOutInstructionError {
  attribute
  type
  cartonGroupingIds
  orchards
  orchardResults {
    id
    farmCode
    orchardName
    currentEuStatus
    eu
    bd
    cbs
    fms
    applied
    verified
    phytoData
  }
}
    `;
export const LoiPortFieldsFragmentDoc = gql`
    fragment loiPortFields on SeaPort {
  id
  name
  country
  createdAt
  updatedAt
}
    `;
export const PalletInFieldsFragmentDoc = gql`
    fragment palletInFields on PalletIn {
  id
  loadOutInstructionId
  state
  updatedAt
  outputFile {
    contentType
    filename
    v2Url
    id
    url
  }
}
    `;
export const LoiCommonFieldsFragmentDoc = gql`
    fragment LoiCommonFields on LoadOutInstruction {
  bookingReference
  transportType
  contacts {
    id
    name
    info
    contactType
    createdByUserId
  }
  containerNumber
  estimatedTimeOfDelivery
  exporter {
    id
    name
  }
  exportersReference
  id
  loadOutReference
  notes
  portOfDestination {
    ...loiPortFields
  }
  portOfDestinationName
  portOfLoading {
    ...loiPortFields
  }
  portOfLoadingName
  printedDate
  q67Reference
  shippingLine
  stuffDate
  stuffLocation {
    id
    name
    createdAt
    updatedAt
  }
  temperatureSetting
  vessel {
    id
    vesselName
  }
  voyage
  templateOutput {
    ...templateOutputFields
  }
  palletIn {
    ...palletInFields
  }
  truckReference
  loadingPoint {
    id
    name
    createdAt
    updatedAt
  }
  offloadingPoint {
    id
    name
    createdAt
    updatedAt
  }
  fileNumber
  airWaybillNo
  shipper
  destination
  allocatedWeight
  routing
  flightDate
  connectingFlightDate
  equipment
  phytoCertificate
  orderPreparedBy
  orderPickedBy
  checked
  stockTransfer
  consignmentReference
  transporterCompany
  estimatedDispatchDate
  loadDate
  orderReference
}
    ${LoiPortFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}
${PalletInFieldsFragmentDoc}`;
export const CgCommonFieldsFragmentDoc = gql`
    fragment cgCommonFields on CartonGrouping {
  batchNumber
  buyer {
    name
  }
  cartons
  consignmentNumber
  exporterCode
  farmCode
  grade
  id
  inventoryCode
  mark
  netMass
  orchard
  pack
  packhouseCode
  packingWeek
  palletGrossMass
  palletNumber
  seller {
    name
  }
  sequenceNumber
  sizeCount
  state
  targetCountry
  targetMarket
  targetRegion
  variety {
    commodity {
      name
    }
    name
    subCommodity {
      name
    }
  }
  palletAge
}
    `;
export const VesselMapFragmentDoc = gql`
    fragment vesselMap on Vessel {
  vesselName
  voyageNumber
  lat
  long
}
    `;
export const SeaPortMapFragmentDoc = gql`
    fragment seaPortMap on SeaPort {
  id
  name
  country
  unLocode
  latitude
  longitude
  createdAt
  updatedAt
}
    `;
export const FboMapFragmentDoc = gql`
    fragment fboMap on FoodBusinessOperator {
  id
  name
  fboCode
  typeOfBusiness
  latitude
  longitude
  createdAt
  updatedAt
}
    `;
export const FarmVarietyFieldsFragmentDoc = gql`
    fragment farmVarietyFields on FarmVariety {
  id
  name
  varietyCode
  hectares
  commodityName
  packingStart
  packingEnd
  peakCount
  variety {
    id
    varietyName
    commodity {
      id
      name
    }
  }
  commodity {
    id
    name
  }
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on Address {
  addressLine1
  addressLine2
  city
  postalCode
  country
  placeId
}
    `;
export const FoodBusinessOperatorFieldsFragmentDoc = gql`
    fragment foodBusinessOperatorFields on FoodBusinessOperator {
  id
  name
  fboCode
  producerName
  typeOfBusiness
  productionRegion
  globalGapNumber
  latitude
  longitude
  status
  address {
    ...addressFields
  }
  company {
    id
    name
  }
  packhouseConnections {
    id
    name
    state
    scheduledFor
    scheduledAt
    createdAt
    updatedAt
    apiUserId
    connected
    lastProcessedDatetime
    onPremSystem
  }
}
    ${AddressFieldsFragmentDoc}`;
export const SoftwareUpdateReportFieldsFragmentDoc = gql`
    fragment softwareUpdateReportFields on SoftwareUpdateReportRequest {
  id
  company {
    id
    name
  }
  softwareUpdateReport
}
    `;
export const PackhouseConnectionFieldsFragmentDoc = gql`
    fragment packhouseConnectionFields on PackhouseConnection {
  id
  name
  state
  scheduledFor
  scheduledAt
  createdAt
  updatedAt
  apiUserId
  connected
  lastProcessedDatetime
  onPremSystem
}
    `;
export const CompanyAssociationFieldsFragmentDoc = gql`
    fragment companyAssociationFields on CompanyAssociation {
  id
  name
}
    `;
export const MasterfileConfigFieldsFragmentDoc = gql`
    fragment masterfileConfigFields on MasterfileConfig {
  id
  state
  masterfileEntityType
  masterfileEntityId
  companyId
}
    `;
export const MetabaseReportFieldsFragmentDoc = gql`
    fragment MetabaseReportFields on MetabaseReport {
  badges {
    color
    text
  }
  chartSource
  description
  domain
  id
  name
  displayName
  scope
  url
  powerbiEmbedAttributes {
    embedToken
    embedUrl
    reportId
  }
}
    `;
export const NotificationRuleSubscriptionFieldsFragmentDoc = gql`
    fragment NotificationRuleSubscriptionFields on NotificationRuleSubscription {
  id
  enabled
  notifyEmail
  notifyWeb
  notifyMobile
  notifyWhatsapp
  config
}
    `;
export const NotificationRuleFieldsFragmentDoc = gql`
    fragment NotificationRuleFields on NotificationRule {
  id
  name
  description
  notificationSlug
  severity
  defaultThresholds
  notificationRuleSubscription {
    ...NotificationRuleSubscriptionFields
  }
}
    ${NotificationRuleSubscriptionFieldsFragmentDoc}`;
export const NotificationItemFieldsFragmentDoc = gql`
    fragment NotificationItemFields on NotificationItem {
  id
  entityType
  entityId
}
    `;
export const ChannelNotificationFieldsFragmentDoc = gql`
    fragment ChannelNotificationFields on ChannelNotification {
  id
  channelMetadata
  sentAt
  readAt
  archivedAt
  deliveredAt
  title
  body
  notificationRule {
    ...NotificationRuleFields
  }
  notificationItems {
    ...NotificationItemFields
  }
}
    ${NotificationRuleFieldsFragmentDoc}
${NotificationItemFieldsFragmentDoc}`;
export const PortDisplayFieldsFragmentDoc = gql`
    fragment portDisplayFields on SeaPort {
  id
  name
  displayName
  country
  createdAt
  updatedAt
}
    `;
export const OfferItemPriceFieldsFragmentDoc = gql`
    fragment offerItemPriceFields on OfferItemPrice {
  id
  portOfDestination {
    ...portDisplayFields
  }
  portOfDestinationId
  dipPriceAmountMajorUnit
  cifPriceAmountMajorUnit
  priceUnit
}
    ${PortDisplayFieldsFragmentDoc}`;
export const OfferItemFieldsFragmentDoc = gql`
    fragment offerItemFields on OfferItem {
  id
  offerId
  sizeCounts
  grade
  quantity
  quantityUnit
  offerItemPrices {
    ...offerItemPriceFields
  }
  createdAt
  updatedAt
}
    ${OfferItemPriceFieldsFragmentDoc}`;
export const OfferRecipientFieldsFragmentDoc = gql`
    fragment offerRecipientFields on OfferRecipient {
  id
  state
  contactUserId
  buyer {
    id
    name
  }
  portOfDestination {
    ...portDisplayFields
  }
  portOfDestinationId
}
    ${PortDisplayFieldsFragmentDoc}`;
export const OfferFieldsFragmentDoc = gql`
    fragment offerFields on Offer {
  id
  isRootOfferOpenPrice
  isRootOfferOpenQuantity
  state
  title
  description
  currency
  packingWeek
  rootOfferId
  previousOfferId
  orderId
  offerItems {
    ...offerItemFields
  }
  offerRecipients {
    ...offerRecipientFields
  }
  rootOffer {
    id
    companyId
  }
  incoterm
  buyer {
    id
    name
  }
  tradeRegion {
    id
    name
    code
  }
  variety {
    id
    name
    varietyName
    varietyCode
    commodity {
      id
    }
  }
  user {
    id
    firstName
    lastName
  }
  company {
    id
    name
  }
  companyId
  packType
  palletStack
  priceTerm
  expiresAt
  initialQuantity
  quantity
  quantityUnit
  createdAt
  updatedAt
}
    ${OfferItemFieldsFragmentDoc}
${OfferRecipientFieldsFragmentDoc}`;
export const OfferItemPriceExpectedReturnFieldsFragmentDoc = gql`
    fragment offerItemPriceExpectedReturnFields on OfferItemPriceExpectedReturn {
  incoterm
  unit
  currency
  conversionPriceAmountMajorUnit
}
    `;
export const CommentFieldsFragmentDoc = gql`
    fragment commentFields on Comment {
  id
  commentText
  isDeleted
  createdAt
  updatedAt
  user {
    id
    firstName
    lastName
    avatarFile {
      id
      filename
      url
    }
  }
}
    `;
export const SellerCompanyFieldsFragmentDoc = gql`
    fragment sellerCompanyFields on Company {
  id
  name
  logoFile {
    id
    filename
    v2Url
  }
  varieties {
    id
    varietyId
    name
    commodity {
      id
      name
    }
  }
  additionalFields {
    id
    name
  }
}
    `;
export const SingleLineItemFieldsFragmentDoc = gql`
    fragment singleLineItemFields on LineItem {
  id
  additionalFields
  packingWeek
  startWeek
  endWeek
  targetRegion
  targetCountry
  targetMarket
  quantity
  plannedQuantity
  plannedQuantityUnit
  incoterm
  pack
  palletStack
  priority
  quantityUnit
  priceMinorUnit
  sizeCounts
  priceTerm
  currency
  state
  priceUnit
  grade
  mark
  commodityId
  varietyId
  packedCartons
  packedPallets
  variety {
    id
    commodity {
      id
      name
    }
    subCommodity {
      id
      name
    }
    name
    varietyCode
  }
  referenceNumber
  rank
  batchNumber
  inventoryCode
  unlimited
  orderId
  lineItemGroupingId
  createdAt
  updatedAt
  seller {
    id
    name
  }
  buyer {
    id
    name
  }
  departurePortId
  departurePort {
    id
    name
    displayName
    createdAt
    updatedAt
  }
  destinationPortId
  destinationPort {
    id
    name
    displayName
    createdAt
    updatedAt
  }
  cumulativeQuantity
}
    `;
export const StatesDistributionFieldsFragmentDoc = gql`
    fragment statesDistributionFields on LineItem {
  statesDistribution {
    quantity
    quantityTotal
    palletQuantity
    palletQuantityTotal
    state
    supplyChainOrder
  }
}
    `;
export const ShipmentDocumentFieldsFragmentDoc = gql`
    fragment shipmentDocumentFields on ShipmentDocument {
  id
  documentType
  user {
    id
    firstName
    lastName
    company {
      id
    }
  }
  file {
    id
    filename
    v2Url
  }
}
    `;
export const SingleOrderFieldsFragmentDoc = gql`
    fragment singleOrderFields on Order {
  id
  state
  isPackhouseRun
  createdAt
  updatedAt
  comments {
    ...commentFields
  }
  buyer {
    id
    name
    logoFile {
      id
      v2Url
    }
    additionalFields {
      id
      name
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
  }
  seller {
    ...sellerCompanyFields
  }
  lineItems {
    ...singleLineItemFields
  }
  lineItemGroupings {
    id
    cumulativeQuantity
    quantityType
    commonFields
    deleted
    rank
    lineItems {
      ...singleLineItemFields
      ...statesDistributionFields
    }
  }
  audits {
    id
    action
    auditableType
    auditableId
    associatedType
    associatedId
    createdAt
    auditedChanges
    version
    user {
      id
      firstName
      company {
        id
        name
      }
    }
  }
  shipmentDocuments {
    ...shipmentDocumentFields
  }
}
    ${CommentFieldsFragmentDoc}
${SellerCompanyFieldsFragmentDoc}
${SingleLineItemFieldsFragmentDoc}
${StatesDistributionFieldsFragmentDoc}
${ShipmentDocumentFieldsFragmentDoc}`;
export const ExpectedNetReturnFieldsFragmentDoc = gql`
    fragment expectedNetReturnFields on LineItem {
  expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
    unit
    error
    equivalentPrice {
      incoterm
      moneyAmount {
        displayString
      }
    }
    pricePoints {
      incoterm
      moneyAmount {
        currency {
          symbol
        }
        amount
      }
      chargesApplied {
        name
        moneyAmount {
          amount
        }
      }
    }
  }
}
    `;
export const SingleOrderFieldsWithNetReturnFragmentDoc = gql`
    fragment singleOrderFieldsWithNetReturn on Order {
  ...singleOrderFields
  lineItemGroupings {
    lineItems {
      ...expectedNetReturnFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}
${ExpectedNetReturnFieldsFragmentDoc}`;
export const MultipleOrderFieldsFragmentDoc = gql`
    fragment multipleOrderFields on Order {
  id
  state
  isPackhouseRun
  updatedAt
  createdAt
  lineItemGroupings {
    commonFields
    cumulativeQuantity
    cumulativeTooltip
    deleted
    id
    numberCumulativeSiblings
    quantityType
    rank
    lineItems(
      lineItemStates: $lineItemStates
      packingWeekStart: $packingWeekStart
      packingWeekEnd: $packingWeekEnd
      varietyIds: $varietyIds
      commodityIds: $commodityIds
      subCommodityIds: $subCommodityIds
      states: $states
    ) {
      ...singleLineItemFields
      ...statesDistributionFields
      ...expectedNetReturnFields
    }
  }
  buyer {
    id
    name
    logoFile {
      id
      filename
      v2Url
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
  }
  seller {
    ...sellerCompanyFields
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${StatesDistributionFieldsFragmentDoc}
${ExpectedNetReturnFieldsFragmentDoc}
${SellerCompanyFieldsFragmentDoc}`;
export const DuplicateOrderFieldsFragmentDoc = gql`
    fragment duplicateOrderFields on Order {
  id
  isPackhouseRun
  lineItemGroupings {
    id
    cumulativeQuantity
    quantityType
    commonFields
    deleted
    rank
    lineItems {
      ...singleLineItemFields
    }
  }
  buyer {
    id
    name
    logoFile {
      id
      filename
      v2Url
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
  }
  seller {
    ...sellerCompanyFields
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${SellerCompanyFieldsFragmentDoc}`;
export const CompanyFieldsFragmentDoc = gql`
    fragment companyFields on Company {
  id
  name
}
    `;
export const ProfitAndLossReportFieldsFragmentDoc = gql`
    fragment ProfitAndLossReportFields on ProfitAndLossReport {
  nodes {
    farmCode
    containerNumber
    commodity
    variety
    packType
    sizeCount
    grade
    targetRegion
    targetMarket
    targetCountry
    buyerName
    sellerName
    batchNumber
    palletNumber
    exporterCode
    mark
    inventoryCode
    packingWeek
    voyageNumber
    extendedFields
    totalCartons
    totalStdCartons
    totalKilograms
    cgCount
    palletCount
    shippingWeek
    arrivalWeek
    dischargePort
    vesselName
    incoterm
    contractCurrency
    paymentAdviceNumber
    poNumber
    allOnStatement
    paymentAdviceDownloadUrl
    revenue
    cifCosts
    netCif
    fobCosts
    netFob
    dipCosts
    netDip
    exwCosts
    netExw
    growerFinalPayment
    overseasCosts
    localCosts
    revenueAdvance
    revenueFinal
    revenueCreditNote
    revenueDebitNote
    revenuePerCarton
    revenuePerStdCarton
    revenuePerKg
    netCifPerCarton
    netCifPerStdCarton
    netFobPerCarton
    netFobPerStdCarton
    netDipPerCarton
    netDipPerStdCarton
    netExwPerCarton
    netExwPerStdCarton
    cashReceived
    accountsReceivable
    cashReceivedPerCarton
    cashReceivedPerStdCarton
    revenueInclVat
    cifCostsInclVat
    fobCostsInclVat
    dipCostsInclVat
    exwCostsInclVat
    netCifInclVat
    netFobInclVat
    netDipInclVat
    netExwInclVat
    overseasCostsInclVat
    localCostsInclVat
    vatTotalRevenue
    vatTotalCosts
    revenueInclVatPerCarton
    revenueInclVatPerStdCarton
    revenueInclVatPerKg
    netCifInclVatPerCarton
    netCifInclVatPerStdCarton
    netFobInclVatPerCarton
    netFobInclVatPerStdCarton
    netDipInclVatPerCarton
    netDipInclVatPerStdCarton
    netExwInclVatPerCarton
    netExwInclVatPerStdCarton
    costBreakdown
    linkedRecordsCount
    linkedCgIds
    linkedContainerIds
    linkedBbcIds
  }
  pageInfo {
    hasNextPage
  }
  meta {
    rowCount
    sqlMs
    totalMs
    reportingCurrency
    costCategories {
      key
      label
      section
    }
    extendedFieldKeys
  }
}
    `;
export const ShipmentCommonFieldsFragmentDoc = gql`
    fragment shipmentCommonFields on Shipment {
  id
  shipmentType
  ppecbBookingReference
  shippingLine
  voyageNumber
  shippingLineVoyageNumber
  loadPort
  billToParty
  exporterCode
  cfCode
  ppecbRegisteredExporterCode
  ppecbRegisteredAgentCode
  phoneNumber
  userName
  dateCreated
  vesselOriginalEstimatedDateOfDeparture
  stackDates
  stackDatesClose
  stackDatesOpenStatus
  stackDatesCloseStatus
  shipper
  status
  vesselName
  vesselCode
  ppecbVoyageNumber
  controller
  client
  comments
  estimatedTimeOfDeparture
  actualTimeOfDeparture
  exportNotificationError
}
    `;
export const ExportDocumentFieldsFragmentDoc = gql`
    fragment exportDocumentFields on ExportDocument {
  id
  documentType
  file {
    id
    filename
    v2Url
  }
}
    `;
export const SliCommonFieldsFragmentDoc = gql`
    fragment sliCommonFields on ShipmentLineItem {
  id
  ppecbBookingReference
  ppecbBookingItemReference
  shippingLineReference
  customerReference
  truckReference
  orderReference
  loadDate
  consignmentReference
  regimeCode
  finalCountryOfDestination
  importPermitNumber
  exporterOnCertificate
  isGensetRequired
  isTranshipment
  isColdTreatment
  transhipmentVesselName
  transhipmentVoyageNumber
  transhipmentPort
  finalPortOfDischarge
  tempSensor
  userName
  dateCreated
  isConventionalShipping
  depot
  collectionDate
  loadingInstructionNumber
  haulageType
  transporter
  receiver
  cargoVgm
  solas
  tempDevice
  estimatedTimeOfDeparture
  actualTimeOfDeparture
  estimatedTimeOfArrival
  actualTimeOfArrival
  containerAndSealNumber
  paymentTerms
  shippingLineContactNumber
  humidity
  voidPlugs
  ventSetting
  protocolTemperature
  protocolDays
  specialInstruction
  status
  productCodes
  containerNumber
  sealNumber
  nettWeight
  grossWeight
  state
  comments
  consignee
  fruitOriginCode
  fruitOriginName
  radiation
  fumigation
  treatmentType
  serviceContractNumber
  customerReference
  totalCartons
  exportNotificationError
  tareWeight
  loadingPoints {
    activityPointCode
    loadingDate
    quantity
    containerType
    unitOfMeasure
  }
  portOfDestination {
    id
    name
    unLocode
  }
  portOfDischarge {
    id
    name
    unLocode
  }
  emptyDepot {
    id
    producerName
    name
    fboCode
  }
  clientReference
  exportDocuments {
    ...exportDocumentFields
  }
  certificateTransportInstruction {
    id
    templateOutput {
      state
      ...templateOutputFields
    }
  }
  shipmentLineItemGroupingId
  tasks {
    id
    index
    taskLevel
    uploadedAt
    customDate
    hasDocument
    platformTask
    title
    documentId
    file {
      id
      filename
      v2Url
    }
    templateOutput {
      outputFiles {
        id
        filename
        v2Url
      }
    }
  }
  checklist {
    emailSubject
    title
  }
}
    ${ExportDocumentFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;
export const IndexShipmentLineItemFieldssFragmentDoc = gql`
    fragment indexShipmentLineItemFieldss on ShipmentLineItem {
  id
  shipmentType
  containerNumber
  sealNumber
  grossWeight
  nettWeight
  comments
  shippingLineReference
  customerReference
  consignee
  serviceContractNumber
  clientReference
  voyageNumber
  portOfDestination {
    name
    unLocode
  }
  finalPortOfDischarge
  portOfDischarge {
    name
    unLocode
  }
  state
  status
  totalCartons
  productCodes
  estimatedTimeOfDeparture
  actualTimeOfDeparture
  estimatedTimeOfArrival
  actualTimeOfArrival
  shipment {
    id
    controller
    client
    vesselName
    portOfLoading {
      name
    }
    stackDates
    stackDatesClose
    stackDatesOpenStatus
    stackDatesCloseStatus
    estimatedTimeOfDeparture
    actualTimeOfDeparture
    estimatedTimeOfArrival
    actualTimeOfArrival
    shipmentType
  }
  sliContainer {
    id
    container {
      containerNumber
      containerSize
      containerType
      cartonGroupings {
        commodity {
          name
        }
      }
    }
  }
  sliBreakBulk {
    id
    breakBulkContainer {
      name
    }
  }
  tasks {
    id
    index
    taskLevel
    documentId
    uploadedAt
    customDate
    hasDocument
    platformTask
    title
    file {
      id
      filename
      v2Url
    }
    templateOutput {
      outputFiles {
        id
        filename
        v2Url
      }
    }
  }
  checklist {
    emailSubject
    title
  }
  createdAt
}
    `;
export const AddendumHeaderFieldsFragmentDoc = gql`
    fragment addendumHeaderFields on AddendumHeader {
  id
  requestId
  exporterCode
  cfCode
  lspCode
  transportType
  vesselName
  vesselType
  voyageNumber
  regimeCode
  shippingBookingReference
  loadPort
  dischargePort
  shippedTargetCountry
  shippedTargetRegion
  locationOfIssue
  estimatedDepartureDate
  eCertAgreementCode
  verificationStatus
  addendumStatus
  ecertStatus
  transactionId
  errorReason
  state
}
    `;
export const AddendumLineItemFieldsFragmentDoc = gql`
    fragment addendumLineItemFields on AddendumLineItem {
  id
  stuffLoadDate
  loadPointFboCode
  consignmentNumber
  phc
  inspectedSscc
  clientRef
  upn
  inspectedTargetRegion
  inspectedTargetCountry
  commodityCode
  varietyCode
  productClass
  nettWeight
  grossWeight
  ssccNettWeight
  ssccGrossWeight
  cartonQuantity
  inspectionPoint
  inspectorCode
  inspectionDate
  inspectionManifestNumber
  containerNumber
  sequenceNumberOfInspectedSscc
  puc
  orchard
  productionArea
  phytoData
  sizeCountBerrySize
  packCode
  palletQuantity
}
    `;
export const TaskCommonFieldsFragmentDoc = gql`
    fragment taskCommonFields on TaskableTask {
  id
  index
  taskLevel
  uploadedAt
  customDate
  hasDocument
  platformTask
  platformDocuments {
    id
    blobId
    filename
    contentType
    v2Url
    uploadedAt
  }
  title
  documentId
  state
  dateOfCompletion
  taskableId
  taskableType
  file {
    id
    filename
    v2Url
    uploadedAt
  }
  templateOutput {
    outputFiles {
      id
      filename
      v2Url
    }
    updatedAt
  }
}
    `;
export const CompanyInformationFragmentDoc = gql`
    fragment companyInformation on Company {
  id
  name
  logoFile {
    id
    url
  }
  varieties {
    id
    varietyId
    name
    commodity {
      id
      name
      icon {
        v2Url
      }
    }
  }
  certificates {
    certificateType {
      name
    }
  }
  tradeRegions {
    name
    code
  }
}
    `;
export const UserFeedItemFragmentDoc = gql`
    fragment userFeedItem on UserFeedItem {
  id
  message
  read
  seen
  createdAt
  notifiable {
    ... on Comment {
      id
      __typename
      commentable {
        ... on Order {
          id
          __typename
        }
      }
    }
  }
}
    `;
export const GenerateAccountStatementOutputFilesDocument = gql`
    mutation generateAccountStatementOutputFiles($companyId: ID!, $contactId: ID!, $fromDate: ISO8601Date) {
  generateAccountStatementOutputFiles(
    companyId: $companyId
    contactId: $contactId
    fromDate: $fromDate
  ) {
    accountStatement {
      id
      templateOutput {
        ...accountStatementTemplateOutputFields
      }
    }
  }
}
    ${AccountStatementTemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAccountStatementOutputFilesGQL extends Apollo.Mutation<GenerateAccountStatementOutputFilesMutation, GenerateAccountStatementOutputFilesMutationVariables> {
    document = GenerateAccountStatementOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAccountStatementStateChangeDocument = gql`
    subscription onAccountStatementStateChange {
  onAccountStatementStateChange {
    id
    templateOutput {
      ...accountStatementTemplateOutputFields
    }
  }
}
    ${AccountStatementTemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAccountStatementStateChangeGQL extends Apollo.Subscription<OnAccountStatementStateChangeSubscription, OnAccountStatementStateChangeSubscriptionVariables> {
    document = OnAccountStatementStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountStatementDocument = gql`
    query accountStatement($id: ID!) {
  accountStatement(id: $id) {
    id
    templateOutput {
      ...accountStatementTemplateOutputFields
    }
  }
}
    ${AccountStatementTemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountStatementGQL extends Apollo.Query<AccountStatementQuery, AccountStatementQueryVariables> {
    document = AccountStatementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAccountingExportDocument = gql`
    mutation generateAccountingExport($invoiceIds: [ID!]!) {
  generateAccountingExport(invoiceIds: $invoiceIds) {
    accountingExport {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAccountingExportGQL extends Apollo.Mutation<GenerateAccountingExportMutation, GenerateAccountingExportMutationVariables> {
    document = GenerateAccountingExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountingExportDocument = gql`
    query accountingExport($id: ID!) {
  accountingExport(id: $id) {
    id
    exportStatus
    exportedAt
    exportFile {
      v2Url
    }
    exportErrors {
      ...exportErrorFields
    }
  }
}
    ${ExportErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountingExportGQL extends Apollo.Query<AccountingExportQuery, AccountingExportQueryVariables> {
    document = AccountingExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAccountingExportStateChangeDocument = gql`
    subscription onAccountingExportStateChange {
  onAccountingExportStateChange {
    id
    exportStatus
    exportedAt
    exportFile {
      v2Url
    }
    exportErrors {
      ...exportErrorFields
    }
  }
}
    ${ExportErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAccountingExportStateChangeGQL extends Apollo.Subscription<OnAccountingExportStateChangeSubscription, OnAccountingExportStateChangeSubscriptionVariables> {
    document = OnAccountingExportStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAdditionalFieldDocument = gql`
    mutation CreateAdditionalField($attributes: CreateAdditionalFieldAttributes!) {
  createAdditionalField(attributes: $attributes) {
    additionalField {
      id
      companyId
      name
      description
      fieldType
      parameters
      isPackingInstruction
      private
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAdditionalFieldGQL extends Apollo.Mutation<CreateAdditionalFieldMutation, CreateAdditionalFieldMutationVariables> {
    document = CreateAdditionalFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAdditionalFieldDocument = gql`
    mutation DeleteAdditionalField($id: Int!) {
  deleteAdditionalField(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAdditionalFieldGQL extends Apollo.Mutation<DeleteAdditionalFieldMutation, DeleteAdditionalFieldMutationVariables> {
    document = DeleteAdditionalFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAdditionalFieldDocument = gql`
    mutation UpdateAdditionalField($id: Int!, $attributes: UpdateAdditionalFieldAttributes!) {
  updateAdditionalField(id: $id, attributes: $attributes) {
    additionalField {
      id
      name
      description
      fieldType
      parameters
      isPackingInstruction
      private
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAdditionalFieldGQL extends Apollo.Mutation<UpdateAdditionalFieldMutation, UpdateAdditionalFieldMutationVariables> {
    document = UpdateAdditionalFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdditionalFieldsDocument = gql`
    query AdditionalFields($companyids: [Int!]!) {
  additionalFields(companyIds: $companyids) {
    id
    name
    description
    fieldType
    parameters
    isPackingInstruction
    private
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdditionalFieldsGQL extends Apollo.Query<AdditionalFieldsQuery, AdditionalFieldsQueryVariables> {
    document = AdditionalFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NetReturnFieldsDocument = gql`
    query NetReturnFields($packingWeek: String!) {
  netReturnStandardFields(packingWeek: $packingWeek)
  netReturnAdditionalFields(packingWeek: $packingWeek) {
    companyId
    createdAt
    description
    fieldType
    id
    isPackingInstruction
    name
    parameters
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NetReturnFieldsGQL extends Apollo.Query<NetReturnFieldsQuery, NetReturnFieldsQueryVariables> {
    document = NetReturnFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAg1TableOutputFileDocument = gql`
    mutation GenerateAg1TableOutputFile($data: Json!, $fields: [Ag1TableFieldAttribute!]!, $fileformat: TemplateFileFormatEnum!, $tablename: String!, $filtervalues: String) {
  generateAg1TableOutputFile(
    data: $data
    fields: $fields
    fileFormat: $fileformat
    tableName: $tablename
    filterValues: $filtervalues
  ) {
    fileUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAg1TableOutputFileGQL extends Apollo.Mutation<GenerateAg1TableOutputFileMutation, GenerateAg1TableOutputFileMutationVariables> {
    document = GenerateAg1TableOutputFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirAddendumHeaderByIdDocument = gql`
    query AirAddendumHeaderById($id: Int!) {
  addendumHeaderById(id: $id) {
    ...airAddendumHeaderFields
    addendumLineItems {
      ...airAddendumLineItemFields
    }
  }
}
    ${AirAddendumHeaderFieldsFragmentDoc}
${AirAddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirAddendumHeaderByIdGQL extends Apollo.Query<AirAddendumHeaderByIdQuery, AirAddendumHeaderByIdQueryVariables> {
    document = AirAddendumHeaderByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumsOnAirFreightShipmentDocument = gql`
    query AddendumsOnAirFreightShipment($airFreightShipmentId: Int!) {
  addendumsOnAirFreightShipment(airFreightShipmentId: $airFreightShipmentId) {
    id
    loadOutInstructions {
      id
      loadOutReference
      airFreightShipmentLineItem {
        externalShipmentId
        airFreightShipment {
          masterWaybillNumber
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumsOnAirFreightShipmentGQL extends Apollo.Query<AddendumsOnAirFreightShipmentQuery, AddendumsOnAirFreightShipmentQueryVariables> {
    document = AddendumsOnAirFreightShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentLoisDocument = gql`
    query AirFreightShipmentLois($airFreightShipmentId: ID!) {
  airFreightShipmentLois(airFreightShipmentId: $airFreightShipmentId) {
    id
    loadOutReference
    airWaybillNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentLoisGQL extends Apollo.Query<AirFreightShipmentLoisQuery, AirFreightShipmentLoisQueryVariables> {
    document = AirFreightShipmentLoisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAirAddendumDocument = gql`
    mutation GenerateAirAddendum($loiIds: [ID!]!) {
  generateAirAddendum(loiIds: $loiIds) {
    errors
    addendumHeader {
      ...airAddendumHeaderFields
      addendumLineItems {
        ...airAddendumLineItemFields
      }
    }
  }
}
    ${AirAddendumHeaderFieldsFragmentDoc}
${AirAddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAirAddendumGQL extends Apollo.Mutation<GenerateAirAddendumMutation, GenerateAirAddendumMutationVariables> {
    document = GenerateAirAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAirAddendumDocument = gql`
    mutation UpdateAirAddendum($addendumLineItems: [AddendumLineItemAttributes!]!, $addendumHeader: AddendumHeaderAttributes!) {
  updateAirAddendum(
    addendumLineItems: $addendumLineItems
    addendumHeader: $addendumHeader
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAirAddendumGQL extends Apollo.Mutation<UpdateAirAddendumMutation, UpdateAirAddendumMutationVariables> {
    document = UpdateAirAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelAirAddendumDocument = gql`
    mutation CancelAirAddendum($id: Int!) {
  cancelAirAddendum(id: $id) {
    id
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelAirAddendumGQL extends Apollo.Mutation<CancelAirAddendumMutation, CancelAirAddendumMutationVariables> {
    document = CancelAirAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAddendumHeaderOutputFilesDocument = gql`
    mutation GenerateAddendumHeaderOutputFiles($addendumHeaderId: ID!) {
  generateAddendumHeaderOutputFiles(addendumHeaderId: $addendumHeaderId) {
    templateOutput {
      errorReason
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAddendumHeaderOutputFilesGQL extends Apollo.Mutation<GenerateAddendumHeaderOutputFilesMutation, GenerateAddendumHeaderOutputFilesMutationVariables> {
    document = GenerateAddendumHeaderOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratePalletOutOutputFilesDocument = gql`
    mutation GeneratePalletOutOutputFiles($addendumHeaderId: ID!) {
  generatePalletOutOutputFiles(addendumHeaderId: $addendumHeaderId) {
    palletOutId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratePalletOutOutputFilesGQL extends Apollo.Mutation<GeneratePalletOutOutputFilesMutation, GeneratePalletOutOutputFilesMutationVariables> {
    document = GeneratePalletOutOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnPalletOutOutputStateChangeDocument = gql`
    subscription onPalletOutOutputStateChange {
  onPalletOutOutputStateChange {
    ...palletOutFields
  }
}
    ${PalletOutFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnPalletOutOutputStateChangeGQL extends Apollo.Subscription<OnPalletOutOutputStateChangeSubscription, OnPalletOutOutputStateChangeSubscriptionVariables> {
    document = OnPalletOutOutputStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentsDocument = gql`
    query AirFreightShipments($filterAttributes: AirFreightShipmentsFilter!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  airFreightShipments(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...airFreightShipmentFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${AirFreightShipmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentsGQL extends Apollo.Query<AirFreightShipmentsQuery, AirFreightShipmentsQueryVariables> {
    document = AirFreightShipmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentsFilterAttributesDocument = gql`
    query AirFreightShipmentsFilterAttributes {
  airFreightShipmentsFilterAttributes {
    carrierNames
    controllers
    flightNumbers
    states
    shippers
    masterWaybillNumbers
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentsFilterAttributesGQL extends Apollo.Query<AirFreightShipmentsFilterAttributesQuery, AirFreightShipmentsFilterAttributesQueryVariables> {
    document = AirFreightShipmentsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentLineItemsByShipmentDocument = gql`
    query airFreightShipmentLineItemsByShipment($id: Int!) {
  airFreightShipmentLineItemsByShipment(id: $id) {
    ...airFreightShipmentLineItemFields
    airFreightShipment {
      id
    }
  }
}
    ${AirFreightShipmentLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentLineItemsByShipmentGQL extends Apollo.Query<AirFreightShipmentLineItemsByShipmentQuery, AirFreightShipmentLineItemsByShipmentQueryVariables> {
    document = AirFreightShipmentLineItemsByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentByIdDocument = gql`
    query airFreightShipmentById($id: Int!) {
  airFreightShipmentById(id: $id) {
    ...airFreightShipmentFields
    airFreightShipmentLineItems {
      ...airFreightShipmentLineItemFields
    }
  }
}
    ${AirFreightShipmentFieldsFragmentDoc}
${AirFreightShipmentLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentByIdGQL extends Apollo.Query<AirFreightShipmentByIdQuery, AirFreightShipmentByIdQueryVariables> {
    document = AirFreightShipmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NestedAirFreightShipmentLineItemsDocument = gql`
    query NestedAirFreightShipmentLineItems($airFreightShipmentId: ID!) {
  nestedAirFreightShipmentLineItems(airFreightShipmentId: $airFreightShipmentId) {
    bookingReference
    collectionDate
    comments
    commodityCode
    consignee
    consignor
    eta
    externalShipmentId
    finalDestinationCode
    finalDestinationLocation
    finalPortOfDischargeCode
    finalPortOfDischargeLocation
    goodsDescription
    grossDimensions
    grossWeight
    housebill
    id
    isTransshipment
    natureOfGoods
    packageQuantity
    packageType
    orderReference
    specialHandling
    transshipmentPort
    transshipmentCarrierName
    transshipmentFlightNumber
    volume
    lastStatusMessage
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NestedAirFreightShipmentLineItemsGQL extends Apollo.Query<NestedAirFreightShipmentLineItemsQuery, NestedAirFreightShipmentLineItemsQueryVariables> {
    document = NestedAirFreightShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnallocatedAirFreightShipmentLineItemsDocument = gql`
    query UnallocatedAirFreightShipmentLineItems($orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  unallocatedAirFreightShipmentLineItems(
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      bookingReference
      collectionDate
      comments
      commodityCode
      consignee
      consignor
      createdAt
      eta
      externalShipmentId
      finalDestinationCode
      finalDestinationLocation
      finalPortOfDischargeCode
      finalPortOfDischargeLocation
      goodsDescription
      grossDimensions
      grossWeight
      housebill
      id
      isTransshipment
      natureOfGoods
      packageQuantity
      packageType
      orderReference
      specialHandling
      lastStatusMessage
      state
      transshipmentPort
      transshipmentCarrierName
      transshipmentFlightNumber
      updatedAt
      volume
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnallocatedAirFreightShipmentLineItemsGQL extends Apollo.Query<UnallocatedAirFreightShipmentLineItemsQuery, UnallocatedAirFreightShipmentLineItemsQueryVariables> {
    document = UnallocatedAirFreightShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmployeesDocument = gql`
    query Employees {
  employees {
    id
    userFirstName
    userLastName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmployeesGQL extends Apollo.Query<EmployeesQuery, EmployeesQueryVariables> {
    document = EmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteAirFreightShipmentDocument = gql`
    mutation CompleteAirFreightShipment($completeAirFreightShipmentId: Int!) {
  completeAirFreightShipment(id: $completeAirFreightShipmentId) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteAirFreightShipmentGQL extends Apollo.Mutation<CompleteAirFreightShipmentMutation, CompleteAirFreightShipmentMutationVariables> {
    document = CompleteAirFreightShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAirFreightShipmentControllerDocument = gql`
    mutation UpdateAirFreightShipmentController($airFreightShipmentId: Int!, $controllerId: Int, $controllerName: String) {
  updateAirFreightShipmentController(
    airFreightShipmentId: $airFreightShipmentId
    controllerId: $controllerId
    controllerName: $controllerName
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAirFreightShipmentControllerGQL extends Apollo.Mutation<UpdateAirFreightShipmentControllerMutation, UpdateAirFreightShipmentControllerMutationVariables> {
    document = UpdateAirFreightShipmentControllerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransnetVisitsByShipmentIdDocument = gql`
    mutation fetchTransnetVisitsByShipmentId($shipmentId: ID!) {
  fetchTransnetVisitsByShipment(shipmentId: $shipmentId) {
    visitList {
      arrivalNumber
      vesselName
      port
      vesselCallSign
      imoNumber
      arrivalDate
      departureDate
      voyageNumberIn
      voyageNumberOut
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransnetVisitsByShipmentIdGQL extends Apollo.Mutation<FetchTransnetVisitsByShipmentIdMutation, FetchTransnetVisitsByShipmentIdMutationVariables> {
    document = FetchTransnetVisitsByShipmentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransnetContainerOperatorsDocument = gql`
    mutation fetchTransnetContainerOperators {
  fetchTransnetContainerOperators {
    containerOperators
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransnetContainerOperatorsGQL extends Apollo.Mutation<FetchTransnetContainerOperatorsMutation, FetchTransnetContainerOperatorsMutationVariables> {
    document = FetchTransnetContainerOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransnetAccountsDocument = gql`
    query fetchTransnetAccounts {
  transnetAccounts {
    id
    number
    seaPort {
      id
      unLocode
      name
      country
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransnetAccountsGQL extends Apollo.Query<FetchTransnetAccountsQuery, FetchTransnetAccountsQueryVariables> {
    document = FetchTransnetAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCargoDueDocument = gql`
    mutation createCargoDue($cargoDueData: Json!, $sliIds: [ID!]!, $transnetVisit: Json!) {
  createCargoDue(
    cargoDueData: $cargoDueData
    sliIds: $sliIds
    transnetVisit: $transnetVisit
  ) {
    cargoDue {
      id
      status
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCargoDueGQL extends Apollo.Mutation<CreateCargoDueMutation, CreateCargoDueMutationVariables> {
    document = CreateCargoDueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CargoDuesDocument = gql`
    query cargoDues($filterAttributes: CargoDuesFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  cargoDues(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      shipmentId
      clientReference
      shippingLineReference
      estimatedTimeOfDeparture
      actualTimeOfDeparture
      sliContainer {
        id
      }
      numberOfContainers
      cargoDue {
        id
        status
        submissionDate
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CargoDuesGQL extends Apollo.Query<CargoDuesQuery, CargoDuesQueryVariables> {
    document = CargoDuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransnetTerminalsDocument = gql`
    query transnetTerminals {
  transnetTerminals {
    name
    code
    portName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TransnetTerminalsGQL extends Apollo.Query<TransnetTerminalsQuery, TransnetTerminalsQueryVariables> {
    document = TransnetTerminalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonCountsDocument = gql`
    query CartonCounts {
  cartonCounts {
    id
    name
    commodityId
    cartonTypeId
    counts
    priceMetric
    stackSizes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonCountsGQL extends Apollo.Query<CartonCountsQuery, CartonCountsQueryVariables> {
    document = CartonCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonGroupingsDocument = gql`
    query CartonGroupings($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      ...cartonGrouping
    }
  }
}
    ${CartonGroupingFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonGroupingsGQL extends Apollo.Query<CartonGroupingsQuery, CartonGroupingsQueryVariables> {
    document = CartonGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CashFlowCartonGroupingsDocument = gql`
    query CashFlowCartonGroupings($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      ...cashFlowCartonGrouping
    }
  }
}
    ${CashFlowCartonGroupingFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CashFlowCartonGroupingsGQL extends Apollo.Query<CashFlowCartonGroupingsQuery, CashFlowCartonGroupingsQueryVariables> {
    document = CashFlowCartonGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainerClaimsDocument = gql`
    query ContainerClaims($containerClaimId: ID, $claimLineItemGroupingId: ID, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $tab: ArrivalQcTabEnum!, $first: Int, $last: Int, $after: String, $before: String) {
  claims(
    containerClaimId: $containerClaimId
    claimLineItemGroupingId: $claimLineItemGroupingId
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    tab: $tab
  ) {
    containerClaims(first: $first, last: $last, after: $after, before: $before) {
      nodes {
        ...ContainerClaimFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainerClaimsGQL extends Apollo.Query<ContainerClaimsQuery, ContainerClaimsQueryVariables> {
    document = ContainerClaimsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClaimLineItemGroupingsDocument = gql`
    query ClaimLineItemGroupings($containerClaimId: ID, $claimLineItemGroupingId: ID, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $tab: ArrivalQcTabEnum!, $first: Int, $last: Int, $after: String, $before: String) {
  claims(
    containerClaimId: $containerClaimId
    claimLineItemGroupingId: $claimLineItemGroupingId
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    tab: $tab
  ) {
    containerClaims(first: $first, last: $last, after: $after, before: $before) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
    claimLineItemGroupings {
      ...ClaimLineItemGroupingFields
    }
  }
}
    ${ClaimLineItemGroupingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClaimLineItemGroupingsGQL extends Apollo.Query<ClaimLineItemGroupingsQuery, ClaimLineItemGroupingsQueryVariables> {
    document = ClaimLineItemGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClaimLineItemPalletsDocument = gql`
    query ClaimLineItemPallets($containerClaimId: ID, $claimLineItemGroupingId: ID, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $tab: ArrivalQcTabEnum!, $first: Int, $last: Int, $after: String, $before: String) {
  claims(
    containerClaimId: $containerClaimId
    claimLineItemGroupingId: $claimLineItemGroupingId
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    tab: $tab
  ) {
    containerClaims(first: $first, last: $last, after: $after, before: $before) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
    claimLineItemPallets {
      id
      palletNumber
      arrivalQcGrade
      expectedClaim
      claimLineItemGroupingId
      claimLineItems {
        id
      }
      progressiveClaimLineItemDefects {
        ...ClaimLineItemDefectFields
      }
      progressiveDefectOptions {
        ...DefectFields
      }
      cosmeticClaimLineItemDefects {
        ...ClaimLineItemDefectFields
      }
      cosmeticDefectOptions {
        ...DefectFields
      }
      otherClaimLineItemDefects {
        ...ClaimLineItemDefectFields
      }
      otherDefectOptions {
        ...DefectFields
      }
      commodity {
        id
        name
      }
    }
  }
}
    ${ClaimLineItemDefectFieldsFragmentDoc}
${DefectFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClaimLineItemPalletsGQL extends Apollo.Query<ClaimLineItemPalletsQuery, ClaimLineItemPalletsQueryVariables> {
    document = ClaimLineItemPalletsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainersForArrivalQcDocument = gql`
    query ContainersForArrivalQc($searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!]) {
  containersForArrivalQc(
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    containerNumber
    vesselName
    voyageNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainersForArrivalQcGQL extends Apollo.Query<ContainersForArrivalQcQuery, ContainersForArrivalQcQueryVariables> {
    document = ContainersForArrivalQcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BreakBulkContainersForArrivalQcDocument = gql`
    query BreakBulkContainersForArrivalQc($searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!]) {
  breakBulkContainersForArrivalQc(
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    voyageNumber
    vesselName
    counterParty {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BreakBulkContainersForArrivalQcGQL extends Apollo.Query<BreakBulkContainersForArrivalQcQuery, BreakBulkContainersForArrivalQcQueryVariables> {
    document = BreakBulkContainersForArrivalQcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArrivalQcClaimLineItemPalletGradeDocument = gql`
    mutation UpdateArrivalQcClaimLineItemPalletGrade($claimLineItemIds: [ID!]!, $arrivalQcGrade: ArrivalQcGradeEnum!) {
  updateArrivalQcClaimLineItemPalletGrade(
    claimLineItemIds: $claimLineItemIds
    arrivalQcGrade: $arrivalQcGrade
  ) {
    containerClaim {
      ...ContainerClaimFields
    }
    errors
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArrivalQcClaimLineItemPalletGradeGQL extends Apollo.Mutation<UpdateArrivalQcClaimLineItemPalletGradeMutation, UpdateArrivalQcClaimLineItemPalletGradeMutationVariables> {
    document = UpdateArrivalQcClaimLineItemPalletGradeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArrivalQcClaimLineItemGroupingGradeDocument = gql`
    mutation UpdateArrivalQcClaimLineItemGroupingGrade($claimLineItemGroupingId: ID!, $arrivalQcGrade: ArrivalQcGradeEnum!) {
  updateArrivalQcClaimLineItemGroupingGrade(
    claimLineItemGroupingId: $claimLineItemGroupingId
    arrivalQcGrade: $arrivalQcGrade
  ) {
    containerClaim {
      ...ContainerClaimFields
    }
    errors
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArrivalQcClaimLineItemGroupingGradeGQL extends Apollo.Mutation<UpdateArrivalQcClaimLineItemGroupingGradeMutation, UpdateArrivalQcClaimLineItemGroupingGradeMutationVariables> {
    document = UpdateArrivalQcClaimLineItemGroupingGradeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemGroupingExpectedClaimDocument = gql`
    mutation UpdateClaimLineItemGroupingExpectedClaim($claimLineItemGroupingId: ID!, $expectedClaim: ExpectedClaimEnum!) {
  updateClaimLineItemGroupingExpectedClaim(
    claimLineItemGroupingId: $claimLineItemGroupingId
    expectedClaim: $expectedClaim
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemGroupingExpectedClaimGQL extends Apollo.Mutation<UpdateClaimLineItemGroupingExpectedClaimMutation, UpdateClaimLineItemGroupingExpectedClaimMutationVariables> {
    document = UpdateClaimLineItemGroupingExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemPalletExpectedClaimDocument = gql`
    mutation UpdateClaimLineItemPalletExpectedClaim($claimLineItemIds: [ID!]!, $expectedClaim: ExpectedClaimEnum!) {
  updateClaimLineItemPalletExpectedClaim(
    claimLineItemIds: $claimLineItemIds
    expectedClaim: $expectedClaim
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemPalletExpectedClaimGQL extends Apollo.Mutation<UpdateClaimLineItemPalletExpectedClaimMutation, UpdateClaimLineItemPalletExpectedClaimMutationVariables> {
    document = UpdateClaimLineItemPalletExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemGroupingCommentDocument = gql`
    mutation UpdateClaimLineItemGroupingComment($claimLineItemGroupingId: ID!, $comment: String) {
  updateClaimLineItemGroupingComment(
    claimLineItemGroupingId: $claimLineItemGroupingId
    comment: $comment
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemGroupingCommentGQL extends Apollo.Mutation<UpdateClaimLineItemGroupingCommentMutation, UpdateClaimLineItemGroupingCommentMutationVariables> {
    document = UpdateClaimLineItemGroupingCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemGroupingDefectDocument = gql`
    mutation UpdateClaimLineItemGroupingDefect($claimLineItemGroupingId: ID!, $defectId: ID!) {
  updateClaimLineItemGroupingDefect(
    claimLineItemGroupingId: $claimLineItemGroupingId
    defectId: $defectId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemGroupingDefectGQL extends Apollo.Mutation<UpdateClaimLineItemGroupingDefectMutation, UpdateClaimLineItemGroupingDefectMutationVariables> {
    document = UpdateClaimLineItemGroupingDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemPalletDefectDocument = gql`
    mutation UpdateClaimLineItemPalletDefect($claimLineItemIds: [ID!]!, $defectId: ID!) {
  updateClaimLineItemPalletDefect(
    claimLineItemIds: $claimLineItemIds
    defectId: $defectId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemPalletDefectGQL extends Apollo.Mutation<UpdateClaimLineItemPalletDefectMutation, UpdateClaimLineItemPalletDefectMutationVariables> {
    document = UpdateClaimLineItemPalletDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContainerClaimNoteDocument = gql`
    mutation UpdateContainerClaimNote($containerClaimId: ID!, $note: String) {
  updateContainerClaimNote(containerClaimId: $containerClaimId, note: $note) {
    errors
    containerClaim {
      ...ContainerClaimFields
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContainerClaimNoteGQL extends Apollo.Mutation<UpdateContainerClaimNoteMutation, UpdateContainerClaimNoteMutationVariables> {
    document = UpdateContainerClaimNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArrivalQcCaptureDatetimeDocument = gql`
    mutation UpdateArrivalQcCaptureDatetime($containerClaimId: ID!, $arrivalQcCaptureDatetime: ISO8601DateTime) {
  updateArrivalQcCaptureDatetime(
    containerClaimId: $containerClaimId
    arrivalQcCaptureDatetime: $arrivalQcCaptureDatetime
  ) {
    errors
    containerClaim {
      ...ContainerClaimFields
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArrivalQcCaptureDatetimeGQL extends Apollo.Mutation<UpdateArrivalQcCaptureDatetimeMutation, UpdateArrivalQcCaptureDatetimeMutationVariables> {
    document = UpdateArrivalQcCaptureDatetimeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkContainerClaimAsCompletedDocument = gql`
    mutation MarkContainerClaimAsCompleted($containerClaimId: ID!) {
  markContainerClaimAsCompleted(containerClaimId: $containerClaimId) {
    errors
    containerClaimId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkContainerClaimAsCompletedGQL extends Apollo.Mutation<MarkContainerClaimAsCompletedMutation, MarkContainerClaimAsCompletedMutationVariables> {
    document = MarkContainerClaimAsCompletedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContainerClaimGradeDocument = gql`
    mutation UpdateContainerClaimGrade($containerClaimId: ID!, $arrivalQcState: ArrivalQcStateEnum!, $arrivalQcGrade: ArrivalQcGradeEnum!) {
  updateContainerClaimGrade(
    containerClaimId: $containerClaimId
    arrivalQcState: $arrivalQcState
    arrivalQcGrade: $arrivalQcGrade
  ) {
    containerClaim {
      ...ContainerClaimFields
    }
    errors
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContainerClaimGradeGQL extends Apollo.Mutation<UpdateContainerClaimGradeMutation, UpdateContainerClaimGradeMutationVariables> {
    document = UpdateContainerClaimGradeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaptureDefectPercentagesDocument = gql`
    mutation CaptureDefectPercentages($attributes: DefectPercentageCaptureAttributes!) {
  captureDefectPercentages(attributes: $attributes) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaptureDefectPercentagesGQL extends Apollo.Mutation<CaptureDefectPercentagesMutation, CaptureDefectPercentagesMutationVariables> {
    document = CaptureDefectPercentagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemGroupingDefectDocument = gql`
    mutation RemoveClaimLineItemGroupingDefect($claimLineItemGroupingId: ID!, $defectId: ID!) {
  removeClaimLineItemGroupingDefect(
    claimLineItemGroupingId: $claimLineItemGroupingId
    defectId: $defectId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemGroupingDefectGQL extends Apollo.Mutation<RemoveClaimLineItemGroupingDefectMutation, RemoveClaimLineItemGroupingDefectMutationVariables> {
    document = RemoveClaimLineItemGroupingDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemPalletDefectDocument = gql`
    mutation RemoveClaimLineItemPalletDefect($claimLineItemIds: [ID!]!, $defectId: ID!, $claimLineItemGroupingId: ID!) {
  removeClaimLineItemPalletDefect(
    claimLineItemIds: $claimLineItemIds
    defectId: $defectId
    claimLineItemGroupingId: $claimLineItemGroupingId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemPalletDefectGQL extends Apollo.Mutation<RemoveClaimLineItemPalletDefectMutation, RemoveClaimLineItemPalletDefectMutationVariables> {
    document = RemoveClaimLineItemPalletDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemGroupingExpectedClaimDocument = gql`
    mutation RemoveClaimLineItemGroupingExpectedClaim($claimLineItemGroupingId: ID!, $expectedClaim: ExpectedClaimEnum!) {
  removeClaimLineItemGroupingExpectedClaim(
    claimLineItemGroupingId: $claimLineItemGroupingId
    expectedClaim: $expectedClaim
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemGroupingExpectedClaimGQL extends Apollo.Mutation<RemoveClaimLineItemGroupingExpectedClaimMutation, RemoveClaimLineItemGroupingExpectedClaimMutationVariables> {
    document = RemoveClaimLineItemGroupingExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemPalletExpectedClaimDocument = gql`
    mutation RemoveClaimLineItemPalletExpectedClaim($claimLineItemIds: [ID!]!) {
  removeClaimLineItemPalletExpectedClaim(claimLineItemIds: $claimLineItemIds) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemPalletExpectedClaimGQL extends Apollo.Mutation<RemoveClaimLineItemPalletExpectedClaimMutation, RemoveClaimLineItemPalletExpectedClaimMutationVariables> {
    document = RemoveClaimLineItemPalletExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SoftDeleteContainerClaimDocument = gql`
    mutation softDeleteContainerClaim($containerClaimId: ID!) {
  softDeleteContainerClaim(containerClaimId: $containerClaimId) {
    error
    containerClaimId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SoftDeleteContainerClaimGQL extends Apollo.Mutation<SoftDeleteContainerClaimMutation, SoftDeleteContainerClaimMutationVariables> {
    document = SoftDeleteContainerClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadClaimFilesDocument = gql`
    mutation UploadClaimFiles($containerClaimId: ID!, $files: [Upload!]!) {
  uploadClaimFiles(containerClaimId: $containerClaimId, files: $files) {
    errors
    containerClaim {
      ...ContainerClaimFields
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadClaimFilesGQL extends Apollo.Mutation<UploadClaimFilesMutation, UploadClaimFilesMutationVariables> {
    document = UploadClaimFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateArrivalQcsDocument = gql`
    mutation GenerateArrivalQcs($containerableIds: [ID!]!, $containerableType: ContainerableTypeEnum!) {
  generateArrivalQcs(
    containerableIds: $containerableIds
    containerableType: $containerableType
  ) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateArrivalQcsGQL extends Apollo.Mutation<GenerateArrivalQcsMutation, GenerateArrivalQcsMutationVariables> {
    document = GenerateArrivalQcsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnArrivalQcGenerationStateChangeDocument = gql`
    subscription OnArrivalQcGenerationStateChange {
  onArrivalQcGenerationStateChange {
    containerableId
    containerableType
    containerNumber
    vesselName
    voyageNumber
    status
    errorMessage
    containerClaimId
    counterParty {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnArrivalQcGenerationStateChangeGQL extends Apollo.Subscription<OnArrivalQcGenerationStateChangeSubscription, OnArrivalQcGenerationStateChangeSubscriptionVariables> {
    document = OnArrivalQcGenerationStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommentDocument = gql`
    mutation CreateComment($attributes: CreateCommentAttributes!) {
  createComment(attributes: $attributes) {
    comment {
      ...commentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommentGQL extends Apollo.Mutation<CreateCommentMutation, CreateCommentMutationVariables> {
    document = CreateCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentid: Int!) {
  deleteComment(commentId: $commentid) {
    comment {
      ...commentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommentGQL extends Apollo.Mutation<DeleteCommentMutation, DeleteCommentMutationVariables> {
    document = DeleteCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommercialTermChangeRequestDocument = gql`
    mutation CreateCommercialTermChangeRequest($attributes: CreateCommercialTermChangeRequestAttributes!) {
  createCommercialTermChangeRequest(attributes: $attributes) {
    changeRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommercialTermChangeRequestGQL extends Apollo.Mutation<CreateCommercialTermChangeRequestMutation, CreateCommercialTermChangeRequestMutationVariables> {
    document = CreateCommercialTermChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommercialTermsDocument = gql`
    query CommercialTerms($filterAttributes: CommercialTermFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  commercialTerms(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...commercialTerm
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${CommercialTermFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommercialTermsGQL extends Apollo.Query<CommercialTermsQuery, CommercialTermsQueryVariables> {
    document = CommercialTermsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommercialTermFilterAttributesDocument = gql`
    query CommercialTermFilterAttributes {
  commercialTermFilterAttributes {
    targetRegions
    advanceTypes
    advanceUnits
    commodities {
      id
      name
    }
    buyers {
      id
      name
    }
    events
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommercialTermFilterAttributesGQL extends Apollo.Query<CommercialTermFilterAttributesQuery, CommercialTermFilterAttributesQueryVariables> {
    document = CommercialTermFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonTypesByCommodityDocument = gql`
    query CartonTypesByCommodity($commodityId: ID!) {
  cartonTypesByCommodity(commodityId: $commodityId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonTypesByCommodityGQL extends Apollo.Query<CartonTypesByCommodityQuery, CartonTypesByCommodityQueryVariables> {
    document = CartonTypesByCommodityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertCommercialTermDocument = gql`
    mutation UpsertCommercialTerm($attributes: CommercialTermAttributes!) {
  upsertCommercialTerm(attributes: $attributes) {
    errors
    commercialTerm {
      ...commercialTerm
    }
  }
}
    ${CommercialTermFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertCommercialTermGQL extends Apollo.Mutation<UpsertCommercialTermMutation, UpsertCommercialTermMutationVariables> {
    document = UpsertCommercialTermDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommoditiesDocument = gql`
    query Commodities {
  commodities {
    id
    name
    varieties {
      id
      name
      varietyName
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommoditiesGQL extends Apollo.Query<CommoditiesQuery, CommoditiesQueryVariables> {
    document = CommoditiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportersDocument = gql`
    query Exporters {
  supplierExporters {
    supplierExporters {
      id
      name
      exporterCodes {
        id
        exporterCode
      }
      exporter {
        id
        name
      }
      foodBusinessOperators {
        id
        fboCode
        createdAt
        updatedAt
      }
      coldStores {
        id
        name
        fboCode
        createdAt
        updatedAt
      }
      coldStoreClientChangeRequests {
        id
        status
        companyAssociation {
          id
          name
          createdAt
          updatedAt
        }
        coldStore {
          id
          name
          fboCode
          createdAt
          updatedAt
        }
      }
      exporterLogoImageUrl
      masterfileConfig {
        id
        state
      }
      isPackhouseContainerised
    }
    clientChangeRequests {
      id
      supplier {
        id
        name
      }
      exporter {
        id
        name
      }
      exporterCodes {
        id
        exporterCode
      }
      foodBusinessOperators {
        id
        fboCode
        createdAt
        updatedAt
      }
      coldStores {
        id
        name
        fboCode
        createdAt
        updatedAt
      }
      exporterLogoImageUrl
      relation
      oneswitchFacilitated
      exporterName
      fboId
      isPackhouseContainerised
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportersGQL extends Apollo.Query<ExportersQuery, ExportersQueryVariables> {
    document = ExportersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExporterFbosDocument = gql`
    query ExporterFbos {
  exporterFbos {
    id
    name
    fboCode
    company {
      id
      companyLogoImageUrl
      exporterCodes {
        id
        exporterCode
      }
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExporterFbosGQL extends Apollo.Query<ExporterFbosQuery, ExporterFbosQueryVariables> {
    document = ExporterFbosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExporterAndColdStoreClientRequestDocument = gql`
    mutation CreateExporterAndColdStoreClientRequest($exporterFboId: ID!, $coldStoreIds: [ID!]!, $isPackhouseContainerised: Boolean) {
  createExporterAndColdStoreClientRequest(
    exporterFboId: $exporterFboId
    coldStoreIds: $coldStoreIds
    isPackhouseContainerised: $isPackhouseContainerised
  ) {
    errors
    clientChangeRequest {
      id
      fboId
      isPackhouseContainerised
      coldStores {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExporterAndColdStoreClientRequestGQL extends Apollo.Mutation<CreateExporterAndColdStoreClientRequestMutation, CreateExporterAndColdStoreClientRequestMutationVariables> {
    document = CreateExporterAndColdStoreClientRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigCompanyAssociationsDocument = gql`
    mutation ConfirmMasterfileConfigCompanyAssociations($masterfileConfigs: [MasterfileConfigCompanyAssociationInput!]!) {
  confirmMasterfileConfigCompanyAssociations(
    masterfileConfigs: $masterfileConfigs
  ) {
    errors
    masterfileConfigs {
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigCompanyAssociationsGQL extends Apollo.Mutation<ConfirmMasterfileConfigCompanyAssociationsMutation, ConfirmMasterfileConfigCompanyAssociationsMutationVariables> {
    document = ConfirmMasterfileConfigCompanyAssociationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSupplierExporterRequestDocument = gql`
    mutation CreateSupplierExporterRequest($attributes: CreateSupplierExporterRequestAttribute!) {
  createSupplierExporterRequest(attributes: $attributes) {
    clientChangeRequests {
      id
      supplier {
        id
        name
      }
      exporter {
        id
        name
      }
      exporterCodes {
        id
        exporterCode
      }
      foodBusinessOperators {
        id
        fboCode
        createdAt
        updatedAt
      }
      exporterLogoImageUrl
      exporterName
      relation
      oneswitchFacilitated
      isPackhouseContainerised
      fboId
      createdAt
      updatedAt
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSupplierExporterRequestGQL extends Apollo.Mutation<CreateSupplierExporterRequestMutation, CreateSupplierExporterRequestMutationVariables> {
    document = CreateSupplierExporterRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmExporterColdStoresDocument = gql`
    mutation ConfirmExporterColdStores($companyAssociationExportColdStoreAttributes: [CompanyAssociationExportColdStoreAttributes!]!, $clientChangeRequestExportColdStoreAttributes: [ClientChangeRequestExportColdStoreAttributes!]!) {
  confirmExporterColdStores(
    companyAssociationExportColdStoreAttributes: $companyAssociationExportColdStoreAttributes
    clientChangeRequestExportColdStoreAttributes: $clientChangeRequestExportColdStoreAttributes
  ) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmExporterColdStoresGQL extends Apollo.Mutation<ConfirmExporterColdStoresMutation, ConfirmExporterColdStoresMutationVariables> {
    document = ConfirmExporterColdStoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExporterColdStoreRequestDocument = gql`
    mutation CreateExporterColdStoreRequest($companyAssociationId: ID!, $coldStoreIds: [ID!]!, $isPackhouseContainerisation: Boolean!) {
  createExporterColdStoreRequest(
    companyAssociationId: $companyAssociationId
    coldStoreIds: $coldStoreIds
    isPackhouseContainerisation: $isPackhouseContainerisation
  ) {
    success
    errors
    clientChangeRequests {
      status
      companyAssociation {
        id
      }
      coldStore {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExporterColdStoreRequestGQL extends Apollo.Mutation<CreateExporterColdStoreRequestMutation, CreateExporterColdStoreRequestMutationVariables> {
    document = CreateExporterColdStoreRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadCompanyCertificateDocument = gql`
    mutation UploadCompanyCertificate($file: Upload!, $expirydate: String!, $companyid: Int!, $certificatetypeid: Int!) {
  uploadCompanyCertificate(
    file: $file
    expiryDate: $expirydate
    companyId: $companyid
    certificateTypeId: $certificatetypeid
  ) {
    certificate {
      id
      expiryDate
      createdAt
      certificate {
        id
        filename
        url
        v2Url
      }
      certificateType {
        name
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadCompanyCertificateGQL extends Apollo.Mutation<UploadCompanyCertificateMutation, UploadCompanyCertificateMutationVariables> {
    document = UploadCompanyCertificateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyCertificateDocument = gql`
    mutation DeleteCompanyCertificate($id: Int!) {
  deleteCompanyCertificate(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyCertificateGQL extends Apollo.Mutation<DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables> {
    document = DeleteCompanyCertificateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CertificateTypeDocument = gql`
    query CertificateType {
  certificateTypes {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CertificateTypeGQL extends Apollo.Query<CertificateTypeQuery, CertificateTypeQueryVariables> {
    document = CertificateTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyCompanyDocument = gql`
    query MyCompany {
  myCompany {
    id
    name
    about
    registrationNumber
    vatNumber
    createdAt
    state
    onboardingStep
    logoFile {
      id
      filename
      url
    }
    address {
      addressLine1
      addressLine2
      city
      postalCode
      country
    }
    tradeRegions {
      id
      name
      code
      countries {
        id
        name
        code
      }
    }
    certificates {
      id
      expiryDate
      createdAt
      updatedAt
      certificate {
        id
        filename
        url
        v2Url
      }
      certificateType {
        name
        id
      }
    }
    varieties {
      id
      varietyId
      variety {
        id
        name
        varietyCode
      }
      name
      peakCount
      hectares
      packingStart
      packingEnd
      commodity {
        id
        name
        icon {
          v2Url
        }
      }
      images {
        id
        url
        v2Url
        filename
        thumbnailUrl
        v2ThumbnailUrl
      }
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
    additionalFields {
      id
      companyId
      name
      description
      fieldType
      parameters
      createdAt
      updatedAt
      isPackingInstruction
      private
    }
    activeUsers {
      id
      firstName
      lastName
      phoneNumber
      email
      state
      role
      roles {
        id
        name
        resourceType
        resourceId
        createdAt
        updatedAt
      }
      employee {
        id
      }
    }
    invites {
      id
      email
      state
    }
    defaultLocale
    sellers {
      id
      name
    }
    isSeller
    buyers {
      id
      name
    }
    isBuyer
    commoditySeasons {
      ...commoditySeason
    }
  }
}
    ${CommoditySeasonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyCompanyGQL extends Apollo.Query<MyCompanyQuery, MyCompanyQueryVariables> {
    document = MyCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradePartnersForMyCompanyDocument = gql`
    query tradePartnersForMyCompany {
  myCompany {
    buyers {
      id
      name
    }
    sellers {
      id
      name
    }
    isBuyer
    isSeller
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TradePartnersForMyCompanyGQL extends Apollo.Query<TradePartnersForMyCompanyQuery, TradePartnersForMyCompanyQueryVariables> {
    document = TradePartnersForMyCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDetailsDocument = gql`
    mutation UpdateCompanyDetails($attributes: UpdateCompanyAttributes!) {
  updateCompanyDetails(attributes: $attributes) {
    company {
      id
      name
      about
      registrationNumber
      vatNumber
      address {
        addressLine1
        addressLine2
        city
        postalCode
        country
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyDetailsGQL extends Apollo.Mutation<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables> {
    document = UpdateCompanyDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadCompanyLogoDocument = gql`
    mutation UploadCompanyLogo($file: Upload!, $companyid: Int!) {
  uploadCompanyLogo(file: $file, companyId: $companyid) {
    company {
      logoFile {
        id
        filename
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadCompanyLogoGQL extends Apollo.Mutation<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables> {
    document = UploadCompanyLogoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyTradeRegionsDocument = gql`
    mutation UpdateCompanyTradeRegions($addtraderegions: [TradeRegionAttributes!]!, $removetraderegions: [TradeRegionAttributes!]!) {
  updateCompanyTradeRegions(
    addTradeRegions: $addtraderegions
    removeTradeRegions: $removetraderegions
  ) {
    company {
      tradeRegions {
        id
        name
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyTradeRegionsGQL extends Apollo.Mutation<UpdateCompanyTradeRegionsMutation, UpdateCompanyTradeRegionsMutationVariables> {
    document = UpdateCompanyTradeRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrencyConversionDocument = gql`
    query CurrencyConversion($currencyConversionAttributes: CurrencyConversionAttributes!) {
  currencyConversion(currencyConversionAttributes: $currencyConversionAttributes) {
    id
    rates
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrencyConversionGQL extends Apollo.Query<CurrencyConversionQuery, CurrencyConversionQueryVariables> {
    document = CurrencyConversionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrencyConversionByIdDocument = gql`
    query CurrencyConversionById($currencyConversionId: ID!) {
  currencyConversionById(currencyConversionId: $currencyConversionId) {
    id
    rates
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrencyConversionByIdGQL extends Apollo.Query<CurrencyConversionByIdQuery, CurrencyConversionByIdQueryVariables> {
    document = CurrencyConversionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertCurrencyExchangeRateDocument = gql`
    mutation UpsertCurrencyExchangeRate($currencyExchangeRateAttributes: CurrencyExchangeRateAttributes!) {
  upsertCurrencyExchangeRate(
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    currencyExchangeRate {
      id
      toCurrency
      fromCurrency
      exchangeRate
      exchangeRateType
      exchangeRateDate
      currencyConversionId
      exchangeableId
      exchangeableType
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertCurrencyExchangeRateGQL extends Apollo.Mutation<UpsertCurrencyExchangeRateMutation, UpsertCurrencyExchangeRateMutationVariables> {
    document = UpsertCurrencyExchangeRateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCurrencyExchangeRateDocument = gql`
    mutation DeleteCurrencyExchangeRate($currencyExchangeRateId: ID!) {
  deleteCurrencyExchangeRate(currencyExchangeRateId: $currencyExchangeRateId) {
    currencyExchangeRateId
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCurrencyExchangeRateGQL extends Apollo.Mutation<DeleteCurrencyExchangeRateMutation, DeleteCurrencyExchangeRateMutationVariables> {
    document = DeleteCurrencyExchangeRateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrencyExchangeRateDocument = gql`
    query CurrencyExchangeRate($exchangeableId: ID!, $exchangeableType: String!) {
  currencyExchangeRate(
    exchangeableId: $exchangeableId
    exchangeableType: $exchangeableType
  ) {
    id
    toCurrency
    fromCurrency
    exchangeRate
    exchangeRateType
    exchangeRateDate
    currencyConversionId
    exchangeableId
    exchangeableType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrencyExchangeRateGQL extends Apollo.Query<CurrencyExchangeRateQuery, CurrencyExchangeRateQueryVariables> {
    document = CurrencyExchangeRateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardQueryDocument = gql`
    query DashboardQuery($locationId: Int, $containerId: Int, $commoditygroups: [CommodityGroupEnum!], $forExport: Boolean) {
  dashboardTrackingData(
    locationId: $locationId
    containerId: $containerId
    commoditygroups: $commoditygroups
    forExport: $forExport
  ) {
    cartonGroupings {
      batchNumber
      cartons
      commodityName
      consignmentNumber
      containerId
      exporterCode
      farmCode
      grade
      id
      inspectionDate
      inventoryCode
      locationId
      mark
      netMass
      orchard
      packhouseCode
      packingWeek
      palletGrossMass
      palletNumber
      productCharacteristic
      sequenceNumber
      state
      targetMarket
      targetCountry
      targetRegion
      varietyName
    }
    containers {
      arrivalDate
      arrivalEventClassifier
      cartons
      cartonsInTransit
      containerId
      containerNumber
      containerType
      departureDate
      departureEventClassifier
      finalDestinationId
      finalDeliveryDatetime
      finalDestinationName
      finalDestinationType
      locationId
      id
      nextDeliveryDatetime
      nextDestinationId
      nextDestinationName
      nextDestinationType
      pallets
      palletsInTransit
      state
      stateInTransit
    }
    locations {
      id
      cartons
      cartonsInTransit
      containers
      containersInTransit
      geoLocation {
        lat
        lon
      }
      locationId
      locationType
      name
      pallets
      palletsInTransit
      unallocated
      unallocatedInTransit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardQueryGQL extends Apollo.Query<DashboardQueryQuery, DashboardQueryQueryVariables> {
    document = DashboardQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardSearchDocument = gql`
    query DashboardSearch($fields: [DashboardSearchFieldsEnum!], $searchTerm: String, $commodityGroups: [CommodityGroupEnum!]) {
  dashboardSearch(
    fields: $fields
    searchTerm: $searchTerm
    commodityGroups: $commodityGroups
  ) {
    raw
    hits {
      score
      highlight
      source {
        ... on DashboardCartonGrouping {
          batchNumber
          cartons
          commodityName
          consignmentNumber
          containerId
          containerNumber
          exporterCode
          farmCode
          grade
          id
          inspectionDate
          inventoryCode
          locationId
          mark
          netMass
          orchard
          packhouseCode
          packingWeek
          palletGrossMass
          palletNumber
          productCharacteristic
          sequenceNumber
          state
          targetCountry
          targetMarket
          targetRegion
          varietyName
        }
        ... on DashboardContainer {
          arrivalDate
          cartons
          cartonsInTransit
          collectionDatetime
          containerId
          containerNumber
          containerType
          departureDate
          finalDeliveryDatetime
          finalDestinationId
          finalDestinationLatitude
          finalDestinationLongitude
          finalDestinationName
          finalDestinationType
          id
          locationId
          nextDeliveryDatetime
          nextDestinationId
          nextDestinationLatitude
          nextDestinationLongitude
          nextDestinationName
          nextDestinationType
          pallets
          palletsInTransit
          state
          stateInTransit
        }
        ... on DashboardLocation {
          cartons
          cartonsInTransit
          containers
          containersInTransit
          id
          locationId
          locationType
          name
          pallets
          palletsInTransit
          unallocated
          unallocatedInTransit
        }
      }
    }
    total {
      relation
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardSearchGQL extends Apollo.Query<DashboardSearchQuery, DashboardSearchQueryVariables> {
    document = DashboardSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardFiltersDocument = gql`
    query DashboardFilters {
  dashboardFilters {
    commodities {
      id
      name
      commodityGroup
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardFiltersGQL extends Apollo.Query<DashboardFiltersQuery, DashboardFiltersQueryVariables> {
    document = DashboardFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DataPreparationsDocument = gql`
    query DataPreparations {
  dataPreparations {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DataPreparationsGQL extends Apollo.Query<DataPreparationsQuery, DataPreparationsQueryVariables> {
    document = DataPreparationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DataPreparationDocument = gql`
    query DataPreparation($id: ID!) {
  dataPreparation(id: $id) {
    dataOutputs {
      createdAt
      downloadedAt
      fileType
      id
      outputFile {
        contentType
        filename
        id
        url
        v2Url
      }
    }
    error
    id
    description
    name
    status
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DataPreparationGQL extends Apollo.Query<DataPreparationQuery, DataPreparationQueryVariables> {
    document = DataPreparationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateDataOutputFilesDocument = gql`
    mutation GenerateDataOutputFiles($id: ID!) {
  generateDataOutputFiles(id: $id) {
    dataPreparation {
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateDataOutputFilesGQL extends Apollo.Mutation<GenerateDataOutputFilesMutation, GenerateDataOutputFilesMutationVariables> {
    document = GenerateDataOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDataOutputDocument = gql`
    mutation UpdateDataOutput($attributes: DataOutputAttributes!) {
  updateDataOutput(attributes: $attributes) {
    dataOutput {
      id
      downloadedAt
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDataOutputGQL extends Apollo.Mutation<UpdateDataOutputMutation, UpdateDataOutputMutationVariables> {
    document = UpdateDataOutputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefaultCostsDocument = gql`
    query DefaultCosts($filterAttributes: DefaultCostFilters, $first: Int, $last: Int, $after: String, $before: String) {
  defaultCosts(
    filterAttributes: $filterAttributes
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      cartonGroupingTransaction {
        id
        cartonGrouping {
          palletNumber
          containerNumber
        }
        currency
        amountMajorUnit
        isActual
        quantityPriceMajorUnit
        quantityAmount
        quantityType
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DefaultCostsGQL extends Apollo.Query<DefaultCostsQuery, DefaultCostsQueryVariables> {
    document = DefaultCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinanceRuleDocument = gql`
    query financeRule($id: ID!) {
  financeRule(id: $id) {
    id
    name
    amountCents
    ruleDescription
    createdAt
    endDate
    enabled
    isDefaultCost
    defaultCgtsFinalised
    defaultCgtsPendingReview
    currency
    unit
    percentage
    humanReadableExpression
    incotermForPercentageCalculation
    costCode {
      id
      name
    }
    groupedCostCodes {
      costCode {
        id
        name
      }
      startDate
      endDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinanceRuleGQL extends Apollo.Query<FinanceRuleQuery, FinanceRuleQueryVariables> {
    document = FinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDefaultCostsDocument = gql`
    mutation RemoveDefaultCosts($attributes: RemoveDefaultCostAttributes!) {
  removeDefaultCosts(attributes: $attributes) {
    errors
    cgtIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultCostsGQL extends Apollo.Mutation<RemoveDefaultCostsMutation, RemoveDefaultCostsMutationVariables> {
    document = RemoveDefaultCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinaliseDefaultCostsDocument = gql`
    mutation FinaliseDefaultCosts($attributes: FinaliseDefaultCostAttributes!) {
  finaliseDefaultCosts(attributes: $attributes) {
    errors
    cgtIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinaliseDefaultCostsGQL extends Apollo.Mutation<FinaliseDefaultCostsMutation, FinaliseDefaultCostsMutationVariables> {
    document = FinaliseDefaultCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainersForFinanceRuleDocument = gql`
    query ContainersForFinanceRule($financeRuleId: ID!) {
  containersForFinanceRule(financeRuleId: $financeRuleId) {
    id
    containerNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainersForFinanceRuleGQL extends Apollo.Query<ContainersForFinanceRuleQuery, ContainersForFinanceRuleQueryVariables> {
    document = ContainersForFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadDocumentsDocument = gql`
    mutation DownloadDocuments($documentAttributes: [DownloadDocumentAttributes!]!, $zippedFilename: String!) {
  downloadDocuments(
    documentAttributes: $documentAttributes
    zippedFilename: $zippedFilename
  ) {
    url
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadDocumentsGQL extends Apollo.Mutation<DownloadDocumentsMutation, DownloadDocumentsMutationVariables> {
    document = DownloadDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendEmailDocument = gql`
    mutation SendEmail($attributes: SendEmailAttributes!) {
  sendEmail(attributes: $attributes) {
    errors
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendEmailGQL extends Apollo.Mutation<SendEmailMutation, SendEmailMutationVariables> {
    document = SendEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmailDocumentsDocument = gql`
    mutation EmailDocuments($attributes: EmailDocumentsAttributes!) {
  emailDocuments(attributes: $attributes) {
    errors
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmailDocumentsGQL extends Apollo.Mutation<EmailDocumentsMutation, EmailDocumentsMutationVariables> {
    document = EmailDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmailTaskDocumentsDocument = gql`
    mutation EmailTaskDocuments($attributes: EmailTaskDocumentsAttributes!) {
  emailTaskDocuments(attributes: $attributes) {
    errors
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmailTaskDocumentsGQL extends Apollo.Mutation<EmailTaskDocumentsMutation, EmailTaskDocumentsMutationVariables> {
    document = EmailTaskDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateEphytoDocument = gql`
    mutation DuplicateEphyto($id: Int!, $applicationType: Int!) {
  duplicateEphyto(id: $id, applicationType: $applicationType) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateEphytoGQL extends Apollo.Mutation<DuplicateEphytoMutation, DuplicateEphytoMutationVariables> {
    document = DuplicateEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEphytoDocument = gql`
    mutation DeleteEphyto($id: Int!) {
  deleteEphyto(id: $id) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEphytoGQL extends Apollo.Mutation<DeleteEphytoMutation, DeleteEphytoMutationVariables> {
    document = DeleteEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEphytoDocumentDocument = gql`
    mutation UpdateEphytoDocument($id: Int!, $type: String!) {
  updateEphytoDocument(id: $id, type: $type) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEphytoDocumentGQL extends Apollo.Mutation<UpdateEphytoDocumentMutation, UpdateEphytoDocumentMutationVariables> {
    document = UpdateEphytoDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadEphytoDocumentDocument = gql`
    mutation UploadEphytoDocument($ephytoId: Int!, $file: Upload!) {
  uploadEphytoDocument(ephytoId: $ephytoId, file: $file) {
    errors
    ephytoDocuments {
      ...ephytoDocumentFields
    }
  }
}
    ${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadEphytoDocumentGQL extends Apollo.Mutation<UploadEphytoDocumentMutation, UploadEphytoDocumentMutationVariables> {
    document = UploadEphytoDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEphytoDocumentDocument = gql`
    mutation DeleteEphytoDocument($id: Int!) {
  deleteEphytoDocument(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEphytoDocumentGQL extends Apollo.Mutation<DeleteEphytoDocumentMutation, DeleteEphytoDocumentMutationVariables> {
    document = DeleteEphytoDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDraftEphytoDocument = gql`
    mutation UpdateDraftEphyto($ephytoId: Int!) {
  updateDraftEphyto(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDraftEphytoGQL extends Apollo.Mutation<UpdateDraftEphytoMutation, UpdateDraftEphytoMutationVariables> {
    document = UpdateDraftEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitEphytoDocument = gql`
    mutation SubmitEphyto($ephytoId: Int!) {
  submitEphyto(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitEphytoGQL extends Apollo.Mutation<SubmitEphytoMutation, SubmitEphytoMutationVariables> {
    document = SubmitEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DraftEphytoDocument = gql`
    mutation DraftEphyto($ephytoId: Int!) {
  draftEphyto(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DraftEphytoGQL extends Apollo.Mutation<DraftEphytoMutation, DraftEphytoMutationVariables> {
    document = DraftEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchEphytoStatusDocument = gql`
    mutation FetchEphytoStatus($ephytoId: Int!) {
  fetchEphytoStatus(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchEphytoStatusGQL extends Apollo.Mutation<FetchEphytoStatusMutation, FetchEphytoStatusMutationVariables> {
    document = FetchEphytoStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateEphytoDocument = gql`
    mutation GenerateEphyto($isEntireBooking: Boolean!, $shipmentType: String!, $bookingReference: String, $ephytoId: Int, $sliIds: [Int!]) {
  generateEphyto(
    isEntireBooking: $isEntireBooking
    shipmentType: $shipmentType
    bookingReference: $bookingReference
    ephytoId: $ephytoId
    sliIds: $sliIds
  ) {
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
    errors
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateEphytoGQL extends Apollo.Mutation<GenerateEphytoMutation, GenerateEphytoMutationVariables> {
    document = GenerateEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateEphytoTradeUnitDocument = gql`
    mutation GenerateEphytoTradeUnit($shipmentType: String!, $ephytoId: Int) {
  generateEphytoTradeUnit(shipmentType: $shipmentType, ephytoId: $ephytoId) {
    errors
    ephytoTradeUnits {
      ...ephytoTradeUnitCommonFields
    }
  }
}
    ${EphytoTradeUnitCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateEphytoTradeUnitGQL extends Apollo.Mutation<GenerateEphytoTradeUnitMutation, GenerateEphytoTradeUnitMutationVariables> {
    document = GenerateEphytoTradeUnitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEphytoDocument = gql`
    mutation UpdateEphyto($ephyto: EphytoAttributes!, $ephytoConsignmentItems: [EphytoConsignmentItemAttributes!]!) {
  updateEphyto(ephyto: $ephyto, ephytoConsignmentItems: $ephytoConsignmentItems) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEphytoGQL extends Apollo.Mutation<UpdateEphytoMutation, UpdateEphytoMutationVariables> {
    document = UpdateEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoPackageTypesDocument = gql`
    query EphytoPackageTypes {
  ephytoPackageTypes {
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoPackageTypesGQL extends Apollo.Query<EphytoPackageTypesQuery, EphytoPackageTypesQueryVariables> {
    document = EphytoPackageTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoAppliedChemicalsDocument = gql`
    query EphytoAppliedChemicals {
  ephytoAppliedChemicals
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoAppliedChemicalsGQL extends Apollo.Query<EphytoAppliedChemicalsQuery, EphytoAppliedChemicalsQueryVariables> {
    document = EphytoAppliedChemicalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoTransportMeansDocument = gql`
    query EphytoTransportMeans {
  ephytoTransportMeans
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoTransportMeansGQL extends Apollo.Query<EphytoTransportMeansQuery, EphytoTransportMeansQueryVariables> {
    document = EphytoTransportMeansDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoUnitOfMeasureCodesDocument = gql`
    query EphytoUnitOfMeasureCodes {
  ephytoUnitOfMeasureCodes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoUnitOfMeasureCodesGQL extends Apollo.Query<EphytoUnitOfMeasureCodesQuery, EphytoUnitOfMeasureCodesQueryVariables> {
    document = EphytoUnitOfMeasureCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoTreatmentsDocument = gql`
    query EphytoTreatments {
  ephytoTreatments {
    firstLevel
    firstLevelCode
    secondLevel
    secondLevelCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoTreatmentsGQL extends Apollo.Query<EphytoTreatmentsQuery, EphytoTreatmentsQueryVariables> {
    document = EphytoTreatmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoCountriesDocument = gql`
    query EphytoCountries {
  ephytoCountries {
    isoCode
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoCountriesGQL extends Apollo.Query<EphytoCountriesQuery, EphytoCountriesQueryVariables> {
    document = EphytoCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoAgreementCodesDocument = gql`
    query EphytoAgreementCodes {
  ephytoAgreementCodes {
    agreementCode
    agreementName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoAgreementCodesGQL extends Apollo.Query<EphytoAgreementCodesQuery, EphytoAgreementCodesQueryVariables> {
    document = EphytoAgreementCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoLocationsDocument = gql`
    query EphytoLocations($countryCodes: [String!]!) {
  ephytoLocations(countryCodes: $countryCodes) {
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoLocationsGQL extends Apollo.Query<EphytoLocationsQuery, EphytoLocationsQueryVariables> {
    document = EphytoLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoPortOfEntriesDocument = gql`
    query EphytoPortOfEntries($countryCodes: [String!]!) {
  ephytoPortOfEntries(countryCodes: $countryCodes) {
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoPortOfEntriesGQL extends Apollo.Query<EphytoPortOfEntriesQuery, EphytoPortOfEntriesQueryVariables> {
    document = EphytoPortOfEntriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoContactsDocument = gql`
    query EphytoContacts {
  contacts {
    id
    name
    info
    contactType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoContactsGQL extends Apollo.Query<EphytoContactsQuery, EphytoContactsQueryVariables> {
    document = EphytoContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NonEphytoShipmentLineItemsDocument = gql`
    query nonEphytoShipmentLineItems($shipmentId: Int!, $type: String!) {
  nonEphytoShipmentLineItems(shipmentId: $shipmentId, type: $type) {
    id
    labelDisplay
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NonEphytoShipmentLineItemsGQL extends Apollo.Query<NonEphytoShipmentLineItemsQuery, NonEphytoShipmentLineItemsQueryVariables> {
    document = NonEphytoShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytosDocument = gql`
    query ephytos($filterAttributes: EphytoFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  ephytos(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      id
      agreementCode
      applicationStatus
      state
      targetCountry
      unloadingBaseportLocation
      customReferenceNo
      applicationReferenceNo
      desiredIssueLocation
      departureDate
      applicationType
      consignorName
      consigneeName
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytosGQL extends Apollo.Query<EphytosQuery, EphytosQueryVariables> {
    document = EphytosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoFilterAttributesDocument = gql`
    query EphytoFilterAttributes {
  ephytoFilterAttributes {
    statuses
    customerReferences
    entryPorts
    consignees
    consignors
    vessels
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoFilterAttributesGQL extends Apollo.Query<EphytoFilterAttributesQuery, EphytoFilterAttributesQueryVariables> {
    document = EphytoFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoCertificateUrlDocument = gql`
    query EphytoCertificateUrl($id: Int!) {
  ephytoCertificateUrl(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoCertificateUrlGQL extends Apollo.Query<EphytoCertificateUrlQuery, EphytoCertificateUrlQueryVariables> {
    document = EphytoCertificateUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportDocumentTypesDocument = gql`
    query ExportDocumentTypes {
  exportDocumentTypes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportDocumentTypesGQL extends Apollo.Query<ExportDocumentTypesQuery, ExportDocumentTypesQueryVariables> {
    document = ExportDocumentTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoDocumentTypesDocument = gql`
    query EphytoDocumentTypes {
  ephytoDocumentTypes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoDocumentTypesGQL extends Apollo.Query<EphytoDocumentTypesQuery, EphytoDocumentTypesQueryVariables> {
    document = EphytoDocumentTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoByIdDocument = gql`
    query EphytoById($id: Int!) {
  ephytoById(id: $id) {
    ...ephytoCommonFields
    ephytoTradeUnits {
      ...ephytoTradeUnitCommonFields
    }
    ephytoConsignmentItems {
      ...ephytoConsignmentItemCommonFields
    }
    ephytoDocuments {
      ...ephytoDocumentFields
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoByIdGQL extends Apollo.Query<EphytoByIdQuery, EphytoByIdQueryVariables> {
    document = EphytoByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimateConfigDocument = gql`
    query estimateConfig {
  uiConfigs(configType: "estimate-config", visibility: Company) {
    id
    data
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimateConfigGQL extends Apollo.Query<EstimateConfigQuery, EstimateConfigQueryVariables> {
    document = EstimateConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimateOptionsDocument = gql`
    query estimateOptions($season: Int!) {
  myCompany {
    id
    name
    sellers {
      id
      name
    }
    allCompanies {
      id
      name
    }
  }
  commodities(onlyOperational: true) {
    id
    name
  }
  varieties(onlyOperational: true, skipMixedVarieties: true) {
    id
    name
    commodity {
      id
    }
  }
  productionUnits: foodBusinessOperators(businessTypes: [0], includeSellers: true) {
    id
    name
    typeOfBusiness
    fboCode
    company {
      id
      name
    }
  }
  packhouses: foodBusinessOperators(
    businessTypes: [1, 5]
    includeSellers: true
    includeThirdPartyPackhouses: true
  ) {
    id
    name
    typeOfBusiness
    fboCode
    company {
      id
    }
  }
  fboOrchards(includeSellers: true) {
    id
    hectares(season: $season)
    orchard
    block
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
    foodBusinessOperator {
      id
      fboCode
      name
      company {
        id
        name
      }
    }
  }
  cartonCounts {
    id
    name
    commodityId
    cartonTypeId
    counts
    priceMetric
    stackSizes
  }
  commodityDefaultSeasons {
    commodityId
    minWeek(year: $season)
    maxWeek(year: $season)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimateOptionsGQL extends Apollo.Query<EstimateOptionsQuery, EstimateOptionsQueryVariables> {
    document = EstimateOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimatesDocument = gql`
    query Estimates($endWeek: String, $startWeek: String, $weeks: Boolean, $season: Int, $matchCols: [EstimateMatchModeEnum!], $commodityIds: [Int!], $subCommodityIds: [Int!], $varietyIds: [Int!], $onlyEditableEstimates: Boolean) {
  estimates(
    endWeek: $endWeek
    startWeek: $startWeek
    weeks: $weeks
    season: $season
    commodityIds: $commodityIds
    subCommodityIds: $subCommodityIds
    varietyIds: $varietyIds
    onlyEditableEstimates: $onlyEditableEstimates
  ) {
    id
    week
    season
    provider {
      id
      name
    }
    fboOrchard {
      id
      orchard
      hectares(season: $season)
      foodBusinessOperator {
        company {
          id
        }
      }
    }
    cartonType {
      id
      name
    }
    commodity {
      id
      name
    }
    variety {
      id
      name
      subCommodity {
        name
      }
    }
    productionUnit {
      id
      name
      fboCode
      typeOfBusiness
    }
    packHouse {
      id
      name
      fboCode
      typeOfBusiness
    }
    visibleCompanies {
      id
      name
    }
    estimateValues {
      id
      estType
      value
      conversionWeight
      grade
      sizeCounts
      acceptedValue(matchCols: $matchCols)
      inSeasonValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimatesGQL extends Apollo.Query<EstimatesQuery, EstimatesQueryVariables> {
    document = EstimatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrchardSeasonsDocument = gql`
    query OrchardSeasons($season: Int!) {
  orchardSeasons(season: $season) {
    id
    startDate
    endDate
    hectares
    plantedDate
    fboOrchard {
      orchard
      foodBusinessOperator {
        fboCode
      }
      variety {
        name
        commodity {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrchardSeasonsGQL extends Apollo.Query<OrchardSeasonsQuery, OrchardSeasonsQueryVariables> {
    document = OrchardSeasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrchardYieldsDocument = gql`
    query OrchardYields($orchardSeasonId: ID, $capturedBefore: ISO8601DateTime!, $capturedAfter: ISO8601DateTime!) {
  orchardYields(
    orchardSeasonId: $orchardSeasonId
    capturedBefore: $capturedBefore
    capturedAfter: $capturedAfter
  ) {
    id
    weight
    weightPerBin
    orchardSeasonId
    captureDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrchardYieldsGQL extends Apollo.Query<OrchardYieldsQuery, OrchardYieldsQueryVariables> {
    document = OrchardYieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrchardSeasonsDocument = gql`
    mutation UpdateOrchardSeasons($updateData: [OrchardSeasonAttributes!], $deleteData: [Int!]) {
  updateOrchardSeasons(updateData: $updateData, deleteData: $deleteData) {
    createSummary {
      succeeded
      failed
      errors
    }
    updateSummary {
      succeeded
      failed
      errors
    }
    deleteSummary {
      succeeded
      failed
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrchardSeasonsGQL extends Apollo.Mutation<UpdateOrchardSeasonsMutation, UpdateOrchardSeasonsMutationVariables> {
    document = UpdateOrchardSeasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateCommoditySeasonsDocument = gql`
    mutation GenerateCommoditySeasons($season: Int!) {
  generateCommoditySeasons(seasonYear: $season) {
    error
    failures
    successes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateCommoditySeasonsGQL extends Apollo.Mutation<GenerateCommoditySeasonsMutation, GenerateCommoditySeasonsMutationVariables> {
    document = GenerateCommoditySeasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrchardYieldsDocument = gql`
    mutation UpdateOrchardYields($createData: [OrchardYieldAttributes!], $updateData: [OrchardYieldAttributes!], $deleteData: [Int!]) {
  updateOrchardYields(
    createData: $createData
    updateData: $updateData
    deleteData: $deleteData
  ) {
    createSummary {
      errors
      failed
      succeeded
    }
    updateSummary {
      succeeded
      failed
      errors
    }
    deleteSummary {
      succeeded
      failed
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrchardYieldsGQL extends Apollo.Mutation<UpdateOrchardYieldsMutation, UpdateOrchardYieldsMutationVariables> {
    document = UpdateOrchardYieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEstimatesDocument = gql`
    mutation UpdateEstimates($createData: [EstimateAttributes!], $deleteData: [Int!], $updateData: [EstimateAttributes!]) {
  updateEstimates(
    createData: $createData
    deleteData: $deleteData
    updateData: $updateData
  ) {
    createSummary {
      succeeded
      failed
      errors
    }
    updateSummary {
      succeeded
      failed
      errors
    }
    deleteSummary {
      succeeded
      failed
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEstimatesGQL extends Apollo.Mutation<UpdateEstimatesMutation, UpdateEstimatesMutationVariables> {
    document = UpdateEstimatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsDocument = gql`
    query Documents($first: Int, $last: Int, $after: String, $before: String, $dateAfter: ISO8601DateTime, $dateBefore: ISO8601DateTime, $states: [EtlDocumentStateEnum!], $emailFrom: String, $emailTo: String, $documentTypes: [String!], $orderByFields: [ColumnOrderAttributes!]) {
  documents(
    first: $first
    last: $last
    after: $after
    before: $before
    dateAfter: $dateAfter
    dateBefore: $dateBefore
    states: $states
    emailFrom: $emailFrom
    emailTo: $emailTo
    documentTypes: $documentTypes
    orderByFields: $orderByFields
  ) {
    nodes {
      ...documentFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsGQL extends Apollo.Query<DocumentsQuery, DocumentsQueryVariables> {
    document = DocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentDocument = gql`
    query Document($documentId: Int!) {
  document(id: $documentId) {
    ...documentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentGQL extends Apollo.Query<DocumentQuery, DocumentQueryVariables> {
    document = DocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentRowsDocument = gql`
    query DocumentRows($after: String, $before: String, $first: Int, $last: Int, $documentId: Int!, $states: [EtlDocumentRowStateEnum!]) {
  documentRows(
    after: $after
    before: $before
    first: $first
    last: $last
    documentId: $documentId
    states: $states
  ) {
    nodes {
      createdAt
      errorReason
      id
      processOutput
      state
      value
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentRowsGQL extends Apollo.Query<DocumentRowsQuery, DocumentRowsQueryVariables> {
    document = DocumentRowsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadEtlDocumentDocument = gql`
    mutation UploadEtlDocument($documentId: Int!, $file: Upload!) {
  uploadEtlDocument(documentId: $documentId, file: $file) {
    document {
      ...documentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadEtlDocumentGQL extends Apollo.Mutation<UploadEtlDocumentMutation, UploadEtlDocumentMutationVariables> {
    document = UploadEtlDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessEtlDocumentDocument = gql`
    mutation ProcessEtlDocument($documentId: Int!) {
  processEtlDocument(documentId: $documentId) {
    document {
      ...documentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessEtlDocumentGQL extends Apollo.Mutation<ProcessEtlDocumentMutation, ProcessEtlDocumentMutationVariables> {
    document = ProcessEtlDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFarmVarietyDocument = gql`
    mutation CreateFarmVariety($attributes: CreateFarmVarietyAttributes!) {
  createFarmVariety(attributes: $attributes) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFarmVarietyGQL extends Apollo.Mutation<CreateFarmVarietyMutation, CreateFarmVarietyMutationVariables> {
    document = CreateFarmVarietyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFarmVarietyDocument = gql`
    mutation UpdateFarmVariety($attributes: UpdateFarmVarietyAttributes!) {
  updateFarmVariety(attributes: $attributes) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFarmVarietyGQL extends Apollo.Mutation<UpdateFarmVarietyMutation, UpdateFarmVarietyMutationVariables> {
    document = UpdateFarmVarietyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFarmVarietyDocument = gql`
    mutation DeleteFarmVariety($varietyid: Int!, $companyId: Int!) {
  deleteFarmVariety(varietyId: $varietyid, companyId: $companyId) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFarmVarietyGQL extends Apollo.Mutation<DeleteFarmVarietyMutation, DeleteFarmVarietyMutationVariables> {
    document = DeleteFarmVarietyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadFarmVarietyImageDocument = gql`
    mutation UploadFarmVarietyImage($id: Int!, $image: Upload!) {
  uploadFarmVarietyImage(id: $id, image: $image) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadFarmVarietyImageGQL extends Apollo.Mutation<UploadFarmVarietyImageMutation, UploadFarmVarietyImageMutationVariables> {
    document = UploadFarmVarietyImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFarmVarietyImageDocument = gql`
    mutation DeleteFarmVarietyImage($varietyid: Int!, $imageid: Int!) {
  deleteFarmVarietyImage(varietyId: $varietyid, imageId: $imageid) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFarmVarietyImageGQL extends Apollo.Mutation<DeleteFarmVarietyImageMutation, DeleteFarmVarietyImageMutationVariables> {
    document = DeleteFarmVarietyImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinanceReportDocument = gql`
    query FinanceReport($attributes: FinanceReportFilterAttributes!) {
  financeReport(attributes: $attributes) {
    items {
      commodity
      variety
      amount
      amountPerCarton
      batchNumber
      buyer
      packType
      cartons
      stdCartons
      containerNumber
      currency
      exchangeRate
      exporterCode
      farmCode
      grade
      incoterm
      isActual
      palletNumber
      liReferenceNumber
      txReferenceNumber
      seller
      sizeCount
      state
      targetMarket
      targetRegion
      transactionDate
      transactionType
      transactionWeek
      shippingWeek
      packingWeek
      generalLedgerName
      secondaryCategory
      primaryCategory
      zarAmount
      zarPerCarton
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinanceReportGQL extends Apollo.Query<FinanceReportQuery, FinanceReportQueryVariables> {
    document = FinanceReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LatestCurrencyConversionDocument = gql`
    query LatestCurrencyConversion {
  latestCurrencyConversion {
    rates
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LatestCurrencyConversionGQL extends Apollo.Query<LatestCurrencyConversionQuery, LatestCurrencyConversionQueryVariables> {
    document = LatestCurrencyConversionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFinanceRulesDocument = gql`
    query GetFinanceRules($filterAttributes: FinanceRuleFilters!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String, $grouped: Boolean = false, $groupType: String) {
  financeRules(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
    grouped: $grouped
    groupType: $groupType
  ) {
    nodes {
      id
      name
      amountCents
      company {
        id
        name
      }
      costCode {
        id
        name
      }
      matchCondition {
        id
      }
      groupedCostCodes {
        financeRuleId
        costCode {
          id
          name
        }
        startDate
        endDate
        financeRuleId
      }
      createdAt
      currency
      enabled
      endDate
      incotermForPercentageCalculation
      simpleExpression
      simpleExpressionFields
      simpleExpressionMatchTypes
      simpleExpressionValues
      humanReadableExpression
      percentage
      startDate
      unit
      isDefaultCost
      ruleDescription
      updatedAt
      defaultCgtsPendingReview
      defaultCgtsFinalised
      formattedCost
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFinanceRulesGQL extends Apollo.Query<GetFinanceRulesQuery, GetFinanceRulesQueryVariables> {
    document = GetFinanceRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinanceRulesFilterAttributesDocument = gql`
    query FinanceRulesFilterAttributes {
  financeRulesFilterAttributes {
    ruleNames
    costCodes {
      id
      name
    }
    currencies
    units
    startDates
    endDates
    enabled
    isDefaultCost
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinanceRulesFilterAttributesGQL extends Apollo.Query<FinanceRulesFilterAttributesQuery, FinanceRulesFilterAttributesQueryVariables> {
    document = FinanceRulesFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertFinanceRulesDocument = gql`
    mutation UpsertFinanceRules($attributesList: [FinanceRuleAttributes!]!) {
  upsertFinanceRule(attributesList: $attributesList) {
    success
    errors {
      message
    }
    financeRules {
      id
      name
      unit
      amountCents
      currency
      incotermForPercentageCalculation
      percentage
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertFinanceRulesGQL extends Apollo.Mutation<UpsertFinanceRulesMutation, UpsertFinanceRulesMutationVariables> {
    document = UpsertFinanceRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFinanceRuleDocument = gql`
    mutation DeleteFinanceRule($ids: [ID!]!) {
  deleteFinanceRule(ids: $ids) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFinanceRuleGQL extends Apollo.Mutation<DeleteFinanceRuleMutation, DeleteFinanceRuleMutationVariables> {
    document = DeleteFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllowedOptionsDocument = gql`
    query GetAllowedOptions {
  allowedUnits
  allowedIncoterms
  allowedCurrencies
  allowedMatchTypes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllowedOptionsGQL extends Apollo.Query<GetAllowedOptionsQuery, GetAllowedOptionsQueryVariables> {
    document = GetAllowedOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFinanceRuleDocument = gql`
    mutation CreateFinanceRule($attributes: [FinanceRuleAttributes!]!) {
  createFinanceRule(attributes: $attributes) {
    financeRules {
      id
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFinanceRuleGQL extends Apollo.Mutation<CreateFinanceRuleMutation, CreateFinanceRuleMutationVariables> {
    document = CreateFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFinanceRuleDocument = gql`
    mutation UpdateFinanceRule($attributes: [FinanceRuleAttributes!]!, $deleteIds: [ID!]) {
  updateFinanceRule(attributes: $attributes, deleteIds: $deleteIds) {
    financeRules {
      id
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFinanceRuleGQL extends Apollo.Mutation<UpdateFinanceRuleMutation, UpdateFinanceRuleMutationVariables> {
    document = UpdateFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFinanceRuleEnabledStateDocument = gql`
    mutation UpdateFinanceRuleEnabledState($updateIds: [ID!]!, $state: Boolean!) {
  updateFinanceRuleEnabledState(updateIds: $updateIds, state: $state) {
    financeRules {
      id
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFinanceRuleEnabledStateGQL extends Apollo.Mutation<UpdateFinanceRuleEnabledStateMutation, UpdateFinanceRuleEnabledStateMutationVariables> {
    document = UpdateFinanceRuleEnabledStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradeCompaniesDocument = gql`
    query TradeCompanies($id: ID!) {
  company(id: $id) {
    id
    buyers {
      id
      name
    }
    sellers {
      id
      name
    }
    varieties {
      id
      name
    }
    commodities {
      id
      name
    }
    tradeRegions {
      id
      name
      code
      countries {
        id
        name
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TradeCompaniesGQL extends Apollo.Query<TradeCompaniesQuery, TradeCompaniesQueryVariables> {
    document = TradeCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateProducerStatementDocument = gql`
    mutation GenerateProducerStatement($cartonGroupingIds: [Int!]!, $fileFormat: TemplateFileFormatEnum!, $reportingCurrency: String) {
  generateProducerStatement(
    cartonGroupingIds: $cartonGroupingIds
    fileFormat: $fileFormat
    reportingCurrency: $reportingCurrency
  ) {
    fileUrl
    statementNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateProducerStatementGQL extends Apollo.Mutation<GenerateProducerStatementMutation, GenerateProducerStatementMutationVariables> {
    document = GenerateProducerStatementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteUserDocument = gql`
    mutation InviteUser($email: String!, $firstName: String, $lastName: String) {
  inviteUser(email: $email, firstName: $firstName, lastName: $lastName) {
    invite {
      id
      email
      state
      message
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteUserGQL extends Apollo.Mutation<InviteUserMutation, InviteUserMutationVariables> {
    document = InviteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($id: Int!) {
  revokeInvite(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeInviteGQL extends Apollo.Mutation<RevokeInviteMutation, RevokeInviteMutationVariables> {
    document = RevokeInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInviteDocument = gql`
    mutation ResendInvite($id: Int!) {
  resendInvite(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInviteGQL extends Apollo.Mutation<ResendInviteMutation, ResendInviteMutationVariables> {
    document = ResendInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoicesSummaryDocument = gql`
    query invoicesSummary($filterAttributes: InvoicesFilters!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $page: String!, $first: Int, $last: Int, $after: String, $before: String) {
  invoices(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    page: $page
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...invoicesSummaryFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${InvoicesSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoicesSummaryGQL extends Apollo.Query<InvoicesSummaryQuery, InvoicesSummaryQueryVariables> {
    document = InvoicesSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PopulateInvoiceContainerDataDocument = gql`
    query populateInvoiceContainerData($containerId: Int!, $selectedCurrency: String!, $invoiceType: String!, $cgIds: [Int!]!, $commercialTermId: Int) {
  populateInvoiceContainerData(
    containerId: $containerId
    selectedCurrency: $selectedCurrency
    invoiceType: $invoiceType
    cgIds: $cgIds
    commercialTermId: $commercialTermId
  ) {
    invoiceLineItems {
      ...invliCommonFields
    }
    portOfLoading {
      ...invPortFields
    }
    portOfDestination {
      ...invPortFields
    }
    vessel {
      id
      vesselName
    }
    voyage
    commercialTerm {
      id
      paymentTerm
      advanceAmount
      advanceCreditTerm
      advanceType
      advanceUnit
      finalCreditTerm
    }
  }
}
    ${InvliCommonFieldsFragmentDoc}
${InvPortFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PopulateInvoiceContainerDataGQL extends Apollo.Query<PopulateInvoiceContainerDataQuery, PopulateInvoiceContainerDataQueryVariables> {
    document = PopulateInvoiceContainerDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceDocument = gql`
    query invoice($id: Int!) {
  invoice(id: $id) {
    invoiceLineItems {
      ...invliCommonFields
    }
    ...invCommonFields
    currencyExchangeRate {
      id
      fromCurrency
      toCurrency
      exchangeRate
      exchangeRateDate
      exchangeRateType
      currencyConversion {
        id
        rates
        timestamp
      }
    }
    attachedDocuments {
      id
      v2Url
      filename
      contentType
    }
    linkedAdvanceInvoice {
      id
      invoiceNumber
      advancePayment
    }
    overRecoveryCreditNote {
      id
      invoiceNumber
      totalIncoterm
    }
  }
}
    ${InvliCommonFieldsFragmentDoc}
${InvCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceGQL extends Apollo.Query<InvoiceQuery, InvoiceQueryVariables> {
    document = InvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PopulateInvoiceFromParentDocument = gql`
    query populateInvoiceFromParent($parentInvoiceId: Int!, $documentType: String!) {
  populateInvoiceFromParent(
    parentInvoiceId: $parentInvoiceId
    documentType: $documentType
  ) {
    invoice {
      ...invCommonFields
    }
    revenueLineItems {
      ...invliCommonFields
    }
    errors
  }
}
    ${InvCommonFieldsFragmentDoc}
${InvliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PopulateInvoiceFromParentGQL extends Apollo.Query<PopulateInvoiceFromParentQuery, PopulateInvoiceFromParentQueryVariables> {
    document = PopulateInvoiceFromParentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncomeInvoiceLineItemsDocument = gql`
    query IncomeInvoiceLineItems($id: ID!) {
  incomeInvoiceLineItems(id: $id) {
    ...invliCommonFields
  }
}
    ${InvliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IncomeInvoiceLineItemsGQL extends Apollo.Query<IncomeInvoiceLineItemsQuery, IncomeInvoiceLineItemsQueryVariables> {
    document = IncomeInvoiceLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CostInvoiceLineItemsDocument = gql`
    query CostInvoiceLineItems($id: ID!) {
  costInvoiceLineItems(id: $id) {
    ...invliCommonFields
  }
}
    ${InvliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CostInvoiceLineItemsGQL extends Apollo.Query<CostInvoiceLineItemsQuery, CostInvoiceLineItemsQueryVariables> {
    document = CostInvoiceLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceCartonGroupingTransactionsDocument = gql`
    query InvoiceCartonGroupingTransactions($id: Int!) {
  invoiceCartonGroupingTransactions(id: $id) {
    cartonGrouping {
      palletNumber
      cartons
    }
    amountMajorUnit
    currency
    quantityType
    quantityPriceMajorUnit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceCartonGroupingTransactionsGQL extends Apollo.Query<InvoiceCartonGroupingTransactionsQuery, InvoiceCartonGroupingTransactionsQueryVariables> {
    document = InvoiceCartonGroupingTransactionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceFilterAttributesDocument = gql`
    query invoiceFilterAttributes($page: String!) {
  invoicesFilterAttributes(page: $page) {
    vessels {
      id
      vesselName
    }
    contacts {
      id
      name
      contactType
      createdByUserId
    }
    incoterms
    varieties {
      id
      name
    }
    commodities {
      id
      name
    }
    documentTypes {
      type
      name
    }
    states
    targetCountries
    invoiceNumbers
    transportTypes
    containers
    palletNumbers
    costCodes
    exportStatuses
    financialYearOptions {
      year
      label
      startDate
      endDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceFilterAttributesGQL extends Apollo.Query<InvoiceFilterAttributesQuery, InvoiceFilterAttributesQueryVariables> {
    document = InvoiceFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceNumberDocument = gql`
    query invoiceNumber($documenttype: String) {
  invoiceNumber(documenttype: $documenttype)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceNumberGQL extends Apollo.Query<InvoiceNumberQuery, InvoiceNumberQueryVariables> {
    document = InvoiceNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceSeaPortsDocument = gql`
    query invoiceSeaPorts($limit: Int, $seaportname: String, $isportofloading: Boolean, $orderbyinv: Boolean) {
  seaPorts(
    limit: $limit
    seaportname: $seaportname
    isportofloading: $isportofloading
    orderbyinv: $orderbyinv
  ) {
    ...invPortFields
  }
}
    ${InvPortFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceSeaPortsGQL extends Apollo.Query<InvoiceSeaPortsQuery, InvoiceSeaPortsQueryVariables> {
    document = InvoiceSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceScrollTradeCountriesDocument = gql`
    query invoiceScrollTradeCountries($first: Int, $last: Int, $after: String, $before: String, $searchTerm: String) {
  invoiceScrollTradeCountries(
    first: $first
    last: $last
    after: $after
    before: $before
    searchTerm: $searchTerm
  ) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceScrollTradeCountriesGQL extends Apollo.Query<InvoiceScrollTradeCountriesQuery, InvoiceScrollTradeCountriesQueryVariables> {
    document = InvoiceScrollTradeCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceVesselsDocument = gql`
    query invoiceVessels($limit: Int, $seaportid: Int, $vesselname: String) {
  vessels(limit: $limit, seaportid: $seaportid, vesselname: $vesselname) {
    id
    vesselName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceVesselsGQL extends Apollo.Query<InvoiceVesselsQuery, InvoiceVesselsQueryVariables> {
    document = InvoiceVesselsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceVoyagesDocument = gql`
    query invoiceVoyages($vesselid: Int!, $seaportid: Int) {
  voyages(vesselid: $vesselid, seaportid: $seaportid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceVoyagesGQL extends Apollo.Query<InvoiceVoyagesQuery, InvoiceVoyagesQueryVariables> {
    document = InvoiceVoyagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceContactsDocument = gql`
    query invoiceContacts {
  contacts {
    id
    name
    info
    contactType
    createdByUserId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceContactsGQL extends Apollo.Query<InvoiceContactsQuery, InvoiceContactsQueryVariables> {
    document = InvoiceContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VatTypesDocument = gql`
    query vatTypes {
  vatTypes {
    id
    name
    percentage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VatTypesGQL extends Apollo.Query<VatTypesQuery, VatTypesQueryVariables> {
    document = VatTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceContainersDocument = gql`
    query invoiceContainers($limit: Int, $port: Int, $containernumber: String, $excludesassignedinvlis: Boolean, $onlytrackingenabled: Boolean) {
  containers(
    limit: $limit
    originportid: $port
    containernumber: $containernumber
    excludesassignedinvlis: $excludesassignedinvlis
    onlytrackingenabled: $onlytrackingenabled
  ) {
    containerNumber
    id
    stuffDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceContainersGQL extends Apollo.Query<InvoiceContainersQuery, InvoiceContainersQueryVariables> {
    document = InvoiceContainersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceUnassignedCGsDocument = gql`
    query invoiceUnassignedCGs($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      ...invCommonCGFields
    }
    filterValues {
      batchNumber
      consignmentNumber
      packingWeek
      targetMarket
      exporterCode
      voyageNumber
      vessel {
        id
        vesselName
      }
      variety {
        id
        name
      }
      seller {
        id
        name
      }
      buyer {
        id
        name
      }
    }
  }
}
    ${InvCommonCgFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceUnassignedCGsGQL extends Apollo.Query<InvoiceUnassignedCGsQuery, InvoiceUnassignedCGsQueryVariables> {
    document = InvoiceUnassignedCGsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchCgCommercialTermDocument = gql`
    query fetchCgCommercialTerm($cgId: ID!) {
  fetchCgCommercialTerm(cgId: $cgId) {
    id
    paymentTerm
    advanceAmount
    advanceCreditTerm
    advanceType
    advanceUnit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchCgCommercialTermGQL extends Apollo.Query<FetchCgCommercialTermQuery, FetchCgCommercialTermQueryVariables> {
    document = FetchCgCommercialTermDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceCustomFieldsDocument = gql`
    query invoiceCustomFields($excludedCustomFieldIds: [Int!]) {
  customFields(excludedCustomFieldIds: $excludedCustomFieldIds) {
    id
    name
    required
    isDefault
    defaultValue
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceCustomFieldsGQL extends Apollo.Query<InvoiceCustomFieldsQuery, InvoiceCustomFieldsQueryVariables> {
    document = InvoiceCustomFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyCostCodesDocument = gql`
    query CompanyCostCodes {
  companyCostCodes {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyCostCodesGQL extends Apollo.Query<CompanyCostCodesQuery, CompanyCostCodesQueryVariables> {
    document = CompanyCostCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateQuickCostDocument = gql`
    mutation CreateQuickCost($attributes: QuickCostAttributes!) {
  createQuickCost(attributes: $attributes) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateQuickCostGQL extends Apollo.Mutation<CreateQuickCostMutation, CreateQuickCostMutationVariables> {
    document = CreateQuickCostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculatePalletCostsDocument = gql`
    mutation CalculatePalletCosts($cgIds: [Int!]!, $costId: Int!) {
  calculatePalletCosts(cgIds: $cgIds, costId: $costId) {
    estimatePalletCosts
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculatePalletCostsGQL extends Apollo.Mutation<CalculatePalletCostsMutation, CalculatePalletCostsMutationVariables> {
    document = CalculatePalletCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContactDocument = gql`
    mutation CreateContact($attributes: ContactAttributes!) {
  createContact(attributes: $attributes) {
    contact {
      id
      name
      info
      contactType
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContactGQL extends Apollo.Mutation<CreateContactMutation, CreateContactMutationVariables> {
    document = CreateContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContactDocument = gql`
    mutation UpdateContact($attributes: ContactAttributes!) {
  updateContact(attributes: $attributes) {
    contact {
      id
      name
      info
      contactType
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContactGQL extends Apollo.Mutation<UpdateContactMutation, UpdateContactMutationVariables> {
    document = UpdateContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: Int!) {
  deleteContact(id: $id) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteContactGQL extends Apollo.Mutation<DeleteContactMutation, DeleteContactMutationVariables> {
    document = DeleteContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomFieldDocument = gql`
    mutation CreateCustomField($attributes: CustomFieldAttributes!) {
  createCustomField(attributes: $attributes) {
    customField {
      id
      name
      required
      isDefault
      defaultValue
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomFieldGQL extends Apollo.Mutation<CreateCustomFieldMutation, CreateCustomFieldMutationVariables> {
    document = CreateCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomFieldDocument = gql`
    mutation UpdateCustomField($attributes: CustomFieldAttributes!) {
  updateCustomField(attributes: $attributes) {
    customField {
      id
      name
      required
      isDefault
      defaultValue
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomFieldGQL extends Apollo.Mutation<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables> {
    document = UpdateCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCustomFieldDocument = gql`
    mutation DeleteCustomField($id: Int!) {
  deleteCustomField(id: $id) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCustomFieldGQL extends Apollo.Mutation<DeleteCustomFieldMutation, DeleteCustomFieldMutationVariables> {
    document = DeleteCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($attributes: InvoiceAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  createInvoice(
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    invoice {
      cartonGroupings {
        ...invCommonCGFields
      }
      invoiceLineItems {
        ...invliCommonFields
      }
      ...invCommonFields
    }
  }
}
    ${InvCommonCgFieldsFragmentDoc}
${InvliCommonFieldsFragmentDoc}
${InvCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceGQL extends Apollo.Mutation<CreateInvoiceMutation, CreateInvoiceMutationVariables> {
    document = CreateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateCommercialsDocument = gql`
    mutation CalculateCommercials($attributes: InvoiceAttributes!) {
  calculateCommercials(attributes: $attributes) {
    errors
    advancePayment
    finalPayment
    advanceCreditTerm
    finalCreditTerm
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateCommercialsGQL extends Apollo.Mutation<CalculateCommercialsMutation, CalculateCommercialsMutationVariables> {
    document = CalculateCommercialsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateInvoiceDocument = gql`
    mutation DuplicateInvoice($id: ID!, $documentType: String!, $shouldDuplicateLineItems: Boolean!) {
  duplicateInvoice(
    id: $id
    documentType: $documentType
    shouldDuplicateLineItems: $shouldDuplicateLineItems
  ) {
    errors
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateInvoiceGQL extends Apollo.Mutation<DuplicateInvoiceMutation, DuplicateInvoiceMutationVariables> {
    document = DuplicateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaptureAccountSaleDocument = gql`
    mutation CaptureAccountSale($id: ID!) {
  captureAccountSale(id: $id) {
    errors
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaptureAccountSaleGQL extends Apollo.Mutation<CaptureAccountSaleMutation, CaptureAccountSaleMutationVariables> {
    document = CaptureAccountSaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInvoiceFromBatchDocument = gql`
    mutation CreateInvoiceFromBatch($invoiceIds: [ID!]!, $documentType: String!) {
  createInvoiceFromBatch(invoiceIds: $invoiceIds, documentType: $documentType) {
    errors
    invoice {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceFromBatchGQL extends Apollo.Mutation<CreateInvoiceFromBatchMutation, CreateInvoiceFromBatchMutationVariables> {
    document = CreateInvoiceFromBatchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($attributes: InvoiceAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  updateInvoice(
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    invoice {
      cartonGroupings {
        ...invCommonCGFields
      }
      invoiceLineItems {
        ...invliCommonFields
      }
      ...invCommonFields
    }
    reconciliationDocuments {
      id
      invoiceNumber
      documentType
    }
  }
}
    ${InvCommonCgFieldsFragmentDoc}
${InvliCommonFieldsFragmentDoc}
${InvCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoiceGQL extends Apollo.Mutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables> {
    document = UpdateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($id: Int!) {
  deleteInvoice(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInvoiceGQL extends Apollo.Mutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables> {
    document = DeleteInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateInvoiceTotalsDocument = gql`
    mutation CalculateInvoiceTotals($attributes: InvoiceIncotermAttributes!) {
  calculateInvoiceIncoterm(attributes: $attributes) {
    invoice {
      id
      cartonCount
      currency
      freightCost
      insuranceCost
      localCosts
      palletCount
      totalFob
      totalIncoterm
      incoterm
      invoiceDate
      advancePayment
      advanceCreditTerm
      finalPayment
      finalCreditTerm
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateInvoiceTotalsGQL extends Apollo.Mutation<CalculateInvoiceTotalsMutation, CalculateInvoiceTotalsMutationVariables> {
    document = CalculateInvoiceTotalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateInvoiceOutputFilesDocument = gql`
    mutation GenerateInvoiceOutputFiles($invoiceId: ID!) {
  generateInvoiceOutputFiles(invoiceId: $invoiceId) {
    templateOutput {
      errorReason
      id
      state
      templateVariant
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateInvoiceOutputFilesGQL extends Apollo.Mutation<GenerateInvoiceOutputFilesMutation, GenerateInvoiceOutputFilesMutationVariables> {
    document = GenerateInvoiceOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInvoiceStateDocument = gql`
    mutation updateInvoiceState($id: Int!, $state: String!) {
  updateInvoiceState(id: $id, state: $state) {
    invoice {
      id
      state
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoiceStateGQL extends Apollo.Mutation<UpdateInvoiceStateMutation, UpdateInvoiceStateMutationVariables> {
    document = UpdateInvoiceStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadInvoiceDocumentsDocument = gql`
    mutation UploadInvoiceDocuments($invoiceId: ID!, $files: [Upload!]!) {
  uploadInvoiceDocuments(invoiceId: $invoiceId, files: $files) {
    errors
    warnings
    invoice {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadInvoiceDocumentsGQL extends Apollo.Mutation<UploadInvoiceDocumentsMutation, UploadInvoiceDocumentsMutationVariables> {
    document = UploadInvoiceDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInvoiceDocumentDocument = gql`
    mutation DeleteInvoiceDocument($invoiceId: ID!, $documentId: ID!) {
  deleteInvoiceDocument(invoiceId: $invoiceId, documentId: $documentId) {
    errors
    invoice {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInvoiceDocumentGQL extends Apollo.Mutation<DeleteInvoiceDocumentMutation, DeleteInvoiceDocumentMutationVariables> {
    document = DeleteInvoiceDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineItemDocument = gql`
    query LineItem($lineItemId: ID!, $unit: String, $currency: CurrencyEnum, $incoterm: IncotermWithNscEnum) {
  lineItem(lineItemId: $lineItemId) {
    expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
      unit
      error
      pricePoints {
        incoterm
        moneyAmount {
          currency {
            symbol
            isoCode
            smallestDenomination
            subunitToUnit
          }
          displayString
          fractional
          amount
        }
        chargesApplied {
          name
          moneyAmount {
            currency {
              symbol
              isoCode
              smallestDenomination
              subunitToUnit
            }
            displayString
            fractional
            amount
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LineItemGQL extends Apollo.Query<LineItemQuery, LineItemQueryVariables> {
    document = LineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HistoricalMarketVolumesDocument = gql`
    query HistoricalMarketVolumes($companyId: ID!, $commodityId: ID!, $regionCode: String!) {
  historicalMarketVolumes(
    companyId: $companyId
    commodityId: $commodityId
    regionCode: $regionCode
  ) {
    companyName
    targetRegion
    commodityName
    grade
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HistoricalMarketVolumesGQL extends Apollo.Query<HistoricalMarketVolumesQuery, HistoricalMarketVolumesQueryVariables> {
    document = HistoricalMarketVolumesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIncotermLineItemDocument = gql`
    mutation CreateIncotermLineItem($attributes: CreateLineItemAttributes!, $buyerId: ID, $sellerId: ID, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  createIncotermLineItem(
    attributes: $attributes
    buyerId: $buyerId
    sellerId: $sellerId
  ) {
    lineItem {
      expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
        ...expectedReturnSummaryFields
      }
    }
    errors
  }
}
    ${ExpectedReturnSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIncotermLineItemGQL extends Apollo.Mutation<CreateIncotermLineItemMutation, CreateIncotermLineItemMutationVariables> {
    document = CreateIncotermLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIncotermLineItemsDocument = gql`
    mutation CreateIncotermLineItems($lineItemAttributes: [CreateLineItemAttributes!]!, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  createIncotermLineItems(lineItemAttributes: $lineItemAttributes) {
    lineItems {
      expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
        ...expectedReturnSummaryFields
      }
    }
    errors
  }
}
    ${ExpectedReturnSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIncotermLineItemsGQL extends Apollo.Mutation<CreateIncotermLineItemsMutation, CreateIncotermLineItemsMutationVariables> {
    document = CreateIncotermLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoisSummaryDocument = gql`
    query LoisSummary($filterAttributes: LoadOutInstructionsFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  loadOutInstructions(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      loadOutReference
      bookingReference
      containerNumber
      transportType
      exportersReference
      shippingLine
      clientReference
      voyage
      portOfLoadingName
      portOfDestinationName
      estimatedTimeOfDelivery
      exporterName
      stuffDate
      contacts {
        name
        contactType
        createdByUserId
      }
      vesselName
      truckReference
      consignmentReference
      orderReference
      loadDate
      loadingPoint {
        name
      }
      offloadingPoint {
        name
      }
      id
      fileNumber
      airWaybillNo
      shipper
      destination
      flightDate
      updatedAt
      createdAt
      sentEmailList {
        id
        createdAt
        recipient
        attachments
      }
      templateOutput {
        outputFiles {
          id
          filename
        }
      }
      palletCount
      stackDates
      stackDatesClose
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoisSummaryGQL extends Apollo.Query<LoisSummaryQuery, LoisSummaryQueryVariables> {
    document = LoisSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiFilterAttributesDocument = gql`
    query LoiFilterAttributes {
  loadOutInstructionsFilterAttributes {
    commodities {
      id
      name
    }
    vessels {
      id
      vesselName
    }
    varieties {
      id
      name
    }
    exporters {
      id
      name
    }
    contacts {
      id
      name
      contactType
      createdByUserId
    }
    loadingPoints {
      id
      name
    }
    offloadingPoints {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiFilterAttributesGQL extends Apollo.Query<LoiFilterAttributesQuery, LoiFilterAttributesQueryVariables> {
    document = LoiFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiReferenceDocument = gql`
    query loiReference {
  loadOutInstructionReference
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiReferenceGQL extends Apollo.Query<LoiReferenceQuery, LoiReferenceQueryVariables> {
    document = LoiReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentLineItemsWithNoLoiDocument = gql`
    query airFreightShipmentLineItemsWithNoLoi {
  airFreightShipmentLineItemsWithNoLoi {
    id
    orderReference
    bookingReference
    finalDestinationLocation
    externalShipmentId
    eta
    finalDestinationCode
    goodsDescription
    company {
      id
      name
    }
    airFreightShipment {
      masterWaybillNumber
      shipper
      estimatedDepartureTime
      controller
      portOfLoadingCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentLineItemsWithNoLoiGQL extends Apollo.Query<AirFreightShipmentLineItemsWithNoLoiQuery, AirFreightShipmentLineItemsWithNoLoiQueryVariables> {
    document = AirFreightShipmentLineItemsWithNoLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiExportersDocument = gql`
    query loiExporters($limit: Int, $orderbyloi: Boolean, $companyname: String) {
  exporters(limit: $limit, orderbyloi: $orderbyloi, companyname: $companyname) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiExportersGQL extends Apollo.Query<LoiExportersQuery, LoiExportersQueryVariables> {
    document = LoiExportersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiStuffLocationsDocument = gql`
    query loiStuffLocations($limit: Int, $orderbyloi: Boolean, $fboname: String) {
  stuffLocations(limit: $limit, orderbyloi: $orderbyloi, fboname: $fboname) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiStuffLocationsGQL extends Apollo.Query<LoiStuffLocationsQuery, LoiStuffLocationsQueryVariables> {
    document = LoiStuffLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiTruckingLoadingPointsDocument = gql`
    query loiTruckingLoadingPoints($limit: Int, $orderByLoi: Boolean, $fboName: String) {
  truckingLoadingPoints(limit: $limit, orderByLoi: $orderByLoi, fboName: $fboName) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiTruckingLoadingPointsGQL extends Apollo.Query<LoiTruckingLoadingPointsQuery, LoiTruckingLoadingPointsQueryVariables> {
    document = LoiTruckingLoadingPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiTruckingOffloadingPointsDocument = gql`
    query loiTruckingOffloadingPoints($limit: Int, $orderByLoi: Boolean, $fboName: String) {
  truckingOffloadingPoints(
    limit: $limit
    orderByLoi: $orderByLoi
    fboName: $fboName
  ) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiTruckingOffloadingPointsGQL extends Apollo.Query<LoiTruckingOffloadingPointsQuery, LoiTruckingOffloadingPointsQueryVariables> {
    document = LoiTruckingOffloadingPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiSeaPortsDocument = gql`
    query loiSeaPorts($limit: Int, $orderbyloi: Boolean, $seaportname: String, $isportofloading: Boolean, $stufflocationid: Int) {
  seaPorts(
    limit: $limit
    orderbyloi: $orderbyloi
    seaportname: $seaportname
    isportofloading: $isportofloading
    stufflocationid: $stufflocationid
  ) {
    id
    name
    country
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiSeaPortsGQL extends Apollo.Query<LoiSeaPortsQuery, LoiSeaPortsQueryVariables> {
    document = LoiSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiVesselsDocument = gql`
    query loiVessels($limit: Int, $vesselname: String, $seaportid: Int) {
  vessels(limit: $limit, vesselname: $vesselname, seaportid: $seaportid) {
    id
    vesselName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiVesselsGQL extends Apollo.Query<LoiVesselsQuery, LoiVesselsQueryVariables> {
    document = LoiVesselsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiVoyagesDocument = gql`
    query loiVoyages($vesselid: Int!, $seaportid: Int) {
  voyages(vesselid: $vesselid, seaportid: $seaportid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiVoyagesGQL extends Apollo.Query<LoiVoyagesQuery, LoiVoyagesQueryVariables> {
    document = LoiVoyagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiContactsDocument = gql`
    query loiContacts {
  contacts {
    id
    name
    info
    contactType
    createdByUserId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiContactsGQL extends Apollo.Query<LoiContactsQuery, LoiContactsQueryVariables> {
    document = LoiContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiUnassignedCgFilterAttributesDocument = gql`
    query loiUnassignedCGFilterAttributes($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    filterValues {
      batchNumber
      consignmentNumber
      packingWeek
      targetMarket
      variety {
        id
        name
      }
      seller {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiUnassignedCgFilterAttributesGQL extends Apollo.Query<LoiUnassignedCgFilterAttributesQuery, LoiUnassignedCgFilterAttributesQueryVariables> {
    document = LoiUnassignedCgFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiUnassignedCartonGroupingsDocument = gql`
    query loiUnassignedCartonGroupings($attributes: CartonGroupingSearchAttributes!, $loadingPointId: Int, $portOfLoadingId: Int, $transportType: String, $hideReassignable: Boolean) {
  loadOutInstructionCgs(
    attributes: $attributes
    loadingPointId: $loadingPointId
    portOfLoadingId: $portOfLoadingId
    transportType: $transportType
    hideReassignable: $hideReassignable
  ) {
    id
    batchNumber
    buyerName
    cartons
    consignmentNumber
    commodityName
    exporterCode
    farmCode
    inventoryCode
    mark
    orchard
    grade
    pack
    packingWeek
    palletNumber
    sellerName
    sequenceNumber
    sizeCount
    state
    subCommodityName
    targetMarket
    targetRegion
    varietyName
    palletAge
    existingLoadOut
    isReassignable
    netMass
    palletGrossMass
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiUnassignedCartonGroupingsGQL extends Apollo.Query<LoiUnassignedCartonGroupingsQuery, LoiUnassignedCartonGroupingsQueryVariables> {
    document = LoiUnassignedCartonGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiUnassignedCGsDocument = gql`
    query loiUnassignedCGs($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      batchNumber
      buyer {
        name
      }
      cartons
      consignmentNumber
      exporterCode
      farmCode
      grade
      id
      inventoryCode
      mark
      netMass
      orchard
      pack
      packhouseCode
      packingWeek
      palletGrossMass
      palletNumber
      seller {
        name
      }
      sequenceNumber
      sizeCount
      state
      targetCountry
      targetMarket
      targetRegion
      variety {
        commodity {
          name
        }
        name
        subCommodity {
          name
        }
      }
      loadOutInstructions {
        loadOutReference
        transportType
        loadingPoint {
          id
          name
          createdAt
          updatedAt
        }
        portOfLoading {
          ...loiPortFields
        }
      }
      palletAge
    }
    filterValues {
      batchNumber
      consignmentNumber
      packingWeek
      targetMarket
      variety {
        id
        name
      }
      seller {
        id
        name
      }
    }
    totalCount
    totalCountPallets
  }
}
    ${LoiPortFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiUnassignedCGsGQL extends Apollo.Query<LoiUnassignedCGsQuery, LoiUnassignedCGsQueryVariables> {
    document = LoiUnassignedCGsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiDocument = gql`
    query Loi($id: Int!) {
  loadOutInstruction(id: $id) {
    ...LoiCommonFields
    airFreightShipmentLineItem {
      id
      orderReference
      bookingReference
      externalShipmentId
      updatedAt
      createdAt
    }
    shipmentLineItem {
      id
      updatedAt
      createdAt
    }
    cartonGroupings {
      ...cgCommonFields
    }
    loiCartonGroupings {
      id
      batchNumber
      buyerName
      cartons
      consignmentNumber
      commodityName
      exporterCode
      farmCode
      inventoryCode
      mark
      orchard
      grade
      pack
      packingWeek
      palletNumber
      sellerName
      sequenceNumber
      sizeCount
      state
      subCommodityName
      targetMarket
      targetRegion
      varietyName
      palletAge
      existingLoadOut
      isReassignable
      netMass
      palletGrossMass
    }
  }
}
    ${LoiCommonFieldsFragmentDoc}
${CgCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiGQL extends Apollo.Query<LoiQuery, LoiQueryVariables> {
    document = LoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoiDocument = gql`
    mutation CreateLoi($attributes: LoadOutAttributes!) {
  createLoadOutInstruction(attributes: $attributes) {
    errors {
      ...LoiErrorFields
    }
    loadOutInstruction {
      cartonGroupings {
        id
      }
      ...LoiCommonFields
    }
  }
}
    ${LoiErrorFieldsFragmentDoc}
${LoiCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoiGQL extends Apollo.Mutation<CreateLoiMutation, CreateLoiMutationVariables> {
    document = CreateLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLoiDocument = gql`
    mutation UpdateLoi($attributes: LoadOutAttributes!) {
  updateLoadOutInstruction(attributes: $attributes) {
    errors {
      ...LoiErrorFields
    }
    loadOutInstruction {
      cartonGroupings {
        id
      }
      ...LoiCommonFields
    }
  }
}
    ${LoiErrorFieldsFragmentDoc}
${LoiCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLoiGQL extends Apollo.Mutation<UpdateLoiMutation, UpdateLoiMutationVariables> {
    document = UpdateLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLoiDocument = gql`
    mutation DeleteLoi($id: Int!) {
  deleteLoadOutInstruction(id: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLoiGQL extends Apollo.Mutation<DeleteLoiMutation, DeleteLoiMutationVariables> {
    document = DeleteLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateLoadOutInstructionOutputFilesDocument = gql`
    mutation GenerateLoadOutInstructionOutputFiles($loadoutinstructionid: ID!) {
  generateLoadOutInstructionOutputFiles(
    loadoutinstructionid: $loadoutinstructionid
  ) {
    templateOutput {
      errorReason
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateLoadOutInstructionOutputFilesGQL extends Apollo.Mutation<GenerateLoadOutInstructionOutputFilesMutation, GenerateLoadOutInstructionOutputFilesMutationVariables> {
    document = GenerateLoadOutInstructionOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratePalletInOutputFilesDocument = gql`
    mutation GeneratePalletInOutputFiles($loadOutInstructionId: ID!) {
  generatePalletInOutputFiles(loadOutInstructionId: $loadOutInstructionId) {
    palletInId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratePalletInOutputFilesGQL extends Apollo.Mutation<GeneratePalletInOutputFilesMutation, GeneratePalletInOutputFilesMutationVariables> {
    document = GeneratePalletInOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnPalletInOutputStateChangeDocument = gql`
    subscription onPalletInOutputStateChange {
  onPalletInOutputStateChange {
    ...palletInFields
  }
}
    ${PalletInFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnPalletInOutputStateChangeGQL extends Apollo.Subscription<OnPalletInOutputStateChangeSubscription, OnPalletInOutputStateChangeSubscriptionVariables> {
    document = OnPalletInOutputStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EvaluateShipmentImpactDocument = gql`
    query EvaluateShipmentImpact($sliId: ID!, $loiAttributes: LoadOutAttributes!) {
  evaluateShipmentImpact(sliId: $sliId, loiAttributes: $loiAttributes) {
    willAffectShipment
    willCreateNewShipment
    shipmentId
    portOfLoading
    vesselName
    voyage
    shippingLine
    client
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EvaluateShipmentImpactGQL extends Apollo.Query<EvaluateShipmentImpactQuery, EvaluateShipmentImpactQueryVariables> {
    document = EvaluateShipmentImpactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveSlisToNewShipmentDocument = gql`
    mutation MoveSlisToNewShipment($sliIds: [ID!]!, $shipmentId: ID) {
  moveSlisToNewShipment(sliIds: $sliIds, shipmentId: $shipmentId) {
    shipment {
      id
    }
    shipmentLineItems {
      id
      shipmentId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveSlisToNewShipmentGQL extends Apollo.Mutation<MoveSlisToNewShipmentMutation, MoveSlisToNewShipmentMutationVariables> {
    document = MoveSlisToNewShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentMapPointsForOrderDocument = gql`
    query CurrentMapPointsForOrder($id: Int!) {
  currentMapPointsForOrder(id: $id) {
    totalCartons
    containers {
      id
      containerNumber
      orderId
      otherPartyName
      vesselName
      portOfDestination
      eta
    }
    orders {
      orderId
      otherPartyName
      totalCartons
    }
    location {
      ...vesselMap
      ...seaPortMap
      ...fboMap
      __typename
    }
  }
}
    ${VesselMapFragmentDoc}
${SeaPortMapFragmentDoc}
${FboMapFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentMapPointsForOrderGQL extends Apollo.Query<CurrentMapPointsForOrderQuery, CurrentMapPointsForOrderQueryVariables> {
    document = CurrentMapPointsForOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonConversionsDocument = gql`
    query CartonConversions($filterAttributes: CartonConversionFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  cartonConversions(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    commodityName
    conversionFactor
    actualMass
    massConversion
    pack
    sizeCount
    convertedSizeCount
    conversionType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonConversionsGQL extends Apollo.Query<CartonConversionsQuery, CartonConversionsQueryVariables> {
    document = CartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCartonConversionsDocument = gql`
    mutation createCartonConversions($actualMass: Float, $commodityId: ID, $conversionFactor: Float, $conversionType: String, $convertedSizeCount: String, $massConversion: Float, $pack: String, $sizeCount: String) {
  createCartonConversion(
    actualMass: $actualMass
    commodityId: $commodityId
    conversionFactor: $conversionFactor
    conversionType: $conversionType
    convertedSizeCount: $convertedSizeCount
    massConversion: $massConversion
    pack: $pack
    sizeCount: $sizeCount
  ) {
    cartonConversion {
      id
      commodityName
      conversionFactor
      actualMass
      massConversion
      pack
      sizeCount
      convertedSizeCount
      conversionType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCartonConversionsGQL extends Apollo.Mutation<CreateCartonConversionsMutation, CreateCartonConversionsMutationVariables> {
    document = CreateCartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCartonConversionsDocument = gql`
    mutation updateCartonConversions($id: ID!, $actualMass: Float, $conversionFactor: Float, $convertedSizeCount: String, $massConversion: Float) {
  updateCartonConversion(
    id: $id
    actualMass: $actualMass
    conversionFactor: $conversionFactor
    convertedSizeCount: $convertedSizeCount
    massConversion: $massConversion
  ) {
    cartonConversion {
      id
      commodityName
      conversionFactor
      actualMass
      massConversion
      pack
      sizeCount
      convertedSizeCount
      conversionType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCartonConversionsGQL extends Apollo.Mutation<UpdateCartonConversionsMutation, UpdateCartonConversionsMutationVariables> {
    document = UpdateCartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCartonConversionsDocument = gql`
    mutation deleteCartonConversions($id: ID!) {
  deleteCartonConversion(id: $id) {
    cartonConversion {
      id
      commodityName
      conversionFactor
      actualMass
      massConversion
      pack
      sizeCount
      convertedSizeCount
      conversionType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCartonConversionsGQL extends Apollo.Mutation<DeleteCartonConversionsMutation, DeleteCartonConversionsMutationVariables> {
    document = DeleteCartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonConversionFilterAttributesDocument = gql`
    query CartonConversionFilterAttributes {
  cartonConversionFilterAttributes {
    conversionType
    commodityName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonConversionFilterAttributesGQL extends Apollo.Query<CartonConversionFilterAttributesQuery, CartonConversionFilterAttributesQueryVariables> {
    document = CartonConversionFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CgErrorsDocument = gql`
    query CgErrors($filterAttributes: CgErrorFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  cgErrors(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    errorContext
    errorMessage
    errorType
    errorSubtype
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CgErrorsGQL extends Apollo.Query<CgErrorsQuery, CgErrorsQueryVariables> {
    document = CgErrorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResolveCgErrorDocument = gql`
    mutation ResolveCgError($id: ID!, $resolution: CgErrorResolutionInput!, $userContext: String) {
  resolveCgError(id: $id, resolution: $resolution, userContext: $userContext) {
    cgError {
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResolveCgErrorGQL extends Apollo.Mutation<ResolveCgErrorMutation, ResolveCgErrorMutationVariables> {
    document = ResolveCgErrorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CgErrorFilterAttributesDocument = gql`
    query CgErrorFilterAttributes {
  cgErrorFilterAttributes {
    errorType
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CgErrorFilterAttributesGQL extends Apollo.Query<CgErrorFilterAttributesQuery, CgErrorFilterAttributesQueryVariables> {
    document = CgErrorFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIgnoreErrorRequestDocument = gql`
    mutation CreateIgnoreErrorRequest($action: String!, $errorToIgnore: String!) {
  createIgnoreErrorRequest(action: $action, errorToIgnore: $errorToIgnore) {
    clientChangeRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIgnoreErrorRequestGQL extends Apollo.Mutation<CreateIgnoreErrorRequestMutation, CreateIgnoreErrorRequestMutationVariables> {
    document = CreateIgnoreErrorRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateClientChangeRequestDocument = gql`
    mutation CreateClientChangeRequest($action: String!, $userContext: String, $modelId: ID!) {
  createClientChangeRequest(
    action: $action
    userContext: $userContext
    modelId: $modelId
  ) {
    clientChangeRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateClientChangeRequestGQL extends Apollo.Mutation<CreateClientChangeRequestMutation, CreateClientChangeRequestMutationVariables> {
    document = CreateClientChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterfileFarmVarietiesDocument = gql`
    query MasterfileFarmVarieties($filterAttributes: FarmVarietyFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  masterfileFarmVarieties(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    ... on FarmVariety {
      id
      name: varietyName
      varietyCode
      commodityName
      hectares
      peakCount
      packingStart
      packingEnd
      status
    }
    ... on FarmVarietyRequest {
      modelId
      name
      commodityName
      varietyCode
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterfileFarmVarietiesGQL extends Apollo.Query<MasterfileFarmVarietiesQuery, MasterfileFarmVarietiesQueryVariables> {
    document = MasterfileFarmVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListVarietiesDocument = gql`
    query listVarieties {
  listVarieties {
    id
    varietyName
    commodity {
      id
      name
    }
    subCommodity {
      id
      name
    }
    varietyCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListVarietiesGQL extends Apollo.Query<ListVarietiesQuery, ListVarietiesQueryVariables> {
    document = ListVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FarmVarietyFilterAttributesDocument = gql`
    query farmVarietyFilterAttributes {
  farmVarietyFilterAttributes {
    status
    commodityName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FarmVarietyFilterAttributesGQL extends Apollo.Query<FarmVarietyFilterAttributesQuery, FarmVarietyFilterAttributesQueryVariables> {
    document = FarmVarietyFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFarmVarietyClienChangeRequestDocument = gql`
    mutation CreateFarmVarietyClienChangeRequest($modelId: Int!, $name: String!, $varietyId: Int!, $varietyCode: String!, $commodityName: String!, $commodityId: Int!, $action: String!) {
  createFarmVarietyClientChangeRequest(
    modelId: $modelId
    name: $name
    varietyId: $varietyId
    varietyCode: $varietyCode
    commodityName: $commodityName
    commodityId: $commodityId
    action: $action
  ) {
    clientChangeRequest {
      id
      status
      name
      varietyCode
      commodityName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFarmVarietyClienChangeRequestGQL extends Apollo.Mutation<CreateFarmVarietyClienChangeRequestMutation, CreateFarmVarietyClienChangeRequestMutationVariables> {
    document = CreateFarmVarietyClienChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FarmVarietiesDocument = gql`
    query farmVarieties {
  farmVarieties {
    id
    name: varietyName
    varietyCode
    commodityName
    hectares
    peakCount
    packingStart
    packingEnd
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FarmVarietiesGQL extends Apollo.Query<FarmVarietiesQuery, FarmVarietiesQueryVariables> {
    document = FarmVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FarmVarietyClientChangeRequestsDocument = gql`
    query farmVarietyClientChangeRequests {
  farmVarietyClientChangeRequests {
    name
    status
    varietyCode
    commodityName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FarmVarietyClientChangeRequestsGQL extends Apollo.Query<FarmVarietyClientChangeRequestsQuery, FarmVarietyClientChangeRequestsQueryVariables> {
    document = FarmVarietyClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterfileFoodBusinessOperatorsDocument = gql`
    query MasterfileFoodBusinessOperators($filterAttributes: FoodBusinessOperatorFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  masterfileFoodBusinessOperators(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    ... on FoodBusinessOperator {
      id
      name
      fboCode
      typeOfBusiness
      producerName
      latitude
      longitude
      globalGapNumber
      productionRegion
      updatedAt
      status
    }
    ... on FoodBusinessOperatorRequest {
      fboCode
      name
      globalGapNumber
      latitude
      longitude
      modelId
      status
      producerName
      productionRegion
      typeOfBusiness
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterfileFoodBusinessOperatorsGQL extends Apollo.Query<MasterfileFoodBusinessOperatorsQuery, MasterfileFoodBusinessOperatorsQueryVariables> {
    document = MasterfileFoodBusinessOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorsDocument = gql`
    query foodBusinessOperators {
  foodBusinessOperators {
    id
    name
    fboCode
    typeOfBusiness
    producerName
    latitude
    longitude
    globalGapNumber
    productionRegion
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorsGQL extends Apollo.Query<FoodBusinessOperatorsQuery, FoodBusinessOperatorsQueryVariables> {
    document = FoodBusinessOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorClientChangeRequestsDocument = gql`
    query foodBusinessOperatorClientChangeRequests {
  foodBusinessOperatorClientChangeRequests {
    fboCode
    name
    globalGapNumber
    latitude
    longitude
    modelId
    status
    producerName
    productionRegion
    typeOfBusiness
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorClientChangeRequestsGQL extends Apollo.Query<FoodBusinessOperatorClientChangeRequestsQuery, FoodBusinessOperatorClientChangeRequestsQueryVariables> {
    document = FoodBusinessOperatorClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFoodBusinessOperatorClientChangeRequestDocument = gql`
    mutation CreateFoodBusinessOperatorClientChangeRequest($modelId: Int!, $name: String!, $action: String!, $fboCode: String!, $globalGapNumber: String!, $latitude: Float!, $longitude: Float!, $producerName: String!, $productionRegion: String!, $typeOfBusiness: String!) {
  createFoodBusinessOperatorClientChangeRequest(
    modelId: $modelId
    action: $action
    name: $name
    fboCode: $fboCode
    globalGapNumber: $globalGapNumber
    latitude: $latitude
    longitude: $longitude
    producerName: $producerName
    productionRegion: $productionRegion
    typeOfBusiness: $typeOfBusiness
  ) {
    clientChangeRequest {
      id
      fboCode
      name
      globalGapNumber
      latitude
      longitude
      modelId
      producerName
      productionRegion
      status
      typeOfBusiness
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFoodBusinessOperatorClientChangeRequestGQL extends Apollo.Mutation<CreateFoodBusinessOperatorClientChangeRequestMutation, CreateFoodBusinessOperatorClientChangeRequestMutationVariables> {
    document = CreateFoodBusinessOperatorClientChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorFilterAttributesDocument = gql`
    query FoodBusinessOperatorFilterAttributes {
  foodBusinessOperatorFilterAttributes {
    status
    typeOfBusiness
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorFilterAttributesGQL extends Apollo.Query<FoodBusinessOperatorFilterAttributesQuery, FoodBusinessOperatorFilterAttributesQueryVariables> {
    document = FoodBusinessOperatorFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionRegionsDocument = gql`
    query productionRegions {
  productionRegions {
    id
    name
    countryCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionRegionsGQL extends Apollo.Query<ProductionRegionsQuery, ProductionRegionsQueryVariables> {
    document = ProductionRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListFoodBusinessOperatorsDocument = gql`
    query listFoodBusinessOperators {
  listFoodBusinessOperators {
    fboCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListFoodBusinessOperatorsGQL extends Apollo.Query<ListFoodBusinessOperatorsQuery, ListFoodBusinessOperatorsQueryVariables> {
    document = ListFoodBusinessOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorsByTypeDocument = gql`
    query FoodBusinessOperatorsByType($typeOfBusiness: Int!) {
  foodBusinessOperatorsByType(typeOfBusiness: $typeOfBusiness) {
    id
    name
    producerName
    fboCode
    productionRegion
    company {
      id
    }
    locationMappings {
      locationCode
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorsByTypeGQL extends Apollo.Query<FoodBusinessOperatorsByTypeQuery, FoodBusinessOperatorsByTypeQueryVariables> {
    document = FoodBusinessOperatorsByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterfileConfigsDocument = gql`
    query MasterfileConfigs($filterAttributes: MasterfileConfigFilterAttributes, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!]) {
  masterfileConfigs(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    ...masterfileConfigFields
    masterfileEntity {
      ... on FarmVariety {
        ...farmVarietyFields
      }
      ... on FoodBusinessOperator {
        ...foodBusinessOperatorFields
      }
      ... on CompanyAssociation {
        ...companyAssociationFields
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${FarmVarietyFieldsFragmentDoc}
${FoodBusinessOperatorFieldsFragmentDoc}
${CompanyAssociationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterfileConfigsGQL extends Apollo.Query<MasterfileConfigsQuery, MasterfileConfigsQueryVariables> {
    document = MasterfileConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InternalPackhouseClientChangeRequestsDocument = gql`
    query InternalPackhouseClientChangeRequests {
  internalPackhouseClientChangeRequests {
    id
    status
    company {
      id
      name
    }
    packhouse {
      ...foodBusinessOperatorFields
    }
  }
}
    ${FoodBusinessOperatorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InternalPackhouseClientChangeRequestsGQL extends Apollo.Query<InternalPackhouseClientChangeRequestsQuery, InternalPackhouseClientChangeRequestsQueryVariables> {
    document = InternalPackhouseClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSoftwareUpdateReportDocument = gql`
    mutation CreateSoftwareUpdateReport($softwareUpdateReport: [String!]!) {
  createSoftwareUpdateReport(softwareUpdateReport: $softwareUpdateReport) {
    errors
    clientChangeRequest {
      ...softwareUpdateReportFields
    }
  }
}
    ${SoftwareUpdateReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSoftwareUpdateReportGQL extends Apollo.Mutation<CreateSoftwareUpdateReportMutation, CreateSoftwareUpdateReportMutationVariables> {
    document = CreateSoftwareUpdateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackhouseSoftwareUpdateReportsDocument = gql`
    query PackhouseSoftwareUpdateReports {
  packhouseSoftwareUpdateReports {
    ...softwareUpdateReportFields
  }
}
    ${SoftwareUpdateReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PackhouseSoftwareUpdateReportsGQL extends Apollo.Query<PackhouseSoftwareUpdateReportsQuery, PackhouseSoftwareUpdateReportsQueryVariables> {
    document = PackhouseSoftwareUpdateReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigFboDocument = gql`
    mutation ConfirmMasterfileConfigFbo($masterfileConfigs: [MasterfileConfigFboInput!]!) {
  confirmMasterfileConfigFbo(masterfileConfigs: $masterfileConfigs) {
    errors
    masterfileConfigs {
      ...masterfileConfigFields
      masterfileEntity {
        ... on FoodBusinessOperator {
          ...foodBusinessOperatorFields
        }
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${FoodBusinessOperatorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigFboGQL extends Apollo.Mutation<ConfirmMasterfileConfigFboMutation, ConfirmMasterfileConfigFboMutationVariables> {
    document = ConfirmMasterfileConfigFboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigPackhouseConnectionsDocument = gql`
    mutation ConfirmMasterfileConfigPackhouseConnections($masterfileConfigs: [MasterfileConfigPackhouseConnectionAttributes!]!) {
  confirmMasterfileConfigPackhouseConnections(
    masterfileConfigs: $masterfileConfigs
  ) {
    errors
    masterfileConfigs {
      ...masterfileConfigFields
      masterfileEntity {
        ... on PackhouseConnection {
          ...packhouseConnectionFields
        }
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${PackhouseConnectionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigPackhouseConnectionsGQL extends Apollo.Mutation<ConfirmMasterfileConfigPackhouseConnectionsMutation, ConfirmMasterfileConfigPackhouseConnectionsMutationVariables> {
    document = ConfirmMasterfileConfigPackhouseConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigFarmVarietiesDocument = gql`
    mutation ConfirmMasterfileConfigFarmVarieties($masterfileConfigs: [MasterfileConfigFarmVarietyInput!]!) {
  confirmMasterfileConfigFarmVarieties(masterfileConfigs: $masterfileConfigs) {
    errors
    masterfileConfigs {
      ...masterfileConfigFields
      masterfileEntity {
        ... on FarmVariety {
          ...farmVarietyFields
        }
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${FarmVarietyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigFarmVarietiesGQL extends Apollo.Mutation<ConfirmMasterfileConfigFarmVarietiesMutation, ConfirmMasterfileConfigFarmVarietiesMutationVariables> {
    document = ConfirmMasterfileConfigFarmVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFarmFboDocument = gql`
    mutation CreateFarmFbo($attributes: CreateFarmAttribute!) {
  createFarmFbo(attributes: $attributes) {
    foodBusinessOperator {
      ...foodBusinessOperatorFields
    }
    masterfileConfig {
      ...masterfileConfigFields
    }
    errors
  }
}
    ${FoodBusinessOperatorFieldsFragmentDoc}
${MasterfileConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFarmFboGQL extends Apollo.Mutation<CreateFarmFboMutation, CreateFarmFboMutationVariables> {
    document = CreateFarmFboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddInternalPackhouseDocument = gql`
    mutation AddInternalPackhouse($attributes: AddInternalPackhouseAttributes!) {
  addInternalPackhouse(attributes: $attributes) {
    errors
    clientChangeRequest {
      id
      status
      company {
        id
        name
      }
      packhouse {
        ...foodBusinessOperatorFields
      }
    }
  }
}
    ${FoodBusinessOperatorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddInternalPackhouseGQL extends Apollo.Mutation<AddInternalPackhouseMutation, AddInternalPackhouseMutationVariables> {
    document = AddInternalPackhouseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetabaseReportFilterAttributesDocument = gql`
    query MetabaseReportFilterAttributes {
  metabaseReportFilterAttributes {
    badges {
      id
      text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MetabaseReportFilterAttributesGQL extends Apollo.Query<MetabaseReportFilterAttributesQuery, MetabaseReportFilterAttributesQueryVariables> {
    document = MetabaseReportFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetabaseReportsDocument = gql`
    query MetabaseReports($filters: MetabaseReportFilters!, $searchTerm: String!, $searchField: String!) {
  metabaseReports(
    filters: $filters
    searchTerm: $searchTerm
    searchField: $searchField
  ) {
    ...MetabaseReportFields
  }
}
    ${MetabaseReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MetabaseReportsGQL extends Apollo.Query<MetabaseReportsQuery, MetabaseReportsQueryVariables> {
    document = MetabaseReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetabaseReportDocument = gql`
    query MetabaseReport($id: Int!) {
  metabaseReport(id: $id) {
    ...MetabaseReportFields
  }
}
    ${MetabaseReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MetabaseReportGQL extends Apollo.Query<MetabaseReportQuery, MetabaseReportQueryVariables> {
    document = MetabaseReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NetReturnProgramsDocument = gql`
    query NetReturnPrograms {
  netReturnPrograms {
    additionalFields
    buyerId
    batchNumber
    cartonTypeName
    cartonTypeId
    commodityId
    commodityName
    configuredCurrency
    configuredUnit
    createdAt
    currency
    id
    incoterm
    inventoryCode
    packingWeek
    priceMinorUnit
    priceTerm
    priceUnit
    programId
    programName
    programVisibility
    quantity
    quantityUnit
    referenceNumber
    sizeCounts
    stackSize
    sellerId
    targetMarket
    tradeCountryId
    tradeCountryName
    tradeRegionId
    tradeRegionName
    updatedAt
    varietyId
    varietyName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NetReturnProgramsGQL extends Apollo.Query<NetReturnProgramsQuery, NetReturnProgramsQueryVariables> {
    document = NetReturnProgramsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNetReturnProgramDocument = gql`
    mutation CreateNetReturnProgram($attributes: NetReturnProgramAttributes!) {
  createNetReturnProgram(attributes: $attributes) {
    netReturnProgram {
      id
      programName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNetReturnProgramGQL extends Apollo.Mutation<CreateNetReturnProgramMutation, CreateNetReturnProgramMutationVariables> {
    document = CreateNetReturnProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNetReturnProgramDocument = gql`
    mutation UpdateNetReturnProgram($attributes: NetReturnProgramAttributes!) {
  updateNetReturnProgram(attributes: $attributes) {
    netReturnProgram {
      id
      programName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNetReturnProgramGQL extends Apollo.Mutation<UpdateNetReturnProgramMutation, UpdateNetReturnProgramMutationVariables> {
    document = UpdateNetReturnProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteNetReturnProgramDocument = gql`
    mutation DeleteNetReturnProgram($id: ID!) {
  deleteNetReturnProgram(id: $id) {
    netReturnProgram {
      id
      programName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNetReturnProgramGQL extends Apollo.Mutation<DeleteNetReturnProgramMutation, DeleteNetReturnProgramMutationVariables> {
    document = DeleteNetReturnProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnNotificationEventDocument = gql`
    subscription onNotificationEvent {
  newInAppNotification {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnNotificationEventGQL extends Apollo.Subscription<OnNotificationEventSubscription, OnNotificationEventSubscriptionVariables> {
    document = OnNotificationEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelNotificationsDocument = gql`
    query getChannelNotifications($filterAttributes: ChannelNotificationFilterAttributes!, $first: Int, $last: Int, $after: String, $before: String) {
  channelNotifications(
    filterAttributes: $filterAttributes
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...ChannelNotificationFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${ChannelNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelNotificationsGQL extends Apollo.Query<GetChannelNotificationsQuery, GetChannelNotificationsQueryVariables> {
    document = GetChannelNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnreadChannelNotificationsCountDocument = gql`
    query getUnreadChannelNotificationsCount($severity: NotificationRuleSeverityEnum) {
  unreadChannelNotificationsCount(severity: $severity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnreadChannelNotificationsCountGQL extends Apollo.Query<GetUnreadChannelNotificationsCountQuery, GetUnreadChannelNotificationsCountQueryVariables> {
    document = GetUnreadChannelNotificationsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTotalChannelNotificationsCountDocument = gql`
    query getTotalChannelNotificationsCount($severity: NotificationRuleSeverityEnum) {
  channelNotificationsCount(severity: $severity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTotalChannelNotificationsCountGQL extends Apollo.Query<GetTotalChannelNotificationsCountQuery, GetTotalChannelNotificationsCountQueryVariables> {
    document = GetTotalChannelNotificationsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelNotificationDocument = gql`
    query getChannelNotification($id: ID!) {
  channelNotificationById(id: $id) {
    ...ChannelNotificationFields
  }
}
    ${ChannelNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelNotificationGQL extends Apollo.Query<GetChannelNotificationQuery, GetChannelNotificationQueryVariables> {
    document = GetChannelNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationRulesDocument = gql`
    query NotificationRules($notificationSlugs: [NotificationSlugEnum!]!) {
  notificationRules(notificationSlugs: $notificationSlugs) {
    ...NotificationRuleFields
  }
}
    ${NotificationRuleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationRulesGQL extends Apollo.Query<NotificationRulesQuery, NotificationRulesQueryVariables> {
    document = NotificationRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($ids: [ID!]!) {
  markNotificationsAsRead(ids: $ids) {
    ids
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkNotificationsAsReadGQL extends Apollo.Mutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables> {
    document = MarkNotificationsAsReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkNotificationsAsUnreadDocument = gql`
    mutation MarkNotificationsAsUnread($ids: [ID!]!) {
  markNotificationsAsUnread(ids: $ids) {
    ids
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkNotificationsAsUnreadGQL extends Apollo.Mutation<MarkNotificationsAsUnreadMutation, MarkNotificationsAsUnreadMutationVariables> {
    document = MarkNotificationsAsUnreadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveNotificationsDocument = gql`
    mutation ArchiveNotifications($ids: [ID!]!) {
  archiveNotifications(ids: $ids) {
    ids
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveNotificationsGQL extends Apollo.Mutation<ArchiveNotificationsMutation, ArchiveNotificationsMutationVariables> {
    document = ArchiveNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubscribeToNotificationRulesDocument = gql`
    mutation subscribeToNotificationRules($notificationRuleSubscriptionAttributes: [NotificationRuleSubscriptionAttributes!]!) {
  subscribeToNotificationRules(
    notificationRuleSubscriptionAttributes: $notificationRuleSubscriptionAttributes
  ) {
    notificationRuleSubscriptions {
      ...NotificationRuleSubscriptionFields
    }
    errors
  }
}
    ${NotificationRuleSubscriptionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubscribeToNotificationRulesGQL extends Apollo.Mutation<SubscribeToNotificationRulesMutation, SubscribeToNotificationRulesMutationVariables> {
    document = SubscribeToNotificationRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecentRootOffersDocument = gql`
    query RecentRootOffers {
  recentRootOffers {
    ...offerFields
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RecentRootOffersGQL extends Apollo.Query<RecentRootOffersQuery, RecentRootOffersQueryVariables> {
    document = RecentRootOffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OffersDocument = gql`
    query Offers($filterAttributes: OfferFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  offers(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...offerFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OffersGQL extends Apollo.Query<OffersQuery, OffersQueryVariables> {
    document = OffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CounterOffersDocument = gql`
    query CounterOffers($filterAttributes: OfferFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String, $currency: CurrencyEnum, $incoterm: IncotermWithNscEnum, $unit: String) {
  counterOffers(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...offerFields
      offerItems {
        offerItemPrices {
          expectedReturnSummary(currency: $currency, incoterm: $incoterm, unit: $unit) {
            ...offerItemPriceExpectedReturnFields
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${OfferFieldsFragmentDoc}
${OfferItemPriceExpectedReturnFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CounterOffersGQL extends Apollo.Query<CounterOffersQuery, CounterOffersQueryVariables> {
    document = CounterOffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferFilterAttributesDocument = gql`
    query OfferFilterAttributes {
  offerFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    varieties {
      id
      name
      varietyCode
    }
    tradeRegions {
      id
      name
      code
    }
    portsOfDestination {
      ...portDisplayFields
    }
  }
}
    ${PortDisplayFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferFilterAttributesGQL extends Apollo.Query<OfferFilterAttributesQuery, OfferFilterAttributesQueryVariables> {
    document = OfferFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferByIdDocument = gql`
    query OfferById($id: ID!) {
  offerById(id: $id) {
    ...offerFields
    rootOffer {
      id
      companyId
      offerItems {
        ...offerItemFields
      }
    }
  }
}
    ${OfferFieldsFragmentDoc}
${OfferItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferByIdGQL extends Apollo.Query<OfferByIdQuery, OfferByIdQueryVariables> {
    document = OfferByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferHistoryByIdDocument = gql`
    query OfferHistoryById($id: ID!) {
  offerHistoryById(id: $id) {
    id
    currency
    companyId
    company {
      id
      name
    }
    createdAt
    quantity
    offerItems {
      id
      sizeCounts
      offerItemPrices {
        id
        cifPriceAmountMajorUnit
        portOfDestinationId
      }
    }
    offerRecipients {
      id
      buyer {
        id
        name
      }
      portOfDestinationId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferHistoryByIdGQL extends Apollo.Query<OfferHistoryByIdQuery, OfferHistoryByIdQueryVariables> {
    document = OfferHistoryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOfferAsSupplierDocument = gql`
    mutation CreateOfferAsSupplier($attributes: OfferAttributes!) {
  createOfferAsSupplier(attributes: $attributes) {
    offer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOfferAsSupplierGQL extends Apollo.Mutation<CreateOfferAsSupplierMutation, CreateOfferAsSupplierMutationVariables> {
    document = CreateOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloseOfferAsSupplierDocument = gql`
    mutation CloseOfferAsSupplier($offerId: ID!) {
  closeOfferAsSupplier(offerId: $offerId) {
    offer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CloseOfferAsSupplierGQL extends Apollo.Mutation<CloseOfferAsSupplierMutation, CloseOfferAsSupplierMutationVariables> {
    document = CloseOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectOfferAsSupplierDocument = gql`
    mutation RejectOfferAsSupplier($counterOfferId: ID!) {
  rejectOfferAsSupplier(counterOfferId: $counterOfferId) {
    counterOffer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectOfferAsSupplierGQL extends Apollo.Mutation<RejectOfferAsSupplierMutation, RejectOfferAsSupplierMutationVariables> {
    document = RejectOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptOfferAsSupplierDocument = gql`
    mutation AcceptOfferAsSupplier($counterOfferId: ID!) {
  acceptOfferAsSupplier(counterOfferId: $counterOfferId) {
    counterOffer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptOfferAsSupplierGQL extends Apollo.Mutation<AcceptOfferAsSupplierMutation, AcceptOfferAsSupplierMutationVariables> {
    document = AcceptOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCounterOfferAsSupplierDocument = gql`
    mutation CreateCounterOfferAsSupplier($previousOfferId: ID!, $attributes: CounterOfferAttributes!) {
  createCounterOfferAsSupplier(
    previousOfferId: $previousOfferId
    attributes: $attributes
  ) {
    counterOffer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCounterOfferAsSupplierGQL extends Apollo.Mutation<CreateCounterOfferAsSupplierMutation, CreateCounterOfferAsSupplierMutationVariables> {
    document = CreateCounterOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnWhatsappInteractionFailedToDeliverDocument = gql`
    subscription onWhatsappInteractionFailedToDeliver {
  onWhatsappInteractionFailedToDeliver {
    id
    offerRecipientId
    buyerName
    buyerId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnWhatsappInteractionFailedToDeliverGQL extends Apollo.Subscription<OnWhatsappInteractionFailedToDeliverSubscription, OnWhatsappInteractionFailedToDeliverSubscriptionVariables> {
    document = OnWhatsappInteractionFailedToDeliverDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyOnboardingStepDocument = gql`
    mutation UpdateCompanyOnboardingStep($onboardingStep: CompanyOnboardingStepEnum!) {
  updateCompanyOnboardingStep(onboardingStep: $onboardingStep) {
    errors
    company {
      id
      onboardingStep
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyOnboardingStepGQL extends Apollo.Mutation<UpdateCompanyOnboardingStepMutation, UpdateCompanyOnboardingStepMutationVariables> {
    document = UpdateCompanyOnboardingStepDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramsDocument = gql`
    query OrderPrograms($filterAttributes: OrderProgramFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $orderProgramIds: [ID!]) {
  orderPrograms(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    orderProgramIds: $orderProgramIds
  ) {
    batchNumber
    cartonCountId
    cartonTypeId
    cartonTypeName
    commodity {
      id
      name
    }
    commodityId
    commodityName
    companyId
    companyLogoImageUrl
    companyName
    createdAt
    currency
    grade
    hiddenFields
    id
    incoterm
    inventoryCode
    mark
    portOfDestination {
      id
      name
      displayName
      createdAt
      updatedAt
    }
    portOfDestinationId
    portOfDestinationName
    portOfLoading {
      id
      name
      displayName
      createdAt
      updatedAt
    }
    portOfLoadingId
    portOfLoadingName
    priceTerm
    priceUnit
    priceAmountMajorUnit
    priority
    programId
    programName
    programVisibility
    quantityUnit
    quantity
    referenceNumber
    sizeCounts
    stackSize
    targetMarket
    tradeCountryId
    tradeCountryCode
    tradeCountryName
    tradeRegionId
    tradeRegionCode
    tradeRegionName
    updatedAt
    varietyCode
    varietyId
    varietyName
    variety {
      id
      name
      varietyCode
    }
    additionalFields
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramsGQL extends Apollo.Query<OrderProgramsQuery, OrderProgramsQueryVariables> {
    document = OrderProgramsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramCommoditiesDocument = gql`
    query OrderProgramCommodities($onlyOperational: Boolean) {
  commodities(onlyOperational: $onlyOperational) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramCommoditiesGQL extends Apollo.Query<OrderProgramCommoditiesQuery, OrderProgramCommoditiesQueryVariables> {
    document = OrderProgramCommoditiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramVarietiesDocument = gql`
    query OrderProgramVarieties($onlyOperational: Boolean, $skipMixedVarieties: Boolean, $commodityId: ID) {
  varieties(
    onlyOperational: $onlyOperational
    skipMixedVarieties: $skipMixedVarieties
    commodityId: $commodityId
  ) {
    id
    name
    varietyCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramVarietiesGQL extends Apollo.Query<OrderProgramVarietiesQuery, OrderProgramVarietiesQueryVariables> {
    document = OrderProgramVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramSeaPortDocument = gql`
    query OrderProgramSeaPort($seaPortId: ID!) {
  seaPort(seaPortId: $seaPortId) {
    id
    name
    country
    displayName
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramSeaPortGQL extends Apollo.Query<OrderProgramSeaPortQuery, OrderProgramSeaPortQueryVariables> {
    document = OrderProgramSeaPortDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramSeaPortsDocument = gql`
    query OrderProgramSeaPorts($filterAttributes: SeaPortFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  seaPortsV2(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    name
    country
    displayName
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramSeaPortsGQL extends Apollo.Query<OrderProgramSeaPortsQuery, OrderProgramSeaPortsQueryVariables> {
    document = OrderProgramSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramTradeCountriesDocument = gql`
    query OrderProgramTradeCountries($tradeRegionId: ID) {
  tradeCountries(tradeRegionId: $tradeRegionId) {
    id
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramTradeCountriesGQL extends Apollo.Query<OrderProgramTradeCountriesQuery, OrderProgramTradeCountriesQueryVariables> {
    document = OrderProgramTradeCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderProgramDocument = gql`
    mutation CreateOrderProgram($attributes: OrderProgramAttributes!) {
  createOrderProgram(attributes: $attributes) {
    errors
    orderProgram {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderProgramGQL extends Apollo.Mutation<CreateOrderProgramMutation, CreateOrderProgramMutationVariables> {
    document = CreateOrderProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrderProgramDocument = gql`
    mutation UpdateOrderProgram($orderProgramId: ID!, $attributes: OrderProgramAttributes!) {
  updateOrderProgram(orderProgramId: $orderProgramId, attributes: $attributes) {
    errors
    orderProgram {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrderProgramGQL extends Apollo.Mutation<UpdateOrderProgramMutation, UpdateOrderProgramMutationVariables> {
    document = UpdateOrderProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOrderProgramDocument = gql`
    mutation DeleteOrderProgram($orderProgramId: ID!) {
  deleteOrderProgram(orderProgramId: $orderProgramId) {
    errors
    orderProgram {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOrderProgramGQL extends Apollo.Mutation<DeleteOrderProgramMutation, DeleteOrderProgramMutationVariables> {
    document = DeleteOrderProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineItemsDocument = gql`
    query LineItems($filterAttributes: LineItemFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  lineItems(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...singleLineItemFields
      ...expectedNetReturnFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${ExpectedNetReturnFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LineItemsGQL extends Apollo.Query<LineItemsQuery, LineItemsQueryVariables> {
    document = LineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersV3Document = gql`
    query OrdersV3($filterAttributes: OrderFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  ordersV3(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      id
      seller {
        id
        name
      }
      state
      updatedAt
      buyer {
        id
        name
      }
      createdAt
      lineItemGroupings {
        commonFields
        cumulativeQuantity
        cumulativeTooltip
        deleted
        id
        lineItems {
          ...singleLineItemFields
          ...statesDistributionFields
        }
        numberCumulativeSiblings
        quantityType
        rank
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${StatesDistributionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersV3GQL extends Apollo.Query<OrdersV3Query, OrdersV3QueryVariables> {
    document = OrdersV3Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineItemsFilterAttributesDocument = gql`
    query LineItemsFilterAttributes {
  lineItemsFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    sellers {
      id
      name
    }
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LineItemsFilterAttributesGQL extends Apollo.Query<LineItemsFilterAttributesQuery, LineItemsFilterAttributesQueryVariables> {
    document = LineItemsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersFilterAttributesDocument = gql`
    query OrdersFilterAttributes {
  ordersFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    sellers {
      id
      name
    }
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersFilterAttributesGQL extends Apollo.Query<OrdersFilterAttributesQuery, OrdersFilterAttributesQueryVariables> {
    document = OrdersFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuantityTypeDocument = gql`
    query quantityType {
  quantityType
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuantityTypeGQL extends Apollo.Query<QuantityTypeQuery, QuantityTypeQueryVariables> {
    document = QuantityTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderDocument = gql`
    mutation CreateOrder($attributes: CreateOrderAttributes!, $lineItemStates: [String!], $packingWeekStart: String, $packingWeekEnd: String, $varietyIds: [Int!], $commodityIds: [Int!], $subCommodityIds: [Int!], $states: [StateFilter!], $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  createOrder(attributes: $attributes) {
    order {
      ...multipleOrderFields
    }
    errors
  }
}
    ${MultipleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderGQL extends Apollo.Mutation<CreateOrderMutation, CreateOrderMutationVariables> {
    document = CreateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersSearchDocument = gql`
    query OrdersSearch($limit: Int!, $skip: Int!, $filter: OrderFilter!, $lineItemStates: [String!], $packingWeekStart: String, $packingWeekEnd: String, $varietyIds: [Int!], $commodityIds: [Int!], $subCommodityIds: [Int!], $states: [StateFilter!], $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  ordersSearch(filter: $filter) {
    orders(limit: $limit, skip: $skip) {
      ...multipleOrderFields
    }
    totalOrders
    totalFiltered
  }
}
    ${MultipleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersSearchGQL extends Apollo.Query<OrdersSearchQuery, OrdersSearchQueryVariables> {
    document = OrdersSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersSearchFilterAttributesDocument = gql`
    query ordersSearchFilterAttributes {
  ordersSearchFilterAttributes {
    commodities {
      id
      name
    }
    varieties {
      id
      name
    }
    subCommodities {
      id
      name
    }
    companies {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersSearchFilterAttributesGQL extends Apollo.Query<OrdersSearchFilterAttributesQuery, OrdersSearchFilterAttributesQueryVariables> {
    document = OrdersSearchFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderDocument = gql`
    query Order($id: ID!, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  order(id: $id) {
    ...singleOrderFieldsWithNetReturn
  }
}
    ${SingleOrderFieldsWithNetReturnFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderGQL extends Apollo.Query<OrderQuery, OrderQueryVariables> {
    document = OrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateOrderDocument = gql`
    query DuplicateOrder($id: ID!) {
  order(id: $id) {
    ...duplicateOrderFields
  }
}
    ${DuplicateOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateOrderGQL extends Apollo.Query<DuplicateOrderQuery, DuplicateOrderQueryVariables> {
    document = DuplicateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($attributes: UpdateOrderAttributes!) {
  updateOrder(attributes: $attributes) {
    order {
      ...singleOrderFields
    }
    errors
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrderGQL extends Apollo.Mutation<UpdateOrderMutation, UpdateOrderMutationVariables> {
    document = UpdateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLineItemsDocument = gql`
    mutation UpdateLineItems($attributes: [UpdateLineItemAttributes!]!) {
  updateLineItems(attributes: $attributes) {
    lineItems {
      ...singleLineItemFields
    }
    errors
  }
}
    ${SingleLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLineItemsGQL extends Apollo.Mutation<UpdateLineItemsMutation, UpdateLineItemsMutationVariables> {
    document = UpdateLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptLineItemsDocument = gql`
    mutation AcceptLineItems($ids: [Int!]!) {
  acceptLineItems(ids: $ids) {
    orders {
      ...singleOrderFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptLineItemsGQL extends Apollo.Mutation<AcceptLineItemsMutation, AcceptLineItemsMutationVariables> {
    document = AcceptLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WontPackLineItemsDocument = gql`
    mutation WontPackLineItems($ids: [Int!]!) {
  wontPackLineItems(ids: $ids) {
    orders {
      ...singleOrderFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class WontPackLineItemsGQL extends Apollo.Mutation<WontPackLineItemsMutation, WontPackLineItemsMutationVariables> {
    document = WontPackLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevertLineItemsToCreatedDocument = gql`
    mutation RevertLineItemsToCreated($ids: [Int!]!) {
  revertLineItemsToCreated(ids: $ids) {
    orders {
      ...singleOrderFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevertLineItemsToCreatedGQL extends Apollo.Mutation<RevertLineItemsToCreatedMutation, RevertLineItemsToCreatedMutationVariables> {
    document = RevertLineItemsToCreatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevertOrderChangeDocument = gql`
    mutation RevertOrderChange($startid: Int!, $endid: Int!, $orderid: Int!) {
  revertOrderChange(startId: $startid, endId: $endid, orderId: $orderid) {
    order {
      ...singleOrderFields
    }
    errors
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevertOrderChangeGQL extends Apollo.Mutation<RevertOrderChangeMutation, RevertOrderChangeMutationVariables> {
    document = RevertOrderChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadOrderShipmentDocumentDocument = gql`
    mutation UploadOrderShipmentDocument($orderid: Int!, $type: String!, $file: Upload!) {
  uploadOrderShipmentDocument(orderid: $orderid, type: $type, file: $file) {
    order {
      shipmentDocuments {
        ...shipmentDocumentFields
      }
    }
  }
}
    ${ShipmentDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadOrderShipmentDocumentGQL extends Apollo.Mutation<UploadOrderShipmentDocumentMutation, UploadOrderShipmentDocumentMutationVariables> {
    document = UploadOrderShipmentDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewOrderDocument = gql`
    subscription NewOrder {
  newOrder {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NewOrderGQL extends Apollo.Subscription<NewOrderSubscription, NewOrderSubscriptionVariables> {
    document = NewOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAcceptLineItemsDocument = gql`
    subscription OnAcceptLineItems {
  onAcceptLineItems {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAcceptLineItemsGQL extends Apollo.Subscription<OnAcceptLineItemsSubscription, OnAcceptLineItemsSubscriptionVariables> {
    document = OnAcceptLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnWontPackLineItemsDocument = gql`
    subscription OnWontPackLineItems {
  onWontPackLineItems {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnWontPackLineItemsGQL extends Apollo.Subscription<OnWontPackLineItemsSubscription, OnWontPackLineItemsSubscriptionVariables> {
    document = OnWontPackLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnRevertLineItemsToCreatedDocument = gql`
    subscription OnRevertLineItemsToCreated {
  onRevertLineItemsToCreated {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnRevertLineItemsToCreatedGQL extends Apollo.Subscription<OnRevertLineItemsToCreatedSubscription, OnRevertLineItemsToCreatedSubscriptionVariables> {
    document = OnRevertLineItemsToCreatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackInstructionsLineItemsDocument = gql`
    query PackInstructionsLineItems($attributes: PackInstructionsAttributes!) {
  packInstructions(attributes: $attributes) {
    groupId
    priority
    batchNumber
    buyer
    comments {
      commentText
      id
      userId
      commentableType
      user {
        avatarFile {
          id
          filename
          url
        }
        firstName
        lastName
        id
      }
      updatedAt
      isDeleted
      createdAt
      commentableId
    }
    commodity
    grade
    id
    inventoryCode
    mark
    orderId
    pack
    packingWeek
    palletStack
    quantitesPacked
    quantityRequested
    quantityUnit
    referenceNumber
    seller
    sizeCounts
    state
    subCommodity
    targetMarket
    targetRegion
    targetCountry
    variety
    varietyCode
    additionalFields
    incoterm
    priceUnit
    priceMajorUnit
    currency
    priceTerm
    formattedPrice
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PackInstructionsLineItemsGQL extends Apollo.Query<PackInstructionsLineItemsQuery, PackInstructionsLineItemsQueryVariables> {
    document = PackInstructionsLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackInstructionsFilterAttributesDocument = gql`
    query PackInstructionsFilterAttributes {
  packInstructionsFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    sellers {
      id
      name
    }
    subCommodities {
      id
      name
    }
    varieties {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PackInstructionsFilterAttributesGQL extends Apollo.Query<PackInstructionsFilterAttributesQuery, PackInstructionsFilterAttributesQueryVariables> {
    document = PackInstructionsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnePackClientCodesDocument = gql`
    query OnePackClientCodes {
  onepackClientCodes {
    id
    clientCode
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnePackClientCodesGQL extends Apollo.Query<OnePackClientCodesQuery, OnePackClientCodesQueryVariables> {
    document = OnePackClientCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnepackSyncCallsDocument = gql`
    query OnepackSyncCalls($clientCode: String, $limit: Int) {
  onepackPackInstructionSyncCalls(clientCode: $clientCode, limit: $limit) {
    id
    clientCode
    url
    message
    statusCode
    syncSucceeded
    itemsCount
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnepackSyncCallsGQL extends Apollo.Query<OnepackSyncCallsQuery, OnepackSyncCallsQueryVariables> {
    document = OnepackSyncCallsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePackInstructionLineItemPriorityDocument = gql`
    mutation updatePackInstructionLineItemPriority($packInstructionLineItemId: ID!, $priority: Int) {
  updatePackInstructionLineItemPriority(
    packInstructionLineItemId: $packInstructionLineItemId
    priority: $priority
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePackInstructionLineItemPriorityGQL extends Apollo.Mutation<UpdatePackInstructionLineItemPriorityMutation, UpdatePackInstructionLineItemPriorityMutationVariables> {
    document = UpdatePackInstructionLineItemPriorityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PushPackInstructionsToOnepackDocument = gql`
    mutation pushPackInstructionsToOnepack($clientCode: String!, $packInstructionsAttributes: PackInstructionsAttributes!) {
  pushPackInstructionsToOnepack(
    clientCode: $clientCode
    packInstructionsAttributes: $packInstructionsAttributes
  ) {
    success
    message
    isPlatformError
    packInstructionRef
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PushPackInstructionsToOnepackGQL extends Apollo.Mutation<PushPackInstructionsToOnepackMutation, PushPackInstructionsToOnepackMutationVariables> {
    document = PushPackInstructionsToOnepackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackhouseConnectionsDocument = gql`
    query PackhouseConnections {
  packhouseConnections {
    id
    name
    state
    scheduledFor
    scheduledAt
    createdAt
    updatedAt
    apiUserId
    connected
    lastProcessedDatetime
    onPremSystem
    company {
      ...companyFields
    }
    foodBusinessOperator {
      ...foodBusinessOperatorFields
    }
    masterfileConfig {
      ...masterfileConfigFields
    }
  }
}
    ${CompanyFieldsFragmentDoc}
${FoodBusinessOperatorFieldsFragmentDoc}
${MasterfileConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PackhouseConnectionsGQL extends Apollo.Query<PackhouseConnectionsQuery, PackhouseConnectionsQueryVariables> {
    document = PackhouseConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackhouseConnectionsClientChangeRequestsDocument = gql`
    query PackhouseConnectionsClientChangeRequests {
  packhouseConnectionsClientChangeRequests {
    id
    foodBusinessOperator {
      id
      name
      fboCode
      producerName
      typeOfBusiness
      productionRegion
      company {
        id
        name
      }
      createdAt
      updatedAt
    }
    company {
      ...companyFields
    }
    createdAt
    updatedAt
  }
}
    ${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PackhouseConnectionsClientChangeRequestsGQL extends Apollo.Query<PackhouseConnectionsClientChangeRequestsQuery, PackhouseConnectionsClientChangeRequestsQueryVariables> {
    document = PackhouseConnectionsClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePackhouseConnectionsRequestDocument = gql`
    mutation CreatePackhouseConnectionsRequest($attributes: CreatePackhouseConnectionsAttribute!) {
  createPackhouseConnectionsRequest(attributes: $attributes) {
    clientChangeRequests {
      id
      foodBusinessOperator {
        id
        name
        fboCode
        producerName
        typeOfBusiness
        productionRegion
        company {
          id
          name
        }
        createdAt
        updatedAt
      }
      company {
        ...companyFields
      }
      createdAt
      updatedAt
    }
    errors
  }
}
    ${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePackhouseConnectionsRequestGQL extends Apollo.Mutation<CreatePackhouseConnectionsRequestMutation, CreatePackhouseConnectionsRequestMutationVariables> {
    document = CreatePackhouseConnectionsRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentDocument = gql`
    query Payment($id: ID!) {
  payment(id: $id) {
    totalAmountMajorUnit
    allocatedAmountMajorUnit
    remainingAmountMajorUnit
    bankChargesMajorUnit
    bankChargesSplit
    cashbookReference
    companyName
    companyId
    createdAt
    currency
    description
    id
    contactName
    contactId
    paymentDate
    paymentType
    updatedAt
    state
    invoices {
      id
      invoiceNumber
      documentType
      currency
      allocatedAmountMajorUnit
      remainingAmountMajorUnit
      containerNumbers
      state
      totalIncoterm
      remittableAmountMajorUnit
      updatedAt
      invoicePayments {
        id
        invoiceId
        paymentId
        amountMajorUnit
      }
    }
    invoicePaymentAllocations {
      invoiceId
      totalAmountMajorUnit
    }
    currencyExchangeRate {
      id
      fromCurrency
      toCurrency
      exchangeRate
      exchangeRateDate
      exchangeRateType
      currencyConversion {
        id
        rates
        timestamp
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentGQL extends Apollo.Query<PaymentQuery, PaymentQueryVariables> {
    document = PaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentsDocument = gql`
    query Payments($filterAttributes: PaymentsFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  payments(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      totalAmountMajorUnit
      allocatedAmountMajorUnit
      remainingAmountMajorUnit
      bankChargesMajorUnit
      bankChargesSplit
      cashbookReference
      companyName
      companyId
      createdAt
      currency
      description
      id
      contactName
      contactId
      paymentDate
      paymentType
      updatedAt
      state
      exchangeRate
      currencyExchangeRate {
        id
        fromCurrency
        toCurrency
        exchangeRate
        exchangeRateDate
        exchangeRateType
        currencyConversion {
          id
          rates
          timestamp
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentsGQL extends Apollo.Query<PaymentsQuery, PaymentsQueryVariables> {
    document = PaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentsFilterAttributesDocument = gql`
    query PaymentsFilterAttributes {
  paymentsFilterAttributes {
    contacts {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentsFilterAttributesGQL extends Apollo.Query<PaymentsFilterAttributesQuery, PaymentsFilterAttributesQueryVariables> {
    document = PaymentsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyPaymentsDocument = gql`
    query CompanyPayments($filterAttributes: CompanyPaymentFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  companyPayments(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    incomingAmountDueMajorUnit
    outgoingAmountDueMajorUnit
    currency
    companyName
    companyId
    invoicesDue
    contactName
    contactId
    incomingUnallocatedAmountMajorUnit
    outgoingUnallocatedAmountMajorUnit
    unallocatedPayments
    contact {
      id
      name
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyPaymentsGQL extends Apollo.Query<CompanyPaymentsQuery, CompanyPaymentsQueryVariables> {
    document = CompanyPaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyPaymentsFilterAttributesDocument = gql`
    query CompanyPaymentsFilterAttributes {
  companyPaymentsFilterAttributes {
    contacts {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyPaymentsFilterAttributesGQL extends Apollo.Query<CompanyPaymentsFilterAttributesQuery, CompanyPaymentsFilterAttributesQueryVariables> {
    document = CompanyPaymentsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoicesDocument = gql`
    query Invoices($filterAttributes: InvoicesFilters!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $page: String!, $first: Int, $last: Int, $after: String, $before: String) {
  invoices(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    page: $page
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      id
      invoiceNumber
      documentType
      currency
      allocatedAmountMajorUnit
      remainingAmountMajorUnit
      remittableAmountMajorUnit
      containerNumbers
      state
      totalIncoterm
      updatedAt
      invoicePayments {
        id
        invoiceId
        paymentId
        amountMajorUnit
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoicesGQL extends Apollo.Query<InvoicesQuery, InvoicesQueryVariables> {
    document = InvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePaymentDocument = gql`
    mutation CreatePayment($attributes: PaymentAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  createPayment(
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    payment {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePaymentGQL extends Apollo.Mutation<CreatePaymentMutation, CreatePaymentMutationVariables> {
    document = CreatePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($paymentId: ID!, $attributes: PaymentAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  updatePayment(
    paymentId: $paymentId
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    payment {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePaymentGQL extends Apollo.Mutation<UpdatePaymentMutation, UpdatePaymentMutationVariables> {
    document = UpdatePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePaymentDocument = gql`
    mutation DeletePayment($paymentId: ID!) {
  deletePayment(paymentId: $paymentId) {
    errors
    payment {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePaymentGQL extends Apollo.Mutation<DeletePaymentMutation, DeletePaymentMutationVariables> {
    document = DeletePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocatePaymentsDocument = gql`
    mutation AllocatePayments($paymentAllocations: [PaymentAllocationAttributes!]!) {
  allocatePayments(paymentAllocations: $paymentAllocations) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocatePaymentsGQL extends Apollo.Mutation<AllocatePaymentsMutation, AllocatePaymentsMutationVariables> {
    document = AllocatePaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PnlLinkedRecordsDocument = gql`
    query PnlLinkedRecords($cartonGroupingIds: [Int!], $containerIds: [Int!], $breakBulkContainerIds: [Int!], $reportingCurrency: String, $fxEnabled: Boolean) {
  pnlLinkedRecords(
    cartonGroupingIds: $cartonGroupingIds
    containerIds: $containerIds
    breakBulkContainerIds: $breakBulkContainerIds
    reportingCurrency: $reportingCurrency
    fxEnabled: $fxEnabled
  ) {
    id
    recordType
    invoiceNumber
    documentType
    rawDocumentType
    state
    date
    currency
    amountMajorUnit
    isPayment
    contactName
    exchangeRateToReporting
    cartons
    cgCount
    downloadUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PnlLinkedRecordsGQL extends Apollo.Query<PnlLinkedRecordsQuery, PnlLinkedRecordsQueryVariables> {
    document = PnlLinkedRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfitAndLossReportDocument = gql`
    query ProfitAndLossReport($filters: ProfitAndLossFilters!) {
  profitAndLossReport(filters: $filters) {
    nodes {
      farmCode
      containerNumber
      commodity
      variety
      packType
      sizeCount
      grade
      targetRegion
      targetMarket
      targetCountry
      buyerName
      sellerName
      batchNumber
      palletNumber
      exporterCode
      mark
      inventoryCode
      packingWeek
      voyageNumber
      extendedFields
      totalCartons
      totalStdCartons
      totalKilograms
      cgCount
      palletCount
      shippingWeek
      arrivalWeek
      dischargePort
      vesselName
      incoterm
      contractCurrency
      paymentAdviceNumber
      poNumber
      allOnStatement
      paymentAdviceDownloadUrl
      revenue
      cifCosts
      netCif
      fobCosts
      netFob
      dipCosts
      netDip
      exwCosts
      netExw
      growerFinalPayment
      overseasCosts
      localCosts
      revenueAdvance
      revenueFinal
      revenueCreditNote
      revenueDebitNote
      revenuePerCarton
      revenuePerStdCarton
      revenuePerKg
      netCifPerCarton
      netCifPerStdCarton
      netFobPerCarton
      netFobPerStdCarton
      netDipPerCarton
      netDipPerStdCarton
      netExwPerCarton
      netExwPerStdCarton
      cashReceived
      accountsReceivable
      cashReceivedPerCarton
      cashReceivedPerStdCarton
      revenueInclVat
      cifCostsInclVat
      fobCostsInclVat
      dipCostsInclVat
      exwCostsInclVat
      netCifInclVat
      netFobInclVat
      netDipInclVat
      netExwInclVat
      overseasCostsInclVat
      localCostsInclVat
      vatTotalRevenue
      vatTotalCosts
      revenueInclVatPerCarton
      revenueInclVatPerStdCarton
      revenueInclVatPerKg
      netCifInclVatPerCarton
      netCifInclVatPerStdCarton
      netFobInclVatPerCarton
      netFobInclVatPerStdCarton
      netDipInclVatPerCarton
      netDipInclVatPerStdCarton
      netExwInclVatPerCarton
      netExwInclVatPerStdCarton
      costBreakdown
      linkedRecordsCount
      linkedCgIds
      linkedContainerIds
      linkedBbcIds
    }
    pageInfo {
      hasNextPage
    }
    meta {
      rowCount
      sqlMs
      totalMs
      reportingCurrency
      costCategories {
        key
        label
        section
      }
      extendedFieldKeys
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfitAndLossReportGQL extends Apollo.Query<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables> {
    document = ProfitAndLossReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueueProfitAndLossReportDocument = gql`
    mutation QueueProfitAndLossReport($requestId: String!, $filters: ProfitAndLossFilters!) {
  queueProfitAndLossReport(requestId: $requestId, filters: $filters) {
    __typename
    requestId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueueProfitAndLossReportGQL extends Apollo.Mutation<QueueProfitAndLossReportMutation, QueueProfitAndLossReportMutationVariables> {
    document = QueueProfitAndLossReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfitAndLossReportOutcomeDocument = gql`
    query ProfitAndLossReportOutcome($requestId: String!) {
  profitAndLossReportOutcome(requestId: $requestId) {
    ... on ProfitAndLossReportPending {
      __typename
      requestId
    }
    ... on ProfitAndLossReportNotFound {
      __typename
      requestId
    }
    ... on ProfitAndLossReportCompleted {
      __typename
      requestId
      report {
        ...ProfitAndLossReportFields
      }
    }
    ... on ProfitAndLossReportError {
      __typename
      requestId
      error
    }
  }
}
    ${ProfitAndLossReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfitAndLossReportOutcomeGQL extends Apollo.Query<ProfitAndLossReportOutcomeQuery, ProfitAndLossReportOutcomeQueryVariables> {
    document = ProfitAndLossReportOutcomeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnProfitAndLossReportCompleteDocument = gql`
    subscription OnProfitAndLossReportComplete($requestId: String!) {
  onProfitAndLossReportComplete(requestId: $requestId) {
    ... on ProfitAndLossReportPending {
      __typename
      requestId
    }
    ... on ProfitAndLossReportNotFound {
      __typename
      requestId
    }
    ... on ProfitAndLossReportCompleted {
      __typename
      requestId
      report {
        ...ProfitAndLossReportFields
      }
    }
    ... on ProfitAndLossReportError {
      __typename
      requestId
      error
    }
  }
}
    ${ProfitAndLossReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnProfitAndLossReportCompleteGQL extends Apollo.Subscription<OnProfitAndLossReportCompleteSubscription, OnProfitAndLossReportCompleteSubscriptionVariables> {
    document = OnProfitAndLossReportCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfitAndLossFilterAttributesDocument = gql`
    query ProfitAndLossFilterAttributes {
  profitAndLossFilterAttributes {
    extendedFieldKeys {
      key
      label
      values
    }
    farmCodes
    containers {
      id
      name
    }
    vessels {
      id
      name
    }
    commodities {
      id
      name
    }
    varieties {
      id
      name
    }
    buyers {
      id
      name
    }
    sellers {
      id
      name
    }
    grades
    targetRegions
    targetMarkets
    targetCountries
    packTypes
    sizeCounts
    marks
    exporterCodes
    inventoryCodes
    poNumbers
    financialYearOptions {
      year
      label
      startDate
      endDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfitAndLossFilterAttributesGQL extends Apollo.Query<ProfitAndLossFilterAttributesQuery, ProfitAndLossFilterAttributesQueryVariables> {
    document = ProfitAndLossFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunReportDocument = gql`
    query runReport($reportId: Int!, $gridRequest: GridRequest, $reportFilters: [Filter!], $outputType: RunReportOutputTypeEnum) {
  runReport(
    id: $reportId
    gridRequest: $gridRequest
    reportFilters: $reportFilters
    outputType: $outputType
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunReportGQL extends Apollo.Query<RunReportQuery, RunReportQueryVariables> {
    document = RunReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunReportAsyncDocument = gql`
    query runReportAsync($reportId: Int!, $gridRequest: GridRequest, $reportFilters: [Filter!], $requestUuid: String!) {
  runReportAsync(
    id: $reportId
    gridRequest: $gridRequest
    reportFilters: $reportFilters
    requestUuid: $requestUuid
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunReportAsyncGQL extends Apollo.Query<RunReportAsyncQuery, RunReportAsyncQueryVariables> {
    document = RunReportAsyncDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportDocument = gql`
    query report($reportId: Int!) {
  report(id: $reportId) {
    createdAt
    dataPreparationId
    description
    id
    name
    configs {
      name
      value
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGQL extends Apollo.Query<ReportQuery, ReportQueryVariables> {
    document = ReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportGroupsDocument = gql`
    query reportGroups($filterAttributes: ReportGroupFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  reportGroups(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    name
    description
    id
    domain
    scope
    badges {
      id
      text
      color
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGroupsGQL extends Apollo.Query<ReportGroupsQuery, ReportGroupsQueryVariables> {
    document = ReportGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportGroupDocument = gql`
    query reportGroup($reportGroupId: Int!) {
  reportGroup(id: $reportGroupId) {
    id
    layout
    name
    description
    configs {
      name
      value
    }
    reports {
      id
      reportType
      name
    }
    switchUnit {
      id
      name
      defaultValue
      switchUnitOptions {
        id
        label
        value
        sortOrder
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGroupGQL extends Apollo.Query<ReportGroupQuery, ReportGroupQueryVariables> {
    document = ReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchReportResultDocument = gql`
    query fetchReportResult($requestUuid: String!) {
  fetchReportResult(requestUuid: $requestUuid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchReportResultGQL extends Apollo.Query<FetchReportResultQuery, FetchReportResultQueryVariables> {
    document = FetchReportResultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportGroupCycleDocument = gql`
    query reportGroupCycle($id: ID!) {
  reportGroupCycle(id: $id) {
    id
    name
    description
    durationSeconds
    items {
      id
      reportGroupId
      params
      reportGroup {
        id
        name
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGroupCycleGQL extends Apollo.Query<ReportGroupCycleQuery, ReportGroupCycleQueryVariables> {
    document = ReportGroupCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateReportGroupDocument = gql`
    mutation createReportGroup($attributes: ReportGroupAttributes!) {
  createReportGroup(attributes: $attributes) {
    errors
    reportGroup {
      description
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateReportGroupGQL extends Apollo.Mutation<CreateReportGroupMutation, CreateReportGroupMutationVariables> {
    document = CreateReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReportGroupDocument = gql`
    mutation updateReportGroup($attributes: ReportGroupAttributes!) {
  updateReportGroup(attributes: $attributes) {
    errors
    reportGroup {
      description
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReportGroupGQL extends Apollo.Mutation<UpdateReportGroupMutation, UpdateReportGroupMutationVariables> {
    document = UpdateReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteReportGroupDocument = gql`
    mutation deleteReportGroup($id: Int!) {
  deleteReportGroup(id: $id) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteReportGroupGQL extends Apollo.Mutation<DeleteReportGroupMutation, DeleteReportGroupMutationVariables> {
    document = DeleteReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnReportCompleteDocument = gql`
    subscription onReportComplete {
  onReportComplete {
    requestUuid
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnReportCompleteGQL extends Apollo.Subscription<OnReportCompleteSubscription, OnReportCompleteSubscriptionVariables> {
    document = OnReportCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnRefreshReportDocument = gql`
    subscription onRefreshReport {
  onRefreshReport {
    chartSource
    description
    domain
    id
    name
    displayName
    scope
    url
    powerbiEmbedAttributes {
      embedToken
      embedUrl
      reportId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnRefreshReportGQL extends Apollo.Subscription<OnRefreshReportSubscription, OnRefreshReportSubscriptionVariables> {
    document = OnRefreshReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueueReportGroupOutputFileDocument = gql`
    mutation QueueReportGroupOutputFile($reportGroupId: ID!, $requestId: String!, $queryParams: String) {
  queueReportGroupOutputFile(
    reportGroupId: $reportGroupId
    requestId: $requestId
    queryParams: $queryParams
  ) {
    requestId
    status
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueueReportGroupOutputFileGQL extends Apollo.Mutation<QueueReportGroupOutputFileMutation, QueueReportGroupOutputFileMutationVariables> {
    document = QueueReportGroupOutputFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnReportOutputFileCompleteDocument = gql`
    subscription OnReportOutputFileComplete($requestId: String!) {
  onReportOutputFileComplete(requestId: $requestId) {
    requestId
    status
    pdfUrl
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnReportOutputFileCompleteGQL extends Apollo.Subscription<OnReportOutputFileCompleteSubscription, OnReportOutputFileCompleteSubscriptionVariables> {
    document = OnReportOutputFileCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SettingsDocument = gql`
    query Settings {
  myUser {
    id
    firstName
    lastName
    phoneNumber
    email
    state
    notifyEmail
    notifyBrowserPush
    createdAt
    updatedAt
    useV2
    avatar
    avatarFile {
      id
      filename
      url
    }
    company {
      id
      name
    }
    role
    roles {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SettingsGQL extends Apollo.Query<SettingsQuery, SettingsQueryVariables> {
    document = SettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: Int!, $firstname: String!, $lastname: String!, $phonenumber: String!, $notifyemail: Boolean!, $notifybrowserpush: Boolean!, $usev2: Boolean!) {
  updateUser(
    id: $id
    firstName: $firstname
    lastName: $lastname
    phoneNumber: $phonenumber
    notifyEmail: $notifyemail
    notifyBrowserPush: $notifybrowserpush
    useV2: $usev2
  ) {
    user {
      id
      firstName
      lastName
      phoneNumber
      state
      notifyEmail
      notifyBrowserPush
      useV2
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserNotificationsDocument = gql`
    mutation UpdateUserNotifications($id: Int!, $notifyEmail: Boolean!, $notifyBrowserPush: Boolean!) {
  updateUserNotifications(
    id: $id
    notifyEmail: $notifyEmail
    notifyBrowserPush: $notifyBrowserPush
  ) {
    user {
      id
      notifyEmail
      notifyBrowserPush
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserNotificationsGQL extends Apollo.Mutation<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables> {
    document = UpdateUserNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadUserAvatarDocument = gql`
    mutation UploadUserAvatar($file: Upload!) {
  uploadUserAvatar(file: $file) {
    user {
      avatarFile {
        id
        filename
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadUserAvatarGQL extends Apollo.Mutation<UploadUserAvatarMutation, UploadUserAvatarMutationVariables> {
    document = UploadUserAvatarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShipmentDocumentDocument = gql`
    mutation UpdateShipmentDocument($id: Int!, $type: String!) {
  updateShipmentDocument(id: $id, type: $type) {
    shipmentDocument {
      id
      documentType
      state
      user {
        id
        firstName
        lastName
        company {
          id
        }
      }
      file {
        id
        filename
        v2Url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShipmentDocumentGQL extends Apollo.Mutation<UpdateShipmentDocumentMutation, UpdateShipmentDocumentMutationVariables> {
    document = UpdateShipmentDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteShipmentDocumentDocument = gql`
    mutation DeleteShipmentDocument($id: Int!) {
  deleteShipmentDocument(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteShipmentDocumentGQL extends Apollo.Mutation<DeleteShipmentDocumentMutation, DeleteShipmentDocumentMutationVariables> {
    document = DeleteShipmentDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateShipmentDocument = gql`
    mutation CreateShipment($attributes: ShipmentAttributes!) {
  createShipment(attributes: $attributes) {
    errors
    shipment {
      ...shipmentCommonFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateShipmentGQL extends Apollo.Mutation<CreateShipmentMutation, CreateShipmentMutationVariables> {
    document = CreateShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShipmentDocument = gql`
    mutation UpdateShipment($attributes: ShipmentAttributes!) {
  updateShipment(attributes: $attributes) {
    errors
    shipment {
      ...shipmentCommonFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShipmentGQL extends Apollo.Mutation<UpdateShipmentMutation, UpdateShipmentMutationVariables> {
    document = UpdateShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateShipmentLineItemDocument = gql`
    mutation CreateShipmentLineItem($attributes: ShipmentLineItemAttributes!) {
  createShipmentLineItem(attributes: $attributes) {
    errors
    shipmentLineItem {
      ...sliCommonFields
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateShipmentLineItemGQL extends Apollo.Mutation<CreateShipmentLineItemMutation, CreateShipmentLineItemMutationVariables> {
    document = CreateShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateShipmentLineItemDocument = gql`
    mutation duplicateShipmentLineItem($id: ID!) {
  duplicateShipmentLineItem(id: $id) {
    shipmentLineItems {
      ...sliCommonFields
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateShipmentLineItemGQL extends Apollo.Mutation<DuplicateShipmentLineItemMutation, DuplicateShipmentLineItemMutationVariables> {
    document = DuplicateShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShipmentLineItemDocument = gql`
    mutation UpdateShipmentLineItem($attributes: ShipmentLineItemAttributes!) {
  updateShipmentLineItem(attributes: $attributes) {
    errors
    shipmentLineItem {
      ...sliCommonFields
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShipmentLineItemGQL extends Apollo.Mutation<UpdateShipmentLineItemMutation, UpdateShipmentLineItemMutationVariables> {
    document = UpdateShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExportNotificationBookingDocument = gql`
    mutation CreateExportNotificationBooking($id: Int!) {
  createExportNotificationBooking(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExportNotificationBookingGQL extends Apollo.Mutation<CreateExportNotificationBookingMutation, CreateExportNotificationBookingMutationVariables> {
    document = CreateExportNotificationBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExportNotificationLineItemDocument = gql`
    mutation CreateExportNotificationLineItem($id: Int!) {
  createExportNotificationLineItem(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExportNotificationLineItemGQL extends Apollo.Mutation<CreateExportNotificationLineItemMutation, CreateExportNotificationLineItemMutationVariables> {
    document = CreateExportNotificationLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAddendumDocument = gql`
    mutation UpdateAddendum($addendumLineItems: [AddendumLineItemAttributes!]!, $addendumHeader: AddendumHeaderAttributes!) {
  updateAddendum(
    addendumLineItems: $addendumLineItems
    addendumHeader: $addendumHeader
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAddendumGQL extends Apollo.Mutation<UpdateAddendumMutation, UpdateAddendumMutationVariables> {
    document = UpdateAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAddendumDocument = gql`
    mutation GenerateAddendum($sliIds: [Int!], $bookingReference: String, $shipmentId: ID) {
  generateAddendum(
    sliIds: $sliIds
    bookingReference: $bookingReference
    shipmentId: $shipmentId
  ) {
    errors
    addendumHeader {
      ...addendumHeaderFields
      addendumLineItems {
        ...addendumLineItemFields
      }
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAddendumGQL extends Apollo.Mutation<GenerateAddendumMutation, GenerateAddendumMutationVariables> {
    document = GenerateAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelAddendumDocument = gql`
    mutation CancelAddendum($id: Int!, $deleteAddendum: Boolean!) {
  cancelAddendum(id: $id, deleteAddendum: $deleteAddendum) {
    id
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelAddendumGQL extends Apollo.Mutation<CancelAddendumMutation, CancelAddendumMutationVariables> {
    document = CancelAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmExportNotificationLineItemDocument = gql`
    mutation ConfirmExportNotificationLineItem($id: Int!) {
  confirmExportNotificationLineItem(id: $id) {
    errors
    shipment {
      ...shipmentCommonFields
      portOfLoading {
        id
        name
        unLocode
      }
      shipmentLineItems {
        ...sliCommonFields
      }
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmExportNotificationLineItemGQL extends Apollo.Mutation<ConfirmExportNotificationLineItemMutation, ConfirmExportNotificationLineItemMutationVariables> {
    document = ConfirmExportNotificationLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteShipmentDocument = gql`
    mutation CompleteShipment($id: ID!) {
  completeShipment(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteShipmentGQL extends Apollo.Mutation<CompleteShipmentMutation, CompleteShipmentMutationVariables> {
    document = CompleteShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteShipmentLineItemDocument = gql`
    mutation CompleteShipmentLineItem($id: ID!) {
  completeShipmentLineItem(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteShipmentLineItemGQL extends Apollo.Mutation<CompleteShipmentLineItemMutation, CompleteShipmentLineItemMutationVariables> {
    document = CompleteShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitAddendumDocument = gql`
    mutation SubmitAddendum($id: Int!) {
  submitAddendum(id: $id) {
    errors
    validation
    addendumHeader {
      ...addendumHeaderFields
      addendumLineItems {
        ...addendumLineItemFields
      }
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitAddendumGQL extends Apollo.Mutation<SubmitAddendumMutation, SubmitAddendumMutationVariables> {
    document = SubmitAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueryAddendumDocument = gql`
    mutation QueryAddendum($id: Int!) {
  queryAddendum(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueryAddendumGQL extends Apollo.Mutation<QueryAddendumMutation, QueryAddendumMutationVariables> {
    document = QueryAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocateSliContainerDocument = gql`
    mutation AllocateSliContainer($sliId: Int!, $sliContainerId: Int, $isBreakBulk: Boolean!) {
  allocateSliContainer(
    sliId: $sliId
    sliContainerId: $sliContainerId
    isBreakBulk: $isBreakBulk
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocateSliContainerGQL extends Apollo.Mutation<AllocateSliContainerMutation, AllocateSliContainerMutationVariables> {
    document = AllocateSliContainerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteShipmentLineItemDocument = gql`
    mutation DeleteShipmentLineItem($id: Int!) {
  deleteShipmentLineItem(id: $id) {
    id
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteShipmentLineItemGQL extends Apollo.Mutation<DeleteShipmentLineItemMutation, DeleteShipmentLineItemMutationVariables> {
    document = DeleteShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAddendumLineItemDocument = gql`
    mutation DeleteAddendumLineItem($id: Int!) {
  deleteAddendumLineItem(id: $id) {
    addendumLineItems {
      ...addendumLineItemFields
    }
    errors
  }
}
    ${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAddendumLineItemGQL extends Apollo.Mutation<DeleteAddendumLineItemMutation, DeleteAddendumLineItemMutationVariables> {
    document = DeleteAddendumLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateAddendumLineItemDocument = gql`
    mutation DuplicateAddendumLineItem($id: Int!) {
  duplicateAddendumLineItem(id: $id) {
    addendumLineItems {
      ...addendumLineItemFields
    }
  }
}
    ${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateAddendumLineItemGQL extends Apollo.Mutation<DuplicateAddendumLineItemMutation, DuplicateAddendumLineItemMutationVariables> {
    document = DuplicateAddendumLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteExportDocumentDocument = gql`
    mutation DeleteExportDocument($id: Int!) {
  deleteExportDocument(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteExportDocumentGQL extends Apollo.Mutation<DeleteExportDocumentMutation, DeleteExportDocumentMutationVariables> {
    document = DeleteExportDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadExportDocumentDocument = gql`
    mutation UploadExportDocument($attributes: ShipmentLineItemAttributes!, $file: Upload!) {
  uploadExportDocument(attributes: $attributes, file: $file) {
    errors
    shipmentLineItem {
      exportDocuments {
        ...exportDocumentFields
      }
    }
  }
}
    ${ExportDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadExportDocumentGQL extends Apollo.Mutation<UploadExportDocumentMutation, UploadExportDocumentMutationVariables> {
    document = UploadExportDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExportDocumentDocument = gql`
    mutation UpdateExportDocument($id: Int!, $type: String!) {
  updateExportDocument(id: $id, type: $type) {
    exportDocument {
      id
      documentType
      user {
        id
        firstName
        lastName
        company {
          id
        }
      }
      file {
        id
        filename
        v2Url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExportDocumentGQL extends Apollo.Mutation<UpdateExportDocumentMutation, UpdateExportDocumentMutationVariables> {
    document = UpdateExportDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemFilterAttributesDocument = gql`
    query ShipmentLineItemFilterAttributes {
  shipmentLineItemFilterAttributes {
    controllers
    shippingLineReferences
    clients
    vessels
    states
    stackDatesStatus
    shipmentTypes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemFilterAttributesGQL extends Apollo.Query<ShipmentLineItemFilterAttributesQuery, ShipmentLineItemFilterAttributesQueryVariables> {
    document = ShipmentLineItemFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbVoyageNumbersDocument = gql`
    query shipmentPpecbVoyageNumbers {
  ppecbVoyageNumbers {
    id
    voyageNumber
    vesselName
    ppecbVoyageNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbVoyageNumbersGQL extends Apollo.Query<ShipmentPpecbVoyageNumbersQuery, ShipmentPpecbVoyageNumbersQueryVariables> {
    document = ShipmentPpecbVoyageNumbersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbCountriesDocument = gql`
    query shipmentPpecbCountries {
  ppecbCountries {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbCountriesGQL extends Apollo.Query<ShipmentPpecbCountriesQuery, ShipmentPpecbCountriesQueryVariables> {
    document = ShipmentPpecbCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbActivityPointsDocument = gql`
    query shipmentPpecbActivityPoints {
  ppecbActivityPoints {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbActivityPointsGQL extends Apollo.Query<ShipmentPpecbActivityPointsQuery, ShipmentPpecbActivityPointsQueryVariables> {
    document = ShipmentPpecbActivityPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbWorldPortsDocument = gql`
    query shipmentPpecbWorldPorts {
  ppecbWorldPorts {
    id
    portCode
    portName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbWorldPortsGQL extends Apollo.Query<ShipmentPpecbWorldPortsQuery, ShipmentPpecbWorldPortsQueryVariables> {
    document = ShipmentPpecbWorldPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbContainerTypesDocument = gql`
    query shipmentPpecbContainerTypes {
  ppecbContainerTypes {
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbContainerTypesGQL extends Apollo.Query<ShipmentPpecbContainerTypesQuery, ShipmentPpecbContainerTypesQueryVariables> {
    document = ShipmentPpecbContainerTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbProductsDocument = gql`
    query shipmentPpecbProducts {
  ppecbProducts {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbProductsGQL extends Apollo.Query<ShipmentPpecbProductsQuery, ShipmentPpecbProductsQueryVariables> {
    document = ShipmentPpecbProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbVentsDocument = gql`
    query shipmentPpecbVents {
  ppecbVents {
    code
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbVentsGQL extends Apollo.Query<ShipmentPpecbVentsQuery, ShipmentPpecbVentsQueryVariables> {
    document = ShipmentPpecbVentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbRegimeCodesDocument = gql`
    query shipmentPpecbRegimeCodes {
  ppecbRegimeCodes {
    regimeCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbRegimeCodesGQL extends Apollo.Query<ShipmentPpecbRegimeCodesQuery, ShipmentPpecbRegimeCodesQueryVariables> {
    document = ShipmentPpecbRegimeCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbPortsDocument = gql`
    query shipmentPpecbPorts {
  ppecbPorts {
    id
    portCode
    portName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbPortsGQL extends Apollo.Query<ShipmentPpecbPortsQuery, ShipmentPpecbPortsQueryVariables> {
    document = ShipmentPpecbPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentTerminalsDocument = gql`
    query shipmentTerminals {
  terminals {
    id
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentTerminalsGQL extends Apollo.Query<ShipmentTerminalsQuery, ShipmentTerminalsQueryVariables> {
    document = ShipmentTerminalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SliContainersDocument = gql`
    query sliContainers {
  sliContainers {
    id
    container {
      id
      containerNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SliContainersGQL extends Apollo.Query<SliContainersQuery, SliContainersQueryVariables> {
    document = SliContainersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SliBreakBulksDocument = gql`
    query sliBreakBulks {
  sliBreakBulks {
    id
    breakBulkContainer {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SliBreakBulksGQL extends Apollo.Query<SliBreakBulksQuery, SliBreakBulksQueryVariables> {
    document = SliBreakBulksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SeaShipmentControllersDocument = gql`
    query SeaShipmentControllers {
  seaShipmentControllers {
    id
    firstName
    lastName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SeaShipmentControllersGQL extends Apollo.Query<SeaShipmentControllersQuery, SeaShipmentControllersQueryVariables> {
    document = SeaShipmentControllersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocateShipmentControllerDocument = gql`
    mutation AllocateShipmentController($shipmentId: Int!, $userId: Int) {
  allocateShipmentController(shipmentId: $shipmentId, userId: $userId) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocateShipmentControllerGQL extends Apollo.Mutation<AllocateShipmentControllerMutation, AllocateShipmentControllerMutationVariables> {
    document = AllocateShipmentControllerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentContainerDepotsDocument = gql`
    query shipmentContainerDepots($typeOfBusiness: Int!) {
  foodBusinessOperatorsByType(typeOfBusiness: $typeOfBusiness) {
    id
    name
    producerName
    fboCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentContainerDepotsGQL extends Apollo.Query<ShipmentContainerDepotsQuery, ShipmentContainerDepotsQueryVariables> {
    document = ShipmentContainerDepotsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumHeaderByIdDocument = gql`
    query addendumHeaderById($id: Int!) {
  addendumHeaderById(id: $id) {
    ...addendumHeaderFields
    addendumLineItems {
      ...addendumLineItemFields
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumHeaderByIdGQL extends Apollo.Query<AddendumHeaderByIdQuery, AddendumHeaderByIdQueryVariables> {
    document = AddendumHeaderByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumLineItemsByHeaderIdDocument = gql`
    query addendumLineItemsByHeaderId($addendumHeaderId: Int!) {
  addendumLineItemsByHeaderId(addendumHeaderId: $addendumHeaderId) {
    ...addendumLineItemFields
  }
}
    ${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumLineItemsByHeaderIdGQL extends Apollo.Query<AddendumLineItemsByHeaderIdQuery, AddendumLineItemsByHeaderIdQueryVariables> {
    document = AddendumLineItemsByHeaderIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumsOnShipmentDocument = gql`
    query addendumsOnShipment($shipmentId: Int!) {
  addendumsOnShipment(shipmentId: $shipmentId) {
    id
    shippingBookingReference
    verificationStatus
    state
    addendumStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumsOnShipmentGQL extends Apollo.Query<AddendumsOnShipmentQuery, AddendumsOnShipmentQueryVariables> {
    document = AddendumsOnShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NonAddendumShipmentLineItemsDocument = gql`
    query nonAddendumShipmentLineItems($shipmentId: Int!, $bookingRef: String) {
  nonAddendumShipmentLineItems(shipmentId: $shipmentId, bookingRef: $bookingRef) {
    id
    containerNumber
    breakBulkContainerNamesIn
    customerReference
    shippingLineReference
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NonAddendumShipmentLineItemsGQL extends Apollo.Query<NonAddendumShipmentLineItemsQuery, NonAddendumShipmentLineItemsQueryVariables> {
    document = NonAddendumShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SliContainersByBookingReferenceDocument = gql`
    query sliContainersByBookingReference($bookingReference: String!) {
  sliContainersByBookingReference(bookingReference: $bookingReference) {
    id
    container {
      containerNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SliContainersByBookingReferenceGQL extends Apollo.Query<SliContainersByBookingReferenceQuery, SliContainersByBookingReferenceQueryVariables> {
    document = SliContainersByBookingReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemsDocument = gql`
    query shipmentLineItems($filterAttributes: ShipmentLineItemFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  shipmentLineItems(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...indexShipmentLineItemFieldss
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${IndexShipmentLineItemFieldssFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemsGQL extends Apollo.Query<ShipmentLineItemsQuery, ShipmentLineItemsQueryVariables> {
    document = ShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemsByShipmentDocument = gql`
    query shipmentLineItemsByShipment($id: Int!) {
  shipmentLineItemsByShipment(id: $id) {
    ...sliCommonFields
    hasLoadOutInstruction
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemsByShipmentGQL extends Apollo.Query<ShipmentLineItemsByShipmentQuery, ShipmentLineItemsByShipmentQueryVariables> {
    document = ShipmentLineItemsByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemGroupingsByShipmentDocument = gql`
    query ShipmentLineItemGroupingsByShipment($id: ID!) {
  shipmentLineItemGroupingsByShipment(id: $id) {
    companyId
    id
    shipmentId
    sligFields
    totalCartons
    totalGrossWeight
    totalNettWeight
    updatedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemGroupingsByShipmentGQL extends Apollo.Query<ShipmentLineItemGroupingsByShipmentQuery, ShipmentLineItemGroupingsByShipmentQueryVariables> {
    document = ShipmentLineItemGroupingsByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemsBySligDocument = gql`
    query ShipmentLineItemsBySlig($id: ID!) {
  shipmentLineItemsBySlig(id: $id) {
    ...sliCommonFields
    sliContainer {
      id
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemsBySligGQL extends Apollo.Query<ShipmentLineItemsBySligQuery, ShipmentLineItemsBySligQueryVariables> {
    document = ShipmentLineItemsBySligDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReassignShipmentLineItemGroupingDocument = gql`
    mutation ReassignShipmentLineItemGrouping($id: ID!, $sligId: ID!) {
  reassignShipmentLineItemGrouping(id: $id, sligId: $sligId) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReassignShipmentLineItemGroupingGQL extends Apollo.Mutation<ReassignShipmentLineItemGroupingMutation, ReassignShipmentLineItemGroupingMutationVariables> {
    document = ReassignShipmentLineItemGroupingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentBookingReferencesDocument = gql`
    query shipmentBookingReferences($id: Int!) {
  shipmentBookingReferences(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentBookingReferencesGQL extends Apollo.Query<ShipmentBookingReferencesQuery, ShipmentBookingReferencesQueryVariables> {
    document = ShipmentBookingReferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbUserByUserIdDocument = gql`
    query ppecbUserByUserId($id: Int!) {
  ppecbUserByUserId(id: $id) {
    id
    agentFboCode
    ppecbRegisteredAgentCode
    ppecbExporters {
      id
      exporterFboCode
      ppecbRegisteredExporterCode
      company {
        name
      }
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbUserByUserIdGQL extends Apollo.Query<PpecbUserByUserIdQuery, PpecbUserByUserIdQueryVariables> {
    document = PpecbUserByUserIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbExporterByShipmentDocument = gql`
    query ppecbExporterByShipment($id: ID!) {
  ppecbExporterByShipment(id: $id) {
    id
    exporterFboCode
    ppecbRegisteredExporterCode
    company {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbExporterByShipmentGQL extends Apollo.Query<PpecbExporterByShipmentQuery, PpecbExporterByShipmentQueryVariables> {
    document = PpecbExporterByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentShipmentClientsDocument = gql`
    query currentShipmentClients {
  currentShipmentClients
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentShipmentClientsGQL extends Apollo.Query<CurrentShipmentClientsQuery, CurrentShipmentClientsQueryVariables> {
    document = CurrentShipmentClientsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentShipmentControllersDocument = gql`
    query currentShipmentControllers {
  currentShipmentControllers
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentShipmentControllersGQL extends Apollo.Query<CurrentShipmentControllersQuery, CurrentShipmentControllersQueryVariables> {
    document = CurrentShipmentControllersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentTruckReferencesDocument = gql`
    query CurrentTruckReferences {
  currentTruckReferences
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentTruckReferencesGQL extends Apollo.Query<CurrentTruckReferencesQuery, CurrentTruckReferencesQueryVariables> {
    document = CurrentTruckReferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentTransportCompaniesDocument = gql`
    query CurrentTransportCompanies {
  currentTransportCompanies
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentTransportCompaniesGQL extends Apollo.Query<CurrentTransportCompaniesQuery, CurrentTransportCompaniesQueryVariables> {
    document = CurrentTransportCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbUserByShipmentDocument = gql`
    query ppecbUserByShipment($id: ID!) {
  ppecbUserByShipment(id: $id) {
    id
    agentFboCode
    ppecbRegisteredAgentCode
    ppecbExporters {
      id
      exporterFboCode
      ppecbRegisteredExporterCode
      company {
        name
      }
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbUserByShipmentGQL extends Apollo.Query<PpecbUserByShipmentQuery, PpecbUserByShipmentQueryVariables> {
    document = PpecbUserByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbUsersDocument = gql`
    query ppecbUsers {
  ppecbUsers {
    id
    agentFboCode
    ppecbRegisteredAgentCode
    ppecbExporters {
      id
      exporterFboCode
      ppecbRegisteredExporterCode
      company {
        name
      }
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbUsersGQL extends Apollo.Query<PpecbUsersQuery, PpecbUsersQueryVariables> {
    document = PpecbUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentDocument = gql`
    query shipment($id: Int!) {
  shipment(id: $id) {
    ...shipmentCommonFields
    portOfLoading {
      id
      name
      unLocode
    }
    terminal {
      id
      name
      code
    }
    shipmentLineItems {
      ...sliCommonFields
    }
    templateOutput {
      state
      ...templateOutputFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentGQL extends Apollo.Query<ShipmentQuery, ShipmentQueryVariables> {
    document = ShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemDocument = gql`
    query shipmentLineItem($id: Int!) {
  shipmentLineItemById(id: $id) {
    ...sliCommonFields
    shipmentId
    shipment {
      id
      ppecbBookingReference
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemGQL extends Apollo.Query<ShipmentLineItemQuery, ShipmentLineItemQueryVariables> {
    document = ShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentSeaPortsDocument = gql`
    query shipmentSeaPorts {
  seaPorts {
    id
    name
    country
    unLocode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentSeaPortsGQL extends Apollo.Query<ShipmentSeaPortsQuery, ShipmentSeaPortsQueryVariables> {
    document = ShipmentSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAddendumHeaderStateChangeDocument = gql`
    subscription onAddendumHeaderStateChange {
  onAddendumHeaderStateChange {
    ...addendumHeaderFields
    addendumLineItems {
      ...addendumLineItemFields
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAddendumHeaderStateChangeGQL extends Apollo.Subscription<OnAddendumHeaderStateChangeSubscription, OnAddendumHeaderStateChangeSubscriptionVariables> {
    document = OnAddendumHeaderStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnShipmentStateChangeDocument = gql`
    subscription onShipmentStateChange {
  onShipmentStateChange {
    ...shipmentCommonFields
    shipmentLineItems {
      ...sliCommonFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnShipmentStateChangeGQL extends Apollo.Subscription<OnShipmentStateChangeSubscription, OnShipmentStateChangeSubscriptionVariables> {
    document = OnShipmentStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitShipmentExportNotificationDocument = gql`
    mutation submitShipmentExportNotification($id: ID!) {
  submitShipmentExportNotification(id: $id) {
    errors
    shipment {
      ...shipmentCommonFields
      shipmentLineItems {
        ...sliCommonFields
      }
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitShipmentExportNotificationGQL extends Apollo.Mutation<SubmitShipmentExportNotificationMutation, SubmitShipmentExportNotificationMutationVariables> {
    document = SubmitShipmentExportNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLoadOutInstructionsFromSlisDocument = gql`
    mutation updateLoadOutInstructionsFromSlis($sliIds: [ID!]!) {
  updateLoadOutInstructionsFromSlis(sliIds: $sliIds) {
    loadOutInstructions {
      id
      vessel {
        id
        vesselName
      }
      voyage
      shippingLine
      portOfLoading {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLoadOutInstructionsFromSlisGQL extends Apollo.Mutation<UpdateLoadOutInstructionsFromSlisMutation, UpdateLoadOutInstructionsFromSlisMutationVariables> {
    document = UpdateLoadOutInstructionsFromSlisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateShipmentExportNotificationOutputFilesDocument = gql`
    mutation generateShipmentExportNotificationOutputFiles($shipmentId: ID!) {
  generateShipmentExportNotificationOutputFiles(shipmentId: $shipmentId) {
    shipment {
      id
      templateOutput {
        state
        ...templateOutputFields
      }
    }
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateShipmentExportNotificationOutputFilesGQL extends Apollo.Mutation<GenerateShipmentExportNotificationOutputFilesMutation, GenerateShipmentExportNotificationOutputFilesMutationVariables> {
    document = GenerateShipmentExportNotificationOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CertificateTransportInstructionDocument = gql`
    query certificateTransportInstruction($id: Int!) {
  certificateTransportInstruction(id: $id) {
    id
    templateOutput {
      state
      ...templateOutputFields
    }
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CertificateTransportInstructionGQL extends Apollo.Query<CertificateTransportInstructionQuery, CertificateTransportInstructionQueryVariables> {
    document = CertificateTransportInstructionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertCertificateTransportInstructionDocument = gql`
    mutation upsertCertificateTransportInstruction($shipmentLineItemId: ID!) {
  upsertCertificateTransportInstruction(shipmentLineItemId: $shipmentLineItemId) {
    certificateTransportInstruction {
      id
      templateOutput {
        state
        ...templateOutputFields
      }
    }
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertCertificateTransportInstructionGQL extends Apollo.Mutation<UpsertCertificateTransportInstructionMutation, UpsertCertificateTransportInstructionMutationVariables> {
    document = UpsertCertificateTransportInstructionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentsToChooseFromDocument = gql`
    query ShipmentsToChooseFrom($shipmentId: Int!) {
  shipmentsToChooseFrom(shipmentId: $shipmentId) {
    id
    vesselName
    client
    voyageNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentsToChooseFromGQL extends Apollo.Query<ShipmentsToChooseFromQuery, ShipmentsToChooseFromQueryVariables> {
    document = ShipmentsToChooseFromDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentsAndShipmentLineItemsDocument = gql`
    query shipmentsAndShipmentLineItems($filterAttributes: ShipmentLineItemFilterAttributes, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $shipmentId: Int, $first: Int, $last: Int, $after: String, $before: String) {
  shipmentsAndShipmentLineItems(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    shipmentId: $shipmentId
  ) {
    shipments {
      id
      vesselName
      voyageNumber
      client
      truckReference
    }
    shipmentLineItems(first: $first, last: $last, after: $after, before: $before) {
      nodes {
        id
        vesselName
        voyageNumber
        truckReference
        consignmentReference
        portOfLoadingName
        portOfDischargeName
        stackDates
        stackDatesClose
        stackDatesOpenStatus
        stackDatesCloseStatus
        estimatedDispatchDate
        estimatedDeliveryDate
        bookingReference
        documentCount
        loadingPoint {
          name
        }
        offloadingPoint {
          name
        }
        checklist {
          emailSubject
          title
        }
        clientReference
        customerReference
        shippingLineReference
        containerNumber
        consignmentGroupName
        palletCount
        documentCount
        taskCompletion {
          complete
          inProgress
          notStarted
          total
        }
        state
        updatedAt
        portOfDestinationName
        portOfDestination {
          id
          name
          unLocode
        }
        estimatedTimeOfDeparture
        actualTimeOfDeparture
        estimatedTimeOfArrival
        actualTimeOfArrival
        shipment {
          id
          ppecbVoyageNumber
          vesselName
          voyageNumber
          client
          terminal {
            id
            name
            code
          }
          controller
          shipmentType
          portOfLoading {
            id
            name
            unLocode
          }
          stackDates
          stackDatesClose
          estimatedTimeOfDeparture
          actualTimeOfDeparture
          estimatedTimeOfArrival
          actualTimeOfArrival
          comments
          state
        }
        sliContainer {
          id
          container {
            containerNumber
          }
        }
        sliBreakBulk {
          id
          breakBulkContainer {
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentsAndShipmentLineItemsGQL extends Apollo.Query<ShipmentsAndShipmentLineItemsQuery, ShipmentsAndShipmentLineItemsQueryVariables> {
    document = ShipmentsAndShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockAtLocationDocument = gql`
    query stockAtLocation($filterAttributes: StockFilterInputAttributes, $searchAttributes: SearchAttributes, $orderAttributes: [ColumnOrderAttributes!], $millerAttributes: MillerCollapsibleInLocationInput) {
  stockAtLocation(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderAttributes: $orderAttributes
    millerAttributes: $millerAttributes
  ) {
    allLocations {
      locationType
      totalPallets
      name
      id
    }
    allVessels {
      name
      id
      totalPallets
      vesselEta
    }
    millerCollapsibleForLocation(millerColumnAttributes: $millerAttributes) {
      field
      value
      totalPallets
    }
    results {
      previousLocationName
      currentLocationName
      nextLocationName
      extendedFields
      commodityId
      batchNumber
      buyerId
      buyerName
      consignmentNumber
      subCommodityName
      varietyVarietyCode
      cartons
      commodityName
      documentStatus
      exporterCode
      extendedFields
      farmCode
      fileUpdates {
        changeDescription
        currentValue
        id
        oldValue
        viewedByIds
      }
      grade
      id
      inspectionDate
      consignmentNumber
      inventoryCode
      loadOutReference
      loadOutInstructionId
      mark
      netMass
      orchard
      pack
      packhouseCode
      packingWeek
      palletNumber
      palletAge
      palletGrossMass
      productCharacteristic
      sequenceNumber
      state
      status
      sizeCount
      sellerName
      targetMarket
      targetRegion
      targetCountry
      varietyName
      varietyId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockAtLocationGQL extends Apollo.Query<StockAtLocationQuery, StockAtLocationQueryVariables> {
    document = StockAtLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockFilterAttributesDocument = gql`
    query stockFilterAttributes {
  stockFilterAttributes {
    batchNumbers
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    documentStatuses
    exporterCodes
    grades
    inventoryCodes
    marks
    packTypes
    sellers {
      id
      name
    }
    sizeCounts
    states
    subCommodities {
      id
      name
    }
    targetMarkets
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockFilterAttributesGQL extends Apollo.Query<StockFilterAttributesQuery, StockFilterAttributesQueryVariables> {
    document = StockFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockErrorsDocument = gql`
    query stockErrors {
  stockErrors {
    errorMessage
    errorCount
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockErrorsGQL extends Apollo.Query<StockErrorsQuery, StockErrorsQueryVariables> {
    document = StockErrorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadedStockFilesDocument = gql`
    query uploadedStockFiles {
  uploadedStockFiles {
    documentId
    filename
    filesize
    filetype
    status
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadedStockFilesGQL extends Apollo.Query<UploadedStockFilesQuery, UploadedStockFilesQueryVariables> {
    document = UploadedStockFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadStockFileMutationDocument = gql`
    mutation UploadStockFileMutation($file: Upload!) {
  uploadStockFile(file: $file) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadStockFileMutationGQL extends Apollo.Mutation<UploadStockFileMutationMutation, UploadStockFileMutationMutationVariables> {
    document = UploadStockFileMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkAuditsAsViewedMutationDocument = gql`
    mutation MarkAuditsAsViewedMutation($auditIds: [ID!]!) {
  markAuditsAsViewed(auditIds: $auditIds) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkAuditsAsViewedMutationGQL extends Apollo.Mutation<MarkAuditsAsViewedMutationMutation, MarkAuditsAsViewedMutationMutationVariables> {
    document = MarkAuditsAsViewedMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockOnVesselDocument = gql`
    query stockOnVessel($vesselId: Int, $filterAttributes: StockFilterInputAttributes, $searchAttributes: SearchAttributes, $orderAttributes: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  stockOnVessel(
    vesselId: $vesselId
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderAttributes: $orderAttributes
  ) {
    allVessels {
      name
      id
      totalPallets
      vesselEta
    }
    results(first: $first, last: $last, after: $after, before: $before) {
      nodes {
        previousLocationName
        currentLocationName
        nextLocationName
        commodityId
        batchNumber
        buyerId
        buyerName
        consignmentNumber
        containerNumber
        subCommodityName
        loadOutReference
        varietyVarietyCode
        cartons
        commodityName
        exporterCode
        extendedFields
        farmCode
        grade
        id
        inspectionDate
        consignmentNumber
        inventoryCode
        mark
        netMass
        orchard
        pack
        packhouseCode
        packingWeek
        palletNumber
        palletAge
        palletGrossMass
        productCharacteristic
        sequenceNumber
        state
        status
        sizeCount
        sellerName
        targetMarket
        targetRegion
        targetCountry
        varietyName
        varietyId
        vesselId
        vesselName
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockOnVesselGQL extends Apollo.Query<StockOnVesselQuery, StockOnVesselQueryVariables> {
    document = StockOnVesselDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShippedStockFilterAttributesDocument = gql`
    query shippedStockFilterAttributes {
  shippedStockFilterAttributes {
    batchNumbers
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    exporterCodes
    grades
    inventoryCodes
    marks
    packTypes
    sellers {
      id
      name
    }
    sizeCounts
    states
    subCommodities {
      id
      name
    }
    targetMarkets
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShippedStockFilterAttributesGQL extends Apollo.Query<ShippedStockFilterAttributesQuery, ShippedStockFilterAttributesQueryVariables> {
    document = ShippedStockFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TasksByShipmentLineItemDocument = gql`
    query TasksByShipmentLineItem($sliId: Int!) {
  tasksByShipmentLineItem(sliId: $sliId) {
    ...taskCommonFields
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TasksByShipmentLineItemGQL extends Apollo.Query<TasksByShipmentLineItemQuery, TasksByShipmentLineItemQueryVariables> {
    document = TasksByShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadTaskDocumentDocument = gql`
    mutation UploadTaskDocument($taskId: Int!, $file: Upload!, $uploadDate: ISO8601DateTime, $customDate: ISO8601DateTime) {
  uploadTaskDocument(
    taskId: $taskId
    file: $file
    uploadDate: $uploadDate
    customDate: $customDate
  ) {
    errors
    task {
      id
      customDate
      uploadedAt
      documentId
      file {
        filename
        v2Url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadTaskDocumentGQL extends Apollo.Mutation<UploadTaskDocumentMutation, UploadTaskDocumentMutationVariables> {
    document = UploadTaskDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTaskDocumentDocument = gql`
    mutation DeleteTaskDocument($id: ID!, $shipmentLineItemId: ID!) {
  deleteTaskDocument(id: $id, shipmentLineItemId: $shipmentLineItemId) {
    tasks {
      ...taskCommonFields
    }
    errors
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTaskDocumentGQL extends Apollo.Mutation<DeleteTaskDocumentMutation, DeleteTaskDocumentMutationVariables> {
    document = DeleteTaskDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTasksDatesDocument = gql`
    mutation UpdateTasksDates($updateValues: Json!) {
  updateTasksDates(updateValues: $updateValues) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTasksDatesGQL extends Apollo.Mutation<UpdateTasksDatesMutation, UpdateTasksDatesMutationVariables> {
    document = UpdateTasksDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomTaskDateDocument = gql`
    mutation UpdateCustomTaskDate($taskId: ID!, $customDate: ISO8601Date, $shipmentLineItemId: ID!) {
  updateCustomTaskDate(
    taskId: $taskId
    customDate: $customDate
    shipmentLineItemId: $shipmentLineItemId
  ) {
    tasks {
      ...taskCommonFields
    }
    errors
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomTaskDateGQL extends Apollo.Mutation<UpdateCustomTaskDateMutation, UpdateCustomTaskDateMutationVariables> {
    document = UpdateCustomTaskDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadTaskDocumentPerSliDocument = gql`
    mutation UploadTaskDocumentPerSli($taskId: ID!, $shipmentLineItemId: ID!, $file: Upload!, $selectedSliIds: [ID!]!) {
  uploadTaskDocumentPerSli(
    taskId: $taskId
    file: $file
    shipmentLineItemId: $shipmentLineItemId
    selectedSliIds: $selectedSliIds
  ) {
    tasks {
      ...taskCommonFields
    }
    errors
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadTaskDocumentPerSliGQL extends Apollo.Mutation<UploadTaskDocumentPerSliMutation, UploadTaskDocumentPerSliMutationVariables> {
    document = UploadTaskDocumentPerSliDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnTemplateOutputStateChangeDocument = gql`
    subscription onTemplateOutputStateChange {
  onTemplateOutputStateChange {
    ...templateOutputFields
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnTemplateOutputStateChangeGQL extends Apollo.Subscription<OnTemplateOutputStateChangeSubscription, OnTemplateOutputStateChangeSubscriptionVariables> {
    document = OnTemplateOutputStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateOutputFilesDocument = gql`
    query templateOutputFiles($templateOutputFilesId: Int!) {
  templateOutputFiles(id: $templateOutputFilesId) {
    outputFiles {
      contentType
      filename
      id
      url
      v2Url
    }
    errorReason
    id
    state
    templateDataSourceId
    templateDataSourceType
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateOutputFilesGQL extends Apollo.Query<TemplateOutputFilesQuery, TemplateOutputFilesQueryVariables> {
    document = TemplateOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateOutputFilesBySourceDocument = gql`
    query templateOutputFilesBySource($dataSourceId: Int!, $dataSourceType: String!) {
  templateOutputFilesBySource(
    dataSourceId: $dataSourceId
    dataSourceType: $dataSourceType
  ) {
    outputFiles {
      contentType
      filename
      id
      url
      v2Url
    }
    errorReason
    id
    state
    templateDataSourceId
    templateDataSourceType
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateOutputFilesBySourceGQL extends Apollo.Query<TemplateOutputFilesBySourceQuery, TemplateOutputFilesBySourceQueryVariables> {
    document = TemplateOutputFilesBySourceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradePartnerDocument = gql`
    query TradePartner($id: ID!) {
  company(id: $id) {
    id
    name
    about
    isBuyer
    isSeller
    logoFile {
      id
      filename
      url
    }
    registrationNumber
    vatNumber
    createdAt
    address {
      addressLine1
      addressLine2
      city
      postalCode
      country
    }
    varieties {
      id
      varietyId
      name
      packingStart
      packingEnd
      peakCount
      hectares
      images {
        id
        url
        thumbnailUrl
      }
      commodity {
        id
        name
        icon {
          v2Url
        }
      }
    }
    certificates {
      id
      companyId
      expiryDate
      certificate {
        url
        filename
      }
      certificateType {
        name
        id
      }
    }
    tradeRegions {
      name
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TradePartnerGQL extends Apollo.Query<TradePartnerQuery, TradePartnerQueryVariables> {
    document = TradePartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradePartnersDocument = gql`
    query TradePartners {
  myCompany {
    id
    isBuyer
    buyers {
      ...companyInformation
    }
    isSeller
    sellers {
      ...companyInformation
    }
  }
}
    ${CompanyInformationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TradePartnersGQL extends Apollo.Query<TradePartnersQuery, TradePartnersQueryVariables> {
    document = TradePartnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OneswitchBuyersDocument = gql`
    query OneswitchBuyers {
  oneswitchBuyers {
    id
    name
    companyLogoImageUrl
    tradeRegions {
      id
      name
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OneswitchBuyersGQL extends Apollo.Query<OneswitchBuyersQuery, OneswitchBuyersQueryVariables> {
    document = OneswitchBuyersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllTradeRegionsDocument = gql`
    query AllTradeRegions {
  tradeRegions {
    id
    name
    code
    countries {
      id
      code
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllTradeRegionsGQL extends Apollo.Query<AllTradeRegionsQuery, AllTradeRegionsQueryVariables> {
    document = AllTradeRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UiConfigsDocument = gql`
    query UiConfigs($visibility: UiConfigVisibilityEnum, $configType: String) {
  uiConfigs(visibility: $visibility, configType: $configType) {
    id
    configType
    visibility
    data
    readonly
  }
  myUser {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UiConfigsGQL extends Apollo.Query<UiConfigsQuery, UiConfigsQueryVariables> {
    document = UiConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UiConfigDocument = gql`
    query UiConfig($id: ID!) {
  uiConfig(id: $id) {
    id
    configType
    visibility
    data
    readonly
  }
  myUser {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UiConfigGQL extends Apollo.Query<UiConfigQuery, UiConfigQueryVariables> {
    document = UiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUiConfigDocument = gql`
    mutation CreateUiConfig($attributes: CreateUpdateUiConfigAttributes!) {
  createUiConfig(attributes: $attributes) {
    config {
      id
      configType
      visibility
      data
      readonly
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUiConfigGQL extends Apollo.Mutation<CreateUiConfigMutation, CreateUiConfigMutationVariables> {
    document = CreateUiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUiConfigDocument = gql`
    mutation DeleteUiConfig($deleteUiConfigId: Int!) {
  deleteUiConfig(id: $deleteUiConfigId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUiConfigGQL extends Apollo.Mutation<DeleteUiConfigMutation, DeleteUiConfigMutationVariables> {
    document = DeleteUiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUiConfigDocument = gql`
    mutation UpdateUiConfig($attributes: CreateUpdateUiConfigAttributes!) {
  updateUiConfig(attributes: $attributes) {
    config {
      id
      configType
      visibility
      data
      readonly
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUiConfigGQL extends Apollo.Mutation<UpdateUiConfigMutation, UpdateUiConfigMutationVariables> {
    document = UpdateUiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFeedItemsConnectionDocument = gql`
    query UserFeedItemsConnection($last: Int, $after: String, $first: Int, $before: String) {
  userFeedConnection(last: $last, after: $after, first: $first, before: $before) {
    pageInfo {
      endCursor
      startCursor
      hasPreviousPage
      hasNextPage
    }
    edges {
      cursor
      node {
        ...userFeedItem
      }
    }
  }
}
    ${UserFeedItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFeedItemsConnectionGQL extends Apollo.Query<UserFeedItemsConnectionQuery, UserFeedItemsConnectionQueryVariables> {
    document = UserFeedItemsConnectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFeedUnseenCountDocument = gql`
    query UserFeedUnseenCount {
  userFeedUnseenCount
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFeedUnseenCountGQL extends Apollo.Query<UserFeedUnseenCountQuery, UserFeedUnseenCountQueryVariables> {
    document = UserFeedUnseenCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserFeedItemDocument = gql`
    mutation UpdateUserFeedItem($attributes: UpdateUserFeedItemAttributes!) {
  updateUserFeedItem(attributes: $attributes) {
    userFeedItem {
      id
      seen
      read
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserFeedItemGQL extends Apollo.Mutation<UpdateUserFeedItemMutation, UpdateUserFeedItemMutationVariables> {
    document = UpdateUserFeedItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserFeedItemsDocument = gql`
    mutation UpdateUserFeedItems($attributes: [UpdateUserFeedItemAttributes!]!) {
  updateUserFeedItems(attributes: $attributes) {
    userFeedItems {
      id
      seen
      read
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserFeedItemsGQL extends Apollo.Mutation<UpdateUserFeedItemsMutation, UpdateUserFeedItemsMutationVariables> {
    document = UpdateUserFeedItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewUserFeedItemDocument = gql`
    subscription newUserFeedItem {
  newUserFeedItem {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewUserFeedItemGQL extends Apollo.Subscription<NewUserFeedItemSubscription, NewUserFeedItemSubscriptionVariables> {
    document = NewUserFeedItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserDocument = gql`
    query User {
  myUser {
    id
    firstName
    lastName
    phoneNumber
    email
    state
    notifyEmail
    notifyBrowserPush
    pastEmailRecipients
    createdAt
    updatedAt
    useV2
    locale
    externalIdentifier
    avatarFile {
      id
      filename
      url
    }
    company {
      id
      name
    }
    role
    roles {
      name
    }
    permissions {
      landingPage
      permissions {
        key
        value
      }
    }
  }
  myCompany {
    id
    name
    defaultLocale
    certificates {
      id
      expiryDate
      createdAt
      updatedAt
      certificate {
        id
        filename
        url
      }
      certificateType {
        id
        name
      }
    }
    sellers {
      id
      name
    }
    isBuyer
    buyers {
      id
      name
    }
    isSeller
    state
    onboardingStep
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserGQL extends Apollo.Query<UserQuery, UserQueryVariables> {
    document = UserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($employeeid: Int!) {
  deleteEmployee(employeeId: $employeeid) {
    employeeId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmployeeGQL extends Apollo.Mutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables> {
    document = DeleteEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindOrCreateVesselDocument = gql`
    mutation FindOrCreateVessel($vesselName: String!) {
  findOrCreateVessel(vesselName: $vesselName) {
    vessel {
      id
      vesselName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindOrCreateVesselGQL extends Apollo.Mutation<FindOrCreateVesselMutation, FindOrCreateVesselMutationVariables> {
    document = FindOrCreateVesselDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }